/** Component data */
export interface ComponentData extends ComponentDataDataOneOf {
  /**
   * Create a widget iframe that users can display on their site. We recommend submitting a proposal before using iframes in your app.
   * Learn More: https://devforum.wix.com/en/article/widget-components
   */
  widgetComponentData?: WidgetComponentData;
  /**
   * Display an iframe as a page on a user's site.
   * Learn More: https://dev.wix.com/docs/build-apps/developer-tools/extensions/iframes/guide-to-page-extensions
   */
  pageComponentData?: PageComponentData;
  /**
   * Load a WOOI directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/viewer/platform/intro/get-started/guidelines
   * @internal
   */
  widgetOutOfIframeData?: WidgetOutOfIframeComponentData;
  /**
   * Load a POOI directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/viewer/platform/intro/get-started/guidelines
   * @internal
   */
  pageOutOfIframeData?: PageOutOfIframeComponentData;
  /**
   * Load a collection of native Editor components directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/editor-platform/welcome-to-the-editor-platform
   * @internal
   */
  platformComponentData?: PlatfromComponentData;
  /**
   * Open an iframe in the Dashboard, or add a link to a page on your platform.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/external-links/about-external-link-extensions
   */
  dashboardComponentData?: DashboardComponentData;
  /**
   * Use an invisible iframe to track activity. It’s added to every page on the site (max. 1).
   * Learn More: https://devforum.wix.com/en/article/worker-components
   */
  workerComponentData?: WorkerComponentData;
  /**
   * Use Wix Blocks to create a widget component. Wix Blocks will open in a new tab.
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/wix-blocks-server---app-builder
   * @internal
   */
  studioComponentData?: StudioComponentData;
  /**
   * A widget component in the Wix Blocks.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/wix-blocks
   * @internal
   */
  studioWidgetComponentData?: StudioWidgetComponentData;
  /**
   * A component that indicates the existence of an importable code package in a Wix Blocks application.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/wix-blocks-code-package
   * @internal
   */
  codePackageComponentData?: CodePackageComponentData;
  /**
   * Load a collection of native components directly in the Business Manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/dashboard-platfrom/dashboard-platfrom-component-data-object
   * @internal
   */
  dashboardPlatformComponentData?: DashboardPlatfromComponentData;
  /**
   * Inject a script into a site’s HTML code.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/embedded-scripts/about-embedded-scripts
   */
  embeddedScriptComponentData?: EmbeddedScriptComponentData;
  /**
   * Display a draggable component in the Editor using an HTML custom element.
   * Learn More: https://devforum.wix.com/kb/en/article/create-a-custom-element
   * @internal
   */
  webComponentData?: WebComponentData;
  /**
   * Extend app with internal Wix extension.
   * @internal
   */
  extensionData?: ExtensionData;
  /** @internal */
  snippetSolutionsData?: SnippetSolutionData;
  /**
   * Extend a site’s CMS to store and manage custom data.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/data-collections/about-data-collections-extensions
   */
  dataComponent?: DataComponent;
  /** @internal */
  dcConfigData?: DCConfigData;
  /**
   * Serve a file from the user’s site domain.
   * Learn More: https://devforum.wix.com/en/article/serving-staic-files-from-the-installed-sites-domain
   * @internal
   */
  staticFileComponentData?: StaticFileComponentData;
  /** @internal */
  appConfig?: AppConfig;
  /**
   * Create a multi-page dashboard in the Business Manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/multiple-dashboards
   * @internal
   */
  multipleDashboardsComponentData?: MultipleDashboardsComponentData;
  /**
   * Payments gateway extension description
   * @internal
   */
  paymentsGateway?: PaymentsGatewayComponentData;
  /**
   * Extend an app with automation capabilities using CRM Automations
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/automation-trigger
   * @internal
   */
  automationTrigger?: AutomationTrigger;
  /**
   * Any restrictions on invoices actions
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/invoices-actions
   * @internal
   */
  invoicesActionsComponentData?: InvoicesActionsComponentData;
  /**
   * Experimental-WIP: Business manager app_config, configures a module and its page components in business manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/dashboard-application
   * @internal
   */
  dashboardApplicationData?: DashboardApplicationData;
  /**
   * Contact Labels Components
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/contact-labels
   * @internal
   */
  contactLabels?: ContactLabelsComponentData;
  /**
   * Display a widget that fits into a predefined slot in a Wix app.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-plugins/about-site-plugin-extensions
   */
  widgetPlugin?: WidgetPluginComponentData;
  /**
   * Cross Sell Integration
   * @internal
   */
  crossSell?: CrossSellConfig;
  /**
   * Experimental-WIP: Local Delivery extension description.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/local-delivery
   * @internal
   */
  localDelivery?: LocalDeliveryComponentData;
  /**
   * WIP: Velo payment provider SPI
   * @internal
   */
  paymentProvider?: PaymentServiceProviderConfig;
  /**
   * Memberships SPI for ECOM platform
   * @internal
   */
  ecomMemberships?: MembershipsSPIConfig;
  /**
   * Line Items Enricher SPI for ECOM platform
   * @internal
   */
  ecomLineItemsEnricher?: LineItemsEnricherConfig;
  /**
   * Provide custom shipping rates to a site's cart and checkout.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/shipping-rates-integration-service-plugin/introduction
   */
  ecomShippingRates?: ShippingRatesConfig;
  /**
   * Shipping Label Carrier SPI
   * @internal
   */
  shippingLabelCarrier?: ShippingLabelCarrierSpiConfig;
  /**
   * Restaurants POS service plugin
   * @internal
   */
  restaurantsPos?: RestaurantsPOSComponentData;
  /**
   * A fictional Shipping SPI that is used by developers to complete SPI training
   * https://github.com/wix-academy/spi-in-scala-path
   * @internal
   */
  fictionalShippingProvider?: ShippingProviderConfig;
  /**
   * Alert Enricher Integration
   * @internal
   */
  alertEnricher?: AlertEnricherSpiConfiguration;
  /** Extend a Wix entity with custom fields for your app */
  dataExtensions?: DataExtensionsComponentData;
  /**
   * A common component type for all Generic Hooks
   * @internal
   */
  genericHooks?: GenericHooksConfig;
  /**
   * WIP: automations action provider
   * @internal
   */
  automationsActionProvider?: ActionProviderSPIConfig;
  /**
   * Become a Wix catalog provider and integrate any external repository of sellable items with the Wix eCommerce platform.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/catalog-service-plugin/introduction
   */
  ecomCatalog?: CatalogSPIConfig;
  /**
   * Add a space to a Wix Dashboard page that can be extended with a widget or menu item.
   * @internal
   */
  backOfficeExtensionContainer?: BackOfficeExtensionContainer;
  /**
   * Create a widget or menu item that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/about-dashboard-plugin-extensions
   * @internal
   */
  backOfficeExtension?: BackOfficeExtension;
  /**
   * WIP: automations trigger provider
   * @internal
   */
  automationsTriggerProvider?: TriggerProviderSPIConfig;
  /**
   * WIP - SPI for execution before identity creation in the new IAM platform
   * @internal
   */
  identityPreRegistration?: PreRegisterConfig;
  /**
   * Premium products upgrades/downgrades
   * @internal
   */
  premiumProductsPaths?: ProductsPathsConfig;
  /**
   * ECOM custom scopes provider - define scopes of catalog items based custom attributes
   * @internal
   */
  ecomCustomScope?: CustomScopeConfig;
  /**
   * Implement gift card benefits such as balance retrieval, redemption, and voiding transactions.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/gift-cards-service-plugin/introduction
   */
  giftCardsProvider?: GiftCardProviderConfig;
  /**
   * Dealer External Filter SPI
   * @internal
   */
  dealerExternalFilterProvider?: ExternalFilterProviderConfig;
  /**
   * Recommendations provider SPI
   * @internal
   */
  ecomRecommendationsProvider?: RecommendationsProviderConfig;
  /**
   * Dropshipping Provider SPI for Ecom Platform
   * @internal
   */
  ecomDropshippingProvider?: DropshippingProviderSPIConfig;
  /**
   * Invoices SPI
   * @internal
   */
  invoicesProvider?: InvoicesConfig;
  /**
   * Provide SEO keyword suggestions to site collaborators, report quota usage, and provide a page where users can upgrade their plan.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/marketing/seo-keywords-suggestions-v-1/introduction
   */
  seoKeywordsSuggestions?: SeoKeywordsSuggestionsSPIConfig;
  /**
   * Ecom custom discount trigger service plugin - define custom triggers to apply discount rules
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/custom-discount-triggers-integration-service-plugin/introduction
   * @internal
   */
  ecomDiscountsTrigger?: CustomTriggerConfig;
  /**
   * Multilingual content provider for site translator to read and update translations
   * @internal
   */
  multilingualContentProvider?: ContentProviderConfig;
  /**
   * Application Automation
   * @internal
   */
  applicationAutomation?: ApplicationAutomationComponent;
  /**
   * Experimental-WIP: A back office page category
   * @internal
   */
  backOfficeSidebarCategory?: BackOfficeSidebarCategory;
  /**
   * Configure a page for your app that will be embedded in the Wix Dashboard.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-pages/about-dashboard-page-extensions
   */
  backOfficePage?: BackOfficePage;
  /**
   * Provide custom additional fees that are added to a site's cart and checkout.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/additional-fees-service-plugin/introduction
   */
  ecomAdditionalFees?: AdditionalFeesSPIConfig;
  /**
   * Send notifications to your app users
   * @internal
   */
  pingUserNotification?: PingNotificationComponentData;
  /** Bookings Pricing Provider SPI */
  bookingsPricingProvider?: BookingsPricingProviderConfig;
  /**
   * Authenticator SPI
   * @internal
   */
  identityAuthenticator?: AuthenticatorConfig;
  /**
   * WIP - SPI for authenticating via external IDP in the new IAM platform
   * @internal
   */
  identityIdpConnector?: IDPConnectionConfig;
  /**
   * Items Selector
   * @internal
   */
  itemsSelectionProvider?: ItemsSelectionProviderConfig;
  /**
   * Portfolio synced projects provider
   * @internal
   */
  portfolioSyncedProjectsProvider?: SyncedProjectsProviderConfig;
  /**
   * Communication Channel
   * @internal
   */
  communicationChannel?: CommunicationChannelConfiguration;
  /**
   * WIP - SPI to run after the login process
   * @internal
   */
  identityPostLogin?: PostLoginConfig;
  /**
   * Create a component that can be easily placed in or opened from a Wix app page.
   * @internal
   */
  backOfficeWidget?: BackOfficeWidget;
  /**
   * Social Marketing Design SPI
   * @internal
   */
  socialMarketingDesign?: SocialMarketingDesignSPIConfig;
  /**
   * Forms Submissions SPI
   * @internal
   */
  formsSubmissionsProvider?: FormSubmissionSpiConfig;
  /**
   * Wix Offering
   * @internal
   */
  wixOffering?: WixOfferingComponentData;
  /**
   * Components translation test component
   * @internal
   */
  devCenterTestingComponent?: DevCenterTestingComponentData;
  /**
   * Components Validator SPI
   * @internal
   */
  componentsValidatorProvider?: ComponentsValidatorConfig;
  /**
   * Components Translations additional fields config
   * @internal
   */
  componentsTranslationsAdditionalFieldsProvider?: ComponentTranslationAdditionalFieldsConfig;
  /**
   * Forms Schema SPI
   * @internal
   */
  formsSchemaProvider?: FormSchemaSpiConfig;
  /**
   * Bookings External Calendar Provider
   * @internal
   */
  bookingsExternalCalendarProvider?: ProviderConfig;
  /**
   * Default Tax Category Config
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/platform-tax
   * @internal
   */
  ecomDefaultTaxationCategory?: DefaultTaxGroupProviderConfig;
  /**
   * Viewer Dynamic Site Structure Config
   * @internal
   */
  viewerDynamicSiteStructureProvider?: DynamicSiteStructureProviderConfig;
  /**
   * Send notifications to your app users of users
   * @internal
   */
  pingUouNotification?: PingNotificationComponentData;
  /**
   * Holds data for authenticating Headless Applications
   * @internal
   */
  headlessOauth?: HeadlessOAuth;
  /**
   * Tax Calculator Structure Config
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/platform-tax
   * @internal
   */
  ecomTaxCalculatorSpi?: TaxCalculatorSpiConfig;
  /**
   * Comments Moderation Provider Config
   * @internal
   * @deprecated Comments Moderation Provider Config
   * @replacedBy comments_filter_provider
   */
  commentsModerationProvider?: CommentModerationProviderConfig;
  /**
   * GridApp files transformer config
   * @internal
   */
  gridAppFilesTransformer?: GridAppFilesTransformerConfig;
  /**
   * Holds benefit programs policy provider configuration
   * @internal
   */
  benefitProgramsPolicyProvider?: PolicyConfig;
  /**
   * Apply custom charges to a site based on usage of your app's services.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/app-management/apps/custom-charges-spi/introduction
   */
  premiumCustomCharges?: CustomChargesConfig;
  /**
   * Validate items in a site's cart and checkout based on custom logic.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/validations-integration-spi/introduction
   */
  ecomValidations?: ValidationsSPIConfig;
  /**
   * Component Reference Data SPI
   * @internal
   */
  componentReferenceDataProvider?: ComponentReferenceDataConfig;
  /**
   * Wix Reviews SPI
   * @internal
   */
  wixReviewsProductCatalog?: ReviewsProductCatalogProviderConfig;
  /**
   * Promote Social Marketing Designs Provider Configuration
   * @internal
   */
  socialMarketingDesignsProvider?: SocialMarketingDesignsProviderConfig;
  /**
   * Promote Google Business Profile Provider Configuration
   * @internal
   */
  googleBusinessProfileFeatureProvider?: GbpFeatureConfig;
  /**
   * Comments Filter Provider Config
   * @internal
   */
  commentsFilterProvider?: CommentFilterProviderConfig;
  /**
   * Tax ID Validator SPI Config
   * @internal
   */
  billingTaxIdValidator?: TaxIdValidatorConfig;
  /**
   * Ping Settings Group Data
   * @internal
   */
  pingSettingsGroup?: PingSettingsGroupComponentData;
  /**
   * Forms Spam Submissions SPI
   * @internal
   */
  formsSpamSubmissionsProvider?: FormSpamSubmissionSpiConfig;
  /**
   * Build a tool that adds functionality to the Wix editors.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/editor-extensions/about-editor-extensions
   */
  editorAddon?: EditorAddon;
  /** External Database component */
  externalDatabaseProvider?: ExternalDatabaseSpiConfig;
  /**
   * Integrate your service with Wix's payment process to allow merchants to request and use your services on their Wix sites.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/payment-settings-integration-service-plugin/introduction
   */
  ecomPaymentSettings?: PaymentSettingsSPIConfig;
  /**
   * Group multiple notifications into one preference toggle.
   * Learn More: https://dev.wix.com/docs/build-apps/build-your-app/user-notifications/add-notification-topics
   * @internal
   */
  notificationTopic?: NotificationTopic;
  /**
   * Notification Preference SPI
   * @internal
   */
  notificationPreferencesFilterProvider?: NotificationPreferencesFilterConfig;
  /**
   * Bookings Resource Types provider SPI config
   * @internal
   */
  bookingsResourceTypesProvider?: BookingsResourceTypesProviderConfig;
  /**
   * Pricing Plans form configuration
   * @internal
   */
  pricingPlansFormConfiguration?: PricingPlansFormConfiguration;
  /**
   * Create a notification to alert your app users about important updates and events.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/notifications/about-notification-extensions
   * @internal
   */
  userNotification?: UserNotification;
  /**
   * Contact Notification
   * @internal
   */
  contactNotification?: ContactNotification;
  /**
   * Add a site page that displays selected widgets.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-pages/about-site-page-extensions
   */
  unifiedPage?: UnifiedPage;
  /**
   * Availability Time Slots Configuration Provider SPI
   * @internal
   */
  availabilityTimeSlotsConfigurationProvider?: AvailabilityTimeSlotsProviderConfig;
  /**
   * Proposal Editor Provider SPI config
   * @internal
   */
  proposalEditorProvider?: ProposalEditorProviderConfig;
  /**
   * Custom Table Reservations Provider SPI config
   * @internal
   */
  customTableReservationsProvider?: CustomReservationsApprovalConfig;
  /**
   * Comments Context provider
   * @internal
   */
  commentsContextProvider?: CommentsContextProviderConfig;
  /**
   * Forms Spam Submission Reports SPI
   * @internal
   */
  formsSpamSubmissionReportsProvider?: FormSpamSubmissionReportSpiConfig;
  /**
   * Automation Velo Action Spi Provider
   * @internal
   */
  automationsVeloActionProvider?: VeloActionConfig;
  /**
   * Calendar Event Type Provider
   * @internal
   */
  calendarEventTypeProvider?: EventTypeProviderConfig;
  /**
   * Reserved - previously was `service_availability_policy_provider`
   * @internal
   */
  reserved?: ServiceAvailabilityPolicyProviderConfig;
  /**
   * Create an SMS message for a pre-installed automation, in order to translate it.
   * @internal
   */
  smsActionMessage?: SmsActionMessage;
  /**
   * Booking Policy Provider SPI
   * @internal
   */
  bookingPolicyProvider?: BookingPolicyProviderConfig;
  /**
   * Multi Service Booking Policy Provider SPI
   * @internal
   */
  multiServiceBookingPolicyProvider?: MultiServiceBookingPolicyProviderConfig;
  /**
   * Forms Submissions Extension SPI
   * @internal
   */
  formsSubmissionsExtensionProvider?: FormSubmissionSpiExtensionConfig;
  /**
   * AI Assistant SPI
   * @internal
   */
  aiAssistant?: AssistantSpiConfig;
  /**
   * Multilingual translation schema
   * Learn More: https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/translation-schema/schema-object
   */
  multilingualTranslationSchema?: MultilingualTranslationSchema;
  /**
   * Tax Groups Provider Service Plugin
   * @internal
   */
  taxGroupsProvider?: TaxGroupsProviderConfig;
  /**
   * Tax Calculation Provider Service Plugin
   * @internal
   */
  taxCalculationProvider?: TaxCalculationConfig;
  /** Create a reusable modal that can be utilized across multiple pages within your app and in other applications. */
  backOfficeModal?: BackOfficeModal;
  /**
   * Deployment Pipeline Provider SPI
   * @internal
   */
  deploymentPipelineProvider?: DeploymentPipelineProviderConfig;
  /**
   * Display a draggable widget on a site using a self-hosted custom element.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-widgets/about-site-widget-extensions
   */
  customElementWidget?: CustomElementWidget;
  /**
   * Create a widget that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/about-dashboard-plugin-extensions
   * @internal
   */
  backOfficeExtensionWidget?: BackOfficeExtensionWidget;
  /**
   * Create a menu item that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/dashboard-menu-plugins/dashboard-menu-plugin-extensions
   * @internal
   */
  backOfficeExtensionMenuItem?: BackOfficeExtensionMenuItem;
  /**
   * Form Template
   * @internal
   */
  formTemplate?: FormTemplate;
  /**
   * Notification Content
   * @internal
   */
  notificationContent?: NotificationContent;
  /**
   * Broadcast List
   * @internal
   */
  broadcastList?: BroadcastList;
  /**
   * Partners Payouts
   * @internal
   */
  partnersPayouts?: PayoutsProviderConfig;
  /**
   * Wix Reviews Entity Catalog Provider SPI
   * @internal
   */
  wixReviewsEntityCatalog?: ReviewsEntityCatalogProviderConfig;
  /**
   * Velo Publish Pipeline Task Provider SPI
   * @internal
   */
  veloPublishPipelineTaskProvider?: VeloPublishPipelineTaskProviderConfig;
  /**
   * Function shop POC SPI
   * @internal
   */
  functionsShopPriceProvider?: FunctionsShopPriceSpiConfig;
  /**
   * Connect your service plugins to Functions so users can define their own custom logic.
   * Learn More: https://github.com/wix-private/functions-client/blob/master/README.md
   * @internal
   */
  function?: _Function;
  /**
   * Ecom Checkout Content
   * @internal
   */
  ecomCheckoutContent?: CheckoutContentSPIConfig;
  /**
   * Communication Channel
   * @internal
   */
  communicationChannelProvider?: V2CommunicationChannelConfiguration;
  /**
   * Webhook
   * @internal
   */
  webhook?: WebhookComponentData;
  /**
   * An extension that holds topology data.
   * @internal
   */
  topology?: TopologyComponentData;
  /**
   * Loyalty Custom Rewards POC
   * @internal
   */
  loyaltyCustomRewards?: CustomRewardProviderConfig;
  /**
   * Create a predefined template that users can use when creating flows in Functions.
   * Learn More: https://github.com/wix-private/functions-client/blob/master/docs/function-templates.md
   * @internal
   */
  functionRecipe?: FunctionRecipe;
  /**
   * external url to the back office
   * @internal
   */
  backOfficeExternalUrl?: BackOfficeExternalUrl;
  /**
   * Authentication factor
   * @internal
   */
  identityFactor?: FactorConfig;
  /**
   * ecom discounts
   * @internal
   */
  ecomDiscounts?: DiscountsSPIConfig;
  /**
   * Blocks Velo custom css - for CSS editing in Blocks
   * @internal
   */
  veloCustomCss?: VeloCustomCss;
  /**
   * Dealer Adaptive Component Provider SPI
   * @internal
   */
  dealerAdaptiveComponentProvider?: AdaptiveComponentProviderConfig;
  /**
   * Wix AI Assistant Action SPI
   * @internal
   */
  aiAssistantAction?: ActionSpiConfig;
  /**
   * Integrate any external inventory with the Wix eCommerce platform.
   * Learn More: https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/catalogs/inventory-service-plugin/introduction
   */
  ecomInventory?: InventorySpiConfig;
  /**
   * Add a monitoring configuration to your app.
   * Learn More: https://dev.wix.com/docs/build-apps/manage-your-app/observability/monitor-your-app-with-sentry
   * @internal
   */
  monitoring?: Monitoring;
  /**
   * PAPI SPI
   * @internal
   */
  papiProvider?: PluginConfig;
  /**
   * Add a lightbox that displays a widget in a popup over a site page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-lightboxes/about-site-lightbox-extensions
   * @internal
   */
  unifiedLightbox?: UnifiedLightbox;
  /**
   * Forms Schema Extension SPI
   * @internal
   */
  formsExtensionProvider?: FormSpiExtensionConfig;
  /** Multilingual translation schema group */
  multilingualTranslationSchemaGroup?: SchemaGroup;
  /**
   * Panel data
   * @internal
   */
  panel?: Panel;
  /**
   * Premium Purchase Validations SPI
   * @internal
   */
  premiumPurchaseValidations?: PurchaseValidationsConfig;
  /**
   * Any Cookies, localStorage, sessionStorage or IndexDB items the app is using in the site or their domain
   * @internal
   */
  browserStorage?: BrowserStorage;
  /**
   * Map this app to SDK module
   * @internal
   */
  sdkDefinition?: SdkDefinition;
  /**
   * Add a space to a Page or Widget that can be extended with a widget plugin.
   * @internal
   */
  siteWidgetSlot?: SiteWidgetSlot;
  /**
   * Calendar Event Validation Provider
   * @internal
   */
  calendarEventValidationProvider?: EventValidationProviderConfig;
  /** @internal */
  clientSideService?: ClientSideService;
  /**
   * Billing Settings SPI
   * @internal
   */
  billingSettings?: BillingSettingsConfig;
  /**
   * Patterns Wizard
   * @internal
   */
  patternsWizard?: PatternsWizard;
  /**
   * Application Profile SPI
   * @internal
   */
  applicationProfile?: ApplicationProfileProviderConfig;
  /**
   * Create an TextToSpeech message for a pre-installed automation, in order to translate it.
   * @internal
   */
  textToSpeechActionMessage?: TextToSpeechActionMessage;
  /**
   * Audience Provider
   * @internal
   */
  audienceProvider?: AudienceProviderConfig;
  /**
   * Pricing Plans Price
   * @internal
   */
  pricingPlansPrice?: PriceSPIConfig;
  /**
   * Pricing Plans Start Date Limits SPI
   * @internal
   */
  pricingPlanStartDateLimits?: StartDateLimitsSPIConfig;
  /**
   * Pricing Plans Start Date Rules SPI
   * @internal
   */
  pricingPlanStartDateRules?: StartDateRulesSPIConfig;
  /**
   * Events ticket reservations SPI
   * @internal
   */
  eventsTicketReservations?: TicketReservationsSpiConfig;
  /**
   * WIP: Dispute Service Plugin
   * @internal
   */
  paymentsDisputeServicePlugin?: DisputeServicePluginConfig;
  /**
   * Pricing Plans Fees
   * @internal
   */
  pricingPlansFees?: FeesSPIConfig;
  /**
   * A react component with native and custom editor abilities
   * @internal
   */
  editorReactComponent?: EditorReactComponent;
  /** @internal */
  suppliersHubMarketplace?: MarketplaceSPIConfig;
  /**
   * Form Schema Dynamic Values
   * @internal
   */
  formSchemaDynamicValues?: FormSchemaDynamicValuesSpiConfig;
  /**
   * Blog paywall SPI
   * @internal
   */
  blogPaywallProvider?: BlogPaywallProviderConfig;
  /**
   * Loyalty Custom Rewards V2
   * @internal
   */
  loyaltyCustomRewardsV2?: RewardProviderConfig;
  /**
   * Restriction service plugin for editing products managed by third-party fulfillment apps, such as dropshipping or print-on-demand services
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/stores/service-plugins/product-restrictions-v3/introduction
   */
  storesProductRestrictions?: ProductRestrictionsConfig;
  /**
   * Form Submission Moderation SPI
   * @internal
   */
  formSubmissionModeration?: FormSubmissionModerationSpiConfig;
  /**
   * Event badges SPI
   * @internal
   */
  eventsEventBadges?: EventBadgesSpiConfig;
  /**
   * Billing Operation SPI
   * @internal
   */
  billingOperation?: OperationExecutorConfig;
  /**
   * customization to the back office
   * @internal
   */
  backOfficeCustomization?: BackOfficeCustomization;
  /**
   * Dev Center components enricher SPI
   * @internal
   */
  componentEnricherProvider?: ComponentEnricherConfig;
  /**
   * Restricted customization to the back office
   * @internal
   */
  backOfficeRestrictedCustomization?: BackOfficeRestrictedCustomization;
  /**
   * Editor app previews POC
   * @internal
   */
  editorAppPreviewsPoc?: AppPreviewProviderConfig;
  /**
   * Legends Persona Configuration SPI
   * @internal
   */
  legendsPersonaConfiguration?: LegendsSpiConfig;
  /**
   * Wix Hosting App Deployment Provider SPI
   * @internal
   */
  wixHostingAppDeploymentProvider?: AppDeploymentProviderConfig;
  /**
   * A component to store the Velo BaaS deployment data
   * @internal
   */
  backendWorker?: BackendWorker;
  /**
   * Event Time Slots Configuration Provider SPI
   * @internal
   */
  eventTimeSlotsConfigurationProvider?: EventTimeSlotsProviderConfig;
  /**
   * Wix Hosting App Environment Provider SPI
   * @internal
   */
  wixHostingAppEnvironmentProvider?: AppEnvironmentProviderConfig;
  /**
   * SDK exports for existing app relavent SDK
   * @internal
   */
  sdkExports?: SDKExports;
  /**
   * A Javascript service for Apps and React Components that will be run in the viewer (client and server side rendering) and in the editor
   * @internal
   */
  viewerService?: ViewerService;
  /**
   * Wix Payments Provider Account Service Plugin
   * @internal
   */
  wixPaymentsProviderAccountServicePlugin?: ProviderAccountServicePluginConfig;
  /**
   * contacts segments v2 filter provider SPI
   * @internal
   */
  contactsSegmentsV2FilterProvider?: ProviderConfigMessage;
  /**
   * Wix Analytics product catalog provider SPI
   * @internal
   */
  analyticsProductCatalog?: ProductCatalogProviderConfig;
  /**
   * Wix Partner Store SPI
   * @internal
   */
  siteMigration?: SiteMigrationSpiConfig;
  /**
   * Restaurnts POS Provider Settings SPI
   * @internal
   */
  restaurantsPosProviderSettingsServicePlugin?: PosProviderSettingsServicePluginConfig;
  /**
   * Wix Vibe instructions
   * @internal
   */
  wixVibeCodingInstructions?: WixVibeCodingInstructions;
  /**
   * Tax Exempt Groups Provider Service Plugin
   * @internal
   */
  taxExemptGroupsProvider?: TaxExemptGroupsProviderConfig;
  /**
   * Bookings Automations Configuration Provider SPI
   * @internal
   */
  bookingAutomationsConfiguration?: BookingAutomationsConfig;
  /**
   * Bookings Platform Configuration Component
   * @internal
   */
  bookingsPlatformConfiguration?: BookingsPlatformConfig;
  /**
   * Bookings Validation Provider SPI - validates bookings for external providers
   * @internal
   */
  bookingsValidationProvider?: BookingsValidationProviderConfig;
  /**
   * Wix Vibe UI Component
   * @internal
   */
  wixVibeComponent?: WixVibeComponent;
  /**
   * Wixel SPI
   * @internal
   */
  wixel?: WixelSPIConfig;
  /** Bookings Staff Sorting Provider SPI */
  staffSortingProvider?: StaffSortingProviderConfig;
  /**
   * Function Ecom Discount Trigger Eligibility Provider SPI
   * @internal
   */
  functionEcomDiscountTriggerEligibilityProvider?: FunctionEcomDiscountTriggerEligibilityProviderConfig;
  /**
   * Functions Assistant Tools SPI
   * @internal
   */
  functionsAssistantTools?: FunctionAssistantToolProviderConfig;
  /**
   * Chunked Site Map Provider SPI for apps that serve large amount of site map entries
   * @internal
   */
  siteMapInfoProvider?: SiteMapProviderConfig;
  /** @internal */
  wixAiGatewayCallback?: WixAiGatewaySpiConfig;
  /**
   * URL mapper provider SPI
   * @internal
   */
  urlMapperProvider?: UrlMapperProviderConfig;
  /**
   * Provider suppression plugin
   * @internal
   */
  providerSuppressionServicePlugin?: ProviderSuppressionServicePluginConfig;
  /**
   * collect form data for checkout items
   * @internal
   */
  ecomForms?: FormsSPIConfig;
  /**
   * Editor Context Provider
   * @internal
   */
  editorContextProvider?: EditorContextProvider;
  /**
   * Editor Function Library
   * @internal
   */
  editorFunctionLibrary?: EditorFunctionLibrary;
  /**
   * Use routers to reuse pages design across multiple data items with dynamic URLs
   * @internal
   */
  appRouter?: AppRouter;
  /**
   * Wixel Binding SPI
   * @internal
   */
  wixelBinding?: BindingsSPIConfig;
  /**
   * Suppliers Hub Marketplace Provider V2
   * @internal
   */
  shubMarketplaceProvider?: MarketplaceProviderConfig;
  /**
   * Booking Action URLs Provider SPI
   * @internal
   */
  bookingActionUrlsProvider?: BookingActionUrlsProviderConfig;
  /**
   * Calendar Conferencing Provider SPI
   * @internal
   */
  calendarConferencingProvider?: ConferencingProviderConfig;
  /**
   * Validate cancel action provider SPI
   * @internal
   */
  bassValidateCancelAction?: CancelSubscriptionsConfig;
  /**
   * Wixel viewer router provider SPI
   * @internal
   */
  wixelViewerRouterProvider?: ViewerRouterSPIConfig;
  /**
   * Premium Action SPI
   * @internal
   */
  premiumAction?: PremiumActionConfig;
  /**
   * Automation Template
   * @internal
   */
  automationTemplate?: AutomationTemplateComponent;
  /**
   * Agent Maker Approval Provider SPI
   * @internal
   */
  agentMakerApprovalProvider?: ApprovalProviderConfig;
  /**
   * Service Tags Configuration SPI - declares valid tags for bookings services
   * @internal
   */
  serviceTagsConfiguration?: ServiceTagsConfig;
  /**
   * Loyalty Points Adjustment SPI - allows Functions to adjust loyalty points before assignment
   * @internal
   */
  loyaltyPointsAdjustment?: PointsAdjustmentProviderConfig;
  /**
   * Loyalty Earn Points Limit SPI
   * @internal
   */
  loyaltyEarnPointsLimit?: EarnPointsLimitProviderConfig;
  /**
   * Realtime Permissions Provider SPI - integrate with Wix to control who can receive messages on your Wix Realtime channels, by providing a custom permissions check that authorizes whether a subscriber is allowed to subscribe to your app's channels.
   * Learn More: https://dev.wix.com/docs/sdk/core-modules/realtime/extensions/realtime-permissions-provider/check-subscriber-permissions
   */
  realtimePermissionsProvider?: RealtimePermissionsProviderConfig;
  /**
   * Calendar Search Provider SPI — allows entities to participate in Calendar search
   * @internal
   */
  calendarSearchProvider?: CalendarSearchProviderConfig;
  /**
   * EditorInstallation — declares what to install when the parent app is installed in the editor
   * @internal
   */
  editorInstallation?: EditorInstallation;
  /**
   * App-level actions surfaced in the App Manager menu.
   * @internal
   */
  appActions?: AppActions;
  /**
   * Rollout Step Executor SPI — declares per-implementer config for services that execute one step of a multi-site rollout on one site.
   * @internal
   */
  rolloutStepExecutor?: RolloutStepExecutorConfig;
  /**
   * Bookings Platform Premium Validation SPI configuration.
   * @internal
   */
  bookingsPlatformPremiumValidation?: BookingsPlatformPremiumValidationProviderConfig;
  /**
   * Global CSS — URL pointing to the site's CSS content.
   * @internal
   */
  globalCss?: GlobalCssConfig;
  /**
   * Connector Config — declares how the app connects to a third-party provider, including its identity and authentication method.
   * @internal
   */
  connectorConfig?: ConnectorConfig;
  /**
   * Channel Data Provider SPI — lets a channel integrator provide business data (name, type, address) for a connected channel account.
   * @internal
   */
  channelDataProvider?: ChannelDataProviderConfig;
}

/** @oneof */
/** @internal */
export interface ComponentDataDataOneOf {
  /**
   * Create a widget iframe that users can display on their site. We recommend submitting a proposal before using iframes in your app.
   * Learn More: https://devforum.wix.com/en/article/widget-components
   */
  widgetComponentData?: WidgetComponentData;
  /**
   * Display an iframe as a page on a user's site.
   * Learn More: https://dev.wix.com/docs/build-apps/developer-tools/extensions/iframes/guide-to-page-extensions
   */
  pageComponentData?: PageComponentData;
  /**
   * Load a WOOI directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/viewer/platform/intro/get-started/guidelines
   * @internal
   */
  widgetOutOfIframeData?: WidgetOutOfIframeComponentData;
  /**
   * Load a POOI directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/viewer/platform/intro/get-started/guidelines
   * @internal
   */
  pageOutOfIframeData?: PageOutOfIframeComponentData;
  /**
   * Load a collection of native Editor components directly in the Editor DOM.
   * Learn More: https://dev.wix.com/docs/fed-guild/articles/editor-platform/welcome-to-the-editor-platform
   * @internal
   */
  platformComponentData?: PlatfromComponentData;
  /**
   * Open an iframe in the Dashboard, or add a link to a page on your platform.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/external-links/about-external-link-extensions
   */
  dashboardComponentData?: DashboardComponentData;
  /**
   * Use an invisible iframe to track activity. It’s added to every page on the site (max. 1).
   * Learn More: https://devforum.wix.com/en/article/worker-components
   */
  workerComponentData?: WorkerComponentData;
  /**
   * Use Wix Blocks to create a widget component. Wix Blocks will open in a new tab.
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/wix-blocks-server---app-builder
   * @internal
   */
  studioComponentData?: StudioComponentData;
  /**
   * A widget component in the Wix Blocks.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/wix-blocks
   * @internal
   */
  studioWidgetComponentData?: StudioWidgetComponentData;
  /**
   * A component that indicates the existence of an importable code package in a Wix Blocks application.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/wix-blocks-code-package
   * @internal
   */
  codePackageComponentData?: CodePackageComponentData;
  /**
   * Load a collection of native components directly in the Business Manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/dashboard-platfrom/dashboard-platfrom-component-data-object
   * @internal
   */
  dashboardPlatformComponentData?: DashboardPlatfromComponentData;
  /**
   * Inject a script into a site’s HTML code.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/embedded-scripts/about-embedded-scripts
   */
  embeddedScriptComponentData?: EmbeddedScriptComponentData;
  /**
   * Display a draggable component in the Editor using an HTML custom element.
   * Learn More: https://devforum.wix.com/kb/en/article/create-a-custom-element
   * @internal
   */
  webComponentData?: WebComponentData;
  /**
   * Extend app with internal Wix extension.
   * @internal
   */
  extensionData?: ExtensionData;
  /** @internal */
  snippetSolutionsData?: SnippetSolutionData;
  /**
   * Extend a site’s CMS to store and manage custom data.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/data-collections/about-data-collections-extensions
   */
  dataComponent?: DataComponent;
  /** @internal */
  dcConfigData?: DCConfigData;
  /**
   * Serve a file from the user’s site domain.
   * Learn More: https://devforum.wix.com/en/article/serving-staic-files-from-the-installed-sites-domain
   * @internal
   */
  staticFileComponentData?: StaticFileComponentData;
  /** @internal */
  appConfig?: AppConfig;
  /**
   * Create a multi-page dashboard in the Business Manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/multiple-dashboards
   * @internal
   */
  multipleDashboardsComponentData?: MultipleDashboardsComponentData;
  /**
   * Payments gateway extension description
   * @internal
   */
  paymentsGateway?: PaymentsGatewayComponentData;
  /**
   * Extend an app with automation capabilities using CRM Automations
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/automation-trigger
   * @internal
   */
  automationTrigger?: AutomationTrigger;
  /**
   * Any restrictions on invoices actions
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/invoices-actions
   * @internal
   */
  invoicesActionsComponentData?: InvoicesActionsComponentData;
  /**
   * Experimental-WIP: Business manager app_config, configures a module and its page components in business manager.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/dashboard-application
   * @internal
   */
  dashboardApplicationData?: DashboardApplicationData;
  /**
   * Contact Labels Components
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/contact-labels
   * @internal
   */
  contactLabels?: ContactLabelsComponentData;
  /**
   * Display a widget that fits into a predefined slot in a Wix app.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-plugins/about-site-plugin-extensions
   */
  widgetPlugin?: WidgetPluginComponentData;
  /**
   * Cross Sell Integration
   * @internal
   */
  crossSell?: CrossSellConfig;
  /**
   * Experimental-WIP: Local Delivery extension description.
   * Learn More: https://bo.wix.com/wix-docs/rnd/dev-center/components-catalog/local-delivery
   * @internal
   */
  localDelivery?: LocalDeliveryComponentData;
  /**
   * WIP: Velo payment provider SPI
   * @internal
   */
  paymentProvider?: PaymentServiceProviderConfig;
  /**
   * Memberships SPI for ECOM platform
   * @internal
   */
  ecomMemberships?: MembershipsSPIConfig;
  /**
   * Line Items Enricher SPI for ECOM platform
   * @internal
   */
  ecomLineItemsEnricher?: LineItemsEnricherConfig;
  /**
   * Provide custom shipping rates to a site's cart and checkout.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/shipping-rates-integration-service-plugin/introduction
   */
  ecomShippingRates?: ShippingRatesConfig;
  /**
   * Shipping Label Carrier SPI
   * @internal
   */
  shippingLabelCarrier?: ShippingLabelCarrierSpiConfig;
  /**
   * Restaurants POS service plugin
   * @internal
   */
  restaurantsPos?: RestaurantsPOSComponentData;
  /**
   * A fictional Shipping SPI that is used by developers to complete SPI training
   * https://github.com/wix-academy/spi-in-scala-path
   * @internal
   */
  fictionalShippingProvider?: ShippingProviderConfig;
  /**
   * Alert Enricher Integration
   * @internal
   */
  alertEnricher?: AlertEnricherSpiConfiguration;
  /** Extend a Wix entity with custom fields for your app */
  dataExtensions?: DataExtensionsComponentData;
  /**
   * A common component type for all Generic Hooks
   * @internal
   */
  genericHooks?: GenericHooksConfig;
  /**
   * WIP: automations action provider
   * @internal
   */
  automationsActionProvider?: ActionProviderSPIConfig;
  /**
   * Become a Wix catalog provider and integrate any external repository of sellable items with the Wix eCommerce platform.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/catalog-service-plugin/introduction
   */
  ecomCatalog?: CatalogSPIConfig;
  /**
   * Add a space to a Wix Dashboard page that can be extended with a widget or menu item.
   * @internal
   */
  backOfficeExtensionContainer?: BackOfficeExtensionContainer;
  /**
   * Create a widget or menu item that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/about-dashboard-plugin-extensions
   * @internal
   */
  backOfficeExtension?: BackOfficeExtension;
  /**
   * WIP: automations trigger provider
   * @internal
   */
  automationsTriggerProvider?: TriggerProviderSPIConfig;
  /**
   * WIP - SPI for execution before identity creation in the new IAM platform
   * @internal
   */
  identityPreRegistration?: PreRegisterConfig;
  /**
   * Premium products upgrades/downgrades
   * @internal
   */
  premiumProductsPaths?: ProductsPathsConfig;
  /**
   * ECOM custom scopes provider - define scopes of catalog items based custom attributes
   * @internal
   */
  ecomCustomScope?: CustomScopeConfig;
  /**
   * Implement gift card benefits such as balance retrieval, redemption, and voiding transactions.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/gift-cards-service-plugin/introduction
   */
  giftCardsProvider?: GiftCardProviderConfig;
  /**
   * Dealer External Filter SPI
   * @internal
   */
  dealerExternalFilterProvider?: ExternalFilterProviderConfig;
  /**
   * Recommendations provider SPI
   * @internal
   */
  ecomRecommendationsProvider?: RecommendationsProviderConfig;
  /**
   * Dropshipping Provider SPI for Ecom Platform
   * @internal
   */
  ecomDropshippingProvider?: DropshippingProviderSPIConfig;
  /**
   * Invoices SPI
   * @internal
   */
  invoicesProvider?: InvoicesConfig;
  /**
   * Provide SEO keyword suggestions to site collaborators, report quota usage, and provide a page where users can upgrade their plan.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/marketing/seo-keywords-suggestions-v-1/introduction
   */
  seoKeywordsSuggestions?: SeoKeywordsSuggestionsSPIConfig;
  /**
   * Ecom custom discount trigger service plugin - define custom triggers to apply discount rules
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/custom-discount-triggers-integration-service-plugin/introduction
   * @internal
   */
  ecomDiscountsTrigger?: CustomTriggerConfig;
  /**
   * Multilingual content provider for site translator to read and update translations
   * @internal
   */
  multilingualContentProvider?: ContentProviderConfig;
  /**
   * Application Automation
   * @internal
   */
  applicationAutomation?: ApplicationAutomationComponent;
  /**
   * Experimental-WIP: A back office page category
   * @internal
   */
  backOfficeSidebarCategory?: BackOfficeSidebarCategory;
  /**
   * Configure a page for your app that will be embedded in the Wix Dashboard.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-pages/about-dashboard-page-extensions
   */
  backOfficePage?: BackOfficePage;
  /**
   * Provide custom additional fees that are added to a site's cart and checkout.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/additional-fees-service-plugin/introduction
   */
  ecomAdditionalFees?: AdditionalFeesSPIConfig;
  /**
   * Send notifications to your app users
   * @internal
   */
  pingUserNotification?: PingNotificationComponentData;
  /** Bookings Pricing Provider SPI */
  bookingsPricingProvider?: BookingsPricingProviderConfig;
  /**
   * Authenticator SPI
   * @internal
   */
  identityAuthenticator?: AuthenticatorConfig;
  /**
   * WIP - SPI for authenticating via external IDP in the new IAM platform
   * @internal
   */
  identityIdpConnector?: IDPConnectionConfig;
  /**
   * Items Selector
   * @internal
   */
  itemsSelectionProvider?: ItemsSelectionProviderConfig;
  /**
   * Portfolio synced projects provider
   * @internal
   */
  portfolioSyncedProjectsProvider?: SyncedProjectsProviderConfig;
  /**
   * Communication Channel
   * @internal
   */
  communicationChannel?: CommunicationChannelConfiguration;
  /**
   * WIP - SPI to run after the login process
   * @internal
   */
  identityPostLogin?: PostLoginConfig;
  /**
   * Create a component that can be easily placed in or opened from a Wix app page.
   * @internal
   */
  backOfficeWidget?: BackOfficeWidget;
  /**
   * Social Marketing Design SPI
   * @internal
   */
  socialMarketingDesign?: SocialMarketingDesignSPIConfig;
  /**
   * Forms Submissions SPI
   * @internal
   */
  formsSubmissionsProvider?: FormSubmissionSpiConfig;
  /**
   * Wix Offering
   * @internal
   */
  wixOffering?: WixOfferingComponentData;
  /**
   * Components translation test component
   * @internal
   */
  devCenterTestingComponent?: DevCenterTestingComponentData;
  /**
   * Components Validator SPI
   * @internal
   */
  componentsValidatorProvider?: ComponentsValidatorConfig;
  /**
   * Components Translations additional fields config
   * @internal
   */
  componentsTranslationsAdditionalFieldsProvider?: ComponentTranslationAdditionalFieldsConfig;
  /**
   * Forms Schema SPI
   * @internal
   */
  formsSchemaProvider?: FormSchemaSpiConfig;
  /**
   * Bookings External Calendar Provider
   * @internal
   */
  bookingsExternalCalendarProvider?: ProviderConfig;
  /**
   * Default Tax Category Config
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/platform-tax
   * @internal
   */
  ecomDefaultTaxationCategory?: DefaultTaxGroupProviderConfig;
  /**
   * Viewer Dynamic Site Structure Config
   * @internal
   */
  viewerDynamicSiteStructureProvider?: DynamicSiteStructureProviderConfig;
  /**
   * Send notifications to your app users of users
   * @internal
   */
  pingUouNotification?: PingNotificationComponentData;
  /**
   * Holds data for authenticating Headless Applications
   * @internal
   */
  headlessOauth?: HeadlessOAuth;
  /**
   * Tax Calculator Structure Config
   * Learn More: https://bo.wix.com/wix-docs/rest/drafts/platform-tax
   * @internal
   */
  ecomTaxCalculatorSpi?: TaxCalculatorSpiConfig;
  /**
   * Comments Moderation Provider Config
   * @internal
   * @deprecated Comments Moderation Provider Config
   * @replacedBy comments_filter_provider
   */
  commentsModerationProvider?: CommentModerationProviderConfig;
  /**
   * GridApp files transformer config
   * @internal
   */
  gridAppFilesTransformer?: GridAppFilesTransformerConfig;
  /**
   * Holds benefit programs policy provider configuration
   * @internal
   */
  benefitProgramsPolicyProvider?: PolicyConfig;
  /**
   * Apply custom charges to a site based on usage of your app's services.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/app-management/apps/custom-charges-spi/introduction
   */
  premiumCustomCharges?: CustomChargesConfig;
  /**
   * Validate items in a site's cart and checkout based on custom logic.
   * Learn More: https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/validations-integration-spi/introduction
   */
  ecomValidations?: ValidationsSPIConfig;
  /**
   * Component Reference Data SPI
   * @internal
   */
  componentReferenceDataProvider?: ComponentReferenceDataConfig;
  /**
   * Wix Reviews SPI
   * @internal
   */
  wixReviewsProductCatalog?: ReviewsProductCatalogProviderConfig;
  /**
   * Promote Social Marketing Designs Provider Configuration
   * @internal
   */
  socialMarketingDesignsProvider?: SocialMarketingDesignsProviderConfig;
  /**
   * Promote Google Business Profile Provider Configuration
   * @internal
   */
  googleBusinessProfileFeatureProvider?: GbpFeatureConfig;
  /**
   * Comments Filter Provider Config
   * @internal
   */
  commentsFilterProvider?: CommentFilterProviderConfig;
  /**
   * Tax ID Validator SPI Config
   * @internal
   */
  billingTaxIdValidator?: TaxIdValidatorConfig;
  /**
   * Ping Settings Group Data
   * @internal
   */
  pingSettingsGroup?: PingSettingsGroupComponentData;
  /**
   * Forms Spam Submissions SPI
   * @internal
   */
  formsSpamSubmissionsProvider?: FormSpamSubmissionSpiConfig;
  /**
   * Build a tool that adds functionality to the Wix editors.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/editor-extensions/about-editor-extensions
   */
  editorAddon?: EditorAddon;
  /** External Database component */
  externalDatabaseProvider?: ExternalDatabaseSpiConfig;
  /**
   * Integrate your service with Wix's payment process to allow merchants to request and use your services on their Wix sites.
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/payment-settings-integration-service-plugin/introduction
   */
  ecomPaymentSettings?: PaymentSettingsSPIConfig;
  /**
   * Group multiple notifications into one preference toggle.
   * Learn More: https://dev.wix.com/docs/build-apps/build-your-app/user-notifications/add-notification-topics
   * @internal
   */
  notificationTopic?: NotificationTopic;
  /**
   * Notification Preference SPI
   * @internal
   */
  notificationPreferencesFilterProvider?: NotificationPreferencesFilterConfig;
  /**
   * Bookings Resource Types provider SPI config
   * @internal
   */
  bookingsResourceTypesProvider?: BookingsResourceTypesProviderConfig;
  /**
   * Pricing Plans form configuration
   * @internal
   */
  pricingPlansFormConfiguration?: PricingPlansFormConfiguration;
  /**
   * Create a notification to alert your app users about important updates and events.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/notifications/about-notification-extensions
   * @internal
   */
  userNotification?: UserNotification;
  /**
   * Contact Notification
   * @internal
   */
  contactNotification?: ContactNotification;
  /**
   * Add a site page that displays selected widgets.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-pages/about-site-page-extensions
   */
  unifiedPage?: UnifiedPage;
  /**
   * Availability Time Slots Configuration Provider SPI
   * @internal
   */
  availabilityTimeSlotsConfigurationProvider?: AvailabilityTimeSlotsProviderConfig;
  /**
   * Proposal Editor Provider SPI config
   * @internal
   */
  proposalEditorProvider?: ProposalEditorProviderConfig;
  /**
   * Custom Table Reservations Provider SPI config
   * @internal
   */
  customTableReservationsProvider?: CustomReservationsApprovalConfig;
  /**
   * Comments Context provider
   * @internal
   */
  commentsContextProvider?: CommentsContextProviderConfig;
  /**
   * Forms Spam Submission Reports SPI
   * @internal
   */
  formsSpamSubmissionReportsProvider?: FormSpamSubmissionReportSpiConfig;
  /**
   * Automation Velo Action Spi Provider
   * @internal
   */
  automationsVeloActionProvider?: VeloActionConfig;
  /**
   * Calendar Event Type Provider
   * @internal
   */
  calendarEventTypeProvider?: EventTypeProviderConfig;
  /**
   * Reserved - previously was `service_availability_policy_provider`
   * @internal
   */
  reserved?: ServiceAvailabilityPolicyProviderConfig;
  /**
   * Create an SMS message for a pre-installed automation, in order to translate it.
   * @internal
   */
  smsActionMessage?: SmsActionMessage;
  /**
   * Booking Policy Provider SPI
   * @internal
   */
  bookingPolicyProvider?: BookingPolicyProviderConfig;
  /**
   * Multi Service Booking Policy Provider SPI
   * @internal
   */
  multiServiceBookingPolicyProvider?: MultiServiceBookingPolicyProviderConfig;
  /**
   * Forms Submissions Extension SPI
   * @internal
   */
  formsSubmissionsExtensionProvider?: FormSubmissionSpiExtensionConfig;
  /**
   * AI Assistant SPI
   * @internal
   */
  aiAssistant?: AssistantSpiConfig;
  /**
   * Multilingual translation schema
   * Learn More: https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/translation-schema/schema-object
   */
  multilingualTranslationSchema?: MultilingualTranslationSchema;
  /**
   * Tax Groups Provider Service Plugin
   * @internal
   */
  taxGroupsProvider?: TaxGroupsProviderConfig;
  /**
   * Tax Calculation Provider Service Plugin
   * @internal
   */
  taxCalculationProvider?: TaxCalculationConfig;
  /** Create a reusable modal that can be utilized across multiple pages within your app and in other applications. */
  backOfficeModal?: BackOfficeModal;
  /**
   * Deployment Pipeline Provider SPI
   * @internal
   */
  deploymentPipelineProvider?: DeploymentPipelineProviderConfig;
  /**
   * Display a draggable widget on a site using a self-hosted custom element.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-widgets/about-site-widget-extensions
   */
  customElementWidget?: CustomElementWidget;
  /**
   * Create a widget that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/about-dashboard-plugin-extensions
   * @internal
   */
  backOfficeExtensionWidget?: BackOfficeExtensionWidget;
  /**
   * Create a menu item that will be rendered within a Wix Dashboard page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/dashboard-extensions/dashboard-plugins/dashboard-menu-plugins/dashboard-menu-plugin-extensions
   * @internal
   */
  backOfficeExtensionMenuItem?: BackOfficeExtensionMenuItem;
  /**
   * Form Template
   * @internal
   */
  formTemplate?: FormTemplate;
  /**
   * Notification Content
   * @internal
   */
  notificationContent?: NotificationContent;
  /**
   * Broadcast List
   * @internal
   */
  broadcastList?: BroadcastList;
  /**
   * Partners Payouts
   * @internal
   */
  partnersPayouts?: PayoutsProviderConfig;
  /**
   * Wix Reviews Entity Catalog Provider SPI
   * @internal
   */
  wixReviewsEntityCatalog?: ReviewsEntityCatalogProviderConfig;
  /**
   * Velo Publish Pipeline Task Provider SPI
   * @internal
   */
  veloPublishPipelineTaskProvider?: VeloPublishPipelineTaskProviderConfig;
  /**
   * Function shop POC SPI
   * @internal
   */
  functionsShopPriceProvider?: FunctionsShopPriceSpiConfig;
  /**
   * Connect your service plugins to Functions so users can define their own custom logic.
   * Learn More: https://github.com/wix-private/functions-client/blob/master/README.md
   * @internal
   */
  function?: _Function;
  /**
   * Ecom Checkout Content
   * @internal
   */
  ecomCheckoutContent?: CheckoutContentSPIConfig;
  /**
   * Communication Channel
   * @internal
   */
  communicationChannelProvider?: V2CommunicationChannelConfiguration;
  /**
   * Webhook
   * @internal
   */
  webhook?: WebhookComponentData;
  /**
   * An extension that holds topology data.
   * @internal
   */
  topology?: TopologyComponentData;
  /**
   * Loyalty Custom Rewards POC
   * @internal
   */
  loyaltyCustomRewards?: CustomRewardProviderConfig;
  /**
   * Create a predefined template that users can use when creating flows in Functions.
   * Learn More: https://github.com/wix-private/functions-client/blob/master/docs/function-templates.md
   * @internal
   */
  functionRecipe?: FunctionRecipe;
  /**
   * external url to the back office
   * @internal
   */
  backOfficeExternalUrl?: BackOfficeExternalUrl;
  /**
   * Authentication factor
   * @internal
   */
  identityFactor?: FactorConfig;
  /**
   * ecom discounts
   * @internal
   */
  ecomDiscounts?: DiscountsSPIConfig;
  /**
   * Blocks Velo custom css - for CSS editing in Blocks
   * @internal
   */
  veloCustomCss?: VeloCustomCss;
  /**
   * Dealer Adaptive Component Provider SPI
   * @internal
   */
  dealerAdaptiveComponentProvider?: AdaptiveComponentProviderConfig;
  /**
   * Wix AI Assistant Action SPI
   * @internal
   */
  aiAssistantAction?: ActionSpiConfig;
  /**
   * Integrate any external inventory with the Wix eCommerce platform.
   * Learn More: https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/catalogs/inventory-service-plugin/introduction
   */
  ecomInventory?: InventorySpiConfig;
  /**
   * Add a monitoring configuration to your app.
   * Learn More: https://dev.wix.com/docs/build-apps/manage-your-app/observability/monitor-your-app-with-sentry
   * @internal
   */
  monitoring?: Monitoring;
  /**
   * PAPI SPI
   * @internal
   */
  papiProvider?: PluginConfig;
  /**
   * Add a lightbox that displays a widget in a popup over a site page.
   * Learn More: https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-lightboxes/about-site-lightbox-extensions
   * @internal
   */
  unifiedLightbox?: UnifiedLightbox;
  /**
   * Forms Schema Extension SPI
   * @internal
   */
  formsExtensionProvider?: FormSpiExtensionConfig;
  /** Multilingual translation schema group */
  multilingualTranslationSchemaGroup?: SchemaGroup;
  /**
   * Panel data
   * @internal
   */
  panel?: Panel;
  /**
   * Premium Purchase Validations SPI
   * @internal
   */
  premiumPurchaseValidations?: PurchaseValidationsConfig;
  /**
   * Any Cookies, localStorage, sessionStorage or IndexDB items the app is using in the site or their domain
   * @internal
   */
  browserStorage?: BrowserStorage;
  /**
   * Map this app to SDK module
   * @internal
   */
  sdkDefinition?: SdkDefinition;
  /**
   * Add a space to a Page or Widget that can be extended with a widget plugin.
   * @internal
   */
  siteWidgetSlot?: SiteWidgetSlot;
  /**
   * Calendar Event Validation Provider
   * @internal
   */
  calendarEventValidationProvider?: EventValidationProviderConfig;
  /** @internal */
  clientSideService?: ClientSideService;
  /**
   * Billing Settings SPI
   * @internal
   */
  billingSettings?: BillingSettingsConfig;
  /**
   * Patterns Wizard
   * @internal
   */
  patternsWizard?: PatternsWizard;
  /**
   * Application Profile SPI
   * @internal
   */
  applicationProfile?: ApplicationProfileProviderConfig;
  /**
   * Create an TextToSpeech message for a pre-installed automation, in order to translate it.
   * @internal
   */
  textToSpeechActionMessage?: TextToSpeechActionMessage;
  /**
   * Audience Provider
   * @internal
   */
  audienceProvider?: AudienceProviderConfig;
  /**
   * Pricing Plans Price
   * @internal
   */
  pricingPlansPrice?: PriceSPIConfig;
  /**
   * Pricing Plans Start Date Limits SPI
   * @internal
   */
  pricingPlanStartDateLimits?: StartDateLimitsSPIConfig;
  /**
   * Pricing Plans Start Date Rules SPI
   * @internal
   */
  pricingPlanStartDateRules?: StartDateRulesSPIConfig;
  /**
   * Events ticket reservations SPI
   * @internal
   */
  eventsTicketReservations?: TicketReservationsSpiConfig;
  /**
   * WIP: Dispute Service Plugin
   * @internal
   */
  paymentsDisputeServicePlugin?: DisputeServicePluginConfig;
  /**
   * Pricing Plans Fees
   * @internal
   */
  pricingPlansFees?: FeesSPIConfig;
  /**
   * A react component with native and custom editor abilities
   * @internal
   */
  editorReactComponent?: EditorReactComponent;
  /** @internal */
  suppliersHubMarketplace?: MarketplaceSPIConfig;
  /**
   * Form Schema Dynamic Values
   * @internal
   */
  formSchemaDynamicValues?: FormSchemaDynamicValuesSpiConfig;
  /**
   * Blog paywall SPI
   * @internal
   */
  blogPaywallProvider?: BlogPaywallProviderConfig;
  /**
   * Loyalty Custom Rewards V2
   * @internal
   */
  loyaltyCustomRewardsV2?: RewardProviderConfig;
  /**
   * Restriction service plugin for editing products managed by third-party fulfillment apps, such as dropshipping or print-on-demand services
   * Learn More: https://dev.wix.com/docs/rest/business-solutions/stores/service-plugins/product-restrictions-v3/introduction
   */
  storesProductRestrictions?: ProductRestrictionsConfig;
  /**
   * Form Submission Moderation SPI
   * @internal
   */
  formSubmissionModeration?: FormSubmissionModerationSpiConfig;
  /**
   * Event badges SPI
   * @internal
   */
  eventsEventBadges?: EventBadgesSpiConfig;
  /**
   * Billing Operation SPI
   * @internal
   */
  billingOperation?: OperationExecutorConfig;
  /**
   * customization to the back office
   * @internal
   */
  backOfficeCustomization?: BackOfficeCustomization;
  /**
   * Dev Center components enricher SPI
   * @internal
   */
  componentEnricherProvider?: ComponentEnricherConfig;
  /**
   * Restricted customization to the back office
   * @internal
   */
  backOfficeRestrictedCustomization?: BackOfficeRestrictedCustomization;
  /**
   * Editor app previews POC
   * @internal
   */
  editorAppPreviewsPoc?: AppPreviewProviderConfig;
  /**
   * Legends Persona Configuration SPI
   * @internal
   */
  legendsPersonaConfiguration?: LegendsSpiConfig;
  /**
   * Wix Hosting App Deployment Provider SPI
   * @internal
   */
  wixHostingAppDeploymentProvider?: AppDeploymentProviderConfig;
  /**
   * A component to store the Velo BaaS deployment data
   * @internal
   */
  backendWorker?: BackendWorker;
  /**
   * Event Time Slots Configuration Provider SPI
   * @internal
   */
  eventTimeSlotsConfigurationProvider?: EventTimeSlotsProviderConfig;
  /**
   * Wix Hosting App Environment Provider SPI
   * @internal
   */
  wixHostingAppEnvironmentProvider?: AppEnvironmentProviderConfig;
  /**
   * SDK exports for existing app relavent SDK
   * @internal
   */
  sdkExports?: SDKExports;
  /**
   * A Javascript service for Apps and React Components that will be run in the viewer (client and server side rendering) and in the editor
   * @internal
   */
  viewerService?: ViewerService;
  /**
   * Wix Payments Provider Account Service Plugin
   * @internal
   */
  wixPaymentsProviderAccountServicePlugin?: ProviderAccountServicePluginConfig;
  /**
   * contacts segments v2 filter provider SPI
   * @internal
   */
  contactsSegmentsV2FilterProvider?: ProviderConfigMessage;
  /**
   * Wix Analytics product catalog provider SPI
   * @internal
   */
  analyticsProductCatalog?: ProductCatalogProviderConfig;
  /**
   * Wix Partner Store SPI
   * @internal
   */
  siteMigration?: SiteMigrationSpiConfig;
  /**
   * Restaurnts POS Provider Settings SPI
   * @internal
   */
  restaurantsPosProviderSettingsServicePlugin?: PosProviderSettingsServicePluginConfig;
  /**
   * Wix Vibe instructions
   * @internal
   */
  wixVibeCodingInstructions?: WixVibeCodingInstructions;
  /**
   * Tax Exempt Groups Provider Service Plugin
   * @internal
   */
  taxExemptGroupsProvider?: TaxExemptGroupsProviderConfig;
  /**
   * Bookings Automations Configuration Provider SPI
   * @internal
   */
  bookingAutomationsConfiguration?: BookingAutomationsConfig;
  /**
   * Bookings Platform Configuration Component
   * @internal
   */
  bookingsPlatformConfiguration?: BookingsPlatformConfig;
  /**
   * Bookings Validation Provider SPI - validates bookings for external providers
   * @internal
   */
  bookingsValidationProvider?: BookingsValidationProviderConfig;
  /**
   * Wix Vibe UI Component
   * @internal
   */
  wixVibeComponent?: WixVibeComponent;
  /**
   * Wixel SPI
   * @internal
   */
  wixel?: WixelSPIConfig;
  /** Bookings Staff Sorting Provider SPI */
  staffSortingProvider?: StaffSortingProviderConfig;
  /**
   * Function Ecom Discount Trigger Eligibility Provider SPI
   * @internal
   */
  functionEcomDiscountTriggerEligibilityProvider?: FunctionEcomDiscountTriggerEligibilityProviderConfig;
  /**
   * Functions Assistant Tools SPI
   * @internal
   */
  functionsAssistantTools?: FunctionAssistantToolProviderConfig;
  /**
   * Chunked Site Map Provider SPI for apps that serve large amount of site map entries
   * @internal
   */
  siteMapInfoProvider?: SiteMapProviderConfig;
  /** @internal */
  wixAiGatewayCallback?: WixAiGatewaySpiConfig;
  /**
   * URL mapper provider SPI
   * @internal
   */
  urlMapperProvider?: UrlMapperProviderConfig;
  /**
   * Provider suppression plugin
   * @internal
   */
  providerSuppressionServicePlugin?: ProviderSuppressionServicePluginConfig;
  /**
   * collect form data for checkout items
   * @internal
   */
  ecomForms?: FormsSPIConfig;
  /**
   * Editor Context Provider
   * @internal
   */
  editorContextProvider?: EditorContextProvider;
  /**
   * Editor Function Library
   * @internal
   */
  editorFunctionLibrary?: EditorFunctionLibrary;
  /**
   * Use routers to reuse pages design across multiple data items with dynamic URLs
   * @internal
   */
  appRouter?: AppRouter;
  /**
   * Wixel Binding SPI
   * @internal
   */
  wixelBinding?: BindingsSPIConfig;
  /**
   * Suppliers Hub Marketplace Provider V2
   * @internal
   */
  shubMarketplaceProvider?: MarketplaceProviderConfig;
  /**
   * Booking Action URLs Provider SPI
   * @internal
   */
  bookingActionUrlsProvider?: BookingActionUrlsProviderConfig;
  /**
   * Calendar Conferencing Provider SPI
   * @internal
   */
  calendarConferencingProvider?: ConferencingProviderConfig;
  /**
   * Validate cancel action provider SPI
   * @internal
   */
  bassValidateCancelAction?: CancelSubscriptionsConfig;
  /**
   * Wixel viewer router provider SPI
   * @internal
   */
  wixelViewerRouterProvider?: ViewerRouterSPIConfig;
  /**
   * Premium Action SPI
   * @internal
   */
  premiumAction?: PremiumActionConfig;
  /**
   * Automation Template
   * @internal
   */
  automationTemplate?: AutomationTemplateComponent;
  /**
   * Agent Maker Approval Provider SPI
   * @internal
   */
  agentMakerApprovalProvider?: ApprovalProviderConfig;
  /**
   * Service Tags Configuration SPI - declares valid tags for bookings services
   * @internal
   */
  serviceTagsConfiguration?: ServiceTagsConfig;
  /**
   * Loyalty Points Adjustment SPI - allows Functions to adjust loyalty points before assignment
   * @internal
   */
  loyaltyPointsAdjustment?: PointsAdjustmentProviderConfig;
  /**
   * Loyalty Earn Points Limit SPI
   * @internal
   */
  loyaltyEarnPointsLimit?: EarnPointsLimitProviderConfig;
  /**
   * Realtime Permissions Provider SPI - integrate with Wix to control who can receive messages on your Wix Realtime channels, by providing a custom permissions check that authorizes whether a subscriber is allowed to subscribe to your app's channels.
   * Learn More: https://dev.wix.com/docs/sdk/core-modules/realtime/extensions/realtime-permissions-provider/check-subscriber-permissions
   */
  realtimePermissionsProvider?: RealtimePermissionsProviderConfig;
  /**
   * Calendar Search Provider SPI — allows entities to participate in Calendar search
   * @internal
   */
  calendarSearchProvider?: CalendarSearchProviderConfig;
  /**
   * EditorInstallation — declares what to install when the parent app is installed in the editor
   * @internal
   */
  editorInstallation?: EditorInstallation;
  /**
   * App-level actions surfaced in the App Manager menu.
   * @internal
   */
  appActions?: AppActions;
  /**
   * Rollout Step Executor SPI — declares per-implementer config for services that execute one step of a multi-site rollout on one site.
   * @internal
   */
  rolloutStepExecutor?: RolloutStepExecutorConfig;
  /**
   * Bookings Platform Premium Validation SPI configuration.
   * @internal
   */
  bookingsPlatformPremiumValidation?: BookingsPlatformPremiumValidationProviderConfig;
  /**
   * Global CSS — URL pointing to the site's CSS content.
   * @internal
   */
  globalCss?: GlobalCssConfig;
  /**
   * Connector Config — declares how the app connects to a third-party provider, including its identity and authentication method.
   * @internal
   */
  connectorConfig?: ConnectorConfig;
  /**
   * Channel Data Provider SPI — lets a channel integrator provide business data (name, type, address) for a connected channel account.
   * @internal
   */
  channelDataProvider?: ChannelDataProviderConfig;
}

/** An iframe to be displayed on the user’s site */
export interface WidgetComponentData {
  /** Allow users to resize and move the widget, or pin it to a specific position on all pages of the site. */
  fixedPositionOption?: FixedPositionOptions;
  /** Widget will automatically be stretched to this width after installing it */
  widgetWidthType?: WidgetWidthTypeWithLiterals;
  /**
   * Widget width size
   * @max 9999
   */
  width?: number | null;
  /**
   * Widget width height
   * @max 9999
   */
  height?: number | null;
  /**
   * A public link to the widget endpoint
   * @format WEB_URL
   */
  widgetEndpointUrl?: string | null;
  /** A public link to the mobile endpoint */
  widgetMobileEndpointUrl?: string | null;
  /** A public link to the settings endpoint */
  settingsEndpointUrl?: string | null;
  /** A public link to the SEO endpoint */
  seoEndpointUrl?: string | null;
  /** Product display data for this component */
  widgetDisplay?: WidgetDisplay;
  /** When true, this is the default component */
  default?: boolean;
  /** When this is turned on, this page will be added to the site when installing the app, regardless of whether it's the default component or not */
  essential?: boolean;
  /** Published state for this widget */
  published?: boolean;
  /** When true, allow this widget to be added only once */
  addOnlyOnce?: boolean;
  /**
   * This ID is used to identify your widget endpoint in a Wix site. You can use this ID when using methods of the Wix SDK
   * @readonly
   */
  tpaWidgetId?: string;
  /** Where this should be rendered */
  position?: Position;
  /** Article id in settings panel */
  helpId?: string | null;
  /** Default Mobile Height */
  defaultMobileHeight?: number | null;
  /** Min Mobile Height */
  minMobileHeight?: number | null;
  /** Mobile Settings Enabled */
  mobileSettingsEnabled?: boolean;
  /** Mobile article id in settings panel */
  mobileHelpId?: string | null;
  /**
   * Editor setting version. optional values: 1 (old - deprecated) or 2 (new). default value is 2
   * @min 1
   * @max 2
   */
  settingsVersion?: number | null;
  /** If setting version is 1, this will be the public link to the settings endpoint */
  settingsEndpointUrlV1?: string | null;
  /** A public link to the settings endpoint on ADI editor */
  onBoardingSettingsEndpointUrl?: string | null;
  /** The sub pages list for this component to be rendered in */
  subPages?: SubPage[];
  /** If this component should be stretched in relation to a form factor (desktop, tablet, mobile) */
  isStretched?: IsStretched;
  /** Any margins this page should have in relation to a form factor (desktop, tablet, mobile) */
  margins?: Margins;
  /** Any docking this page (horizontal / vertical) should have in relation to a form factor (desktop, tablet, mobile) */
  docking?: Docking;
  /** The height of this page in relation to a form factor (desktop, tablet, mobile) */
  heightBreakPoints?: Height;
  /** The width of this page in relation to a form factor (desktop, tablet, mobile) */
  widthBreakPoints?: ApiWidth;
  /** Keep default and let users stretch widget to full width (GFPP) */
  addStretchButton?: boolean;
  /** toggle to mark whether the editor should revoke an app that contains this component. */
  excludeFromAutoRevoke?: boolean;
  /** should be <%=serviceUrl('your_artifact_id', '<resource-path>')%>, this field will later be used to trasform the settings url field in both the component and the **derived widget** */
  settingsEndpointUrlTemplate?: string | null;
  /** should be <%=serviceUrl('your_artifact_id', '<resource-path>')%>, this field will later be used to trasform the settings url field in both the component and the **derived widget** */
  settingsEndpointUrlV1Template?: string | null;
  /**
   * The component-type as will be written in Document Management.
   * @internal
   * @maxLength 512
   */
  componentType?: string | null;
  /**
   * The type of the referenced schema e.g. `wysiwyg.viewer.components.tpapps.TPAWidget`.
   * @internal
   * @maxLength 512
   */
  refType?: string | null;
  /**
   * if true, ssr will not cache pages that contain this widget
   * @internal
   */
  ssrCacheExcluded?: boolean;
  /**
   * if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @internal
   * @deprecated if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @replacedBy site_members_ssr_caching
   * @targetRemovalDate 2025-12-31
   */
  siteMembersSsrCacheExcluded?: boolean;
  /**
   * Controls SSR caching behavior when site members are logged in
   * @internal
   */
  siteMembersSsrCaching?: SiteMembersSsrCachingWithLiterals;
  /**
   * Controls MPA Navigation behavior for this widget
   * @internal
   */
  mpaNavigation?: MpaNavigationWithLiterals;
  /** Add widget to site home page (supported only in server installation currently) */
  addToHomePage?: boolean;
}

/** Allow users to resize and move the widget, or pin it to a specific position on all pages of the site. */
/** @internal */
export interface FixedPositionOptions {
  /** Vertical widget position in the browser window */
  widgetVertical?: WidgetVerticalWithLiterals;
  /** Horizontal widget position in the browser window */
  widgetHorizontal?: WidgetHorizontalWithLiterals;
}

/** Vertical widget position in the browser window */
/** @internal */
export enum WidgetVertical {
  NONE_VERTICAL = 'NONE_VERTICAL',
  TOP = 'TOP',
  CENTER_VERTICAL = 'CENTER_VERTICAL',
  BOTTOM = 'BOTTOM',
}

/** @enumType */
/** @internal */
export type WidgetVerticalWithLiterals =
  | WidgetVertical
  | 'NONE_VERTICAL'
  | 'TOP'
  | 'CENTER_VERTICAL'
  | 'BOTTOM';

/** Horizontal widget position in the browser window */
/** @internal */
export enum WidgetHorizontal {
  NONE_HORIZONTAL = 'NONE_HORIZONTAL',
  LEFT = 'LEFT',
  CENTER_HORIZONTAL = 'CENTER_HORIZONTAL',
  RIGHT = 'RIGHT',
}

/** @enumType */
/** @internal */
export type WidgetHorizontalWithLiterals =
  | WidgetHorizontal
  | 'NONE_HORIZONTAL'
  | 'LEFT'
  | 'CENTER_HORIZONTAL'
  | 'RIGHT';

/** Widget will automatically be stretched to this width after installing it */
/** @internal */
export enum WidgetWidthType {
  NONE_TYPE = 'NONE_TYPE',
  /** A custom width for the widget */
  CUSTOM = 'CUSTOM',
  /** Full width of the browser window */
  FULL = 'FULL',
}

/** @enumType */
/** @internal */
export type WidgetWidthTypeWithLiterals =
  | WidgetWidthType
  | 'NONE_TYPE'
  | 'CUSTOM'
  | 'FULL';

/** @internal */
export interface WidgetDisplay {
  name?: string;
  /**
   * short description about the widget
   * @maxLength 300
   */
  shortDescription?: string | null;
  /** images showing off how the widget looks */
  images?: string[];
  /** optional, if no order exist for all components, will be decided by order in array (non-deterministic) */
  order?: number | null;
  price?: number | null;
  variationId?: string | null;
}

/** @internal */
export interface Position {
  region?: RegionWithLiterals;
}

/** @internal */
export enum Region {
  no_region = 'no_region',
  header = 'header',
  pageContainer = 'pageContainer',
  footer = 'footer',
}

/** @enumType */
/** @internal */
export type RegionWithLiterals =
  | Region
  | 'no_region'
  | 'header'
  | 'pageContainer'
  | 'footer';

/** @internal */
export interface SubPage {
  /** The path of the subpage */
  key?: string;
  /** If it's sub entities are enumerable for querying (for example, a search endpoint is not enumerable) */
  enumerable?: boolean;
  /** Should hide inner routes of this sub page from floating dynamic pages navigation bar */
  hideFromFloatingNavBar?: boolean;
  /** Should hide this sub page from selections in link panel */
  hideFromLinkPanel?: boolean;
}

/** @internal */
export interface IsStretched {
  desktop?: boolean | null;
  tablet?: boolean | null;
  mobile?: boolean | null;
}

/** @internal */
export interface Margins {
  desktop?: DisplayProperties;
  tablet?: DisplayProperties;
  mobile?: DisplayProperties;
}

/** @internal */
export interface DisplayProperties {
  top?: DisplayValue;
  right?: DisplayValue;
  bottom?: DisplayValue;
  left?: DisplayValue;
}

/** @internal */
export interface DisplayValue {
  type?: UnitTypeWithLiterals;
  value?: number | null;
}

/** @internal */
export enum UnitType {
  NO_UNIT = 'NO_UNIT',
  AUTO = 'AUTO',
  PX = 'PX',
  VH = 'VH',
  VW = 'VW',
  PERCENTAGE = 'PERCENTAGE',
}

/** @enumType */
/** @internal */
export type UnitTypeWithLiterals =
  | UnitType
  | 'NO_UNIT'
  | 'AUTO'
  | 'PX'
  | 'VH'
  | 'VW'
  | 'PERCENTAGE';

/** @internal */
export interface Docking {
  desktop?: DockingProperties;
  tablet?: DockingProperties;
  mobile?: DockingProperties;
}

/** @internal */
export interface DockingProperties {
  horizontal?: HorizontalDockingWithLiterals;
  vertical?: VerticalDockingWithLiterals;
}

/** @internal */
export enum HorizontalDocking {
  NO_HDOCKING = 'NO_HDOCKING',
  LEFT_DOCKING = 'LEFT_DOCKING',
  HCENTER = 'HCENTER',
  RIGHT_DOCKING = 'RIGHT_DOCKING',
}

/** @enumType */
/** @internal */
export type HorizontalDockingWithLiterals =
  | HorizontalDocking
  | 'NO_HDOCKING'
  | 'LEFT_DOCKING'
  | 'HCENTER'
  | 'RIGHT_DOCKING';

/** @internal */
export enum VerticalDocking {
  NO_VDOCKING = 'NO_VDOCKING',
  TOP_DOCKING = 'TOP_DOCKING',
  VCENTER = 'VCENTER',
  BOTTOM_DOCKING = 'BOTTOM_DOCKING',
}

/** @enumType */
/** @internal */
export type VerticalDockingWithLiterals =
  | VerticalDocking
  | 'NO_VDOCKING'
  | 'TOP_DOCKING'
  | 'VCENTER'
  | 'BOTTOM_DOCKING';

/** @internal */
export interface Height {
  desktop?: DisplayValue;
  tablet?: DisplayValue;
  mobile?: DisplayValue;
}

/** @internal */
export interface ApiWidth {
  desktop?: DisplayValue;
  tablet?: DisplayValue;
  mobile?: DisplayValue;
}

/** SSR caching configuration for site members */
/** @internal */
export enum SiteMembersSsrCaching {
  UNKNOWN_SITE_MEMBERS_SSR_CACHING = 'UNKNOWN_SITE_MEMBERS_SSR_CACHING',
  /** SSR caching is allowed when site members are logged in */
  CACHING_ALLOWED = 'CACHING_ALLOWED',
  /** SSR caching is not allowed when site members are logged in */
  CACHING_NOT_ALLOWED = 'CACHING_NOT_ALLOWED',
}

/** @enumType */
/** @internal */
export type SiteMembersSsrCachingWithLiterals =
  | SiteMembersSsrCaching
  | 'UNKNOWN_SITE_MEMBERS_SSR_CACHING'
  | 'CACHING_ALLOWED'
  | 'CACHING_NOT_ALLOWED';

/** MPA Navigation configuration */
/** @internal */
export enum MpaNavigation {
  DEFAULT = 'DEFAULT',
  /** MPA Navigation is enabled for this component */
  ALLOWED = 'ALLOWED',
  /** MPA Navigation is disabled for this component */
  NOT_ALLOWED = 'NOT_ALLOWED',
}

/** @enumType */
/** @internal */
export type MpaNavigationWithLiterals =
  | MpaNavigation
  | 'DEFAULT'
  | 'ALLOWED'
  | 'NOT_ALLOWED';

/** An iframe to be displayed as a full page on the user’s site */
export interface PageComponentData {
  /** Hide this page from the user’s site menu */
  isHidden?: boolean;
  /** Show in pages menu */
  showInPanel?: boolean | null;
  /** Set page to full width */
  isFullWidth?: boolean;
  /** Keep default and let users stretch page to full width (GFPP) */
  addStrechButton?: boolean;
  /**
   * A public link to the page endpoint
   * @format WEB_URL
   */
  pageEndpointUrl?: string | null;
  /** A public link to the mobile endpoint */
  pageMobileEndpointUrl?: string | null;
  /** A public link to the settings endpoint */
  settingsEndpointUrl?: string | null;
  /** A public link to the SEO endpoint */
  seoEndpointUrl?: string | null;
  /**
   * When true, this is the default component
   * Main visual component. One components must be default (no more than 1 component)
   */
  default?: boolean;
  /**
   * Second visual component
   * When this is turned on, this page will be added to the site when installing the app, regardless of whether it's the default component or not
   */
  essential?: boolean;
  /** Published state for this page */
  published?: boolean;
  /**
   * This ID is used to identify your page endpoint in a Wix site. You can use this ID when using methods of the Wix SDK
   * @readonly
   */
  tpaWidgetId?: string;
  /** Article id in settings panel */
  helpId?: string | null;
  /** Default Mobile Height */
  defaultMobileHeight?: number | null;
  /** Min Mobile Height */
  minMobileHeight?: number | null;
  /** Mobile Settings Enabled */
  mobileSettingsEnabled?: boolean;
  /** Mobile article id in settings panel */
  mobileHelpId?: string | null;
  /**
   * Editor setting version. optional values: 1 (old - deprecated) or 2 (new). default value is 2
   * @min 1
   * @max 2
   */
  settingsVersion?: number | null;
  /** If setting version is 1, this will be the public link to the settings endpoint */
  settingsEndpointUrlV1?: string | null;
  /** A public link to the settings endpoint on ADI editor */
  onBoardingSettingsEndpointUrl?: string | null;
  /** The padding to use in different views */
  padding?: Padding;
  /** The sub pages list for this component to be rendered in */
  subPages?: SubPage[];
  /** toggle to mark whether the editor should revoke an app that contains this component. */
  excludeFromAutoRevoke?: boolean;
  /** Options to mark whether this page is replacing other page or is replaced by other page. */
  pageReplaceOptions?: PageReplaceOptions;
  /** Elements in the editor can be linked to this page (a button for example) */
  linkable?: boolean | null;
  /** Should add the page to site menu. defaults to true (will add the page to site menu) */
  addToSiteMenu?: boolean | null;
  /** Should allow multiple instances of the page (allow duplicate the page). defaults to false (will not allow multiple instances of the page) */
  multiInstanceEnabled?: boolean;
  /**
   * The component-type as will be written in Document Management.
   * @internal
   * @maxLength 512
   */
  componentType?: string | null;
  /**
   * The type of the referenced schema e.g. `wysiwyg.viewer.components.tpapps.TPASection`.
   * @internal
   * @maxLength 512
   */
  refType?: string | null;
  /**
   * if true, ssr will not cache pages that contain this page widget
   * @internal
   */
  ssrCacheExcluded?: boolean;
  /**
   * if true, when site member is logged in this page - ssr will not cache it
   * @internal
   * @deprecated if true, when site member is logged in this page - ssr will not cache it
   * @replacedBy site_members_ssr_caching
   * @targetRemovalDate 2025-12-31
   */
  siteMembersSsrCacheExcluded?: boolean;
  /**
   * Controls SSR caching behavior when site members are logged in
   * @internal
   */
  siteMembersSsrCaching?: SiteMembersSsrCachingWithLiterals;
  /**
   * Controls MPA Navigation behavior for this page
   * @internal
   */
  mpaNavigation?: MpaNavigationWithLiterals;
  /**
   * short description about the page
   * @maxLength 300
   */
  shortDescription?: string | null;
  /** When true, this page is displayed as full page on desktop only */
  fullPageDesktopOnly?: boolean | null;
  /** When true, this page is used as a landing page on mobile */
  landingPageInMobile?: boolean | null;
}

/** @internal */
export interface Padding {
  desktop?: DisplayProperties;
  tablet?: DisplayProperties;
  mobile?: DisplayProperties;
}

/** @internal */
export interface PageReplaceOptions extends PageReplaceOptionsOptionsOneOf {
  replacingOptions?: ReplacingOptions;
  replaceableOptions?: ReplaceableOptions;
  type?: ReplacementTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface PageReplaceOptionsOptionsOneOf {
  replacingOptions?: ReplacingOptions;
  replaceableOptions?: ReplaceableOptions;
}

/** @internal */
export interface PageReplace {
  /**
   * The app id of the page the app can replace
   * @format GUID
   */
  appId?: string;
  /**
   * The page id the app can replace
   * @format GUID
   */
  pageId?: string;
}

/** @internal */
export enum ReplacementType {
  UNKNOWN_REPLACEMENT = 'UNKNOWN_REPLACEMENT',
  REPLACING = 'REPLACING',
  REPLACEABLE = 'REPLACEABLE',
}

/** @enumType */
/** @internal */
export type ReplacementTypeWithLiterals =
  | ReplacementType
  | 'UNKNOWN_REPLACEMENT'
  | 'REPLACING'
  | 'REPLACEABLE';

/** @internal */
export interface ReplacingOptions {
  /** describe the page and application id that this page will replace. */
  pageReplace?: PageReplace;
}

/** @internal */
export interface ReplaceableOptions {
  /** toggle to mark whether this page can be replaced by other page or app. */
  isReplaceable?: boolean;
}

/** A widget out of iframe component that loads directly in the Editor DOM */
/** @internal */
export interface WidgetOutOfIframeComponentData {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  componentUrl?: string;
  /**
   * Iframe controller URL.
   * @format WEB_URL
   */
  controllerUrl?: string | null;
  /** Information about the widget. */
  widgetData?: WidgetComponentData;
  /**
   * Out of iframe SSR URL.
   * @format WEB_URL
   */
  ssrComponentUrl?: string | null;
  /** Format: `<%=serviceUrl('your_artifact_id', 'component_url_bundle_file')%>`. */
  componentUrlTemplate?: string | null;
  /** Format: `<%=serviceUrl('your_artifact_id', 'controller_url_bundle_file')%>`. */
  controllerUrlTemplate?: string | null;
  /** Out of iframe widget data. */
  outOfIframeData?: OutOfIframeData;
  /** Format: `<%=serviceUrl('your_artifact_id', 'no_css_component_url_bundle_file')%>`. */
  noCssComponentUrlTemplate?: string | null;
  /**
   * Out of iframe no css component URL.
   * @format WEB_URL
   */
  noCssComponentUrl?: string | null;
  /** Whether to support different style param values for different breakpoints. */
  cssPerBreakpoint?: boolean | null;
  /**
   * builderConfig static url.
   * @format WEB_URL
   */
  builderConfigUrl?: string | null;
  /**
   * The component-type as will be written in Document Management.
   * @internal
   * @maxLength 512
   */
  componentType?: string | null;
  /**
   * The type of the referenced schema e.g. `wysiwyg.viewer.components.tpapps.TPAWidget`.
   * @internal
   * @maxLength 512
   */
  refType?: string | null;
  /**
   * Builder config URL template. `<%=serviceUrl('your_artifact_id', 'builder_url_bundle_file')%>`
   * @maxLength 512
   */
  builderConfigUrlTemplate?: string | null;
  /** Whether to render the component in the Editor as React (true) or as an iframe (false) */
  ooiInEditor?: boolean | null;
  /**
   * if true, render the OOI instead
   * @internal
   */
  migratingToOoi?: boolean | null;
}

/** Out Of Iframes additional info */
/** @internal */
export interface OutOfIframeData {
  /** The setting URLs for the app */
  settingsUrls?: SettingsUrl[];
  /** Automatically installed on app installation */
  autoInstall?: boolean;
  /** The info about how to report errors for the App */
  errorReporting?: ErrorReporting;
  /** The list of slots available */
  slots?: ApiSlot[];
  /** if true, ssr will not cache pages that contain this widget */
  ssrCacheExcluded?: boolean;
  /** Should use loadable-components */
  isLoadable?: boolean;
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /**
   * if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @deprecated if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @replacedBy site_members_ssr_caching
   * @targetRemovalDate 2025-12-31
   */
  siteMembersSsrCacheExcluded?: boolean;
  /**
   * Controls SSR caching behavior when site members are logged in
   * @deprecated Controls SSR caching behavior when site members are logged in
   * @targetRemovalDate 2026-03-01
   */
  siteMembersSsrCaching?: SiteMembersSsrCachingWithLiterals;
}

/** An editor settings configuration */
/** @internal */
export interface SettingsUrl {
  /**
   * The URL for the setting panel
   * @format WEB_URL
   */
  url?: string;
  /** What type of editor this is */
  editorType?: string;
  /** How this view is rendered (mobile, tablet, etc) */
  viewType?: string;
  /** should be <%=serviceUrl('your_artifact_id', '<resource-path>')%>, this field will later be used to trasform the settings url field in both the component and the **derived widget** */
  urlTemplate?: string | null;
}

/** Error reporting configuration for the App */
/** @internal */
export interface ErrorReporting {
  /** An error reporting URL to be used by our infra (Example: A sentry DSN url) */
  url?: string;
  /** Optional: Data about the artifact that reports the error. */
  artifact?: ErrorReportingArtifact;
}

/** Data of the artifact that reports an error. */
/** @internal */
export interface ErrorReportingArtifact {
  /**
   * The full artifact id of the project which errors are associated with (Example: com.wixpress.my-artifact)
   * @minLength 1
   * @maxLength 255
   */
  fullArtifactId?: string;
  /**
   * The project version which errors are associated with (Example: Falcon fingerprint)
   * @minLength 1
   * @maxLength 255
   */
  version?: string;
}

/** Definition of slot */
/** @internal */
export interface ApiSlot {
  /** Role of the slot component (uniquely identifies slot within parent comp; used by Velo) - former "slotName" */
  slotRole?: string;
  /** The list of interfaces that should be implemented by a plugin in order to fit the slot */
  pluginInterfaces?: PluginInterfaceWithLiterals[];
  /** Id of the slot component (a.k.a. Velo role) */
  slotId?: string;
}

/** The types of public APIs exposed by the Plugin */
/** @internal */
export enum PluginInterface {
  /** No public APIs exposed */
  NONE_INTERFACE = 'NONE_INTERFACE',
  /** The slot requires the REVIEWS interface to be implemented by the plugin. The plugin specifies the implementation of the REVIEWS interface */
  REVIEWS = 'REVIEWS',
  /** The slot requires the RATINGS_SUMMARY interface to be implemented by the plugin. The plugin specifies the implementation of the RATINGS_SUMMARY interface */
  RATINGS_SUMMARY = 'RATINGS_SUMMARY',
  /** The slot requires the RATINGS_SUMMARY_OOI_LIST interface to be implemented by the plugin. The plugin specifies the implementation of the RATINGS_SUMMARY_OOI_LIST interface */
  RATINGS_SUMMARY_OOI_LIST = 'RATINGS_SUMMARY_OOI_LIST',
  /** The slot requires the BOOKINGS_SERVICE interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_SERVICE interface */
  BOOKINGS_SERVICE = 'BOOKINGS_SERVICE',
  /** The slot requires the BOOKINGS_FORM interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_FORM interface */
  BOOKINGS_FORM = 'BOOKINGS_FORM',
  /** The slot requires the BASE interface to be implemented by the plugin. The plugin specifies the implementation of the BASE interface */
  BASE = 'BASE',
  /** The slot requires the EVENT interface to be implemented by the plugin. The plugin specifies the implementation of the EVENT interface */
  EVENT = 'EVENT',
  /** The slot requires the PRODUCT interface to be implemented by the plugin. The plugin specifies the implementation of the PRODUCT interface */
  PRODUCT = 'PRODUCT',
  /** The slot requires the CHECKOUT interface to be implemented by the plugin. The plugin specifies the implementation of the CHECKOUT interface */
  CHECKOUT = 'CHECKOUT',
  /** The slot requires the CATEGORY interface to be implemented by the plugin. The plugin specifies the implementation of the CATEGORY interface */
  CATEGORY = 'CATEGORY',
  /** The slot requires the BOOKINGS_CALENDAR interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_CALENDAR interface */
  BOOKINGS_CALENDAR = 'BOOKINGS_CALENDAR',
  /** The slot requires the CART interface to be implemented by the plugin. The plugin specifies the implementation of the CART interface */
  CART = 'CART',
}

/** @enumType */
/** @internal */
export type PluginInterfaceWithLiterals =
  | PluginInterface
  | 'NONE_INTERFACE'
  | 'REVIEWS'
  | 'RATINGS_SUMMARY'
  | 'RATINGS_SUMMARY_OOI_LIST'
  | 'BOOKINGS_SERVICE'
  | 'BOOKINGS_FORM'
  | 'BASE'
  | 'EVENT'
  | 'PRODUCT'
  | 'CHECKOUT'
  | 'CATEGORY'
  | 'BOOKINGS_CALENDAR'
  | 'CART';

/** @internal */
export interface ExtensionExposure {
  /**
   * The exposure of the component
   * @internal
   */
  exposure?: ExtensionExposureExposureWithLiterals;
  /** Determines if the component is production ready */
  maturity?: MaturityWithLiterals;
}

/** @internal */
export enum ExtensionExposureExposure {
  /** Unexposed. to be used by dev team only */
  PRIVATE = 'PRIVATE',
  /** Exposed internally */
  INTERNAL = 'INTERNAL',
  /** Exposed to the world */
  PUBLIC = 'PUBLIC',
}

/** @enumType */
/** @internal */
export type ExtensionExposureExposureWithLiterals =
  | ExtensionExposureExposure
  | 'PRIVATE'
  | 'INTERNAL'
  | 'PUBLIC';

/** @internal */
export enum Maturity {
  /** Immature. subject to breaking changes */
  ALPHA = 'ALPHA',
  /** Ready for integration. 2 weeks notice before breaking changes are applied */
  BETA = 'BETA',
  /** Matured. breaking changes are not acceptable. 3 month notice before sunset */
  GA = 'GA',
  /** Not yet implemented */
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
}

/** @enumType */
/** @internal */
export type MaturityWithLiterals =
  | Maturity
  | 'ALPHA'
  | 'BETA'
  | 'GA'
  | 'NOT_IMPLEMENTED';

/** A page out of iframe component that loads directly in the Editor DOM */
/** @internal */
export interface PageOutOfIframeComponentData {
  /**
   * Out of iframe component URL.
   * @format WEB_URL
   */
  componentUrl?: string;
  /**
   * Out of iframe controller URL.
   * @format WEB_URL
   */
  controllerUrl?: string | null;
  /** Page data. */
  pageData?: PageComponentData;
  /**
   * Out of iframe SSR URL.
   * @format WEB_URL
   */
  ssrComponentUrl?: string | null;
  /** Component URL template. `<%=serviceUrl('your_artifact_id', 'component_url_bundle_file')%>` */
  componentUrlTemplate?: string | null;
  /** Controller URL template. `<%=serviceUrl('your_artifact_id', 'controller_url_bundle_file')%>` */
  controllerUrlTemplate?: string | null;
  /** Data about the out of iframe page. */
  outOfIframeData?: OutOfIframeData;
  /** Setting endpoint URL template. `<%=serviceUrl('your_artifact_id', '<resource-path>')%>`. Used to transform the settings URL field in both the component and the **derived widget**. */
  settingsEndpointUrlTemplate?: string | null;
  /** Setting endpoint URL v1 template. `<%=serviceUrl('your_artifact_id', '<resource-path>')%>`.  Used to transform the settings URL field in both the component and the **derived widget**. */
  settingsEndpointUrlV1Template?: string | null;
  /** No css component URL template. `<%=serviceUrl('your_artifact_id', 'no_css_component_url_bundle_file')%>`. */
  noCssComponentUrlTemplate?: string | null;
  /**
   * URL for the out of iframe no CSS component URL.
   * @format WEB_URL
   */
  noCssComponentUrl?: string | null;
  /** Whether to enable support for different style param values for different breakpoints. */
  cssPerBreakpoint?: boolean | null;
  /**
   * builderConfig static url.
   * @format WEB_URL
   */
  builderConfigUrl?: string | null;
  /**
   * The component-type as will be written in Document Management.
   * @internal
   * @maxLength 512
   */
  componentType?: string | null;
  /**
   * The type of the referenced schema e.g. `wysiwyg.viewer.components.tpapps.TPASection`.
   * @internal
   * @maxLength 512
   */
  refType?: string | null;
  /**
   * Builder config URL template. `<%=serviceUrl('your_artifact_id', 'builder_url_bundle_file')%>`
   * @maxLength 512
   */
  builderConfigUrlTemplate?: string | null;
  /** Whether to render the component in the Editor as React (true) or as an iframe (false) */
  ooiInEditor?: boolean | null;
  /**
   * if true, render the OOI instead
   * @internal
   */
  migratingToOoi?: boolean | null;
}

/** Create a collection of native Editor components that loads directly in the Editor DOM */
/** @internal */
export interface PlatfromComponentData {
  /**
   * Path to a Javascript file that Editor runs on app install
   * @format WEB_URL
   */
  editorScriptUrl?: string | null;
  /** Path to a Javascript file that viewer runs for page components / widgets and applicative business logic */
  viewerScriptUrl?: string | null;
  /** If true, components of the app wont be added to the editor (only run editor scripts) */
  platformOnly?: boolean;
  /** If the viewer script should run in the Editor */
  enableInEditor?: boolean;
  /** URL to get complex routing decisions at runtime from a platform app. Some spec can be seen here: https://docs.google.com/document/d/1t_3bl9vVMoPVm_I9Sx59LsVUPXi07gihGIg3-F7z8Q0/edit?ts=595512f6#heading=h.9ca9859ng5d */
  routerServiceUrl?: string | null;
  /**
   * Path to a Javascript file that viewer runs for page components / widgets and applicative business logic. Includes verbose logs for Wix runtime.
   * @format WEB_URL
   */
  viewerVerboseScriptUrl?: string | null;
  /** A map of string descriptor the app understands to a versioned URL topology value, can be an API or statics data. Example: `storesCartAPI: https://stores.com/api/v2/cart/ */
  baseUrls?: Record<string, string>;
  /** Used by DAC (gradual roll-out). A map of string descriptor the app understands to a template versioned URL topology value, Example: `storeCSSStuff: https://static.pararstorage.com/services/stores-css-stuff/<%=serviceVersion('your_artifact_id')%>/main.css */
  baseUrlsTemplate?: Record<string, string>;
  /** should be <%=serviceUrl('your_artifact_id', 'viewer_script_url_bundle_file')%> */
  viewerScriptUrlTemplate?: string | null;
  /** If this component should be stretched in relation to a form factor (desktop, tablet, mobile) */
  isStretched?: IsStretched;
  /** Any margins this page should have in relation to a form factor (desktop, tablet, mobile) */
  margins?: Margins;
  /** Any docking this page (horizontal / vertical) should have in relation to a form factor (desktop, tablet, mobile) */
  docking?: Docking;
  /** The height of this page in relation to a form factor (desktop, tablet, mobile) */
  height?: Height;
  /** The width of this page in relation to a form factor (desktop, tablet, mobile) */
  width?: ApiWidth;
  /**
   * Support adding application pages with preset data
   * Vertical endpoint that clones the data
   * https://docs.google.com/document/d/1pUp-d9vVMCTjDdQffBuwh1mBvQacQZy0n6nm2amCMV4/edit
   * @format WEB_URL
   */
  cloneAppDataUrl?: string | null;
  /**
   * False by default
   * If false, data is cloned per app
   * If true, the data is cloned per add component on component addition
   */
  shouldCloneDataPerComponent?: boolean;
  /**
   * Error reporting URL used to report errors at platform level,
   * and as fallback for pageOOI and widgetOOI error reporting
   */
  errorReporting?: ErrorReporting;
  /**
   * A concrete versioned URL of the translation template, contains `{language}` parameter in the path
   * @format WEB_URL
   */
  editorTranslationUrl?: string | null;
  /** A version templated URL of the translation template, contains a <%=serviceVersion('your_artifact_id')%> template and a `{language}` template */
  editorTranslationUrlTemplate?: string | null;
  excludeFromAutoRevoke?: boolean;
  /**
   * Should be <%=serviceUrl('your_artifact_id', 'editor_script_url_bundle_file')%>, this will later be resolved to the right version in the context of the request, meaning, URL/Cookie overrides, Rollout version, Employee Preview version and override the version of editor_script_url.
   * @internal
   */
  editorScriptUrlTemplate?: string | null;
  /** dictates if the app has migrated to the new platform API */
  migratedToNewPlatformApi?: boolean;
  /** The HTTP Verb used to call the router, if not set will be POST */
  routerHttpMethod?: HTTPMethodWithLiterals;
}

/** Add interim support for HTTP methods before a bigger rewrite for Routers as a component */
/** @internal */
export enum HTTPMethod {
  UNKNOWN_METHOD = 'UNKNOWN_METHOD',
  GET = 'GET',
  POST = 'POST',
}

/** @enumType */
/** @internal */
export type HTTPMethodWithLiterals =
  | HTTPMethod
  | 'UNKNOWN_METHOD'
  | 'GET'
  | 'POST';

/**
 * An iframe that opens in the user’s Wix Dashboard,
 * or add a link to open the page directly in your platform.
 */
export interface DashboardComponentData {
  /**
   * The dashboard url.
   * @format WEB_URL
   */
  url?: string;
  /**
   * External or Internal dashboard.
   * The user’s Wix Dashboard (recommended) or your platform or site
   */
  embedded?: boolean;
  /**
   * A settings page for users to customize your dashboard
   * @maxLength 300
   */
  settingsPageUrl?: string | null;
  /** @maxLength 300 */
  checkStatusUrl?: string | null;
  published?: boolean | null;
  hideWixSideMenu?: boolean | null;
}

/** An invisible iframe to track site activity. It’ll be added to every page on the user’s site */
export interface WorkerComponentData {
  /**
   * A public link to the worker endpoint
   * @format WEB_URL
   */
  workerEndpointUrl?: string;
}

/**
 * An extension to platform used by Wix Blocks UI
 * The main component in the Wix Blocks.
 * no manual adding. auto-created only from Wix Blocks
 */
/** @internal */
export interface StudioComponentData {
  /** Path to a Javascript file that Editor runs on app install */
  editorScriptUrl?: string;
  /** Path to a Javascript file that viewer runs for page components / widgets and applicative business logic */
  viewerScriptUrl?: string;
  /** If true, components of the app wont be added to the editor (only run editor scripts) */
  platformOnly?: boolean;
  /** If the viewer script should run in the Editor */
  enableInEditor?: boolean;
  /** URL to get complex routing decisions at runtime from a platform app. Some spec can be seen here: https://docs.google.com/document/d/1t_3bl9vVMoPVm_I9Sx59LsVUPXi07gihGIg3-F7z8Q0/edit?ts=595512f6#heading=h.9ca9859ng5d */
  routerServiceUrl?: string;
  /** Path to a Javascript file that viewer runs for page components / widgets and applicative business logic. Includes verbose logs for Wix runtime. */
  viewerVerboseScriptUrl?: string;
  /**
   * Instance id of wixCode in the original dev site. used in order to access the widgets code
   * @format GUID
   */
  wixCodeInstanceId?: string;
  /**
   * Id of the grid in wixCode FS where the widgets code is located. used in order to access the widgets code
   * @format GUID
   */
  wixCodeGridId?: string;
  /** Path to a json which contains metaData of the devSite */
  siteHeaderUrl?: string;
  /** A map of string descriptor the app understands to a versioned URL topology value, can be an API or statics data. This may have some values which are NOT URL since Studio computes some values on the fly. */
  baseUrls?: Record<string, string>;
  /** If true, not shown in add panel and apps panel when it is installed */
  hideInAddPanel?: boolean;
  /** if true, this studio component enforce permissions */
  permissionsEnforced?: boolean;
}

/** A widget component in the Wix Blocks. */
/** @internal */
export interface StudioWidgetComponentData {
  /** Id of the widget */
  studioWidgetId?: string;
  /** Path to a json which contains the widget data and structure */
  pageJsonFilename?: string;
  /** variationId -> widget variation data */
  variations?: Record<string, StudioWidgetVariation>;
  /** Product display data for this component */
  widgetDisplay?: WidgetDisplay;
  /** If it is required to be installed as part of the app */
  essential?: boolean;
  /** The version of blocks used to build this widget */
  blocksVersion?: string;
  /** If this component should be stretched in relation to a form factor (desktop, tablet, mobile) */
  isStretched?: IsStretched;
  /** Any margins this page should have in relation to a form factor (desktop, tablet, mobile) */
  margins?: Margins;
  /** Any docking this page (horizontal / vertical) should have in relation to a form factor (desktop, tablet, mobile) */
  docking?: Docking;
  /** The height of this page in relation to a form factor (desktop, tablet, mobile) */
  height?: Height;
  /** The width of this page in relation to a form factor (desktop, tablet, mobile) */
  width?: ApiWidth;
  /**
   * Optional, static artifact short name, used for BoB application to indicate the relation between the widget and its static artifact
   * @internal
   */
  relatedArtifact?: string | null;
  /** Properties of installed custom elements */
  customElement?: CustomElement;
  /** ids of nested widgets in this widget */
  nestedWidgets?: NestedWidgets;
  /** Properties of widget's presets */
  presetsInfo?: PresetInfo[];
  /** Widget properties that affect the way it behaves during installation in a site. */
  installationSettings?: InstallationSettings;
  /** Properties that affect the widget's presence in the editor. */
  editorPresence?: EditorPresence;
  /** Base info of component by shared logic of unified components */
  base?: BaseInfo;
  /** Unified widget installation settings */
  installation?: WidgetInstallationSettings;
  /**
   * if true, ssr will not cache pages that contain this widget
   * @internal
   */
  ssrCacheExcluded?: boolean;
  /**
   * The builder component model by shared logic of unified components. Required in oder to create a builder component
   * @internal
   */
  componentModel?: ComponentModel;
  /**
   * Optional: The URL of the widget's code bundle
   * @format WEB_URL
   */
  widgetBundleUrl?: string | null;
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /**
   * if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @internal
   * @deprecated if true, when site member is logged in and this widget is in the page - ssr will not cache it
   * @replacedBy site_members_ssr_caching
   * @targetRemovalDate 2025-12-31
   */
  siteMembersSsrCacheExcluded?: boolean;
  /**
   * Controls SSR caching behavior when site members are logged in
   * @internal
   */
  siteMembersSsrCaching?: SiteMembersSsrCachingWithLiterals;
  /**
   * Controls MPA Navigation behavior for this studio widget
   * @internal
   */
  mpaNavigation?: MpaNavigationWithLiterals;
}

/** A variation of a blocks widget */
/** @internal */
export interface StudioWidgetVariation {
  /** Id of the widget variation */
  id?: string;
  /** Display name of the variation */
  name?: string;
  /** Path to a json which contains the widget variation data and structure */
  pageJsonFilename?: string;
}

/** @internal */
export interface CustomElement extends CustomElementConsentCategoryOneOf {
  essential?: boolean;
  /** Related to performance and other functional measurements. */
  functional?: boolean;
  /** Related to analytics about how the site is used in order to improve it. */
  analytics?: boolean;
  /** Related to allowing better customization of the experience to a current visitor. */
  advertising?: boolean;
  /** Boolean to make custom element in this widget be available for free sites */
  allowedForFreeSite?: boolean;
  /** CCPA compliance flag. */
  dataToThirdParty?: boolean;
}

/** @oneof */
/** @internal */
export interface CustomElementConsentCategoryOneOf {
  essential?: boolean;
  /** Related to performance and other functional measurements. */
  functional?: boolean;
  /** Related to analytics about how the site is used in order to improve it. */
  analytics?: boolean;
  /** Related to allowing better customization of the experience to a current visitor. */
  advertising?: boolean;
}

/** Nested widgets */
/** @internal */
export interface NestedWidgets {
  /**
   * ids of all recursively nested widgets from the same Blocks app
   * @format GUID
   */
  internal?: string[];
}

/** Preset Info */
/** @internal */
export interface PresetInfo {
  /** Id of the widget's preset */
  presetId?: string;
  /** Display name of the widget's preset */
  presetName?: string;
  /** The default size used when the preset is added to the stage */
  defaultSize?: PresetSize;
}

/** Preset Size */
/** @internal */
export interface PresetSize {
  /** The width of the preset when it's added to the stage */
  width?: DisplayValue;
  /** The height of the preset when it's added to the stage */
  height?: DisplayValue;
}

/** Settings to control the behavour of widgets when installed in a wix site. */
/** @internal */
export interface InstallationSettings extends InstallationSettingsOptionsOneOf {
  /** Extra options needed when `install_page` is set to `PAGE`. */
  pageOptions?: PageOptions;
  /** Extra options needed when `install_page` is set to `LIGHTBOX`. */
  lightboxOptions?: LightboxOptions;
  /** How to add the widget automatically to the site. Options could be `NO_PAGE`, `CURRENT`, `PAGE` or `LIGHTBOX`. */
  installPage?: InstallPageWithLiterals;
  /** Controls whether to show or hide the widget in the add panel. */
  showInAddPanel?: boolean | null;
  /** Defines the main preset per breakpoint for the widget. */
  mainPresets?: MainPresets;
}

/** @oneof */
/** @internal */
export interface InstallationSettingsOptionsOneOf {
  /** Extra options needed when `install_page` is set to `PAGE`. */
  pageOptions?: PageOptions;
  /** Extra options needed when `install_page` is set to `LIGHTBOX`. */
  lightboxOptions?: LightboxOptions;
}

/** The page to which a new widget can be added */
/** @internal */
export enum InstallPage {
  /** Don't add widget to a page */
  NO_PAGE = 'NO_PAGE',
  /** Add widget to the current page in the editor */
  CURRENT = 'CURRENT',
  /** Add widget to a new page in the editor */
  PAGE = 'PAGE',
  /** Add widget to a new lightbox in the editor */
  LIGHTBOX = 'LIGHTBOX',
}

/** @enumType */
/** @internal */
export type InstallPageWithLiterals =
  | InstallPage
  | 'NO_PAGE'
  | 'CURRENT'
  | 'PAGE'
  | 'LIGHTBOX';

/** Defines the main preset per breakpoint for the widget. */
/** @internal */
export interface MainPresets {
  /** The main desktop preset. */
  desktopPresetId?: string;
  /** The main tablet preset. */
  tabletPresetId?: string;
  /** The main mobile preset. */
  mobilePresetId?: string;
}

/** Options for widgets that are added as a page during installation */
/** @internal */
export interface PageOptions {
  /** Display name of the page that will be shown in the page menu. */
  pageName?: string;
  /** The page ID used for navigation purposes. Once set cannot be changed. */
  pageId?: string;
}

/** @internal */
export interface LightboxOptions {
  /** Display name of the lightbox that will be shown in the lightbox menu. */
  lightboxName?: string;
  /** The lightbox ID used for navigation purposes. Once set cannot be changed. */
  lightboxId?: string;
}

/** @internal */
export interface EditorPresence {
  /** Properties that describe the presence of each of the widget's presets */
  presetsEditorPresence?: PresetEditorPresence[];
}

/** @internal */
export interface PresetEditorPresence {
  /** Id of the widget's preset */
  presetId?: string;
  /** Controls whether to show or hide the preset in the Add Panel */
  showInAddPanel?: boolean;
  /** Controls whether to show or hide the preset in the Presets Panel */
  showInPresetsPanel?: boolean;
  /** Optional image to show as the preset's thumbnail in the editor, if left empty an automatic snapshot of the preset will be used */
  wixMediaThumbnail?: WixCommonImage;
  /** Another preset id that is a mobile variation of this preset */
  mobilePresetId?: string;
}

/** @internal */
export interface WixCommonImage {
  /** WixMedia image ID. */
  id?: string;
  /** Image URL. */
  url?: string;
  /**
   * Original image height.
   * @readonly
   */
  height?: number;
  /**
   * Original image width.
   * @readonly
   */
  width?: number;
  /** Image alt text. */
  altText?: string | null;
  /**
   * Image URL expiration date (when relevant).
   * @internal
   * @readonly
   */
  urlExpirationDate?: Date | null;
  /**
   * Image filename.
   * @readonly
   */
  filename?: string | null;
  /**
   * Image size in bytes.
   * @internal
   * @readonly
   * @format DECIMAL_VALUE
   */
  sizeInBytes?: string | null;
  /**
   * Focal point of the image.
   * @internal
   */
  focalPoint?: FocalPoint;
}

/** @internal */
export interface FocalPoint {
  /** X-coordinate of the focal point. */
  x?: number;
  /** Y-coordinate of the focal point. */
  y?: number;
  /** crop by height */
  height?: number | null;
  /** crop by width */
  width?: number | null;
}

/** @internal */
export interface BaseInfo {
  /**
   * The name of the component
   * @minLength 1
   * @maxLength 30
   */
  name?: string;
  /** The internal id of the component by the own app */
  id?: string;
  /**
   * The description of the component by the own app
   * @maxLength 130
   */
  description?: string;
  /** Reference to help articles about the widget */
  helpResources?: HelpResources;
}

/** @internal */
export interface HelpResources {
  /**
   * The Wix Answers' article related to the component (chosen by own app)
   * @format GUID
   */
  articleId?: string;
}

/** @internal */
export interface WidgetInstallationSettings
  extends WidgetInstallationSettingsTargetContainerOneOf {
  /** Which static container should the widget be installed at */
  staticContainer?: StaticContainerWithLiterals;
  /**
   * Deprecated, autoAdd should be mapped to static_container HOMEPAGE, essential should be mapped to container. Shared installation settings for unified components
   * @deprecated Deprecated, autoAdd should be mapped to static_container HOMEPAGE, essential should be mapped to container. Shared installation settings for unified components
   * @replacedBy static_container
   * @targetRemovalDate 2026-02-26
   */
  base?: BaseInstallation;
  /**
   * Deprecated, default_preset should be mapped to presets, region is not relevant. Widget installation settings for unified components
   * @deprecated Deprecated, default_preset should be mapped to presets, region is not relevant. Widget installation settings for unified components
   * @replacedBy presets
   * @targetRemovalDate 2026-02-26
   */
  widget?: WidgetInstallation;
  /** Default presets per breakpoint with which the widget should be installed */
  presets?: DefaultPresets;
}

/** @oneof */
/** @internal */
export interface WidgetInstallationSettingsTargetContainerOneOf {
  /** Which static container should the widget be installed at */
  staticContainer?: StaticContainerWithLiterals;
}

/** @internal */
export interface BaseInstallation {
  /** Auto add component to stage */
  autoAdd?: boolean;
  /** Mark component as essential for the existence of the app (force to delete the whole app) */
  essential?: boolean;
  /** Max instances of the component that can be on site */
  maxInstances?: number | null;
}

/** @internal */
export interface WidgetInstallation {
  /** Preset should be selected defaultly with installation */
  defaultPreset?: MainPresets;
  /** Region of widget */
  region?: RegionTypeWithLiterals;
}

/** @internal */
export enum RegionType {
  HEADER = 'HEADER',
  BODY = 'BODY',
  FOOTER = 'FOOTER',
}

/** @enumType */
/** @internal */
export type RegionTypeWithLiterals = RegionType | 'HEADER' | 'BODY' | 'FOOTER';

/** @internal */
export interface DefaultPresets {
  /**
   * Default preset ID in small (mobile) breakpoint
   * @minLength 1
   * @maxLength 50
   */
  small?: string | null;
  /**
   * Deprecated, use default - Default preset ID in large (desktop) breakpoint
   * @minLength 1
   * @maxLength 50
   * @deprecated Deprecated, use default - Default preset ID in large (desktop) breakpoint
   * @replacedBy default
   * @targetRemovalDate 2025-12-02
   */
  large?: string | null;
  /**
   * Default preset ID
   * @minLength 1
   * @maxLength 50
   */
  default?: string | null;
}

/** @internal */
export enum StaticContainer {
  UNKNOWN_CONTAINER = 'UNKNOWN_CONTAINER',
  /** Widget should be installed in the homepage */
  HOMEPAGE = 'HOMEPAGE',
  /** Show widget on all pages */
  GLOBAL_PAGE = 'GLOBAL_PAGE',
}

/** @enumType */
/** @internal */
export type StaticContainerWithLiterals =
  | StaticContainer
  | 'UNKNOWN_CONTAINER'
  | 'HOMEPAGE'
  | 'GLOBAL_PAGE';

/** @internal */
export interface ComponentModel {
  /** The component type of the builder component. */
  componentType?: string;
  /**
   * The component URL of the builder component
   * @format WEB_URL
   */
  componentUrl?: string;
}

/** A component that indicates the existence of an importable code package in a Wix Blocks application. */
/** @internal */
export interface CodePackageComponentData {
  /**
   * The GUID to access the package code in the Velo/Wix Code system
   * @format GUID
   */
  gridId?: string;
  /** Name of the package for display */
  displayName?: string;
  /** Name of the package for import */
  importName?: string;
  /** An optional description of this package and what it does */
  description?: string | null;
}

/** A collection of native components that load directly in the Business Manager */
/** @internal */
export interface DashboardPlatfromComponentData {
  /**
   * Path to a Javascript file that Dashboard runs on app install
   * @format WEB_URL
   */
  scriptUrl?: string;
}

/** Inject third party scripts into the user’s site */
export interface EmbeddedScriptComponentData {
  /** The script */
  template?: string;
  /** A name that’s unique to this component. Names can include letters and the hyphen (-) character only */
  name?: string;
  /** What category of pages this will be embedded on (single, many, none) */
  pages?: EmbeddedScriptPagesWithLiterals;
  /** Where in the HTML this should be embedded */
  placement?: EmbeddedScriptPlacementWithLiterals;
  /** An article explaining how to activate the script */
  connectArticleUrl?: string;
  /** Type of script you are injecting. This will be used for GDPR and cookie consent purposes */
  embedCategory?: EmbedCategoryWithLiterals;
  /**
   * if the script should be loaded once - default and only supported value is true
   * @readonly
   */
  loadOnce?: boolean;
  /** allow developers to decide if their app script can be install on free sites */
  allowedForFreeSite?: boolean;
  /**
   * The runtime dependencies array to declare the widget packages.
   * @maxSize 50
   */
  dependencies?: WixDependency[];
}

/** Category of pages this will be embedded on (single, many, none) */
/** @internal */
export enum EmbeddedScriptPages {
  /** It will not be embedded */
  NONE_PAGES = 'NONE_PAGES',
  /** It will be embedded once */
  ONCE = 'ONCE',
  /** It will be embedded multiple times on specific pages */
  SPECIFIC_PAGES = 'SPECIFIC_PAGES',
}

/** @enumType */
/** @internal */
export type EmbeddedScriptPagesWithLiterals =
  | EmbeddedScriptPages
  | 'NONE_PAGES'
  | 'ONCE'
  | 'SPECIFIC_PAGES';

/** Where that embed will be rendered */
/** @internal */
export enum EmbeddedScriptPlacement {
  /** It will not be rendered */
  NONE_PLACEMENT = 'NONE_PLACEMENT',
  /** In the document head */
  HEAD = 'HEAD',
  /** Prepended before all children already rendered in the body tag */
  BODY_START = 'BODY_START',
  /** Appended after the last child already rendered in the body tag */
  BODY_END = 'BODY_END',
}

/** @enumType */
/** @internal */
export type EmbeddedScriptPlacementWithLiterals =
  | EmbeddedScriptPlacement
  | 'NONE_PLACEMENT'
  | 'HEAD'
  | 'BODY_START'
  | 'BODY_END';

/** Embed category defined for Privacy regulation compliance in EU and CCPA in the US */
/** @internal */
export enum EmbedCategory {
  /** Not categorized yet */
  UNKNOWN = 'UNKNOWN',
  /** Must load regardless of policy */
  ESSENTIAL = 'ESSENTIAL',
  /** Adds optional functionality to the site */
  FUNCTIONAL = 'FUNCTIONAL',
  /** Adds analytics abilities to the site */
  ANALYTICS = 'ANALYTICS',
  /** Adds advertising content or advertising tracking to the site */
  ADVERTISING = 'ADVERTISING',
}

/** @enumType */
/** @internal */
export type EmbedCategoryWithLiterals =
  | EmbedCategory
  | 'UNKNOWN'
  | 'ESSENTIAL'
  | 'FUNCTIONAL'
  | 'ANALYTICS'
  | 'ADVERTISING';

/** @internal */
export interface WixDependency {
  /**
   * The fully qualified package name from npm, example: @wix/frontend-location
   * @minLength 2
   * @maxLength 100
   */
  packageName?: string;
  /** The major version of the package (this may be a detail included in the package name, but is conventional in NPM with semver semantics */
  version?: number;
}

/** A draggable custom element. Add your custom script and generate ui directly in the viewer */
/** @internal */
export interface WebComponentData {
  /** A link to a preview image we can render in the editor in place of your component */
  imagePreview?: string;
  /** Web component size */
  size?: Size;
  /**
   * This script url should render temp empty state
   * @format WEB_URL
   */
  scriptTag?: string;
  /** Unique tag name to use in order to connect your JS script to your web component */
  tagName?: string;
  /**
   * The settings panel URL for this component
   * @format WEB_URL
   */
  settingsUrl?: string | null;
  /** The editor modal that the user will see */
  modalTitle?: string;
  /** Settings CTA label */
  connectLabel?: string;
  /** Dynamic settings(Graphic Floating Properties Panel settings) */
  gfppSettings?: Settings;
  /** Custom element type PAGE / WIDGET */
  type?: WebComponentDataElementTypeWithLiterals;
  /** Boolean to make this component be available for free sites */
  allowedForFreeSite?: boolean;
  /**
   * A public link to the SEO endpoint
   * @format WEB_URL
   */
  seoUrl?: string | null;
  /** For case that the widget will be used as page */
  slug?: string | null;
  /** For case that the widget will be used as page */
  showPageInMenu?: boolean;
  /** The details of the selected widget to add */
  widget?: WidgetDetails;
  /** Give the option to change the script type */
  scriptType?: ScriptTypeWithLiterals;
  /** Web component default mobile height */
  defaultMobileHeight?: number | null;
  /** Prevent the deletion of the widget when set to true. */
  essential?: boolean;
  /** Toggle to mark whether the editor should revoke an app that contains this component. */
  excludeFromAutoRevoke?: boolean;
  /** defines the widget's behaviour in editor page */
  widgetBehavior?: WidgetBehavior;
  /** When true, avoid adding widgets when this component is installed/used. */
  avoidAddingWidgets?: boolean;
}

/** Web component size */
/** @internal */
export interface Size {
  /**
   * Height in pixels
   * @max 9999
   */
  height?: number;
  /**
   * Width in pixels
   * @max 9999
   */
  width?: number;
}

/** Graphic Floating Properties Panel settings */
/** @internal */
export interface Settings {
  activeTab?: string;
  /** @format WEB_URL */
  fetchInitialData?: string | null;
  tabs?: Tab[];
}

/** Setting tab definition */
/** @internal */
export interface Tab {
  label?: string;
  items?: Container[];
  /** hidden tab will not be visible in editor and dev center preview */
  hidden?: boolean;
}

/** UI Container in page */
/** @internal */
export interface Container extends ContainerDataOneOf {
  /** containers */
  main?: Main;
  section?: Section;
  drillInListItem?: DrillInListItem;
  /** items */
  thumbnails?: Thumbnails;
  sliderLabeled?: SliderLabeled;
  dropDownLabeled?: DropDownLabeled;
  toggleLabeled?: ToggleLabeled;
  barAlignment?: BarAlignment;
  textInputLabeled?: TextInputLabeled;
  resetButton?: ResetButton;
  fontFamilyWithColorPicker?: FontFamilyWithColorPicker;
  radioButtonLabeled?: RadioButtonLabeled;
  colorSelectLabeled?: ColorSelectLabeled;
  textStyle?: TextStyle;
}

/** @oneof */
/** @internal */
export interface ContainerDataOneOf {
  /** containers */
  main?: Main;
  section?: Section;
  drillInListItem?: DrillInListItem;
  /** items */
  thumbnails?: Thumbnails;
  sliderLabeled?: SliderLabeled;
  dropDownLabeled?: DropDownLabeled;
  toggleLabeled?: ToggleLabeled;
  barAlignment?: BarAlignment;
  textInputLabeled?: TextInputLabeled;
  resetButton?: ResetButton;
  fontFamilyWithColorPicker?: FontFamilyWithColorPicker;
  radioButtonLabeled?: RadioButtonLabeled;
  colorSelectLabeled?: ColorSelectLabeled;
  textStyle?: TextStyle;
}

/** Main 1 */
/** @internal */
export interface Main {
  items?: MainPropsData[];
}

/** MainPropsData */
/** @internal */
export interface MainPropsData {
  dashboardButton?: DashboardButton;
  richTextWithIllustrationVertical?: RichTextWithIllustrationVertical;
}

/** DashboardButton main 2 */
/** @internal */
export interface DashboardButton {
  title?: string;
  label?: string;
}

/** RichTextWithIllustrationVertical main 1 */
/** @internal */
export interface RichTextWithIllustrationVertical {
  key?: string;
  label?: string;
  text?: string;
}

/** Section 2 */
/** @internal */
export interface Section {
  label?: string;
}

/** DrillInListItem 3 */
/** @internal */
export interface DrillInListItem {
  items?: DrillItem[];
  label?: string;
}

/** DrillItem */
/** @internal */
export interface DrillItem extends DrillItemDataOneOf {
  /** containers */
  section?: Section;
  /** items */
  radioButtonLabeled?: RadioButtonLabeled;
  colorSelectLabeled?: ColorSelectLabeled;
  thumbnails?: Thumbnails;
  sliderLabeled?: SliderLabeled;
  dropDownLabeled?: DropDownLabeled;
  toggleLabeled?: ToggleLabeled;
  barAlignment?: BarAlignment;
  textInputLabeled?: TextInputLabeled;
  fontFamilyWithColorPicker?: FontFamilyWithColorPicker;
  textStyle?: TextStyle;
}

/** @oneof */
/** @internal */
export interface DrillItemDataOneOf {
  /** containers */
  section?: Section;
  /** items */
  radioButtonLabeled?: RadioButtonLabeled;
  colorSelectLabeled?: ColorSelectLabeled;
  thumbnails?: Thumbnails;
  sliderLabeled?: SliderLabeled;
  dropDownLabeled?: DropDownLabeled;
  toggleLabeled?: ToggleLabeled;
  barAlignment?: BarAlignment;
  textInputLabeled?: TextInputLabeled;
  fontFamilyWithColorPicker?: FontFamilyWithColorPicker;
  textStyle?: TextStyle;
}

/** RadioButtonLabeled 12 */
/** @internal */
export interface RadioButtonLabeled {
  key?: string;
  title?: string;
  value?: string;
  options?: string[];
  description?: string;
  conditions?: Condition[];
}

/** @internal */
export interface Condition {
  value?: string;
  state?: SingleKeyCondition[];
}

/** @internal */
export interface SingleKeyCondition {
  key?: string;
  value?: string;
  visible?: boolean;
}

/** ColorSelectLabeled 13 */
/** @internal */
export interface ColorSelectLabeled extends ColorSelectLabeledDataOneOf {
  customColor?: ColorDefinition;
  templateColor?: TemplateDefaultColorWithLiterals;
  title?: string;
  key?: string;
  /** @deprecated */
  color?: string;
  defaultData?: ColorDefinition;
  description?: string;
}

/** @oneof */
/** @internal */
export interface ColorSelectLabeledDataOneOf {
  customColor?: ColorDefinition;
  templateColor?: TemplateDefaultColorWithLiterals;
}

/** @internal */
export interface ColorDefinition {
  value?: string;
  opacity?: string;
}

/** @internal */
export enum TemplateDefaultColor {
  BACKGROUND = 'BACKGROUND',
  SECONDARY_TEXTS = 'SECONDARY_TEXTS',
  MAIN_TEXT_AND_ICONS = 'MAIN_TEXT_AND_ICONS',
  BORDERS_AND_DIVIDERS = 'BORDERS_AND_DIVIDERS',
  BUTTONS_AND_LINKS = 'BUTTONS_AND_LINKS',
}

/** @enumType */
/** @internal */
export type TemplateDefaultColorWithLiterals =
  | TemplateDefaultColor
  | 'BACKGROUND'
  | 'SECONDARY_TEXTS'
  | 'MAIN_TEXT_AND_ICONS'
  | 'BORDERS_AND_DIVIDERS'
  | 'BUTTONS_AND_LINKS';

/** Thumbnails 4 */
/** @internal */
export interface Thumbnails {
  key?: string;
  title?: string;
  value?: string;
  options?: ThumbnailData[];
  size?: ThumbnailsSizeWithLiterals;
  description?: string;
  conditions?: Condition[];
}

/** Structure for thumbnail */
/** @internal */
export interface ThumbnailData {
  value?: string;
  /** @format WEB_URL */
  src?: string | null;
  /** @format WEB_URL */
  selectedSrc?: string | null;
  /** @format WEB_URL */
  onHoverSrc?: string | null;
  label?: string;
}

/** @internal */
export enum ThumbnailsSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  XLARGE = 'XLARGE',
}

/** @enumType */
/** @internal */
export type ThumbnailsSizeWithLiterals =
  | ThumbnailsSize
  | 'SMALL'
  | 'MEDIUM'
  | 'LARGE'
  | 'XLARGE';

/** SliderLabeled 5 */
/** @internal */
export interface SliderLabeled {
  key?: string;
  title?: string;
  size?: string;
  placeholder?: string;
  description?: string;
  minSize?: number;
  maxSize?: number;
}

/** DropDownLabeled 6 */
/** @internal */
export interface DropDownLabeled {
  key?: string;
  title?: string;
  value?: string;
  options?: string[];
  description?: string;
  conditions?: Condition[];
}

/** ToggleLabeled 7 */
/** @internal */
export interface ToggleLabeled {
  key?: string;
  title?: string;
  value?: boolean;
  description?: string;
  conditions?: Condition[];
}

/**
 * Elements =========
 * BarAlignment 8
 */
/** @internal */
export interface BarAlignment {
  /** @deprecated */
  selected?: BarAlignmentSelectedWithLiterals;
  key?: string;
  title?: string;
  description?: string;
  value?: BarAlignmentSelectedWithLiterals;
  conditions?: Condition[];
}

/** Bar alignment selected value */
/** @internal */
export enum BarAlignmentSelected {
  ALIGN_LEFT = 'ALIGN_LEFT',
  ALIGN_CENTER = 'ALIGN_CENTER',
  ALIGN_RIGHT = 'ALIGN_RIGHT',
}

/** @enumType */
/** @internal */
export type BarAlignmentSelectedWithLiterals =
  | BarAlignmentSelected
  | 'ALIGN_LEFT'
  | 'ALIGN_CENTER'
  | 'ALIGN_RIGHT';

/** TextInputLabeled 9 */
/** @internal */
export interface TextInputLabeled {
  key?: string;
  title?: string;
  placeholder?: string;
  value?: string;
  description?: string;
}

/** 11 */
/** @internal */
export interface FontFamilyWithColorPicker {
  key?: string;
  title?: string;
  description?: string;
  value?: FontDefinition;
  defaultValue?: FontDefinition;
}

/** defintion and enums */
/** @internal */
export interface FontDefinition {
  font?: string;
  color?: ColorDefinition;
}

/** TextStyle 14 */
/** @internal */
export interface TextStyle extends TextStyleDefaultColorOneOf {
  customColor?: ColorDefinition;
  templateColor?: TemplateDefaultColorWithLiterals;
  key?: string;
  title?: string;
  description?: string;
  defaultTextStyle?: DefaultTextStyleWithLiterals;
}

/** @oneof */
/** @internal */
export interface TextStyleDefaultColorOneOf {
  customColor?: ColorDefinition;
  templateColor?: TemplateDefaultColorWithLiterals;
}

/** @internal */
export enum DefaultTextStyle {
  TITLE = 'TITLE',
  PARAGRAPH = 'PARAGRAPH',
  LOWER_HIERARCHY_TEXTS = 'LOWER_HIERARCHY_TEXTS',
}

/** @enumType */
/** @internal */
export type DefaultTextStyleWithLiterals =
  | DefaultTextStyle
  | 'TITLE'
  | 'PARAGRAPH'
  | 'LOWER_HIERARCHY_TEXTS';

/** 10 */
/** @internal */
export interface ResetButton {
  label?: string;
}

/** @internal */
export enum WebComponentDataElementType {
  WIDGET = 'WIDGET',
  PAGE = 'PAGE',
}

/** @enumType */
/** @internal */
export type WebComponentDataElementTypeWithLiterals =
  | WebComponentDataElementType
  | 'WIDGET'
  | 'PAGE';

/** @internal */
export interface WidgetDetails {
  name?: string | null;
  icon?: string | null;
  description?: string | null;
}

/** @internal */
export enum ScriptType {
  NO_SCRIPT_TYPE = 'NO_SCRIPT_TYPE',
  MODULE = 'MODULE',
}

/** @enumType */
/** @internal */
export type ScriptTypeWithLiterals = ScriptType | 'NO_SCRIPT_TYPE' | 'MODULE';

/** @internal */
export interface WidgetBehavior {
  /** Toggle whether the widget is removable from the page. */
  removable?: boolean;
  /** Toggle whether the widget is duplicatable from the page. */
  duplicatable?: boolean;
}

/** @internal */
export interface ExtensionData {
  data?: string;
  extensionType?: ExtensionTypeWithLiterals;
}

/** @internal */
export enum ExtensionType {
  NONE_EXTENSION = 'NONE_EXTENSION',
  PAYMENTS_GATEWAY_EXTENSION = 'PAYMENTS_GATEWAY_EXTENSION',
  COUPONS_EXTENSION = 'COUPONS_EXTENSION',
  DROPSHIPPING_EXTENSION = 'DROPSHIPPING_EXTENSION',
  FULFILMENT_EXTENSION = 'FULFILMENT_EXTENSION',
  DROPSHIPPING_SUPPLIER_EXTENSION = 'DROPSHIPPING_SUPPLIER_EXTENSION',
  FULFILLMENT_CENTER_EXTENSION = 'FULFILLMENT_CENTER_EXTENSION',
  RESTAURANTS_POS_EXTENSION = 'RESTAURANTS_POS_EXTENSION',
  ART_STORE_EXTENSION = 'ART_STORE_EXTENSION',
  ASCEND_AUTOMATION_EXTENSION = 'ASCEND_AUTOMATION_EXTENSION',
  CONTACT_LABELS_EXTENSION = 'CONTACT_LABELS_EXTENSION',
}

/** @enumType */
/** @internal */
export type ExtensionTypeWithLiterals =
  | ExtensionType
  | 'NONE_EXTENSION'
  | 'PAYMENTS_GATEWAY_EXTENSION'
  | 'COUPONS_EXTENSION'
  | 'DROPSHIPPING_EXTENSION'
  | 'FULFILMENT_EXTENSION'
  | 'DROPSHIPPING_SUPPLIER_EXTENSION'
  | 'FULFILLMENT_CENTER_EXTENSION'
  | 'RESTAURANTS_POS_EXTENSION'
  | 'ART_STORE_EXTENSION'
  | 'ASCEND_AUTOMATION_EXTENSION'
  | 'CONTACT_LABELS_EXTENSION';

/** @internal */
export interface SnippetSolutionData {
  code?: string;
  instructions?: string;
}

/** An extension for adding data collections to a site when the app is installed. */
export interface DataComponent {
  /**
   * Token used by Wix to add collections to a site during app installation. For internal use only.
   * @internal
   * @format GUID
   */
  collectionsToken?: string | null;
  /**
   * Data collections automatically added to a site when the app is installed.
   * @maxSize 100
   */
  collections?: Collection[];
}

/** @internal */
export interface Field extends FieldTypeOptionsOneOf {
  /** Metadata for a reference field. */
  referenceOptions?: ReferenceOptions;
  /** Metadata for a multi-reference field. */
  multiReferenceOptions?: MultiReferenceOptions;
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
  /**
   * Required. Unique identifier for the field. For example, `firstName`.
   * @minLength 1
   * @maxLength 1000
   */
  key?: string;
  /**
   * Field's display name when displayed in the CMS. For example, `First Name`.
   * @minLength 1
   * @maxLength 1000
   */
  displayName?: string | null;
  /**
   * Required. Field's data type.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  type?: FieldTypeWithLiterals;
  /** Whether the field is encrypted. */
  encrypted?: boolean;
  /**
   * Field description.
   * @maxLength 16000
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface FieldTypeOptionsOneOf {
  /** Metadata for a reference field. */
  referenceOptions?: ReferenceOptions;
  /** Metadata for a multi-reference field. */
  multiReferenceOptions?: MultiReferenceOptions;
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
}

/** @internal */
export enum FieldType {
  UNKNOWN_FIELD_TYPE = 'UNKNOWN_FIELD_TYPE',
  /** Plain-text string. */
  TEXT = 'TEXT',
  /** Number. */
  NUMBER = 'NUMBER',
  /** Date string in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format: `YYYY-MM-DD`. */
  DATE = 'DATE',
  /** [JavaScript Date object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) (SDK) or an object in the following format: `"someFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. */
  DATETIME = 'DATETIME',
  /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
  IMAGE = 'IMAGE',
  /** Boolean `true` or `false` value. */
  BOOLEAN = 'BOOLEAN',
  /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
  DOCUMENT = 'DOCUMENT',
  /** URL in one of the following formats: `http://`, `https://`, `ftp://`, `mailto:`, `sms:`, `tel:`. */
  URL = 'URL',
  /** [Rich-text](https://dev.wix.com/docs/rest/articles/getting-started/rich-text) string that may contain a subset of HTML tags. */
  RICH_TEXT = 'RICH_TEXT',
  /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
  VIDEO = 'VIDEO',
  /** Any field type. */
  ANY = 'ANY',
  /** Array of strings. */
  ARRAY_STRING = 'ARRAY_STRING',
  /** Array of documents: web or [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URLs. */
  ARRAY_DOCUMENT = 'ARRAY_DOCUMENT',
  /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
  AUDIO = 'AUDIO',
  /** Time string in `hh:mm:ss.SSS` format. */
  TIME = 'TIME',
  /** Language codes in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format. These may include country codes in [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format. */
  LANGUAGE = 'LANGUAGE',
  /** [Rich content](https://dev.wix.com/docs/ricos/getting-started/introduction). */
  RICH_CONTENT = 'RICH_CONTENT',
  /** Array of web or [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URLs. */
  MEDIA_GALLERY = 'MEDIA_GALLERY',
  /** Physical [address object](https://dev.wix.com/docs/api-reference/business-solutions/cms/data-types-in-wix-data#address-object). */
  ADDRESS = 'ADDRESS',
  /**
   * Reference to another item in another collection. See [Query Referenced Data Items](https://dev.wix.com/docs/api-reference/business-solutions/cms/data-items/query-referenced-data-items) to learn about item references.
   *
   * If you select this type, then you must pass the `referencedCollectionId` field as well.
   */
  REFERENCE = 'REFERENCE',
  /** References to multiple items in another collection. See [Query Referenced Data Items](https://dev.wix.com/docs/api-reference/business-solutions/cms/data-items/query-referenced-data-items) to learn about item references. */
  MULTI_REFERENCE = 'MULTI_REFERENCE',
  /** JSON object. */
  OBJECT = 'OBJECT',
  /** Array. */
  ARRAY = 'ARRAY',
}

/** @enumType */
/** @internal */
export type FieldTypeWithLiterals =
  | FieldType
  | 'UNKNOWN_FIELD_TYPE'
  | 'TEXT'
  | 'NUMBER'
  | 'DATE'
  | 'DATETIME'
  | 'IMAGE'
  | 'BOOLEAN'
  | 'DOCUMENT'
  | 'URL'
  | 'RICH_TEXT'
  | 'VIDEO'
  | 'ANY'
  | 'ARRAY_STRING'
  | 'ARRAY_DOCUMENT'
  | 'AUDIO'
  | 'TIME'
  | 'LANGUAGE'
  | 'RICH_CONTENT'
  | 'MEDIA_GALLERY'
  | 'ADDRESS'
  | 'REFERENCE'
  | 'MULTI_REFERENCE'
  | 'OBJECT'
  | 'ARRAY';

/** @internal */
export interface ObjectOptions {
  /**
   * Fields within the object.
   * @maxSize 1000
   */
  fields?: ObjectField[];
}

/** @internal */
export interface ArrayOptions extends ArrayOptionsElementTypeOptionsOneOf {
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
  /** Element's data type. */
  elementType?: FieldTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ArrayOptionsElementTypeOptionsOneOf {
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
}

/** @internal */
export interface ObjectField extends ObjectFieldTypeOptionsOneOf {
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
  /**
   * Field ID.
   * @minLength 1
   * @maxLength 1000
   */
  key?: string;
  /**
   * Display name for the field.
   * @minLength 1
   * @maxLength 1000
   */
  displayName?: string | null;
  /**
   * Field type.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  type?: FieldTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ObjectFieldTypeOptionsOneOf {
  /** Metadata for an object field. */
  objectOptions?: ObjectOptions;
  /** Metadata for an array field. */
  arrayOptions?: ArrayOptions;
}

/** @internal */
export interface ReferenceOptions {
  /**
   * Referenced collection ID.
   * @minLength 1
   * @maxLength 256
   */
  referencedCollectionId?: string;
}

/** @internal */
export interface MultiReferenceOptions {
  /**
   * Referenced collection ID.
   * @minLength 1
   * @maxLength 256
   */
  referencedCollectionId?: string;
}

/** Data permissions defined by access level for each action. */
/** @internal */
export interface DataPermissions {
  /** Required. Access level required to read data items. */
  itemRead?: AccessLevelWithLiterals;
  /** Required. Access level required to insert data items. */
  itemInsert?: AccessLevelWithLiterals;
  /** Required. Access level required to update data items. */
  itemUpdate?: AccessLevelWithLiterals;
  /** Required. Access level required to remove data items. */
  itemRemove?: AccessLevelWithLiterals;
}

/**
 * Describes who can perform certain action.
 * Each level includes all levels below it (except UNDEFINED).
 */
/** @internal */
export enum AccessLevel {
  /** Not set. */
  UNDEFINED = 'UNDEFINED',
  /** Anyone, including site visitors. */
  ANYONE = 'ANYONE',
  /** Any signed-in user, including site members and collaborators. */
  SITE_MEMBER = 'SITE_MEMBER',
  /** Any signed-in user, but site members only have access to their own items. */
  SITE_MEMBER_AUTHOR = 'SITE_MEMBER_AUTHOR',
  /** Site collaborator that has a role with CMS access permission. */
  CMS_EDITOR = 'CMS_EDITOR',
  /** CMS administrators and users or roles granted special access. */
  PRIVILEGED = 'PRIVILEGED',
}

/** @enumType */
/** @internal */
export type AccessLevelWithLiterals =
  | AccessLevel
  | 'UNDEFINED'
  | 'ANYONE'
  | 'SITE_MEMBER'
  | 'SITE_MEMBER_AUTHOR'
  | 'CMS_EDITOR'
  | 'PRIVILEGED';

/** @internal */
export interface Index {
  /**
   * Fields for which the index is defined.
   *
   * Max: 3 fields (for a unique index: 1 field)
   * @minSize 1
   * @maxSize 3
   */
  fields?: IndexField[];
  /**
   * Whether the index enforces uniqueness of values in the field for which it is defined.
   * If `true`, the index can have only one field.
   *
   * Default: `false`
   */
  unique?: boolean;
}

/**
 * Order determines how values are ordered in the index. This is important when
 * ordering and/or range querying by indexed fields.
 */
/** @internal */
export enum Order {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** @enumType */
/** @internal */
export type OrderWithLiterals = Order | 'ASC' | 'DESC';

/** @internal */
export interface IndexField {
  /**
   * Path of the field to index. For example: `title` or `options.price`.
   * @minLength 1
   * @maxLength 128
   */
  path?: string;
  /**
   * Sort order for the index. Base on how the data is regularly queried.
   *
   * Default: `ASC`
   */
  order?: OrderWithLiterals;
}

/** @internal */
export interface Collection {
  /**
   * Required. Collection ID suffix. The app namespace is automatically prepended in the CMS.
   * For example, the full ID for `my-products-1` becomes `@company/app-name/my-products-1`.
   * @maxLength 256
   */
  idSuffix?: string;
  /**
   * Collection's display name as shown in the CMS. For example, `My First Collection`.
   * @minLength 1
   * @maxLength 1000
   */
  displayName?: string | null;
  /**
   * Field whose value the CMS displays to represent the collection item when referenced in a different collection.
   * @minLength 1
   * @maxLength 1000
   */
  displayField?: string | null;
  /**
   * Required. Collection's field structure.
   * @minSize 1
   * @maxSize 1000
   */
  fields?: Field[];
  /** Required. Levels of permission for accessing and modifying data, defined by the lowest role needed to perform each action. */
  dataPermissions?: DataPermissions;
  /**
   * Indexes defined for the collection. An index is a map of a collection's data, organized according to specific fields to increase query speed.
   * @maxSize 3
   */
  indexes?: Index[];
  /**
   * Optional initial data to populate the collection with.
   * @maxSize 1000
   */
  initialData?: Record<string, any>[] | null;
}

/** @internal */
export interface DCConfigData {
  isVisualApp?: boolean;
}

/** @internal */
export interface StaticFileComponentData {
  /** @format WEB_URL */
  url?: string;
}

/** @internal */
export interface AppConfig {
  siteConfig?: SiteConfig;
  namespace?: string;
}

/** @internal */
export interface SiteConfig {
  /**
   * todo: WEB_URL
   * @maxLength 1000
   */
  siteStructureApi?: string | null;
}

/**
 * Business Manager sidebar category that contains sidebar links.
 * each link in the category opens in the business manager in an iframe.
 */
/** @internal */
export interface MultipleDashboardsComponentData {
  /** items inside the category */
  items?: DashboardItem[];
}

/**
 * a single dashboard page,
 * represented in Business Manager as sidebar link that opens in an iframe
 */
/** @internal */
export interface DashboardItem {
  /** name of the sidebar link of the page */
  label?: string;
  /** data about the current page */
  dashboardData?: DashboardComponentData;
  /** permission to check for this page. */
  permissionId?: string | null;
}

/** Test component extension */
/** @internal */
export interface PaymentsGatewayComponentData {
  /**
   * The shop url
   * @format WEB_URL
   */
  shopUrl?: string;
}

/** @internal */
export interface AutomationTrigger {
  /**
   * The name that will be passed with trigger report event to activate an Automation.
   * @maxLength 80
   */
  name?: string;
  /**
   * The name displayed to the user.
   * @maxLength 80
   */
  displayName?: string;
  /** The schema of the payload that will be passed with trigger when activating an Automation. */
  schemaConfig?: SchemaConfig;
  /**
   * Email template to be shown when user choose this trigger and email action.
   * @internal
   */
  emailTemplateName?: string | null;
  deploymentUri?: string;
  revision?: number;
}

/** @internal */
export interface SchemaConfig {
  /** The fields of the payload as sent in the report event */
  fields?: SchemaField[];
  /**
   * Dynamic schema service URL.
   * Dynamic schema is used when user needs to choose specific entities from site to activate the Automation.
   * For example form name, purchased product, etc.
   * @format WEB_URL
   */
  dynamicSchemaUrl?: string | null;
}

/** @internal */
export interface SchemaField {
  /** The key as it appears on the report event payload. */
  key?: string;
  /** The name displayed to the user. */
  displayName?: string;
  /** The field type */
  fieldType?: SchemaFieldType;
  /** Sample values, values that could show up in the payload of a trigger. */
  sampleValues?: string[];
  /** The field exposure */
  exposure?: SchemaFieldExposureWithLiterals;
}

/** @internal */
export enum PrimitiveType {
  UNKNOWN_PRIMITIVE_TYPE = 'UNKNOWN_PRIMITIVE_TYPE',
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
}

/** @enumType */
/** @internal */
export type PrimitiveTypeWithLiterals =
  | PrimitiveType
  | 'UNKNOWN_PRIMITIVE_TYPE'
  | 'TEXT'
  | 'BOOLEAN'
  | 'NUMBER';

/** @internal */
export enum SimpleType {
  UNKNOWN_SIMPLE_TYPE = 'UNKNOWN_SIMPLE_TYPE',
  MONEY = 'MONEY',
  LINK = 'LINK',
  BACKOFFICE_LINK = 'BACKOFFICE_LINK',
  LIVESITE_LINK = 'LIVESITE_LINK',
  MULTILINGUAL = 'MULTILINGUAL',
  IMAGE_LINK = 'IMAGE_LINK',
  GUID = 'GUID',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  CONTACT_ID = 'CONTACT_ID',
}

/** @enumType */
/** @internal */
export type SimpleTypeWithLiterals =
  | SimpleType
  | 'UNKNOWN_SIMPLE_TYPE'
  | 'MONEY'
  | 'LINK'
  | 'BACKOFFICE_LINK'
  | 'LIVESITE_LINK'
  | 'MULTILINGUAL'
  | 'IMAGE_LINK'
  | 'GUID'
  | 'EMAIL'
  | 'PHONE'
  | 'CONTACT_ID';

/** @internal */
export interface Primitive {
  primitiveType?: PrimitiveTypeWithLiterals;
}

/** @internal */
export interface Simple {
  simpleType?: SimpleTypeWithLiterals;
}

/** @internal */
export interface _Date {
  /** Default: false, set this to true if the date is normally a future date, like: Invoice expiration date, Membership renewal date */
  allowNegativeOffset?: boolean | null;
}

/** @internal */
export interface SchemaFieldType extends SchemaFieldTypeFieldTypeOneOf {
  primitive?: Primitive;
  simple?: Simple;
  /**
   * The field value must conform to the following JSON structure { "timestamp": string, "timeZone": string }, where the timestamp is ISO format UTC, and the time zone is the full name
   * Example: { "timestamp": "2021-03-22T11:41:47.992Z", timeZone: "Asia/Jerusalem" }
   */
  date?: _Date;
}

/** @oneof */
/** @internal */
export interface SchemaFieldTypeFieldTypeOneOf {
  primitive?: Primitive;
  simple?: Simple;
  /**
   * The field value must conform to the following JSON structure { "timestamp": string, "timeZone": string }, where the timestamp is ISO format UTC, and the time zone is the full name
   * Example: { "timestamp": "2021-03-22T11:41:47.992Z", timeZone: "Asia/Jerusalem" }
   */
  date?: _Date;
}

/** @internal */
export enum SchemaFieldExposure {
  UNKNOWN_EXPOSURE = 'UNKNOWN_EXPOSURE',
  /** Not sent to the action provider */
  SETUP = 'SETUP',
  /** Sent to the action provider and usually hidden from user */
  HIDDEN = 'HIDDEN',
  /** Sent to the action provider and usually shown to user */
  EXPOSED = 'EXPOSED',
}

/** @enumType */
/** @internal */
export type SchemaFieldExposureWithLiterals =
  | SchemaFieldExposure
  | 'UNKNOWN_EXPOSURE'
  | 'SETUP'
  | 'HIDDEN'
  | 'EXPOSED';

/** represents Invoices integration policies */
/** @internal */
export interface InvoicesActionsComponentData {
  /** partial payment restriction on invoice */
  partialPayment?: PartialPaymentRestrictionWithLiterals;
}

/** Possible Partial Payment Policy Values */
/** @internal */
export enum PartialPaymentRestriction {
  UNDEFINED = 'UNDEFINED',
  /** Allow Partial Payment */
  ALLOW = 'ALLOW',
  /** Disallow Partial Payment */
  DISALLOW = 'DISALLOW',
}

/** @enumType */
/** @internal */
export type PartialPaymentRestrictionWithLiterals =
  | PartialPaymentRestriction
  | 'UNDEFINED'
  | 'ALLOW'
  | 'DISALLOW';

/** Experimental-WIP: Specifies the app module configuration of business manager module */
/** @internal */
export interface DashboardApplicationData {
  /**
   * List of bundles to be loaded for your module
   * @minSize 1
   */
  bundles?: Bundle[];
  /**
   * Your module id as defined in business-manager-api
   * @minLength 2
   * @maxLength 64
   */
  id?: string | null;
  /** List of available page components that your module is registering */
  pageComponents?: PageDashboardApplicationComponent[];
  /** The default component to load when another app navigates to your module */
  defaultPageComponentId?: string | null;
  /** Config section that will be provided to your lazy component and component along with all other properties from business-manager, if your config object will contain topology parameter, you'll be able to benefit from statics override machanism */
  config?: AppConfiguration;
  /** Allows an application to declare that when it's opened inside the business-manager without a deeplink the business-manager home should be shown. It currently only affects opening the app from Editor/ADI */
  useHomeAsLandingPage?: boolean | null;
  /** If there are some experiments that define if this page should be enabled, list of experiment lists with OR relationship between them, experiments should be in business manager scope */
  enabledByExperiments?: ExperimentGroupWrapper[];
  /** If this module should load in absence of any pages, by default this won't run */
  loadWithoutPages?: boolean | null;
  /** List of hosted component of the application */
  components?: HostedComponent[];
}

/** Specifes business manager module file bundle */
/** @internal */
export interface Bundle {
  /**
   * The JavaScript file to load
   * @format WEB_URL
   */
  file?: string;
  /** If there are some experiments that define if this page should be enabled, list of experiment lists with OR relationship between them, experiments should be in business manager scope */
  enabledByExperiments?: ExperimentGroupWrapper[];
  /**
   * A alternative debug file for debugging issues
   * @format WEB_URL
   */
  debugFile?: string | null;
}

/** Specifies a list of experiments that have AND relationship between them, and OR relationship between each list */
/** @internal */
export interface ExperimentGroupWrapper {
  /**
   * list of experiments with AND relationship between them, for false value use ! before experiment spec
   * @minSize 1
   */
  experimentsGroup?: string[];
}

/** Specifies page components for a business manager module */
/** @internal */
export interface PageDashboardApplicationComponent {
  /**
   * The id of the page
   * @minLength 1
   */
  id?: string;
  /**
   * The route of the page, the part of the url after /dashboard/{msid}/ (must be unique in the specific application)
   * @minLength 1
   */
  route?: string;
  /**
   * The name you used to register this component to the ModuleRegistry (must be unique across apps)
   * @minLength 1
   */
  name?: string;
  /** If there are some experiments that define if this page should be enabled, list of experiment lists with OR relationship between them, experiments should be in business manager scope. */
  enabledByExperiments?: ExperimentGroupWrapper[];
  /** Additional routes to the page */
  routeAliases?: string[];
}

/** Specifies config for topology and config data */
/** @internal */
export interface AppConfiguration {
  /** A map of topology key to template url */
  topology?: Record<string, string>;
  /** Config section that will be provided to your lazy component and component along with all other properties from business-manager, if your config object will contain topology parameter */
  configData?: Record<string, string>;
}

/** Specifes business hosted component configuration */
/** @internal */
export interface HostedComponent {
  /**
   * A unique id for the component, maps between the host and name
   * @minLength 1
   */
  id?: string;
  /**
   * The component name used in registerComponentWithModuleParams components can be shared by using the same name but a unique id
   * @minLength 1
   */
  name?: string;
  /** Permissions required for the component, this is not strictly enforced */
  requiredPermission?: string;
  /** Represents the collection of components where the component will be hosted, get this value from the host provider. */
  hostContainerId?: HostContainerIdWithLiterals;
  /** If there are some experiments that define if this page should be enabled, list of experiment lists with OR relationship between them, experiments should be in business manager scope */
  enabledByExperiments?: ExperimentGroupWrapper[];
  /** A URI used to send component error events */
  errorReporting?: ErrorReporting;
}

/** @internal */
export enum HostContainerId {
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  BUSINESS_DASHBOARD_HOST = 'BUSINESS_DASHBOARD_HOST',
  SIDEBAR_FOOTER = 'SIDEBAR_FOOTER',
}

/** @enumType */
/** @internal */
export type HostContainerIdWithLiterals =
  | HostContainerId
  | 'BUSINESS_MANAGER'
  | 'BUSINESS_DASHBOARD_HOST'
  | 'SIDEBAR_FOOTER';

/** Contact Labels Extensions */
/** @internal */
export interface ContactLabelsComponentData {
  /** Whether apps can create labels in this namespace. */
  allowAppDefinedLabels?: boolean | null;
  /**
   * Required permissions to manage app-defined labels.
   * Only apps with these permission will be able to create labels in this namespace.
   * Relevant if `allow_app_defined_labels` is `true`.
   */
  permission?: string | null;
  /** Predefined labels that exist on all sites that install the app. */
  predefinedLabels?: PredefinedLabel[];
}

/** @internal */
export interface PredefinedLabel {
  /**
   * Unique key. Can contain letters, dashes, or underscores.
   * For example, `"secondary-hobby"`.
   * @minLength 1
   * @maxLength 50
   */
  key?: string;
  /**
   * Display name.
   * For example, `"Secondary Hobby"`.
   * @minLength 1
   * @maxLength 180
   */
  displayName?: string;
}

/** A component to be rendered within Widget Slots */
export interface WidgetPluginComponentData {
  /**
   * ID of the widget used for the plugin component.
   * @format GUID
   */
  referenceComponentId?: string;
  /** APIs implemented by the Plugin's widget. */
  pluginInterfaces?: PluginInterfaceWithLiterals[];
  /** Marketing information about the plugin. */
  marketData?: PluginMarketData;
  /** List of placements where the plugin is allowed to be installed. */
  placements?: PluginPlacement[];
  /** Widget plugin installation settings. */
  installation?: PluginInstallationSettings;
  /**
   * List of placements where the plugin is allowed to be installed.
   * @internal
   * @format GUID
   * @maxSize 100
   */
  placementsSlotIds?: string[];
}

/** Marketing information about the plugin. */
/** @internal */
export interface PluginMarketData {
  /**
   * Plugin name.
   * @minLength 1
   * @maxLength 50
   */
  name?: string;
  /**
   * Plugin description.
   * @maxLength 130
   */
  description?: string;
  /**
   * Plugin logo. 35x35px in JPG or PNG format.
   * @format WEB_URL
   */
  logoUrl?: string | null;
}

/** Combination of IDs that uniquely identify a slot in the app component. */
/** @internal */
export interface PluginPlacement {
  /**
   * Slot app definition ID.
   * @format GUID
   */
  appDefinitionId?: string;
  /**
   * Slot app component ID.
   * @format GUID
   */
  widgetId?: string;
  /**
   * Slot ID.
   * @minLength 1
   */
  slotId?: string;
}

/** @internal */
export interface PluginInstallationSettings {
  /** Shared installation settings for unified components */
  base?: BaseInstallation;
}

/** @internal */
export interface CrossSellConfig {
  /** uri for call implementor, could be one of `grpc://<artifact-name>`, `velo://`, `https://` */
  baseUri?: string;
}

/** Local Delivery component */
/** @internal */
export interface LocalDeliveryComponentData {
  /**
   * URL for the Delivery provider registration web page.
   * The App Instance and Account Id query parameters are attached to the registration URL
   * so that you can identify your account when accessing the vendor api. [learn more](https://devforum.wix.com/en/article/app-instance)
   * @format WEB_URL
   */
  registrationUrl?: string;
  /**
   * The base URL for all the local delivery api calls.
   * Description of end points and schema can be find in the local delivery documentation.
   */
  apiBaseUri?: string;
}

/** Configuration for the payment service SPI implementor */
/** @internal */
export interface PaymentServiceProviderConfig {
  /**
   * Payment service provider to display on Accept payments tab in Business manager
   * @minLength 1
   */
  title?: string;
  /** SPI base url */
  baseUrl?: string;
  /** Available payment methods */
  paymentMethods?: PaymentMethod[];
  /** Provider authentication methods */
  credentialsFields?: PaymentServiceProviderCredentialsField[];
}

/** @internal */
export interface PaymentMethod extends PaymentMethodMethodOneOf {
  /** Information about hosted page payment method */
  hostedPage?: HostedPage;
}

/** @oneof */
/** @internal */
export interface PaymentMethodMethodOneOf {
  /** Information about hosted page payment method */
  hostedPage?: HostedPage;
}

/** @internal */
export interface HostedPage {
  /**
   * The payment method title to be will be displayed on accept payments tab in business manager as well as on the checkout
   * @minLength 1
   */
  title?: string;
  /** Url to images in different formats and colors */
  logos?: Logos;
  /** Billing address fields that buyer needs to fill in order to process payment with the specified payment method */
  billingAddressMandatoryFields?: MandatoryFieldWithLiterals[];
}

/** @internal */
export interface Logos {
  /** white theme logos */
  white?: Color;
  /** colored theme logos */
  colored?: Color;
}

/** @internal */
export interface Color {
  /**
   * URL to SVG image
   * @format WEB_URL
   */
  svg?: string;
  /**
   * URL to PNG image
   * @format WEB_URL
   */
  png?: string;
}

/** @internal */
export enum MandatoryField {
  ZIPCODE = 'ZIPCODE',
  CITY = 'CITY',
  STATE = 'STATE',
  ADDRESS = 'ADDRESS',
  COUNTRY_CODE = 'COUNTRY_CODE',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  STREET = 'STREET',
  HOUSE_NUMBER = 'HOUSE_NUMBER',
  TAX_IDENTIFIER = 'TAX_IDENTIFIER',
}

/** @enumType */
/** @internal */
export type MandatoryFieldWithLiterals =
  | MandatoryField
  | 'ZIPCODE'
  | 'CITY'
  | 'STATE'
  | 'ADDRESS'
  | 'COUNTRY_CODE'
  | 'EMAIL'
  | 'PHONE'
  | 'FIRST_NAME'
  | 'LAST_NAME'
  | 'STREET'
  | 'HOUSE_NUMBER'
  | 'TAX_IDENTIFIER';

/** @internal */
export interface PaymentServiceProviderCredentialsField
  extends PaymentServiceProviderCredentialsFieldFieldOneOf {
  /** text field */
  simpleField?: SimpleField;
  /** checkbox field */
  checkboxField?: CheckboxField;
  /** dropdown field */
  dropdownField?: DropdownField;
}

/** @oneof */
/** @internal */
export interface PaymentServiceProviderCredentialsFieldFieldOneOf {
  /** text field */
  simpleField?: SimpleField;
  /** checkbox field */
  checkboxField?: CheckboxField;
  /** dropdown field */
  dropdownField?: DropdownField;
}

/** @internal */
export interface SimpleField {
  /**
   * field name
   * @minLength 1
   */
  name?: string;
  /**
   * field label
   * @minLength 1
   */
  label?: string;
}

/** @internal */
export interface CheckboxField {
  /**
   * field name
   * @minLength 1
   */
  name?: string;
  /**
   * field label
   * @minLength 1
   */
  label?: string;
  /** field tooltip */
  tooltip?: string | null;
}

/** @internal */
export interface DropdownField {
  /**
   * field name
   * @minLength 1
   */
  name?: string;
  /**
   * field label
   * @minLength 1
   */
  label?: string;
  /** specific options */
  options?: DropdownFieldOption[];
}

/** @internal */
export interface DropdownFieldOption {
  /**
   * option key
   * @minLength 1
   */
  key?: string;
  /**
   * option value
   * @minLength 1
   */
  value?: string;
}

/** @internal */
export interface MembershipsSPIConfig {
  /** The URL of the SPI implementation */
  deploymentUri?: string;
  /**
   * @minSize 1
   * @maxSize 300
   */
  catalogAppDefIds?: string[];
  /** Set to true once your app implements the updated redemption methods (`ListExistingMemberships`, `ListPurchasablePlans`, `EnhanceAndValidateSelection`) */
  toggleUpdatedMethodsEnabled?: boolean;
}

/** @internal */
export interface LineItemsEnricherConfig {
  /** the base URI where all the methods are deployed. */
  baseUri?: string;
}

export interface ShippingRatesConfig {
  /**
   * Base URI where the endpoints are called.
   * Wix eCommerce appends the endpoint path to the base URI.
   * For example, to call the Get Shipping Rates endpoint at `https://my-shipping-provider.com/v1/getRates`,
   * the base URI you provide here is `https://my-shipping-provider.com/`.
   * @minLength 1
   */
  deploymentUri?: string;
  /**
   * Human-readable name of the shipping provider.
   * @minLength 1
   * @maxLength 64
   */
  name?: string;
  /**
   * Description of the shipping provider.
   * @maxLength 200
   */
  description?: string | null;
  /**
   * URL to more info about the shipping provider.
   * @maxLength 200
   */
  learnMoreUrl?: string | null;
  /**
   * URL to reach the shipping provider app's dashboard.
   * @minLength 1
   * @maxLength 2048
   * @format WEB_URL
   */
  dashboardUrl?: string | null;
  /** Whether to require the site owner to define a fallback/default rate. Set to `true` if you do not provide rates as part of the integration. */
  fallbackDefinitionMandatory?: boolean;
  /**
   * Thumbnail image of the shipping rates provider. Displayed in the shipping settings section in the Dashboard.
   * The URL must be of an image uploaded to the [Wix Media Manager](https://support.wix.com/en/article/wix-media-uploading-media-to-the-media-manager).
   * @format WEB_URL
   */
  thumbnailUrl?: string | null;
  /**
   * feature toggle initialized with default value = false. should be true if implemented by spi provider
   * @internal
   */
  toggleGetDashboardTableEnabled?: boolean;
  /**
   * Feature toggle initialized with default value = false. should be true if implemented by spi provider
   * This flag controls if the spi provider supports the update status api.
   * @internal
   */
  toggleUpdateActiveStatusEnabled?: boolean;
}

/** @internal */
export interface ShippingLabelCarrierSpiConfig {
  /** the base URI where all the methods are deployed */
  baseUri?: string;
  /**
   * the countries supported to send from
   * @format COUNTRY
   * @minSize 1
   * @maxSize 300
   */
  originCountries?: string[];
  /**
   * the countries supported to send to
   * @format COUNTRY
   * @minSize 1
   * @maxSize 300
   */
  destinationCountries?: string[];
  /**
   * the currency of the labels
   * @format CURRENCY
   */
  currency?: string;
  /** the measurement system of he labels (Metric or Imperial) */
  measurementSystem?: MeasurementSystemWithLiterals;
  /** does carrier support insurance */
  isInsuranceSupported?: boolean;
  /**
   * preset carrier packages
   * @minSize 1
   * @maxSize 20
   */
  packageTypes?: PackageType[];
}

/** @internal */
export enum MeasurementSystem {
  Metric = 'Metric',
  Imperial = 'Imperial',
}

/** @enumType */
/** @internal */
export type MeasurementSystemWithLiterals =
  | MeasurementSystem
  | 'Metric'
  | 'Imperial';

/** @internal */
export interface PackageType {
  /**
   * carrier id that can be used to get quotes and purchase
   * @maxLength 30
   */
  id?: string;
  /**
   * display name of the package (translated)
   * @maxLength 100
   */
  name?: string;
  /**
   * description (translated)
   * @maxLength 200
   */
  description?: string;
  /** the dimensions of the package */
  dimension?: PackageDimension;
  /** image of the package (Optional) */
  image?: V1Image;
}

/** @internal */
export interface PackageDimension {
  /**
   * width of the package
   * @max 120
   */
  width?: number;
  /**
   * length of the package
   * @max 120
   */
  length?: number;
  /**
   * height of the package (Optional)
   * @max 120
   */
  height?: number | null;
}

/** @internal */
export interface V1Image {
  /** WixMedia image ID. */
  id?: string;
  /** Image URL. */
  url?: string;
  /**
   * Original image height.
   * @readonly
   */
  height?: number;
  /**
   * Original image width.
   * @readonly
   */
  width?: number;
  /** Image alt text. Optional. */
  altText?: string | null;
  /**
   * Image URL expiration date (when relevant). Optional
   * @internal
   */
  urlExpirationDate?: Date | null;
  /** Image filename. Optional. */
  filename?: string | null;
  /**
   * Image size in bytes. Optional.
   * @internal
   * @format DECIMAL_VALUE
   */
  sizeInBytes?: string | null;
}

/** Restaurants POS component */
/** @internal */
export interface RestaurantsPOSComponentData {
  /**
   * URL for the Restaurants POS registration web page.
   * The app instance and account ID query parameters are appended to the registration URL so that you can identify an account when accessing the vendor api.
   * [Learn more](https://devforum.wix.com/en/article/app-instance).
   * @format WEB_URL
   */
  registrationUrl?: string;
  /** Base URL for all the Restaurants POS API calls. */
  apiBaseUri?: string;
  /** Configuration parameters defining the behavoiur of the catalog sync. */
  catalogSyncConfiguration?: CatalogSyncConfiguration;
}

/** @internal */
export interface CatalogSyncConfiguration {
  /** If menu, section, or dish availability will be updated on the POS side or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  entityAvailabilityUpdated?: DefaultWithLiterals;
  /** Whether fulfillment methods will be defined on the POS side or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  fulfillmentMethodsDefinition?: DefaultWithLiterals;
  /** If dish images will be updated on the POS side or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  dishImagesUpdated?: DefaultWithLiterals;
  /** If sorting (Menu/Category/Dish/Options) will be done on the POS side (API order) or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  entitySortingControl?: DefaultWithLiterals;
  /** If labels will be updated on the POS side or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  dishLabelsUpdated?: DefaultWithLiterals;
  /** If min/max amount of choices is to be set on the POS side or on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  dishOptionsMinMaxUpdated?: DefaultWithLiterals;
  /** If dish in/out of stock will be retrieved from POS or updated on [Wix Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menus/introduction). */
  dishInStockUpdated?: DefaultWithLiterals;
}

/** @internal */
export enum Default {
  WIX = 'WIX',
  POS = 'POS',
}

/** @enumType */
/** @internal */
export type DefaultWithLiterals = Default | 'WIX' | 'POS';

/** @internal */
export interface ShippingProviderConfig {
  /** URI configuration of the deployment */
  deploymentUri?: SpiBaseUri;
  /** User-friendly name of the shipping provider */
  shippingCompanyName?: string;
  /** Cost of making a shipment */
  shippingPrice?: number;
}

/** Base URI configuration for a service plugin. Wix uses these URIs to call your service plugin methods. */
/** @internal */
export interface SpiBaseUri {
  /**
   * Base URI for your service plugin. Wix appends each method's path to this URI.
   *
   * For example, to receive requests at `https://my-app.com/v1/my-method`, set this field to `https://my-app.com/`.
   * @minLength 6
   * @maxLength 2048
   */
  baseUri?: string;
  /** Alternative URIs for specific methods. Use these to override the default URI for individual methods. */
  alternativeUris?: AlternativeUri[];
}

/** Custom URI for the specified service plugin method. */
/** @internal */
export interface AlternativeUri {
  /**
   * Name of the method to call at the absolute URI, in PascalCase. For example, to call [Get Shipping Rates](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/extensions/shipping-rates/shipping-rates-integration-service-plugin/get-shipping-rates) on an alternative URI, specify `GetShippingRates`.
   * @minLength 3
   * @maxLength 128
   */
  methodName?: string;
  /**
   * Absolute URI that Wix calls for this method. Wix doesn't append any path to this URI.
   *
   * The URI must begin with `https://`, such as `https://my-app.com/v1/my-custom-method`.
   * @minLength 6
   * @maxLength 2048
   */
  absoluteUri?: string;
}

/** @internal */
export interface AlertEnricherSpiConfiguration {
  deploymentUri?: string;
}

/** A component holding schema of Data Extensions */
export interface DataExtensionsComponentData {
  /**
   * Deprecated, use fqdn and schema instead.
   * @internal
   * @deprecated
   */
  schemas?: Record<string, string>;
  /** FQDN of the entity that the application extends */
  fqdn?: string;
  /** Schema of the extended fields in JSON Schema compatible format */
  schema?: Record<string, any> | null;
  /**
   * Extension point for this schema. empty string or "ROOT" means regular top level schema
   * @maxLength 20
   */
  extensionPoint?: string;
}

/** @internal */
export interface GenericHooksConfig {
  /**
   * Hook definitions
   * @maxSize 100
   */
  hooks?: GenericHookConfig[];
}

/** @internal */
export enum HookType {
  UNDEFINED = 'UNDEFINED',
  BEFORE_BLOCKING = 'BEFORE_BLOCKING',
  BEFORE = 'BEFORE',
  AFTER = 'AFTER',
}

/** @enumType */
/** @internal */
export type HookTypeWithLiterals =
  | HookType
  | 'UNDEFINED'
  | 'BEFORE_BLOCKING'
  | 'BEFORE'
  | 'AFTER';

/** @internal */
export interface GenericHookConfig {
  /** FQN of proto service */
  serviceFqn?: string;
  /** Name of RPC inside given proto service */
  methodName?: string;
  /**
   * An URI, which uniquely identifies the hook for invocation
   * @format WEB_URL
   */
  uri?: string;
  /** Type of hook */
  hookType?: HookTypeWithLiterals;
}

/** @internal */
export interface ActionProviderSPIConfig {
  /** URL to action provider service for this action */
  baseUri?: string;
  /** Action service plugin configuration */
  actionConfig?: ActionSPIConfig;
}

/** @internal */
export interface ActionSPIConfig {
  /**
   * Identifier for this action - human-readable action key - unique per app def ID
   * @minLength 5
   * @maxLength 50
   */
  actionKey?: string;
  /**
   * The action expects the following input
   * The schema is described according to the JSON Schema standard: https://json-schema.org/
   *
   * Example - Add Label to Contact Action input schema:
   * {
   * "$schema": "https://json-schema.org/draft/2020-12/schema",
   * "type": "object",
   * "title": "Add label to contact input schema",
   * "description": "The schema of the JSON that is sent when invoking this add label to contact action",
   * "default": {},
   * "examples": [
   * {
   * "contactId": "a647eb32-c5f4-11ec-9d64-0242ac120002",
   * "labelId": "1e8b5e5e-dba2-11ec-9d64-0242ac120002"
   * }
   * ],
   * "required": [
   * "contactId",
   * "labelId"
   * ],
   * "properties": {
   * "contactId": {
   * "$id": "#/properties/contactId",
   * "type": "string",
   * "format": "uuid",
   * "title": "Contact Id",
   * "description": "The ID of the contact to apply the label to",
   * "default": "",
   * "identityType": "contact" // can be contact/visitor/user, limited to 1 type per identity.
   * },
   * "labelId": {
   * "$id": "#/properties/labelId",
   * "type": "string",
   * "format": "uuid",
   * "title": "Label Id",
   * "description": "The ID of the label to apply",
   * "default": "",
   * }
   * }
   * }
   */
  inputSchema?: Record<string, any> | null;
  /**
   * The output of the action, which will be added to the payload after execution.
   * The schema is described according to the JSON Schema standard: https://json-schema.org/
   *
   * Example - Output of create task action
   * {
   * "$schema": "https://json-schema.org/draft/2020-12/schema",
   * "type": "object",
   * "title": "Create task action schema",
   * "description": "The schema of the JSON that is sent when invoking this create task action",
   * "default": {},
   * "examples": [
   * {
   * "taskId": "a647eb32-c5f4-11ec-9d64-0242ac120002",
   * }
   * ],
   * "required": [
   * "taskId"
   * ],
   * "properties": {
   * "taskId": {
   * "$id": "#/properties/taskId",
   * "type": "string",
   * "format": "uuid",
   * "title": "Contact Id",
   * "description": "The ID of the task created",
   * "default": "",
   * }
   * }
   * }
   */
  outputSchema?: Record<string, any> | null;
  /**
   * Actions display name - human-readable field. Ex. - "Send SMS"
   * @minLength 5
   * @maxLength 80
   */
  displayName?: string | null;
  description?: string | null;
  /** Specifies which optional methods were implemented */
  implementedMethods?: ActionSPIConfigImplementedMethods;
  /**
   * Indicates whether we should wait for the action to complete before executing the next actions or finish and
   * expect a callback in the `actionCompleted` method.
   * @deprecated Indicates whether we should wait for the action to complete before executing the next actions or finish and
   * expect a callback in the `actionCompleted` method.
   * @targetRemovalDate 2025-03-10
   */
  executionType?: ExecutionTypeWithLiterals;
  /** @internal */
  metadata?: Metadata;
  /** Chosen interface for action. */
  interfaceConfiguration?: ActionSPIConfigInterfaceConfiguration;
  /** Icon representing the action in the UI */
  icon?: WixCommonImage;
  /**
   * The action configuration source information
   * @internal
   */
  source?: Source;
  /**
   * action id
   * @format GUID
   */
  id?: string | null;
  /** Whether this action supports synchronous invocation. */
  supportsSyncInvocation?: boolean;
}

/** @internal */
export enum ActionSPIConfigInterfaceConfigurationType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WIDGET_COMPONENT = 'WIDGET_COMPONENT',
  GENERIC = 'GENERIC',
}

/** @enumType */
/** @internal */
export type ActionSPIConfigInterfaceConfigurationTypeWithLiterals =
  | ActionSPIConfigInterfaceConfigurationType
  | 'UNKNOWN_TYPE'
  | 'WIDGET_COMPONENT'
  | 'GENERIC';

/** @internal */
export interface WidgetComponentOptions {
  /**
   * Name of provided component
   * @minLength 1
   * @maxLength 80
   */
  componentName?: string;
}

/** @internal */
export interface GenericOptions {
  /** UI schema */
  uiSchema?: Record<string, any> | null;
}

/** @internal */
export enum IntegrationType {
  UNKNOWN_INTEGRATION_TYPE = 'UNKNOWN_INTEGRATION_TYPE',
  /** Integration with Wix API methods */
  WIX_API = 'WIX_API',
  /** Integration with external APIs via OpenAPI specifications */
  OPEN_API = 'OPEN_API',
}

/** @enumType */
/** @internal */
export type IntegrationTypeWithLiterals =
  | IntegrationType
  | 'UNKNOWN_INTEGRATION_TYPE'
  | 'WIX_API'
  | 'OPEN_API';

/** OpenAPI integration configuration */
/** @internal */
export interface OpenApiOptions {
  /**
   * URL to the OpenAPI specification file
   * @minLength 1
   * @maxLength 2000
   * @format WEB_URL
   */
  openApiSpecUrl?: string;
  /**
   * Optional: Link to additional documentation for the external API
   * @maxLength 2000
   * @format WEB_URL
   */
  documentationUrl?: string | null;
  /**
   * Optional: Human-readable explanation or prompt describing the integration
   * @maxLength 5000
   */
  explanation?: string | null;
}

/** @internal */
export enum SourceType {
  UNKNOWN_SOURCE_TYPE = 'UNKNOWN_SOURCE_TYPE',
  /** The input/output schemas are constructed by developers in Dev Center using the self-service flow */
  DEV_CENTER = 'DEV_CENTER',
  /** The input/output schemas are derived from an existing Wix API through the API-to-Action feature */
  WIX_API = 'WIX_API',
  /** The action invokes external API methods based on configuration */
  INTEGRATION = 'INTEGRATION',
}

/** @enumType */
/** @internal */
export type SourceTypeWithLiterals =
  | SourceType
  | 'UNKNOWN_SOURCE_TYPE'
  | 'DEV_CENTER'
  | 'WIX_API'
  | 'INTEGRATION';

/** @internal */
export interface WixApiOptions {
  /**
   * Service entity fqdn
   * @minLength 1
   * @maxLength 100
   */
  serviceEntityFqdn?: string;
  /**
   * The service providing the API
   * @minLength 1
   * @maxLength 200
   */
  serviceName?: string;
  /**
   * The method name
   * @minLength 1
   * @maxLength 200
   */
  methodName?: string;
}

/** @internal */
export interface IntegrationOptions extends IntegrationOptionsOptionsOneOf {
  /** Required when integration_type = OPEN_API */
  openApiOptions?: OpenApiOptions;
  /** The integration type */
  integrationType?: IntegrationTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface IntegrationOptionsOptionsOneOf {
  /** Required when integration_type = OPEN_API */
  openApiOptions?: OpenApiOptions;
}

/** disable-flynt renamed-field-breaking-change */
/** @internal */
export interface ActionSPIConfigImplementedMethods {
  /** Implements ValidateConfiguration */
  validateConfiguration?: boolean;
  /** Implements DuplicateInputMapping */
  duplicateInputMapping?: boolean;
  /** Implements GenerateApplicationAutomationInputMapping */
  generateApplicationAutomationInputMapping?: boolean;
  /** Implements GetQuotaInfo */
  getQuotaInfo?: boolean;
  /** Implements OnBeforeSave */
  onBeforeSave?: boolean;
  /** Implements OnReset */
  onReset?: boolean;
  /** implements generateActionInputMappingFromTemplate */
  generateActionInputMappingFromTemplate?: boolean;
  /** implements OnRemove */
  onRemove?: boolean;
  /** Implements GetDynamicInputSchema */
  getDynamicInputSchema?: boolean;
  /** Implements MergeInputMappings */
  mergeInputMappings?: boolean;
  /** Implements GetDynamicOutputSchema */
  getDynamicOutputSchema?: boolean;
  /** Implements GenerateInputMappingFromIntent */
  generateInputMappingFromIntent?: boolean;
}

/** @internal */
export enum ExecutionType {
  UNKNOWN_EXECUTION_TYPE = 'UNKNOWN_EXECUTION_TYPE',
  SYNC = 'SYNC',
  ASYNC = 'ASYNC',
}

/** @enumType */
/** @internal */
export type ExecutionTypeWithLiterals =
  | ExecutionType
  | 'UNKNOWN_EXECUTION_TYPE'
  | 'SYNC'
  | 'ASYNC';

/** @internal */
export interface Metadata {
  /** Show action only to advanced mode users (Wix staff) */
  hidden?: boolean;
}

/** @internal */
export interface ActionSPIConfigInterfaceConfiguration
  extends ActionSPIConfigInterfaceConfigurationOptionsOneOf {
  /** @internal */
  widgetComponentOptions?: WidgetComponentOptions;
  genericOptions?: GenericOptions;
  /** Type of chosen interface. */
  type?: ActionSPIConfigInterfaceConfigurationTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ActionSPIConfigInterfaceConfigurationOptionsOneOf {
  /** @internal */
  widgetComponentOptions?: WidgetComponentOptions;
  genericOptions?: GenericOptions;
}

/** @internal */
export interface Source extends SourceOptionsOneOf {
  /** Wix API options */
  wixApiOptions?: WixApiOptions;
  /** Integration options */
  integrationOptions?: IntegrationOptions;
  /** the source type */
  type?: SourceTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface SourceOptionsOneOf {
  /** Wix API options */
  wixApiOptions?: WixApiOptions;
  /** Integration options */
  integrationOptions?: IntegrationOptions;
}

export interface CatalogSPIConfig {
  /** Base URI which Wix eCommerce will call to access Catalog service plugin endpoints. For example, to call the Get Catalog Items endpoint at `https://my-external-catalog.com/get-catalog-items`, the base URI you provide here is `https://my-external-catalog.com`. */
  deploymentUri?: string;
  /** Configuration details for discounts applied to all items in the catalog. */
  allItemsDiscount?: DiscountConfig;
  /** Configuration details for discounts applied to specific items in the catalog. */
  specificItemsDiscount?: DiscountConfig;
}

/** @internal */
export interface DiscountConfig {
  /**
   * Whether the discount is enabled.
   *
   * Default: `false`.
   */
  enabled?: boolean;
  /**
   * Translation key for text to display to the site owner.
   * @minLength 5
   * @maxLength 100
   */
  translationKey?: string;
}

/** A container (slot) that can be extended by other applications (e.g. widget slot or context menu slot) */
/** @internal */
export interface BackOfficeExtensionContainer {
  /** Information about the type of slot. */
  extendable?: Extendable;
  /**
   * Platform that hosts the modal.
   *
   * Must be `"BUSINESS_MANAGER"`.
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Default route for the container.
   * @maxLength 400
   */
  defaultRoute?: string | null;
  /** A container (slot) common properties. */
  slotData?: SlotData;
  /** Context consumed by AI-powered features */
  aiContext?: AiContext;
}

/** Extensibility properties used by containers (slots) */
/** @internal */
export interface Extendable {
  /** Type of component that this slot accepts. */
  extendedBy?: ExtendingComponentTypeWithLiterals;
}

/** Which component types can be extended in containers */
/** @internal */
export enum ExtendingComponentType {
  INVALID = 'INVALID',
  BACK_OFFICE_MENU_ITEM = 'BACK_OFFICE_MENU_ITEM',
  BACK_OFFICE_EXTENSION_WIDGET = 'BACK_OFFICE_EXTENSION_WIDGET',
}

/** @enumType */
/** @internal */
export type ExtendingComponentTypeWithLiterals =
  | ExtendingComponentType
  | 'INVALID'
  | 'BACK_OFFICE_MENU_ITEM'
  | 'BACK_OFFICE_EXTENSION_WIDGET';

/** List of back-office hosting platforms */
/** @internal */
export enum BackOfficeHostingPlatforms {
  NO_HOSTING_PLATFORM = 'NO_HOSTING_PLATFORM',
  /** Site Dashboard (The Wix Dashboard) */
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  /** User Account Dashboard */
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  /** Internal: Dev center */
  DEV_CENTER = 'DEV_CENTER',
  /** Enterprise dashboard (available to enterprise accounts only) */
  ENTERPRISE = 'ENTERPRISE',
  /** Partners dashboard (available to partners accounts only) */
  PARTNERS_DASHBOARD = 'PARTNERS_DASHBOARD',
  /** Employee only financial support dashboard */
  FINANCIALS_INTERNAL_BO = 'FINANCIALS_INTERNAL_BO',
  /** FED Guild POC dashboard */
  FED_GUILD_POC = 'FED_GUILD_POC',
  /** Studio dashboard */
  STUDIO_DASHBOARD = 'STUDIO_DASHBOARD',
  /** Channels dashboard (available to channels accounts only) */
  CHANNELS = 'CHANNELS',
  /** Wix internal dashboard for data tools (proffesional data consumers, i.e Business Analysts, Data Engineers...) */
  DATA_TOOLS = 'DATA_TOOLS',
  /** Internal back-office for payment service provider management */
  PSP_BACKOFFICE = 'PSP_BACKOFFICE',
  /** Rise.ai account dashboard */
  RISE_PLATFORM_ACCOUNT_DASHBOARD = 'RISE_PLATFORM_ACCOUNT_DASHBOARD',
  /** Enterprise demo dashboard (available to possible enterprise accounts for demo purposes) */
  DEMO_DASHBOARD_ENTERPRISE = 'DEMO_DASHBOARD_ENTERPRISE',
  /** A new AI scheduling assistant product dashboard (codename: "Nownia") */
  AI_SCHEDULING_ASSISTANT_DASHBOARD = 'AI_SCHEDULING_ASSISTANT_DASHBOARD',
  /** Employee only getting paid cluster dashboard */
  GETTING_PAID = 'GETTING_PAID',
  /** Wix internal dashboard for data (non proffesional data consumers, i.e any Wix Employee that has a need for BI data) */
  DATA = 'DATA',
  /** Dashboard for viral forms/lite events/etc */
  LITE_DASHBOARD = 'LITE_DASHBOARD',
  /** Picasso AI application POC */
  PICASSO_EDITOR = 'PICASSO_EDITOR',
  /** Base44 Host Dashboard POC */
  BASE44_DASHBOARD_POC = 'BASE44_DASHBOARD_POC',
  /** Wixel Editor */
  WIXEL_EDITOR = 'WIXEL_EDITOR',
  /** Base44 Platform */
  BASE44_PLATFORM = 'BASE44_PLATFORM',
  /** Payments by Wix Back Office */
  PAYMENTS_BO = 'PAYMENTS_BO',
  /** Symphony Giza host */
  SYMPHONY = 'SYMPHONY',
  /** BMR Giza host */
  BMR = 'BMR',
}

/** @enumType */
/** @internal */
export type BackOfficeHostingPlatformsWithLiterals =
  | BackOfficeHostingPlatforms
  | 'NO_HOSTING_PLATFORM'
  | 'BUSINESS_MANAGER'
  | 'ACCOUNT_MANAGER'
  | 'DEV_CENTER'
  | 'ENTERPRISE'
  | 'PARTNERS_DASHBOARD'
  | 'FINANCIALS_INTERNAL_BO'
  | 'FED_GUILD_POC'
  | 'STUDIO_DASHBOARD'
  | 'CHANNELS'
  | 'DATA_TOOLS'
  | 'PSP_BACKOFFICE'
  | 'RISE_PLATFORM_ACCOUNT_DASHBOARD'
  | 'DEMO_DASHBOARD_ENTERPRISE'
  | 'AI_SCHEDULING_ASSISTANT_DASHBOARD'
  | 'GETTING_PAID'
  | 'DATA'
  | 'LITE_DASHBOARD'
  | 'PICASSO_EDITOR'
  | 'BASE44_DASHBOARD_POC'
  | 'WIXEL_EDITOR'
  | 'BASE44_PLATFORM'
  | 'PAYMENTS_BO'
  | 'SYMPHONY'
  | 'BMR';

/** Definitions of common slots properties */
/** @internal */
export interface SlotData extends SlotDataSlotTypeOneOf {
  /** Widget-specific slot. */
  widgetOptions?: WidgetSlot;
  /** Menu-specific slot. */
  menuOptions?: MenuSlot;
  /**
   * Slot display name.
   * @maxLength 400
   */
  displayName?: string | null;
  /**
   * Slot description.
   * @maxLength 400
   */
  description?: string | null;
  /** Parameters for the slot. */
  slotParams?: SlotParams;
  /**
   * HTTP links to a markdown files.
   * @maxSize 100
   * @format WEB_URL
   */
  mdHttpLinks?: string[];
  type?: SlotDataTypeWithLiterals;
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
}

/** @oneof */
/** @internal */
export interface SlotDataSlotTypeOneOf {
  /** Widget-specific slot. */
  widgetOptions?: WidgetSlot;
  /** Menu-specific slot. */
  menuOptions?: MenuSlot;
}

/** @internal */
export interface DtsDefinitionReference
  extends DtsDefinitionReferenceDtsDefinitionOneOf {
  dtsHttpLinkOptions?: DtsHttpLink;
  dtsContentOptions?: DtsContent;
  type?: DtsDefinitionTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface DtsDefinitionReferenceDtsDefinitionOneOf {
  dtsHttpLinkOptions?: DtsHttpLink;
  dtsContentOptions?: DtsContent;
}

/** @internal */
export enum DtsDefinitionType {
  UNKNOWN = 'UNKNOWN',
  DTS_HTTP_LINK = 'DTS_HTTP_LINK',
  DTS_CONTENT = 'DTS_CONTENT',
}

/** @enumType */
/** @internal */
export type DtsDefinitionTypeWithLiterals =
  | DtsDefinitionType
  | 'UNKNOWN'
  | 'DTS_HTTP_LINK'
  | 'DTS_CONTENT';

/** @internal */
export interface DtsHttpLink {
  /**
   * HTTP link to the bundled d.ts file.
   * @maxLength 400
   */
  bundledDtsHttpLink?: string;
}

/** @internal */
export interface DtsContent {
  /**
   * d.ts file content.
   * @maxLength 2000
   */
  bundledDtsContent?: string;
}

/** @internal */
export interface BlocksData {
  /** Maximum allowed dimensions. */
  maxDimensionsPixels?: Dimension;
  /** Minimum allowed dimensions. */
  minDimensionsPixels?: Dimension;
  /**
   * Slot placeholder component ID in the document.
   * @maxLength 50
   */
  compRefId?: string | null;
}

/** @internal */
export interface Dimension {
  /**
   * Width of the component (max: 9999).
   * @max 9999
   */
  width?: number | null;
  /**
   * Height of the component (max: 9999).
   * @max 9999
   */
  height?: number | null;
}

/** @internal */
export interface SlotParams {
  /** DTS reference for the slot parameters. */
  slotParamsDtsReference?: DtsDefinitionReference;
  /**
   * Named export to use.
   * @maxLength 400
   */
  namedExport?: string | null;
}

/** @internal */
export enum SlotDataType {
  UNKNOWN = 'UNKNOWN',
  WIDGET = 'WIDGET',
  MENU = 'MENU',
}

/** @enumType */
/** @internal */
export type SlotDataTypeWithLiterals =
  | SlotDataType
  | 'UNKNOWN'
  | 'WIDGET'
  | 'MENU';

/** @internal */
export interface WidgetSlot {
  /** Blocks specific data. */
  blocksData?: BlocksData;
}

/** @internal */
export interface MenuSlot {}

/** @internal */
export interface AiContext {
  /**
   * @minLength 20
   * @maxLength 10000
   */
  description?: string | null;
}

/**
 * A component that enables extending Wix Dashboard Functionality, as defined by ExtendingComponentType.
 * Currently this supports extending menus and extending widget slots (for Wix apps that expose such menus and slots)
 */
/** @internal */
export interface BackOfficeExtension extends BackOfficeExtensionExtensionOneOf {
  /** Information about a widget extension. */
  widget?: LegacyBackOfficeExtensionWidget;
  /** Information about a menu item extension. */
  menuItem?: LegacyBackOfficeMenuItem;
  /**
   * ID of the slot that hosts the extension.
   * @format GUID
   */
  extends?: string;
  /** Extension title. This is how the extension is referred to in the Wix Dev Center. */
  title?: string;
  /** Extension description. This is how the extension is described in the Wix Dev Center. */
  description?: string | null;
  /** Type of extension. */
  extensionType?: ExtendingComponentTypeWithLiterals;
  /**
   * Platform that hosts the extension.
   *
   * Must be `"BUSINESS_MANAGER"`.
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Required permission to view the extension.
   * @internal
   */
  requiredPermission?: string;
  /**
   * Sentry error reporting DSN (internal)
   * @internal
   */
  errorReporting?: ErrorReporting;
  /** Context consumed by AI-powered features */
  aiContext?: AiContext;
}

/** @oneof */
/** @internal */
export interface BackOfficeExtensionExtensionOneOf {
  /** Information about a widget extension. */
  widget?: LegacyBackOfficeExtensionWidget;
  /** Information about a menu item extension. */
  menuItem?: LegacyBackOfficeMenuItem;
}

/** The schema of a widget extending a slot exposed in a page in the Wix Dashboard */
/** @internal */
export interface LegacyBackOfficeExtensionWidget
  extends LegacyBackOfficeExtensionWidgetAssetOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /**
   * Wix script asset to use in this widget
   * @internal
   */
  scriptAsset?: BackOfficeScriptAsset;
  /**
   * Initial width of the widget while loading, in pixels.
   * Width may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @max 9999
   */
  width?: number | null;
  /**
   * Initial height of the widget while loading, in pixels.
   * Height may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @max 9999
   */
  height?: number | null;
}

/** @oneof */
/** @internal */
export interface LegacyBackOfficeExtensionWidgetAssetOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /**
   * Wix script asset to use in this widget
   * @internal
   */
  scriptAsset?: BackOfficeScriptAsset;
}

/** Internal: Specifications for loading an asset via JS in the back office */
/** @internal */
export interface BackOfficeScriptAsset {
  /**
   * The JavaScript file to load
   * @format WEB_URL
   */
  url?: string;
  /**
   * Namespacing of the component in the Webpack Module Federation registry
   * @minLength 1
   */
  containerId?: string;
  /**
   * Key name for the retrieval of the component
   * @minLength 1
   */
  exportedName?: string;
  /** Optional: What type should by used on <script> tag. */
  scriptType?: BackOfficeScriptAssetTypeWithLiterals;
}

/** Type attribute for the script tag */
/** @internal */
export enum BackOfficeScriptAssetType {
  /** Script will be loaded without a type attribute */
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** Use "module" as the script type */
  MODULE = 'MODULE',
}

/** @enumType */
/** @internal */
export type BackOfficeScriptAssetTypeWithLiterals =
  | BackOfficeScriptAssetType
  | 'UNKNOWN_TYPE'
  | 'MODULE';

/** The schema of a menu extension of a slot exposed in a page in the Wix Dashboard */
/** @internal */
export interface LegacyBackOfficeMenuItem {
  /**
   * [Wix Design System icon key](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full-size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /** Action that takes places when the menu item is clicked. */
  action?: LegacyBackOfficeMenuItemAction;
  /**
   * Menu item subtitle.
   * @maxLength 200
   */
  subtitle?: string | null;
}

/** View modes for how to open a component. */
/** @internal */
export enum ViewMode {
  /** Opens a page in place of the current page. */
  PAGE = 'PAGE',
  /** Opens as a modal on the current page. */
  MODAL = 'MODAL',
}

/** @enumType */
/** @internal */
export type ViewModeWithLiterals = ViewMode | 'PAGE' | 'MODAL';

/** the schema of the data needed to open a component from menu extensions */
/** @internal */
export interface OpenComponent {
  /**
   * ID of the component to open.
   * @format GUID
   */
  componentId?: string;
  /** How the component is opened. */
  viewMode?: ViewModeWithLiterals;
  /** Parameters to navigate to a page or as props for a modal. */
  componentParams?: Record<string, string>;
}

/** The schema of an action that is onvoked from menu extensions */
/** @internal */
export interface LegacyBackOfficeMenuItemAction {
  /** Component that opens when the menu item is clicked. */
  openComponent?: OpenComponent;
}

/** @internal */
export interface TriggerProviderSPIConfig {
  /**
   * The trigger configuration
   *
   * example of a trigger:
   *
   * {
   * appId: "56cc7843-fdfc-417f-a660-d4af9a2eafe3",
   * triggerKey: "form_submit",
   * displayName: "Visitor submits a form",
   * payloadDataSchema: {
   * "$schema": "http://json-schema.org/draft-07/schema",
   * "type": "object",
   * "title": "Visitor submits a form Payload Schema",
   * "description": "The schema of the payload that is part of the triggered event",
   * "default": {},
   * "examples": [
   * {
   * "formId": "60d2cd50-1047-4164-884d-8c24fbda84bb",
   * "formName": "My Cool Form
   * }
   * ],
   * "properties": {
   * "formId": {
   * "$id": "#/properties/formId",
   * "type": "string",
   * "format": "uuid",
   * "title": "Form ID",
   * "description": "The form identifier",
   * "default": "",
   * "examples": [
   * "60d2cd50-1047-4164-884d-8c24fbda84bb"
   * ]
   * },
   * "formName": {
   * "$id": "#/properties/formName",
   * "type": "string",
   * "title": "Form Name",
   * "description": "The form display name",
   * "default": "",
   * "examples": [
   * "My Form"
   * ]
   * },
   * "contactId": {
   * "$id": "#/properties/contactId",
   * "type": "string",
   * "format": "uuid",
   * "title": "Contact Id",
   * "description": "The Id of the contact which submitted the form",
   * "default": "",
   * "identityType": "contact", // can be contact, visitor, user limited to 1 type per identity,
   * "name": "contact" // friendly name to be used later on, in order to user that person's data "contact.firstName"
   * }
   * },
   * "required": [
   * "formId",
   * "formName",
   * "contactId"
   * ],
   * "additionalProperties": false
   * }
   * }
   */
  triggerConfig?: Record<string, any> | null;
  /** URL to the trigger provider service */
  baseUri?: string;
}

/** @internal */
export interface PreRegisterConfig {
  /** the base URI where all the methods are deployed. */
  baseUri?: string;
}

/** @internal */
export interface ProductsPathsConfig {
  /** implementer's deployment uri */
  deploymentUri?: string;
}

/** @internal */
export interface CustomScopeConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
}

export interface GiftCardProviderConfig {
  /** The URL of the SPI implementation */
  deploymentUri?: string;
}

/** @internal */
export interface ExternalFilterProviderConfig {
  /** the base URI where all the methods are deployed. E.g */
  baseUri?: string;
}

/** @internal */
export interface RecommendationsProviderConfig {
  /** URI where the application implementing the SPI is deployed. */
  deploymentUri?: string;
  /**
   * App IDs of catalogs for which recommended items can be found.
   * @minSize 1
   * @maxSize 100
   * @minLength 1
   * @maxLength 36
   */
  catalogAppIds?: string[];
  /**
   * The algorithms that this application can use to calculate item recommendations.
   * @minSize 1
   * @maxSize 100
   */
  supportedAlgorithms?: AlgorithmConfig[];
}

/** @internal */
export interface AlgorithmConfig {
  /**
   * Algorithm name. This value is not translatable.
   * @minLength 1
   * @maxLength 50
   */
  name?: string;
  /**
   * Algorithm description. This describes how the algorithm works and if it has any limitations regarding site content, number of items in the catalog, site traffic, and so on. This value is not translatable.
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
  /**
   * A supplemental `description`. It can be used to help break up and organize information. You can, for example, display this information as a tooltip or as an additional section that is collapsed by default.
   * @minLength 1
   * @maxLength 300
   */
  additionalInfo?: string | null;
  /**
   * Algorithms may have the following types:
   * * `RELATED_ITEMS` - This type of algorithm provides recommendations based on 1 or more other provided items. For example, when an item is added to a cart, the algorithm can suggest other items frequently bought together with that item.
   * * `GLOBAL` - This type of algorithm provides general recommendations based on site or project statistics. For example, bestsellers or new arrivals.
   */
  algorithmType?: AlgorithmTypeWithLiterals;
  /**
   * Algorithm ID. This must be unique for a specific app but does not have to be unique across all apps on the site or in the project.
   * @format GUID
   */
  algorithmId?: string;
}

/** @internal */
export enum AlgorithmType {
  UNSPECIFIED = 'UNSPECIFIED',
  RELATED_ITEMS = 'RELATED_ITEMS',
  GLOBAL = 'GLOBAL',
}

/** @enumType */
/** @internal */
export type AlgorithmTypeWithLiterals =
  | AlgorithmType
  | 'UNSPECIFIED'
  | 'RELATED_ITEMS'
  | 'GLOBAL';

/** @internal */
export interface DropshippingProviderSPIConfig {
  /** name of the dropshipping provider was it appears in relevant screens/mails in eComm Platform */
  name?: string;
  /** The URL of the SPI implementation - not needed in this case */
  deploymentUri?: string;
  /**
   * URI for the thumbnail page
   * @format WEB_URL
   */
  thumbnailUri?: string;
  /**
   * URI of the dashboard page
   * @format WEB_URL
   */
  dashboardUri?: string;
  /** if duplication operation for product is locked */
  duplicateProduct?: LockableOperationWithLiterals;
  /** whether there is a warning or not when price is changed */
  changePrice?: RestrictedOperationWithLiterals;
  /** whether the chagne inventory operations are locked */
  changeInventory?: LockableOperationWithLiterals;
  /** where there is a warning of not when changing options */
  manageOptions?: RestrictedOperationWithLiterals;
}

/** @internal */
export enum LockableOperation {
  /** When operation lockability is not specified */
  UNSPECIFIED_LOCKABLE = 'UNSPECIFIED_LOCKABLE',
  /** Operation is locked */
  LOCKED = 'LOCKED',
  /** Operation is unlocked */
  UNLOCKED = 'UNLOCKED',
}

/** @enumType */
/** @internal */
export type LockableOperationWithLiterals =
  | LockableOperation
  | 'UNSPECIFIED_LOCKABLE'
  | 'LOCKED'
  | 'UNLOCKED';

/** @internal */
export enum RestrictedOperation {
  UNSPECIFIED_RESTRICTED = 'UNSPECIFIED_RESTRICTED',
  ALLOW = 'ALLOW',
  WARN = 'WARN',
}

/** @enumType */
/** @internal */
export type RestrictedOperationWithLiterals =
  | RestrictedOperation
  | 'UNSPECIFIED_RESTRICTED'
  | 'ALLOW'
  | 'WARN';

/** @internal */
export interface InvoicesConfig {
  /** Base URI of spi provider */
  baseUri?: string;
}

export interface SeoKeywordsSuggestionsSPIConfig {
  /**
   * Base URL of your SEO implementation. Wix sends API requests to endpoints implemented using this URL.
   * @minLength 1
   */
  baseUri?: string;
  /**
   * URL of the page where users can purchase a paid plan. Wix offers a link to this page when you respond with a value of `false` in quota's `paidPlan` property.
   * @format WEB_URL
   */
  upgradeUrl?: string | null;
  /**
   * List of countries you support for SEO analysis.
   * 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format.
   * @format COUNTRY
   * @minSize 1
   * @maxSize 250
   */
  supportedCountryCodes?: string[];
  /** Whether there is a quota limit in the service. When `true`, the response includes the quota object. */
  quotaEnabled?: boolean | null;
  /**
   * Your website's landing page.
   * @format WEB_URL
   */
  landingPageUrl?: string;
}

/** @internal */
export interface CustomTriggerConfig {
  /**
   * Required. Base URI where the endpoints are called. Wix appends the endpoint path to the base URI.
   * For example, to call the Get Eligible Triggers endpoint at `https://my-discount-app.com/v1/get-eligible-triggers`, the base URI you provide here is `https://my-discount-app.com/`.
   */
  deploymentUri?: string;
}

/** @internal */
export interface ContentProviderConfig {
  /** base uri for each implementer */
  deploymentUri?: string;
  /**
   * a human readable name of the provider
   * @maxLength 64
   */
  providerName?: string;
  /** the maximum items allowed to read and update in a single request */
  maximumReadingBulkSize?: number | null;
}

/** Automation Component data that is stored in dev center */
/** @internal */
export interface ApplicationAutomationComponent {
  /** A rule that contains a trigger & some actions */
  rule?: Rule;
  /**
   * Automation name
   * @maxLength 500
   */
  name?: string | null;
  /**
   * Automation description
   * @maxLength 2000
   */
  description?: string | null;
  /** Automation metadata */
  metadata?: AutomationMetadata;
  /** Automation status */
  status?: StatusWithLiterals;
  /** Optional origin that indicates the source of the automation */
  origin?: OriginInfo;
  /**
   * Automation id - points to a V3 Builder automation id
   * @format GUID
   */
  automationId?: string | null;
  /**
   * trigger app id - used for reading easily for cache - v3
   * @format GUID
   */
  triggerAppId?: string | null;
  /**
   * trigger key - used for reading easily for cache - v3
   * @minLength 1
   * @maxLength 100
   */
  triggerKey?: string | null;
}

/** @internal */
export interface Rule {
  /** an event triggered by visitors on a site, or by a site manager (owner & team). */
  trigger?: ServiceTrigger;
  /**
   * the actions responding to the trigger happening
   * @maxSize 100
   */
  actions?: ServiceAction[];
}

/** @internal */
export interface ServiceTrigger {
  /**
   * the id of the app defining the trigger
   * @format GUID
   */
  appId?: string;
  /**
   * Identifier for this trigger - human readable action key
   * @maxLength 100
   */
  triggerKey?: string;
  /**
   * optional list of filters on schema fields
   * @maxSize 5
   */
  filters?: TriggerFilter[];
  /**
   * optional - allows to define a trigger whose following actions will be executed only if the same event for the same resource has not in the last X seconds.
   * for example, if the trigger is "session booked", the resource is a contact and the timeframe is 3600 seconds (contact hasn't booked another session in the last hour),
   * then the actions will be executed only if the same event (session booked for that contact) has not happened in the last hour.
   * resource id is sent in runtime via the externalEntityId parameter, ReportEvent method.
   */
  debounce?: Debounce;
}

/** @internal */
export interface TriggerFilter {
  /**
   * the filter identifier
   * @format GUID
   */
  id?: string | null;
  /**
   * the field key from the schema, for example "formId"
   * @minLength 1
   * @maxLength 50
   */
  fieldKey?: string;
  /** filter expression that evaluates to a boolean, for example - {{ contains(["guid1","guid2"];formId) }} */
  filterExpression?: string;
}

/** @internal */
export interface Debounce {
  /**
   * Amount of time in seconds to wait for any additional events to occur before triggering the actions.
   * If no additional events occur within the specified time, the actions will be triggered.
   * If additional events occur within the specified time, the timer will be reset.
   * @min 1
   */
  timeFrameInSeconds?: number;
  /**
   * The field key in the event payload, which indicates the identifier of the entity/event to debounce on
   * For example: if the trigger is "user logged in", the resource is a contact and the resource key is "contactId",
   * Another example: if the trigger is "visitor logged in", the resource is a visitor and the resource key is "visitorId".
   * @maxLength 100
   */
  fieldKey?: string;
}

/** @internal */
export interface ServiceAction {
  /**
   * the id of the action for delayed events
   * @format GUID
   * @readonly
   */
  id?: string | null;
  /**
   * the id of the app defining the action
   * @format GUID
   */
  appId?: string;
  /**
   * Identifier for this action - human readable action key - unique per app def id
   * @maxLength 80
   */
  actionKey?: string;
  /**
   * input mapping expression for the action inputs
   * for example:
   * `{  "subject": "Thanks for reaching out!"
   * "message": "Hi {{contact.name.first}}, thanks for contacting our business"
   * }`
   * where the value for "contact.name.first" comes from the trigger's payload
   * @maxLength 5000
   */
  actionConfig?: string;
  /**
   * output mapping expression for the action output
   * for example in get-contact action:
   * `{ "author": "{{$}}" }`
   * This will map the entire entity of contact under `author` namespace
   * @maxLength 3000
   */
  outputActionConfig?: string | null;
  /** Optional delay configuration for the action */
  delay?: Delay;
  /** allows you define an activation policy - like number of activations in a time frame, or limit by some identifier, like contact (e.g. send email to user only at first login) */
  rateLimit?: RateLimit;
  /**
   * allows the user to define a condition for the action to be executed, if the condition fails the action (and following actions) will not be executed
   * @deprecated allows the user to define a condition for the action to be executed, if the condition fails the action (and following actions) will not be executed
   * @replacedBy conditions
   * @targetRemovalDate 2023-08-01
   */
  condition?: ActionCondition;
  conditions?: Conditions;
  /**
   * allows the user to define a namespace for the action output
   * @minLength 1
   * @maxLength 100
   */
  namespace?: string | null;
}

/** @internal */
export enum BlockType {
  UNKNOWN = 'UNKNOWN',
  OR = 'OR',
  AND = 'AND',
}

/** @enumType */
/** @internal */
export type BlockTypeWithLiterals = BlockType | 'UNKNOWN' | 'OR' | 'AND';

/** @internal */
export interface ConditionBlock {
  type?: BlockTypeWithLiterals;
  /**
   * @minSize 1
   * @maxSize 20
   */
  lineExpressions?: string[];
}

/** @internal */
export interface Offset extends OffsetValueOneOf {
  /** A delay in seconds */
  seconds?: number;
  /** The key of the field in the trigger payload which contains a delay, in seconds. */
  delayFieldKey?: string;
}

/** @oneof */
/** @internal */
export interface OffsetValueOneOf {
  /** A delay in seconds */
  seconds?: number;
  /** The key of the field in the trigger payload which contains a delay, in seconds. */
  delayFieldKey?: string;
}

/** calculated as date + delay */
/** @internal */
export interface Until {
  /** The key of the field in the trigger payload which contains the date to delay until */
  dateFieldKey?: string;
  /** Optional: a delay to add together with the date described in the payload */
  offset?: Offset;
}

/** @internal */
export interface Delay extends DelayTypeOneOf {
  /** A delay which is calculated based on the immediate time when the action is triggered. */
  for?: Offset;
  /** A delay which is calculated based on a date field in the trigger payload. May also be used together with an Offset delay. */
  until?: Until;
}

/** @oneof */
/** @internal */
export interface DelayTypeOneOf {
  /** A delay which is calculated based on the immediate time when the action is triggered. */
  for?: Offset;
  /** A delay which is calculated based on a date field in the trigger payload. May also be used together with an Offset delay. */
  until?: Until;
}

/** @internal */
export interface RateLimit {
  /**
   * time frame in minutes
   * @min 1
   */
  timeFrame?: number | null;
  /**
   * number of activations allowed in the given time frame
   * @min 1
   */
  activations?: number;
  /**
   * limit the activation by an entity, for example activate once per contact. example: {{contact.id}}
   * @minLength 1
   * @maxLength 300
   */
  uniqueIdentifierExpression?: string | null;
}

/** @internal */
export interface ActionCondition {
  /**
   * entity object is deprecated due to the new approach to conditions
   * the condition expression, for example - {{and(gt(price;10);lt(price;100))}}
   * @minLength 1
   * @maxLength 2000
   */
  conditionExpression?: string;
}

/** @internal */
export interface Conditions {
  /**
   * condition evaluates to `true` if either of the blocks evaluate to `true` (aka OR between all)
   * @minSize 1
   * @maxSize 10
   */
  conditionBlocks?: ConditionBlock[];
}

/** @internal */
export interface AutomationMetadata {
  /** Is this Automation hidden on a site? */
  hidden?: boolean;
  /** Can this Automation be deactivated on a site? */
  alwaysActive?: boolean;
  /** Is this Automation's scheduling modification is disabled on a site? */
  schedulingModificationDisabled?: boolean;
  /** Is the removal of this Automation's actions disabled? */
  actionRemovalDisabled?: boolean;
  /** Is conditions editing for this Automation allowed on a site? */
  actionConditionsEditingDisabled?: boolean;
  /**
   * Domain
   * @internal
   * @immutable
   */
  domain?: DomainWithLiterals;
}

/** @internal */
export enum Domain {
  /** User domain (default) */
  USER = 'USER',
  /** Wix domain */
  WIX = 'WIX',
}

/** @enumType */
/** @internal */
export type DomainWithLiterals = Domain | 'USER' | 'WIX';

/** @internal */
export enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** @enumType */
/** @internal */
export type StatusWithLiterals = Status | 'ACTIVE' | 'INACTIVE';

/** @internal */
export interface OriginInfo {
  /**
   * The id of the original automation used to create the preinstalled automation (v3/Builder only)
   * @format GUID
   */
  siteAutomationId?: string;
  /**
   * The site which the automation was originally created in (v3/Builder only)
   * @format GUID
   */
  metaSiteId?: string;
}

/** Back-office sidebar categories */
/** @internal */
export interface BackOfficeSidebarCategory {
  /**
   * Platform that hosts the modal.
   *
   * Must be `"BUSINESS_MANAGER"`.
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Category title.
   * @minLength 1
   */
  title?: string;
  /** Sidebar order within the app */
  priority?: number;
}

/** A page in one of the back-office platforms */
export interface BackOfficePage extends BackOfficePageAssetOneOf {
  /** @format WEB_URL */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
  /**
   * The platform this page is hosted on
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /** The route of the page, must be a valid URL path, relative to the app namespace or app id */
  routePath?: string;
  /** Routes that redirect to this page, these paths should include the original path including the namespace or app id */
  previousRoutePaths?: string[];
  /**
   * Page title, also used as sidebar entry label
   * @minLength 1
   */
  title?: string;
  /** False by default, if true, sidebar will be hidden when loading the page */
  fullPage?: boolean;
  /**
   * Required permission to view page. if subject is missing this permission, the page link will be hidden from the sidebar and a "no-permission-page" will be displayed when visiting the route
   * @internal
   */
  requiredPermission?: string;
  /**
   * Optional: category this page belongs to
   * @format GUID
   */
  pageCategoryId?: string | null;
  /** Should the page be shown or hidden in the sidebar, by default a link to the page will be shown */
  hideInSidebar?: boolean;
  /** Sidebar order within the category and app, lower priority means the page is earlier, by default priority is 0, meaning newer pages will appear first */
  priority?: number;
  /**
   * Which page is active in sidebar when this page is loaded
   * @format GUID
   */
  activeSidebarPageId?: string | null;
  /**
   * Sentry error reporting DSN
   * @internal
   */
  errorReporting?: ErrorReporting;
  /** general component data */
  metaData?: ComponentMetaData;
  /**
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * Anchors for direct navigation to specific sections of the page
   * @maxSize 50
   */
  pageAnchors?: PageAnchor[];
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /**
   * The exported name of the page route, used to reference this route externally.
   * @internal
   * @maxLength 100
   */
  exportedRouteName?: string | null;
  /**
   * Determines how the page layout is rendered.
   * Allowed values: "standard_view", "builder_view", "expanded_view", default: "standard_view".
   */
  layoutMode?: LayoutModeWithLiterals;
  /** whether the page supports mobile devices, default is false, meaning the page is redirected to native app */
  mobileCompatible?: boolean;
}

/** @oneof */
/** @internal */
export interface BackOfficePageAssetOneOf {
  /** @format WEB_URL */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
}

/** @internal */
export interface ComponentMetaData {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title?: string | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  description?: string | null;
  /**
   * Searchable keywords
   * @maxSize 100
   */
  keywords?: Keywords[];
  /** Is searchable */
  searchable?: boolean;
  aiContext?: AiContext;
}

/** @internal */
export interface Keywords {
  /** Keyword ID */
  id?: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  value?: string;
}

/** @internal */
export interface PageAnchor {
  /**
   * A URL path relative to the page route for direct navigation to a specific section
   * @minLength 1
   * @maxLength 100
   */
  relativeUrl?: string;
  /**
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /** metadata for the page anchor */
  metaData?: AnchorMetaData;
  /**
   * anchor ID
   * @maxLength 50
   */
  id?: string;
  /**
   * The exported name of the internal route, used to reference this route externally.
   * @internal
   * @maxLength 100
   */
  exportedRouteName?: string | null;
  /**
   * List of dynamic URL parameters
   * @internal
   * @maxSize 50
   */
  urlParams?: UrlParam[];
}

/** @internal */
export interface AnchorMetaData {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title?: string | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  description?: string | null;
  /**
   * anchor keywords
   * @maxSize 100
   */
  keywords?: Keywords[];
}

/** @internal */
export interface UrlParam {
  /**
   * The name of the parameter
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * The description of the parameter
   * @minLength 1
   * @maxLength 200
   */
  description?: string;
}

/** @internal */
export enum LayoutMode {
  STANDARD_VIEW = 'STANDARD_VIEW',
  BUILDER_VIEW = 'BUILDER_VIEW',
  EXPANDED_VIEW = 'EXPANDED_VIEW',
}

/** @enumType */
/** @internal */
export type LayoutModeWithLiterals =
  | LayoutMode
  | 'STANDARD_VIEW'
  | 'BUILDER_VIEW'
  | 'EXPANDED_VIEW';

export interface AdditionalFeesSPIConfig {
  /**
   * Base URI where the endpoints are called.
   * Wix eCommerce appends the endpoint path to the base URI.
   * For example, to call the Calculate Additional Fees endpoint at `https://my-additional-fees.com/v1/calculateAdditionalFees`,
   * the base URI you provide here is `https://my-additional-fees.com/`.
   */
  deploymentUri?: string;
  /**
   * Optional WQL filter to apply to the `CalculateAdditionalFeesRequest`.
   * When provided, only requests that match the filter will be forwarded to the implementer.
   *
   * Learn more about how to define a [WQL filter](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   * @internal
   */
  filter?: Record<string, any> | null;
}

/** Describes a notification that can be sent to users */
/** @internal */
export interface PingNotificationComponentData {
  /**
   * The ID of a specific version of the notification template.
   * @internal
   * @format GUID
   */
  templateId?: string;
}

export interface BookingsPricingProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
  /** User-friendly name of the pricing provider */
  pricingProviderName?: string;
}

/** @internal */
export interface AuthenticatorConfig {
  /** the base URI where all the methods are deployed. */
  baseUri?: string;
  /** Is the enrolment step required (eg. for saving the password, public key, etc.) */
  requireUserEnroll?: boolean;
  /** Information required during the enrollment and authentication processes */
  expectedInputs?: ExpectedInputs;
}

/** @internal */
export interface ExpectedInputs {
  /** Inputs that will be expected from the user at the start of the process of trying to enroll or authenticate */
  expectedStartInputs?: PredefinedExpectedInput[];
  /** Inputs that may be required during a second step of enroll/authenticate, specified at runtime by sending a Verify response */
  expectedVerifyInputs?: PredefinedExpectedInput[];
}

/**
 * Specifies an expected input that can be fully configured by the SPI implementor, perhaps with overrides by the admin, _before_ runtime.
 * Notably, this does not include WebAuthn, as that input requires a unique, random challenge to be generated and persisted per request (ie at runtime)
 * in order to be implemented correctly.
 */
/** @internal */
export interface PredefinedExpectedInput {
  /** The key used to identify the value entered into the input in the user_start_inputs or user_verify_inputs map */
  key?: string;
  /** The name of the input as it should be indicated to the user */
  displayName?: string;
  /** The configuration for the input */
  configuration?: PredefinedExpectedInputConfiguration;
}

/** @internal */
export interface PredefinedExpectedInputConfiguration
  extends PredefinedExpectedInputConfigurationTypeOneOf {
  textInput?: AdminConfigurableTextInput;
}

/** @oneof */
/** @internal */
export interface PredefinedExpectedInputConfigurationTypeOneOf {
  textInput?: AdminConfigurableTextInput;
}

/** @internal */
export interface AdminConfigurableTextInput {
  /** The default settings for the text input */
  defaultSettings?: TextInputSettings;
  /**
   * Settings that must be have non-null values.
   * This must be a subset of admin_configurable_settings.
   */
  requiredSettings?: string[];
  /**
   * Settings that the admin may override.
   * This must be a valid FieldMask with respect to TextFieldSettings as the root object.
   */
  adminConfigurableSettings?: string[];
}

/** @internal */
export interface TextInputSettings {
  /** The minimum length required for the user to enter */
  minLength?: number | null;
  /** The maximum length allowed for the user to enter */
  maxLength?: number | null;
  /** A regex that the text entered by the user must match */
  regex?: string | null;
  /** How should the field be displayed to the end user */
  displayType?: TextInputDisplayTypeWithLiterals;
}

/** @internal */
export enum TextInputDisplayType {
  /** A regular text field */
  TEXT = 'TEXT',
  /** A password field (where the text is hidden visually) */
  PASSWORD = 'PASSWORD',
  /** A field optimized for one time codes */
  CODE = 'CODE',
}

/** @enumType */
/** @internal */
export type TextInputDisplayTypeWithLiterals =
  | TextInputDisplayType
  | 'TEXT'
  | 'PASSWORD'
  | 'CODE';

/** @internal */
export interface IDPConnectionConfig {
  /** the base URI where all the methods are deployed. */
  baseUri?: string;
  /** Information required from the admin when he will install the app; */
  requiredConfig?: Record<string, string>;
}

/** @internal */
export interface ItemsSelectionProviderConfig {
  /**
   * Base URI which Wix calls to retrieve the selected items. For example, `"deploymentUri": "https://my-items.com"`.
   * @minLength 1
   */
  deploymentUri?: string;
  /**
   * A unique identifier for the provider.
   * @minLength 3
   * @maxLength 250
   */
  key?: string;
  /** Supported search parameters. */
  searchParams?: SearchParams;
  /** Display data such as provider name and icon. */
  contentData?: ContentData;
  /**
   * Optional additional step taken after the initial item selection.
   * @internal
   */
  additionalStepInfo?: AdditionalStepInfo;
  /**
   * An array of strings representing the Wix UI pages supported by your SPI implementation. If no tags are listed, Wix assumes that the implementation supports all eligible pages.
   * @maxSize 50
   */
  supportedTags?: TagWithLiterals[];
  /**
   * Optional create new item option, to define a widget that will be opened to create a new item
   * @internal
   */
  createNewItemInfo?: CreateNewItemInfo;
  /** Configuration settings for how the thumbnail is displayed. */
  itemThumbnail?: ItemThumbnail;
  /** Pagination Mode */
  paginationMode?: PaginationModeWithLiterals;
  /**
   * Additional fields associated with the provider
   * @internal
   * @maxSize 100
   */
  tagsOverrides?: TagOverridesEntry[];
  /** Optional render overrides for the provider. */
  renderOverrides?: RenderOverrides;
}

/** @internal */
export interface LearnMore {
  /**
   * The url of the learn more link. If you want a dynamic url according to the user locale, you can add {{locale}} variable within the string.
   * @maxLength 2048
   */
  url?: string;
  /**
   * Optional link label.
   * @maxLength 500
   */
  label?: string | null;
}

/** @internal */
export enum ThumbnailType {
  UNKNOWN_THUMBNAIL_TYPE = 'UNKNOWN_THUMBNAIL_TYPE',
  IMAGE = 'IMAGE',
  AVATAR = 'AVATAR',
}

/** @enumType */
/** @internal */
export type ThumbnailTypeWithLiterals =
  | ThumbnailType
  | 'UNKNOWN_THUMBNAIL_TYPE'
  | 'IMAGE'
  | 'AVATAR';

/** @internal */
export interface ImageConfig {
  shape?: ImageShapeWithLiterals;
}

/** @internal */
export enum ImageShape {
  UNKNOWN_SHAPE = 'UNKNOWN_SHAPE',
  /** Circle */
  CIRCLE = 'CIRCLE',
  /** Square */
  SQUARE = 'SQUARE',
  /** Rectangle */
  RECTANGLE = 'RECTANGLE',
}

/** @enumType */
/** @internal */
export type ImageShapeWithLiterals =
  | ImageShape
  | 'UNKNOWN_SHAPE'
  | 'CIRCLE'
  | 'SQUARE'
  | 'RECTANGLE';

/** @internal */
export interface AvatarConfig {
  shape?: AvatarShapeWithLiterals;
}

/** @internal */
export enum AvatarShape {
  UNKNOWN_SHAPE = 'UNKNOWN_SHAPE',
  /** Circle */
  CIRCLE = 'CIRCLE',
  /** Square */
  SQUARE = 'SQUARE',
}

/** @enumType */
/** @internal */
export type AvatarShapeWithLiterals =
  | AvatarShape
  | 'UNKNOWN_SHAPE'
  | 'CIRCLE'
  | 'SQUARE';

/** @internal */
export interface SearchField {
  /** Supported searchable fields. */
  key?: string;
  /**
   * Item description.
   * @minLength 1
   * @maxLength 100
   */
  description?: string;
}

/** @internal */
export interface FilterInfo extends FilterInfoOptionsOneOf {
  /** Static hardcoded options */
  staticOptions?: StaticFilterOptions;
  /** The filter options are items of another provider */
  providerOptions?: ProviderFilterOptions;
  /**
   * Key of the filter
   * @minLength 1
   * @maxLength 100
   */
  key?: string;
  /** Optional filter will be shown only for consumers with this tag. Only one filter is allowed per tag. */
  tag?: TagWithLiterals;
  /** The filter selection type. */
  selectionType?: FilterSelectionTypeWithLiterals;
  /** Filter options type. For now only static options are supported */
  optionsType?: FilterOptionsTypeWithLiterals;
  /**
   * Optional placeholder text to display on the filter
   * @maxLength 500
   */
  placeholder?: string | null;
}

/** @oneof */
/** @internal */
export interface FilterInfoOptionsOneOf {
  /** Static hardcoded options */
  staticOptions?: StaticFilterOptions;
  /** The filter options are items of another provider */
  providerOptions?: ProviderFilterOptions;
}

/** @internal */
export enum Tag {
  UNKNOWN_TAG = 'UNKNOWN_TAG',
  EMBEDDABLE = 'EMBEDDABLE',
  ECOM_EDIT_ORDER = 'ECOM_EDIT_ORDER',
  ECOM_CREATE_ORDER = 'ECOM_CREATE_ORDER',
  INBOX = 'INBOX',
  ECOM_CREATE_PAY_LINK = 'ECOM_CREATE_PAY_LINK',
  ECOM_DELIVERY_PROFILES = 'ECOM_DELIVERY_PROFILES',
  ADD_TO_CATEGORY = 'ADD_TO_CATEGORY',
  MY_BUSINESS = 'MY_BUSINESS',
  PIPELINE_LINKED_ENTITY = 'PIPELINE_LINKED_ENTITY',
  GET_PAID = 'GET_PAID',
  PIPELINE_CARD_CATALOG_ITEM = 'PIPELINE_CARD_CATALOG_ITEM',
  OWNER_CHECKOUT = 'OWNER_CHECKOUT',
  ECOM_PREVIEW_CHECKOUT = 'ECOM_PREVIEW_CHECKOUT',
  ALL_CATEGORIES = 'ALL_CATEGORIES',
}

/** @enumType */
/** @internal */
export type TagWithLiterals =
  | Tag
  | 'UNKNOWN_TAG'
  | 'EMBEDDABLE'
  | 'ECOM_EDIT_ORDER'
  | 'ECOM_CREATE_ORDER'
  | 'INBOX'
  | 'ECOM_CREATE_PAY_LINK'
  | 'ECOM_DELIVERY_PROFILES'
  | 'ADD_TO_CATEGORY'
  | 'MY_BUSINESS'
  | 'PIPELINE_LINKED_ENTITY'
  | 'GET_PAID'
  | 'PIPELINE_CARD_CATALOG_ITEM'
  | 'OWNER_CHECKOUT'
  | 'ECOM_PREVIEW_CHECKOUT'
  | 'ALL_CATEGORIES';

/** @internal */
export enum FilterSelectionType {
  UNKNOWN_SELECTION = 'UNKNOWN_SELECTION',
  /** Allow to select only a single item */
  SINGLE_SELECTION = 'SINGLE_SELECTION',
  /** Allow to select multiple items */
  MULTIPLE_SELECTION = 'MULTIPLE_SELECTION',
}

/** @enumType */
/** @internal */
export type FilterSelectionTypeWithLiterals =
  | FilterSelectionType
  | 'UNKNOWN_SELECTION'
  | 'SINGLE_SELECTION'
  | 'MULTIPLE_SELECTION';

/** @internal */
export enum FilterOptionsType {
  UNKNOWN_FILTER_OPTIONS = 'UNKNOWN_FILTER_OPTIONS',
  /** Static hardcoded options */
  STATIC = 'STATIC',
  PROVIDER = 'PROVIDER',
}

/** @enumType */
/** @internal */
export type FilterOptionsTypeWithLiterals =
  | FilterOptionsType
  | 'UNKNOWN_FILTER_OPTIONS'
  | 'STATIC'
  | 'PROVIDER';

/** @internal */
export interface StaticFilterOptions {
  /**
   * List of hardcoded options for a filter
   * @maxSize 50
   */
  data?: StaticFilterOption[];
}

/** @internal */
export interface StaticFilterOption {
  /**
   * Title of a filter option
   * @minLength 1
   * @maxLength 500
   */
  label?: string;
  /**
   * Value of a filter option
   * @minLength 1
   * @maxLength 100
   */
  value?: string;
}

/** @internal */
export interface ProviderFilterOptions {
  /**
   * Provider identifier for fetching filter options
   * @minLength 3
   * @maxLength 250
   */
  key?: string;
}

/** @internal */
export interface ContentDataOverrides {
  /**
   * Provider name.
   * @minLength 1
   * @maxLength 100
   */
  providerName?: string | null;
}

/** @internal */
export interface TagOverrides {
  /** Additional fields associated with the provider. */
  additionalFields?: Record<string, any> | null;
  /** Display data such as provider name. */
  contentData?: ContentDataOverrides;
}

/** @internal */
export interface SearchParams {
  /**
   * Supported search parameters.
   * @maxSize 50
   */
  fields?: SearchField[];
  /**
   * Filters for viewing only part of the items. Maximum one filter per tag.
   * @maxSize 100
   */
  filters?: FilterInfo[];
}

/** @internal */
export interface ContentData {
  /**
   * Provider icon. Choose an icon name from the [Wix Design System](https://www.wixdesignsystem.com/).
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * Provider name.
   * @minLength 1
   * @maxLength 100
   */
  providerName?: string;
  /**
   * Item title.
   * @minLength 1
   * @maxLength 100
   */
  title?: string;
  /**
   * Button label.
   * @minLength 1
   * @maxLength 50
   */
  button?: string;
  /**
   * Item description.
   * @minLength 1
   * @maxLength 100
   */
  subtitle?: string | null;
  /** Learn more link. */
  learnMore?: LearnMore;
}

/** @internal */
export interface AdditionalStepInfo {
  /** ID of the widget associated with the step. */
  widgetId?: string;
  /**
   * one app (mobile) component id that will be opened to show additional step
   * @internal
   * @minLength 1
   * @maxLength 50
   */
  mobileComponentId?: string | null;
  /**
   * Title of the additional step.
   * @minLength 1
   * @maxLength 100
   */
  title?: string;
  /**
   * Subtitle of the additional step.
   * @maxLength 100
   */
  subtitle?: string | null;
  /** Hide item note if exists when showing selected item on additional step header, default: false. */
  hideItemNote?: boolean | null;
}

/** @internal */
export interface CreateNewItemInfo {
  /** ID of the widget associated with the new item modal. */
  widgetId?: string;
  /**
   * one app (mobile) component id that will be opened to create a new item
   * @internal
   * @minLength 1
   * @maxLength 50
   */
  mobileComponentId?: string | null;
  /**
   * Button label for creating a new item
   * @minLength 1
   * @maxLength 50
   */
  buttonText?: string | null;
}

/** @internal */
export interface ItemThumbnail extends ItemThumbnailOptionsOneOf {
  /** Configuration specific to images. */
  imageConfig?: ImageConfig;
  /** Configuration specific to avatars. */
  avatarConfig?: AvatarConfig;
  /** Thumbnail type */
  type?: ThumbnailTypeWithLiterals;
  /** Whether the thumbnail is hidden from the UI. */
  hidden?: boolean | null;
}

/** @oneof */
/** @internal */
export interface ItemThumbnailOptionsOneOf {
  /** Configuration specific to images. */
  imageConfig?: ImageConfig;
  /** Configuration specific to avatars. */
  avatarConfig?: AvatarConfig;
}

/** @internal */
export enum PaginationMode {
  UNKNOWN_PAGINATION_MODE = 'UNKNOWN_PAGINATION_MODE',
  CURSOR = 'CURSOR',
  OFFSET = 'OFFSET',
}

/** @enumType */
/** @internal */
export type PaginationModeWithLiterals =
  | PaginationMode
  | 'UNKNOWN_PAGINATION_MODE'
  | 'CURSOR'
  | 'OFFSET';

/** @internal */
export interface TagOverridesEntry {
  /** The tag associated with the overrides. */
  tag?: TagWithLiterals;
  /** The overrides for the tag. */
  overrides?: TagOverrides;
}

/** @internal */
export interface RenderOverrides {
  /** Whether to hide the search bar in the picker UI */
  hideSearch?: boolean | null;
}

/** @internal */
export interface SyncedProjectsProviderConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: string;
  /**
   * The Provider Name
   * @maxLength 200
   */
  providerName?: string;
  /** which project's fields are synced by the provider, and therefore will not be editable through wix portfolio project page. */
  projectSyncedFields?: string[];
}

/** @internal */
export interface CommunicationChannelConfiguration {
  deploymentUri?: string;
  config?: ChannelConfiguration;
}

/** @internal */
export interface ChannelConfiguration
  extends ChannelConfigurationMessagingConfigOneOf {
  directMessageConfig?: DirectMessageConfig;
  emailMessageConfig?: EmailMessageConfig;
  smsMessageConfig?: SmsMessageConfig;
  /** The type of the communication channel */
  type?: ChannelTypeWithLiterals;
  /** Specific provider branding parameters for the channel */
  branding?: ChannelBranding;
  /** Conversation initiation definition */
  conversationLimitations?: ConversationLimitations;
}

/** @oneof */
/** @internal */
export interface ChannelConfigurationMessagingConfigOneOf {
  directMessageConfig?: DirectMessageConfig;
  emailMessageConfig?: EmailMessageConfig;
  smsMessageConfig?: SmsMessageConfig;
}

/** The type of the communication channel */
/** @internal */
export enum ChannelType {
  UNKNOWN_CHANNEL_TYPE = 'UNKNOWN_CHANNEL_TYPE',
  DIRECT_MESSAGING = 'DIRECT_MESSAGING',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

/** @enumType */
/** @internal */
export type ChannelTypeWithLiterals =
  | ChannelType
  | 'UNKNOWN_CHANNEL_TYPE'
  | 'DIRECT_MESSAGING'
  | 'EMAIL'
  | 'SMS';

/** @internal */
export interface DirectMessageConfig {
  /** When marked as true, there's no need to list the supported types explicitly */
  acceptAllMessageTypes?: boolean;
  /**
   * Direct message types accepted by the provider. only those types will be sent from Wix
   * If all are excepted this field can be left empty and there's no need to explicitly state types
   */
  acceptedMessageTypes?: AcceptedDirectMessageTypeWithLiterals[];
  /** Elaborates what media types (mime types) and sizes are supported */
  mediaCapabilities?: MediaCapabilities;
}

/** @internal */
export enum AcceptedDirectMessageType {
  TEXT = 'TEXT',
  MEDIA = 'MEDIA',
  CARD = 'CARD',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  FORM = 'FORM',
}

/** @enumType */
/** @internal */
export type AcceptedDirectMessageTypeWithLiterals =
  | AcceptedDirectMessageType
  | 'TEXT'
  | 'MEDIA'
  | 'CARD'
  | 'ANNOUNCEMENT'
  | 'FORM';

/** @internal */
export interface MediaCapabilities {
  /** When marked as true, there's no need to list the supported types explicitly */
  allMediaTypes?: boolean;
  /**
   * List for supported media types
   * If all are excepted this field can be left empty and there's no need to explicitly state types
   * @maxSize 50
   */
  supportedMediaTypes?: MediaMimeTypeWithLiterals[];
  /** Maximum file size in bytes of a single file in a message */
  maxFileSizeInBytes?: number | null;
}

/** Mime type for relevant media entities in channels */
/** @internal */
export enum MediaMimeType {
  UNKNOWN_MIME_TYPE = 'UNKNOWN_MIME_TYPE',
  IMAGE_JPEG = 'IMAGE_JPEG',
  IMAGE_PNG = 'IMAGE_PNG',
  IMAGE_WEBP = 'IMAGE_WEBP',
  VIDEO_MPEG = 'VIDEO_MPEG',
  VIDEO_MP4 = 'VIDEO_MP4',
  VIDEO_3GP = 'VIDEO_3GP',
  AUDIO_AAC = 'AUDIO_AAC',
  AUDIO_MP4 = 'AUDIO_MP4',
  AUDIO_MPEG = 'AUDIO_MPEG',
  AUDIO_OGG = 'AUDIO_OGG',
  AUDIO_OPUS = 'AUDIO_OPUS',
  APPLICATION_PDF = 'APPLICATION_PDF',
  APPLICATION_OCTET_STREAM = 'APPLICATION_OCTET_STREAM',
}

/** @enumType */
/** @internal */
export type MediaMimeTypeWithLiterals =
  | MediaMimeType
  | 'UNKNOWN_MIME_TYPE'
  | 'IMAGE_JPEG'
  | 'IMAGE_PNG'
  | 'IMAGE_WEBP'
  | 'VIDEO_MPEG'
  | 'VIDEO_MP4'
  | 'VIDEO_3GP'
  | 'AUDIO_AAC'
  | 'AUDIO_MP4'
  | 'AUDIO_MPEG'
  | 'AUDIO_OGG'
  | 'AUDIO_OPUS'
  | 'APPLICATION_PDF'
  | 'APPLICATION_OCTET_STREAM';

/** @internal */
export interface EmailMessageConfig {
  /** Media (Attachment) types accepted by the provider */
  mediaCapabilities?: MediaCapabilities;
  /** Maximum size in bytes of total media items in a message. */
  maxTotalFilesSizeInBytes?: number | null;
}

/** @internal */
export interface SmsMessageConfig {
  /** When marked as true, there's no need to list the supported types explicitly */
  acceptAllMessageTypes?: boolean;
  /** SMS message types accepted by the provider. only those types will be sent from Wix */
  acceptedMessageTypes?: AcceptedSmsMessageTypeWithLiterals[];
  /** Elaborates what media types (mime types) and sizes are supported */
  mediaCapabilities?: MediaCapabilities;
}

/** @internal */
export enum AcceptedSmsMessageType {
  SMS = 'SMS',
  MMS = 'MMS',
}

/** @enumType */
/** @internal */
export type AcceptedSmsMessageTypeWithLiterals =
  | AcceptedSmsMessageType
  | 'SMS'
  | 'MMS';

/** @internal */
export interface ChannelBranding {
  /** The name of the channel, e.g. `Facebook` / `SMS` */
  displayName?: string;
  /** Name of the channel provider (Wix, Meta, Google) */
  providerName?: string | null;
  /** Relevant brand icons, used when the channel is integrated */
  brandIcons?: BrandIcons;
}

/**
 * Brand icons required for correct channel integration
 * todo: 1. which ones are required ?
 * todo: 2. we may need to specify Icons specs (i.e. format and sizes)
 */
/** @internal */
export interface BrandIcons {
  default?: ChannelIcon;
  vector?: ChannelIcon;
  bwOutlineVector?: ChannelIcon;
}

/** @internal */
export interface ChannelIcon {
  /** Specific Icon url */
  url?: string | null;
}

/** @internal */
export interface ConversationLimitations {
  /**
   * Defines who can initiate conversation in this channel.
   * If, `CUSTOMER` is selected, this means that only inbound
   * messages can start a conversation (aka business can only reply and not initiate the first communication).
   */
  initDirection?: InitDirectionWithLiterals;
}

/** @internal */
export enum InitDirection {
  UNKNOWN_INIT_DIRECTION = 'UNKNOWN_INIT_DIRECTION',
  BUSINESS = 'BUSINESS',
  CUSTOMER = 'CUSTOMER',
  BOTH = 'BOTH',
}

/** @enumType */
/** @internal */
export type InitDirectionWithLiterals =
  | InitDirection
  | 'UNKNOWN_INIT_DIRECTION'
  | 'BUSINESS'
  | 'CUSTOMER'
  | 'BOTH';

/** @internal */
export interface PostLoginConfig {
  /** the base URI where all the methods are deployed. */
  baseUri?: string;
}

/** A general widget in one of the back-office platforms */
/** @internal */
export interface BackOfficeWidget extends BackOfficeWidgetContentOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
  /**
   * Platform that hosts the widget.
   *
   * Must be `"BUSINESS_MANAGER"`.
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Widget title.
   * @minLength 1
   */
  title?: string;
  /**
   * Required permission to view this widget
   * @internal
   */
  requiredPermission?: string;
  /**
   * Sentry error reporting DSN
   * @internal
   */
  errorReporting?: ErrorReporting;
  /**
   * Initial width of the widget while loading, in pixels.
   * Width may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @max 9999
   */
  width?: number | null;
  /**
   * Initial height of the widget while loading, in pixels.
   * Height may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @max 9999
   */
  height?: number | null;
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /** Context consumed by AI-powered features */
  aiContext?: AiContext;
}

/** @oneof */
/** @internal */
export interface BackOfficeWidgetContentOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
}

/** @internal */
export interface SocialMarketingDesignSPIConfig {
  /** The URL of the SPI implementation */
  baseUri?: string;
  /** ID of the provider */
  id?: string;
  /** Name of the provider */
  name?: string;
  /**
   * URL of the editor
   * @format WEB_URL
   */
  editorUrl?: string;
  /**
   * URL of the templates page
   * @format WEB_URL
   */
  templatesPageUrl?: string;
  /**
   * Provider's icon, to be displayed in UI
   * @format WEB_URL
   */
  iconUrl?: string;
}

/** @internal */
export interface FormSubmissionSpiConfig {
  /**
   * URI where the SPI Implementer is deployed
   * @maxLength 500
   */
  deploymentUri?: string;
  /**
   * Configuration of namespaces known by implementer
   * @maxSize 3
   */
  namespaceConfigs?: FormsSubmissionsNamespaceConfig[];
}

/** @internal */
export interface FormsSubmissionsNamespaceConfig {
  /**
   * Namespace name.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /** Permissions associated with this namespace. */
  permissions?: SubmissionPermissions;
  /** Mark new submission as pending by default. */
  pendingByDefault?: boolean;
  /**
   * Allows to disable automatic contact insert/update on contact mapping provided.
   * On manual contact mapping enabled, the implementer is responsible for mapping the submission to a contact.
   * Out of the box GDPR support is not available for unmapped submissions with contact PII fields.
   */
  manualContactMapping?: boolean;
  /**
   * Delete a PENDING submission after X days.
   * @min 1
   */
  deletePendingAfterDays?: number | null;
  /** Sets a flag that indicates a submission, when exporting, should have signature as image instead of text. */
  exportSignatureAsImage?: boolean;
  /** If set to true, will index submissions with filterable fields that can be used in search. */
  enableSearchFilters?: boolean;
}

/** @internal */
export interface SubmissionPermissions {
  /**
   * Name of the permission required to create new submission.
   * @maxLength 200
   */
  create?: string;
  /**
   * Name of the permission required to delete existing submission.
   * @maxLength 200
   */
  delete?: string;
  /**
   * Name of the permission required to update existing submission.
   * @maxLength 200
   */
  update?: string;
  /**
   * Name of the permission required to read and view submission.
   * @maxLength 200
   */
  read?: string;
  /**
   * Name of the permission required to read PII data of the submission.
   * If not specified, no additional permission check is performed, and PII data is returned if the user has permission to read.
   * @maxLength 200
   */
  readPii?: string | null;
}

/** Redirects to either a page component in the Business Manager or to a wix answers article */
/** @internal */
export interface WixOfferingComponentData
  extends WixOfferingComponentDataOfferingOneOf {
  /** Redirects to a page in the Business Manager. */
  businessManagerPage?: BusinessManagerPage;
  /**
   * Redirects to an article with this ID.
   * @format GUID
   */
  articleGuid?: string;
}

/** @oneof */
/** @internal */
export interface WixOfferingComponentDataOfferingOneOf {
  /** Redirects to a page in the Business Manager. */
  businessManagerPage?: BusinessManagerPage;
  /**
   * Redirects to an article with this ID.
   * @format GUID
   */
  articleGuid?: string;
}

/** @internal */
export interface BusinessManagerPage {
  /** ID of the page component to redirect to. */
  componentId?: string;
  /** Redirects to this app state. */
  appState?: string | null;
  /** Whether to show the regular app page in the App Market instead of redirecting to the Business Manager page. */
  showRegularAppPage?: boolean;
}

/** A component used for testing dev center functionality */
/** @internal */
export interface DevCenterTestingComponentData
  extends DevCenterTestingComponentDataTranslatableOneOfOneOf {
  translatableString?: string;
  translatableOptionalString?: string | null;
  translatableMessageInOneOf?: MessageContainingTranslatables;
  /** Non translatable field */
  nonTranslatable?: string;
  name?: string;
  /** @maxLength 500 */
  description?: string | null;
  translationsMap?: Record<string, string>;
  translatableMessage?: MessageContainingTranslatables;
  /** @maxSize 500 */
  mapOfTranslatableMessages?: Record<string, MessageContainingTranslatables>;
  baseUri?: string;
  /** @format GUID */
  referenceId?: string | null;
  referenceData?: CustomRefData;
  priceMultiplier?: number;
  responsePrefix?: string;
  /** @maxSize 500 */
  translatedMessagesWithUniqueField?: TranslatedMessageWithUniqueFieldRepeated[];
  /** @maxSize 500 */
  translatedMessagesWithIdField?: TranslatedMessageWithIdRepeated[];
  componentMetadata?: DiscoveryMetaData;
  /** @maxSize 500 */
  repeatedComponentMetadata?: DiscoveryMetaData[];
  /** @maxSize 500 */
  repeatedInternalComponentMetadata?: InternalComponentMetadata[];
  translatableRichContent?: RichContent;
  nonTranslatableRichContent?: RichContent;
  richContentMap?: Record<string, RichContent>;
  exposure?: ExtensionExposure;
  /**
   * @maxSize 500
   * @maxLength 500
   */
  referencedEntity?: string[];
  testEnum?: TestEnumWithLiterals;
}

/** @oneof */
/** @internal */
export interface DevCenterTestingComponentDataTranslatableOneOfOneOf {
  translatableString?: string;
  translatableOptionalString?: string | null;
  translatableMessageInOneOf?: MessageContainingTranslatables;
}

/** @internal */
export interface MessageContainingTranslatables {
  messageName?: string;
  messageDescription?: string | null;
  messageTranslationsMap?: Record<string, string>;
  innerTranslatableRichContent?: RichContent;
}

/** @internal */
export interface RichContent {
  /** Node objects representing a rich content document. */
  nodes?: Node[];
  /** Object metadata. */
  metadata?: V1Metadata;
  /** Global styling for header, paragraph, block quote, and code block nodes in the object. */
  documentStyle?: DocumentStyle;
}

/** @internal */
export interface Node extends NodeDataOneOf {
  /** Data for a button node. */
  buttonData?: ButtonData;
  /** Data for a code block node. */
  codeBlockData?: CodeBlockData;
  /** Data for a divider node. */
  dividerData?: DividerData;
  /** Data for a file node. */
  fileData?: FileData;
  /** Data for a gallery node. */
  galleryData?: GalleryData;
  /** Data for a GIF node. */
  gifData?: GIFData;
  /** Data for a heading node. */
  headingData?: HeadingData;
  /** Data for an embedded HTML node. */
  htmlData?: HTMLData;
  /** Data for an image node. */
  imageData?: ImageData;
  /** Data for a link preview node. */
  linkPreviewData?: LinkPreviewData;
  /** @deprecated */
  mapData?: MapData;
  /** Data for a paragraph node. */
  paragraphData?: ParagraphData;
  /** Data for a poll node. */
  pollData?: PollData;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: TextData;
  /** Data for an app embed node. */
  appEmbedData?: AppEmbedData;
  /** Data for a video node. */
  videoData?: VideoData;
  /** Data for an oEmbed node. */
  embedData?: EmbedData;
  /** Data for a collapsible list node. */
  collapsibleListData?: CollapsibleListData;
  /** Data for a table node. */
  tableData?: TableData;
  /** Data for a table cell node. */
  tableCellData?: TableCellData;
  /** Data for a custom external node. */
  externalData?: Record<string, any> | null;
  /** Data for an audio node. */
  audioData?: AudioData;
  /** Data for an ordered list node. */
  orderedListData?: OrderedListData;
  /** Data for a bulleted list node. */
  bulletedListData?: BulletedListData;
  /** Data for a block quote node. */
  blockquoteData?: BlockquoteData;
  /** Data for a caption node. */
  captionData?: CaptionData;
  /** Data for a layout node. Reserved for future use. */
  layoutData?: LayoutData;
  /** Data for a cell node. */
  layoutCellData?: LayoutCellData;
  /** Data for a shape node. */
  shapeData?: ShapeData;
  /** Data for a card node. */
  cardData?: CardData;
  /** Data for a table of contents node. */
  tocData?: TocData;
  /** Data for a smart block node. */
  smartBlockData?: SmartBlockData;
  /** Data for a smart block cell node. */
  smartBlockCellData?: SmartBlockCellData;
  /** Data for a checkbox list node. */
  checkboxListData?: CheckboxListData;
  /** Data for a list item node. */
  listItemData?: ListItemNodeData;
  /** Node type. Use `APP_EMBED` for nodes that embed content from other Wix apps. Use `EMBED` to embed content in [oEmbed](https://oembed.com/) format. */
  type?: NodeTypeWithLiterals;
  /** Node ID. */
  id?: string;
  /** A list of child nodes. */
  nodes?: Node[];
  /** Padding and background color styling for the node. */
  style?: NodeStyle;
}

/** @oneof */
/** @internal */
export interface NodeDataOneOf {
  /** Data for a button node. */
  buttonData?: ButtonData;
  /** Data for a code block node. */
  codeBlockData?: CodeBlockData;
  /** Data for a divider node. */
  dividerData?: DividerData;
  /** Data for a file node. */
  fileData?: FileData;
  /** Data for a gallery node. */
  galleryData?: GalleryData;
  /** Data for a GIF node. */
  gifData?: GIFData;
  /** Data for a heading node. */
  headingData?: HeadingData;
  /** Data for an embedded HTML node. */
  htmlData?: HTMLData;
  /** Data for an image node. */
  imageData?: ImageData;
  /** Data for a link preview node. */
  linkPreviewData?: LinkPreviewData;
  /** @deprecated */
  mapData?: MapData;
  /** Data for a paragraph node. */
  paragraphData?: ParagraphData;
  /** Data for a poll node. */
  pollData?: PollData;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: TextData;
  /** Data for an app embed node. */
  appEmbedData?: AppEmbedData;
  /** Data for a video node. */
  videoData?: VideoData;
  /** Data for an oEmbed node. */
  embedData?: EmbedData;
  /** Data for a collapsible list node. */
  collapsibleListData?: CollapsibleListData;
  /** Data for a table node. */
  tableData?: TableData;
  /** Data for a table cell node. */
  tableCellData?: TableCellData;
  /** Data for a custom external node. */
  externalData?: Record<string, any> | null;
  /** Data for an audio node. */
  audioData?: AudioData;
  /** Data for an ordered list node. */
  orderedListData?: OrderedListData;
  /** Data for a bulleted list node. */
  bulletedListData?: BulletedListData;
  /** Data for a block quote node. */
  blockquoteData?: BlockquoteData;
  /** Data for a caption node. */
  captionData?: CaptionData;
  /** Data for a layout node. Reserved for future use. */
  layoutData?: LayoutData;
  /** Data for a cell node. */
  layoutCellData?: LayoutCellData;
  /** Data for a shape node. */
  shapeData?: ShapeData;
  /** Data for a card node. */
  cardData?: CardData;
  /** Data for a table of contents node. */
  tocData?: TocData;
  /** Data for a smart block node. */
  smartBlockData?: SmartBlockData;
  /** Data for a smart block cell node. */
  smartBlockCellData?: SmartBlockCellData;
  /** Data for a checkbox list node. */
  checkboxListData?: CheckboxListData;
  /** Data for a list item node. */
  listItemData?: ListItemNodeData;
}

/** @internal */
export enum NodeType {
  PARAGRAPH = 'PARAGRAPH',
  TEXT = 'TEXT',
  HEADING = 'HEADING',
  BULLETED_LIST = 'BULLETED_LIST',
  ORDERED_LIST = 'ORDERED_LIST',
  LIST_ITEM = 'LIST_ITEM',
  BLOCKQUOTE = 'BLOCKQUOTE',
  CODE_BLOCK = 'CODE_BLOCK',
  VIDEO = 'VIDEO',
  DIVIDER = 'DIVIDER',
  FILE = 'FILE',
  GALLERY = 'GALLERY',
  GIF = 'GIF',
  HTML = 'HTML',
  IMAGE = 'IMAGE',
  LINK_PREVIEW = 'LINK_PREVIEW',
  /** @deprecated */
  MAP = 'MAP',
  POLL = 'POLL',
  APP_EMBED = 'APP_EMBED',
  BUTTON = 'BUTTON',
  COLLAPSIBLE_LIST = 'COLLAPSIBLE_LIST',
  TABLE = 'TABLE',
  EMBED = 'EMBED',
  COLLAPSIBLE_ITEM = 'COLLAPSIBLE_ITEM',
  COLLAPSIBLE_ITEM_TITLE = 'COLLAPSIBLE_ITEM_TITLE',
  COLLAPSIBLE_ITEM_BODY = 'COLLAPSIBLE_ITEM_BODY',
  TABLE_CELL = 'TABLE_CELL',
  TABLE_ROW = 'TABLE_ROW',
  EXTERNAL = 'EXTERNAL',
  AUDIO = 'AUDIO',
  CAPTION = 'CAPTION',
  LAYOUT = 'LAYOUT',
  LAYOUT_CELL = 'LAYOUT_CELL',
  SHAPE = 'SHAPE',
  CARD = 'CARD',
  TOC = 'TOC',
  SMART_BLOCK = 'SMART_BLOCK',
  SMART_BLOCK_CELL = 'SMART_BLOCK_CELL',
  CHECKBOX_LIST = 'CHECKBOX_LIST',
}

/** @enumType */
/** @internal */
export type NodeTypeWithLiterals =
  | NodeType
  | 'PARAGRAPH'
  | 'TEXT'
  | 'HEADING'
  | 'BULLETED_LIST'
  | 'ORDERED_LIST'
  | 'LIST_ITEM'
  | 'BLOCKQUOTE'
  | 'CODE_BLOCK'
  | 'VIDEO'
  | 'DIVIDER'
  | 'FILE'
  | 'GALLERY'
  | 'GIF'
  | 'HTML'
  | 'IMAGE'
  | 'LINK_PREVIEW'
  | 'MAP'
  | 'POLL'
  | 'APP_EMBED'
  | 'BUTTON'
  | 'COLLAPSIBLE_LIST'
  | 'TABLE'
  | 'EMBED'
  | 'COLLAPSIBLE_ITEM'
  | 'COLLAPSIBLE_ITEM_TITLE'
  | 'COLLAPSIBLE_ITEM_BODY'
  | 'TABLE_CELL'
  | 'TABLE_ROW'
  | 'EXTERNAL'
  | 'AUDIO'
  | 'CAPTION'
  | 'LAYOUT'
  | 'LAYOUT_CELL'
  | 'SHAPE'
  | 'CARD'
  | 'TOC'
  | 'SMART_BLOCK'
  | 'SMART_BLOCK_CELL'
  | 'CHECKBOX_LIST';

/** @internal */
export interface NodeStyle {
  /** The top padding value in pixels. */
  paddingTop?: string | null;
  /** The bottom padding value in pixels. */
  paddingBottom?: string | null;
  /** The background color as a hexadecimal value. */
  backgroundColor?: string | null;
}

/** @internal */
export interface ButtonData {
  /** Styling for the button's container. */
  containerData?: PluginContainerData;
  /** The button type. */
  type?: ButtonDataTypeWithLiterals;
  /** Styling for the button. */
  styles?: Styles;
  /** The text to display on the button. */
  text?: string | null;
  /** Button link details. */
  link?: V1Link;
}

/** Background type */
/** @internal */
export enum BackgroundType {
  /** Solid color background */
  COLOR = 'COLOR',
  /** Gradient background */
  GRADIENT = 'GRADIENT',
}

/** @enumType */
/** @internal */
export type BackgroundTypeWithLiterals = BackgroundType | 'COLOR' | 'GRADIENT';

/** @internal */
export interface Gradient {
  /** Gradient type. */
  type?: GradientTypeWithLiterals;
  /**
   * Color stops for the gradient.
   * @maxSize 1000
   */
  stops?: Stop[];
  /** Angle in degrees for linear gradient (0-360). */
  angle?: number | null;
  /**
   * Horizontal center position for radial gradient (0-100).
   * @max 100
   */
  centerX?: number | null;
  /**
   * Vertical center position for radial gradient (0-100).
   * @max 100
   */
  centerY?: number | null;
}

/** Gradient type. */
/** @internal */
export enum GradientType {
  /** Linear gradient. */
  LINEAR = 'LINEAR',
  /** Radial gradient. */
  RADIAL = 'RADIAL',
}

/** @enumType */
/** @internal */
export type GradientTypeWithLiterals = GradientType | 'LINEAR' | 'RADIAL';

/** A single color stop in the gradient. */
/** @internal */
export interface Stop {
  /**
   * Stop color as hex value.
   * @maxLength 19
   */
  color?: string | null;
  /** Stop position (0-1). */
  position?: number | null;
}

/** @internal */
export interface StylesBorder {
  /**
   * Deprecated: Use `borderWidth` in `styles` instead.
   * @deprecated
   */
  width?: number | null;
  /**
   * Deprecated: Use `borderRadius` in `styles` instead.
   * @deprecated
   */
  radius?: number | null;
}

/** @internal */
export interface Colors {
  /**
   * Deprecated: Use `textColor` in `styles` instead.
   * @deprecated
   */
  text?: string | null;
  /**
   * Deprecated: Use `borderColor` in `styles` instead.
   * @deprecated
   */
  border?: string | null;
  /**
   * Deprecated: Use `backgroundColor` in `styles` instead.
   * @deprecated
   */
  background?: string | null;
}

/** Background styling (color or gradient) */
/** @internal */
export interface StylesBackground {
  /** Background type. */
  type?: BackgroundTypeWithLiterals;
  /**
   * Background color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Gradient configuration. */
  gradient?: Gradient;
}

/** @internal */
export interface PluginContainerData {
  /** The width of the node when it's displayed. */
  width?: PluginContainerDataWidth;
  /** The node's alignment within its container. */
  alignment?: PluginContainerDataAlignmentWithLiterals;
  /** Spoiler cover settings for the node. */
  spoiler?: Spoiler;
  /** The height of the node when it's displayed. */
  height?: PluginContainerDataHeight;
  /** Sets whether text should wrap around this node when it's displayed. If `textWrap` is `false`, the node takes up the width of its container. Defaults to `true` for all node types except 'DIVIVDER' where it defaults to `false`. */
  textWrap?: boolean | null;
}

/** @internal */
export enum WidthType {
  /** Width matches the content width */
  CONTENT = 'CONTENT',
  /** Small Width */
  SMALL = 'SMALL',
  /** Width will match the original asset width */
  ORIGINAL = 'ORIGINAL',
  /** coast-to-coast display */
  FULL_WIDTH = 'FULL_WIDTH',
}

/** @enumType */
/** @internal */
export type WidthTypeWithLiterals =
  | WidthType
  | 'CONTENT'
  | 'SMALL'
  | 'ORIGINAL'
  | 'FULL_WIDTH';

/** @internal */
export interface PluginContainerDataWidth
  extends PluginContainerDataWidthDataOneOf {
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: WidthTypeWithLiterals;
  /** A custom width value in pixels. */
  custom?: string | null;
}

/** @oneof */
/** @internal */
export interface PluginContainerDataWidthDataOneOf {
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: WidthTypeWithLiterals;
  /** A custom width value in pixels. */
  custom?: string | null;
}

/** @internal */
export enum PluginContainerDataAlignment {
  /** Center Alignment */
  CENTER = 'CENTER',
  /** Left Alignment */
  LEFT = 'LEFT',
  /** Right Alignment */
  RIGHT = 'RIGHT',
}

/** @enumType */
/** @internal */
export type PluginContainerDataAlignmentWithLiterals =
  | PluginContainerDataAlignment
  | 'CENTER'
  | 'LEFT'
  | 'RIGHT';

/** @internal */
export interface Spoiler {
  /** Sets whether the spoiler cover is enabled for this node. Defaults to `false`. */
  enabled?: boolean | null;
  /** The description displayed on top of the spoiler cover. */
  description?: string | null;
  /** The text for the button used to remove the spoiler cover. */
  buttonText?: string | null;
}

/** @internal */
export interface PluginContainerDataHeight {
  /** A custom height value in pixels. */
  custom?: string | null;
}

/** @internal */
export enum ButtonDataType {
  /** Regular link button */
  LINK = 'LINK',
  /** Triggers custom action that is defined in plugin configuration by the consumer */
  ACTION = 'ACTION',
}

/** @enumType */
/** @internal */
export type ButtonDataTypeWithLiterals = ButtonDataType | 'LINK' | 'ACTION';

/** @internal */
export interface Styles {
  /**
   * Deprecated: Use `borderWidth` and `borderRadius` instead.
   * @deprecated
   */
  border?: StylesBorder;
  /**
   * Deprecated: Use `textColor`, `borderColor` and `backgroundColor` instead.
   * @deprecated
   */
  colors?: Colors;
  /** Border width in pixels. */
  borderWidth?: number | null;
  /**
   * Deprecated: Use `borderWidth` for normal/hover states instead.
   * @deprecated
   */
  borderWidthHover?: number | null;
  /** Border radius in pixels. */
  borderRadius?: number | null;
  /**
   * Border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /**
   * Border color as a hexadecimal value (hover state).
   * @maxLength 19
   */
  borderColorHover?: string | null;
  /**
   * Text color as a hexadecimal value.
   * @maxLength 19
   */
  textColor?: string | null;
  /**
   * Text color as a hexadecimal value (hover state).
   * @maxLength 19
   */
  textColorHover?: string | null;
  /**
   * Deprecated: Use `background` instead.
   * @maxLength 19
   * @deprecated
   */
  backgroundColor?: string | null;
  /**
   * Deprecated: Use `backgroundHover` instead.
   * @maxLength 19
   * @deprecated
   */
  backgroundColorHover?: string | null;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: string | null;
  /** Background styling (color or gradient). */
  background?: StylesBackground;
  /** Background styling for hover state (color or gradient). */
  backgroundHover?: StylesBackground;
}

/** @internal */
export interface V1Link extends V1LinkDataOneOf {
  /** The absolute URL for the linked document. */
  url?: string;
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: string;
  /**
   * he HTML `target` attribute value for the link. This property defines where the linked document opens as follows:
   * `SELF` - Default. Opens the linked document in the same frame as the link.
   * `BLANK` - Opens the linked document in a new browser tab or window.
   * `PARENT` - Opens the linked document in the link's parent frame.
   * `TOP` - Opens the linked document in the full body of the link's browser tab or window.
   */
  target?: LinkTargetWithLiterals;
  /** The HTML `rel` attribute value for the link. This object specifies the relationship between the current document and the linked document. */
  rel?: Rel;
  /** A serialized object used for a custom or external link panel. */
  customData?: string | null;
}

/** @oneof */
/** @internal */
export interface V1LinkDataOneOf {
  /** The absolute URL for the linked document. */
  url?: string;
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: string;
}

/** @internal */
export enum LinkTarget {
  /** Opens the linked document in the same frame as it was clicked (this is default) */
  SELF = 'SELF',
  /** Opens the linked document in a new window or tab */
  BLANK = 'BLANK',
  /** Opens the linked document in the parent frame */
  PARENT = 'PARENT',
  /** Opens the linked document in the full body of the window */
  TOP = 'TOP',
}

/** @enumType */
/** @internal */
export type LinkTargetWithLiterals =
  | LinkTarget
  | 'SELF'
  | 'BLANK'
  | 'PARENT'
  | 'TOP';

/** @internal */
export interface Rel {
  /** Indicates to search engine crawlers not to follow the link. Defaults to `false`. */
  nofollow?: boolean | null;
  /** Indicates to search engine crawlers that the link is a paid placement such as sponsored content or an advertisement. Defaults to `false`. */
  sponsored?: boolean | null;
  /** Indicates that this link is user-generated content and isn't necessarily trusted or endorsed by the page’s author. For example, a link in a fourm post. Defaults to `false`. */
  ugc?: boolean | null;
  /** Indicates that this link protect referral information from being passed to the target website. */
  noreferrer?: boolean | null;
}

/** @internal */
export interface CodeBlockData {
  /** Styling for the code block's text. */
  textStyle?: V1TextStyle;
}

/** @internal */
export interface V1TextStyle {
  /** Text alignment. Defaults to `AUTO`. */
  textAlignment?: TextAlignmentWithLiterals;
  /** A CSS `line-height` value for the text expressed as a ratio relative to the font size. For example, if the font size is 20px, a `lineHeight` value of `'1.5'`` results in a line height of 30px. */
  lineHeight?: string | null;
}

/** @internal */
export enum TextAlignment {
  /** browser default, eqivalent to `initial` */
  AUTO = 'AUTO',
  /** Left align */
  LEFT = 'LEFT',
  /** Right align */
  RIGHT = 'RIGHT',
  /** Center align */
  CENTER = 'CENTER',
  /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
  JUSTIFY = 'JUSTIFY',
}

/** @enumType */
/** @internal */
export type TextAlignmentWithLiterals =
  | TextAlignment
  | 'AUTO'
  | 'LEFT'
  | 'RIGHT'
  | 'CENTER'
  | 'JUSTIFY';

/** @internal */
export interface DividerData {
  /** Styling for the divider's container. */
  containerData?: PluginContainerData;
  /** Divider line style. */
  lineStyle?: LineStyleWithLiterals;
  /** Divider width. */
  width?: DividerDataWidthWithLiterals;
  /** Divider alignment. */
  alignment?: DividerDataAlignmentWithLiterals;
}

/** @internal */
export enum LineStyle {
  /** Single Line */
  SINGLE = 'SINGLE',
  /** Double Line */
  DOUBLE = 'DOUBLE',
  /** Dashed Line */
  DASHED = 'DASHED',
  /** Dotted Line */
  DOTTED = 'DOTTED',
}

/** @enumType */
/** @internal */
export type LineStyleWithLiterals =
  | LineStyle
  | 'SINGLE'
  | 'DOUBLE'
  | 'DASHED'
  | 'DOTTED';

/** @internal */
export enum DividerDataWidth {
  /** Large line */
  LARGE = 'LARGE',
  /** Medium line */
  MEDIUM = 'MEDIUM',
  /** Small line */
  SMALL = 'SMALL',
}

/** @enumType */
/** @internal */
export type DividerDataWidthWithLiterals =
  | DividerDataWidth
  | 'LARGE'
  | 'MEDIUM'
  | 'SMALL';

/** @internal */
export enum DividerDataAlignment {
  /** Center alignment */
  CENTER = 'CENTER',
  /** Left alignment */
  LEFT = 'LEFT',
  /** Right alignment */
  RIGHT = 'RIGHT',
}

/** @enumType */
/** @internal */
export type DividerDataAlignmentWithLiterals =
  | DividerDataAlignment
  | 'CENTER'
  | 'LEFT'
  | 'RIGHT';

/** @internal */
export interface FileData {
  /** Styling for the file's container. */
  containerData?: PluginContainerData;
  /** The source for the file's data. */
  src?: FileSource;
  /** File name. */
  name?: string | null;
  /** File type. */
  type?: string | null;
  /**
   * Use `sizeInKb` instead.
   * @deprecated
   */
  size?: number | null;
  /** Settings for PDF files. */
  pdfSettings?: PDFSettings;
  /** File MIME type. */
  mimeType?: string | null;
  /** File path. */
  path?: string | null;
  /** File size in KB. */
  sizeInKb?: string | null;
}

/** @internal */
export enum PDFSettingsViewMode {
  /** No PDF view */
  NONE = 'NONE',
  /** Full PDF view */
  FULL = 'FULL',
  /** Mini PDF view */
  MINI = 'MINI',
}

/** @enumType */
/** @internal */
export type PDFSettingsViewModeWithLiterals =
  | PDFSettingsViewMode
  | 'NONE'
  | 'FULL'
  | 'MINI';

/** @internal */
export interface FileSource extends FileSourceDataOneOf {
  /** The absolute URL for the file's source. */
  url?: string | null;
  /**
   * Custom ID. Use `id` instead.
   * @deprecated
   */
  custom?: string | null;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: string | null;
  /** Indicates whether the file's source is private. Defaults to `false`. */
  private?: boolean | null;
}

/** @oneof */
/** @internal */
export interface FileSourceDataOneOf {
  /** The absolute URL for the file's source. */
  url?: string | null;
  /**
   * Custom ID. Use `id` instead.
   * @deprecated
   */
  custom?: string | null;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: string | null;
}

/** @internal */
export interface PDFSettings {
  /**
   * PDF view mode. One of the following:
   * `NONE` : The PDF isn't displayed.
   * `FULL` : A full page view of the PDF is displayed.
   * `MINI` : A mini view of the PDF is displayed.
   */
  viewMode?: PDFSettingsViewModeWithLiterals;
  /** Sets whether the PDF download button is disabled. Defaults to `false`. */
  disableDownload?: boolean | null;
  /** Sets whether the PDF print button is disabled. Defaults to `false`. */
  disablePrint?: boolean | null;
}

/** @internal */
export interface GalleryData {
  /** Styling for the gallery's container. */
  containerData?: PluginContainerData;
  /** The items in the gallery. */
  items?: Item[];
  /** Options for defining the gallery's appearance. */
  options?: GalleryOptions;
  /** Sets whether the gallery's expand button is disabled. Defaults to `false`. */
  disableExpand?: boolean | null;
  /** Sets whether the gallery's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean | null;
}

/** @internal */
export interface Media {
  /** The source for the media's data. */
  src?: FileSource;
  /** Media width in pixels. */
  width?: number | null;
  /** Media height in pixels. */
  height?: number | null;
  /** Media duration in seconds. Only relevant for audio and video files. */
  duration?: number | null;
}

/** @internal */
export interface ItemImage {
  /** Image file details. */
  media?: Media;
  /** Link details for images that are links. */
  link?: V1Link;
}

/** @internal */
export interface ItemVideo {
  /** Video file details. */
  media?: Media;
  /** Video thumbnail file details. */
  thumbnail?: Media;
}

/** @internal */
export interface Item extends ItemDataOneOf {
  /** An image item. */
  image?: ItemImage;
  /** A video item. */
  video?: ItemVideo;
  /** Item title. */
  title?: string | null;
  /** Item's alternative text. */
  altText?: string | null;
}

/** @oneof */
/** @internal */
export interface ItemDataOneOf {
  /** An image item. */
  image?: ItemImage;
  /** A video item. */
  video?: ItemVideo;
}

/** @internal */
export interface GalleryOptions {
  /** Gallery layout. */
  layout?: GalleryOptionsLayout;
  /** Styling for gallery items. */
  item?: ItemStyle;
  /** Styling for gallery thumbnail images. */
  thumbnails?: GalleryOptionsThumbnails;
}

/** @internal */
export enum LayoutType {
  /** Collage type */
  COLLAGE = 'COLLAGE',
  /** Masonry type */
  MASONRY = 'MASONRY',
  /** Grid type */
  GRID = 'GRID',
  /** Thumbnail type */
  THUMBNAIL = 'THUMBNAIL',
  /** Slider type */
  SLIDER = 'SLIDER',
  /** Slideshow type */
  SLIDESHOW = 'SLIDESHOW',
  /** Panorama type */
  PANORAMA = 'PANORAMA',
  /** Column type */
  COLUMN = 'COLUMN',
  /** Magic type */
  MAGIC = 'MAGIC',
  /** Fullsize images type */
  FULLSIZE = 'FULLSIZE',
}

/** @enumType */
/** @internal */
export type LayoutTypeWithLiterals =
  | LayoutType
  | 'COLLAGE'
  | 'MASONRY'
  | 'GRID'
  | 'THUMBNAIL'
  | 'SLIDER'
  | 'SLIDESHOW'
  | 'PANORAMA'
  | 'COLUMN'
  | 'MAGIC'
  | 'FULLSIZE';

/** @internal */
export enum Orientation {
  /** Rows Orientation */
  ROWS = 'ROWS',
  /** Columns Orientation */
  COLUMNS = 'COLUMNS',
}

/** @enumType */
/** @internal */
export type OrientationWithLiterals = Orientation | 'ROWS' | 'COLUMNS';

/** @internal */
export enum Crop {
  /** Crop to fill */
  FILL = 'FILL',
  /** Crop to fit */
  FIT = 'FIT',
}

/** @enumType */
/** @internal */
export type CropWithLiterals = Crop | 'FILL' | 'FIT';

/** @internal */
export enum ThumbnailsAlignment {
  /** Top alignment */
  TOP = 'TOP',
  /** Right alignment */
  RIGHT = 'RIGHT',
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
  /** Left alignment */
  LEFT = 'LEFT',
  /** No thumbnail */
  NONE = 'NONE',
}

/** @enumType */
/** @internal */
export type ThumbnailsAlignmentWithLiterals =
  | ThumbnailsAlignment
  | 'TOP'
  | 'RIGHT'
  | 'BOTTOM'
  | 'LEFT'
  | 'NONE';

/** @internal */
export interface GalleryOptionsLayout {
  /** Gallery layout type. */
  type?: LayoutTypeWithLiterals;
  /** Sets whether horizontal scroll is enabled. Defaults to `true` unless the layout `type` is set to `GRID` or `COLLAGE`. */
  horizontalScroll?: boolean | null;
  /** Gallery orientation. */
  orientation?: OrientationWithLiterals;
  /** The number of columns to display on full size screens. */
  numberOfColumns?: number | null;
  /** The number of columns to display on mobile screens. */
  mobileNumberOfColumns?: number | null;
}

/** @internal */
export interface ItemStyle {
  /** Desirable dimension for each item in pixels (behvaior changes according to gallery type) */
  targetSize?: number | null;
  /** Item ratio */
  ratio?: number | null;
  /** Sets how item images are cropped. */
  crop?: CropWithLiterals;
  /** The spacing between items in pixels. */
  spacing?: number | null;
}

/** @internal */
export interface GalleryOptionsThumbnails {
  /** Thumbnail alignment. */
  placement?: ThumbnailsAlignmentWithLiterals;
  /** Spacing between thumbnails in pixels. */
  spacing?: number | null;
}

/** @internal */
export interface GIFData {
  /** Styling for the GIF's container. */
  containerData?: PluginContainerData;
  /** The source of the full size GIF. */
  original?: GIF;
  /** The source of the downsized GIF. */
  downsized?: GIF;
  /** Height in pixels. */
  height?: number;
  /** Width in pixels. */
  width?: number;
  /** Type of GIF (Sticker or NORMAL). Defaults to `NORMAL`. */
  gifType?: GIFTypeWithLiterals;
}

/** @internal */
export interface GIF {
  /**
   * GIF format URL.
   * @format WEB_URL
   */
  gif?: string | null;
  /**
   * MP4 format URL.
   * @format WEB_URL
   */
  mp4?: string | null;
  /**
   * Thumbnail URL.
   * @format WEB_URL
   */
  still?: string | null;
}

/** @internal */
export enum GIFType {
  NORMAL = 'NORMAL',
  STICKER = 'STICKER',
}

/** @enumType */
/** @internal */
export type GIFTypeWithLiterals = GIFType | 'NORMAL' | 'STICKER';

/** @internal */
export interface HeadingData {
  /** Heading level from 1-6. */
  level?: number;
  /** Styling for the heading text. */
  textStyle?: V1TextStyle;
  /** Indentation level from 1-4. */
  indentation?: number | null;
  /** Rendered heading level for SEO/accessibility, overrides the HTML tag when set. */
  renderedLevel?: number | null;
}

/** @internal */
export interface HTMLData extends HTMLDataDataOneOf {
  /** The URL for the HTML code for the node. */
  url?: string;
  /** The HTML code for the node. */
  html?: string;
  /**
   * Whether this is an AdSense element. Use `source` instead.
   * @deprecated
   */
  isAdsense?: boolean | null;
  /** The WixelWidget ID for AI_WIDGET source nodes. */
  widgetId?: string;
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: PluginContainerData;
  /** The type of HTML code. */
  source?: HTMLDataSourceWithLiterals;
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: boolean | null;
}

/** @oneof */
/** @internal */
export interface HTMLDataDataOneOf {
  /** The URL for the HTML code for the node. */
  url?: string;
  /** The HTML code for the node. */
  html?: string;
  /**
   * Whether this is an AdSense element. Use `source` instead.
   * @deprecated
   */
  isAdsense?: boolean | null;
  /** The WixelWidget ID for AI_WIDGET source nodes. */
  widgetId?: string;
}

/** @internal */
export enum HTMLDataSource {
  HTML = 'HTML',
  ADSENSE = 'ADSENSE',
  AI = 'AI',
  AI_WIDGET = 'AI_WIDGET',
}

/** @enumType */
/** @internal */
export type HTMLDataSourceWithLiterals =
  | HTMLDataSource
  | 'HTML'
  | 'ADSENSE'
  | 'AI'
  | 'AI_WIDGET';

/** @internal */
export interface ImageData {
  /** Styling for the image's container. */
  containerData?: PluginContainerData;
  /** Image file details. */
  image?: Media;
  /** Link details for images that are links. */
  link?: V1Link;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: boolean | null;
  /** Image's alternative text. */
  altText?: string | null;
  /**
   * Deprecated: use Caption node instead.
   * @deprecated
   */
  caption?: string | null;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean | null;
  /** Sets whether the image is decorative and does not need an explanation. Defaults to `false`. */
  decorative?: boolean | null;
  /** Styling for the image. */
  styles?: ImageDataStyles;
  /** Non-destructive crop rectangle, expressed as fractions (0-1) of the original image. When omitted, the full image is shown. */
  crop?: ImageDataCrop;
}

/** @internal */
export interface ImageDataStylesBorder {
  /** Border width in pixels. */
  width?: number | null;
  /**
   * Border color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Border radius in pixels. */
  radius?: number | null;
}

/** @internal */
export interface ImageDataStyles {
  /** Border attributes. */
  border?: ImageDataStylesBorder;
}

/** @internal */
export interface ImageDataCrop {
  /** Left edge of the crop, as a fraction (0-1) of the original image width. */
  x?: number | null;
  /** Top edge of the crop, as a fraction (0-1) of the original image height. */
  y?: number | null;
  /** Visible width of the crop, as a fraction (0-1) of the original image width. */
  width?: number | null;
  /** Visible height of the crop, as a fraction (0-1) of the original image height. */
  height?: number | null;
}

/** @internal */
export interface LinkPreviewData {
  /** Styling for the link preview's container. */
  containerData?: PluginContainerData;
  /** Link details. */
  link?: V1Link;
  /** Preview title. */
  title?: string | null;
  /** Preview thumbnail URL. */
  thumbnailUrl?: string | null;
  /** Preview description. */
  description?: string | null;
  /** The preview content as HTML. */
  html?: string | null;
  /** Styling for the link preview. */
  styles?: LinkPreviewDataStyles;
}

/** @internal */
export enum StylesPosition {
  /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = 'START',
  /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
  /** Thumbnail positioned at the top */
  TOP = 'TOP',
  /** Thumbnail hidden and not displayed */
  HIDDEN = 'HIDDEN',
}

/** @enumType */
/** @internal */
export type StylesPositionWithLiterals =
  | StylesPosition
  | 'START'
  | 'END'
  | 'TOP'
  | 'HIDDEN';

/** @internal */
export interface LinkPreviewDataStyles {
  /**
   * Background color as a hexadecimal value.
   * @maxLength 19
   */
  backgroundColor?: string | null;
  /**
   * Title color as a hexadecimal value.
   * @maxLength 19
   */
  titleColor?: string | null;
  /**
   * Subtitle color as a hexadecimal value.
   * @maxLength 19
   */
  subtitleColor?: string | null;
  /**
   * Link color as a hexadecimal value.
   * @maxLength 19
   */
  linkColor?: string | null;
  /** Border width in pixels. */
  borderWidth?: number | null;
  /** Border radius in pixels. */
  borderRadius?: number | null;
  /**
   * Border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition?: StylesPositionWithLiterals;
}

/** @internal */
export interface MapData {
  /** Styling for the map's container. */
  containerData?: PluginContainerData;
  /** Map settings. */
  mapSettings?: MapSettings;
}

/** @internal */
export interface MapSettings {
  /** The address to display on the map. */
  address?: string | null;
  /** Sets whether the map is draggable. */
  draggable?: boolean | null;
  /** Sets whether the location marker is visible. */
  marker?: boolean | null;
  /** Sets whether street view control is enabled. */
  streetViewControl?: boolean | null;
  /** Sets whether zoom control is enabled. */
  zoomControl?: boolean | null;
  /** Location latitude. */
  lat?: number | null;
  /** Location longitude. */
  lng?: number | null;
  /** Location name. */
  locationName?: string | null;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: boolean | null;
  /** Initial zoom value. */
  initialZoom?: number | null;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType?: MapTypeWithLiterals;
}

/** @internal */
export enum MapType {
  /** Roadmap map type */
  ROADMAP = 'ROADMAP',
  /** Satellite map type */
  SATELITE = 'SATELITE',
  /** Hybrid map type */
  HYBRID = 'HYBRID',
  /** Terrain map type */
  TERRAIN = 'TERRAIN',
}

/** @enumType */
/** @internal */
export type MapTypeWithLiterals =
  | MapType
  | 'ROADMAP'
  | 'SATELITE'
  | 'HYBRID'
  | 'TERRAIN';

/** @internal */
export interface ParagraphData {
  /** Styling for the paragraph text. */
  textStyle?: V1TextStyle;
  /** Indentation level from 1-4. */
  indentation?: number | null;
  /** Paragraph level */
  level?: number | null;
}

/** @internal */
export interface PollData {
  /** Styling for the poll's container. */
  containerData?: PluginContainerData;
  /** Poll data. */
  poll?: Poll;
  /** Layout settings for the poll and voting options. */
  layout?: PollDataLayout;
  /** Styling for the poll and voting options. */
  design?: Design;
}

/** @internal */
export enum ViewRole {
  /** Only Poll creator can view the results */
  CREATOR = 'CREATOR',
  /** Anyone who voted can see the results */
  VOTERS = 'VOTERS',
  /** Anyone can see the results, even if one didn't vote */
  EVERYONE = 'EVERYONE',
}

/** @enumType */
/** @internal */
export type ViewRoleWithLiterals = ViewRole | 'CREATOR' | 'VOTERS' | 'EVERYONE';

/** @internal */
export enum VoteRole {
  /** Logged in member */
  SITE_MEMBERS = 'SITE_MEMBERS',
  /** Anyone */
  ALL = 'ALL',
}

/** @enumType */
/** @internal */
export type VoteRoleWithLiterals = VoteRole | 'SITE_MEMBERS' | 'ALL';

/** @internal */
export interface SettingsPermissions {
  /** Sets who can view the poll results. */
  view?: ViewRoleWithLiterals;
  /** Sets who can vote. */
  vote?: VoteRoleWithLiterals;
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: boolean | null;
}

/** @internal */
export interface PollOption {
  /** Option ID. */
  id?: string | null;
  /** Option title. */
  title?: string | null;
  /** The image displayed with the option. */
  image?: Media;
}

/** @internal */
export interface PollSettings {
  /** Permissions settings for voting. */
  permissions?: SettingsPermissions;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: boolean | null;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: boolean | null;
}

/** @internal */
export enum PollLayoutType {
  /** List */
  LIST = 'LIST',
  /** Grid */
  GRID = 'GRID',
}

/** @enumType */
/** @internal */
export type PollLayoutTypeWithLiterals = PollLayoutType | 'LIST' | 'GRID';

/** @internal */
export enum PollLayoutDirection {
  /** Left-to-right */
  LTR = 'LTR',
  /** Right-to-left */
  RTL = 'RTL',
}

/** @enumType */
/** @internal */
export type PollLayoutDirectionWithLiterals =
  | PollLayoutDirection
  | 'LTR'
  | 'RTL';

/** @internal */
export interface PollLayout {
  /** The layout for displaying the voting options. */
  type?: PollLayoutTypeWithLiterals;
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction?: PollLayoutDirectionWithLiterals;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: boolean | null;
}

/** @internal */
export interface OptionLayout {
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: boolean | null;
}

/** @internal */
export enum PollDesignBackgroundType {
  /** Color background type */
  COLOR = 'COLOR',
  /** Image background type */
  IMAGE = 'IMAGE',
  /** Gradiant background type */
  GRADIENT = 'GRADIENT',
}

/** @enumType */
/** @internal */
export type PollDesignBackgroundTypeWithLiterals =
  | PollDesignBackgroundType
  | 'COLOR'
  | 'IMAGE'
  | 'GRADIENT';

/** @internal */
export interface BackgroundGradient {
  /** The gradient angle in degrees. */
  angle?: number | null;
  /**
   * The start color as a hexademical value.
   * @maxLength 19
   */
  startColor?: string | null;
  /**
   * The end color as a hexademical value.
   * @maxLength 19
   */
  lastColor?: string | null;
}

/** @internal */
export interface PollDesignBackground
  extends PollDesignBackgroundBackgroundOneOf {
  /**
   * The background color as a hexademical value.
   * @maxLength 19
   */
  color?: string | null;
  /** An image to use for the background. */
  image?: Media;
  /** Details for a gradient background. */
  gradient?: BackgroundGradient;
  /** Background type. For each option, include the relevant details. */
  type?: PollDesignBackgroundTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface PollDesignBackgroundBackgroundOneOf {
  /**
   * The background color as a hexademical value.
   * @maxLength 19
   */
  color?: string | null;
  /** An image to use for the background. */
  image?: Media;
  /** Details for a gradient background. */
  gradient?: BackgroundGradient;
}

/** @internal */
export interface PollDesign {
  /** Background styling. */
  background?: PollDesignBackground;
  /** Border radius in pixels. */
  borderRadius?: number | null;
}

/** @internal */
export interface OptionDesign {
  /** Border radius in pixels. */
  borderRadius?: number | null;
}

/** @internal */
export interface Poll {
  /** Poll ID. */
  id?: string | null;
  /** Poll title. */
  title?: string | null;
  /** Poll creator ID. */
  creatorId?: string | null;
  /** Main poll image. */
  image?: Media;
  /** Voting options. */
  options?: PollOption[];
  /** The poll's permissions and display settings. */
  settings?: PollSettings;
}

/** @internal */
export interface PollDataLayout {
  /** Poll layout settings. */
  poll?: PollLayout;
  /** Voting otpions layout settings. */
  options?: OptionLayout;
}

/** @internal */
export interface Design {
  /** Styling for the poll. */
  poll?: PollDesign;
  /** Styling for voting options. */
  options?: OptionDesign;
}

/** @internal */
export interface TextData {
  /** The text to apply decorations to. */
  text?: string;
  /** The decorations to apply. */
  decorations?: Decoration[];
}

/** Adds appearence changes to text */
/** @internal */
export interface Decoration extends DecorationDataOneOf {
  /** Data for an anchor link decoration. */
  anchorData?: AnchorData;
  /** Data for a color decoration. */
  colorData?: ColorData;
  /** Data for an external link decoration. */
  linkData?: LinkData;
  /** Data for a mention decoration. */
  mentionData?: MentionData;
  /** Data for a font size decoration. */
  fontSizeData?: FontSizeData;
  /** Font weight for a bold decoration. */
  fontWeightValue?: number | null;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: boolean | null;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: boolean | null;
  /** Data for a spoiler decoration. */
  spoilerData?: SpoilerData;
  /** Data for a strikethrough decoration. Defaults to `true`. */
  strikethroughData?: boolean | null;
  /** Data for a superscript decoration. Defaults to `true`. */
  superscriptData?: boolean | null;
  /** Data for a subscript decoration. Defaults to `true`. */
  subscriptData?: boolean | null;
  /** Data for a font family decoration. */
  fontFamilyData?: FontFamilyData;
  /** Data for a hand-drawn sketch annotation decoration. */
  sketchData?: SketchData;
  /** The type of decoration to apply. */
  type?: DecorationTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface DecorationDataOneOf {
  /** Data for an anchor link decoration. */
  anchorData?: AnchorData;
  /** Data for a color decoration. */
  colorData?: ColorData;
  /** Data for an external link decoration. */
  linkData?: LinkData;
  /** Data for a mention decoration. */
  mentionData?: MentionData;
  /** Data for a font size decoration. */
  fontSizeData?: FontSizeData;
  /** Font weight for a bold decoration. */
  fontWeightValue?: number | null;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: boolean | null;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: boolean | null;
  /** Data for a spoiler decoration. */
  spoilerData?: SpoilerData;
  /** Data for a strikethrough decoration. Defaults to `true`. */
  strikethroughData?: boolean | null;
  /** Data for a superscript decoration. Defaults to `true`. */
  superscriptData?: boolean | null;
  /** Data for a subscript decoration. Defaults to `true`. */
  subscriptData?: boolean | null;
  /** Data for a font family decoration. */
  fontFamilyData?: FontFamilyData;
  /** Data for a hand-drawn sketch annotation decoration. */
  sketchData?: SketchData;
}

/** @internal */
export enum DecorationType {
  BOLD = 'BOLD',
  ITALIC = 'ITALIC',
  UNDERLINE = 'UNDERLINE',
  SPOILER = 'SPOILER',
  ANCHOR = 'ANCHOR',
  MENTION = 'MENTION',
  LINK = 'LINK',
  COLOR = 'COLOR',
  FONT_SIZE = 'FONT_SIZE',
  EXTERNAL = 'EXTERNAL',
  STRIKETHROUGH = 'STRIKETHROUGH',
  SUPERSCRIPT = 'SUPERSCRIPT',
  SUBSCRIPT = 'SUBSCRIPT',
  FONT_FAMILY = 'FONT_FAMILY',
  SKETCH = 'SKETCH',
}

/** @enumType */
/** @internal */
export type DecorationTypeWithLiterals =
  | DecorationType
  | 'BOLD'
  | 'ITALIC'
  | 'UNDERLINE'
  | 'SPOILER'
  | 'ANCHOR'
  | 'MENTION'
  | 'LINK'
  | 'COLOR'
  | 'FONT_SIZE'
  | 'EXTERNAL'
  | 'STRIKETHROUGH'
  | 'SUPERSCRIPT'
  | 'SUBSCRIPT'
  | 'FONT_FAMILY'
  | 'SKETCH';

/** @internal */
export interface AnchorData {
  /** The target node's ID. */
  anchor?: string;
}

/** @internal */
export interface ColorData {
  /** The text's background color as a hexadecimal value. */
  background?: string | null;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: string | null;
}

/** @internal */
export interface LinkData {
  /** Link details. */
  link?: V1Link;
}

/** @internal */
export interface MentionData {
  /** The mentioned user's name. */
  name?: string;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug?: string;
  /** Mentioned user's ID. */
  id?: string | null;
}

/** @internal */
export interface FontSizeData {
  /** The units used for the font size. */
  unit?: FontTypeWithLiterals;
  /** Font size value. */
  value?: number | null;
}

/** @internal */
export enum FontType {
  PX = 'PX',
  EM = 'EM',
}

/** @enumType */
/** @internal */
export type FontTypeWithLiterals = FontType | 'PX' | 'EM';

/** @internal */
export interface SpoilerData {
  /** Spoiler ID. */
  id?: string | null;
}

/** @internal */
export interface FontFamilyData {
  /** @maxLength 1000 */
  value?: string | null;
}

/** @internal */
export interface SketchData {
  /** The sketch annotation variant to draw over the text. */
  variant?: VariantWithLiterals;
  /**
   * Annotation color. Defaults to the theme action color.
   * @maxLength 19
   */
  color?: string | null;
  /** Whether the annotation animates on first paint. Defaults to `true`. */
  animate?: boolean | null;
}

/** @internal */
export enum Variant {
  UNDERLINE = 'UNDERLINE',
  BOX = 'BOX',
  CIRCLE = 'CIRCLE',
  HIGHLIGHT = 'HIGHLIGHT',
  STRIKETHROUGH = 'STRIKETHROUGH',
  CROSSED_OFF = 'CROSSED_OFF',
}

/** @enumType */
/** @internal */
export type VariantWithLiterals =
  | Variant
  | 'UNDERLINE'
  | 'BOX'
  | 'CIRCLE'
  | 'HIGHLIGHT'
  | 'STRIKETHROUGH'
  | 'CROSSED_OFF';

/** @internal */
export interface AppEmbedData extends AppEmbedDataAppDataOneOf {
  /** Data for embedded Wix Bookings content. */
  bookingData?: BookingData;
  /** Data for embedded Wix Events content. */
  eventData?: EventData;
  /** The type of Wix App content being embedded. */
  type?: AppTypeWithLiterals;
  /** The ID of the embedded content. */
  itemId?: string | null;
  /** The name of the embedded content. */
  name?: string | null;
  /**
   * Deprecated: Use `image` instead.
   * @deprecated
   */
  imageSrc?: string | null;
  /** The URL for the embedded content. */
  url?: string | null;
  /** An image for the embedded content. */
  image?: Media;
  /** Whether to hide the image. */
  hideImage?: boolean | null;
  /** Whether to hide the title. */
  hideTitle?: boolean | null;
  /** Whether to hide the price. */
  hidePrice?: boolean | null;
  /** Whether to hide the description (Event and Booking). */
  hideDescription?: boolean | null;
  /** Whether to hide the date and time (Event). */
  hideDateTime?: boolean | null;
  /** Whether to hide the location (Event). */
  hideLocation?: boolean | null;
  /** Whether to hide the duration (Booking). */
  hideDuration?: boolean | null;
  /** Whether to hide the button. */
  hideButton?: boolean | null;
  /** Whether to hide the ribbon. */
  hideRibbon?: boolean | null;
  /** Button styling options. */
  buttonStyles?: ButtonStyles;
  /** Image styling options. */
  imageStyles?: ImageStyles;
  /** Ribbon styling options. */
  ribbonStyles?: RibbonStyles;
  /** Card styling options. */
  cardStyles?: CardStyles;
  /** Styling for the app embed's container. */
  containerData?: PluginContainerData;
  /** Pricing data for embedded Wix App content. */
  pricingData?: PricingData;
}

/** @oneof */
/** @internal */
export interface AppEmbedDataAppDataOneOf {
  /** Data for embedded Wix Bookings content. */
  bookingData?: BookingData;
  /** Data for embedded Wix Events content. */
  eventData?: EventData;
}

/** @internal */
export enum ImageStylesPosition {
  /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = 'START',
  /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
  /** Image positioned at the top */
  TOP = 'TOP',
}

/** @enumType */
/** @internal */
export type ImageStylesPositionWithLiterals =
  | ImageStylesPosition
  | 'START'
  | 'END'
  | 'TOP';

/** @internal */
export enum AspectRatio {
  /** 1:1 aspect ratio */
  SQUARE = 'SQUARE',
  /** 16:9 aspect ratio */
  RECTANGLE = 'RECTANGLE',
}

/** @enumType */
/** @internal */
export type AspectRatioWithLiterals = AspectRatio | 'SQUARE' | 'RECTANGLE';

/** @internal */
export enum Resizing {
  /** Fill the container, may crop the image */
  FILL = 'FILL',
  /** Fit the image within the container */
  FIT = 'FIT',
}

/** @enumType */
/** @internal */
export type ResizingWithLiterals = Resizing | 'FILL' | 'FIT';

/** @internal */
export enum Placement {
  /** Ribbon placed on the image */
  IMAGE = 'IMAGE',
  /** Ribbon placed on the product information */
  PRODUCT_INFO = 'PRODUCT_INFO',
}

/** @enumType */
/** @internal */
export type PlacementWithLiterals = Placement | 'IMAGE' | 'PRODUCT_INFO';

/** @internal */
export enum CardStylesType {
  /** Card with visible border and background */
  CONTAINED = 'CONTAINED',
  /** Card without visible border */
  FRAMELESS = 'FRAMELESS',
}

/** @enumType */
/** @internal */
export type CardStylesTypeWithLiterals =
  | CardStylesType
  | 'CONTAINED'
  | 'FRAMELESS';

/** @internal */
export enum CardStylesAlignment {
  /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
  START = 'START',
  /** Content centered */
  CENTER = 'CENTER',
  /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
}

/** @enumType */
/** @internal */
export type CardStylesAlignmentWithLiterals =
  | CardStylesAlignment
  | 'START'
  | 'CENTER'
  | 'END';

/** @internal */
export enum Layout {
  /** Elements stacked vertically */
  STACKED = 'STACKED',
  /** Elements arranged horizontally */
  SIDE_BY_SIDE = 'SIDE_BY_SIDE',
}

/** @enumType */
/** @internal */
export type LayoutWithLiterals = Layout | 'STACKED' | 'SIDE_BY_SIDE';

/** @internal */
export enum AppType {
  PRODUCT = 'PRODUCT',
  EVENT = 'EVENT',
  BOOKING = 'BOOKING',
}

/** @enumType */
/** @internal */
export type AppTypeWithLiterals = AppType | 'PRODUCT' | 'EVENT' | 'BOOKING';

/** @internal */
export interface BookingData {
  /** Booking duration in minutes. */
  durations?: string | null;
}

/** @internal */
export interface EventData {
  /** Event schedule. */
  scheduling?: string | null;
  /** Event location. */
  location?: string | null;
}

/** @internal */
export interface ButtonStyles {
  /** Text to display on the button. */
  buttonText?: string | null;
  /** Border width in pixels. */
  borderWidth?: number | null;
  /** Border radius in pixels. */
  borderRadius?: number | null;
  /**
   * Border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /**
   * Text color as a hexadecimal value.
   * @maxLength 19
   */
  textColor?: string | null;
  /**
   * Background color as a hexadecimal value.
   * @maxLength 19
   */
  backgroundColor?: string | null;
  /**
   * Border color as a hexadecimal value (hover state).
   * @maxLength 19
   */
  borderColorHover?: string | null;
  /**
   * Text color as a hexadecimal value (hover state).
   * @maxLength 19
   */
  textColorHover?: string | null;
  /**
   * Background color as a hexadecimal value (hover state).
   * @maxLength 19
   */
  backgroundColorHover?: string | null;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: string | null;
}

/** @internal */
export interface ImageStyles {
  /** Whether to hide the image. */
  hideImage?: boolean | null;
  /** Position of image. Defaults to `START`. */
  imagePosition?: ImageStylesPositionWithLiterals;
  /** Aspect ratio for the image. Defaults to `SQUARE`. */
  aspectRatio?: AspectRatioWithLiterals;
  /** How the image should be resized. Defaults to `FILL`. */
  resizing?: ResizingWithLiterals;
  /**
   * Image border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Image border width in pixels. */
  borderWidth?: number | null;
  /** Image border radius in pixels. */
  borderRadius?: number | null;
}

/** @internal */
export interface RibbonStyles {
  /** Text to display on the ribbon. */
  ribbonText?: string | null;
  /**
   * Ribbon background color as a hexadecimal value.
   * @maxLength 19
   */
  backgroundColor?: string | null;
  /**
   * Ribbon text color as a hexadecimal value.
   * @maxLength 19
   */
  textColor?: string | null;
  /**
   * Ribbon border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Ribbon border width in pixels. */
  borderWidth?: number | null;
  /** Ribbon border radius in pixels. */
  borderRadius?: number | null;
  /** Placement of the ribbon. Defaults to `IMAGE`. */
  ribbonPlacement?: PlacementWithLiterals;
}

/** @internal */
export interface CardStyles {
  /**
   * Card background color as a hexadecimal value.
   * @maxLength 19
   */
  backgroundColor?: string | null;
  /**
   * Card border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Card border width in pixels. */
  borderWidth?: number | null;
  /** Card border radius in pixels. */
  borderRadius?: number | null;
  /** Card type. Defaults to `CONTAINED`. */
  type?: CardStylesTypeWithLiterals;
  /** Content alignment. Defaults to `START`. */
  alignment?: CardStylesAlignmentWithLiterals;
  /** Layout for title and price. Defaults to `STACKED`. */
  titlePriceLayout?: LayoutWithLiterals;
  /**
   * Title text color as a hexadecimal value.
   * @maxLength 19
   */
  titleColor?: string | null;
  /**
   * Text color as a hexadecimal value.
   * @maxLength 19
   */
  textColor?: string | null;
}

/** @internal */
export interface PricingData {
  /**
   * Minimum numeric price value as string (e.g., "10.99").
   * @decimalValue options { maxScale:2 }
   */
  valueFrom?: string | null;
  /**
   * Maximum numeric price value as string (e.g., "19.99").
   * @decimalValue options { maxScale:2 }
   */
  valueTo?: string | null;
  /**
   * Numeric price value as string after discount application (e.g., "15.99").
   * @decimalValue options { maxScale:2 }
   */
  discountedValue?: string | null;
  /**
   * Currency of the value in ISO 4217 format (e.g., "USD", "EUR").
   * @format CURRENCY
   */
  currency?: string | null;
  /**
   * Pricing plan ID.
   * @format GUID
   */
  pricingPlanId?: string | null;
}

/** @internal */
export interface VideoData {
  /** Styling for the video's container. */
  containerData?: PluginContainerData;
  /** Video details. */
  video?: Media;
  /** Video thumbnail details. */
  thumbnail?: Media;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean | null;
  /** Video title. */
  title?: string | null;
  /** Video options. */
  options?: PlaybackOptions;
}

/** @internal */
export interface PlaybackOptions {
  /** Sets whether the media will automatically start playing. */
  autoPlay?: boolean | null;
  /** Sets whether media's will be looped. */
  playInLoop?: boolean | null;
  /** Sets whether media's controls will be shown. */
  showControls?: boolean | null;
}

/** @internal */
export interface EmbedData {
  /** Styling for the oEmbed node's container. */
  containerData?: PluginContainerData;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: Oembed;
  /** Origin asset source. */
  src?: string | null;
}

/** @internal */
export interface Oembed {
  /** The resource type. */
  type?: string | null;
  /** The width of the resource specified in the `url` property in pixels. */
  width?: number | null;
  /** The height of the resource specified in the `url` property in pixels. */
  height?: number | null;
  /** Resource title. */
  title?: string | null;
  /** The source URL for the resource. */
  url?: string | null;
  /** HTML for embedding a video player. The HTML should have no padding or margins. */
  html?: string | null;
  /** The name of the author or owner of the resource. */
  authorName?: string | null;
  /** The URL for the author or owner of the resource. */
  authorUrl?: string | null;
  /** The name of the resource provider. */
  providerName?: string | null;
  /** The URL for the resource provider. */
  providerUrl?: string | null;
  /** The URL for a thumbnail image for the resource. If this property is defined, `thumbnailWidth` and `thumbnailHeight` must also be defined. */
  thumbnailUrl?: string | null;
  /** The width of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailHeight` must also be defined. */
  thumbnailWidth?: string | null;
  /** The height of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailWidth`must also be defined. */
  thumbnailHeight?: string | null;
  /** The URL for an embedded viedo. */
  videoUrl?: string | null;
  /** The oEmbed version number.  This value must be `1.0`. */
  version?: string | null;
}

/** @internal */
export interface CollapsibleListData {
  /** Styling for the collapsible list's container. */
  containerData?: PluginContainerData;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: boolean | null;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems?: InitialExpandedItemsWithLiterals;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction?: DirectionWithLiterals;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: boolean | null;
}

/** @internal */
export enum InitialExpandedItems {
  /** First item will be expended initally */
  FIRST = 'FIRST',
  /** All items will expended initally */
  ALL = 'ALL',
  /** All items collapsed initally */
  NONE = 'NONE',
}

/** @enumType */
/** @internal */
export type InitialExpandedItemsWithLiterals =
  | InitialExpandedItems
  | 'FIRST'
  | 'ALL'
  | 'NONE';

/** @internal */
export enum Direction {
  /** Left-to-right */
  LTR = 'LTR',
  /** Right-to-left */
  RTL = 'RTL',
}

/** @enumType */
/** @internal */
export type DirectionWithLiterals = Direction | 'LTR' | 'RTL';

/** @internal */
export interface TableData {
  /** Styling for the table's container. */
  containerData?: PluginContainerData;
  /** The table's dimensions. */
  dimensions?: Dimensions;
  /**
   * Deprecated: Use `rowHeader` and `columnHeader` instead.
   * @deprecated
   */
  header?: boolean | null;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: boolean | null;
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: boolean | null;
  /** The spacing between cells in pixels. Defaults to `0`. */
  cellSpacing?: number | null;
  /**
   * Padding in pixels for cells. Follows CSS order: top, right, bottom, left.
   * @maxSize 4
   */
  cellPadding?: number[];
  /** Table's alternative text. */
  altText?: string | null;
}

/** @internal */
export interface Dimensions {
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio?: number[];
  /** An array representing the height of each row in pixels. */
  rowsHeight?: number[];
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth?: number[];
}

/** @internal */
export interface TableCellData {
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: CellStyle;
  /** The cell's border colors. */
  borderColors?: BorderColors;
  /** Defines how many columns the cell spans. Default: 1. */
  colspan?: number | null;
  /** Defines how many rows the cell spans. Default: 1. */
  rowspan?: number | null;
  /** The cell's border widths. */
  borderWidths?: BorderWidths;
}

/** @internal */
export enum VerticalAlignment {
  /** Top alignment */
  TOP = 'TOP',
  /** Middle alignment */
  MIDDLE = 'MIDDLE',
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
}

/** @enumType */
/** @internal */
export type VerticalAlignmentWithLiterals =
  | VerticalAlignment
  | 'TOP'
  | 'MIDDLE'
  | 'BOTTOM';

/** @internal */
export interface CellStyle {
  /** Vertical alignment for the cell's text. */
  verticalAlignment?: VerticalAlignmentWithLiterals;
  /**
   * Cell background color as a hexadecimal value.
   * @maxLength 19
   */
  backgroundColor?: string | null;
}

/** @internal */
export interface BorderColors {
  /**
   * Left border color as a hexadecimal value.
   * @maxLength 19
   */
  left?: string | null;
  /**
   * Right border color as a hexadecimal value.
   * @maxLength 19
   */
  right?: string | null;
  /**
   * Top border color as a hexadecimal value.
   * @maxLength 19
   */
  top?: string | null;
  /**
   * Bottom border color as a hexadecimal value.
   * @maxLength 19
   */
  bottom?: string | null;
}

/** @internal */
export interface BorderWidths {
  /** Left border width in pixels. */
  left?: number | null;
  /** Right border width in pixels. */
  right?: number | null;
  /** Top border width in pixels. */
  top?: number | null;
  /** Bottom border width in pixels. */
  bottom?: number | null;
}

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
/** @internal */
export enum NullValue {
  /** Null value. */
  NULL_VALUE = 'NULL_VALUE',
}

/** @enumType */
/** @internal */
export type NullValueWithLiterals = NullValue | 'NULL_VALUE';

/**
 * `ListValue` is a wrapper around a repeated field of values.
 *
 * The JSON representation for `ListValue` is JSON array.
 */
/** @internal */
export interface ListValue {
  /** Repeated field of dynamically typed values. */
  values?: any[];
}

/** @internal */
export interface AudioData {
  /** Styling for the audio node's container. */
  containerData?: PluginContainerData;
  /** Audio file details. */
  audio?: Media;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: boolean | null;
  /** Cover image. */
  coverImage?: Media;
  /** Track name. */
  name?: string | null;
  /** Author name. */
  authorName?: string | null;
  /** An HTML version of the audio node. */
  html?: string | null;
}

/** @internal */
export interface OrderedListData {
  /** Indentation level from 0-4. */
  indentation?: number;
  /** Offset level from 0-4. */
  offset?: number | null;
  /** List start number. */
  start?: number | null;
}

/** @internal */
export interface BulletedListData {
  /** Indentation level from 0-4. */
  indentation?: number;
  /** Offset level from 0-4. */
  offset?: number | null;
}

/** @internal */
export interface BlockquoteData {
  /** Indentation level from 1-4. */
  indentation?: number;
}

/** @internal */
export interface CaptionData {
  textStyle?: V1TextStyle;
}

/** @internal */
export interface LayoutData {
  /**
   * Deprecated: Use `background` instead.
   * @maxLength 19
   * @deprecated
   */
  backgroundColor?: string | null;
  /** Background image. */
  backgroundImage?: LayoutDataBackgroundImage;
  /**
   * Border color as a hexadecimal value.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Border width in pixels. */
  borderWidth?: number | null;
  /** Border radius in pixels. */
  borderRadius?: number | null;
  /**
   * Deprecated: Use `backdrop` instead.
   * @maxLength 19
   * @deprecated
   */
  backdropColor?: string | null;
  /** Backdrop image. */
  backdropImage?: LayoutDataBackgroundImage;
  /** Backdrop top padding. */
  backdropPaddingTop?: number | null;
  /** Backdrop bottom padding */
  backdropPaddingBottom?: number | null;
  /** Horizontal and vertical gap between columns */
  gap?: number | null;
  /**
   * Padding in pixels for cells. Follows CSS order: top, right, bottom, left
   * @maxSize 4
   */
  cellPadding?: number[];
  /** Vertical alignment for the cell's items. */
  cellVerticalAlignment?: VerticalAlignmentAlignmentWithLiterals;
  /** Responsiveness behaviour of columns when responsiveness applies. Either stacks or wrappers. */
  responsivenessBehaviour?: ResponsivenessBehaviourWithLiterals;
  /** Size in pixels when responsiveness_behaviour applies */
  responsivenessBreakpoint?: number | null;
  /** Styling for the layout's container. */
  containerData?: PluginContainerData;
  /** Defines where selected design propertied applies to */
  designTarget?: DesignTargetWithLiterals;
  /** Banner configuration. When present, this layout is attached to a document edge (top or bottom). */
  banner?: Banner;
  /** Background styling (color or gradient). */
  background?: LayoutDataBackground;
  /** Backdrop styling (color or gradient). */
  backdrop?: Backdrop;
}

/** @internal */
export enum ImageScalingScaling {
  /** Auto image scaling */
  AUTO = 'AUTO',
  /** Contain image scaling */
  CONTAIN = 'CONTAIN',
  /** Cover image scaling */
  COVER = 'COVER',
}

/** @enumType */
/** @internal */
export type ImageScalingScalingWithLiterals =
  | ImageScalingScaling
  | 'AUTO'
  | 'CONTAIN'
  | 'COVER';

/** @internal */
export enum LayoutDataImagePosition {
  /** Image positioned at the center */
  CENTER = 'CENTER',
  /** Image positioned on the left */
  CENTER_LEFT = 'CENTER_LEFT',
  /** Image positioned on the right */
  CENTER_RIGHT = 'CENTER_RIGHT',
  /** Image positioned at the center top */
  TOP = 'TOP',
  /** Image positioned at the top left */
  TOP_LEFT = 'TOP_LEFT',
  /** Image positioned at the top right */
  TOP_RIGHT = 'TOP_RIGHT',
  /** Image positioned at the center bottom */
  BOTTOM = 'BOTTOM',
  /** Image positioned at the bottom left */
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  /** Image positioned at the bottom right */
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
}

/** @enumType */
/** @internal */
export type LayoutDataImagePositionWithLiterals =
  | LayoutDataImagePosition
  | 'CENTER'
  | 'CENTER_LEFT'
  | 'CENTER_RIGHT'
  | 'TOP'
  | 'TOP_LEFT'
  | 'TOP_RIGHT'
  | 'BOTTOM'
  | 'BOTTOM_LEFT'
  | 'BOTTOM_RIGHT';

/** Background styling (color or gradient) */
/** @internal */
export interface LayoutDataBackground {
  /** Background type. */
  type?: LayoutDataBackgroundTypeWithLiterals;
  /**
   * Background color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Gradient configuration. */
  gradient?: Gradient;
}

/** Background type */
/** @internal */
export enum LayoutDataBackgroundType {
  /** Solid color background */
  COLOR = 'COLOR',
  /** Gradient background */
  GRADIENT = 'GRADIENT',
}

/** @enumType */
/** @internal */
export type LayoutDataBackgroundTypeWithLiterals =
  | LayoutDataBackgroundType
  | 'COLOR'
  | 'GRADIENT';

/** @internal */
export enum Origin {
  /** Banner originated from an image */
  IMAGE = 'IMAGE',
  /** Banner originated from a layout */
  LAYOUT = 'LAYOUT',
}

/** @enumType */
/** @internal */
export type OriginWithLiterals = Origin | 'IMAGE' | 'LAYOUT';

/** @internal */
export enum BannerPosition {
  /** Attached to the top edge (banner) */
  TOP = 'TOP',
  /** Attached to the bottom edge (footer) */
  BOTTOM = 'BOTTOM',
}

/** @enumType */
/** @internal */
export type BannerPositionWithLiterals = BannerPosition | 'TOP' | 'BOTTOM';

/** Backdrop type */
/** @internal */
export enum BackdropType {
  /** Solid color backdrop */
  COLOR = 'COLOR',
  /** Gradient backdrop */
  GRADIENT = 'GRADIENT',
}

/** @enumType */
/** @internal */
export type BackdropTypeWithLiterals = BackdropType | 'COLOR' | 'GRADIENT';

/** @internal */
export interface LayoutDataBackgroundImage {
  /** Background image. */
  media?: Media;
  /**
   * Deprecated: use `overlay` instead. Legacy image opacity (0–100) that dimmed the image to reveal the `background`/`backdrop` color behind it.
   * @deprecated
   */
  opacity?: number | null;
  /** Background image scaling. */
  scaling?: ImageScalingScalingWithLiterals;
  /** Position of background. Defaults to `CENTER`. */
  position?: LayoutDataImagePositionWithLiterals;
  /** Blur radius in pixels applied to the image layer. `0` (default) leaves the image unblurred; blur is independent of any color overlay and the two stack. */
  blur?: number | null;
  /** Color or gradient drawn on top of the image. When present, this is the authoritative overlay and `opacity` is ignored. Its presence also marks content as authored under the new overlay model (vs. the legacy `opacity`-based dimming on `background`/`backdrop`). */
  overlay?: LayoutDataBackground;
}

/** @internal */
export enum VerticalAlignmentAlignment {
  /** Top alignment */
  TOP = 'TOP',
  /** Middle alignment */
  MIDDLE = 'MIDDLE',
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
}

/** @enumType */
/** @internal */
export type VerticalAlignmentAlignmentWithLiterals =
  | VerticalAlignmentAlignment
  | 'TOP'
  | 'MIDDLE'
  | 'BOTTOM';

/** @internal */
export enum ResponsivenessBehaviour {
  /** Stacking of columns */
  STACK = 'STACK',
  /** Wrapping of columns */
  WRAP = 'WRAP',
}

/** @enumType */
/** @internal */
export type ResponsivenessBehaviourWithLiterals =
  | ResponsivenessBehaviour
  | 'STACK'
  | 'WRAP';

/** @internal */
export enum DesignTarget {
  /** Design applied to layout */
  LAYOUT = 'LAYOUT',
  /** Design applied to cells */
  CELL = 'CELL',
}

/** @enumType */
/** @internal */
export type DesignTargetWithLiterals = DesignTarget | 'LAYOUT' | 'CELL';

/** @internal */
export interface Banner {
  /** Origin of the banner */
  origin?: OriginWithLiterals;
  /** Position of the banner */
  position?: BannerPositionWithLiterals;
}

/** Backdrop styling (color or gradient) */
/** @internal */
export interface Backdrop {
  /** Backdrop type. */
  type?: BackdropTypeWithLiterals;
  /**
   * Backdrop color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Gradient configuration. */
  gradient?: Gradient;
}

/** @internal */
export interface LayoutCellData {
  /** Size of the cell in 12 columns grid. */
  colSpan?: number | null;
}

/** @internal */
export interface ShapeData {
  /** Styling for the shape's container. */
  containerData?: PluginContainerData;
  /** Shape file details. */
  shape?: Media;
  /** Styling for the shape. */
  styles?: ShapeDataStyles;
}

/** @internal */
export interface ShapeDataStyles {
  /**
   * Shape fill color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Map of original color keys to their new color values. */
  colors?: Record<string, string>;
}

/** @internal */
export interface CardData {
  /** Background styling (color or gradient). */
  background?: CardDataBackground;
  /** Background image. */
  backgroundImage?: CardDataBackgroundImage;
}

/** @internal */
export enum Scaling {
  /** Auto image scaling */
  AUTO = 'AUTO',
  /** Contain image scaling */
  CONTAIN = 'CONTAIN',
  /** Cover image scaling */
  COVER = 'COVER',
}

/** @enumType */
/** @internal */
export type ScalingWithLiterals = Scaling | 'AUTO' | 'CONTAIN' | 'COVER';

/** @internal */
export enum ImagePositionPosition {
  /** Image positioned at the center */
  CENTER = 'CENTER',
  /** Image positioned on the left */
  CENTER_LEFT = 'CENTER_LEFT',
  /** Image positioned on the right */
  CENTER_RIGHT = 'CENTER_RIGHT',
  /** Image positioned at the center top */
  TOP = 'TOP',
  /** Image positioned at the top left */
  TOP_LEFT = 'TOP_LEFT',
  /** Image positioned at the top right */
  TOP_RIGHT = 'TOP_RIGHT',
  /** Image positioned at the center bottom */
  BOTTOM = 'BOTTOM',
  /** Image positioned at the bottom left */
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  /** Image positioned at the bottom right */
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
}

/** @enumType */
/** @internal */
export type ImagePositionPositionWithLiterals =
  | ImagePositionPosition
  | 'CENTER'
  | 'CENTER_LEFT'
  | 'CENTER_RIGHT'
  | 'TOP'
  | 'TOP_LEFT'
  | 'TOP_RIGHT'
  | 'BOTTOM'
  | 'BOTTOM_LEFT'
  | 'BOTTOM_RIGHT';

/** Background styling (color or gradient) */
/** @internal */
export interface CardDataBackground {
  /** Background type. */
  type?: CardDataBackgroundTypeWithLiterals;
  /**
   * Background color as a hexadecimal value.
   * @maxLength 19
   */
  color?: string | null;
  /** Gradient configuration. */
  gradient?: Gradient;
}

/** Background type */
/** @internal */
export enum CardDataBackgroundType {
  /** Solid color background */
  COLOR = 'COLOR',
  /** Gradient background */
  GRADIENT = 'GRADIENT',
}

/** @enumType */
/** @internal */
export type CardDataBackgroundTypeWithLiterals =
  | CardDataBackgroundType
  | 'COLOR'
  | 'GRADIENT';

/** @internal */
export interface CardDataBackgroundImage {
  /** Background image. */
  media?: Media;
  /**
   * Deprecated: use `overlay` instead. Legacy image opacity (0–100) that dimmed the image to reveal the `background` color behind it.
   * @deprecated
   */
  opacity?: number | null;
  /** Background image scaling. */
  scaling?: ScalingWithLiterals;
  /** Position of background. Defaults to `CENTER`. */
  position?: ImagePositionPositionWithLiterals;
  /** Color or gradient drawn on top of the image. When present, this is the authoritative overlay and `opacity` is ignored. Its presence also marks content as authored under the new overlay model (vs. the legacy `opacity`-based dimming on `background`). */
  overlay?: CardDataBackground;
  /** Blur radius in pixels applied to the image layer. `0` (default) leaves the image unblurred; blur is independent of any color overlay and the two stack. */
  blur?: number | null;
}

/** @internal */
export interface TocData {
  /** Heading levels included in the table of contents. Default: [1, 2, 3, 4, 5, 6]. */
  includedHeadings?: number[];
  /** List style. Default: PLAIN. */
  listStyle?: ListStyleWithLiterals;
  /** Optional override for the font size in pixels. */
  fontSize?: number | null;
  /** Optional override for the vertical spacing between items in pixels. */
  itemSpacing?: number | null;
  /**
   * Optional override for the text color.
   * @maxLength 19
   */
  color?: string | null;
  /** Indentation style. Default: NESTED. */
  indentation?: IndentationWithLiterals;
}

/** List style. */
/** @internal */
export enum ListStyle {
  /** No markers (default) */
  PLAIN = 'PLAIN',
  /** Numbered list */
  NUMBERED = 'NUMBERED',
  /** Alphabetic letters */
  LETTERS = 'LETTERS',
  /** Roman numerals */
  ROMAN = 'ROMAN',
  /** Bulleted list */
  BULLETED = 'BULLETED',
  /** Alphabetical index */
  ALPHABETICAL_INDEX = 'ALPHABETICAL_INDEX',
  /** Alphabetical index (compact top-row only) */
  ALPHABETICAL_INDEX_COMPACT = 'ALPHABETICAL_INDEX_COMPACT',
}

/** @enumType */
/** @internal */
export type ListStyleWithLiterals =
  | ListStyle
  | 'PLAIN'
  | 'NUMBERED'
  | 'LETTERS'
  | 'ROMAN'
  | 'BULLETED'
  | 'ALPHABETICAL_INDEX'
  | 'ALPHABETICAL_INDEX_COMPACT';

/** Indentation style. */
/** @internal */
export enum Indentation {
  /** Sub-headings indented under parents (default) */
  NESTED = 'NESTED',
  /** All items at the same level */
  FLAT = 'FLAT',
}

/** @enumType */
/** @internal */
export type IndentationWithLiterals = Indentation | 'NESTED' | 'FLAT';

/** Data for a smart block node. */
/** @internal */
export interface SmartBlockData {
  /** The type of the smart block. */
  type?: SmartBlockDataTypeWithLiterals;
  /** Layout orientation. HORIZONTAL or VERTICAL. Optional for variants with fixed orientation. */
  orientation?: string | null;
  /** Column size controlling cells per row. */
  columnSize?: ColumnSizeWithLiterals;
  /**
   * Border color (for SOLID_JOINED_BOXES variant).
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Border width in pixels (for SOLID_JOINED_BOXES variant). */
  borderWidth?: number | null;
  /** Border radius in pixels (for SOLID_JOINED_BOXES variant). */
  borderRadius?: number | null;
}

/** Layout type of the smart block */
/** @internal */
export enum SmartBlockDataType {
  /** Grid-based layouts with solid box items containing title, body, and icon/image. */
  SOLID_BOXES = 'SOLID_BOXES',
  /** Numbered boxes. */
  NUMBERED_BOXES = 'NUMBERED_BOXES',
  /** Statistics display with large numbers/values. */
  STATS = 'STATS',
  /** Statistics with circular visual elements. */
  CIRCLE_STATS = 'CIRCLE_STATS',
  /** Staggered/zigzag grid layout with alternating box positions. */
  SOLID_BOXES_ALTERNATING = 'SOLID_BOXES_ALTERNATING',
  /** Grid layout with boxes visually joined (no gaps, shared container border). */
  SOLID_JOINED_BOXES = 'SOLID_JOINED_BOXES',
  /** Transparent cells with only a left side line. */
  SIDE_LINE_TEXT = 'SIDE_LINE_TEXT',
  /** Transparent cells with only a top line. */
  TOP_LINE_TEXT = 'TOP_LINE_TEXT',
  /** Outlined boxes with a numbered/icon circle at the top. */
  OUTLINE_BOXES_WITH_TOP_CIRCLE = 'OUTLINE_BOXES_WITH_TOP_CIRCLE',
  /** Large icon bullets with text content. */
  BIG_BULLETS = 'BIG_BULLETS',
  /** Small dot bullets with text content. */
  SMALL_BULLETS = 'SMALL_BULLETS',
  /** Arrow icon bullets with text content. */
  ARROW_BULLETS = 'ARROW_BULLETS',
  /** Process steps with numbered/icon labels above a horizontal line. */
  PROCESS_STEPS = 'PROCESS_STEPS',
  /** Statistics with bar visual elements. */
  BAR_STATS = 'BAR_STATS',
  /** Timeline layout with numbered chips on a connecting line; cells alternate around the line. */
  TIMELINE = 'TIMELINE',
  /** Timeline layout with plain dot indicators; no numbers or shapes; cells alternate around the line. */
  MINIMAL_TIMELINE = 'MINIMAL_TIMELINE',
  /** Numbered pill-shaped labels (stadium chips) with text content; supports HORIZONTAL (pill on top) and VERTICAL (pill on left) orientations. */
  PILLS = 'PILLS',
  /** Star rating display with stars and a numeric value per cell. */
  STAR_RATING = 'STAR_RATING',
  /** Outlined boxes with decorative quote glyphs at the top-left and bottom-right corners. */
  QUOTE_BOXES = 'QUOTE_BOXES',
  /** Donut/ring with numbered annular-sector segments; cell text labels sit outside the ring. */
  CIRCLE = 'CIRCLE',
  /** Hierarchical pyramid where each cell renders as a horizontal slice (apex at top, base at bottom) with the cell number or shape centered inside; text content sits beside (desktop) or below (mobile) the pyramid. */
  PYRAMID = 'PYRAMID',
  /** Cells render a horizontal bar whose width scales with cell index, creating a staircase pattern; bar carries the cell number or a custom shape. */
  STAIRCASE = 'STAIRCASE',
  /** Hierarchical funnel where each cell renders as a horizontal slice (wide at top, narrowing toward the bottom) with the cell number or shape centered inside; text content sits beside (desktop) or below (mobile) the funnel. */
  VERTICAL_FUNNEL = 'VERTICAL_FUNNEL',
}

/** @enumType */
/** @internal */
export type SmartBlockDataTypeWithLiterals =
  | SmartBlockDataType
  | 'SOLID_BOXES'
  | 'NUMBERED_BOXES'
  | 'STATS'
  | 'CIRCLE_STATS'
  | 'SOLID_BOXES_ALTERNATING'
  | 'SOLID_JOINED_BOXES'
  | 'SIDE_LINE_TEXT'
  | 'TOP_LINE_TEXT'
  | 'OUTLINE_BOXES_WITH_TOP_CIRCLE'
  | 'BIG_BULLETS'
  | 'SMALL_BULLETS'
  | 'ARROW_BULLETS'
  | 'PROCESS_STEPS'
  | 'BAR_STATS'
  | 'TIMELINE'
  | 'MINIMAL_TIMELINE'
  | 'PILLS'
  | 'STAR_RATING'
  | 'QUOTE_BOXES'
  | 'CIRCLE'
  | 'PYRAMID'
  | 'STAIRCASE'
  | 'VERTICAL_FUNNEL';

/** Column size controlling how many cells appear per row. */
/** @internal */
export enum ColumnSize {
  /** Up to 4 cells in a row. */
  SMALL = 'SMALL',
  /** Up to 3 cells in a row (default). */
  MEDIUM = 'MEDIUM',
  /** Up to 2 cells in a row. */
  LARGE = 'LARGE',
  /** 1 cell in a row. */
  EXTRA_LARGE = 'EXTRA_LARGE',
}

/** @enumType */
/** @internal */
export type ColumnSizeWithLiterals =
  | ColumnSize
  | 'SMALL'
  | 'MEDIUM'
  | 'LARGE'
  | 'EXTRA_LARGE';

/** Data for a smart block cell node. */
/** @internal */
export interface SmartBlockCellData {
  /** Optional label text for the cell (e.g., for stats variants). */
  label?: string | null;
  /** Shape file details. */
  shape?: Media;
  /**
   * Border color of the cell.
   * @maxLength 19
   */
  borderColor?: string | null;
  /** Border width in pixels. */
  borderWidth?: number | null;
  /** Border radius in pixels. */
  borderRadius?: number | null;
  /** The type of the parent smart block (must match parent). */
  type?: SmartBlockDataTypeWithLiterals;
  /**
   * Accent color for non-background variants (e.g., line, bullet, label color).
   * @maxLength 19
   */
  accentColor?: string | null;
  /**
   * Background color for background-based variants (SOLID_BOXES, SOLID_BOXES_ALTERNATING, SOLID_JOINED_BOXES).
   * @maxLength 19
   */
  backgroundColor?: string | null;
  /**
   * Shape fill color as a hexadecimal value.
   * @maxLength 19
   */
  shapeColor?: string | null;
}

/** @internal */
export interface CheckboxListData {
  /** Indentation level from 0-4. */
  indentation?: number;
  /** Offset level from 0-4. */
  offset?: number | null;
}

/** @internal */
export interface ListItemNodeData {
  /** Checkbox list item state. Defaults to `false`. */
  checked?: boolean | null;
}

/** @internal */
export interface V1Metadata {
  /** Schema version. */
  version?: number;
  /**
   * When the object was created.
   * @readonly
   * @deprecated
   */
  createdTimestamp?: Date | null;
  /**
   * When the object was most recently updated.
   * @deprecated
   */
  updatedTimestamp?: Date | null;
  /** Object ID. */
  id?: string | null;
}

/** @internal */
export interface DocumentStyle {
  /** Styling for H1 nodes. */
  headerOne?: TextNodeStyle;
  /** Styling for H2 nodes. */
  headerTwo?: TextNodeStyle;
  /** Styling for H3 nodes. */
  headerThree?: TextNodeStyle;
  /** Styling for H4 nodes. */
  headerFour?: TextNodeStyle;
  /** Styling for H5 nodes. */
  headerFive?: TextNodeStyle;
  /** Styling for H6 nodes. */
  headerSix?: TextNodeStyle;
  /** Styling for paragraph nodes. */
  paragraph?: TextNodeStyle;
  /** Styling for block quote nodes. */
  blockquote?: TextNodeStyle;
  /** Styling for code block nodes. */
  codeBlock?: TextNodeStyle;
}

/** @internal */
export interface TextNodeStyle {
  /** The decorations to apply to the node. */
  decorations?: Decoration[];
  /** Padding and background color for the node. */
  nodeStyle?: NodeStyle;
  /** Line height for text in the node. */
  lineHeight?: string | null;
}

/** @internal */
export interface CustomRefData {
  title?: string;
  anotherTitle?: string;
}

/** @internal */
export interface TranslatedMessageWithUniqueFieldRepeated {
  uniqueField?: string;
  message?: string;
}

/** @internal */
export interface TranslatedMessageWithIdRepeated {
  id?: string;
  message?: string;
}

/** @internal */
export interface DiscoveryMetaData {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title?: string | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  description?: string | null;
  /**
   * Searchable keywords
   * @maxSize 100
   */
  keywords?: Keywords[];
  /** Is searchable */
  searchable?: boolean;
}

/** @internal */
export interface InternalComponentMetadata {
  componentMetadata?: DiscoveryMetaData;
  /** @maxSize 500 */
  repeatedComponentMetadata?: DiscoveryMetaData[];
}

/** @internal */
export enum TestEnum {
  UNKNOWN_TEST_ENUM = 'UNKNOWN_TEST_ENUM',
  FIRST_TEST = 'FIRST_TEST',
  SECOND_TEST = 'SECOND_TEST',
}

/** @enumType */
/** @internal */
export type TestEnumWithLiterals =
  | TestEnum
  | 'UNKNOWN_TEST_ENUM'
  | 'FIRST_TEST'
  | 'SECOND_TEST';

/** SPI config - defines the relation between implementer URL and which types it is validates */
/** @internal */
export interface ComponentsValidatorConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
  /**
   * Component types that will be validated
   * @minSize 1
   * @maxSize 100
   */
  componentValidationTypes?: ComponentTypeWithLiterals[];
  /** Indicates whether the validation should affect real production */
  testMode?: boolean;
}

/** Component type */
export enum ComponentType {
  NONE = 'NONE',
  STUDIO = 'STUDIO',
  PLATFORM = 'PLATFORM',
  WORKER = 'WORKER',
  DASHBOARD = 'DASHBOARD',
  WIDGET = 'WIDGET',
  PAGE = 'PAGE',
  DASHBOARD_PLATFORM = 'DASHBOARD_PLATFORM',
  STUDIO_WIDGET = 'STUDIO_WIDGET',
  EMBEDDED_SCRIPT = 'EMBEDDED_SCRIPT',
  EXTENSION = 'EXTENSION',
  SNIPPET_SOLUTION = 'SNIPPET_SOLUTION',
  DATA_COMPONENT = 'DATA_COMPONENT',
  WEB = 'WEB',
  DC_CONFIG = 'DC_CONFIG',
  WIDGET_OUT_OF_IFRAME = 'WIDGET_OUT_OF_IFRAME',
  PAGE_OUT_OF_IFRAME = 'PAGE_OUT_OF_IFRAME',
  STATIC_FILE = 'STATIC_FILE',
  APP_CONFIG = 'APP_CONFIG',
  MULTIPLE_DASHBOARDS = 'MULTIPLE_DASHBOARDS',
  PAYMENTS_GATEWAY = 'PAYMENTS_GATEWAY',
  CODE_PACKAGE = 'CODE_PACKAGE',
  AUTOMATION_TRIGGER = 'AUTOMATION_TRIGGER',
  INVOICES_ACTIONS = 'INVOICES_ACTIONS',
  DASHBOARD_APPLICATION = 'DASHBOARD_APPLICATION',
  CONTACT_LABELS = 'CONTACT_LABELS',
  WIDGET_PLUGIN = 'WIDGET_PLUGIN',
  CROSS_SELL = 'CROSS_SELL',
  LOCAL_DELIVERY = 'LOCAL_DELIVERY',
  PAYMENT_PROVIDER = 'PAYMENT_PROVIDER',
  ECOM_MEMBERSHIPS = 'ECOM_MEMBERSHIPS',
  ECOM_LINE_ITEMS_ENRICHER = 'ECOM_LINE_ITEMS_ENRICHER',
  ECOM_SHIPPING_RATES = 'ECOM_SHIPPING_RATES',
  SHIPPING_LABEL_CARRIER = 'SHIPPING_LABEL_CARRIER',
  RESTAURANTS_POS = 'RESTAURANTS_POS',
  FICTIONAL_SHIPPING_PROVIDER = 'FICTIONAL_SHIPPING_PROVIDER',
  ALERT_ENRICHER = 'ALERT_ENRICHER',
  DATA_EXTENSIONS = 'DATA_EXTENSIONS',
  GENERIC_HOOKS = 'GENERIC_HOOKS',
  AUTOMATIONS_ACTION_PROVIDER = 'AUTOMATIONS_ACTION_PROVIDER',
  ECOM_CATALOG = 'ECOM_CATALOG',
  BACK_OFFICE_EXTENSION_CONTAINER = 'BACK_OFFICE_EXTENSION_CONTAINER',
  BACK_OFFICE_EXTENSION = 'BACK_OFFICE_EXTENSION',
  AUTOMATIONS_TRIGGER_PROVIDER = 'AUTOMATIONS_TRIGGER_PROVIDER',
  IDENTITY_PRE_REGISTRATION = 'IDENTITY_PRE_REGISTRATION',
  PREMIUM_PRODUCTS_PATHS = 'PREMIUM_PRODUCTS_PATHS',
  ECOM_CUSTOM_SCOPE = 'ECOM_CUSTOM_SCOPE',
  GIFT_CARDS_PROVIDER = 'GIFT_CARDS_PROVIDER',
  DEALER_EXTERNAL_FILTER_PROVIDER = 'DEALER_EXTERNAL_FILTER_PROVIDER',
  ECOM_DROPSHIPPING_PROVIDER = 'ECOM_DROPSHIPPING_PROVIDER',
  INVOICES_PROVIDER = 'INVOICES_PROVIDER',
  SEO_KEYWORDS_SUGGESTIONS = 'SEO_KEYWORDS_SUGGESTIONS',
  ECOM_DISCOUNTS_TRIGGER = 'ECOM_DISCOUNTS_TRIGGER',
  MULTILINGUAL_CONTENT_PROVIDER = 'MULTILINGUAL_CONTENT_PROVIDER',
  APPLICATION_AUTOMATION = 'APPLICATION_AUTOMATION',
  BACK_OFFICE_SIDEBAR_CATEGORY = 'BACK_OFFICE_SIDEBAR_CATEGORY',
  BACK_OFFICE_PAGE = 'BACK_OFFICE_PAGE',
  ECOM_ADDITIONAL_FEES = 'ECOM_ADDITIONAL_FEES',
  PING_USER_NOTIFICATION = 'PING_USER_NOTIFICATION',
  ECOM_RECOMMENDATIONS_PROVIDER = 'ECOM_RECOMMENDATIONS_PROVIDER',
  BOOKINGS_PRICING_PROVIDER = 'BOOKINGS_PRICING_PROVIDER',
  IDENTITY_AUTHENTICATOR = 'IDENTITY_AUTHENTICATOR',
  IDENTITY_IDP_CONNECTOR = 'IDENTITY_IDP_CONNECTOR',
  ITEMS_SELECTION_PROVIDER = 'ITEMS_SELECTION_PROVIDER',
  PORTFOLIO_SYNCED_PROJECTS_PROVIDER = 'PORTFOLIO_SYNCED_PROJECTS_PROVIDER',
  COMMUNICATION_CHANNEL = 'COMMUNICATION_CHANNEL',
  IDENTITY_POST_LOGIN = 'IDENTITY_POST_LOGIN',
  BACK_OFFICE_WIDGET = 'BACK_OFFICE_WIDGET',
  SOCIAL_MARKETING_DESIGN = 'SOCIAL_MARKETING_DESIGN',
  FORMS_SUBMISSIONS_PROVIDER = 'FORMS_SUBMISSIONS_PROVIDER',
  WIX_OFFERING = 'WIX_OFFERING',
  DEV_CENTER_TESTING_COMPONENT = 'DEV_CENTER_TESTING_COMPONENT',
  COMPONENTS_VALIDATOR_PROVIDER = 'COMPONENTS_VALIDATOR_PROVIDER',
  COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER = 'COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER',
  FORMS_SCHEMA_PROVIDER = 'FORMS_SCHEMA_PROVIDER',
  BOOKINGS_EXTERNAL_CALENDAR_PROVIDER = 'BOOKINGS_EXTERNAL_CALENDAR_PROVIDER',
  ECOM_DEFAULT_TAXATION_CATEGORY = 'ECOM_DEFAULT_TAXATION_CATEGORY',
  VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER = 'VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER',
  PING_UOU_NOTIFICATION = 'PING_UOU_NOTIFICATION',
  HEADLESS_OAUTH = 'HEADLESS_OAUTH',
  ECOM_TAX_CALCULATOR_SPI = 'ECOM_TAX_CALCULATOR_SPI',
  COMMENTS_MODERATION_PROVIDER = 'COMMENTS_MODERATION_PROVIDER',
  GRID_APP_FILES_TRANSFORMER = 'GRID_APP_FILES_TRANSFORMER',
  BENEFIT_PROGRAMS_POLICY_PROVIDER = 'BENEFIT_PROGRAMS_POLICY_PROVIDER',
  PREMIUM_CUSTOM_CHARGES = 'PREMIUM_CUSTOM_CHARGES',
  ECOM_VALIDATIONS = 'ECOM_VALIDATIONS',
  COMPONENT_REFERENCE_DATA_PROVIDER = 'COMPONENT_REFERENCE_DATA_PROVIDER',
  WIX_REVIEWS_PRODUCT_CATALOG = 'WIX_REVIEWS_PRODUCT_CATALOG',
  SOCIAL_MARKETING_DESIGNS_PROVIDER = 'SOCIAL_MARKETING_DESIGNS_PROVIDER',
  GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER = 'GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER',
  COMMENTS_FILTER_PROVIDER = 'COMMENTS_FILTER_PROVIDER',
  BILLING_TAX_ID_VALIDATOR = 'BILLING_TAX_ID_VALIDATOR',
  PING_SETTINGS_GROUP = 'PING_SETTINGS_GROUP',
  FORMS_SPAM_SUBMISSIONS_PROVIDER = 'FORMS_SPAM_SUBMISSIONS_PROVIDER',
  EDITOR_ADDON = 'EDITOR_ADDON',
  EXTERNAL_DATABASE_PROVIDER = 'EXTERNAL_DATABASE_PROVIDER',
  ECOM_PAYMENT_SETTINGS = 'ECOM_PAYMENT_SETTINGS',
  NOTIFICATION_TOPIC = 'NOTIFICATION_TOPIC',
  NOTIFICATION_PREFERENCES_FILTER_PROVIDER = 'NOTIFICATION_PREFERENCES_FILTER_PROVIDER',
  BOOKINGS_RESOURCE_TYPES_PROVIDER = 'BOOKINGS_RESOURCE_TYPES_PROVIDER',
  PRICING_PLANS_FORM_CONFIGURATION = 'PRICING_PLANS_FORM_CONFIGURATION',
  USER_NOTIFICATION = 'USER_NOTIFICATION',
  CONTACT_NOTIFICATION = 'CONTACT_NOTIFICATION',
  UNIFIED_PAGE = 'UNIFIED_PAGE',
  AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER = 'AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER',
  PROPOSAL_EDITOR_PROVIDER = 'PROPOSAL_EDITOR_PROVIDER',
  CUSTOM_TABLE_RESERVATIONS_PROVIDER = 'CUSTOM_TABLE_RESERVATIONS_PROVIDER',
  COMMENTS_CONTEXT_PROVIDER = 'COMMENTS_CONTEXT_PROVIDER',
  FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER = 'FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER',
  AUTOMATIONS_VELO_ACTION_PROVIDER = 'AUTOMATIONS_VELO_ACTION_PROVIDER',
  CALENDAR_EVENT_TYPE_PROVIDER = 'CALENDAR_EVENT_TYPE_PROVIDER',
  /** Reserved - previously was `SERVICE_AVAILABILITY_POLICY_PROVIDER` */
  RESERVED = 'RESERVED',
  SMS_ACTION_MESSAGE = 'SMS_ACTION_MESSAGE',
  BOOKING_POLICY_PROVIDER = 'BOOKING_POLICY_PROVIDER',
  MULTI_SERVICE_BOOKING_POLICY_PROVIDER = 'MULTI_SERVICE_BOOKING_POLICY_PROVIDER',
  AI_ASSISTANT = 'AI_ASSISTANT',
  FORMS_SUBMISSIONS_EXTENSION_PROVIDER = 'FORMS_SUBMISSIONS_EXTENSION_PROVIDER',
  MULTILINGUAL_TRANSLATION_SCHEMA = 'MULTILINGUAL_TRANSLATION_SCHEMA',
  TAX_CALCULATION_PROVIDER = 'TAX_CALCULATION_PROVIDER',
  TAX_GROUPS_PROVIDER = 'TAX_GROUPS_PROVIDER',
  BACK_OFFICE_MODAL = 'BACK_OFFICE_MODAL',
  DEPLOYMENT_PIPELINE_PROVIDER = 'DEPLOYMENT_PIPELINE_PROVIDER',
  CUSTOM_ELEMENT_WIDGET = 'CUSTOM_ELEMENT_WIDGET',
  BACK_OFFICE_EXTENSION_WIDGET = 'BACK_OFFICE_EXTENSION_WIDGET',
  BACK_OFFICE_EXTENSION_MENU_ITEM = 'BACK_OFFICE_EXTENSION_MENU_ITEM',
  FORM_TEMPLATE = 'FORM_TEMPLATE',
  NOTIFICATION_CONTENT = 'NOTIFICATION_CONTENT',
  BROADCAST_LIST = 'BROADCAST_LIST',
  PARTNERS_PAYOUTS = 'PARTNERS_PAYOUTS',
  WIX_REVIEWS_ENTITY_CATALOG = 'WIX_REVIEWS_ENTITY_CATALOG',
  VELO_PUBLISH_PIPELINE_TASK_PROVIDER = 'VELO_PUBLISH_PIPELINE_TASK_PROVIDER',
  FUNCTIONS_SHOP_PRICE_PROVIDER = 'FUNCTIONS_SHOP_PRICE_PROVIDER',
  FUNCTION = 'FUNCTION',
  ECOM_CHECKOUT_CONTENT = 'ECOM_CHECKOUT_CONTENT',
  COMMUNICATION_CHANNEL_PROVIDER = 'COMMUNICATION_CHANNEL_PROVIDER',
  WEBHOOK = 'WEBHOOK',
  TOPOLOGY = 'TOPOLOGY',
  LOYALTY_CUSTOM_REWARDS = 'LOYALTY_CUSTOM_REWARDS',
  FUNCTION_RECIPE = 'FUNCTION_RECIPE',
  BACK_OFFICE_EXTERNAL_URL = 'BACK_OFFICE_EXTERNAL_URL',
  IDENTITY_FACTOR = 'IDENTITY_FACTOR',
  ECOM_DISCOUNTS = 'ECOM_DISCOUNTS',
  VELO_CUSTOM_CSS = 'VELO_CUSTOM_CSS',
  DEALER_ADAPTIVE_COMPONENT_PROVIDER = 'DEALER_ADAPTIVE_COMPONENT_PROVIDER',
  AI_ASSISTANT_ACTION = 'AI_ASSISTANT_ACTION',
  ECOM_INVENTORY = 'ECOM_INVENTORY',
  MONITORING = 'MONITORING',
  PAPI_PROVIDER = 'PAPI_PROVIDER',
  UNIFIED_LIGHTBOX = 'UNIFIED_LIGHTBOX',
  FORMS_EXTENSION_PROVIDER = 'FORMS_EXTENSION_PROVIDER',
  MULTILINGUAL_TRANSLATION_SCHEMA_GROUP = 'MULTILINGUAL_TRANSLATION_SCHEMA_GROUP',
  PANEL = 'PANEL',
  PREMIUM_PURCHASE_VALIDATIONS = 'PREMIUM_PURCHASE_VALIDATIONS',
  BROWSER_STORAGE = 'BROWSER_STORAGE',
  SDK_DEFINITION = 'SDK_DEFINITION',
  SITE_WIDGET_SLOT = 'SITE_WIDGET_SLOT',
  CALENDAR_EVENT_VALIDATION_PROVIDER = 'CALENDAR_EVENT_VALIDATION_PROVIDER',
  CLIENT_SIDE_SERVICE = 'CLIENT_SIDE_SERVICE',
  BILLING_SETTINGS = 'BILLING_SETTINGS',
  PATTERNS_WIZARD = 'PATTERNS_WIZARD',
  APPLICATION_PROFILE = 'APPLICATION_PROFILE',
  TEXT_TO_SPEECH_ACTION_MESSAGE = 'TEXT_TO_SPEECH_ACTION_MESSAGE',
  AUDIENCE_PROVIDER = 'AUDIENCE_PROVIDER',
  PRICING_PLANS_PRICE = 'PRICING_PLANS_PRICE',
  PRICING_PLAN_START_DATE_LIMITS = 'PRICING_PLAN_START_DATE_LIMITS',
  PRICING_PLAN_START_DATE_RULES = 'PRICING_PLAN_START_DATE_RULES',
  EVENTS_TICKET_RESERVATIONS = 'EVENTS_TICKET_RESERVATIONS',
  PAYMENTS_DISPUTE_SERVICE_PLUGIN = 'PAYMENTS_DISPUTE_SERVICE_PLUGIN',
  PRICING_PLANS_FEES = 'PRICING_PLANS_FEES',
  EDITOR_REACT_COMPONENT = 'EDITOR_REACT_COMPONENT',
  SUPPLIERS_HUB_MARKETPLACE = 'SUPPLIERS_HUB_MARKETPLACE',
  FORM_SCHEMA_DYNAMIC_VALUES = 'FORM_SCHEMA_DYNAMIC_VALUES',
  BLOG_PAYWALL_PROVIDER = 'BLOG_PAYWALL_PROVIDER',
  LOYALTY_CUSTOM_REWARDS_V2 = 'LOYALTY_CUSTOM_REWARDS_V2',
  STORES_PRODUCT_RESTRICTIONS = 'STORES_PRODUCT_RESTRICTIONS',
  FORM_SUBMISSION_MODERATION = 'FORM_SUBMISSION_MODERATION',
  EVENTS_EVENT_BADGES = 'EVENTS_EVENT_BADGES',
  BILLING_OPERATION = 'BILLING_OPERATION',
  BACK_OFFICE_CUSTOMIZATION = 'BACK_OFFICE_CUSTOMIZATION',
  COMPONENT_ENRICHER_PROVIDER = 'COMPONENT_ENRICHER_PROVIDER',
  BACK_OFFICE_RESTRICTED_CUSTOMIZATION = 'BACK_OFFICE_RESTRICTED_CUSTOMIZATION',
  EDITOR_APP_PREVIEWS_POC = 'EDITOR_APP_PREVIEWS_POC',
  LEGENDS_PERSONA_CONFIGURATION = 'LEGENDS_PERSONA_CONFIGURATION',
  WIX_HOSTING_APP_DEPLOYMENT_PROVIDER = 'WIX_HOSTING_APP_DEPLOYMENT_PROVIDER',
  BACKEND_WORKER = 'BACKEND_WORKER',
  EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER = 'EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER',
  WIX_HOSTING_APP_ENVIRONMENT_PROVIDER = 'WIX_HOSTING_APP_ENVIRONMENT_PROVIDER',
  SDK_EXPORTS = 'SDK_EXPORTS',
  VIEWER_SERVICE = 'VIEWER_SERVICE',
  WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN = 'WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN',
  CONTACTS_SEGMENTS_V2_FILTER_PROVIDER = 'CONTACTS_SEGMENTS_V2_FILTER_PROVIDER',
  ANALYTICS_PRODUCT_CATALOG = 'ANALYTICS_PRODUCT_CATALOG',
  SITE_MIGRATION = 'SITE_MIGRATION',
  RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN = 'RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN',
  WIX_VIBE_CODING_INSTRUCTIONS = 'WIX_VIBE_CODING_INSTRUCTIONS',
  TAX_EXEMPT_GROUPS_PROVIDER = 'TAX_EXEMPT_GROUPS_PROVIDER',
  BOOKING_AUTOMATIONS_CONFIGURATION = 'BOOKING_AUTOMATIONS_CONFIGURATION',
  WIX_VIBE_COMPONENT = 'WIX_VIBE_COMPONENT',
  WIXEL = 'WIXEL',
  STAFF_SORTING_PROVIDER = 'STAFF_SORTING_PROVIDER',
  FUNCTION_ECOM_DISCOUNT_TRIGGER_ELIGIBILITY_PROVIDER = 'FUNCTION_ECOM_DISCOUNT_TRIGGER_ELIGIBILITY_PROVIDER',
  FUNCTIONS_ASSISTANT_TOOLS = 'FUNCTIONS_ASSISTANT_TOOLS',
  SITE_MAP_INFO_PROVIDER = 'SITE_MAP_INFO_PROVIDER',
  WIX_AI_GATEWAY_CALLBACK = 'WIX_AI_GATEWAY_CALLBACK',
  URL_MAPPER_PROVIDER = 'URL_MAPPER_PROVIDER',
  PROVIDER_SUPPRESSION_SERVICE_PLUGIN = 'PROVIDER_SUPPRESSION_SERVICE_PLUGIN',
  ECOM_FORMS = 'ECOM_FORMS',
  EDITOR_CONTEXT_PROVIDER = 'EDITOR_CONTEXT_PROVIDER',
  EDITOR_FUNCTION_LIBRARY = 'EDITOR_FUNCTION_LIBRARY',
  BOOKINGS_PLATFORM_CONFIGURATION = 'BOOKINGS_PLATFORM_CONFIGURATION',
  BOOKINGS_VALIDATION_PROVIDER = 'BOOKINGS_VALIDATION_PROVIDER',
  APP_ROUTER = 'APP_ROUTER',
  WIXEL_BINDING = 'WIXEL_BINDING',
  SHUB_MARKETPLACE_PROVIDER = 'SHUB_MARKETPLACE_PROVIDER',
  BOOKING_ACTION_URLS_PROVIDER = 'BOOKING_ACTION_URLS_PROVIDER',
  CALENDAR_CONFERENCING_PROVIDER = 'CALENDAR_CONFERENCING_PROVIDER',
  BASS_VALIDATE_CANCEL_ACTION = 'BASS_VALIDATE_CANCEL_ACTION',
  WIXEL_VIEWER_ROUTER_PROVIDER = 'WIXEL_VIEWER_ROUTER_PROVIDER',
  PREMIUM_ACTION = 'PREMIUM_ACTION',
  AUTOMATION_TEMPLATE = 'AUTOMATION_TEMPLATE',
  AGENT_MAKER_APPROVAL_PROVIDER = 'AGENT_MAKER_APPROVAL_PROVIDER',
  SERVICE_TAGS_CONFIGURATION = 'SERVICE_TAGS_CONFIGURATION',
  LOYALTY_POINTS_ADJUSTMENT = 'LOYALTY_POINTS_ADJUSTMENT',
  LOYALTY_EARN_POINTS_LIMIT = 'LOYALTY_EARN_POINTS_LIMIT',
  REALTIME_PERMISSIONS_PROVIDER = 'REALTIME_PERMISSIONS_PROVIDER',
  CALENDAR_SEARCH_PROVIDER = 'CALENDAR_SEARCH_PROVIDER',
  EDITOR_INSTALLATION = 'EDITOR_INSTALLATION',
  APP_ACTIONS = 'APP_ACTIONS',
  ROLLOUT_STEP_EXECUTOR = 'ROLLOUT_STEP_EXECUTOR',
  BOOKINGS_PLATFORM_PREMIUM_VALIDATION = 'BOOKINGS_PLATFORM_PREMIUM_VALIDATION',
  GLOBAL_CSS = 'GLOBAL_CSS',
  CONNECTOR_CONFIG = 'CONNECTOR_CONFIG',
  CHANNEL_DATA_PROVIDER = 'CHANNEL_DATA_PROVIDER',
}

/** @enumType */
export type ComponentTypeWithLiterals =
  | ComponentType
  | 'NONE'
  | 'STUDIO'
  | 'PLATFORM'
  | 'WORKER'
  | 'DASHBOARD'
  | 'WIDGET'
  | 'PAGE'
  | 'DASHBOARD_PLATFORM'
  | 'STUDIO_WIDGET'
  | 'EMBEDDED_SCRIPT'
  | 'EXTENSION'
  | 'SNIPPET_SOLUTION'
  | 'DATA_COMPONENT'
  | 'WEB'
  | 'DC_CONFIG'
  | 'WIDGET_OUT_OF_IFRAME'
  | 'PAGE_OUT_OF_IFRAME'
  | 'STATIC_FILE'
  | 'APP_CONFIG'
  | 'MULTIPLE_DASHBOARDS'
  | 'PAYMENTS_GATEWAY'
  | 'CODE_PACKAGE'
  | 'AUTOMATION_TRIGGER'
  | 'INVOICES_ACTIONS'
  | 'DASHBOARD_APPLICATION'
  | 'CONTACT_LABELS'
  | 'WIDGET_PLUGIN'
  | 'CROSS_SELL'
  | 'LOCAL_DELIVERY'
  | 'PAYMENT_PROVIDER'
  | 'ECOM_MEMBERSHIPS'
  | 'ECOM_LINE_ITEMS_ENRICHER'
  | 'ECOM_SHIPPING_RATES'
  | 'SHIPPING_LABEL_CARRIER'
  | 'RESTAURANTS_POS'
  | 'FICTIONAL_SHIPPING_PROVIDER'
  | 'ALERT_ENRICHER'
  | 'DATA_EXTENSIONS'
  | 'GENERIC_HOOKS'
  | 'AUTOMATIONS_ACTION_PROVIDER'
  | 'ECOM_CATALOG'
  | 'BACK_OFFICE_EXTENSION_CONTAINER'
  | 'BACK_OFFICE_EXTENSION'
  | 'AUTOMATIONS_TRIGGER_PROVIDER'
  | 'IDENTITY_PRE_REGISTRATION'
  | 'PREMIUM_PRODUCTS_PATHS'
  | 'ECOM_CUSTOM_SCOPE'
  | 'GIFT_CARDS_PROVIDER'
  | 'DEALER_EXTERNAL_FILTER_PROVIDER'
  | 'ECOM_DROPSHIPPING_PROVIDER'
  | 'INVOICES_PROVIDER'
  | 'SEO_KEYWORDS_SUGGESTIONS'
  | 'ECOM_DISCOUNTS_TRIGGER'
  | 'MULTILINGUAL_CONTENT_PROVIDER'
  | 'APPLICATION_AUTOMATION'
  | 'BACK_OFFICE_SIDEBAR_CATEGORY'
  | 'BACK_OFFICE_PAGE'
  | 'ECOM_ADDITIONAL_FEES'
  | 'PING_USER_NOTIFICATION'
  | 'ECOM_RECOMMENDATIONS_PROVIDER'
  | 'BOOKINGS_PRICING_PROVIDER'
  | 'IDENTITY_AUTHENTICATOR'
  | 'IDENTITY_IDP_CONNECTOR'
  | 'ITEMS_SELECTION_PROVIDER'
  | 'PORTFOLIO_SYNCED_PROJECTS_PROVIDER'
  | 'COMMUNICATION_CHANNEL'
  | 'IDENTITY_POST_LOGIN'
  | 'BACK_OFFICE_WIDGET'
  | 'SOCIAL_MARKETING_DESIGN'
  | 'FORMS_SUBMISSIONS_PROVIDER'
  | 'WIX_OFFERING'
  | 'DEV_CENTER_TESTING_COMPONENT'
  | 'COMPONENTS_VALIDATOR_PROVIDER'
  | 'COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER'
  | 'FORMS_SCHEMA_PROVIDER'
  | 'BOOKINGS_EXTERNAL_CALENDAR_PROVIDER'
  | 'ECOM_DEFAULT_TAXATION_CATEGORY'
  | 'VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER'
  | 'PING_UOU_NOTIFICATION'
  | 'HEADLESS_OAUTH'
  | 'ECOM_TAX_CALCULATOR_SPI'
  | 'COMMENTS_MODERATION_PROVIDER'
  | 'GRID_APP_FILES_TRANSFORMER'
  | 'BENEFIT_PROGRAMS_POLICY_PROVIDER'
  | 'PREMIUM_CUSTOM_CHARGES'
  | 'ECOM_VALIDATIONS'
  | 'COMPONENT_REFERENCE_DATA_PROVIDER'
  | 'WIX_REVIEWS_PRODUCT_CATALOG'
  | 'SOCIAL_MARKETING_DESIGNS_PROVIDER'
  | 'GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER'
  | 'COMMENTS_FILTER_PROVIDER'
  | 'BILLING_TAX_ID_VALIDATOR'
  | 'PING_SETTINGS_GROUP'
  | 'FORMS_SPAM_SUBMISSIONS_PROVIDER'
  | 'EDITOR_ADDON'
  | 'EXTERNAL_DATABASE_PROVIDER'
  | 'ECOM_PAYMENT_SETTINGS'
  | 'NOTIFICATION_TOPIC'
  | 'NOTIFICATION_PREFERENCES_FILTER_PROVIDER'
  | 'BOOKINGS_RESOURCE_TYPES_PROVIDER'
  | 'PRICING_PLANS_FORM_CONFIGURATION'
  | 'USER_NOTIFICATION'
  | 'CONTACT_NOTIFICATION'
  | 'UNIFIED_PAGE'
  | 'AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER'
  | 'PROPOSAL_EDITOR_PROVIDER'
  | 'CUSTOM_TABLE_RESERVATIONS_PROVIDER'
  | 'COMMENTS_CONTEXT_PROVIDER'
  | 'FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER'
  | 'AUTOMATIONS_VELO_ACTION_PROVIDER'
  | 'CALENDAR_EVENT_TYPE_PROVIDER'
  | 'RESERVED'
  | 'SMS_ACTION_MESSAGE'
  | 'BOOKING_POLICY_PROVIDER'
  | 'MULTI_SERVICE_BOOKING_POLICY_PROVIDER'
  | 'AI_ASSISTANT'
  | 'FORMS_SUBMISSIONS_EXTENSION_PROVIDER'
  | 'MULTILINGUAL_TRANSLATION_SCHEMA'
  | 'TAX_CALCULATION_PROVIDER'
  | 'TAX_GROUPS_PROVIDER'
  | 'BACK_OFFICE_MODAL'
  | 'DEPLOYMENT_PIPELINE_PROVIDER'
  | 'CUSTOM_ELEMENT_WIDGET'
  | 'BACK_OFFICE_EXTENSION_WIDGET'
  | 'BACK_OFFICE_EXTENSION_MENU_ITEM'
  | 'FORM_TEMPLATE'
  | 'NOTIFICATION_CONTENT'
  | 'BROADCAST_LIST'
  | 'PARTNERS_PAYOUTS'
  | 'WIX_REVIEWS_ENTITY_CATALOG'
  | 'VELO_PUBLISH_PIPELINE_TASK_PROVIDER'
  | 'FUNCTIONS_SHOP_PRICE_PROVIDER'
  | 'FUNCTION'
  | 'ECOM_CHECKOUT_CONTENT'
  | 'COMMUNICATION_CHANNEL_PROVIDER'
  | 'WEBHOOK'
  | 'TOPOLOGY'
  | 'LOYALTY_CUSTOM_REWARDS'
  | 'FUNCTION_RECIPE'
  | 'BACK_OFFICE_EXTERNAL_URL'
  | 'IDENTITY_FACTOR'
  | 'ECOM_DISCOUNTS'
  | 'VELO_CUSTOM_CSS'
  | 'DEALER_ADAPTIVE_COMPONENT_PROVIDER'
  | 'AI_ASSISTANT_ACTION'
  | 'ECOM_INVENTORY'
  | 'MONITORING'
  | 'PAPI_PROVIDER'
  | 'UNIFIED_LIGHTBOX'
  | 'FORMS_EXTENSION_PROVIDER'
  | 'MULTILINGUAL_TRANSLATION_SCHEMA_GROUP'
  | 'PANEL'
  | 'PREMIUM_PURCHASE_VALIDATIONS'
  | 'BROWSER_STORAGE'
  | 'SDK_DEFINITION'
  | 'SITE_WIDGET_SLOT'
  | 'CALENDAR_EVENT_VALIDATION_PROVIDER'
  | 'CLIENT_SIDE_SERVICE'
  | 'BILLING_SETTINGS'
  | 'PATTERNS_WIZARD'
  | 'APPLICATION_PROFILE'
  | 'TEXT_TO_SPEECH_ACTION_MESSAGE'
  | 'AUDIENCE_PROVIDER'
  | 'PRICING_PLANS_PRICE'
  | 'PRICING_PLAN_START_DATE_LIMITS'
  | 'PRICING_PLAN_START_DATE_RULES'
  | 'EVENTS_TICKET_RESERVATIONS'
  | 'PAYMENTS_DISPUTE_SERVICE_PLUGIN'
  | 'PRICING_PLANS_FEES'
  | 'EDITOR_REACT_COMPONENT'
  | 'SUPPLIERS_HUB_MARKETPLACE'
  | 'FORM_SCHEMA_DYNAMIC_VALUES'
  | 'BLOG_PAYWALL_PROVIDER'
  | 'LOYALTY_CUSTOM_REWARDS_V2'
  | 'STORES_PRODUCT_RESTRICTIONS'
  | 'FORM_SUBMISSION_MODERATION'
  | 'EVENTS_EVENT_BADGES'
  | 'BILLING_OPERATION'
  | 'BACK_OFFICE_CUSTOMIZATION'
  | 'COMPONENT_ENRICHER_PROVIDER'
  | 'BACK_OFFICE_RESTRICTED_CUSTOMIZATION'
  | 'EDITOR_APP_PREVIEWS_POC'
  | 'LEGENDS_PERSONA_CONFIGURATION'
  | 'WIX_HOSTING_APP_DEPLOYMENT_PROVIDER'
  | 'BACKEND_WORKER'
  | 'EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER'
  | 'WIX_HOSTING_APP_ENVIRONMENT_PROVIDER'
  | 'SDK_EXPORTS'
  | 'VIEWER_SERVICE'
  | 'WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN'
  | 'CONTACTS_SEGMENTS_V2_FILTER_PROVIDER'
  | 'ANALYTICS_PRODUCT_CATALOG'
  | 'SITE_MIGRATION'
  | 'RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN'
  | 'WIX_VIBE_CODING_INSTRUCTIONS'
  | 'TAX_EXEMPT_GROUPS_PROVIDER'
  | 'BOOKING_AUTOMATIONS_CONFIGURATION'
  | 'WIX_VIBE_COMPONENT'
  | 'WIXEL'
  | 'STAFF_SORTING_PROVIDER'
  | 'FUNCTION_ECOM_DISCOUNT_TRIGGER_ELIGIBILITY_PROVIDER'
  | 'FUNCTIONS_ASSISTANT_TOOLS'
  | 'SITE_MAP_INFO_PROVIDER'
  | 'WIX_AI_GATEWAY_CALLBACK'
  | 'URL_MAPPER_PROVIDER'
  | 'PROVIDER_SUPPRESSION_SERVICE_PLUGIN'
  | 'ECOM_FORMS'
  | 'EDITOR_CONTEXT_PROVIDER'
  | 'EDITOR_FUNCTION_LIBRARY'
  | 'BOOKINGS_PLATFORM_CONFIGURATION'
  | 'BOOKINGS_VALIDATION_PROVIDER'
  | 'APP_ROUTER'
  | 'WIXEL_BINDING'
  | 'SHUB_MARKETPLACE_PROVIDER'
  | 'BOOKING_ACTION_URLS_PROVIDER'
  | 'CALENDAR_CONFERENCING_PROVIDER'
  | 'BASS_VALIDATE_CANCEL_ACTION'
  | 'WIXEL_VIEWER_ROUTER_PROVIDER'
  | 'PREMIUM_ACTION'
  | 'AUTOMATION_TEMPLATE'
  | 'AGENT_MAKER_APPROVAL_PROVIDER'
  | 'SERVICE_TAGS_CONFIGURATION'
  | 'LOYALTY_POINTS_ADJUSTMENT'
  | 'LOYALTY_EARN_POINTS_LIMIT'
  | 'REALTIME_PERMISSIONS_PROVIDER'
  | 'CALENDAR_SEARCH_PROVIDER'
  | 'EDITOR_INSTALLATION'
  | 'APP_ACTIONS'
  | 'ROLLOUT_STEP_EXECUTOR'
  | 'BOOKINGS_PLATFORM_PREMIUM_VALIDATION'
  | 'GLOBAL_CSS'
  | 'CONNECTOR_CONFIG'
  | 'CHANNEL_DATA_PROVIDER';

/** @internal */
export interface ComponentTranslationAdditionalFieldsConfig {
  deploymentUri?: string;
}

/** @internal */
export interface FormSchemaSpiConfig {
  /**
   * URI where the SPI Implementer is deployed.
   * @maxLength 500
   */
  deploymentUri?: string;
  /**
   * Configuration of namespaces known by implementer.
   * @maxSize 3
   */
  namespaceConfigs?: FormsSchemaNamespaceConfig[];
}

/** @internal */
export interface FormsSchemaNamespaceConfig {
  /**
   * Namespace name.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /** Permissions associated with this namespace. */
  permissions?: FormsPermissions;
  /** Enable client specific form validation for the namespace, more info in ValidateFormSchema. */
  schemaValidationEnabled?: boolean;
  /** Restrictions associated with this namespace. */
  restrictions?: Restrictions;
  /** Enable translations with multilingual */
  multilingualEnabled?: boolean;
  /** Attempt to select unique name for form. */
  uniqueName?: boolean;
  /** Enable hook for applying form schema related changes before form save, more info in OnBeforeSave. */
  onBeforeSaveHookEnabled?: boolean;
  /**
   * Allow changing submission access level for forms in this namespace.
   * When false (default), forms in this namespace can only use OWNER_AND_COLLABORATORS.
   */
  allowSubmissionAccessOverride?: boolean;
}

/** @internal */
export interface FormsPermissions {
  /**
   * Create permission name
   * @maxLength 200
   */
  create?: string;
  /**
   * Delete permission name
   * @maxLength 200
   */
  delete?: string;
  /**
   * Update permission name
   * @maxLength 200
   */
  update?: string;
  /**
   * Read permission name
   * @maxLength 200
   */
  read?: string;
}

/** @internal */
export interface Restrictions {
  /**
   * Maximum amount of forms allowed per namespace.
   * @max 15000
   */
  maxFormsAmount?: number;
  /**
   * Maximum amount of fields allowed per form.
   * @max 200
   */
  maxFieldsAmount?: number;
}

/** @internal */
export interface ProviderConfig {
  /**
   * The name of the calendar provider.
   * @minLength 1
   */
  name?: string;
  /** The base URI in which all methods are deployed. */
  baseUri?: string;
  /** The provided calendar type. */
  calendarType?: CalendarTypeWithLiterals;
  /**
   * Connect methods used to connect to the calendar.
   * @minSize 1
   */
  connectMethods?: ConnectMethodWithLiterals[];
  /** Whether the sync configuration can be updated. */
  canUpdateSyncConfig?: boolean;
  /** Whether events can be listed from the external calendar to the Wix calendar. */
  listEventFromCalendars?: ListEventFromCalendarsWithLiterals;
  /** Whether Wix calendar sessions can be synced to the external calendar. */
  syncToCalendar?: SyncToCalendarWithLiterals;
}

/** @internal */
export enum CalendarType {
  UNDEFINED = 'UNDEFINED',
  GOOGLE = 'GOOGLE',
  I_CAL = 'I_CAL',
  MICROSOFT = 'MICROSOFT',
  OTHER = 'OTHER',
}

/** @enumType */
/** @internal */
export type CalendarTypeWithLiterals =
  | CalendarType
  | 'UNDEFINED'
  | 'GOOGLE'
  | 'I_CAL'
  | 'MICROSOFT'
  | 'OTHER';

/** @internal */
export enum ConnectMethod {
  OAUTH = 'OAUTH',
  CREDENTIALS = 'CREDENTIALS',
}

/** @enumType */
/** @internal */
export type ConnectMethodWithLiterals = ConnectMethod | 'OAUTH' | 'CREDENTIALS';

/** @internal */
export enum ListEventFromCalendars {
  /** Listing events from the external calendar is not supported. */
  LIST_NOT_SUPPORTED = 'LIST_NOT_SUPPORTED',
  /** Listing events from the primary external calendar only. */
  LIST_FROM_PRIMARY_CALENDAR_ONLY = 'LIST_FROM_PRIMARY_CALENDAR_ONLY',
  /**
   * Listing events from specific external calendars.
   * The external calendars can be listed using the `ExternalCalendarProvider.ListCalendars` API.
   */
  LIST_FROM_SPECIFIC_CALENDARS = 'LIST_FROM_SPECIFIC_CALENDARS',
}

/** @enumType */
/** @internal */
export type ListEventFromCalendarsWithLiterals =
  | ListEventFromCalendars
  | 'LIST_NOT_SUPPORTED'
  | 'LIST_FROM_PRIMARY_CALENDAR_ONLY'
  | 'LIST_FROM_SPECIFIC_CALENDARS';

/** @internal */
export enum SyncToCalendar {
  /** Syncing Wix calendar sessions to the external calendar is not supported. */
  SYNC_NOT_SUPPORTED = 'SYNC_NOT_SUPPORTED',
  /** Syncing Wix calendar sessions to the primary external calendar only. */
  SYNC_TO_PRIMARY_CALENDAR_ONLY = 'SYNC_TO_PRIMARY_CALENDAR_ONLY',
  /** Syncing Wix calendar sessions to a new external calendar. */
  SYNC_TO_DEDICATED_CALENDAR = 'SYNC_TO_DEDICATED_CALENDAR',
}

/** @enumType */
/** @internal */
export type SyncToCalendarWithLiterals =
  | SyncToCalendar
  | 'SYNC_NOT_SUPPORTED'
  | 'SYNC_TO_PRIMARY_CALENDAR_ONLY'
  | 'SYNC_TO_DEDICATED_CALENDAR';

/** @internal */
export interface DefaultTaxGroupProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
  /** User-friendly name of the tax category */
  taxationCategory?: string;
  additionalCategories?: Record<string, TaxationCategoryProvider>;
}

/** @internal */
export interface TaxationCategoryProvider {
  taxationCategory?: string;
  /**
   * must be a unique GUID for the category
   * @format GUID
   */
  taxationCategoryUuid?: string;
}

/** @internal */
export interface DynamicSiteStructureProviderConfig {
  /** URL to dynamic site structure provider service */
  deploymentUri?: string;
}

/** @internal */
export interface HeadlessOAuth {
  /**
   * ID of the site that uses the component.
   * @format GUID
   */
  siteId?: string;
  /** Allowlist of domains that can be redirected to after a login. */
  allowedDomains?: string[];
  /** Component description. */
  description?: string | null;
  /**
   * Login URL to automatically redirect users to from Wix pages.
   * @format WEB_URL
   */
  loginUrl?: string | null;
  /**
   * Array of URIs that can be redirected to after oAuth2 authorization.
   * @maxLength 2048
   */
  allowedRedirectUris?: string[];
  /** Whether a user can resolve the [app secret](https://dev.wix.com/docs/rest/internal-only/dev-center-platform/app-service/introduction). */
  blockSecretGeneration?: boolean;
  /**
   * Logout URL that is invoked when users logout from wix pages.
   * @format WEB_URL
   */
  logoutUrl?: string | null;
  /** OAuth application type. */
  applicationType?: OAuthAppTypeWithLiterals;
  /** OAuth technology used by the application. */
  technology?: OAuthTechnologiesWithLiterals;
  /**
   * List of domain mappings from external domains to Wix domains.
   *
   * When a user accesses a non-Wix domain, they can be automatically forwarded to the corresponding
   * Wix domain based on these mappings. This enables domain-level redirection from
   * external domains to Wix-hosted pages.
   * @maxSize 15
   */
  wixPagesDomainsMappings?: WixPagesDomainMapping[];
  /**
   * Redirect url for Wix-hosted pages.
   * @maxLength 1024
   */
  redirectUrlWixPages?: string | null;
}

/** Types of OAuth application. */
/** @internal */
export enum OAuthAppType {
  /** OAuth app type is not specified. */
  OAUTH_APP_TYPE_UNSPECIFIED = 'OAUTH_APP_TYPE_UNSPECIFIED',
  /** OAuth app type is a web application. */
  WEB_APP = 'WEB_APP',
  /** OAuth app type is a mobile application. */
  MOBILE = 'MOBILE',
  /** OAuth app type is some other type of application. */
  OTHER = 'OTHER',
  /** System OAuth app, isn't editable */
  SYSTEM = 'SYSTEM',
}

/** @enumType */
/** @internal */
export type OAuthAppTypeWithLiterals =
  | OAuthAppType
  | 'OAUTH_APP_TYPE_UNSPECIFIED'
  | 'WEB_APP'
  | 'MOBILE'
  | 'OTHER'
  | 'SYSTEM';

/** OAuth technology used by the oauth application. */
/** @internal */
export enum OAuthTechnologies {
  /** The OAuth technology is not specified. */
  OAUTH_TECHNOLOGY_UNSPECIFIED = 'OAUTH_TECHNOLOGY_UNSPECIFIED',
  /** OAuth technology using JavaScript. */
  JAVASCRIPT = 'JAVASCRIPT',
  /** OAuth technology using Angular. */
  ANGULAR = 'ANGULAR',
  /** OAuth technology using Vue.js. */
  VUE = 'VUE',
  /** OAuth technology using React. */
  REACT = 'REACT',
  /** OAuth technology using React Native. */
  REACT_NATIVE = 'REACT_NATIVE',
  /** OAuth technology using iOS. */
  IOS = 'IOS',
  /** OAuth technology using Android. */
  ANDROID = 'ANDROID',
  /** OAuth technology using some other kind of technology. */
  OTHER_TECHNOLOGY = 'OTHER_TECHNOLOGY',
}

/** @enumType */
/** @internal */
export type OAuthTechnologiesWithLiterals =
  | OAuthTechnologies
  | 'OAUTH_TECHNOLOGY_UNSPECIFIED'
  | 'JAVASCRIPT'
  | 'ANGULAR'
  | 'VUE'
  | 'REACT'
  | 'REACT_NATIVE'
  | 'IOS'
  | 'ANDROID'
  | 'OTHER_TECHNOLOGY';

/** @internal */
export interface WixPagesDomainMapping {
  /** @maxLength 2048 */
  origin?: string;
  /** @maxLength 2048 */
  destination?: string;
}

/** @internal */
export interface TaxCalculatorSpiConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
  /** User-friendly name of the tax calculator */
  calculatorDisplayName?: string;
  /** list of countries and boolean represents if its a white list or black list (supported or unsupported countries) */
  taxCountriesConfig?: TaxCountriesConfig;
}

/** @internal */
export interface TaxCountriesConfig {
  /**
   * list of countries
   * @format COUNTRY
   */
  countries?: string[];
  /** represents if the calculator supports tax in those countries or not */
  isSupported?: boolean;
}

/** @internal */
export interface CommentModerationProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: string;
  /** List of app ids which moderation implementation supports */
  supportedAppIds?: string[];
}

/** @internal */
export interface GridAppFilesTransformerConfig {
  /** URI where the SPI Implementer is deployed */
  uriConfig?: SpiBaseUri;
  /**
   * Transformation layout which should match to value from
   * [GridAppLayout](https://github.com/wix-private/wix-code/blob/master/editor/wix-code-ide-server-ng/proto/wix/velo/ide/v1/grid_app_layout.proto) enum.
   * The new values should be added via PR.
   */
  layout?: string;
  /**
   * List of paths which requires content transformation to GridApp format
   * @maxSize 10
   */
  filesContentToTransformToGridApp?: string[];
  /**
   * List of paths which requires content transformation to Layout format
   * @maxSize 10
   */
  filesContentToTransformToLayout?: string[];
}

/** @internal */
export interface PolicyConfig {
  /** URI where the SPI Implementer is deployed */
  uriConfig?: SpiBaseUri;
}

export interface CustomChargesConfig {
  /**
   * Base URI where the endpoints are called. Wix appends the endpoint path to the base URI.
   *
   * For example, to call the Premium Custom Charges endpoint at `https://custom-charges.com/v1/premium-custom-charges`, the base URI you provide here is `https://custom-charges.com/`.
   */
  baseUri?: SpiBaseUri;
}

export interface ValidationsSPIConfig {
  /** Whether to validate the cart page in addition to the checkout page. Default: `false` */
  validateInCart?: boolean;
  /**
   * Required. Base URI where the endpoints are called. Wix appends the endpoint path to the base URI.
   * For example, to call the Get Validation Violations endpoint at `https://my-validations.com/v1/get-violations`, the base URI you provide here is `https://my-validations.com`.
   * @minLength 1
   */
  deploymentUri?: string;
  /**
   * Optional WQL filter to apply to the validation info.
   * When provided, only validation info requests that match the filter will be sent to the implementer.
   * @internal
   */
  filter?: Record<string, any> | null;
}

/** SPI config - defines the relation between implementer URL and which types it saves */
/** @internal */
export interface ComponentReferenceDataConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /**
   * Component types that contains external (reference) data that is NOT saved in DevCenter.
   * @minSize 1
   * @maxSize 100
   */
  supportedComponentTypes?: ComponentTypeWithLiterals[];
}

/** Configuration for ReviewsProductCatalogProvider */
/** @internal */
export interface ReviewsProductCatalogProviderConfig {
  /** URI where the SPI Implementer is deployed */
  uriConfig?: SpiBaseUri;
  /** Namespace of catalog provider */
  namespace?: string;
  /** Flag that indicates if verified reviews are enabled */
  isVerifiedReviewsEnabled?: boolean;
}

/** @internal */
export interface SocialMarketingDesignsProviderConfig {
  /**
   * The URL of the SPI implementation
   * @minLength 1
   * @maxLength 1024
   */
  baseUri?: string;
  /**
   * Name of the provider
   * @minLength 1
   * @maxLength 1024
   */
  name?: string;
  /**
   * Component id (from dev center) of the editor
   * @format GUID
   */
  editorComponentId?: string;
  /**
   * Provider's icon, to be displayed in UI
   * @format WEB_URL
   */
  iconUrl?: string;
  /** How the Prover should be opened */
  navigationType?: NavigationTypeWithLiterals;
  /** Is delete design implemented by the provider */
  deleteDesignEnabled?: boolean;
  /** If the provider manages designs */
  manageDesigns?: boolean;
}

/** @internal */
export enum NavigationType {
  NAVIGATE = 'NAVIGATE',
  MODAL = 'MODAL',
}

/** @enumType */
/** @internal */
export type NavigationTypeWithLiterals = NavigationType | 'NAVIGATE' | 'MODAL';

/** @internal */
export interface GbpFeatureConfig {
  baseUri?: SpiBaseUri;
}

/** @internal */
export interface CommentFilterProviderConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /** List of app ids for which FilterComment should be invoked */
  supportedAppIds?: string[];
}

/** @internal */
export interface TaxIdValidatorConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /** User-friendly name of the tax id validator */
  validationProvider?: string;
  /** Configuration of supported tax types */
  taxTypesConfig?: TaxTypesConfig;
}

/** @internal */
export interface TaxTypesConfig {
  /** List of supported tax types, as provided in ValidateTaxIdRequest and persisted in TaxIdValidationService */
  supportedTaxTypes?: string[];
}

/** Describes a setting group of a notification */
/** @internal */
export interface PingSettingsGroupComponentData {
  title?: string;
  /** the description of the setting group */
  description?: string | null;
  /** the default state of the setting group */
  state?: PingSettingsGroupComponentDataStateWithLiterals;
}

/** @internal */
export enum PingSettingsGroupComponentDataState {
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  DEFAULT_ON = 'DEFAULT_ON',
  DEFAULT_OFF = 'DEFAULT_OFF',
  ALWAYS_ON = 'ALWAYS_ON',
}

/** @enumType */
/** @internal */
export type PingSettingsGroupComponentDataStateWithLiterals =
  | PingSettingsGroupComponentDataState
  | 'UNKNOWN_STATE'
  | 'DEFAULT_ON'
  | 'DEFAULT_OFF'
  | 'ALWAYS_ON';

/** @internal */
export interface FormSpamSubmissionSpiConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /**
   * Configuration of namespaces known by implementer
   * @maxSize 3
   */
  namespaceConfigs?: FormsSpamSubmissionsNamespaceConfig[];
}

/** @internal */
export interface FormsSpamSubmissionsNamespaceConfig {
  /**
   * Namespace name.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /** Permissions associated with this namespace. */
  permissions?: SpamSubmissionPermissions;
  /**
   * Disables Wix spam submissions filter.
   * Spam submissions are persisted in spam submissions storage to support marking submissions as not spam.
   */
  wixSpamFilterDisabled?: boolean;
}

/** @internal */
export interface SpamSubmissionPermissions {
  /**
   * Create permission name
   * @maxLength 50
   */
  create?: string;
  /**
   * Delete permission name
   * @maxLength 50
   */
  delete?: string;
  /**
   * Update permission name
   * @maxLength 50
   */
  update?: string;
  /**
   * Read permission name
   * @maxLength 50
   */
  read?: string;
  /**
   * Report as not spam permission name
   * @maxLength 50
   */
  reportNotSpam?: string;
}

/** Editor Add-on component */
export interface EditorAddon {
  /**
   * Deprecated, use editor_script
   * @format WEB_URL
   * @deprecated Deprecated, use editor_script
   * @replacedBy editor_script
   * @targetRemovalDate 2025-06-01
   */
  editorScriptUrl?: string;
  /** Tool panel configuration. */
  toolPanelConfig?: ToolPanelConfig;
  /** Information to display in the addons market. */
  marketData?: AddonMarketData;
  /**
   * Optional, path to a Javascript file that will run in Editor environment
   * @format WEB_URL
   */
  editorScript?: string | null;
  /** Toggle to mark whether the editor should revoke an app that contains this component. */
  excludeFromAutoRevoke?: boolean;
}

/** @internal */
export interface InitialPosition {
  /** Offset from the left. For example, `"50px"`. */
  x?: string;
  /** Offset from the top. For example, `"50px"`. */
  y?: string;
}

/** @internal */
export interface ToolPanelConfig {
  /**
   * Iframe URL that hosts the add-on tool panel's content.
   * @format WEB_URL
   */
  url?: string;
  /** Addon tool panel width. */
  width?: string;
  /** Addon tool panel height. */
  height?: string;
  /**
   * Initial position of the opened panel.
   * Offset from top left corner of the container.
   */
  initialPosition?: InitialPosition;
}

/** @internal */
export interface AddonMarketData {
  /**
   * Addon name.
   * @minLength 5
   */
  name?: string;
  /**
   * Deprecated, use teaser
   * @minLength 10
   * @deprecated
   * @replacedBy teaser
   * @targetRemovalDate 2025-06-01
   */
  description?: string;
  /**
   * URL source of the addon's icon. Must be 36px x 36px in JPG or PNG format.
   * @format WEB_URL
   */
  iconUrl?: string | null;
  /** Author's name. */
  author?: string;
  /**
   * Addon teaser.
   * @minLength 10
   * @maxLength 60
   */
  teaser?: string | null;
}

export interface ExternalDatabaseSpiConfig {
  /** The URI where the service provider is deployed. */
  uriConfig?: SpiBaseUri;
  /** The namespace of the external database. This can be used to access collections within the database, for example `namespace/collectionId`. */
  namespace?: string;
  /**
   * Indicates if database is managed by WIX.
   * @internal
   */
  databaseManagedByWix?: boolean | null;
}

export interface PaymentSettingsSPIConfig {
  /**
   * Base URI where the endpoints are called. Wix eCommerce appends the endpoint path to the base URI.
   * For example, to call the Get Payment Settings endpoint at `https://my-payment-settings.com/v1/payment-settings`, the base URI you provide here is `https://my-payment-settings.com/`.
   */
  deploymentUri?: string;
  /**
   * The fallback value that is used for [`requires3dSecure`](https://support.wix.com/en/article/about-3d-secure-3ds-payments-with-third-party-payment-providers) if the service plugin call fails.
   *
   * Default: `false`
   */
  fallbackValueForRequires3dSecure?: boolean;
}

/** Describes topic of a notification */
/** @internal */
export interface NotificationTopic {
  /** the description of the topic */
  description?: string | null;
  /** the default state of the topic */
  state?: NotificationTopicStateWithLiterals;
  /** the type of the topic */
  type?: NotificationTopicTypeWithLiterals;
  /**
   * Set to true if this topic supports multi location.
   * @internal
   */
  multilocationSupported?: boolean;
  /**
   * The recipients' types indicate that this topic is relevant.
   * @maxSize 10
   */
  supportedRecipientTypes?: RecipientTypeWithLiterals[];
}

/** @internal */
export enum NotificationTopicState {
  UNKNOWN_STATE = 'UNKNOWN_STATE',
  DEFAULT_ON = 'DEFAULT_ON',
  DEFAULT_OFF = 'DEFAULT_OFF',
  ALWAYS_ON = 'ALWAYS_ON',
}

/** @enumType */
/** @internal */
export type NotificationTopicStateWithLiterals =
  | NotificationTopicState
  | 'UNKNOWN_STATE'
  | 'DEFAULT_ON'
  | 'DEFAULT_OFF'
  | 'ALWAYS_ON';

/** @internal */
export enum NotificationTopicType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  PROMOTIONAL = 'PROMOTIONAL',
  TRANSACTIONAL = 'TRANSACTIONAL',
}

/** @enumType */
/** @internal */
export type NotificationTopicTypeWithLiterals =
  | NotificationTopicType
  | 'UNKNOWN_TYPE'
  | 'PROMOTIONAL'
  | 'TRANSACTIONAL';

/** Recipient type */
/** @internal */
export enum RecipientType {
  UNKNOWN_RECIPIENT_TYPE = 'UNKNOWN_RECIPIENT_TYPE',
  /** Wix User */
  WIX_USER = 'WIX_USER',
  /** Contact */
  CONTACT = 'CONTACT',
}

/** @enumType */
/** @internal */
export type RecipientTypeWithLiterals =
  | RecipientType
  | 'UNKNOWN_RECIPIENT_TYPE'
  | 'WIX_USER'
  | 'CONTACT';

/** @internal */
export interface NotificationPreferencesFilterConfig {
  /** the base URI where all the methods are deployed. E.g. "https://golden-coupons.com/wix-provider" */
  baseUri?: SpiBaseUri;
}

/** This config provides details of the resource types that are managed by an app implementing this component SPI. */
/** @internal */
export interface BookingsResourceTypesProviderConfig {
  /**
   * References of the resource types that are managed by the app that implements this component SPI.
   * @maxSize 10
   */
  bookingsResourceTypes?: BookingsResourceType[];
}

/** @internal */
export interface BookingsResourceType {
  /**
   * The ID of the resource type. Must be a GUID that is unique within the app.
   * @format GUID
   */
  id?: string | null;
  /**
   * The name of the resource type. This can be any string, such as 'staff' or 'table'.
   * @minLength 1
   * @maxLength 40
   */
  name?: string | null;
}

/** @internal */
export interface PricingPlansFormConfiguration {
  /** *Plan preview** section configuration. */
  planPreview?: PlanFormPreviewSection;
  /** *Plan info** section configuration. */
  infoSection?: PlanFormInfoSection;
  /** *Settings** section configuration. */
  settingsSection?: PlanFormPlanSettingsSection;
  /** *Benefits** section configuration. */
  benefitsSection?: PlanFormBenefitsSection;
  /**
   * *Pricing options** section configuration.
   * DEPRECATED: Use pricing_section and duration_section instead. Will be removed in future versions.
   * @deprecated *Pricing options** section configuration.
   * DEPRECATED: Use pricing_section and duration_section instead. Will be removed in future versions.
   * @replacedBy pricing_section & duration_section
   * @targetRemovalDate 2025-11-30
   */
  pricingAndDurationSection?: PlanFormPricingAndDurationSection;
  /**
   * Custom sections for the form.
   * @maxSize 99
   */
  customSections?: PlanFormCustomSection[];
  /**
   * Order in which sections will be rendered. Can include default section IDs or custom section component IDs.
   * Visible sections that don't exist in this array are displayed below others in default oder.
   * @maxSize 99
   */
  sectionOrder?: PlanFormSection[];
  /** Custom plan form metadata. */
  metadata?: PlanFormTypeMetadata;
  /** *Page permissions** section configuration. */
  pagePermissions?: PlanFormPagePermissionsSection;
  /** Initial plan data for form defaults. */
  initialPlanValue?: PlanFormInitialValue;
  /**
   * Unique custom form name.
   * @minLength 1
   * @maxLength 100
   */
  formName?: string;
  /** *Pricing** section configuration. */
  pricingSection?: PlanFormPricingSection;
  /** *Duration** section configuration. */
  durationSection?: PlanFormDurationSection;
  /** *Custom pricing rules** Functions based pricing rules section configuration. */
  customPricingRulesSection?: PlanFormCustomPricingRulesSection;
  /** *Start date** functions based start date rules section configuration. */
  startDateRulesSection?: PlanFormStartDateRulesSection;
}

/** @internal */
export interface TextWithTooltip {
  /** Displayed text. */
  text?: string;
  /** Tooltip to show next to text. */
  tooltip?: TooltipSuffix;
}

/** @internal */
export interface TooltipSuffix {
  /** Tooltip content. */
  text?: string;
}

/** @internal */
export interface TextWithSuffix extends TextWithSuffixSuffixOneOf {
  /** Tooltip to show next to the text. */
  suffixTooltip?: TooltipSuffix;
  /** Link to show next to the text. */
  suffixLink?: LinkSuffix;
  /** Whether to hide the element. */
  hide?: boolean;
  /** Displayed text. */
  text?: string;
}

/** @oneof */
/** @internal */
export interface TextWithSuffixSuffixOneOf {
  /** Tooltip to show next to the text. */
  suffixTooltip?: TooltipSuffix;
  /** Link to show next to the text. */
  suffixLink?: LinkSuffix;
}

/** @internal */
export interface LinkSuffix {
  /** Whether to hide the element. */
  hide?: boolean;
  /** Link text. */
  text?: string;
  /** External URL to open on link click. */
  url?: string;
  /** Text that is passed to click BI event as `referral_info` field. */
  referralInfo?: string;
}

/** @internal */
export interface PreviewCardPlaceholders {
  /** Placeholder plan name for preview. */
  name?: string;
}

/** @internal */
export interface InputWithPlaceholder {
  /** Input label. */
  label?: TextWithTooltip;
  /** Input placeholder. */
  placeholder?: string;
}

/** @internal */
export interface CoverImageConfiguration {
  /** Whether to hide the cover image input. */
  hide?: boolean;
  /** Cover image input label. */
  label?: TextWithTooltip;
}

/** @internal */
export interface PerksConfiguration {
  /** Whether to hide the **Perks** subsection. */
  hide?: boolean;
  /** *Perks** subsection title. */
  title?: TextWithTooltip;
  /** Perks input placeholder. */
  placeholder?: string;
}

/** @internal */
export interface CheckboxConfiguration {
  /** Policy agreement checkbox input label. */
  label?: string;
  /** Policy checkbox toggle configuration. */
  acceptRequiredToggle?: TextWithTooltip;
  /** Checked by default toggle configuration. */
  acceptedByDefaultToggle?: TextWithTooltip;
}

/** @internal */
export interface PreviewConfiguration {
  /** Preview card title. */
  title?: string;
  /** Preview card subtitle. */
  subtitle?: string;
  /** Label for checkbox in preview. */
  checkboxLabel?: string;
  /** Text for **Buy now** in preview. */
  buttonText?: string;
}

/** @internal */
export interface TermsModalConfiguration {
  /** Modal title. */
  title?: string;
  /** Modal subtitle. */
  subtitle?: string;
  /** Save button text. */
  primaryButtonText?: string;
  /** Cancel button text. */
  secondaryButtonText?: string;
  /** Terms and conditions input configuration. */
  input?: InputWithPlaceholder;
  /** Policy agreement checkbox input configuration. */
  checkbox?: CheckboxConfiguration;
  /** Terms and conditions preview configuration. */
  preview?: PreviewConfiguration;
  /** Modal footer text. */
  footer?: string;
}

/** @internal */
export interface ThankYouPageInputConfig {
  /** Whether to hide input. */
  hide?: boolean;
  /** Label config. */
  label?: TextWithTooltip;
}

/** @internal */
export interface ThankYouPageRedirectsConfiguration {
  /** Whether to hide redirects. */
  hide?: boolean;
  /** Redirects field label. */
  label?: TextWithTooltip;
  /** Home Page option label. */
  homePageOption?: string;
  /** Other Page option label. */
  redirectUrlOption?: string;
}

/** @internal */
export interface ThankYouPagePreviewConfiguration {
  /** Preview card title. */
  title?: string;
  /** Preview card subtitle. */
  subtitle?: string;
}

/** @internal */
export interface ThankYouPageModalConfiguration {
  /** Modal title. */
  title?: string;
  /** Modal subtitle. */
  subtitle?: TextWithSuffix;
  /** Save button text. */
  primaryButtonText?: string;
  /** Cancel button text. */
  secondaryButtonText?: string;
  /** Reset default button text. */
  resetButtonText?: string;
  /** Thank you page title input configuration. */
  titleInput?: ThankYouPageInputConfig;
  /** Thank you page content input configuration. */
  messageInput?: ThankYouPageInputConfig;
  /** Thank you page button text input configuration. */
  buttonTextInput?: ThankYouPageInputConfig;
  /** Thank you page button action field configuration. */
  redirects?: ThankYouPageRedirectsConfiguration;
  /** Thank you page preview configuration. */
  preview?: ThankYouPagePreviewConfiguration;
}

/** @internal */
export interface PlanSettingsRowConfiguration {
  /** Whether to hide the row. */
  hide?: boolean;
  /** Row title. */
  title?: TextWithTooltip;
  /** Row subtitle. */
  subtitle?: TextWithTooltip;
}

/** @internal */
export interface TermsAndConditionsConfiguration {
  /** Whether to hide the row. */
  hide?: boolean;
  /** Row title. */
  title?: TextWithTooltip;
  /** Row subtitle. */
  subtitle?: TextWithTooltip;
  /** "Plan policies" modal configuration. */
  modal?: TermsModalConfiguration;
}

/** @internal */
export interface ThankYouPageConfiguration {
  /** Whether to hide the row. */
  hide?: boolean;
  /** Row title. */
  title?: TextWithTooltip;
  /** Row subtitle. */
  subtitle?: TextWithTooltip;
  /** "\Thank you page modal configuration. */
  modal?: ThankYouPageModalConfiguration;
}

/** @internal */
export interface PlanFormPricingAndDurationSectionDurationInputConfiguration {
  /** Duration dropdown label. */
  label?: TextWithTooltip;
  /** Duration dropdown placeholder. */
  placeholder?: string;
  /** Labels for duration dropdown options. */
  renameOptions?: DurationInputConfigurationDurationRenameOptions;
}

/** @internal */
export interface DurationInputConfigurationDurationRenameOptions {
  /** Text for "Forever" duration option. */
  forever?: string;
  /** Text for "Custom" duration option. */
  custom?: string;
}

/** @internal */
export interface PlanFormPricingAndDurationSectionInputConfiguration {
  /** Input label. */
  label?: TextWithTooltip;
}

/** @internal */
export interface SetupFeeConfiguration {
  /** Hide **Setup fee** toggle. */
  hide?: boolean;
  /** Setup fee toggle label. */
  label?: TextWithTooltip;
  /** Setup fee amount input configuration. */
  amount?: InputWithPlaceholder;
  /** Setup fee name input configuration. */
  name?: InputWithPlaceholder;
}

/** @internal */
export interface FreeTrialConfiguration {
  /** Whether to hide the **Free trial** toggle. */
  hide?: boolean;
  /** Free trial toggle label. */
  label?: TextWithTooltip;
  /** Free trial duration dropdown configuration. */
  duration?: PlanFormPricingAndDurationSectionInputConfiguration;
}

/** @internal */
export interface FreeOptionConfiguration {
  /** Whether to hide the **Free** option. */
  hide?: boolean;
  /** Option title. */
  title?: string;
  /** Option subtitle. */
  subtitle?: string;
  /** Plan duration dropdown configuration. */
  duration?: PlanFormPricingAndDurationSectionDurationInputConfiguration;
  /** Custom duration period dropdown configuration. */
  customDurationPeriod?: PlanFormPricingAndDurationSectionInputConfiguration;
  /** Custom  duration input configuration. */
  customDurationInput?: PlanFormPricingAndDurationSectionInputConfiguration;
}

/** @internal */
export interface OneTimeOptionConfiguration {
  /** Whether to hide the One-time payment option. */
  hide?: boolean;
  /** Option title. */
  title?: string;
  /** Option subtitle. */
  subtitle?: string;
  /** Plan duration dropdown configuration. */
  duration?: PlanFormPricingAndDurationSectionDurationInputConfiguration;
  /** Custom duration period dropdown configuration. */
  customDurationPeriod?: PlanFormPricingAndDurationSectionInputConfiguration;
  /** Custom  duration input configuration. */
  customDurationInput?: PlanFormPricingAndDurationSectionInputConfiguration;
  /** Price input configuration. */
  price?: InputWithPlaceholder;
  /** Setup fee field configuration. */
  setupFee?: SetupFeeConfiguration;
}

/** @internal */
export interface RecurringOptionConfiguration {
  /** Whether to hide the "recurring" option. */
  hide?: boolean;
  /** Option title. */
  title?: string;
  /** Option subtitle. */
  subtitle?: string;
  /** Plan duration dropdown configuration. */
  duration?: PlanFormPricingAndDurationSectionDurationInputConfiguration;
  /** Price input configuration. */
  price?: InputWithPlaceholder;
  /** Setup fee field configuration. */
  setupFee?: SetupFeeConfiguration;
  /** Free trial field configuration. */
  freeTrial?: FreeTrialConfiguration;
  /** Frequency dropdown configuration. */
  frequency?: PlanFormPricingAndDurationSectionInputConfiguration;
  /** Custom frequency input configuration. */
  customFrequency?: PlanFormPricingAndDurationSectionInputConfiguration;
}

/** @internal */
export enum PlanFormPricingOption {
  UNKNOWN_OPTION = 'UNKNOWN_OPTION',
  FREE = 'FREE',
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

/** @enumType */
/** @internal */
export type PlanFormPricingOptionWithLiterals =
  | PlanFormPricingOption
  | 'UNKNOWN_OPTION'
  | 'FREE'
  | 'ONE_TIME'
  | 'RECURRING';

/** @internal */
export interface PlanFormPricingSectionSetupFeeConfiguration {
  /** Hide **Setup fee** toggle. */
  hide?: boolean;
  /** Setup fee toggle label. */
  label?: TextWithTooltip;
  /** Setup fee amount input configuration. */
  amount?: InputWithPlaceholder;
  /** Setup fee name input configuration. */
  name?: InputWithPlaceholder;
}

/** @internal */
export interface PlanFormPricingSectionInputConfiguration {
  /** Input label. */
  label?: TextWithTooltip;
}

/** @internal */
export interface RecurringPricingTypeConfigurationFreeTrialConfiguration {
  /** Whether to hide the **Free trial** toggle. */
  hide?: boolean;
  /** Free trial toggle label. */
  label?: TextWithTooltip;
  /** Free trial duration dropdown configuration. */
  duration?: PlanFormPricingSectionInputConfiguration;
}

/** @internal */
export interface FreePricingTypeConfiguration {
  /** Whether to hide the **Free** type. */
  hide?: boolean;
  /**
   * Type title.
   * @maxLength 40
   */
  title?: string;
  /**
   * Type subtitle.
   * @maxLength 60
   */
  subtitle?: string;
}

/** @internal */
export interface OneTimePricingTypeConfiguration {
  /** Whether to hide the **One-time payment** type. */
  hide?: boolean;
  /**
   * Type title.
   * @maxLength 40
   */
  title?: string;
  /**
   * Type subtitle.
   * @maxLength 60
   */
  subtitle?: string;
  /** Price input configuration. */
  price?: InputWithPlaceholder;
  /** Setup fee field configuration. */
  setupFee?: PlanFormPricingSectionSetupFeeConfiguration;
}

/** @internal */
export interface RecurringPricingTypeConfiguration {
  /** Whether to hide the **Recurring** type. */
  hide?: boolean;
  /**
   * Type title.
   * @maxLength 40
   */
  title?: string;
  /**
   * Type subtitle.
   * @maxLength 60
   */
  subtitle?: string;
  /** Price input configuration. */
  price?: InputWithPlaceholder;
  /** Setup fee field configuration. */
  setupFee?: PlanFormPricingSectionSetupFeeConfiguration;
  /** Free trial field configuration. */
  freeTrial?: RecurringPricingTypeConfigurationFreeTrialConfiguration;
  /** Frequency dropdown configuration. */
  frequency?: PlanFormPricingSectionInputConfiguration;
  /** Custom frequency input configuration. */
  customFrequency?: PlanFormPricingSectionInputConfiguration;
}

/** @internal */
export enum PlanFormPricingType {
  UNKNOWN_OPTION = 'UNKNOWN_OPTION',
  FREE = 'FREE',
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

/** @enumType */
/** @internal */
export type PlanFormPricingTypeWithLiterals =
  | PlanFormPricingType
  | 'UNKNOWN_OPTION'
  | 'FREE'
  | 'ONE_TIME'
  | 'RECURRING';

/** @internal */
export interface DurationRenameOptions {
  /**
   * Text for "Forever" duration option.
   * @maxLength 16
   */
  forever?: string;
  /**
   * Text for "Custom" duration option.
   * @maxLength 16
   */
  custom?: string;
}

/** @internal */
export interface DurationInputConfiguration {
  /** Duration dropdown label. */
  label?: TextWithTooltip;
  /**
   * Duration dropdown placeholder.
   * @maxLength 16
   */
  placeholder?: string;
  /** Labels for duration dropdown options. */
  renameOptions?: DurationRenameOptions;
}

/** @internal */
export interface InputConfiguration {
  /** Input label. */
  label?: TextWithTooltip;
}

/** @internal */
export enum PlanFormDefaultSection {
  UNKNWON_PLAN_FORM_SECTION = 'UNKNWON_PLAN_FORM_SECTION',
  INFO = 'INFO',
  BENEFITS = 'BENEFITS',
  PAGE_PERMISSIONS = 'PAGE_PERMISSIONS',
  PRICING_AND_DURATION = 'PRICING_AND_DURATION',
  ADVANCED_SETTINGS = 'ADVANCED_SETTINGS',
  PRICING = 'PRICING',
  DURATION = 'DURATION',
  CUSTOM_PRICING_RULES = 'CUSTOM_PRICING_RULES',
  START_DATE_RULES = 'START_DATE_RULES',
}

/** @enumType */
/** @internal */
export type PlanFormDefaultSectionWithLiterals =
  | PlanFormDefaultSection
  | 'UNKNWON_PLAN_FORM_SECTION'
  | 'INFO'
  | 'BENEFITS'
  | 'PAGE_PERMISSIONS'
  | 'PRICING_AND_DURATION'
  | 'ADVANCED_SETTINGS'
  | 'PRICING'
  | 'DURATION'
  | 'CUSTOM_PRICING_RULES'
  | 'START_DATE_RULES';

/** @internal */
export interface Illustration extends IllustrationIllustrationOneOf {
  /**
   * Custom exported component ID to be rendered as an illustration.
   * @format GUID
   */
  componentId?: string;
  /** 96x96px image. Used in type choice modal. */
  src?: string;
}

/** @oneof */
/** @internal */
export interface IllustrationIllustrationOneOf {
  /**
   * Custom exported component ID to be rendered as an illustration.
   * @format GUID
   */
  componentId?: string;
  /** 96x96px image. Used in type choice modal. */
  src?: string;
}

/** @internal */
export interface PlanDuration {
  /** Amount of a duration `unit` in a single payment cycle. */
  count?: number;
  /** Unit of time for the cycle duration. */
  unit?: PlanPeriodUnitWithLiterals;
}

/** Pedefined basic time unit. */
/** @internal */
export enum PlanPeriodUnit {
  UNDEFINED = 'UNDEFINED',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

/** @enumType */
/** @internal */
export type PlanPeriodUnitWithLiterals =
  | PlanPeriodUnit
  | 'UNDEFINED'
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'YEAR';

/** @internal */
export interface PlanPriceData {
  /** Monetary amount. Decimal string with a period as a decimal separator. For example, `3.99`. */
  value?: string;
  /** Currency code. Must be valid ISO 4217 currency code. For example, USD. */
  currency?: string;
}

/** @internal */
export interface PricingRecurring {
  /** Length of one payment cycle. */
  cycleDuration?: PlanDuration;
  /**
   * Amount of payment cycles this subscription is valid for.
   *
   * `0` indicates unlimited or until it is canceled.
   */
  cycleCount?: number;
}

/** @internal */
export interface PerkValues {
  /**
   * List of perks.
   * @maxSize 99
   */
  values?: string[];
}

/** @internal */
export interface PlanPricing extends PlanPricingPricingModelOneOf {
  /** Plan has recurring payments. */
  subscription?: PricingRecurring;
  /** One time payment. Plan is valid for the specified duration. */
  singlePaymentForDuration?: PlanDuration;
  /** One time payment. Plan is valid until it is canceled. */
  singlePaymentUnlimited?: boolean;
  /** Amount for a single payment. */
  price?: PlanPriceData;
}

/** @oneof */
/** @internal */
export interface PlanPricingPricingModelOneOf {
  /** Plan has recurring payments. */
  subscription?: PricingRecurring;
  /** One time payment. Plan is valid for the specified duration. */
  singlePaymentForDuration?: PlanDuration;
  /** One time payment. Plan is valid until it is canceled. */
  singlePaymentUnlimited?: boolean;
}

/** @internal */
export interface PlanFormPreviewSection {
  /** Whether to hide the **Preview** section. */
  hide?: boolean;
  /** Preview card title. */
  title?: TextWithTooltip;
  /** Preview card subtitle. */
  subtitle?: TextWithSuffix;
  /** Placeholders for previewed plan. */
  placeholders?: PreviewCardPlaceholders;
  /** Stick **Preview** section to the right while scrolling. As a result, all other sections will be narrower. */
  isSticky?: boolean | null;
}

/** @internal */
export interface PlanFormInfoSection {
  /** Whether to hide the **Info** section. If `true`, remaining fields are ignored. */
  hide?: boolean;
  /** Tooltip title. */
  title?: TextWithTooltip;
  /** Tooltip subtitle. */
  subtitle?: TextWithSuffix;
  /** Plan name input configuration. */
  name?: InputWithPlaceholder;
  /** Plan tagline input configuration. */
  tagline?: InputWithPlaceholder;
  /** Cover image configuration. */
  coverImage?: CoverImageConfiguration;
  /** Plan perks configuration. */
  perks?: PerksConfiguration;
}

/** @internal */
export interface PlanFormPlanSettingsSection {
  /** Whether to hide the **Advanced settings** section. */
  hide?: boolean;
  /** Section title configuration. */
  title?: TextWithTooltip;
  /** Section subtitle configuration. */
  subtitle?: TextWithSuffix;
  /** Configuration for "Limit to 1 purchase per person" plan setting. */
  singlePurchase?: PlanSettingsRowConfiguration;
  /** Configuration for "Allow plan cancellation" plan setting. */
  allowCancellation?: PlanSettingsRowConfiguration;
  /** Configuration for "Let people set start date" plan setting. */
  customStartDate?: PlanSettingsRowConfiguration;
  /** Configuration for "Add a policy" plan setting. */
  termsAndConditions?: TermsAndConditionsConfiguration;
  /** Configuration for "Collect additional info" plan setting. */
  customForms?: PlanSettingsRowConfiguration;
  /** Configuration for "Customize a Thank You page" plan setting. */
  thankYouPage?: ThankYouPageConfiguration;
}

/** @internal */
export interface PlanFormBenefitsSection {
  /** Hide **Benefits** section. */
  hide?: boolean;
  /** *Benefits** section title. */
  title?: TextWithTooltip;
  /** *Benefits** section subtitle. */
  subtitle?: TextWithSuffix;
  /** Suffix link configuration. Rendered at the right side of section header. */
  suffix?: LinkSuffix;
  /**
   * Hide specific benefits from the section.
   * @maxSize 99
   */
  hiddenBenefits?: string[];
}

/** @internal */
export interface PlanFormPricingAndDurationSection {
  /** Whether to hide **Pricing and Duration** section. */
  hide?: boolean;
  /** Section title. */
  title?: TextWithTooltip;
  /** Section subtitle. */
  subtitle?: TextWithSuffix;
  /** Free pricing option configuration. */
  freePricingOption?: FreeOptionConfiguration;
  /** One-time payment pricing option configuration. */
  oneTimeOption?: OneTimeOptionConfiguration;
  /** Recurring pricing option configuration. */
  recurringOption?: RecurringOptionConfiguration;
  /**
   * Order in which pricing options should be displayed.
   * @maxSize 99
   */
  pricingOptionOrder?: PlanFormPricingOptionWithLiterals[];
}

/** @internal */
export interface PlanFormCustomSection {
  /**
   * ID of dashboard extension component.
   * Extensions should have the following container ID: `fb869315-532f-4057-9049-e316f94e192f`
   * @format GUID
   */
  componentId?: string;
}

/** @internal */
export interface PlanFormSection extends PlanFormSectionSectionOneOf {
  /** Extension component ID. */
  componentId?: string;
  /** Default section name. */
  sectionName?: PlanFormDefaultSectionWithLiterals;
}

/** @oneof */
/** @internal */
export interface PlanFormSectionSectionOneOf {
  /** Extension component ID. */
  componentId?: string;
  /** Default section name. */
  sectionName?: PlanFormDefaultSectionWithLiterals;
}

/** @internal */
export interface PlanFormTypeMetadata {
  /** Configuration name. */
  title?: string;
  /** Plan type subtitle. Used in type choice modal. */
  subtitle?: string;
  /** Plan type description. Used in type choice modal. */
  description?: string;
  /** Plan type illustration. Used in type choice modal. */
  illustration?: Illustration;
  /** Your business manager module ID. */
  moduleId?: string;
}

/** @internal */
export interface PlanFormPagePermissionsSection {
  /** Whether to hide the **Page permissions** section. */
  hide?: boolean;
}

/** @internal */
export interface PlanFormInitialValue {
  /** Plan name. */
  name?: string | null;
  /** Plan description. */
  description?: string | null;
  /** What is included with this plan. */
  perks?: PerkValues;
  /** Plan price, payment schedule, and expiration. */
  pricing?: PlanPricing;
  /** Whether the plan is public. */
  public?: boolean | null;
  /**
   * Number of times the same buyer can purchase the plan.
   *
   * Supported values:
   * - `null | 0`: No limitation.
   * - `1`: Limit of one purchase per buyer.
   */
  maxPurchasesPerBuyer?: number | null;
  /** Whether the buyer can start the plan at a future date. */
  allowFutureStartDate?: boolean | null;
  /** Whether the buyer is allowed to cancel their plan. */
  buyerCanCancel?: boolean | null;
  /**
   * Any terms and conditions that apply to the plan. This information will be displayed during checkout.
   * @maxLength 3000
   */
  termsAndConditions?: string | null;
  /** Additional plan data. */
  clientData?: Record<string, string>;
}

/** @internal */
export interface PlanFormPricingSection {
  /** Whether to hide **Pricing** section. */
  hide?: boolean;
  /** Section title. */
  title?: TextWithTooltip;
  /** Section subtitle. */
  subtitle?: TextWithSuffix;
  /** Free pricing type configuration. */
  freePricingType?: FreePricingTypeConfiguration;
  /** One-time payment pricing type configuration. */
  oneTimeType?: OneTimePricingTypeConfiguration;
  /** Recurring pricing type configuration. */
  recurringType?: RecurringPricingTypeConfiguration;
  /**
   * Order in which pricing types should be displayed.
   * @maxSize 99
   */
  pricingTypeOrder?: PlanFormPricingTypeWithLiterals[];
}

/** @internal */
export interface PlanFormDurationSection {
  /** Whether to hide **Duration** section. */
  hide?: boolean;
  /** Section title. */
  title?: TextWithTooltip;
  /** Section subtitle. */
  subtitle?: TextWithSuffix;
  /** Plan duration dropdown configuration. */
  duration?: DurationInputConfiguration;
  /** Custom duration period dropdown configuration - only for **One-time** & **Free** plan types. */
  customDurationPeriod?: InputConfiguration;
  /** Custom duration input configuration - only for **One-time** & **Free** plan types. */
  customDurationInput?: InputConfiguration;
}

/** @internal */
export interface PlanFormCustomPricingRulesSection {
  /** Whether to hide the **Custom pricing rules** section. */
  hide?: boolean;
}

/** @internal */
export interface PlanFormStartDateRulesSection {
  /** Whether to hide the **Start date** section. */
  hide?: boolean;
}

/** Describes user notifications */
/** @internal */
export interface UserNotification {
  /**
   * @internal
   * @format GUID
   */
  referenceId?: string | null;
  referenceData?: UserNotificationData;
}

/** @internal */
export interface UserNotificationData {
  /**
   * name
   * @internal
   */
  name?: string | null;
  /** description */
  description?: string | null;
  /**
   * topic id
   * @minLength 1
   * @format GUID
   */
  topicId?: string | null;
  /** channels */
  channels?: NotificationChannels;
  /** icon */
  icon?: Icon;
  /** intent */
  intent?: IntentWithLiterals;
  /** limiter field */
  limiterField?: LimiterField;
  /** recipient filter */
  recipientFilter?: UserNotificationDataRecipientFilter;
  /** initiator */
  initiator?: UserNotificationDataInitiator;
  /** single deeplink */
  singleDeeplink?: UserNotificationDataDeeplink;
  /** grouped deeplink */
  groupedDeeplink?: UserNotificationDataDeeplink;
  /** context */
  context?: UserNotificationDataContext;
  /** type */
  type?: UserNotificationDataTypeWithLiterals;
}

/** @internal */
export interface TypedDynamicParam {
  /**
   * name
   * @minLength 1
   */
  name?: string;
  /** dynamic param type */
  dynamicParamType?: TypedDynamicParamTypeWithLiterals;
}

/** @internal */
export enum TypedDynamicParamType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  STRING = 'STRING',
  ARRAY = 'ARRAY',
}

/** @enumType */
/** @internal */
export type TypedDynamicParamTypeWithLiterals =
  | TypedDynamicParamType
  | 'UNKNOWN_TYPE'
  | 'STRING'
  | 'ARRAY';

/** @internal */
export enum UserNotificationDataRecipientFilterType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WIX_USERS = 'WIX_USERS',
  SITE_CONTRIBUTORS = 'SITE_CONTRIBUTORS',
}

/** @enumType */
/** @internal */
export type UserNotificationDataRecipientFilterTypeWithLiterals =
  | UserNotificationDataRecipientFilterType
  | 'UNKNOWN_TYPE'
  | 'WIX_USERS'
  | 'SITE_CONTRIBUTORS';

/** @internal */
export interface WixUsersData {
  /** id */
  id?: TypedDynamicParam;
}

/** @internal */
export interface SiteContributorsData {
  /** @minSize 1 */
  permissions?: string[];
}

/** @internal */
export enum InitiatorType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WIX_USER = 'WIX_USER',
  WIX_APP = 'WIX_APP',
}

/** @enumType */
/** @internal */
export type InitiatorTypeWithLiterals =
  | InitiatorType
  | 'UNKNOWN_TYPE'
  | 'WIX_USER'
  | 'WIX_APP';

/** @internal */
export interface WixUserData {
  /**
   * dynamic param name
   * @minLength 1
   */
  dynamicParamName?: string;
}

/** @internal */
export interface ConstOrDynamicParam extends ConstOrDynamicParamValueOneOf {
  /**
   * dynamic param name
   * @minLength 1
   */
  dynamicParamName?: string;
  /**
   * constant
   * @minLength 1
   */
  constant?: string;
}

/** @oneof */
/** @internal */
export interface ConstOrDynamicParamValueOneOf {
  /**
   * dynamic param name
   * @minLength 1
   */
  dynamicParamName?: string;
  /**
   * constant
   * @minLength 1
   */
  constant?: string;
}

/** @internal */
export interface Url {
  constOrDynamicParam?: ConstOrDynamicParam;
}

/** @internal */
export interface BackofficeActionDeeplink {
  /**
   * app ID
   * @minLength 1
   */
  appId?: string;
  /** params */
  params?: Record<string, ConstOrDynamicParam>;
}

/** @internal */
export enum Level {
  UNKNOWN_LEVEL = 'UNKNOWN_LEVEL',
  ACCOUNT = 'ACCOUNT',
  USER = 'USER',
  SITE = 'SITE',
}

/** @enumType */
/** @internal */
export type LevelWithLiterals =
  | Level
  | 'UNKNOWN_LEVEL'
  | 'ACCOUNT'
  | 'USER'
  | 'SITE';

/** @internal */
export interface OrderValue {
  /** can be const/dynamicParamName */
  value?: ConstOrDynamicParam;
  /**
   * order
   * @min 1
   */
  order?: number;
}

/** @internal */
export interface NotificationChannels {
  /** email */
  email?: EmailChannel;
  /** feed */
  feed?: FeedChannels;
  /** mobile push */
  mobilePush?: MobilePushChannel;
  /** voice */
  voice?: VoiceChannel;
  /** sms */
  sms?: SmsChannel;
  /** browser push */
  browserPush?: BrowserPushChannel;
  contentMap?: Record<string, string>;
}

/** @internal */
export interface ResponsysEmail {
  /**
   * responsys email
   * @minLength 1
   */
  responsysTemplate?: string;
}

/** @internal */
export interface VelocityEmail {
  /**
   * velocity module name
   * @minLength 1
   */
  velocityModuleName?: string;
  /**
   * template file
   * @minLength 1
   */
  templateFile?: string;
}

/** @internal */
export interface ShoutoutEmail {
  /**
   * template ID
   * @minLength 1
   */
  templateId?: string;
  /**
   * stream by
   * @minLength 1
   */
  streamBy?: string;
  /**
   * template msid
   * @minLength 1
   */
  templateMsid?: string;
}

/** @internal */
export interface EmailTemplateConfig extends EmailTemplateConfigProviderOneOf {
  /** responsys email */
  responsysEmail?: ResponsysEmail;
  /**
   * velocity email
   * @internal
   */
  velocityEmail?: VelocityEmail;
  /**
   * shoutout email
   * @internal
   */
  shoutoutEmail?: ShoutoutEmail;
}

/** @oneof */
/** @internal */
export interface EmailTemplateConfigProviderOneOf {
  /** responsys email */
  responsysEmail?: ResponsysEmail;
  /**
   * velocity email
   * @internal
   */
  velocityEmail?: VelocityEmail;
  /**
   * shoutout email
   * @internal
   */
  shoutoutEmail?: ShoutoutEmail;
}

/** @internal */
export interface WebFeedContentKeys {
  /** title */
  title?: string | null;
  /** message */
  message?: string | null;
  /** action */
  action?: string | null;
  /** group of two message */
  groupOfTwoMessage?: string | null;
  /** group of many message */
  groupOfManyMessage?: string | null;
  /** group of many action */
  groupOfManyAction?: string | null;
}

/** @internal */
export interface MobileFeedContentKeys {
  /** title */
  title?: string | null;
  /** message */
  message?: string | null;
  /** action */
  action?: string | null;
  /** group of two message */
  groupOfTwoMessage?: string | null;
  /** group of many message */
  groupOfManyMessage?: string | null;
  /** group of many action */
  groupOfManyAction?: string | null;
}

/** @internal */
export interface FeedAggregation {
  /**
   * group key
   * @minLength 1
   */
  groupKey?: string;
  /**
   * window
   * @minLength 1
   */
  window?: string;
  /** icon */
  icon?: Icon;
}

/** @internal */
export interface Icon extends IconDataOneOf {
  /** url data */
  urlData?: UrlData;
  /** icon type */
  type?: IconTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface IconDataOneOf {
  /** url data */
  urlData?: UrlData;
}

/** @internal */
export enum IconType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  URL = 'URL',
  SPOUT = 'SPOUT',
  INITIATOR = 'INITIATOR',
}

/** @enumType */
/** @internal */
export type IconTypeWithLiterals =
  | IconType
  | 'UNKNOWN_TYPE'
  | 'URL'
  | 'SPOUT'
  | 'INITIATOR';

/** @internal */
export interface UrlData {
  /**
   * actual url
   * @format WEB_URL
   */
  url?: string;
}

/** @internal */
export interface WebFeedChannel {
  /** content_keys */
  contentKeys?: WebFeedContentKeys;
}

/** @internal */
export interface MobileFeedChannel {
  /** content keys */
  contentKeys?: MobileFeedContentKeys;
}

/** @internal */
export interface FeedChannelsConfig {
  /** aggregation */
  aggregation?: FeedAggregation;
}

/** @internal */
export interface SharedPlatformMobilePushConfig {
  /** sound */
  sound?: string;
  /** group key */
  groupKey?: string | null;
  /** ttl */
  ttl?: number | null;
  /** target application */
  targetApplication?: MobileApplicationWithLiterals;
}

/** @internal */
export enum MobileApplication {
  UNKNOWN_MOBILE_APPLICATION = 'UNKNOWN_MOBILE_APPLICATION',
  OWNER = 'OWNER',
  SPACES = 'SPACES',
  DINE = 'DINE',
  FITNESS = 'FITNESS',
  WIX_LIFE = 'WIX_LIFE',
  WIX_PARTNERS = 'WIX_PARTNERS',
  BRANDED = 'BRANDED',
  WIX_STUDIO = 'WIX_STUDIO',
  NO_SPECIFIC_TARGET_APP = 'NO_SPECIFIC_TARGET_APP',
}

/** @enumType */
/** @internal */
export type MobileApplicationWithLiterals =
  | MobileApplication
  | 'UNKNOWN_MOBILE_APPLICATION'
  | 'OWNER'
  | 'SPACES'
  | 'DINE'
  | 'FITNESS'
  | 'WIX_LIFE'
  | 'WIX_PARTNERS'
  | 'BRANDED'
  | 'WIX_STUDIO'
  | 'NO_SPECIFIC_TARGET_APP';

/** @internal */
export interface AndroidMobilePushConfig {
  /** sub group key */
  subGroupKey?: string | null;
  /** style */
  style?: AndroidStyleWithLiterals;
  /** grouped deeplink pattern */
  groupedDeeplinkPattern?: string | null;
  /**
   * os settings category
   * @internal
   */
  osSettingsCategory?: string | null;
}

/** @internal */
export enum AndroidStyle {
  UNKNOWN_ANDROID_STYLE = 'UNKNOWN_ANDROID_STYLE',
  BIG_TEXT = 'BIG_TEXT',
  MESSAGING = 'MESSAGING',
  INBOX = 'INBOX',
}

/** @enumType */
/** @internal */
export type AndroidStyleWithLiterals =
  | AndroidStyle
  | 'UNKNOWN_ANDROID_STYLE'
  | 'BIG_TEXT'
  | 'MESSAGING'
  | 'INBOX';

/** @internal */
export interface MobilePushChannelConfig {
  /** shared */
  shared?: SharedPlatformMobilePushConfig;
  /** android */
  android?: AndroidMobilePushConfig;
}

/** @internal */
export interface MobilePushContentKeys {
  /** title */
  title?: string | null;
  /** message */
  message?: string | null;
  /** group of many title */
  groupOfManyTitle?: string | null;
  /** group of many message */
  groupOfManyMessage?: string | null;
  /** master group name override */
  masterGroupNameOverride?: string | null;
}

/** @internal */
export interface ExposureRule extends ExposureRuleRuleOneOf {
  /** boolean experiment exposure rule */
  booleanExperimentExposureRule?: BooleanExperimentExposureRule;
  /** custom experiment exposure rule */
  customExperimentExposureRule?: CustomExperimentExposureRule;
  /** type */
  type?: ExposureRuleTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ExposureRuleRuleOneOf {
  /** boolean experiment exposure rule */
  booleanExperimentExposureRule?: BooleanExperimentExposureRule;
  /** custom experiment exposure rule */
  customExperimentExposureRule?: CustomExperimentExposureRule;
}

/** @internal */
export enum ExposureRuleType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  OPEN_TO_ALL = 'OPEN_TO_ALL',
  OPEN_TO_NONE = 'OPEN_TO_NONE',
  BOOLEAN_EXPERIMENT = 'BOOLEAN_EXPERIMENT',
  CUSTOM_EXPERIMENT = 'CUSTOM_EXPERIMENT',
}

/** @enumType */
/** @internal */
export type ExposureRuleTypeWithLiterals =
  | ExposureRuleType
  | 'UNKNOWN_TYPE'
  | 'OPEN_TO_ALL'
  | 'OPEN_TO_NONE'
  | 'BOOLEAN_EXPERIMENT'
  | 'CUSTOM_EXPERIMENT';

/** @internal */
export interface BooleanExperimentExposureRule {
  /** spec */
  spec?: string;
}

/** @internal */
export interface CustomExperimentExposureRule {
  /** spec */
  spec?: string;
  /** default value */
  defaultValue?: string;
  /** expected value */
  expectedValue?: string;
}

/** @internal */
export interface VoiceContentKeys {
  /** message */
  message?: string | null;
}

/** @internal */
export interface SmsContentKeys {
  /** message */
  message?: string | null;
}

/** @internal */
export interface BrowserPushContentKeys {
  /** title */
  title?: string | null;
  /** message */
  message?: string | null;
}

/** @internal */
export interface EmailChannel {
  /** config */
  config?: EmailTemplateConfig;
}

/** @internal */
export interface FeedChannels {
  /** web feed */
  webFeed?: WebFeedChannel;
  /** mobile feed */
  mobileFeed?: MobileFeedChannel;
  /** config */
  config?: FeedChannelsConfig;
}

/** @internal */
export interface MobilePushChannel {
  /** config */
  config?: MobilePushChannelConfig;
  /** content_keys */
  contentKeys?: MobilePushContentKeys;
  /**
   * exposure rule
   * @internal
   */
  exposure?: ExposureRule;
}

/** @internal */
export interface VoiceChannel {
  /** content keys */
  contentKeys?: VoiceContentKeys;
}

/** @internal */
export interface SmsChannel {
  /** content_keys */
  contentKeys?: SmsContentKeys;
}

/** @internal */
export interface BrowserPushChannel {
  /** content_keys */
  contentKeys?: BrowserPushContentKeys;
}

/** @internal */
export enum Intent {
  UNKNOWN_INTENT = 'UNKNOWN_INTENT',
  MARKETING = 'MARKETING',
  TRANSACTIONAL = 'TRANSACTIONAL',
}

/** @enumType */
/** @internal */
export type IntentWithLiterals =
  | Intent
  | 'UNKNOWN_INTENT'
  | 'MARKETING'
  | 'TRANSACTIONAL';

/** @internal */
export interface LimiterField {
  /** dynamic param name */
  dynamicParamName?: string;
}

/** @internal */
export interface UserNotificationDataRecipientFilter
  extends UserNotificationDataRecipientFilterDataOneOf {
  /** wix users data */
  wixUsersData?: WixUsersData;
  /** site contributors data */
  siteContributorsData?: SiteContributorsData;
  /** recipient filter type */
  type?: UserNotificationDataRecipientFilterTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface UserNotificationDataRecipientFilterDataOneOf {
  /** wix users data */
  wixUsersData?: WixUsersData;
  /** site contributors data */
  siteContributorsData?: SiteContributorsData;
}

/** @internal */
export interface UserNotificationDataInitiator
  extends UserNotificationDataInitiatorDataOneOf {
  /** wix user data */
  wixUserData?: WixUserData;
  /** initiator type */
  type?: InitiatorTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface UserNotificationDataInitiatorDataOneOf {
  /** wix user data */
  wixUserData?: WixUserData;
}

/** @internal */
export interface UserNotificationDataDeeplink
  extends UserNotificationDataDeeplinkOfOneOf {
  /** url */
  url?: Url;
  /**
   * backoffice
   * @internal
   */
  backoffice?: BackofficeActionDeeplink;
  /**
   * account id parameter name
   * @internal
   */
  accountIdParamName?: string | null;
}

/** @oneof */
/** @internal */
export interface UserNotificationDataDeeplinkOfOneOf {
  /** url */
  url?: Url;
  /**
   * backoffice
   * @internal
   */
  backoffice?: BackofficeActionDeeplink;
}

/** @internal */
export interface UserNotificationDataContext {
  level?: LevelWithLiterals;
  /** params */
  params?: Record<string, OrderValue>;
}

/** @internal */
export enum UserNotificationDataType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  REGULAR = 'REGULAR',
  ALERT_WARNING = 'ALERT_WARNING',
  ALERT_INFO = 'ALERT_INFO',
}

/** @enumType */
/** @internal */
export type UserNotificationDataTypeWithLiterals =
  | UserNotificationDataType
  | 'UNKNOWN_TYPE'
  | 'REGULAR'
  | 'ALERT_WARNING'
  | 'ALERT_INFO';

/** Describes contact notifications */
/** @internal */
export interface ContactNotification {
  /** @format GUID */
  referenceId?: string | null;
  referenceData?: ContactsNotificationData;
}

/** @internal */
export interface ContactsNotificationData {
  /**
   * name
   * @minLength 1
   */
  name?: string | null;
  /** description */
  description?: string | null;
  /**
   * topic id
   * @minLength 1
   */
  topicId?: string | null;
  /** channels */
  channels?: NotificationChannels;
  /** icon */
  icon?: Icon;
  /**
   * intent
   * @internal
   */
  intent?: IntentWithLiterals;
  /** limiter field */
  limiterField?: LimiterField;
  /** recipient filter */
  recipientFilter?: RecipientFilter;
  /** initiator */
  initiator?: Initiator;
  /** single deeplink */
  singleDeeplink?: Deeplink;
  /** grouped deeplink */
  groupedDeeplink?: Deeplink;
  /** context */
  context?: Context;
}

/** @internal */
export enum RecipientFilterType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  CONTACTS = 'CONTACTS',
}

/** @enumType */
/** @internal */
export type RecipientFilterTypeWithLiterals =
  | RecipientFilterType
  | 'UNKNOWN_TYPE'
  | 'CONTACTS';

/** @internal */
export interface ContactsData {
  /** id */
  id?: TypedDynamicParam;
}

/** @internal */
export enum Type {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  CONTACT = 'CONTACT',
  SITE_MEMBER = 'SITE_MEMBER',
}

/** @enumType */
/** @internal */
export type TypeWithLiterals =
  | Type
  | 'UNKNOWN_TYPE'
  | 'CONTACT'
  | 'SITE_MEMBER';

/** @internal */
export interface ContactData {
  /**
   * dynamic param name
   * @minLength 1
   */
  dynamicParamName?: string;
}

/** @internal */
export interface SiteMemberData {
  /**
   * dynamic param name
   * @minLength 1
   */
  dynamicParamName?: string;
}

/** @internal */
export interface LiveSiteActionDeeplink {
  /** app page ID */
  appPageId?: string | null;
  /** path */
  path?: string | null;
  /** language */
  language?: ConstOrDynamicParam;
  /** hash fragment */
  hashFragment?: ConstOrDynamicParam;
  /** query params */
  queryParams?: Record<string, ConstOrDynamicParam>;
}

/** @internal */
export interface RecipientFilter extends RecipientFilterDataOneOf {
  /** contacts data */
  contactsData?: ContactsData;
  /** recipient filter type */
  type?: RecipientFilterTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface RecipientFilterDataOneOf {
  /** contacts data */
  contactsData?: ContactsData;
}

/** @internal */
export interface Initiator extends InitiatorDataOneOf {
  /** contact data */
  contactData?: ContactData;
  /** site member data */
  siteMemberData?: SiteMemberData;
  /** initiator type */
  type?: TypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface InitiatorDataOneOf {
  /** contact data */
  contactData?: ContactData;
  /** site member data */
  siteMemberData?: SiteMemberData;
}

/** @internal */
export interface Deeplink extends DeeplinkOfOneOf {
  /** url */
  url?: Url;
  /**
   * live site
   * @internal
   */
  liveSite?: LiveSiteActionDeeplink;
}

/** @oneof */
/** @internal */
export interface DeeplinkOfOneOf {
  /** url */
  url?: Url;
  /**
   * live site
   * @internal
   */
  liveSite?: LiveSiteActionDeeplink;
}

/** @internal */
export interface Context {
  /** params */
  params?: Record<string, OrderValue>;
}

export interface UnifiedPage {
  /** Base info of component by shared logic of unified components */
  base?: BaseInfo;
  /**
   * Page installation settings
   * @deprecated Page installation settings
   * @replacedBy editor_settings
   * @targetRemovalDate 2026-02-26
   */
  installation?: PageInstallationSettings;
  /** Page replacing options (replacer \ replacing \ none) */
  pageReplace?: PageReplaceOptions;
  /** Content of page */
  content?: PageContent;
  /** Settings for how the page integrates with the editor */
  editorSettings?: UnifiedPageEditorSettings;
}

/** @internal */
export interface PageInstallationSettings {
  /** Shared installation settings for unified components */
  base?: BaseInstallation;
  /** Page installation settings for unified components */
  page?: PageInstallation;
}

/** @internal */
export interface PageInstallation {
  /**
   * slug of the page (last part of url that point to the page)
   * @minLength 1
   * @maxLength 200
   */
  slug?: string;
  /** Should add page to site menu */
  addToSiteMenu?: boolean;
  /** Can page be linked through link panel */
  linkable?: boolean;
}

/** @internal */
export interface PageContent {
  /** Widgets to add as content in page. */
  widgets?: WidgetAsContent[];
  /**
   * Whole-page composition. The referenced composition must have CompTypeDomain.PAGE template_type.
   * Exclusive with widgets — at most one of the two may be set.
   */
  pageComposition?: CompositionRef;
}

/** @internal */
export interface WidgetAsContent {
  /**
   * GUID of widget to use as content of page
   * @format GUID
   */
  widgetGuid?: string;
  /** The preset should be used */
  preset?: MainPresets;
  /** Mark widget as essential for the existence of the app (force to delete the whole app) */
  essential?: boolean | null;
}

/** Canonical wrapper for any reference to a composition. */
/** @internal */
export interface CompositionRef {
  /**
   * Stable handle to the underlying structure-template on the structure-templates server.
   * @format GUID
   */
  templateId?: string;
}

/** @internal */
export interface UnifiedPageEditorSettings {
  /** Basic editor settings that are relevant to all page types */
  base?: PageEditorSettings;
  /**
   * slug of the page (last part of url that point to the page)
   * @minLength 1
   * @maxLength 200
   */
  slug?: string | null;
}

/** @internal */
export interface PageEditorSettings {
  /** Add the page to the site menu */
  addToSiteMenu?: boolean | null;
  /** Can a page be linked through the link panel */
  linkable?: boolean | null;
  /** Can a page be duplicated in the editor (if no essential widget is added in the container) */
  duplicatable?: boolean | null;
}

/** @internal */
export interface AvailabilityTimeSlotsProviderConfig {
  /** URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the provider.
   * @maxLength 100
   */
  providerName?: string | null;
}

/** @internal */
export interface ProposalEditorProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of ProposalEditor provider
   * @maxLength 100
   */
  providerName?: string;
}

/** @internal */
export interface CustomReservationsApprovalConfig {
  /** URI where the SPI Implementer is deployed */
  uriConfig?: SpiBaseUri;
  /** @minLength 2 */
  name?: string;
}

/** @internal */
export interface CommentsContextProviderConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /** Comments Environment */
  environment?: EnvironmentWithLiterals;
  /** Feature toggle to indicate if method GetCommentContextResources is implemented */
  toggleResourceProviderEnabled?: boolean;
}

/** @internal */
export enum Environment {
  LIVE_SITE = 'LIVE_SITE',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
}

/** @enumType */
/** @internal */
export type EnvironmentWithLiterals =
  | Environment
  | 'LIVE_SITE'
  | 'BUSINESS_MANAGER';

/** @internal */
export interface FormSpamSubmissionReportSpiConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /**
   * Configuration of namespaces known by implementer
   * @maxSize 3
   */
  namespaceConfigs?: FormSpamSubmissionReportsNamespaceConfig[];
}

/** @internal */
export interface FormSpamSubmissionReportsNamespaceConfig {
  /**
   * Namespace name.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /** Permissions associated with this namespace. */
  permissions?: FormSpamSubmissionReportPermissions;
}

/** @internal */
export interface FormSpamSubmissionReportPermissions {
  /**
   * Create permission name
   * @maxLength 60
   */
  create?: string;
  /**
   * Delete permission name
   * @maxLength 60
   */
  delete?: string;
  /**
   * Update permission name
   * @maxLength 60
   */
  update?: string;
  /**
   * Read permission name
   * @maxLength 60
   */
  read?: string;
  /**
   * Report as not spam permission name
   * @maxLength 60
   */
  reportNotSpam?: string;
  /**
   * Report as not spam permission name
   * @maxLength 60
   */
  checkForSpam?: string;
}

/** @internal */
export interface VeloActionConfig {
  baseUri?: SpiBaseUri;
}

/** @internal */
export interface EventTypeProviderConfig {
  /**
   * Reserved.
   * @internal
   */
  baseUri?: SpiBaseUri;
  /**
   * The name of the event type.
   * Must be globally unique.
   */
  eventTypeName?: string;
  /**
   * Whether the events of this type should be hidden from query results if no type filter is provided.
   * Default is false.
   */
  eventTypeHiddenFromQuery?: boolean;
}

/** @internal */
export interface ServiceAvailabilityPolicyProviderConfig {
  /** URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the provider.
   * @maxLength 100
   */
  providerName?: string | null;
}

/** a translated sms text sent to UOU */
/** @internal */
export interface SmsActionMessage {
  /**
   * sms text
   * @minLength 1
   */
  body?: string;
}

/** @internal */
export interface BookingPolicyProviderConfig {
  /** URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the provider.
   * @maxLength 100
   */
  providerName?: string | null;
}

/** @internal */
export interface MultiServiceBookingPolicyProviderConfig {
  /** URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the provider.
   * @maxLength 100
   */
  providerName?: string | null;
}

/** @internal */
export interface FormSubmissionSpiExtensionConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * Namespace names.
   * @maxSize 10
   */
  namespaceConfigs?: FormsSubmissionsExtensionNamespaceConfig[];
}

/** @internal */
export interface FormsSubmissionsExtensionNamespaceConfig {
  /**
   * Targeted namespace, with what submissions should trigger defined methods.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /**
   * The ID of the specific form that will trigger the defined methods when a submission is made.
   * This field is optional. If not provided, submissions from all forms will trigger the methods.
   * @format GUID
   */
  formId?: string | null;
  /** Enable submission validation. */
  submissionValidationEnabled?: boolean;
}

/** @internal */
export interface AssistantSpiConfig {
  /**
   * The deployment uri of the assistant
   * @maxLength 1000
   */
  deploymentUri?: string;
  /**
   * The name of the assistant
   * @minLength 1
   * @maxLength 100
   */
  assistantName?: string;
  /** The expose_benchmark_tests of the assistant */
  exposeBenchmarkTests?: boolean;
  /** The expose_dynamic_knowledge of the assistant */
  exposeDynamicKnowledge?: boolean;
}

export interface MultilingualTranslationSchema {
  /**
   * @internal
   * @format GUID
   */
  referenceId?: string | null;
  referenceData?: Schema;
}

/** @internal */
export interface Schema {
  /**
   * Translation schema ID. Auto generated when the schema is created. Read Only.
   * @readonly
   * @format GUID
   */
  id?: string | null;
  /** Required. Unique key identifying the translation schema. Cannot be updated after creation. */
  key?: SchemaKey;
  /**
   * Required. List of fields for the translation schema. This property uses a string to map to a `SchemaField` (`Map<string, SchemaField>`).
   *
   * The string serves as a key, which you'll need to access each field in the schema and when adding translation content.
   *
   * [See full structure of `SchemaField`](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/translation-schema/schema-object).
   * @minSize 1
   * @maxSize 1000
   */
  fields?: Record<string, V1SchemaField>;
  /** Fields displayed in content previews. For example, a product name for a product translation schema. */
  previewFields?: PreviewFields;
  /**
   * Whether the translation schema is hidden from the site.
   *
   * Default: `false`
   */
  hidden?: boolean | null;
  /**
   * Translation schema name displayed in the [Translation Manager](https://support.wix.com/en/article/wix-multilingual-using-the-translation-manager).
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * A reference to the parent schema. For example, if the schema is for a menu item, this property would contain the schema ID of the menu it belongs to. Required when `require_parent_entity` is set to `true`.
   * @format GUID
   */
  parentId?: string | null;
  /**
   * Revision number. Auto-generated on creation and incremented by 1 on each update. To prevent conflicting changes, the current revision must be passed when updating a schema. Read Only.
   * @readonly
   */
  revision?: string | null;
  /**
   * Date and time the translation schema was created. Auto-generated by the system. Read Only.
   * @readonly
   */
  createdDate?: Date | null;
  /**
   * Date and time the translation schema was last updated. Auto-generated and updated by the system on every modification. Read Only.
   * @readonly
   */
  updatedDate?: Date | null;
  /**
   * Whether to duplicate the translated content when a site containing the translation schema and content is duplicated.
   *
   * Default: `false`
   */
  duplicateContent?: boolean | null;
  /**
   * Indicate if this schema should be grouped under a custom group in the Translation Manager.
   * For more info about this field check dev-center extension `Multilingual Schema Group`.
   * @format GUID
   */
  schemaGroupId?: string | null;
  /**
   * Whether content created or updated with this schema must include a `parent_entity_id`.
   * When set to `true`, any Create Content or Update Content call targeting this schema
   * will fail if `parent_entity_id` is missing or empty.
   *
   * The schema itself must also have a `parent_id` defined, otherwise the schema
   * Create or Update call will fail with `SchemaRequireParentEntityWithoutParentIdException`.
   *
   * Default: `false`
   */
  requireParentEntity?: boolean | null;
}

/** @internal */
export interface SchemaKey {
  /**
   * ID of the app that created the schema. No need to provide it on creation — it's automatically set to your app's ID, and any provided value is overridden.
   * @format GUID
   * @readonly
   */
  appId?: string;
  /**
   * Required. A unique name defined by the app developer to differentiate translation schemas for various entities within their app. For example, if an app developer is creating a translation schema for blog posts, the `entityType` can be `'blog-posts'`.
   * @minLength 1
   * @maxLength 80
   * @immutable
   */
  entityType?: string;
  /**
   * Scope of the translation schema.
   * No need to provide it on creation — it's automatically set to `GLOBAL`, and any provided value is overridden.
   * @immutable
   */
  scope?: SchemaScopeWithLiterals;
}

/** @internal */
export enum SchemaScope {
  UNKNOWN_SCOPE = 'UNKNOWN_SCOPE',
  /** Global schema for all sites. */
  GLOBAL = 'GLOBAL',
  /** Custom schema for a specific site. */
  SITE = 'SITE',
}

/** @enumType */
/** @internal */
export type SchemaScopeWithLiterals =
  | SchemaScope
  | 'UNKNOWN_SCOPE'
  | 'GLOBAL'
  | 'SITE';

/** @internal */
export interface V1SchemaField {
  /**
   * Field ID. Validated according to Regex `^[A-Za-z0-9-_)(]+$`. Field IDs may contain parentheses to reference repeated items, such as images. These parentheses can't be nested and each opening parenthesis must be followed by a closing one. For example, `title()()` is valid, while `title)(` and `title(())` aren't valid. The value inside the parenthesis is validated according to Regex `^[^)(\\]\\[\\.]+$`.
   * @minLength 1
   * @maxLength 1000
   * @readonly
   */
  id?: string;
  /** Required. Field type. */
  type?: SchemaFieldFieldTypeWithLiterals;
  /**
   * Field name displayed in the [Translation Manager](https://support.wix.com/en/article/wix-multilingual-using-the-translation-manager).
   * @maxLength 1000
   */
  displayName?: string | null;
  /**
   * Field group name.
   * @maxLength 1000
   */
  groupName?: string | null;
  /**
   * Field minimum text length.
   * @min 1
   */
  minLength?: number | null;
  /**
   * Field maximum text length.
   * @min 1
   */
  maxLength?: number | null;
  /**
   * Field format. Content is validated based on the format set here in the field schema. For example, if the format is `EMAIL`, then the content for this field must be a valid email address.
   * @minLength 2
   * @maxLength 20
   */
  format?: string | null;
  /** Whether the field is hidden from the site. Hidden fields are still validated. */
  hidden?: boolean;
  /** Whether the field is read-only, and not intended to be translated. For example, an image. Use this field when you want an image to remain in the [Translation Manager](https://support.wix.com/en/article/wix-multilingual-using-the-translation-manager) for context, but without being translated. */
  displayOnly?: boolean;
  /** Field index. Use for cases where the order of the fields are relevant. */
  index?: number | null;
}

/** @internal */
export enum SchemaFieldFieldType {
  /** Undefined field type */
  UNDEFINED_TYPE = 'UNDEFINED_TYPE',
  /** Short plain text displayed as a single line in the UI. */
  SHORT_TEXT = 'SHORT_TEXT',
  /** Long plain text displayed as multiple lines in the UI. */
  LONG_TEXT = 'LONG_TEXT',
  /** Long text including styles, images, and links. */
  HTML = 'HTML',
  /** Rich-Content using the Wix Ricos format. */
  RICH_CONTENT = 'RICH_CONTENT',
  /** Wix Media Manager image. */
  IMAGE = 'IMAGE',
  /** Image URL without metadata. */
  IMAGE_LINK = 'IMAGE_LINK',
  /** Contains an XML representation of an entity or part of it. */
  JSON = 'JSON',
  /** Wix Media Manager video. */
  VIDEO = 'VIDEO',
  /** Wix Media Manager document. */
  DOCUMENT = 'DOCUMENT',
}

/** @enumType */
/** @internal */
export type SchemaFieldFieldTypeWithLiterals =
  | SchemaFieldFieldType
  | 'UNDEFINED_TYPE'
  | 'SHORT_TEXT'
  | 'LONG_TEXT'
  | 'HTML'
  | 'RICH_CONTENT'
  | 'IMAGE'
  | 'IMAGE_LINK'
  | 'JSON'
  | 'VIDEO'
  | 'DOCUMENT';

/** @internal */
export interface PreviewFields {
  /**
   * ID of the field representing the schema's title.
   * @maxLength 1000
   */
  titleFieldId?: string | null;
  /**
   * ID of the field representing the schema's image.
   * @maxLength 1000
   */
  imageFieldId?: string | null;
}

/** @internal */
export interface TaxGroupsProviderConfig {
  /** Base URI of the service plugin implementation. Since no endpoint is calling this path, it may be left blank. */
  deploymentUri?: SpiBaseUri;
  /**
   * Name of the default tax group for this app. All products retrieved from this app will be categorized, by default, with this group name.
   * The `id` for this tax group is the app's ID.
   * @maxLength 100
   */
  defaultTaxGroup?: string;
  /**
   * Additional tax groups to be added to a site's tax settings when the app is installed.
   * Each `additionalTaxGroup` must include an `id` and a `name`.
   */
  additionalTaxGroups?: Record<string, AdditionalTaxGroup>;
}

/** @internal */
export interface AdditionalTaxGroup {
  /**
   * Tax group name.
   * @maxLength 100
   */
  name?: string;
  /**
   * Unique tax group ID.
   * @format GUID
   */
  id?: string;
}

/** @internal */
export interface TaxCalculationConfig {
  /**
   * Base URI where the endpoints are called. Wix appends the endpoint path to the base URI.
   *
   * For example, to call the Calculate Tax endpoint at https://my-tax-calc.com/v1/calculate-tax, the base URI you provide here is `"https://my-tax-calc.com/"`.
   */
  deploymentUri?: SpiBaseUri;
  /**
   * Display name of the tax calculator.
   * @minLength 1
   * @maxLength 200
   */
  calculatorDisplayName?: string;
  /**
   * List of countries, in [ISO-3166 alpha-1](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format, that the calculator does not support.
   * @format COUNTRY
   * @maxSize 195
   */
  unsupportedCountries?: string[];
}

/** A modal in one of the back-office platforms */
export interface BackOfficeModal extends BackOfficeModalContentOneOf {
  /**
   * Iframe URL that hosts the modal's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
  /**
   * Platform that hosts the modal.
   *
   * Must be `"BUSINESS_MANAGER"`.
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Modal title.
   * @minLength 1
   */
  title?: string;
  /**
   * Permissions required to open the modal.
   * @internal
   */
  requiredPermission?: string;
  /**
   * Sentry error reporting DSN
   * @internal
   */
  errorReporting?: ErrorReporting;
  /**
   * Initial width of the modal while loading, in pixels.
   * Width may be adjusted dynamically based on the content of the modal or limited by the size of the modal's container.
   * @max 9999
   */
  width?: number | null;
  /**
   * Initial height of the modal while loading, in pixels.
   * Height may be adjusted dynamically based on the content of the modal or limited by the size of the modal's container.
   * @max 9999
   */
  height?: number | null;
  /** general component data */
  metaData?: ComponentMetaData;
  /**
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /**
   * The parameters to pass to the modal
   * @internal
   */
  modalParams?: ModalParams;
}

/** @oneof */
/** @internal */
export interface BackOfficeModalContentOneOf {
  /**
   * Iframe URL that hosts the modal's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /** @internal */
  scriptAsset?: BackOfficeScriptAsset;
}

/** @internal */
export interface ModalParams {
  /**
   * Reference to the .d.ts file for defining the modal's parameters.
   * @internal
   */
  parametersDtsDefinition?: DtsDefinitionReference;
  /**
   * Named export to use.
   * @maxLength 400
   */
  namedExport?: string | null;
}

/** @internal */
export interface DeploymentPipelineProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentPipelineUri?: SpiBaseUri;
  /**
   * The deployment pipeline implementer id
   * @format GUID
   */
  deploymentPipelineId?: string;
}

export interface CustomElementWidget {
  /** Base info of component by shared logic of unified components */
  base?: BaseInfo;
  /** Unified widget installation settings */
  installation?: WidgetInstallationSettings;
  /** The extension data for this component */
  widgetData?: WidgetData;
  /** The widget's editor behaviors */
  behaviors?: EditorBehaviors;
  /** The size of the widget */
  size?: WidgetSize;
  /**
   * The runtime dependencies array to declare the widget packages.
   * @maxSize 50
   */
  dependencies?: WixDependency[];
  /**
   * The array of this widget's presets
   * @maxSize 50
   */
  presets?: Preset[];
}

/** @internal */
export interface WidgetData {
  /**
   * The script url that should render on the widget
   * @format WEB_URL
   */
  scriptUrl?: string;
  /**
   * Unique tag name to use in order to connect your JS script to your web component
   * @minLength 2
   * @maxLength 64
   */
  tagName?: string;
  /** Type of JavaScript modularization approach used in the custom element */
  scriptType?: CustomElementScriptTypeWithLiterals;
}

/** @internal */
export enum CustomElementScriptType {
  NONE = 'NONE',
  /** CommonJS modularization approach */
  COMMON_JS = 'COMMON_JS',
  /** ES Module modularization approach */
  ES_MODULE = 'ES_MODULE',
}

/** @enumType */
/** @internal */
export type CustomElementScriptTypeWithLiterals =
  | CustomElementScriptType
  | 'NONE'
  | 'COMMON_JS'
  | 'ES_MODULE';

/** @internal */
export interface EditorBehaviors {
  /** The settings behavior definition for the widget */
  settings?: SettingsPanel;
  /** The dashboard behavior definition for the widget */
  dashboard?: Dashboard;
}

/** @internal */
export interface SettingsPanel {
  /**
   * The settings panel URL for this component
   * @format WEB_URL
   */
  settingsUrl?: string | null;
}

/** @internal */
export interface Dashboard {
  /**
   * The dashboard page guid for the widget manage of the widget
   * @format GUID
   */
  dashboardPageComponentId?: string;
}

/** @internal */
export interface WidgetSize {
  /** define the size of the widget's height */
  height?: WidgetSizeHeight;
  /** define the size of the widget's width */
  width?: WidgetSizeWidth;
}

/** @internal */
export enum HeightMode {
  UNKNOWN = 'UNKNOWN',
  /** Height is calculated by content */
  AUTO = 'AUTO',
  /** Height is fixed require size in px */
  FIXED = 'FIXED',
}

/** @enumType */
/** @internal */
export type HeightModeWithLiterals = HeightMode | 'UNKNOWN' | 'AUTO' | 'FIXED';

/** @internal */
export interface WidgetSizeHeight {
  /** Height calculation mode */
  heightMode?: HeightModeWithLiterals;
  /**
   * Default height in pixels
   * @max 9999
   */
  defaultHeight?: number;
}

/** @internal */
export interface WidgetSizeWidth {
  /** Boolean to set stretch, will place the widget stretched to the full width of the container */
  allowStretch?: boolean;
  /**
   * Default width in pixels
   * @max 9999
   */
  defaultWidth?: number;
  /** Boolean to set stretch by default on installation, if true will place the widget stretched to the full width of the container */
  stretchByDefault?: boolean;
}

/** @internal */
export interface Preset {
  /**
   * The id of the preset
   * @minLength 1
   * @maxLength 50
   */
  id?: string;
  /**
   * Display name of the preset
   * @minLength 1
   * @maxLength 30
   */
  name?: string;
  /** Defines data for screen size for the preset */
  breakpoints?: Breakpoints;
  /**
   * URL of an image to show as the preset's thumbnail in the editor
   * @format WEB_URL
   */
  thumbnailUrl?: string | null;
}

/** @internal */
export interface Breakpoints {
  /** Defines data for small screen size */
  small?: Breakpoint;
  /** Defines data for medium screen size */
  medium?: Breakpoint;
  /** Defines data for large screen size */
  large?: Breakpoint;
}

/** @internal */
export interface Breakpoint {
  /** The size of the preset */
  size?: WidgetSize;
  /**
   * A different preset id to be used according to breakpoint
   * @maxLength 50
   */
  presetId?: string;
}

/** A component that enables extending Wix dashboard functionality. */
/** @internal */
export interface BackOfficeExtensionWidget
  extends BackOfficeExtensionWidgetAssetOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /**
   * Wix script asset to use in this widget
   * @internal
   */
  scriptAsset?: BackOfficeScriptAsset;
  /**
   * Platform that hosts the widget.
   *
   * Must be `"BUSINESS_MANAGER"`.
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Slot ID for the plugin's container.
   * @format GUID
   */
  extends?: string;
  /** Extension description. */
  description?: string | null;
  /** Extension title. */
  title?: string;
  /**
   * Required permission to view the extension.
   * @internal
   */
  requiredPermission?: string;
  /**
   * Sentry error reporting DSN (internal)
   * @internal
   */
  errorReporting?: ErrorReporting;
  /**
   * Initial width of the widget while loading, in pixels.
   * Width may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @internal
   * @max 9999
   */
  width?: number | null;
  /**
   * Initial height of the widget while loading, in pixels.
   * Height may be adjusted dynamically based on the content of the widget or limited by the size of the widget's container.
   * @max 9999
   */
  height?: number | null;
  /**
   * The list of slot ids available
   * @internal
   * @format GUID
   * @maxSize 100
   */
  slotIds?: string[];
  /**
   * Specifying the visibility level and maturity stage
   * @internal
   */
  exposureAndMaturity?: ExtensionExposure;
  /** Context consumed by AI-powered features */
  aiContext?: AiContext;
}

/** @oneof */
/** @internal */
export interface BackOfficeExtensionWidgetAssetOneOf {
  /**
   * Iframe URL that hosts the widget's content.
   * @format WEB_URL
   */
  iframeUrl?: string;
  /**
   * Wix script asset to use in this widget
   * @internal
   */
  scriptAsset?: BackOfficeScriptAsset;
}

/** A component that enables extending a Wix dashboard menu. */
/** @internal */
export interface BackOfficeExtensionMenuItem {
  /**
   * Platform that hosts the modal.
   *
   * Must be `"BUSINESS_MANAGER"`.
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * Slot ID for the plugin's container.
   * @format GUID
   */
  extends?: string;
  /** Extension description. */
  description?: string | null;
  /** Extension title. */
  title?: string;
  /**
   * Menu item subtitle.
   * @maxLength 200
   */
  subtitle?: string | null;
  /**
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * Required permission to view the extension.
   * @internal
   */
  requiredPermission?: string;
  /**
   * Sentry error reporting DSN (internal)
   * @internal
   */
  errorReporting?: ErrorReporting;
  /** Action that takes places when the menu item is clicked. */
  action?: MenuAction;
  /** Context consumed by AI-powered features */
  aiContext?: AiContext;
}

/** @internal */
export interface NavigateToPageAction {
  /**
   * ID for the target [page](https://dev.wix.com/docs/sdk/host-modules/dashboard/page-ids).
   * @format GUID
   */
  pageId?: string;
  /** Relative URL to append to the base page URL. May include path segments, search params, and hash. */
  relativeUrl?: string | null;
}

/** @internal */
export interface OpenModalAction {
  /**
   * ID of the modal to open.
   * @format GUID
   */
  componentId?: string;
  /** Modal parameters. */
  componentParams?: Record<string, string>;
}

/** @internal */
export interface MenuAction extends MenuActionActionOneOf {
  navigateToPage?: NavigateToPageAction;
  openModal?: OpenModalAction;
}

/** @oneof */
/** @internal */
export interface MenuActionActionOneOf {
  navigateToPage?: NavigateToPageAction;
  openModal?: OpenModalAction;
}

/**
 * Form templates represent an entity that can be used as a source when creating a new form,
 * as well as used as common, extendable form.
 */
/** @internal */
export interface FormTemplate extends FormTemplateTemplateTypeOptionsOneOf {
  /** Extension configuration.. */
  extendableOptions?: ExtensionDetails;
  /**
   * Form template ID.
   * @format GUID
   */
  id?: string;
  /**
   * Namespace under which all forms from this template are created.
   * Namespaces can be used to aggregate multiple forms into single set according to use case / business rules / product.
   * @minLength 10
   * @maxLength 50
   * @immutable
   */
  namespace?: string;
  /**
   * List of form fields.
   * @maxSize 100
   */
  fields?: V2Field[];
  /**
   * Fields which were soft deleted, but can be restored by user.
   * @maxSize 100
   */
  deletedFields?: V2Field[];
  /**
   * Steps of the form, determinating layout of the form
   * @maxSize 100
   */
  steps?: Step[];
  /**
   * Form rules, can be applied to layout and items properties.
   * @maxSize 100
   */
  rules?: V2Rule[];
  /**
   * Name that will be assigned to a created template.
   * @minLength 1
   * @maxLength 200
   */
  name?: string | null;
  /** Settings for actions to be taken after form submission. */
  submitSettings?: SubmitSettings;
  /**
   * Specifies the template purpose
   * @immutable
   */
  templateType?: TemplateTypeWithLiterals;
  /**
   * Date of creation.
   * @readonly
   */
  createdDate?: Date | null;
  /**
   * Date of last update.
   * @readonly
   */
  updatedDate?: Date | null;
  /**
   * Settings for field groups.
   * @maxSize 50
   */
  fieldGroups?: FieldGroup[];
  /** Required indicator properties. */
  requiredIndicatorProperties?: RequiredIndicatorProperties;
}

/** @oneof */
/** @internal */
export interface FormTemplateTemplateTypeOptionsOneOf {
  /** Extension configuration.. */
  extendableOptions?: ExtensionDetails;
}

/** @internal */
export interface V2Field extends V2FieldFieldTypeOptionsOneOf {
  /** Field accept input of data */
  inputOptions?: InputField;
  /** Field for displaying information such as header or text paragraph */
  displayOptions?: DisplayField;
  /**
   * Field id.
   * @format GUID
   * @immutable
   */
  id?: string;
  /**
   * Whether the field is hidden.
   * Default: false
   */
  hidden?: boolean;
  /**
   * Custom identification of field, can be used to specify exceptional behaviour of client for specific field
   * @maxLength 50
   */
  identifier?: string | null;
  /**
   * Type of the field
   * @readonly
   */
  fieldType?: FieldFieldTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface V2FieldFieldTypeOptionsOneOf {
  /** Field accept input of data */
  inputOptions?: InputField;
  /** Field for displaying information such as header or text paragraph */
  displayOptions?: DisplayField;
}

/** @internal */
export enum FieldFieldType {
  UNKNOWN_FIELD_TYPE = 'UNKNOWN_FIELD_TYPE',
  INPUT = 'INPUT',
  DISPLAY = 'DISPLAY',
}

/** @enumType */
/** @internal */
export type FieldFieldTypeWithLiterals =
  | FieldFieldType
  | 'UNKNOWN_FIELD_TYPE'
  | 'INPUT'
  | 'DISPLAY';

/** @internal */
export interface InputField extends InputFieldInputTypeOptionsOneOf {
  /** Input return string as value */
  stringOptions?: _String;
  /** Input return number as value */
  numberOptions?: InputField_Number;
  /** Input return boolean as value */
  booleanOptions?: _Boolean;
  /** Input return array as value */
  arrayOptions?: _Array;
  /** Input return object as value */
  objectOptions?: _Object;
  /** Input return "Wix file" as value */
  wixFileOptions?: WixFile;
  /** Input returns selected products as value. */
  paymentOptions?: Payment;
  /** Input returns multiline address as value. */
  multilineAddressOptions?: Address;
  /** Input returns scheduling as value. */
  schedulingOptions?: Scheduling;
  /** Input returns multiline address as value. */
  addressOptions?: Address;
  /**
   * Definition of a target where the value of field belongs.
   * @minLength 1
   * @maxLength 200
   * @immutable
   */
  target?: string;
  /**
   * Mark the field as containing personal information. This will encrypt user data when storing it.
   * Default: false
   */
  pii?: boolean;
  /**
   * Whether the field is required.
   * Default: false
   */
  required?: boolean;
  /**
   * Type of the input field
   * @readonly
   */
  inputType?: InputFieldInputTypeWithLiterals;
  /** Mapping to contacts, telling to what contact property field input value should be saved. */
  contactMapping?: FormFieldContactInfo;
  /**
   * Whether the field is read only.
   * Default: false
   */
  readOnly?: boolean;
}

/** @oneof */
/** @internal */
export interface InputFieldInputTypeOptionsOneOf {
  /** Input return string as value */
  stringOptions?: _String;
  /** Input return number as value */
  numberOptions?: InputField_Number;
  /** Input return boolean as value */
  booleanOptions?: _Boolean;
  /** Input return array as value */
  arrayOptions?: _Array;
  /** Input return object as value */
  objectOptions?: _Object;
  /** Input return "Wix file" as value */
  wixFileOptions?: WixFile;
  /** Input returns selected products as value. */
  paymentOptions?: Payment;
  /** Input returns multiline address as value. */
  multilineAddressOptions?: Address;
  /** Input returns scheduling as value. */
  schedulingOptions?: Scheduling;
  /** Input returns multiline address as value. */
  addressOptions?: Address;
}

/** @internal */
export interface StringType extends StringTypeFormatOptionsOneOf {
  /** DATE format options */
  dateOptions?: DateTimeConstraints;
  /** DATE_TIME format options */
  dateTimeOptions?: DateTimeConstraints;
  /** TIME format options */
  timeOptions?: DateTimeConstraints;
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: DateTimeConstraints;
  /** PHONE format options */
  phoneOptions?: PhoneConstraints;
  /**
   * Minimum length.
   * @max 20000
   */
  minLength?: number | null;
  /**
   * Maximum length.
   * @max 20000
   */
  maxLength?: number | null;
  /**
   * Pattern for a regular expression match.
   * @maxLength 500
   */
  pattern?: string | null;
  /** Format of a string. */
  format?: FormatWithLiterals;
  /**
   * List of allowed values.
   * @maxSize 500
   * @maxLength 20000
   */
  enum?: string[] | null;
  /** Custom error messages displayed when validation fails. */
  validationMessages?: ValidationMessages;
}

/** @oneof */
/** @internal */
export interface StringTypeFormatOptionsOneOf {
  /** DATE format options */
  dateOptions?: DateTimeConstraints;
  /** DATE_TIME format options */
  dateTimeOptions?: DateTimeConstraints;
  /** TIME format options */
  timeOptions?: DateTimeConstraints;
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: DateTimeConstraints;
  /** PHONE format options */
  phoneOptions?: PhoneConstraints;
}

/** @internal */
export enum Format {
  /** Unknown format. */
  UNKNOWN_FORMAT = 'UNKNOWN_FORMAT',
  /** Date format. */
  DATE = 'DATE',
  /** Time format. */
  TIME = 'TIME',
  /** Date and time format. */
  DATE_TIME = 'DATE_TIME',
  /** Email format. */
  EMAIL = 'EMAIL',
  /** URL format. */
  URL = 'URL',
  /** UUID format. */
  UUID = 'UUID',
  /** Phone number format. */
  PHONE = 'PHONE',
  /** URI format. */
  URI = 'URI',
  /** Hostname format. */
  HOSTNAME = 'HOSTNAME',
  /** Hexadecimal color code format. */
  COLOR_HEX = 'COLOR_HEX',
  /** Currency format. */
  CURRENCY = 'CURRENCY',
  /** Language code format. */
  LANGUAGE = 'LANGUAGE',
  /** Date with optional time format. */
  DATE_OPTIONAL_TIME = 'DATE_OPTIONAL_TIME',
}

/** @enumType */
/** @internal */
export type FormatWithLiterals =
  | Format
  | 'UNKNOWN_FORMAT'
  | 'DATE'
  | 'TIME'
  | 'DATE_TIME'
  | 'EMAIL'
  | 'URL'
  | 'UUID'
  | 'PHONE'
  | 'URI'
  | 'HOSTNAME'
  | 'COLOR_HEX'
  | 'CURRENCY'
  | 'LANGUAGE'
  | 'DATE_OPTIONAL_TIME';

/** @internal */
export interface DateTimeConstraints {
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   * @maxLength 50
   */
  minimum?: string | null;
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   * @maxLength 50
   */
  maximum?: string | null;
}

/** @internal */
export interface PhoneConstraints {
  /**
   * Country codes for phone number that are allowed
   * @maxSize 250
   * @maxLength 2
   */
  allowedCountryCodes?: string[];
}

/** @internal */
export interface ValidationMessages {
  /**
   * Error message shown when the pattern validation fails.
   *
   * This message is displayed to users when their input doesn't match the specified regex pattern.
   * @maxLength 200
   */
  pattern?: string | null;
}

/** @internal */
export enum StringComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  TEXT_INPUT = 'TEXT_INPUT',
  RADIO_GROUP = 'RADIO_GROUP',
  DROPDOWN = 'DROPDOWN',
  DATE_TIME = 'DATE_TIME',
  PHONE_INPUT = 'PHONE_INPUT',
  DATE_INPUT = 'DATE_INPUT',
  TIME_INPUT = 'TIME_INPUT',
  DATE_PICKER = 'DATE_PICKER',
  SERVICES_DROPDOWN = 'SERVICES_DROPDOWN',
  PASSWORD = 'PASSWORD',
}

/** @enumType */
/** @internal */
export type StringComponentTypeWithLiterals =
  | StringComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'TEXT_INPUT'
  | 'RADIO_GROUP'
  | 'DROPDOWN'
  | 'DATE_TIME'
  | 'PHONE_INPUT'
  | 'DATE_INPUT'
  | 'TIME_INPUT'
  | 'DATE_PICKER'
  | 'SERVICES_DROPDOWN'
  | 'PASSWORD';

/** @internal */
export interface TextInput {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Placeholder for the value input
   * @maxLength 100
   */
  placeholder?: string | null;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Default value for the text input
   * @maxLength 20000
   */
  default?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface MediaItem extends MediaItemMediaOneOf {
  /** WixMedia image. */
  image?: CommonImage;
}

/** @oneof */
/** @internal */
export interface MediaItemMediaOneOf {
  /** WixMedia image. */
  image?: CommonImage;
}

/** @internal */
export interface CommonImage {
  /**
   * WixMedia image ID.
   * @maxLength 100
   */
  id?: string;
  /**
   * Image URL.
   * @maxLength 2000
   */
  url?: string;
  /**
   * Original image height.
   * @readonly
   */
  height?: number;
  /**
   * Original image width.
   * @readonly
   */
  width?: number;
  /**
   * Image alt text.
   * @maxLength 1000
   */
  altText?: string | null;
  /**
   * Image URL expiration date (when relevant).
   * @internal
   * @readonly
   */
  urlExpirationDate?: Date | null;
  /**
   * Image filename.
   * @readonly
   * @maxLength 1000
   */
  filename?: string | null;
  /**
   * Image size in bytes.
   * @internal
   * @readonly
   * @format DECIMAL_VALUE
   * @decimalValue options { maxScale:10 }
   */
  sizeInBytes?: string | null;
}

/** @internal */
export interface MediaSettings {
  /**
   * Specifies where image should be displayed.
   * Default: BELOW
   */
  imagePosition?: ImagePositionWithLiterals;
  /**
   * Specifies image alignment.
   * Default: CENTER
   */
  imageAlignment?: AlignmentWithLiterals;
  /**
   * Defines how an image should be resized to fit.
   * Default: COVER
   */
  imageFit?: ImageFitWithLiterals;
}

/** @internal */
export enum ImagePosition {
  /** Undefined position. */
  UNKNOWN_IMAGE_POSITION = 'UNKNOWN_IMAGE_POSITION',
  /** Above label. */
  ABOVE = 'ABOVE',
  /** Below label. */
  BELOW = 'BELOW',
}

/** @enumType */
/** @internal */
export type ImagePositionWithLiterals =
  | ImagePosition
  | 'UNKNOWN_IMAGE_POSITION'
  | 'ABOVE'
  | 'BELOW';

/** @internal */
export enum Alignment {
  /** Undefined alignment. */
  UNKNOWN_ALIGNMENT = 'UNKNOWN_ALIGNMENT',
  /** Left. */
  LEFT = 'LEFT',
  /** Center. */
  CENTER = 'CENTER',
  /** Right. */
  RIGHT = 'RIGHT',
}

/** @enumType */
/** @internal */
export type AlignmentWithLiterals =
  | Alignment
  | 'UNKNOWN_ALIGNMENT'
  | 'LEFT'
  | 'CENTER'
  | 'RIGHT';

/** @internal */
export enum ImageFit {
  UNKNOWN_IMAGE_FIT = 'UNKNOWN_IMAGE_FIT',
  /** Image is scaled to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios do not match. */
  COVER = 'COVER',
  /** Image is resized to fill the element's content box. Aspect ratio may not be preserved. */
  CONTAIN = 'CONTAIN',
}

/** @enumType */
/** @internal */
export type ImageFitWithLiterals =
  | ImageFit
  | 'UNKNOWN_IMAGE_FIT'
  | 'COVER'
  | 'CONTAIN';

/** @internal */
export interface RadioGroup {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Flag identifying to show option allowing input custom value
   * List of options to select from
   * @maxSize 400
   */
  options?: RadioGroupOption[];
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: NumberOfColumnsWithLiterals;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface RadioGroupOption {
  /**
   * Selectable option label
   * @maxLength 400
   */
  label?: string | null;
  /**
   * Selectable option value, which is saved to DB.
   * @maxLength 20000
   */
  value?: string | null;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
  /**
   * Option id. Used as binding for translations
   * @format GUID
   * @immutable
   */
  id?: string;
}

/** @internal */
export interface CustomOption {
  /**
   * Label of custom option input
   * @maxLength 350
   */
  label?: string | null;
  /**
   * Placeholder of custom option input
   * @maxLength 100
   */
  placeholder?: string | null;
}

/** @internal */
export enum NumberOfColumns {
  /** Undefined number of columns. */
  UNKNOWN = 'UNKNOWN',
  /** Zero columns. */
  ZERO = 'ZERO',
  /** One column. */
  ONE = 'ONE',
  /** Two columns. */
  TWO = 'TWO',
  /** Three columns. */
  THREE = 'THREE',
}

/** @enumType */
/** @internal */
export type NumberOfColumnsWithLiterals =
  | NumberOfColumns
  | 'UNKNOWN'
  | 'ZERO'
  | 'ONE'
  | 'TWO'
  | 'THREE';

/** @internal */
export interface Dropdown {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * List of options to select from
   * @maxSize 400
   */
  options?: DropdownOption[];
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
  /**
   * Placeholder of dropdown input
   * @maxLength 100
   */
  placeholder?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface DropdownOption {
  /**
   * Selectable option label
   * @maxLength 400
   */
  label?: string | null;
  /**
   * Selectable option value, which is saved to DB.
   * @maxLength 20000
   */
  value?: string | null;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
  /**
   * Option id. Used as binding for translations
   * @format GUID
   * @immutable
   */
  id?: string;
}

/** @internal */
export interface DateTimeInput {
  /**
   * Label of the field. Displayed text for the date/time input.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. Additional information about the date/time input. */
  description?: RichContent;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Flag identifying whether to show or hide the placeholder.
   * Default: true
   */
  showPlaceholder?: boolean | null;
  /**
   * Flag indicating whether to use the 24-hour time format.
   * Default: false.
   */
  use24HourFormat?: boolean;
  /**
   * Default value for the date time input.
   * @format LOCAL_DATE_TIME
   */
  default?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: boolean | null;
}

/** @internal */
export interface PhoneInput {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Placeholder for the value input
   * @maxLength 100
   */
  placeholder?: string | null;
  /**
   * Flag identifying to show label or not
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Default value of the country code
   * @minLength 1
   * @maxLength 5
   */
  defaultCountryCode?: string | null;
  /**
   * Flag identifying to show country flag or not
   * Default: false
   */
  showCountryFlag?: boolean;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface DateInput {
  /**
   * Label of the field. Displayed text for the date/time input.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. Additional information about the date/time input. */
  description?: RichContent;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Flag identifying whether to show or hide the placeholder.
   * Default: true
   */
  showPlaceholder?: boolean | null;
  /**
   * Default value for the date input.
   * @format LOCAL_DATE
   */
  default?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: boolean | null;
}

/** @internal */
export interface TimeInput {
  /**
   * Label of the field. Displayed text for the date/time input.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. Additional information about the date/time input. */
  description?: RichContent;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Flag identifying whether to show or hide the placeholder.
   * Default: true
   */
  showPlaceholder?: boolean | null;
  /**
   * Flag indicating whether to use the 24-hour time format.
   * Default: false.
   */
  use24HourFormat?: boolean;
  /**
   * Default value for the time input.
   * @format LOCAL_TIME
   */
  default?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface DatePicker {
  /**
   * Label of the field. Displayed text for the date/time input.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. Additional information about the date/time input. */
  description?: RichContent;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Placeholder of date picker input
   * @maxLength 100
   */
  placeholder?: string | null;
  /** First day of the week displayed on date picker. */
  firstDayOfWeek?: FirstDayOfWeekWithLiterals;
  /**
   * Default value for the date picker.
   * @format LOCAL_DATE
   */
  default?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export enum FirstDayOfWeek {
  /** First day of the week is Monday. */
  MONDAY = 'MONDAY',
  /** First day of the week is Sunday. */
  SUNDAY = 'SUNDAY',
}

/** @enumType */
/** @internal */
export type FirstDayOfWeekWithLiterals = FirstDayOfWeek | 'MONDAY' | 'SUNDAY';

/** @internal */
export interface ServicesDropdown {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Placeholder of services dropdown input
   * @maxLength 100
   */
  placeholder?: string | null;
  /**
   * List of service options to select from
   * @maxSize 400
   */
  options?: ServicesDropdownOption[];
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
}

/** @internal */
export interface ServicesDropdownOption {
  /**
   * Service name/label
   * @maxLength 400
   */
  label?: string | null;
  /**
   * Option id. Used as binding for translations. Corresponds to the Service ID.
   * @format GUID
   * @immutable
   */
  id?: string;
  /**
   * Selectable option value, which is saved to DB. Corresponds to the Service ID.
   * @format GUID
   * @immutable
   */
  value?: string | null;
}

/** @internal */
export interface Password {
  /**
   * Field label.
   * @maxLength 350
   */
  label?: string | null;
  /** Additional description or instructions for the field. */
  description?: RichContent;
  /**
   * Placeholder text shown inside the field when it's empty.
   * Useful for providing a hint about the expected format or content.
   * @maxLength 100
   */
  placeholder?: string | null;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: boolean | null;
  /**
   * Default value for the field. This value is pre-populated in the field when the form loads.
   * @maxLength 20000
   */
  default?: string | null;
  /** Media content associated with the field, such as an image. */
  media?: MediaItem;
  /** Configuration for the media content. */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface NumberType {
  /** Inclusive maximum value. */
  maximum?: number | null;
  /** Inclusive minimum value. */
  minimum?: number | null;
  /** Multiple of value. */
  multipleOf?: number | null;
  /**
   * List of allowed values.
   * @maxSize 500
   */
  enum?: number[] | null;
}

/** @internal */
export enum NumberComponentType {
  UNKNOWN = 'UNKNOWN',
  NUMBER_INPUT = 'NUMBER_INPUT',
  RATING_INPUT = 'RATING_INPUT',
}

/** @enumType */
/** @internal */
export type NumberComponentTypeWithLiterals =
  | NumberComponentType
  | 'UNKNOWN'
  | 'NUMBER_INPUT'
  | 'RATING_INPUT';

/** @internal */
export interface NumberInput {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Placeholder for the value input
   * @maxLength 100
   */
  placeholder?: string | null;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Default value for the number input */
  default?: number | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface RatingInput {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Default rating
   * @min 1
   * @max 5
   */
  defaultValue?: number | null;
  /**
   * Flag identifying to hide label or not
   * Default: true
   */
  showLabel?: boolean | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface BooleanType {
  /**
   * List of allowed values.
   * @maxSize 2
   */
  enum?: boolean[];
}

/** @internal */
export enum BooleanComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  CHECKBOX = 'CHECKBOX',
}

/** @enumType */
/** @internal */
export type BooleanComponentTypeWithLiterals =
  | BooleanComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'CHECKBOX';

/** @internal */
export interface Checkbox {
  /** Label of the field */
  label?: RichContent;
  /**
   * Flag identifying if checked by default
   * Default: false
   */
  checked?: boolean;
}

/** @internal */
export interface ArrayType {
  /**
   * Maximum amount of array elements.
   * @max 1000
   */
  maxItems?: number | null;
  /**
   * Minimum amount of array elements.
   * @max 1000
   */
  minItems?: number | null;
  /** Type of items allowed in array. */
  items?: ArrayTypeArrayItems;
}

/** @internal */
export enum ItemType {
  UNKNOWN_ITEM_TYPE = 'UNKNOWN_ITEM_TYPE',
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  OBJECT = 'OBJECT',
}

/** @enumType */
/** @internal */
export type ItemTypeWithLiterals =
  | ItemType
  | 'UNKNOWN_ITEM_TYPE'
  | 'STRING'
  | 'NUMBER'
  | 'BOOLEAN'
  | 'INTEGER'
  | 'OBJECT';

/** @internal */
export interface IntegerType {
  /** Maximum value. */
  maximum?: number | null;
  /** Minimum value. */
  minimum?: number | null;
  /** Multiple of value. */
  multipleOf?: number | null;
  /**
   * List of allowed values.
   * @maxSize 500
   */
  enum?: number[] | null;
}

/** @internal */
export interface ObjectType {
  /** Description of object properties. */
  properties?: Record<string, PropertiesType>;
}

/** @internal */
export enum PropertiesTypeEnum {
  UNKNOWN_PROPERTY_TYPE = 'UNKNOWN_PROPERTY_TYPE',
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  ARRAY = 'ARRAY',
}

/** @enumType */
/** @internal */
export type PropertiesTypeEnumWithLiterals =
  | PropertiesTypeEnum
  | 'UNKNOWN_PROPERTY_TYPE'
  | 'STRING'
  | 'NUMBER'
  | 'BOOLEAN'
  | 'INTEGER'
  | 'ARRAY';

/** @internal */
export interface PropertiesType
  extends PropertiesTypePropertiesTypeOptionsOneOf {
  /** String type validation for property. */
  stringOptions?: StringType;
  /** Number type validation for property. */
  numberOptions?: NumberType;
  /** Boolean type validation for property. */
  booleanOptions?: BooleanType;
  /** Integer type validation for property. */
  integerOptions?: IntegerType;
  /** Array type validation for property. */
  arrayOptions?: ArrayType;
  /**
   * Type of object properties
   * @readonly
   */
  propertiesType?: PropertiesTypeEnumWithLiterals;
  /** Whether the property is required. */
  required?: boolean;
}

/** @oneof */
/** @internal */
export interface PropertiesTypePropertiesTypeOptionsOneOf {
  /** String type validation for property. */
  stringOptions?: StringType;
  /** Number type validation for property. */
  numberOptions?: NumberType;
  /** Boolean type validation for property. */
  booleanOptions?: BooleanType;
  /** Integer type validation for property. */
  integerOptions?: IntegerType;
  /** Array type validation for property. */
  arrayOptions?: ArrayType;
}

/** @internal */
export interface ArrayTypeArrayItems
  extends ArrayTypeArrayItemsItemTypeOptionsOneOf {
  /** String type validation for items. */
  stringOptions?: StringType;
  /** Number type validation for items. */
  numberOptions?: NumberType;
  /** Boolean type validation for items. */
  booleanOptions?: BooleanType;
  /** Integer type validation for items. */
  integerOptions?: IntegerType;
  /** Object type validation for items */
  objectOptions?: ObjectType;
  /**
   * Type of array items
   * @readonly
   */
  itemType?: ItemTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ArrayTypeArrayItemsItemTypeOptionsOneOf {
  /** String type validation for items. */
  stringOptions?: StringType;
  /** Number type validation for items. */
  numberOptions?: NumberType;
  /** Boolean type validation for items. */
  booleanOptions?: BooleanType;
  /** Integer type validation for items. */
  integerOptions?: IntegerType;
  /** Object type validation for items */
  objectOptions?: ObjectType;
}

/** @internal */
export enum ArrayComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  TAGS = 'TAGS',
}

/** @enumType */
/** @internal */
export type ArrayComponentTypeWithLiterals =
  | ArrayComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'CHECKBOX_GROUP'
  | 'TAGS';

/** @internal */
export interface CheckboxGroup {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * List of options to select from
   * @maxSize 400
   */
  options?: CheckboxGroupOption[];
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: NumberOfColumnsWithLiterals;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface CheckboxGroupOption {
  /**
   * Selectable option label
   * @maxLength 400
   */
  label?: string | null;
  /** Selectable option value, which is saved to DB. */
  value?: any;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
  /**
   * Option id. Used as binding for translations
   * @format GUID
   * @immutable
   */
  id?: string;
  /** Media item. Media, associated with option, like image. */
  media?: MediaItem;
}

/** @internal */
export interface Tags {
  /**
   * Label of the field
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * List of options to select from
   * @maxSize 400
   */
  options?: TagsOption[];
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: NumberOfColumnsWithLiterals;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface TagsOption {
  /**
   * Selectable option label
   * @maxLength 400
   */
  label?: string | null;
  /** Selectable option value, which is saved to DB. */
  value?: any;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
  /**
   * Option id. Used as binding for translations
   * @format GUID
   * @immutable
   */
  id?: string;
  /** Media item. Media, associated with option, like image. */
  media?: MediaItem;
}

/** @internal */
export enum WixFileComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  FILE_UPLOAD = 'FILE_UPLOAD',
  SIGNATURE = 'SIGNATURE',
}

/** @enumType */
/** @internal */
export type WixFileComponentTypeWithLiterals =
  | WixFileComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'FILE_UPLOAD'
  | 'SIGNATURE';

/** @internal */
export interface FileType {
  /**
   * Amount of files allowed to upload
   * @min 1
   * @max 30
   */
  fileLimit?: number;
  /**
   * Supported file formats for upload
   * @maxSize 5
   */
  uploadFileFormats?: UploadFileFormatWithLiterals[];
}

/** @internal */
export enum UploadFileFormat {
  /** Undefined upload file format. */
  UNKNOWN_UPLOAD_FILE_FORMAT = 'UNKNOWN_UPLOAD_FILE_FORMAT',
  /** Video files. */
  VIDEO = 'VIDEO',
  /** Image files. */
  IMAGE = 'IMAGE',
  /** Audio files. */
  AUDIO = 'AUDIO',
  /** Document files. */
  DOCUMENT = 'DOCUMENT',
  /** Archive files. */
  ARCHIVE = 'ARCHIVE',
}

/** @enumType */
/** @internal */
export type UploadFileFormatWithLiterals =
  | UploadFileFormat
  | 'UNKNOWN_UPLOAD_FILE_FORMAT'
  | 'VIDEO'
  | 'IMAGE'
  | 'AUDIO'
  | 'DOCUMENT'
  | 'ARCHIVE';

/** @internal */
export interface FileUpload {
  /**
   * Selectable option label
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field */
  description?: RichContent;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Text on upload button
   * @maxLength 500
   */
  buttonText?: string | null;
  /**
   * Amount of files allowed to upload
   * @min 1
   * @max 30
   */
  fileLimit?: number;
  /**
   * Supported file formats for upload
   * @maxSize 5
   */
  uploadFileFormats?: UploadFileFormatEnumUploadFileFormatWithLiterals[];
  /**
   * Custom text which appears when file is uploaded, if missing file name will be shown
   * @maxLength 255
   */
  explanationText?: string | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export enum UploadFileFormatEnumUploadFileFormat {
  /** Undefined upload file format. */
  UNDEFINED = 'UNDEFINED',
  /** Video files. */
  VIDEO = 'VIDEO',
  /** Image files. */
  IMAGE = 'IMAGE',
  /** Audio files. */
  AUDIO = 'AUDIO',
  /** Document files. */
  DOCUMENT = 'DOCUMENT',
  /** Archive files. */
  ARCHIVE = 'ARCHIVE',
}

/** @enumType */
/** @internal */
export type UploadFileFormatEnumUploadFileFormatWithLiterals =
  | UploadFileFormatEnumUploadFileFormat
  | 'UNDEFINED'
  | 'VIDEO'
  | 'IMAGE'
  | 'AUDIO'
  | 'DOCUMENT'
  | 'ARCHIVE';

/** @internal */
export interface Signature {
  /**
   * Selectable option label
   * @maxLength 350
   */
  label?: string | null;
  /**
   * Flag identifying to hide label or not
   * Default: true
   */
  showLabel?: boolean | null;
  /** Description of the field */
  description?: RichContent;
  /** Is image upload enabled */
  imageUploadEnabled?: boolean;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export enum PaymentComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  DONATION_INPUT = 'DONATION_INPUT',
  PAYMENT_INPUT = 'PAYMENT_INPUT',
  FIXED_PAYMENT = 'FIXED_PAYMENT',
}

/** @enumType */
/** @internal */
export type PaymentComponentTypeWithLiterals =
  | PaymentComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'CHECKBOX_GROUP'
  | 'DONATION_INPUT'
  | 'PAYMENT_INPUT'
  | 'FIXED_PAYMENT';

/** @internal */
export interface PaymentType {
  /**
   * Field mapped to products.
   * @minSize 1
   * @maxSize 100
   */
  products?: Product[];
  /**
   * Minimum amount of different products.
   * @max 100
   */
  minItems?: number | null;
  /**
   * Maximum amount of different products.
   * @max 100
   */
  maxItems?: number | null;
}

/** @internal */
export enum ProductType {
  /** Unknown product type. */
  UNKNOWN = 'UNKNOWN',
  /** Shippable (physical) product. */
  SHIPPABLE = 'SHIPPABLE',
  /** Digital product. */
  DIGITAL = 'DIGITAL',
}

/** @enumType */
/** @internal */
export type ProductTypeWithLiterals =
  | ProductType
  | 'UNKNOWN'
  | 'SHIPPABLE'
  | 'DIGITAL';

/** @internal */
export enum PriceType {
  /** Unknown price type. */
  UNKNOWN = 'UNKNOWN',
  /** Fixed price. */
  FIXED_PRICE = 'FIXED_PRICE',
  /** Dynamic price from price range. */
  DYNAMIC_PRICE = 'DYNAMIC_PRICE',
}

/** @enumType */
/** @internal */
export type PriceTypeWithLiterals =
  | PriceType
  | 'UNKNOWN'
  | 'FIXED_PRICE'
  | 'DYNAMIC_PRICE';

/** @internal */
export interface QuantityLimit {
  /**
   * Minimum quantity.
   * @min 1
   * @max 100000
   */
  minimum?: number | null;
  /**
   * Maximum quantity.
   * @min 1
   * @max 100000
   */
  maximum?: number | null;
}

/** @internal */
export interface FixedPriceOptions {
  /**
   * Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99).
   * @decimalValue options { gte:0.00, maxScale:2 }
   */
  price?: string;
}

/** @internal */
export interface DynamicPriceOptions {
  /**
   * Minimal price monetary amount.
   * @decimalValue options { gte:0.00, maxScale:2 }
   */
  minPrice?: string;
  /**
   * Maximal price monetary amount.
   * @decimalValue options { gte:0.00, maxScale:2 }
   */
  maxPrice?: string | null;
}

/** @internal */
export interface Product extends ProductPriceOptionsOneOf {
  /** Fixed price options. */
  fixedPriceOptions?: FixedPriceOptions;
  /** Dynamic price options. */
  dynamicPriceOptions?: DynamicPriceOptions;
  /**
   * Product ID.
   * @format GUID
   * @readonly
   */
  id?: string;
  /** Product type. */
  productType?: ProductTypeWithLiterals;
  /** Price type. */
  priceType?: PriceTypeWithLiterals;
  /** Quantity limit. */
  quantityLimit?: QuantityLimit;
}

/** @oneof */
/** @internal */
export interface ProductPriceOptionsOneOf {
  /** Fixed price options. */
  fixedPriceOptions?: FixedPriceOptions;
  /** Dynamic price options. */
  dynamicPriceOptions?: DynamicPriceOptions;
}

/** @internal */
export interface ProductCheckboxGroup {
  /**
   * Label of the field.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. */
  description?: RichContent;
  /**
   * List of options to select from.
   * @maxSize 400
   */
  options?: ProductCheckboxGroupOption[];
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Defines how an image should be resized to fit within its option.
   * Default: COVER
   */
  imageFit?: ImageFitWithLiterals;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface ProductCheckboxGroupOption {
  /**
   * Selectable option label.
   * @maxLength 400
   */
  label?: string | null;
  /** Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list. */
  value?: any;
  /**
   * Option id. Used as binding for translations.
   * @format GUID
   * @immutable
   */
  id?: string;
  /** Media item. Media, associated with option, like image. */
  media?: MediaItem;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
}

/** @internal */
export interface DonationInput {
  /**
   * Label of the field.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. */
  description?: RichContent;
  /**
   * List of options to select from.
   * @maxSize 400
   */
  options?: DonationInputOption[];
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: CustomOption;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: NumberOfColumnsWithLiterals;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface DonationInputOption {
  /**
   * Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list.
   * @format GUID
   */
  value?: string;
  /** Flag identifying that option should be selected by default */
  default?: boolean;
}

/** @internal */
export interface PaymentInput {
  /**
   * Label of the field.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. */
  description?: RichContent;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /**
   * Placeholder of custom option input
   * @maxLength 100
   */
  placeholder?: string | null;
  /** Default value for the payment input */
  default?: number | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export interface FixedPayment {
  /**
   * Label of the field.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. */
  description?: RichContent;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
  /** Media item. Media, associated with field, like image. */
  media?: MediaItem;
  /** Settings for media item */
  mediaSettings?: MediaSettings;
}

/** @internal */
export enum AddressComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
}

/** @enumType */
/** @internal */
export type AddressComponentTypeWithLiterals =
  | AddressComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'MULTILINE_ADDRESS';

/** @internal */
export interface MultilineAddressValidation {
  /**
   * Allowed countries. No countries treated as all.
   * @format COUNTRY
   * @maxSize 200
   */
  allowedCountries?: string[];
  /** Fields overrides. */
  fields?: FieldsOverrides;
}

/** @internal */
export interface FieldOverrides {
  /** Whether the field is required. */
  required?: boolean;
}

/** @internal */
export interface FieldsOverrides {
  /** Subdivision. */
  subdivision?: FieldOverrides;
  /** City. */
  city?: FieldOverrides;
  /** Postal code. */
  postalCode?: FieldOverrides;
  /** Street name. */
  streetName?: FieldOverrides;
  /** Street number. */
  streetNumber?: FieldOverrides;
  /** Address line. */
  addressLine?: FieldOverrides;
  /** Address line 2. */
  addressLine2?: FieldOverrides;
  /** Country. */
  country?: FieldOverrides;
}

/** @internal */
export interface MultilineAddress {
  /**
   * Label of the field.
   * @maxLength 350
   */
  label?: string | null;
  /** Description of the field. */
  description?: RichContent;
  /** Show country flags. */
  showCountryFlags?: boolean;
  /** Default country configuration. */
  defaultCountryConfig?: DefaultCountryConfig;
  /** Fields settings. */
  fieldSettings?: FieldsSettings;
  /** Autocomplete enabled for address line field. */
  autocompleteEnabled?: boolean;
  /**
   * Flag identifying whether to show or hide the address labels.
   * Default: true
   */
  showAddressLabels?: boolean | null;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: boolean | null;
}

/** @internal */
export enum DefaultCountryConfigType {
  /** Unknown default country config type. */
  UNKNOWN_DEFAULT_COUNTRY = 'UNKNOWN_DEFAULT_COUNTRY',
  /** Country is determined by customer's IP address. */
  BY_IP = 'BY_IP',
  /** Pre-selected default country. */
  COUNTRY = 'COUNTRY',
}

/** @enumType */
/** @internal */
export type DefaultCountryConfigTypeWithLiterals =
  | DefaultCountryConfigType
  | 'UNKNOWN_DEFAULT_COUNTRY'
  | 'BY_IP'
  | 'COUNTRY';

/** @internal */
export interface AddressLine2 {
  /** Show address line 2 field. */
  show?: boolean;
}

/** @internal */
export interface DefaultCountryConfig extends DefaultCountryConfigOptionsOneOf {
  /**
   * Country.
   * @format COUNTRY
   */
  countryOptions?: string;
  /** Default country type. */
  type?: DefaultCountryConfigTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface DefaultCountryConfigOptionsOneOf {
  /**
   * Country.
   * @format COUNTRY
   */
  countryOptions?: string;
}

/** @internal */
export interface FieldsSettings {
  /** Address line 2. */
  addressLine2?: AddressLine2;
}

/** @internal */
export enum SchedulingComponentType {
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE',
  APPOINTMENT = 'APPOINTMENT',
}

/** @enumType */
/** @internal */
export type SchedulingComponentTypeWithLiterals =
  | SchedulingComponentType
  | 'UNKNOWN_COMPONENT_TYPE'
  | 'APPOINTMENT';

/** @internal */
export interface Appointment extends AppointmentFormatInfoOneOf {
  /** In person options for the appointment */
  inPersonOptions?: InPersonOptions;
  /** Online video conference options for the appointment */
  videoConferenceOptions?: VideoConferenceOptions;
  /** Phone options for the appointment */
  phoneOptions?: PhoneOptions;
  /**
   * Label of the field
   * @maxLength 255
   */
  label?: string | null;
  /**
   * Name of the appointment
   * @minLength 1
   * @maxLength 400
   */
  name?: string | null;
  /**
   * Duration of the appointment in minutes
   * @min 1
   * @max 44639
   */
  durationInMinutes?: number | null;
  /** Indicates whether manual approval is required for the appointment */
  manualApprovalRequired?: boolean | null;
  /**
   * ID of the staff members providing the appointment
   * @maxSize 220
   * @format GUID
   */
  staffIds?: string[] | null;
  /** The format of the appointment */
  format?: AppointmentFormatWithLiterals;
  /** Description of the field */
  description?: RichContent;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: boolean | null;
}

/** @oneof */
/** @internal */
export interface AppointmentFormatInfoOneOf {
  /** In person options for the appointment */
  inPersonOptions?: InPersonOptions;
  /** Online video conference options for the appointment */
  videoConferenceOptions?: VideoConferenceOptions;
  /** Phone options for the appointment */
  phoneOptions?: PhoneOptions;
}

/** @internal */
export interface Location extends LocationLocationInfoOneOf {
  /**
   * Custom address details
   * @maxLength 512
   */
  customAddress?: string | null;
  /**
   * ID of a business location
   * @format GUID
   */
  businessLocationId?: string | null;
}

/** @oneof */
/** @internal */
export interface LocationLocationInfoOneOf {
  /**
   * Custom address details
   * @maxLength 512
   */
  customAddress?: string | null;
  /**
   * ID of a business location
   * @format GUID
   */
  businessLocationId?: string | null;
}

/** @internal */
export enum AppointmentFormat {
  UNKNOWN_FORMAT_TYPE = 'UNKNOWN_FORMAT_TYPE',
  IN_PERSON = 'IN_PERSON',
  VIDEO_CONFERENCE = 'VIDEO_CONFERENCE',
  PHONE = 'PHONE',
}

/** @enumType */
/** @internal */
export type AppointmentFormatWithLiterals =
  | AppointmentFormat
  | 'UNKNOWN_FORMAT_TYPE'
  | 'IN_PERSON'
  | 'VIDEO_CONFERENCE'
  | 'PHONE';

/** @internal */
export interface InPersonOptions {
  /**
   * The locations details
   * @minSize 1
   * @maxSize 1
   */
  locations?: Location[];
}

/** @internal */
export interface VideoConferenceOptions {
  /**
   * Description or instructions for the online video conference
   * @maxLength 512
   */
  description?: string | null;
}

/** @internal */
export interface PhoneOptions {
  /**
   * Description or instructions for the phone appointment
   * @maxLength 512
   */
  description?: string | null;
}

/** @internal */
export enum InputFieldInputType {
  UNKNOWN_INPUT_TYPE = 'UNKNOWN_INPUT_TYPE',
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  ARRAY = 'ARRAY',
  OBJECT = 'OBJECT',
  WIX_FILE = 'WIX_FILE',
  PAYMENT = 'PAYMENT',
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
  SCHEDULING = 'SCHEDULING',
  ADDRESS = 'ADDRESS',
}

/** @enumType */
/** @internal */
export type InputFieldInputTypeWithLiterals =
  | InputFieldInputType
  | 'UNKNOWN_INPUT_TYPE'
  | 'STRING'
  | 'NUMBER'
  | 'BOOLEAN'
  | 'ARRAY'
  | 'OBJECT'
  | 'WIX_FILE'
  | 'PAYMENT'
  | 'MULTILINE_ADDRESS'
  | 'SCHEDULING'
  | 'ADDRESS';

/** @internal */
export interface FormFieldContactInfo
  extends FormFieldContactInfoAdditionalInfoOneOf {
  /** Email info. */
  emailInfo?: EmailInfo;
  /** Phone info. */
  phoneInfo?: PhoneInfo;
  /** Address info. */
  addressInfo?: AddressInfo;
  /** Custom field info. */
  customFieldInfo?: CustomFieldInfo;
  /** Subscription info */
  subscriptionInfo?: SubscriptionInfo;
  /** Field mapped to contacts. */
  contactField?: ContactFieldWithLiterals;
}

/** @oneof */
/** @internal */
export interface FormFieldContactInfoAdditionalInfoOneOf {
  /** Email info. */
  emailInfo?: EmailInfo;
  /** Phone info. */
  phoneInfo?: PhoneInfo;
  /** Address info. */
  addressInfo?: AddressInfo;
  /** Custom field info. */
  customFieldInfo?: CustomFieldInfo;
  /** Subscription info */
  subscriptionInfo?: SubscriptionInfo;
}

/** @internal */
export enum EmailInfoTag {
  UNTAGGED = 'UNTAGGED',
  MAIN = 'MAIN',
}

/** @enumType */
/** @internal */
export type EmailInfoTagWithLiterals = EmailInfoTag | 'UNTAGGED' | 'MAIN';

/** @internal */
export enum PhoneInfoTag {
  UNTAGGED = 'UNTAGGED',
  MAIN = 'MAIN',
}

/** @enumType */
/** @internal */
export type PhoneInfoTagWithLiterals = PhoneInfoTag | 'UNTAGGED' | 'MAIN';

/** @internal */
export enum AddressInfoTag {
  UNTAGGED = 'UNTAGGED',
  HOME = 'HOME',
}

/** @enumType */
/** @internal */
export type AddressInfoTagWithLiterals = AddressInfoTag | 'UNTAGGED' | 'HOME';

/** @internal */
export enum ConfirmationLevel {
  UNKNOWN_CONFIRMATION_LEVEL = 'UNKNOWN_CONFIRMATION_LEVEL',
  SINGLE_CONFIRMATION = 'SINGLE_CONFIRMATION',
  DOUBLE_CONFIRMATION = 'DOUBLE_CONFIRMATION',
}

/** @enumType */
/** @internal */
export type ConfirmationLevelWithLiterals =
  | ConfirmationLevel
  | 'UNKNOWN_CONFIRMATION_LEVEL'
  | 'SINGLE_CONFIRMATION'
  | 'DOUBLE_CONFIRMATION';

/** @internal */
export enum ContactField {
  UNKNOWN_CONTACT_FIELD = 'UNKNOWN_CONTACT_FIELD',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  COMPANY = 'COMPANY',
  POSITION = 'POSITION',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  ADDRESS = 'ADDRESS',
  BIRTHDATE = 'BIRTHDATE',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  SUBSCRIPTION = 'SUBSCRIPTION',
  VAT_ID = 'VAT_ID',
}

/** @enumType */
/** @internal */
export type ContactFieldWithLiterals =
  | ContactField
  | 'UNKNOWN_CONTACT_FIELD'
  | 'FIRST_NAME'
  | 'LAST_NAME'
  | 'COMPANY'
  | 'POSITION'
  | 'EMAIL'
  | 'PHONE'
  | 'ADDRESS'
  | 'BIRTHDATE'
  | 'CUSTOM_FIELD'
  | 'SUBSCRIPTION'
  | 'VAT_ID';

/** @internal */
export interface EmailInfo {
  /** Email tag. */
  tag?: EmailInfoTagWithLiterals;
}

/** @internal */
export interface PhoneInfo {
  /** Phone tag. */
  tag?: PhoneInfoTagWithLiterals;
}

/** @internal */
export interface AddressInfo {
  /** Address tag. */
  tag?: AddressInfoTagWithLiterals;
}

/** @internal */
export interface CustomFieldInfo {
  /**
   * Custom field key.
   * @minLength 1
   * @maxLength 500
   */
  key?: string;
}

/** @internal */
export interface SubscriptionInfo {
  /**
   * Subscription consent opt in level, either single or double confirmation.
   * Default: SINGLE_CONFIRMATION
   */
  confirmationLevel?: ConfirmationLevelWithLiterals;
}

/** @internal */
export interface _String extends _StringComponentTypeOptionsOneOf {
  /** Text input field */
  textInputOptions?: TextInput;
  /** Selection field as radio group */
  radioGroupOptions?: RadioGroup;
  /** Selection field as drop down */
  dropdownOptions?: Dropdown;
  /** Field for selecting date and/or time */
  dateTimeOptions?: DateTimeInput;
  /** Phone input field */
  phoneInputOptions?: PhoneInput;
  /** Dropdown based component for selecting date */
  dateInputOptions?: DateInput;
  /** Field for selecting time */
  timeInputOptions?: TimeInput;
  /** Calendar type component for selecting date */
  datePickerOptions?: DatePicker;
  /** Dropdown for selecting services */
  servicesDropdownOptions?: ServicesDropdown;
  /** Password component settings. */
  passwordOptions?: Password;
  /** Validation of field output value. */
  validation?: StringType;
  /**
   * Component type of the string input field
   * @readonly
   */
  componentType?: StringComponentTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface _StringComponentTypeOptionsOneOf {
  /** Text input field */
  textInputOptions?: TextInput;
  /** Selection field as radio group */
  radioGroupOptions?: RadioGroup;
  /** Selection field as drop down */
  dropdownOptions?: Dropdown;
  /** Field for selecting date and/or time */
  dateTimeOptions?: DateTimeInput;
  /** Phone input field */
  phoneInputOptions?: PhoneInput;
  /** Dropdown based component for selecting date */
  dateInputOptions?: DateInput;
  /** Field for selecting time */
  timeInputOptions?: TimeInput;
  /** Calendar type component for selecting date */
  datePickerOptions?: DatePicker;
  /** Dropdown for selecting services */
  servicesDropdownOptions?: ServicesDropdown;
  /** Password component settings. */
  passwordOptions?: Password;
}

/** @internal */
export interface InputField_Number
  extends InputField_NumberComponentTypeOptionsOneOf {
  /** Number value input field */
  numberInputOptions?: NumberInput;
  /** Rating value input field */
  ratingInputOptions?: RatingInput;
  /** Validation of field output value. */
  validation?: NumberType;
  /**
   * Component type of the number input field
   * @readonly
   */
  componentType?: NumberComponentTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface InputField_NumberComponentTypeOptionsOneOf {
  /** Number value input field */
  numberInputOptions?: NumberInput;
  /** Rating value input field */
  ratingInputOptions?: RatingInput;
}

/** @internal */
export interface _Boolean extends _BooleanComponentTypeOptionsOneOf {
  /** Checkbox input field */
  checkboxOptions?: Checkbox;
  /** Validation of field output value. */
  validation?: BooleanType;
  /**
   * Component type of the boolean input field
   * @readonly
   */
  componentType?: BooleanComponentTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface _BooleanComponentTypeOptionsOneOf {
  /** Checkbox input field */
  checkboxOptions?: Checkbox;
}

/** @internal */
export interface _Array extends _ArrayComponentTypeOptionsOneOf {
  /** Checkbox group input field */
  checkboxGroupOptions?: CheckboxGroup;
  /** Tags input field */
  tagsOptions?: Tags;
  /** Validation of array type. */
  validation?: ArrayType;
  /**
   * Component type of the array input field
   * @readonly
   */
  componentType?: ArrayComponentTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface _ArrayComponentTypeOptionsOneOf {
  /** Checkbox group input field */
  checkboxGroupOptions?: CheckboxGroup;
  /** Tags input field */
  tagsOptions?: Tags;
}

/** @internal */
export interface _Object {
  /** Validation of object type. */
  validation?: ObjectType;
}

/** @internal */
export interface WixFile extends WixFileComponentTypeOptionsOneOf {
  /** File upload input field */
  fileUploadOptions?: FileUpload;
  /** Signature input field */
  signatureOptions?: Signature;
  /**
   * Component type of the array input field
   * @readonly
   */
  componentType?: WixFileComponentTypeWithLiterals;
  /** Validation of field type. */
  validation?: FileType;
}

/** @oneof */
/** @internal */
export interface WixFileComponentTypeOptionsOneOf {
  /** File upload input field */
  fileUploadOptions?: FileUpload;
  /** Signature input field */
  signatureOptions?: Signature;
}

/** @internal */
export interface Payment extends PaymentComponentTypeOptionsOneOf {
  /** Checkbox group input field. */
  checkboxGroupOptions?: ProductCheckboxGroup;
  /** Donation input field. */
  donationInputOptions?: DonationInput;
  /** Payment input field. */
  paymentInputOptions?: PaymentInput;
  /** Fixed payment field. */
  fixedPaymentOptions?: FixedPayment;
  /**
   * Component type of the payment input field.
   * @readonly
   */
  componentType?: PaymentComponentTypeWithLiterals;
  /** Validation of payment type. */
  validation?: PaymentType;
}

/** @oneof */
/** @internal */
export interface PaymentComponentTypeOptionsOneOf {
  /** Checkbox group input field. */
  checkboxGroupOptions?: ProductCheckboxGroup;
  /** Donation input field. */
  donationInputOptions?: DonationInput;
  /** Payment input field. */
  paymentInputOptions?: PaymentInput;
  /** Fixed payment field. */
  fixedPaymentOptions?: FixedPayment;
}

/** @internal */
export interface Address extends AddressComponentTypeOptionsOneOf {
  /** Multiline address input field. */
  multilineAddressOptions?: MultilineAddress;
  /**
   * Component type of the multiline address field.
   * @readonly
   */
  componentType?: AddressComponentTypeWithLiterals;
  /** Validation of multiline address field output value. */
  validation?: MultilineAddressValidation;
}

/** @oneof */
/** @internal */
export interface AddressComponentTypeOptionsOneOf {
  /** Multiline address input field. */
  multilineAddressOptions?: MultilineAddress;
}

/** @internal */
export interface Scheduling extends SchedulingComponentTypeOptionsOneOf {
  /** Appointment input field */
  appointmentOptions?: Appointment;
  /**
   * Component type of the scheduling input field
   * @readonly
   */
  componentType?: SchedulingComponentTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface SchedulingComponentTypeOptionsOneOf {
  /** Appointment input field */
  appointmentOptions?: Appointment;
}

/** @internal */
export interface DisplayField extends DisplayFieldDisplayFieldTypeOptionsOneOf {
  /** Component displaying rich content */
  richContentOptions?: RichContentOptions;
  /** Page navigation component resolving as navigation or submit buttons */
  pageNavigationOptions?: PageNavigationOptions;
  /** Type of the display field */
  displayFieldType?: DisplayFieldTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface DisplayFieldDisplayFieldTypeOptionsOneOf {
  /** Component displaying rich content */
  richContentOptions?: RichContentOptions;
  /** Page navigation component resolving as navigation or submit buttons */
  pageNavigationOptions?: PageNavigationOptions;
}

/** @internal */
export enum DisplayFieldType {
  UNKNOWN_FIELD_TYPE = 'UNKNOWN_FIELD_TYPE',
  RICH_CONTENT = 'RICH_CONTENT',
  PAGE_NAVIGATION = 'PAGE_NAVIGATION',
  LOGIN_BAR = 'LOGIN_BAR',
}

/** @enumType */
/** @internal */
export type DisplayFieldTypeWithLiterals =
  | DisplayFieldType
  | 'UNKNOWN_FIELD_TYPE'
  | 'RICH_CONTENT'
  | 'PAGE_NAVIGATION'
  | 'LOGIN_BAR';

/** @internal */
export interface RichContentOptions {
  /** Content of the header */
  richContent?: RichContent;
  /** Number of paragraphs visible. Other part is hidden under expandable section. If not provided all text visible. */
  maxShownParagraphs?: number | null;
}

/** @internal */
export interface PageNavigationOptions {
  /**
   * When button is not on last page it behaves as switch between pages page, text of label to go to next page.
   * @maxLength 65
   */
  nextPageText?: string | null;
  /**
   * When button is not on last page it behaves as switch between pages page, text of label to go to previous page.
   * @maxLength 65
   */
  previousPageText?: string | null;
  /**
   * Text on the button when button is submitting a form
   * @maxLength 65
   */
  submitText?: string | null;
}

/** @internal */
export interface Step {
  /**
   * Step ID.
   * @format GUID
   * @immutable
   */
  id?: string;
  /**
   * Name of the step.
   * @maxLength 200
   */
  name?: string | null;
  /** Is step hidden */
  hidden?: boolean;
  /** Form step properties */
  layout?: FormLayout;
}

/** @internal */
export interface FormLayout {
  /** Layout for large break point. */
  large?: BreakPoint;
  /** Layout for medium break point. */
  medium?: BreakPoint;
  /** Layout for small break point. */
  small?: BreakPoint;
}

/** @internal */
export interface BreakPoint {
  /**
   * Description of layouts for items.
   * @maxSize 500
   */
  items?: ItemLayout[];
  /** Amount of columns of layout grid. */
  columns?: number | null;
  /** Row height of layout grid. */
  rowHeight?: number | null;
  /** Description of elements margins. */
  margin?: Margin;
  /** Description of elements paddings. */
  padding?: Margin;
  /**
   * Sections of the layout, which allow manage fields
   * @maxSize 100
   */
  sections?: BreakPointSection[];
}

/** @internal */
export interface ItemLayout extends ItemLayoutItemOneOf {
  /**
   * Form field reference id.
   * @format GUID
   */
  fieldId?: string;
  /** Group info, defining that this item is a group of multiple fields */
  group?: Group;
  /** Horizontal coordinate in the grid. */
  row?: number | null;
  /** Vertical coordinate in the grid. */
  column?: number | null;
  /** Height. */
  width?: number | null;
  /** Width. */
  height?: number | null;
}

/** @oneof */
/** @internal */
export interface ItemLayoutItemOneOf {
  /**
   * Form field reference id.
   * @format GUID
   */
  fieldId?: string;
  /** Group info, defining that this item is a group of multiple fields */
  group?: Group;
}

/** @internal */
export interface Group {
  /**
   * Field group reference id.
   * @format GUID
   */
  groupId?: string;
  /**
   * Description of layouts for items.
   * @minSize 1
   * @maxSize 500
   */
  items?: ItemLayout[];
}

/** @internal */
export interface Margin {
  /** Horizontal value. */
  horizontal?: number | null;
  /** Vertical value. */
  vertical?: number | null;
}

/** @internal */
export interface BreakPointSection {
  /**
   * Id of the section
   * @format GUID
   * @minLength 1
   */
  id?: string;
  /** Horizontal coordinate in the grid. */
  row?: number | null;
  /**
   * A list of field identifiers that are permitted to be placed within a section.
   * The section will only accept fields with IDs specified in this list.
   * If the section encounters the $new key within the list,
   * it allows the inclusion of fields not explicitly listed,
   * enabling dynamic addition of new fields.
   * @maxSize 100
   * @maxLength 100
   */
  allowedFieldIds?: string[];
}

/** @internal */
export interface V2Rule {
  /**
   * Id of the rule
   * @format GUID
   * @immutable
   */
  id?: string;
  /** Rule on which item properties or layouts will be changed. */
  expression?: ConditionNode;
  /**
   * Form items with defined properties that will be
   * changed when given condition is resolved to true.
   * @maxSize 500
   */
  overrides?: FormOverride[];
  /**
   * Name of the rule
   * @maxLength 200
   */
  name?: string | null;
  /** Namespace rules are part of business logic of app owning namespace, have limited editing possibilities. */
  namespaceRule?: boolean | null;
}

/** Enum for different types of changeable properties. */
/** @internal */
export enum ChangeableProperty {
  /** Unknown property type. */
  UNKNOWN = 'UNKNOWN',
  /** Required property type. */
  REQUIRED = 'REQUIRED',
  /** Hidden property type. */
  HIDDEN = 'HIDDEN',
  /** Allowed values property type. */
  ALLOWED_VALUES = 'ALLOWED_VALUES',
}

/** @enumType */
/** @internal */
export type ChangeablePropertyWithLiterals =
  | ChangeableProperty
  | 'UNKNOWN'
  | 'REQUIRED'
  | 'HIDDEN'
  | 'ALLOWED_VALUES';

/** @internal */
export interface RequiredOptions {
  /** Value of required property */
  value?: boolean;
}

/** @internal */
export interface HiddenOptions {
  /** Value of hidden property */
  value?: boolean;
}

/** @internal */
export interface AllowedValuesOptions {
  /**
   * Allowed values
   * @maxSize 300
   * @maxLength 200
   */
  value?: string[];
}

/** @internal */
export enum OverrideEntityType {
  UNKNOWN = 'UNKNOWN',
  FIELD = 'FIELD',
}

/** @enumType */
/** @internal */
export type OverrideEntityTypeWithLiterals =
  | OverrideEntityType
  | 'UNKNOWN'
  | 'FIELD';

/** @internal */
export interface FormOverrideFieldOverride
  extends FormOverrideFieldOverridePropertyTypeOptionsOneOf {
  /** Required property overrides */
  requiredOptions?: RequiredOptions;
  /** Hidden property overrides */
  hiddenOptions?: HiddenOptions;
  /** Allowed values property overrides */
  allowedValuesOptions?: AllowedValuesOptions;
  /**
   * Overridden entity id
   * @immutable
   * @format GUID
   */
  fieldId?: string;
  /** Form entity properties path with new value, that will be changed on condition. */
  propertyType?: ChangeablePropertyWithLiterals;
}

/** @oneof */
/** @internal */
export interface FormOverrideFieldOverridePropertyTypeOptionsOneOf {
  /** Required property overrides */
  requiredOptions?: RequiredOptions;
  /** Hidden property overrides */
  hiddenOptions?: HiddenOptions;
  /** Allowed values property overrides */
  allowedValuesOptions?: AllowedValuesOptions;
}

/** @internal */
export interface ConditionNode extends ConditionNodeNodeOneOf {
  /** A compound condition that requires all conditions to be true. */
  and?: AndCondition;
  /** A compound condition that requires at least one condition to be true. */
  or?: OrCondition;
  /** A single condition in the rule. */
  condition?: V2Condition;
}

/** @oneof */
/** @internal */
export interface ConditionNodeNodeOneOf {
  /** A compound condition that requires all conditions to be true. */
  and?: AndCondition;
  /** A compound condition that requires at least one condition to be true. */
  or?: OrCondition;
  /** A single condition in the rule. */
  condition?: V2Condition;
}

/** @internal */
export interface AndCondition {
  /**
   * The list of conditions that must all be true.
   * @minSize 1
   * @maxSize 100
   */
  conditions?: ConditionNode[];
}

/** @internal */
export interface OrCondition {
  /**
   * The list of conditions where at least one must be true.
   * @minSize 1
   * @maxSize 100
   */
  conditions?: ConditionNode[];
}

/** @internal */
export interface V2Condition {
  /**
   * The property name to be evaluated, supports dot notation for nested properties.
   * @maxLength 100
   */
  fact?: string;
  /** The operator to use for comparison. */
  operator?: OperatorWithLiterals;
  /**
   * The value to compare against.
   * @maxLength 500
   */
  value?: string;
}

/** @internal */
export enum Operator {
  UNKNOWN = 'UNKNOWN',
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  EMPTY = 'EMPTY',
  NOT_EMPTY = 'NOT_EMPTY',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  BEFORE = 'BEFORE',
  BEFORE_OR_EQUAL = 'BEFORE_OR_EQUAL',
  AFTER = 'AFTER',
  AFTER_OR_EQUAL = 'AFTER_OR_EQUAL',
  BETWEEN = 'BETWEEN',
  ANY = 'ANY',
  ARRAY_EQUAL = 'ARRAY_EQUAL',
  ARRAY_NOT_EQUAL = 'ARRAY_NOT_EQUAL',
  CHECKED = 'CHECKED',
  NOT_CHECKED = 'NOT_CHECKED',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  IS_DATE_OLDER_THAN = 'IS_DATE_OLDER_THAN',
  IS_DATE_OLDER_THAN_OR_EQUAL = 'IS_DATE_OLDER_THAN_OR_EQUAL',
  IS_DATE_NEWER_THAN = 'IS_DATE_NEWER_THAN',
  IS_DATE_NEWER_THAN_OR_EQUAL = 'IS_DATE_NEWER_THAN_OR_EQUAL',
}

/** @enumType */
/** @internal */
export type OperatorWithLiterals =
  | Operator
  | 'UNKNOWN'
  | 'EQUAL'
  | 'NOT_EQUAL'
  | 'EMPTY'
  | 'NOT_EMPTY'
  | 'CONTAINS'
  | 'NOT_CONTAINS'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUALS'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUALS'
  | 'BEFORE'
  | 'BEFORE_OR_EQUAL'
  | 'AFTER'
  | 'AFTER_OR_EQUAL'
  | 'BETWEEN'
  | 'ANY'
  | 'ARRAY_EQUAL'
  | 'ARRAY_NOT_EQUAL'
  | 'CHECKED'
  | 'NOT_CHECKED'
  | 'IN'
  | 'NOT_IN'
  | 'IS_DATE_OLDER_THAN'
  | 'IS_DATE_OLDER_THAN_OR_EQUAL'
  | 'IS_DATE_NEWER_THAN'
  | 'IS_DATE_NEWER_THAN_OR_EQUAL';

/** @internal */
export interface FormOverride extends FormOverrideEntityTypeOptionsOneOf {
  /** Field override properties. */
  fieldOptions?: FormOverrideFieldOverride;
  /**
   * Override entity type.
   * @immutable
   */
  entityType?: OverrideEntityTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface FormOverrideEntityTypeOptionsOneOf {
  /** Field override properties. */
  fieldOptions?: FormOverrideFieldOverride;
}

/** @internal */
export interface SubmitSettings
  extends SubmitSettingsSubmitSuccessActionOptionsOneOf {
  /** Options for showing a thank you message after submission. */
  thankYouMessageOptions?: ThankYouMessageOptions;
  /** Options for redirecting to a URL after submission. */
  redirectOptions?: RedirectOptions;
  /** Action that is triggered after a successful form submission. */
  submitSuccessAction?: SubmitSuccessActionWithLiterals;
}

/** @oneof */
/** @internal */
export interface SubmitSettingsSubmitSuccessActionOptionsOneOf {
  /** Options for showing a thank you message after submission. */
  thankYouMessageOptions?: ThankYouMessageOptions;
  /** Options for redirecting to a URL after submission. */
  redirectOptions?: RedirectOptions;
}

/** @internal */
export enum Target {
  /** Unknown target. */
  UNKNOWN_TARGET = 'UNKNOWN_TARGET',
  /** Open in the same browser tab. */
  SELF = 'SELF',
  /** Open in a new browser tab. */
  BLANK = 'BLANK',
}

/** @enumType */
/** @internal */
export type TargetWithLiterals = Target | 'UNKNOWN_TARGET' | 'SELF' | 'BLANK';

/** @internal */
export enum SubmitSuccessAction {
  /** Unknown submit success action. */
  UNKNOWN_SUBMIT_SUCCESS_ACTION = 'UNKNOWN_SUBMIT_SUCCESS_ACTION',
  /** No action will be taken after submission. */
  NO_ACTION = 'NO_ACTION',
  /** A thank you message will be shown after submission. */
  THANK_YOU_MESSAGE = 'THANK_YOU_MESSAGE',
  /** The user will be redirected to a URL after submission. */
  REDIRECT = 'REDIRECT',
}

/** @enumType */
/** @internal */
export type SubmitSuccessActionWithLiterals =
  | SubmitSuccessAction
  | 'UNKNOWN_SUBMIT_SUCCESS_ACTION'
  | 'NO_ACTION'
  | 'THANK_YOU_MESSAGE'
  | 'REDIRECT';

/** @internal */
export interface ThankYouMessageOptions {
  /** Duration in seconds after which the message should disappear. If 0, the message will stay forever. */
  durationInSeconds?: number | null;
  /** The message shown after form submission. */
  richContent?: RichContent;
}

/** @internal */
export interface RedirectOptions {
  /**
   * The URL to which the user should be redirected after a successful form submission.
   * @maxLength 2000
   */
  redirectUrl?: string | null;
  /** How the URL should be opened. */
  target?: TargetWithLiterals;
}

/** @internal */
export enum TemplateType {
  UNKNOWN = 'UNKNOWN',
  /** a template, which can be extended by a site specific form with custom properties */
  EXTENDABLE = 'EXTENDABLE',
  /** a template, from which a demo form is created */
  DEMO = 'DEMO',
  /**
   * a form input, having more than one field.
   * E.g. address (country, state, street, postal code), or phone number (country code, number)
   */
  FORM_INPUT = 'FORM_INPUT',
}

/** @enumType */
/** @internal */
export type TemplateTypeWithLiterals =
  | TemplateType
  | 'UNKNOWN'
  | 'EXTENDABLE'
  | 'DEMO'
  | 'FORM_INPUT';

/** @internal */
export interface ExtensionDetails {
  /** Allow user to add/remove custom field, not present in template */
  addCustomFields?: AddCustomFields;
  /** Allow user to override properties of already existing template fields */
  overrideTemplateFields?: OverrideTemplateFields;
  /** Allow user to delete specific fields */
  deleteTemplateFields?: DeleteTemplateFields;
}

/** @internal */
export enum CustomFieldsType {
  /** Allow user to add/remove any custom field, not present in template */
  ANY = 'ANY',
}

/** @enumType */
/** @internal */
export type CustomFieldsTypeWithLiterals = CustomFieldsType | 'ANY';

/** @internal */
export enum EditableProperties {
  UNKNOWN = 'UNKNOWN',
  /** Change property responsible for field requirement */
  REQUIRED = 'REQUIRED',
  /** Change property responsible for field visibility */
  HIDDEN = 'HIDDEN',
  /** Change property of field label */
  LABEL = 'LABEL',
  /** Change property of field placeholder */
  PLACEHOLDER = 'PLACEHOLDER',
  /** Change property of field description */
  DESCRIPTION = 'DESCRIPTION',
  /**
   * Change property of validation specifying max/min boundaries for input value
   * maxLength/minLength for string, max/min for number.
   */
  INPUT_VALUE_LIMITS = 'INPUT_VALUE_LIMITS',
  /** Change property responsible for field default value */
  DEFAULT_VALUE = 'DEFAULT_VALUE',
}

/** @enumType */
/** @internal */
export type EditablePropertiesWithLiterals =
  | EditableProperties
  | 'UNKNOWN'
  | 'REQUIRED'
  | 'HIDDEN'
  | 'LABEL'
  | 'PLACEHOLDER'
  | 'DESCRIPTION'
  | 'INPUT_VALUE_LIMITS'
  | 'DEFAULT_VALUE';

/** @internal */
export interface EditableFields {
  /**
   * List of editable properties for field
   * @maxSize 10
   */
  properties?: EditablePropertiesWithLiterals[];
}

/** @internal */
export interface AddCustomFields {
  /** Field types which can be added */
  fieldType?: CustomFieldsTypeWithLiterals;
}

/** @internal */
export interface OverrideTemplateFields {
  /** Editable properties by field id. */
  editableFields?: Record<string, EditableFields>;
}

/** @internal */
export interface DeleteTemplateFields {
  /**
   * List of ids, of fields which can be deleted
   * @format GUID
   * @maxSize 100
   */
  deletableFieldIds?: string[];
}

/** @internal */
export interface FieldGroup {
  /**
   * Id of group, on layout
   * @format GUID
   */
  id?: string;
  /**
   * Label of group
   * @maxLength 350
   */
  label?: string | null;
}

/** @internal */
export interface RequiredIndicatorProperties {
  /** Required indicator. */
  requiredIndicator?: RequiredIndicatorWithLiterals;
  /** Required indicator placement. */
  requiredIndicatorPlacement?: RequiredIndicatorPlacementWithLiterals;
}

/** @internal */
export enum RequiredIndicator {
  /** Unknown required indicator. */
  UNKNOWN_INDICATOR = 'UNKNOWN_INDICATOR',
  /** Asterisk (*). */
  ASTERISK = 'ASTERISK',
  /** Text (default: "Required"). */
  TEXT = 'TEXT',
  /** None. */
  NONE = 'NONE',
}

/** @enumType */
/** @internal */
export type RequiredIndicatorWithLiterals =
  | RequiredIndicator
  | 'UNKNOWN_INDICATOR'
  | 'ASTERISK'
  | 'TEXT'
  | 'NONE';

/** @internal */
export enum RequiredIndicatorPlacement {
  /** Unknown required indicator placement. */
  UNKNOWN_PLACEMENT = 'UNKNOWN_PLACEMENT',
  /** After field title. */
  AFTER_FIELD_TITLE = 'AFTER_FIELD_TITLE',
  /** Before field title. */
  BEFORE_FIELD_TITLE = 'BEFORE_FIELD_TITLE',
}

/** @enumType */
/** @internal */
export type RequiredIndicatorPlacementWithLiterals =
  | RequiredIndicatorPlacement
  | 'UNKNOWN_PLACEMENT'
  | 'AFTER_FIELD_TITLE'
  | 'BEFORE_FIELD_TITLE';

/** Describes a setting group of a notification */
/** @internal */
export interface NotificationContent {
  single?: SingleContent;
  grouped?: GroupedContent;
}

/** notification content. */
/** @internal */
export interface SingleContent {
  /** Title. */
  title?: string | null;
  /** Text that appears in the nofication. */
  message?: string;
  /** Action that can be triggered in the notification. */
  action?: string | null;
}

/** notification content. */
/** @internal */
export interface GroupedContent {
  /** Title. */
  title?: string | null;
  /** Message. */
  message?: string;
  /** Action. */
  action?: string | null;
}

/** Describes topic of a notification */
/** @internal */
export interface BroadcastList {
  /** @maxSize 20 */
  params?: Param[];
}

/** @internal */
export interface Param {
  id?: string;
  displayName?: string;
}

/** @internal */
export interface PayoutsProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
}

/** Configuration for ReviewsEntityCatalogProvider */
/** @internal */
export interface ReviewsEntityCatalogProviderConfig {
  /** URI where the SPI Implementer is deployed */
  uriConfig?: SpiBaseUri;
  /**
   * Namespace of catalog provider
   * @maxLength 100
   */
  namespace?: string;
  /** Flag that indicates if verified reviews are enabled */
  verifiedReviewsEnabled?: boolean;
}

/** @internal */
export interface VeloPublishPipelineTaskProviderConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /**
   * The Velo Task name
   * @maxSize 100
   */
  implementerTasksNames?: WixCodePublishTaskNameWithLiterals[];
}

/** @internal */
export enum WixCodePublishTaskName {
  /** unknown */
  UNKNOWN = 'UNKNOWN',
  /** user code bundle */
  USER_CODE_BUNDLE = 'USER_CODE_BUNDLE',
  /** exported functions analysis */
  EXPORTED_FUNCTIONS_ANALYSIS = 'EXPORTED_FUNCTIONS_ANALYSIS',
  /** imported namespaces analysis */
  IMPORTED_NAMESPACES_ANALYSIS = 'IMPORTED_NAMESPACES_ANALYSIS',
  /** page details analysis */
  PAGE_DETAILS_ANALYSIS = 'PAGE_DETAILS_ANALYSIS',
  /** user code validation */
  USER_CODE_VALIDATION = 'USER_CODE_VALIDATION',
  /** code packages dependencies registration */
  CODE_PACKAGES_REGISTRATION = 'CODE_PACKAGES_REGISTRATION',
}

/** @enumType */
/** @internal */
export type WixCodePublishTaskNameWithLiterals =
  | WixCodePublishTaskName
  | 'UNKNOWN'
  | 'USER_CODE_BUNDLE'
  | 'EXPORTED_FUNCTIONS_ANALYSIS'
  | 'IMPORTED_NAMESPACES_ANALYSIS'
  | 'PAGE_DETAILS_ANALYSIS'
  | 'USER_CODE_VALIDATION'
  | 'CODE_PACKAGES_REGISTRATION';

/** @internal */
export interface FunctionsShopPriceSpiConfig {
  /** Uri config */
  uriConfig?: SpiBaseUri;
  /**
   * function shop id
   * @format GUID
   */
  functionShopId?: string | null;
  /** Namespace */
  namespace?: Namespace;
  /**
   * Repeated namespace case
   * @maxSize 100
   */
  namespaces?: Namespace[];
  /**
   * String name
   * @maxLength 100
   */
  shopName?: string | null;
  /** Simple double */
  shopNumber?: number | null;
}

/** @internal */
export interface Namespace {
  /**
   * Namespace name
   * @maxLength 100
   */
  name?: string | null;
  /**
   * Additional function shop id
   * @format GUID
   */
  functionShopId?: string | null;
}

/**
 * A component that describes a Function
 * Design is highly influenced by business schema api
 */
/** @internal */
export interface _Function {
  /**
   * Function method definitions
   * @maxSize 100
   */
  definitions?: FunctionDefinition[];
  /** Function configuration */
  configuration?: Configuration;
  /** Function description */
  description?: Description;
}

/** @internal */
export interface Input {
  /**
   * Schema definition: https://json-schema.org/draft/2020-12/schema
   * Protobuf does not support `$` variables -- cannot define the json-schema in protobuf
   */
  schema?: Record<string, any> | null;
  /** UI definition */
  ui?: Record<string, any> | null;
  /**
   * Input display description
   * @maxLength 200
   */
  displayDescription?: string | null;
  /** Builder SPI */
  builderSpi?: BuilderSpi;
}

/** @internal */
export interface BuilderSpi {
  /**
   * SPI url called from Function Builder
   * @maxLength 1000
   */
  baseUri?: string | null;
  /** Whether SPI supports appending Input Schema dynamically */
  dynamicSchemaFetchingEnabled?: boolean | null;
}

/** @internal */
export interface Output {
  /**
   * Schema definition: https://json-schema.org/draft/2020-12/schema
   * Protobuf does not support `$` variables -- cannot define the json-schema in protobuf
   */
  schema?: Record<string, any> | null;
  /** UI definition */
  ui?: Record<string, any> | null;
  /** Defined state */
  defined?: State;
  /** Empty state */
  empty?: State;
  /** Static content for the output */
  staticContent?: StaticContent;
}

/** @internal */
export interface State {
  /**
   * State description
   * @maxLength 200
   */
  description?: string | null;
}

/** @internal */
export interface StaticContent {
  /**
   * Static content title
   * @maxLength 100
   */
  title?: string | null;
  /**
   * Static content description
   * @maxLength 200
   */
  description?: string | null;
}

/** @internal */
export interface Spi {
  /**
   * SPI fqdn
   * @maxLength 200
   */
  fqdn?: string | null;
  /**
   * Configuration based on dev center SPI component configuration
   * Schema definition: https://json-schema.org/draft/2020-12/schema
   */
  schema?: Record<string, any> | null;
  /** UI definition */
  ui?: Record<string, any> | null;
}

/** @internal */
export interface CustomInitialPreset {
  /**
   * Custom initial function template extension id
   * @format GUID
   */
  functionTemplateExtensionId?: string | null;
  /** Indicates whether the custom initial preset with a custom function template is enabled; if false, the blank function template is used */
  enabled?: boolean | null;
}

/** @internal */
export enum Scope {
  UNKNOWN_SCOPE = 'UNKNOWN_SCOPE',
  /** One function instance is allowed per site */
  SITE = 'SITE',
  /** One function instance is allowed per entity */
  ENTITY = 'ENTITY',
}

/** @enumType */
/** @internal */
export type ScopeWithLiterals = Scope | 'UNKNOWN_SCOPE' | 'SITE' | 'ENTITY';

/**
 * Function definition
 * IMPORTANT! Initial product will support only single function definition
 */
/** @internal */
export interface FunctionDefinition {
  /**
   * Method
   * @maxLength 255
   */
  method?: string;
  /** Function input. */
  input?: Input;
  /** Function output. */
  output?: Output;
  /**
   * @format GUID
   * @readonly
   */
  triggerId?: string | null;
}

/** @internal */
export interface Configuration {
  /** Function can be implemented multiple times on single site */
  multipleInstancesAllowed?: boolean | null;
  /** Spi configuration */
  spi?: Spi;
  /**
   * Do not include the function in the functions catalog in the BM
   * @internal
   */
  hideFromFunctionsCatalog?: boolean | null;
  /** The custom initial preset to use when building a function from scratch */
  customInitialPreset?: CustomInitialPreset;
  /**
   * Do not include the function in the create with AI flow
   * @internal
   */
  hideFromCreateWithAi?: boolean | null;
  /** Scope of the function when multiple_instances_allowed is false */
  scope?: ScopeWithLiterals;
  /**
   * Error message to display when entity scope validation fails.
   * @maxLength 200
   */
  entityScopeErrorMessage?: string | null;
}

/** @internal */
export interface Description {
  /** @maxLength 600 */
  aboutDescription?: string | null;
  /**
   * Description of how it works
   * @maxLength 1000
   */
  howItWorksDescription?: string | null;
  /**
   * Description of the outcome
   * @maxLength 600
   */
  outcomeDescription?: string | null;
  /** Representative image */
  representativeImage?: WixCommonImage;
  /**
   * Title of the builderless function template selection modal
   * @maxLength 100
   */
  builderlessTemplateSelectionModalTitle?: string | null;
  /**
   * Subtitle of the builderless function template selection modal
   * @maxLength 200
   */
  builderlessTemplateSelectionModalSubtitle?: string | null;
}

/** @internal */
export interface CheckoutContentSPIConfig {
  /**
   * Base URI where the endpoints are called. Wix eCommerce appends the endpoint path to the base URI.
   * @minLength 1
   * @maxLength 1000
   */
  deploymentUri?: string;
  /**
   * Text to display in place of the "Continue shopping" link.
   * @maxLength 30
   */
  continueShoppingLink?: string | null;
  /**
   * Text to display in place of the "Order summary" title.
   * @minLength 1
   * @maxLength 30
   */
  orderSummary?: string | null;
  /**
   * Text to display in place of the "Customer details" title.
   * @minLength 1
   * @maxLength 30
   */
  customerDetails?: string | null;
  /**
   * Text to display in place of the "Review and place order" title.
   * @minLength 1
   * @maxLength 50
   */
  reviewAndPlaceOrder?: string | null;
  /**
   * Text to display in place of the "Place order" button.
   * @minLength 1
   * @maxLength 50
   */
  placeOrderButton?: string | null;
  /**
   * Text to display in place of the "Place order & pay" button.
   * @minLength 1
   * @maxLength 50
   */
  placeOrderPayButton?: string | null;
}

/** @internal */
export interface V2CommunicationChannelConfiguration {
  /**
   * The channel provider URI that will be called in runtime
   * @maxLength 2000
   */
  deploymentUri?: string;
  /** The main configuration of the channel */
  config?: ChannelChannelConfiguration;
  /** States whether or not specific methods were implemented by the provider in order to know whether to call them in runtime */
  implementedMethods?: ChannelImplementedMethods;
}

/** @internal */
export interface ChannelChannelConfiguration
  extends ChannelChannelConfigurationMessagingConfigOneOf {
  /** Direct messaging configuration */
  directMessagingConfig?: DmDirectMessageConfig;
  /** Email messaging configuration */
  emailConfig?: EmailEmailMessageConfig;
  /** Sms messaging configuration */
  smsConfig?: SmsSmsMessageConfig;
  /**
   * kebab-case channel identifier. Allows the provider to register multiple channels with the same provider app.
   * @minLength 1
   * @maxLength 50
   */
  channelKey?: string;
  /** The type of the communication channel */
  type?: ChannelConfigurationChannelTypeWithLiterals;
  /** Specific provider branding parameters for the channel */
  branding?: ChannelChannelBranding;
  /**
   * Indicates if the channel is HIPAA compliant
   * @readonly
   */
  hipaaCompliant?: boolean;
}

/** @oneof */
/** @internal */
export interface ChannelChannelConfigurationMessagingConfigOneOf {
  /** Direct messaging configuration */
  directMessagingConfig?: DmDirectMessageConfig;
  /** Email messaging configuration */
  emailConfig?: EmailEmailMessageConfig;
  /** Sms messaging configuration */
  smsConfig?: SmsSmsMessageConfig;
}

/** The type of the communication channel */
/** @internal */
export enum ChannelConfigurationChannelType {
  UNKNOWN_CHANNEL_TYPE = 'UNKNOWN_CHANNEL_TYPE',
  DIRECT_MESSAGING = 'DIRECT_MESSAGING',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

/** @enumType */
/** @internal */
export type ChannelConfigurationChannelTypeWithLiterals =
  | ChannelConfigurationChannelType
  | 'UNKNOWN_CHANNEL_TYPE'
  | 'DIRECT_MESSAGING'
  | 'EMAIL'
  | 'SMS';

/** @internal */
export interface DmDirectMessageConfig {
  /**
   * Direct message types accepted by the provider.
   * Only supported types will be sent to the provider.
   * If the provider supports all message types, this field can be empty.
   * @maxSize 100
   */
  acceptedMessageTypes?: AcceptedMessageTypesAcceptedDirectMessageTypeWithLiterals[];
  /** Supported media types (mime types) and sizes */
  mediaCapabilities?: ChannelMediaCapabilities;
  /** Defines whether or not sending messages will be available for recipients without contact Id */
  allowAnonymousRecipients?: boolean;
  /**
   * TODO: we might consider changing/removing this field on next phases due to a strong dependency on Wix live site
   * Indicates whether or not the channel requires a live Wix website for a proper end to end channel functionality,
   * (for example, a live site is required for chat use case)
   */
  requireLiveSite?: boolean;
}

/** 'TEXT' type is assumed to be always supported, hence not explicitly annotated. */
/** @internal */
export enum AcceptedMessageTypesAcceptedDirectMessageType {
  UNKNOWN_DIRECT_MESSAGE_TYPE = 'UNKNOWN_DIRECT_MESSAGE_TYPE',
  MEDIA = 'MEDIA',
  CARD = 'CARD',
  MINIMAL = 'MINIMAL',
  FORM = 'FORM',
  SYSTEM = 'SYSTEM',
}

/** @enumType */
/** @internal */
export type AcceptedMessageTypesAcceptedDirectMessageTypeWithLiterals =
  | AcceptedMessageTypesAcceptedDirectMessageType
  | 'UNKNOWN_DIRECT_MESSAGE_TYPE'
  | 'MEDIA'
  | 'CARD'
  | 'MINIMAL'
  | 'FORM'
  | 'SYSTEM';

/** @internal */
export interface ChannelMediaCapabilities {
  /** When marked as true, 'supported_media_types' will be ignored. */
  allMediaTypes?: boolean;
  /** Maximal file size in bytes of a single file in a message */
  maxFileSizeInBytes?: number | null;
  /**
   * List for supported media MIME types. Used when allMediaTypes is set to `false`
   * Allowed MIME types must be according to the format as described here:
   * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
   * @maxSize 50
   * @maxLength 255
   */
  supportedMediaTypes?: string[];
}

/** @internal */
export interface EmailEmailMessageConfig {
  /** Supported media types (mime types) and sizes */
  mediaCapabilities?: ChannelMediaCapabilities;
  /** Maximal size in bytes of total media items in a message. */
  maxTotalFilesSizeInBytes?: number | null;
}

/** @internal */
export interface SmsSmsMessageConfig {
  /**
   * SMS message types accepted by the provider. Only supported types will be sent to the provider.
   * @minSize 1
   * @maxSize 100
   */
  acceptedMessageTypes?: AcceptedMessageTypesAcceptedSmsMessageTypeWithLiterals[];
  /** Supported media types (mime types) and sizes */
  mediaCapabilities?: ChannelMediaCapabilities;
  /** Optional - maximum sms message length in characters, if not given, will be unlimited */
  maxCharacters?: string | null;
}

/** @internal */
export enum AcceptedMessageTypesAcceptedSmsMessageType {
  UNKNOWN_SMS_MESSAGE_TYPE = 'UNKNOWN_SMS_MESSAGE_TYPE',
  SMS = 'SMS',
  MMS = 'MMS',
}

/** @enumType */
/** @internal */
export type AcceptedMessageTypesAcceptedSmsMessageTypeWithLiterals =
  | AcceptedMessageTypesAcceptedSmsMessageType
  | 'UNKNOWN_SMS_MESSAGE_TYPE'
  | 'SMS'
  | 'MMS';

/** @internal */
export interface ChannelChannelBranding {
  /**
   * The name of the channel, e.g. `Facebook` / `SMS`
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /**
   * The name of the channel provider (e.g. Wix, Meta, Google)
   * @minLength 1
   * @maxLength 100
   */
  providerName?: string;
  /**
   * The description of the channel
   * @minLength 1
   * @maxLength 500
   */
  description?: string | null;
  /** Relevant brand icons */
  brandIcons?: ChannelBrandIcons;
}

/** Brand icons required for correct channel integration */
/** @internal */
export interface ChannelBrandIcons {
  /** Channel branding vector Icon */
  vectorImage?: UpstreamWixCommonImage;
  /** Channel branding Black & White Icon */
  bwOutlineVectorImage?: UpstreamWixCommonImage;
}

/** @internal */
export interface UpstreamWixCommonImage {
  /**
   * WixMedia image ID.
   * @maxLength 2000
   */
  id?: string | null;
  /**
   * Image URL.
   * @format WEB_URL
   * @readonly
   */
  url?: string | null;
}

/** @internal */
export interface ChannelImplementedMethods {
  /** Implements getQuotaInfo */
  getQuotaInfo?: boolean;
  /** Implements validateSendingEligibility */
  validateSendingEligibility?: boolean;
  /** Implements updateMessageStatus */
  updateMessageStatus?: boolean;
}

/** @internal */
export interface WebhookComponentData {
  /**
   * The slug of the webhook, as in webhooks catalog
   * @minLength 1
   * @maxLength 128
   */
  webhookSlug?: string;
  /**
   * The callback url to be called when the webhook is triggered
   * @format WEB_URL
   */
  callbackUrl?: string;
}

/** A component that holds topology data for an application. */
/** @internal */
export interface TopologyComponentData {
  /**
   * Records of topology
   * @format WEB_URL
   */
  topology?: Record<string, string>;
}

/** @internal */
export interface CustomRewardProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the custom reward
   * @maxLength 100
   */
  rewardName?: string;
  /**
   * User-friendly description of the custom reward
   * @maxLength 500
   */
  rewardDescription?: string;
}

/** Wix Users can choose to create a "Function" component according to predefined recipes for smoother user experience */
/** @internal */
export interface FunctionRecipe {
  /**
   * Description of the function recipe
   * @maxLength 300
   */
  displayDescription?: string;
  /**
   * Meta site from which template function was taken to create a recipe
   * @format GUID
   */
  originMetaSiteId?: string;
  /**
   * Function in the meta site which was used as a template to create a recipe
   * @format GUID
   */
  originFunctionId?: string;
  /**
   * "Function" component/extension that this recipe is about
   * @format GUID
   */
  functionExtensionId?: string;
  /**
   * Created function id
   * @format GUID
   */
  functionId?: string | null;
  /**
   * Builderless flow form template id
   * @format GUID
   */
  formTemplateExtensionId?: string | null;
}

/** A backoffice component for external url`s */
/** @internal */
export interface BackOfficeExternalUrl {
  /**
   * The platform this component is hosted on
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * the external url to be opened
   * @maxLength 250
   */
  url?: string | null;
  /** general component data */
  metaData?: ComponentMetaData;
  /**
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * Required permission to view URL. if subject is missing this permission, the link will be hidden from the search
   * @internal
   * @maxLength 128
   */
  requiredPermission?: string | null;
}

/** @internal */
export interface FactorConfig {
  /** the base URI where all the methods are deployed. */
  uriConfig?: SpiBaseUri;
  /** the type of the factor */
  factorType?: FactorTypeWithLiterals;
  /** whether the factor supports verify without enrolling first */
  supportsVerifyWithoutEnroll?: boolean;
  /** whether the factor implementer requires enrollment */
  enrollRequired?: boolean;
}

/** @internal */
export enum FactorType {
  /** Unknown factor type. */
  UNKNOWN_FACTOR_TYPE = 'UNKNOWN_FACTOR_TYPE',
  /** Requires a password. */
  PASSWORD = 'PASSWORD',
  /** Requires a code sent via SMS. */
  SMS = 'SMS',
  /** Requires a code sent by phone call. */
  CALL = 'CALL',
  /** Requires a code sent by email. */
  EMAIL = 'EMAIL',
  /** Requires authentication via an authenticator app. */
  TOTP = 'TOTP',
  /** Requires authentication via a push notification. */
  PUSH = 'PUSH',
  /** Requires authentication via WebAuthn/passkey. */
  WEBAUTHN = 'WEBAUTHN',
  /** Requires a recovery code. */
  RECOVERY_CODE = 'RECOVERY_CODE',
}

/** @enumType */
/** @internal */
export type FactorTypeWithLiterals =
  | FactorType
  | 'UNKNOWN_FACTOR_TYPE'
  | 'PASSWORD'
  | 'SMS'
  | 'CALL'
  | 'EMAIL'
  | 'TOTP'
  | 'PUSH'
  | 'WEBAUTHN'
  | 'RECOVERY_CODE';

/** @internal */
export interface DiscountsSPIConfig {
  /**
   * Base URI where the endpoints are called.
   * Wix eCommerce appends the endpoint path to the base URI.
   * @minLength 1
   * @maxLength 200
   */
  deploymentUri?: string;
}

/** @internal */
export interface VeloCustomCss {
  /**
   * The grid id containing the css
   * @format GUID
   */
  gridId?: string;
  /**
   * Path to the css file in the grid
   * @minLength 2
   * @maxLength 255
   */
  filePath?: string;
}

/** @internal */
export interface AdaptiveComponentProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * identifier for SPI implementer
   * @format GUID
   */
  implementerConfigId?: string;
}

/** @internal */
export interface ActionSpiConfig {
  /**
   * The deployment uri of the assistant action
   * @maxLength 1000
   */
  deploymentUri?: string;
  /**
   * The name of the assistant action
   * @minLength 1
   * @maxLength 100
   */
  actionName?: string;
}

export interface InventorySpiConfig {
  /**
   * Base URI where the endpoints are called.
   * Wix eCommerce appends the endpoint path to the base URI.
   * @minLength 1
   * @maxLength 200
   */
  deploymentUri?: string;
}

/** @internal */
export interface Monitoring extends MonitoringOptionsOneOf {
  /** Sentry provider options */
  sentryOptions?: SentryOptions;
  /** Panorama provider options */
  panoramaOptions?: PanoramaOptions;
  /** Wix provider options */
  wixOptions?: WixOptions;
  /** Provider type */
  type?: MonitoringTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface MonitoringOptionsOneOf {
  /** Sentry provider options */
  sentryOptions?: SentryOptions;
  /** Panorama provider options */
  panoramaOptions?: PanoramaOptions;
  /** Wix provider options */
  wixOptions?: WixOptions;
}

/** @internal */
export interface SentryOptions {
  /**
   * The sentry DSN
   * @minLength 1
   * @maxLength 255
   */
  dsn?: string;
}

/** @internal */
export interface Project {
  /**
   * Group id (e.g. com.wixpress)
   * @minLength 1
   * @maxLength 100
   */
  groupId?: string;
  /**
   * Short artifact id
   * @minLength 1
   * @maxLength 100
   */
  artifactId?: string;
  /**
   * Build fingerprint
   * @minLength 1
   * @maxLength 100
   */
  fingerprint?: string;
}

/** @internal */
export enum MonitoringType {
  UNKNOWN_PROVIDER = 'UNKNOWN_PROVIDER',
  SENTRY = 'SENTRY',
  PANORAMA = 'PANORAMA',
  WIX = 'WIX',
}

/** @enumType */
/** @internal */
export type MonitoringTypeWithLiterals =
  | MonitoringType
  | 'UNKNOWN_PROVIDER'
  | 'SENTRY'
  | 'PANORAMA'
  | 'WIX';

/** @internal */
export interface PanoramaOptions {
  /** Sentry config */
  sentry?: SentryOptions;
  /** Project config */
  project?: Project;
}

/** @internal */
export interface WixOptions {}

/** @internal */
export interface PluginConfig {
  /** @maxLength 1000 */
  deploymentUri?: string;
  /**
   * has to be unique across all plugins
   * @maxLength 1024
   */
  pluginName?: string;
  /**
   * has to be unique across all plugins
   * @maxLength 1024
   */
  pluginDisplayName?: string;
  startingEnforcementDate?: Date | null;
  importanceLevel?: ImportanceLevelWithLiterals;
  /** @maxSize 100 */
  constraints?: Constraint[];
  /** enables plugin to use Slack escalation */
  toggleSlackMessageEnabled?: boolean;
}

/** @internal */
export interface Consequence {
  escalation?: EscalationWithLiterals;
  /** days to resolve the violation */
  daysToResolve?: number | null;
}

/** @internal */
export enum Escalation {
  BREAK_BUILD = 'BREAK_BUILD',
  BLOCK_ROLLOUT = 'BLOCK_ROLLOUT',
  BLOCK_FUTURE_ROLLOUT = 'BLOCK_FUTURE_ROLLOUT',
  OPEN_BUG_SLA = 'OPEN_BUG_SLA',
  /** only shows violation in papi-dashboard */
  VISIBILITY = 'VISIBILITY',
  /** sends Slack notification */
  SEND_SLACK_MESSAGE = 'SEND_SLACK_MESSAGE',
}

/** @enumType */
/** @internal */
export type EscalationWithLiterals =
  | Escalation
  | 'BREAK_BUILD'
  | 'BLOCK_ROLLOUT'
  | 'BLOCK_FUTURE_ROLLOUT'
  | 'OPEN_BUG_SLA'
  | 'VISIBILITY'
  | 'SEND_SLACK_MESSAGE';

/** @internal */
export enum ImportanceLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

/** @enumType */
/** @internal */
export type ImportanceLevelWithLiterals =
  | ImportanceLevel
  | 'LOW'
  | 'MEDIUM'
  | 'HIGH';

/** @internal */
export interface Constraint {
  /** @maxLength 1024 */
  id?: string;
  /** @maxSize 10 */
  consequences?: Consequence[];
  /**
   * link to FAQ docs
   * @maxLength 1024
   */
  faqLink?: string;
  /**
   * override the default cta for the constraint
   * @maxLength 1024
   */
  overrideCtaMessage?: string | null;
}

/** @internal */
export interface UnifiedLightbox {
  /** Base info of component by shared logic of unified components */
  base?: BaseInfo;
  /** Settings for how the lightbox integrates with the editor */
  editorSettings?: LightboxEditorSettings;
  /** Options for how to close the lightbox component */
  closeOptions?: LightboxCloseOptions;
  /** Content of a lightbox */
  content?: LightboxContent;
}

/** @internal */
export interface LightboxEditorSettings {
  /** Basic editor settings that are relevant to all page types */
  base?: PageEditorSettings;
}

/** @internal */
export interface LightboxCloseOptions {
  /** If true or unset, the lightbox will be closed when overlay is clicked */
  closeOnOverlayClick?: boolean | null;
  /** Show an X button that closes the lightbox component */
  showXButton?: boolean | null;
}

/** @internal */
export interface LightboxContent {
  /**
   * Widgets to add as content in a lightbox.
   * @maxSize 1
   */
  widgets?: PageWidgetAsContent[];
  /**
   * Whole-lightbox composition. The referenced composition must have CompTypeDomain.PAGE template_type.
   * Exclusive with widgets — at most one of the two may be set.
   */
  pageComposition?: CompositionRef;
}

/** @internal */
export interface PageWidgetAsContent {
  /**
   * GUID of widget to use as content of page
   * @format GUID
   */
  widgetGuid?: string;
  /** The preset should be used */
  preset?: MainPresets;
  /** Mark widget as essential for the existence of the app (force to delete the whole app) */
  essential?: boolean;
}

/** @internal */
export interface FormSpiExtensionConfig {
  /**
   * Deployment URI where the endpoints are called. Wix Forms appends the endpoint path to the deployment URI.
   * For example, to call the Override Form endpoint at `https://my-form.com/v4/forms/override`,
   * the `deploymentUri` you provide here is `https://my-form.com/`.
   */
  deploymentUri?: SpiBaseUri;
  /**
   * The app which the form belongs to. For example, the namespace for the Wix Forms app is `wix.form_app.form`.
   *
   * Call `Get Form` to retrieve the namespace.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /**
   * The IDs of the specific forms that will trigger the defined methods when a form is requested on the API.
   * This field is optional. If empty, requests for all forms will trigger the methods.
   * @maxSize 100
   * @format GUID
   */
  formIds?: string[];
}

export interface SchemaGroup {
  /**
   * SchemaGroup ID. Field is read only.
   * @format GUID
   * @readonly
   */
  id?: string | null;
  /**
   * Date and time the SchemaGroup was created. Field is read only.
   * @readonly
   */
  createdDate?: Date | null;
  /**
   * Date and time the SchemaGroup was last updated. Field is read only.
   * @readonly
   */
  updatedDate?: Date | null;
  /**
   * Name of the SchemaGroup. Max symbol length is 100. Field is translatable.
   * @maxLength 100
   */
  name?: string | null;
  /**
   * List of Schemas.
   * @maxSize 50
   */
  groupElements?: SchemaGroupElement[];
}

/** @internal */
export interface SchemaGroupElement {
  /**
   * ID of the Schema. If the schema group uses an element from another existing group, the reference id to that group has to be provided here.
   * @format GUID
   */
  id?: string | null;
  /** Position of the schema group element. */
  position?: number | null;
}

/** @internal */
export interface Panel extends PanelSelectedContentTypeOneOf {
  /**
   * The URL to the html page of the panel in case of iFrame
   * @format WEB_URL
   */
  url?: string;
  /**
   * The configuration for rendering the panel directly in the host
   * @internal
   */
  code?: CodePanel;
  /**
   * external reference to the panel
   * @internal
   * @maxLength 20
   */
  referenceId?: string | null;
  /**
   * The title of the panel
   * @minLength 1
   * @maxLength 200
   */
  displayName?: string;
  /** Optional: The size of the panel (not affecting overlay panel mode) */
  size?: PanelSize;
  /** The selected panel content type */
  contentType?: PanelContentTypeWithLiterals;
  /** The selected panel mode - draggable is default */
  panelMode?: PanelModeWithLiterals;
}

/** @oneof */
/** @internal */
export interface PanelSelectedContentTypeOneOf {
  /**
   * The URL to the html page of the panel in case of iFrame
   * @format WEB_URL
   */
  url?: string;
  /**
   * The configuration for rendering the panel directly in the host
   * @internal
   */
  code?: CodePanel;
}

/** @internal */
export interface PanelSize {
  /**
   * height of the panel in px
   * @min 150
   */
  height?: number | null;
  /** width of the panel */
  width?: WidthWithLiterals;
}

/** @internal */
export enum Width {
  UNKNOWN_WIDTH = 'UNKNOWN_WIDTH',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

/** @enumType */
/** @internal */
export type WidthWithLiterals =
  | Width
  | 'UNKNOWN_WIDTH'
  | 'SMALL'
  | 'MEDIUM'
  | 'LARGE';

/** Represents the options for panel content types */
/** @internal */
export enum PanelContentType {
  UNKNOWN_PanelContentType = 'UNKNOWN_PanelContentType',
  url = 'url',
  code = 'code',
}

/** @enumType */
/** @internal */
export type PanelContentTypeWithLiterals =
  | PanelContentType
  | 'UNKNOWN_PanelContentType'
  | 'url'
  | 'code';

/** Represents the information needed for code panels */
/** @internal */
export interface CodePanel {
  /**
   * The url for the panel code
   * @format WEB_URL
   */
  bundleUrl?: string;
  /**
   * The url for the panel css
   * @format WEB_URL
   */
  cssUrl?: string | null;
}

/** Represents the options for panel display modes */
/** @internal */
export enum PanelMode {
  /** default - A non-blocking panel that allows interaction with the underlying interface */
  UNKNOWN_PanelMode = 'UNKNOWN_PanelMode',
  /** A blocking panel that overlays, typically used for modal-like experiences */
  overlay = 'overlay',
}

/** @enumType */
/** @internal */
export type PanelModeWithLiterals = PanelMode | 'UNKNOWN_PanelMode' | 'overlay';

/** @internal */
export interface PurchaseValidationsConfig {
  /** deployment URI */
  uriConfig?: SpiBaseUri;
}

/** @internal */
export interface BrowserStorage {
  /** The type of browser storage used */
  type?: StorageTypeWithLiterals;
  /**
   * The name of the storage item in the browser (as can be seen in DEV Console)
   * @maxLength 100
   */
  name?: string;
  /**
   * A human friendly description of the storage item and what it is used for.
   * > This is for allowing users to display consent pages on their sites with this information.
   * @minLength 10
   * @maxLength 500
   */
  description?: string;
  /**
   * The consent category to which the storage item belongs.
   * This defines when this storage item is allowed to be used in a visitor session.
   * > This is legally important for complying with EU privacy law, so make sure to define this carefully.
   */
  consentCategory?: ConsentCategoryWithLiterals;
  /** Where this storage item will be set in the browser (User domain or the App domain) */
  domain?: StorageDomainWithLiterals;
}

/** The type of storage we are declaring */
/** @internal */
export enum StorageType {
  UNKNOWN_STORAGE_TYPE = 'UNKNOWN_STORAGE_TYPE',
  /** A [cookie](https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie) we store in the browser */
  COOKIE = 'COOKIE',
  /** A [localStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage) item that persists across tabs in the domain */
  LOCALSTORAGE = 'LOCALSTORAGE',
  /** A [sessionStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage) item for a specific tab in the domain */
  SESSIONSTORAGE = 'SESSIONSTORAGE',
  /** An item in [IndexDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API) */
  INDEXDB = 'INDEXDB',
}

/** @enumType */
/** @internal */
export type StorageTypeWithLiterals =
  | StorageType
  | 'UNKNOWN_STORAGE_TYPE'
  | 'COOKIE'
  | 'LOCALSTORAGE'
  | 'SESSIONSTORAGE'
  | 'INDEXDB';

/** The category for EU and US Privacy Law classification */
/** @internal */
export enum ConsentCategory {
  /** This is an invalid value, you must classify your storage item. */
  UNKNOWN_CATEGORY = 'UNKNOWN_CATEGORY',
  /** Is required for your app to function and does not use the data to do any tracking. */
  essential = 'essential',
  /** Related to performanc and functional additions that are niceities but the app can work without. */
  functional = 'functional',
  /** Related to analytics and may including tracking sessions and vistors to the site. */
  analytics = 'analytics',
  /** Related to advertising, upselling and marketing data collected to be used. */
  advertising = 'advertising',
}

/** @enumType */
/** @internal */
export type ConsentCategoryWithLiterals =
  | ConsentCategory
  | 'UNKNOWN_CATEGORY'
  | 'essential'
  | 'functional'
  | 'analytics'
  | 'advertising';

/** @internal */
export enum StorageDomain {
  UNKNOWN_STORAGE_DOMAIN = 'UNKNOWN_STORAGE_DOMAIN',
  /** Storing the values in the domain of the website the app is installed on */
  SITE_DOMAIN = 'SITE_DOMAIN',
  /** Storing the values in the Wix Backoffice domain */
  WIX_DOMAIN = 'WIX_DOMAIN',
  /** Storing the values as 3rd party in the application domain */
  APP_DOMAIN = 'APP_DOMAIN',
}

/** @enumType */
/** @internal */
export type StorageDomainWithLiterals =
  | StorageDomain
  | 'UNKNOWN_STORAGE_DOMAIN'
  | 'SITE_DOMAIN'
  | 'WIX_DOMAIN'
  | 'APP_DOMAIN';

/** Describe SDK module definition for an app */
/** @internal */
export interface SdkDefinition {
  /**
   * The SDK module name, for example "ecom"
   * @maxLength 100
   */
  sdkModuleName?: string;
}

/** A container (slot) that can be extended by other applications (e.g. widget plugin) */
/** @internal */
export interface SiteWidgetSlot {
  /** A container (slot) common properties. */
  slotData?: SlotData;
  /**
   * Name of the slot. Displayed to users when selecting a Plugin Placement, Must be unique within its parent component.
   * @minLength 2
   * @maxLength 50
   */
  slotKeyName?: string | null;
}

/** Configuration for the event validation provider. */
/** @internal */
export interface EventValidationProviderConfig {
  /** The base URI to reach the provider's service. */
  baseUri?: SpiBaseUri;
  /**
   * List of validation targets specifying the methods to validate and optional filters.
   * @minSize 1
   * @maxSize 10
   */
  validationTargets?: ValidationTarget[];
}

/** @internal */
export interface ValidationTarget {
  /** The method to validate. */
  method?: MethodWithLiterals;
  /**
   * Optional WQL filter applied to the events for validation.
   * Only events matching this filter will be validated.
   * Supported event fields:
   * - `appId`
   */
  filter?: Record<string, any> | null;
}

/** @internal */
export enum Method {
  /** Validate an event before creation. */
  CREATE = 'CREATE',
  /** Validate an event before update. */
  UPDATE = 'UPDATE',
  /** Validate an event before cancel. */
  CANCEL = 'CANCEL',
}

/** @enumType */
/** @internal */
export type MethodWithLiterals = Method | 'CREATE' | 'UPDATE' | 'CANCEL';

/** Client Service is a broad category encompassing any value, function, or feature that an application needs. A service is typically a class with a narrow, well-defined purpose. A component is one type of class that can use DI. */
/** @internal */
export interface ClientSideService {
  /**
   * ID of a  UI service.
   * @format GUID
   */
  id?: string;
  /**
   * Exported name of a service
   * @minLength 2
   * @maxLength 100
   */
  exportedName?: string;
  /** Definition of a service */
  definition?: Definition;
  /** Implementation metadata of a service, a service with no runtime definition will be considered as an atom. */
  implementation?: Implementation;
}

/** @internal */
export interface Npm {
  /**
   * Npm package name
   * @minLength 2
   * @maxLength 100
   */
  packageName?: string;
  /**
   * Npm semantic version
   * @minLength 2
   * @maxLength 100
   */
  packageVersion?: string;
  /**
   * Package entry point, default to main entry
   * @minLength 2
   * @maxLength 100
   */
  specifier?: string | null;
  /**
   * Imported name, default to default import
   * @minLength 2
   * @maxLength 100
   */
  importedName?: string | null;
}

/** @internal */
export interface Definition {
  /** Reflecting a service definition using npm package */
  npm?: Npm;
}

/** @internal */
export interface Implementation {
  /** Reflecting a service runtime using npm package */
  npm?: Npm;
  /**
   * Bundle URL
   * @format WEB_URL
   */
  bundleUrl?: string | null;
  /**
   * reference to other client side services
   * @format GUID
   * @maxSize 100
   */
  serviceDependencies?: string[];
}

/** @internal */
export interface BillingSettingsConfig {
  /**
   * Display name for the subscription type in the billing UI.
   * @minLength 1
   * @maxLength 200
   */
  subscriptionType?: string;
  actionsConfigSource?: ActionsConfigSourceWithLiterals;
  merchantActions?: MerchantActions;
}

/**
 * Source of action permissions: legacy SubscriptionPolicies or new MerchantActions.
 * UNSPECIFIED is a sentinel (NOT_IMPLEMENTED) — consumers treat it as legacy POLICIES.
 */
/** @internal */
export enum ActionsConfigSource {
  ACTIONS_CONFIG_SOURCE_UNSPECIFIED = 'ACTIONS_CONFIG_SOURCE_UNSPECIFIED',
  ACTIONS_CONFIG_SOURCE_POLICIES = 'ACTIONS_CONFIG_SOURCE_POLICIES',
  ACTIONS_CONFIG_SOURCE_ACTIONS = 'ACTIONS_CONFIG_SOURCE_ACTIONS',
}

/** @enumType */
/** @internal */
export type ActionsConfigSourceWithLiterals =
  | ActionsConfigSource
  | 'ACTIONS_CONFIG_SOURCE_UNSPECIFIED'
  | 'ACTIONS_CONFIG_SOURCE_POLICIES'
  | 'ACTIONS_CONFIG_SOURCE_ACTIONS';

/**
 * Per-action permissions for merchant Business Manager operations. All fields
 * default to false (deny) — set to true only the actions your vertical permits.
 * Only consulted when actions_config_source = ACTIONS_CONFIG_SOURCE_ACTIONS.
 *
 * Each field also acts as the gate for the corresponding customer-portal action
 * (where one exists). If allow_X is false, BASS blocks the action for both the
 * merchant and the customer — the customer ≤ merchant invariant is automatic.
 * Customer-portal *behavior* (notice periods, cancellation timing, etc.) is
 * configured separately by each merchant via BBS CustomerSettings; this proto
 * only controls *whether* the action is allowed at all.
 */
/** @internal */
export interface MerchantActions {
  /**
   * Allows extending a subscription's end date — either by appending billing
   * cycles (termed subscriptions) or by a custom time period. Disable for
   * verticals where the end date is bound to an external lifecycle (e.g. a
   * course with a fixed end date).
   */
  allowExtend?: boolean;
  /**
   * Allows turning auto-renewal OFF. The subscription continues to the end of
   * the current cycle and then ends without renewing. Distinct from immediate
   * cancel (which is gated by allow_cancel). Also gates the customer-portal
   * CYCLE_AUTO_RENEW_OFF action used in the legacy customer flow.
   */
  allowCycleAutoRenewOff?: boolean;
  /**
   * Allows turning auto-renewal back ON for a subscription that previously had
   * it disabled. Also gates the customer-portal CYCLE_AUTO_RENEW_ON action.
   */
  allowCycleAutoRenewOn?: boolean;
  /**
   * Allows canceling the subscription. Cancellation timing (immediate vs.
   * end-of-period) for the customer portal is configured per-merchant via
   * BBS CustomerSettings.cancel_action. Also gates the customer-portal CANCEL.
   */
  allowCancel?: boolean;
  /**
   * Allows pausing the subscription (temporarily stops billing and/or service
   * delivery, depending on the chosen pause policy). Combined with allow_resume,
   * also gates the customer-portal PAUSE_RESUME action — customers can only
   * pause if both allow_pause and allow_resume are true.
   */
  allowPause?: boolean;
  /**
   * Allows resuming a paused subscription. See allow_pause for the customer
   * portal interaction.
   */
  allowResume?: boolean;
  /**
   * Allows marking an invoice or billing cycle as paid manually. Used when
   * payment was collected outside the platform (e.g. offline / bank transfer /
   * in-person). Merchant-only — no customer-portal counterpart.
   */
  allowMarkAsPaid?: boolean;
  /**
   * Allows updating the payment method stored on the subscription (e.g. swap
   * credit card). Also gates the customer-portal UPDATE_PAYMENT_METHOD action.
   */
  allowUpdatePaymentMethod?: boolean;
  /**
   * Allows changing the next billing date — moving it earlier (typically with
   * proration) or later (typically with an extra charge). Fine-grained config
   * (min/max offsets, proration rules, weekly behavior) is set per-merchant via
   * BBS CustomerSettings.update_billing_date_action. Also gates the customer-portal
   * UPDATE_BILLING_DATE action.
   */
  allowUpdateBillingDate?: boolean;
  /**
   * Allows changing the collection method (e.g. switch from online card
   * payments to offline / manual collection, or vice versa). Merchant-only —
   * no customer-portal counterpart.
   */
  allowUpdateCollectionMethod?: boolean;
  /**
   * Allows changing the subscription start date — typically used for PENDING
   * subscriptions that have not yet activated. Merchant-only — no customer-portal
   * counterpart.
   */
  allowUpdateStartDate?: boolean;
}

/** A component holding configuration of Patterns Wizard */
/** @internal */
export interface PatternsWizard {
  /** Configuration of the patterns wizard */
  config?: Record<string, any> | null;
}

/** @internal */
export interface ApplicationProfileProviderConfig {
  /** URI where the SPI implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /** Implemented methods */
  implementedMethods?: V1ImplementedMethods;
  /** default application profile */
  defaultApplicationProfile?: ApplicationProfile;
}

/** @internal */
export interface V1ImplementedMethods {
  /** Implement QueryApplicationProfiles */
  getMyApplicationProfile?: boolean;
}

/** @internal */
export interface ApplicationProfile {
  /**
   * name
   * @maxLength 200
   * @readonly
   */
  name?: string | null;
  /**
   * image url
   * @format WEB_URL
   * @readonly
   */
  imageUrl?: string | null;
}

/** a translated TextToSpeech payload sent to UOU */
/** @internal */
export interface TextToSpeechActionMessage {
  /**
   * Text-to-speech message body. Should be a valid SSML as string.
   * See https://www.w3.org/TR/speech-synthesis/
   * i.e. <speak>\r\nHi, testing text to speech.\r\n</speak>
   * i.e. <speak>\r\n<audio src=\"https://storage.googleapis.com/wix-restaurants/audio/beep.mp3\"/>\r\nA new order was received.\r\n</speak>
   * @minLength 1
   * @maxLength 5000
   */
  body?: string;
}

/** @internal */
export interface AudienceProviderConfig {
  /** notification preference filter SPI configuration */
  baseUri?: SpiBaseUri;
  /**
   * Provider key
   * @minLength 1
   * @maxLength 50
   */
  key?: string;
  /**
   * The name of the audience provider, e.g. `Blog Post Subscribers` / `Contacts Labels`
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /** Type of participant. Each audience provider can support only one type of recipient */
  participantType?: ParticipantTypeWithLiterals;
  /** Standard json schema which describe the json the provider should get in the Resolve end point */
  inputSchema?: Record<string, any> | null;
  /**
   * Interface configuration
   * If empty default interface configuration will be auto generated based on the input schema
   */
  interfaceConfiguration?: InterfaceConfiguration;
  /** Specifying which optional methods are implemented. */
  implementedMethods?: ImplementedMethods;
  /**
   * Define the scopes which the provider audience is relevant
   * @maxSize 10
   */
  scopes?: V1ScopeWithLiterals[];
}

/** @internal */
export enum ParticipantType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  WIX_USER = 'WIX_USER',
  CONTACT = 'CONTACT',
  ANONYMOUS = 'ANONYMOUS',
}

/** @enumType */
/** @internal */
export type ParticipantTypeWithLiterals =
  | ParticipantType
  | 'UNKNOWN_TYPE'
  | 'WIX_USER'
  | 'CONTACT'
  | 'ANONYMOUS';

/** @internal */
export interface InterfaceConfiguration
  extends InterfaceConfigurationOfTypeOneOf {
  /** Should be filled if the provider implements its own custom UI */
  widgetComponentConfiguration?: WidgetComponent;
  /**
   * Should be filled if the provider implements Item Selection UI Component
   * @internal
   */
  itemSelectionConfiguration?: ItemSelection;
  /** Type of interface configuration */
  type?: InterfaceConfigurationTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface InterfaceConfigurationOfTypeOneOf {
  /** Should be filled if the provider implements its own custom UI */
  widgetComponentConfiguration?: WidgetComponent;
  /**
   * Should be filled if the provider implements Item Selection UI Component
   * @internal
   */
  itemSelectionConfiguration?: ItemSelection;
}

/** @internal */
export enum InterfaceConfigurationType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  /** Widget component built by the provider */
  WIDGET_COMPONENT = 'WIDGET_COMPONENT',
  /** Item Selection, in case the provider implemented item selection component */
  ITEM_SELECTION = 'ITEM_SELECTION',
}

/** @enumType */
/** @internal */
export type InterfaceConfigurationTypeWithLiterals =
  | InterfaceConfigurationType
  | 'UNKNOWN_TYPE'
  | 'WIDGET_COMPONENT'
  | 'ITEM_SELECTION';

/** @internal */
export interface WidgetComponent {
  /**
   * widget component id
   * @format GUID
   */
  componentId?: string;
}

/** @internal */
export interface ItemSelection {
  /**
   * Item selection provider key
   * @minLength 1
   * @maxLength 100
   */
  providerKey?: string;
  /**
   * Mapping between item selection ids array to correlate input schema field
   * @minLength 1
   * @maxLength 25
   */
  schemaIdsFieldName?: string;
}

/** @internal */
export interface ImplementedMethods {
  /** Implements countParticipants */
  countParticipants?: boolean;
}

/** @internal */
export enum V1Scope {
  UNKNOWN_SCOPE = 'UNKNOWN_SCOPE',
  /** Provider audience is available only in scope of specific site */
  SPECIFIC_SITE = 'SPECIFIC_SITE',
  /** Provider audience is available only in scope of non specific site */
  NON_SPECIFIC_SITE = 'NON_SPECIFIC_SITE',
}

/** @enumType */
/** @internal */
export type V1ScopeWithLiterals =
  | V1Scope
  | 'UNKNOWN_SCOPE'
  | 'SPECIFIC_SITE'
  | 'NON_SPECIFIC_SITE';

/** Config for the Price SPI */
/** @internal */
export interface PriceSPIConfig {
  /**
   * Pricing plan for which the SPI method should optionally apply
   * @format GUID
   */
  planId?: string;
  /** Required. Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  uriConfig?: SpiBaseUri;
}

/** @internal */
export interface StartDateLimitsSPIConfig {
  /** Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  baseUri?: SpiBaseUri;
  /**
   * Pricing plan for which the SPI method should apply
   * @format GUID
   */
  planId?: string;
}

/** @internal */
export interface StartDateRulesSPIConfig {
  /** Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  baseUri?: SpiBaseUri;
  /**
   * Pricing plan for which the SPI method should apply
   * @format GUID
   */
  planId?: string;
}

/** @internal */
export interface TicketReservationsSpiConfig {
  /** URI where the SPI Implementer is deployed. */
  baseUri?: SpiBaseUri;
}

/** Configuration for the dispute service plugin implementor */
/** @internal */
export interface DisputeServicePluginConfig {
  /**
   * Base URI where the endpoints are called. Wix appends the endpoint path to the base URI.
   * For example, to call the Accept Dispute endpoint at https://my-payments.com/disputes/v1/accept-dispute, the base URI you provide here is https://my-payments.com/disputes.
   */
  baseUri?: SpiBaseUri;
}

/** Config for the Fees SPI */
/** @internal */
export interface FeesSPIConfig {
  /**
   * Pricing plan for which the SPI method should optionally apply
   * @format GUID
   */
  planId?: string;
  /** Required. Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  uriConfig?: SpiBaseUri;
}

/** The full model for an imported component set in DEV Center */
/** @internal */
export interface EditorReactComponent {
  /**
   * The type of component to present in the Page tree, will be prefixed with AppSlug
   * @maxLength 100
   * @minLength 1
   */
  type?: string;
  /**
   * The public description of the component do display
   * @maxLength 300
   * @minLength 3
   */
  description?: string;
  /** List of component resources. This comprises any runtime code we need to load and execute for the component. */
  resources?: Resources;
  /** The configuration describing the component abilities and behaviors on the Editor stage */
  editorElement?: EditorElement;
  /** The installation settings of the component */
  installation?: InstallationInfo;
  /** Module configuration for NPM-based component */
  moduleConfiguration?: EditorReactComponentModuleConfiguration;
  /**
   * A URL to get the component Schema from the CDN
   * @internal
   * @format WEB_URL
   */
  schemaUrl?: string | null;
}

/** @internal */
export interface Resources {
  /** The bundle we will load and render in the browser in the site */
  client?: ClientResources;
  /**
   * An optional client definition of the component we will load and render in the editor, *it replaces the client bundle.*
   * The  main use case is to control the live site component and enable different experiences in the editor.
   * For example, supporting `states` manipulation:
   * Show calendar in the editor
   * Open drop down in the editor
   */
  editor?: ClientResources;
  /** The bundle for SSR, should not include any DOM API references */
  server?: Resource;
  /** The optional component SDK to expose to Velo Users to interact with the component */
  sdk?: Resource;
  /** Details for how to load translations for the component */
  translations?: TranslationResources;
  /** The optional interactions configuration JSON file */
  interactions?: Resource;
  /**
   * As URL to store the asset generator for runtime rendering
   * @internal
   * @format WEB_URL
   */
  viewerReducedModel?: string | null;
  /**
   * A URL to get schema references of items for component
   * @internal
   * @format WEB_URL
   */
  schemaRefsUrl?: string | null;
  /**
   * A URL to get the resolved CSS for the component for runtime rendering of CSS
   * @internal
   * @format WEB_URL
   */
  viewerRuntimeCss?: string | null;
  /** The exported hooks for usage with the contexts defined inside the editorElement. key must ,match key in the contexts map of the editorElement, and the value is the name of the hook that will be used to consume this context in the component code. Example: { "MyContext": "useMyContext" } */
  contextHooks?: Record<string, string>;
}

/** @internal */
export interface ClientResources {
  /**
   * A URL to an ESM javascript bundle. It's default export should be the component
   * @format WEB_URL
   */
  componentUrl?: string;
  /**
   * A URL to the CSS file that is the default layout and style for the component
   * @format WEB_URL
   */
  cssUrl?: string | null;
  /**
   * A list of service dependencies required by the component, example: ['@wix/environment']
   * @maxLength 80
   * @maxSize 20
   * @deprecated A list of service dependencies required by the component, example: ['@wix/environment']
   * @replacedBy dependencies
   * @targetRemovalDate 2025-12-30
   */
  serviceDependencies?: string[];
  /**
   * A module specifier for the component’s react code.
   * @maxLength 100
   */
  moduleSpecifier?: string | null;
  /** Dependencies on services and contexts */
  dependencies?: EditorDependencies;
}

/** @internal */
export interface EditorDependencies {
  /**
   * A list of service dependencies required by the component, example: ['@wix/environment']
   * @maxLength 80
   * @maxSize 20
   */
  serviceDependencies?: string[];
  /**
   * Dependencies on context providers in order to work
   * @maxLength 80
   * @maxSize 20
   */
  contextDependencies?: string[];
  /**
   * Dependencies on components that we want as externals in our bundle, example: wixEditorElements.AppWidget
   * @maxLength 80
   * @maxSize 20
   */
  componentDependencies?: string[];
}

/** @internal */
export interface Resource {
  /**
   * A URL to an ESM javascript bundle
   * @format WEB_URL
   */
  url?: string;
}

/** @internal */
export interface TranslationResources {
  /**
   * The URL that we will add the language to for fetching translations, example: `https://somecdn.com/translations/`
   * @format WEB_URL
   */
  basePath?: string;
  /**
   * The list of supported languages according to the [ISO-639-1 specification](https://en.wikipedia.org/wiki/ISO_639-1)
   * @format LANGUAGE
   * @maxSize 37
   */
  languages?: string[];
}

/** @internal */
export interface EditorElement {
  /**
   * DOM Query selector for this element that we can use to find it when rendering it (preferably  a className)
   * @minLength 4
   * @maxLength 300
   */
  selector?: string;
  /**
   * Human friendly name on the editor stage when the component is in interaction with the user
   * @maxLength 50
   */
  displayName?: string;
  /** data-api of this element, a map of data-items where the key is the data-item name and the value is the data-item definition. These will be manifested as `props` for the component */
  data?: Record<string, DataItem>;
  /** A map of contexts this component exposes inside containers it supports */
  contexts?: Record<string, ApiContext>;
  /** elements-map of this element, a map of inner-elements where the key is the element name and the value is the element definition */
  elements?: Record<string, ElementItem>;
  /** Native actions specified for the component */
  actions?: Actions;
  /** Custom actions specified for the component, allowing for flexibility beyond native actions */
  customActions?: Record<string, Action>;
  /** Component presets definition. Canonically useful for different layout or theming */
  presets?: Record<string, PresetItem>;
  /** Layout capabilities of the component */
  layout?: EditorElementLayout;
  /** The Archetype this component adheres to, to be used for classification by AI models */
  archetype?: ArchetypeWithLiterals;
  /** A map with definitions of states that this element can be edited in */
  states?: Record<string, ElementState>;
  /** Interactions of the component supports */
  interactions?: Interactions;
  /**
   * Display filters for the Element, used to define the visibility of inner / ref elements, style items, data items and custom actions in the editor
   * The Element is the first in line to affect the display, Preset and State are after it
   */
  displayFilters?: DisplayFilters;
  /** Display groups for the element, used to group elements in the editor for better UX */
  displayGroups?: Record<string, DisplayGroupItem>;
  /** A map of CSS properties that this element supports, where the key is the CSS property name and the value is the CSS property definition */
  cssProperties?: Record<string, CssPropertyItem>;
  /** A map of CSS properties that this element supports, where the key is the CSS property name and the value is the CSS property definition */
  cssCustomProperties?: Record<string, CssCustomPropertyItem>;
  /** A reference to a help article for this element */
  helpArticle?: HelpArticle;
  /**
   * A description of the editor element
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface DataItem extends DataItemSelectedDataTypeOneOf {
  /** An optional object to define limitations on the text input */
  text?: Text;
  /** A required list of options to supply to the users to choose from */
  textEnum?: TextEnum;
  /** An optional set of restrictions to apply to the number */
  number?: _Number;
  /** A required list of types we want to user to be able to specify, empty means all possible A11Y values */
  a11y?: A11y;
  /** A definition of what links should be supported */
  link?: Link;
  /** An array of a data type */
  arrayItems?: ArrayItems;
  /** A container in which to render another component */
  container?: ReactElementContainer;
  /** A definition of what rich text abilities should be supported */
  richText?: RichText;
  /** A definition of what images should be supported */
  image?: Image;
  /** A definition of what videos should be supported */
  video?: Video;
  /** A definition of what vector arts should be supported */
  vectorArt?: VectorArt;
  /** An definition of a nested data-object */
  data?: DataItems;
  /** A definition of a custom function */
  function?: EditorFunction;
  /** A definition of what fields are available for filtering */
  filter?: FilterDefinition;
  /** A definition of what fields are available for sorting */
  sort?: SortDefinition;
  /** Defines the type of data we are configuring */
  dataType?: DataTypeWithLiterals;
  /**
   * Display name of this data item
   * @maxLength 100
   */
  displayName?: string | null;
  /** The default value of this data item (only for display purposes). */
  defaultValue?: any;
  /**
   * Whether this data item is deprecated
   * @internal
   */
  deprecated?: boolean;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
  /** Disables the ability to delete this data-item value in the Editor UI */
  disableDeletion?: boolean | null;
  /**
   * A description of this data item
   * @maxLength 300
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface DataItemSelectedDataTypeOneOf {
  /** An optional object to define limitations on the text input */
  text?: Text;
  /** A required list of options to supply to the users to choose from */
  textEnum?: TextEnum;
  /** An optional set of restrictions to apply to the number */
  number?: _Number;
  /** A required list of types we want to user to be able to specify, empty means all possible A11Y values */
  a11y?: A11y;
  /** A definition of what links should be supported */
  link?: Link;
  /** An array of a data type */
  arrayItems?: ArrayItems;
  /** A container in which to render another component */
  container?: ReactElementContainer;
  /** A definition of what rich text abilities should be supported */
  richText?: RichText;
  /** A definition of what images should be supported */
  image?: Image;
  /** A definition of what videos should be supported */
  video?: Video;
  /** A definition of what vector arts should be supported */
  vectorArt?: VectorArt;
  /** An definition of a nested data-object */
  data?: DataItems;
  /** A definition of a custom function */
  function?: EditorFunction;
  /** A definition of what fields are available for filtering */
  filter?: FilterDefinition;
  /** A definition of what fields are available for sorting */
  sort?: SortDefinition;
}

/** @internal */
export enum DataType {
  UNKNOWN_DataType = 'UNKNOWN_DataType',
  /** A simple text value */
  text = 'text',
  /** A list of predefined textual values to choose from */
  textEnum = 'textEnum',
  /** Any number */
  number = 'number',
  /** true / false value */
  booleanValue = 'booleanValue',
  /** An object containing the selected A11Y fields chosen */
  a11y = 'a11y',
  /** A Wix Link object type */
  link = 'link',
  /** A Wix Image object type */
  image = 'image',
  /** A Wix Video object type */
  video = 'video',
  /** A Wix Sanitized Vector Art object */
  vectorArt = 'vectorArt',
  /** A Wix Audio object */
  audio = 'audio',
  /** DEPRECATED - use the `data` dataType instead. A [JSON Schema definition](https://json-schema.org/specification) the developer understands in his code (useful for complex props). Some limitation may apply. */
  schema = 'schema',
  /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
  localDate = 'localDate',
  /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
  localTime = 'localTime',
  /** Local Date Time output  ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
  localDateTime = 'localDateTime',
  /** a URL with scheme http or https */
  webUrl = 'webUrl',
  /** standard email address according to [RFC 5321, section 4.1.2](https://datatracker.ietf.org/doc/html/rfc5321#section-4.1.2) */
  email = 'email',
  /** a validation format designed to match phone numbers with a variety of common characters, including digits (0-9), spaces, parentheses, plus sign, hyphens, and periods */
  phone = 'phone',
  /** hostname according to IANA */
  hostname = 'hostname',
  /** A valid `regex` pattern supplied by the User */
  regex = 'regex',
  /** A unique identifier */
  guid = 'guid',
  /** a HTML text with css inline styling */
  richText = 'richText',
  /** A container place in the component that will be passed in as {children} or a function prop, depending on the case */
  container = 'container',
  /** An array type of data */
  arrayItems = 'arrayItems',
  /** selected `direction` for the component according to (HTML `dir` attribute)[https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir] */
  direction = 'direction',
  /** A list of menu-items */
  menuItems = 'menuItems',
  /** A complex data type that can be used to define a data structure, such as an object or a map */
  data = 'data',
  /** A custom function that can be used to call a function from a custom library */
  'function' = 'function',
  /** Deprecated: use function with pointerEvent parameter. Standard [onClick handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/click_event) */
  onClick = 'onClick',
  /** Deprecated: use function with changeEvent parameter. Standard [onChange handler](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event) */
  onChange = 'onChange',
  /** Deprecated: use function with keyboardEvent parameter. Standard [onKeyPress handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/keypress_event) */
  onKeyPress = 'onKeyPress',
  /** Deprecated: use function with keyboardEvent parameter. Standard [onKeyUp handler](https://developer.mozilla.org/en-US/docs/Web/API/Element/keyup_event) */
  onKeyUp = 'onKeyUp',
  /** Deprecated: use function with submitEvent parameter. Standard [onSubmit handler](https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/submit_event) */
  onSubmit = 'onSubmit',
  /** A WQL-compliant filter definition for querying data */
  filter = 'filter',
  /** A WQL-compliant sort definition for ordering data */
  sort = 'sort',
  /** A media type that is ONLY used for binding and not stored in the document store of the site */
  visualMedia = 'visualMedia',
}

/** @enumType */
/** @internal */
export type DataTypeWithLiterals =
  | DataType
  | 'UNKNOWN_DataType'
  | 'text'
  | 'textEnum'
  | 'number'
  | 'booleanValue'
  | 'a11y'
  | 'link'
  | 'image'
  | 'video'
  | 'vectorArt'
  | 'audio'
  | 'schema'
  | 'localDate'
  | 'localTime'
  | 'localDateTime'
  | 'webUrl'
  | 'email'
  | 'phone'
  | 'hostname'
  | 'regex'
  | 'guid'
  | 'richText'
  | 'container'
  | 'arrayItems'
  | 'direction'
  | 'menuItems'
  | 'data'
  | 'function'
  | 'onClick'
  | 'onChange'
  | 'onKeyPress'
  | 'onKeyUp'
  | 'onSubmit'
  | 'filter'
  | 'sort'
  | 'visualMedia';

/** @internal */
export interface Text {
  /** Indicates maximum length allowed for the text */
  maxLength?: number | null;
  /** Indicates minimum length required for the text */
  minLength?: number | null;
  /**
   * A regex pattern that the text must comply with
   * @maxLength 100
   */
  pattern?: string | null;
  /**
   * Configures this text as an item-selection field, populated by an items provider implementing the Items
   * Selection SPI (wix.items_selection.spi_host.v1). provider_key picks the provider; for multi-select use an array of Text.
   */
  itemSelection?: ItemSelectionConfig;
}

/** Configuration for selecting items from an items provider (e.g. via a dropdown picker) */
/** @internal */
export interface ItemSelectionConfig {
  /**
   * The key of the items provider to select items from
   * @minLength 1
   * @maxLength 100
   */
  providerKey?: string;
  /**
   * The maximum number of items that can be selected
   * @min 1
   */
  maxSelected?: number | null;
  /** The item field whose value is stored (defaults to id) */
  itemField?: ItemFieldWithLiterals;
}

/** @internal */
export enum ItemField {
  /** item.id */
  ID = 'ID',
  /** item.name */
  NAME = 'NAME',
  /** item.description */
  DESCRIPTION = 'DESCRIPTION',
  /** item.note */
  NOTE = 'NOTE',
}

/** @enumType */
/** @internal */
export type ItemFieldWithLiterals =
  | ItemField
  | 'ID'
  | 'NAME'
  | 'DESCRIPTION'
  | 'NOTE';

/** @internal */
export interface TextEnum {
  /**
   * list of valid enum items
   * @maxSize 100
   */
  options?: Option[];
}

/** @internal */
export interface Option {
  /**
   * actual text value for this item
   * @maxLength 100
   */
  value?: string;
  /**
   * display name for this text item
   * @maxLength 100
   */
  displayName?: string;
  /**
   * A description of this text item
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface _Number {
  /**
   * @deprecated
   * @replacedBy min
   * @targetRemovalDate 2025-11-30
   */
  minimum?: number | null;
  /**
   * Indicates minimum value required for the number
   * @format DECIMAL_VALUE
   */
  min?: string | null;
  /**
   * @deprecated
   * @replacedBy max
   * @targetRemovalDate 2025-11-30
   */
  maximum?: number | null;
  /**
   * Indicates maximum value allowed for the number
   * @format DECIMAL_VALUE
   */
  max?: string | null;
  /**
   * @deprecated
   * @replacedBy multiplier
   * @targetRemovalDate 2025-11-30
   */
  multipleOf?: number | null;
  /**
   * The multiplier for the number value
   * @format DECIMAL_VALUE
   */
  multiplier?: string | null;
}

/** @internal */
export interface A11y {
  /**
   * A collection of attributes that will be stated in the manifest
   * @maxSize 100
   */
  attributes?: A11yAttributesWithLiterals[];
}

/** @internal */
export enum A11yAttributes {
  Unknown_AriaAttributes = 'Unknown_AriaAttributes',
  /** The value used for tabIndex attribute */
  tabIndex = 'tabIndex',
  /** The value used for aria-level */
  ariaLevel = 'ariaLevel',
  /** The value used for aria-expanded */
  ariaExpanded = 'ariaExpanded',
  /** The value used for aria-disabled */
  ariaDisabled = 'ariaDisabled',
  /** The value used for aria-atomic */
  ariaAtomic = 'ariaAtomic',
  /** The value used for aria-hidden */
  ariaHidden = 'ariaHidden',
  /** The value used for aria-busy */
  ariaBusy = 'ariaBusy',
  /** Indicates if should add Multiline instructions to aria-label */
  multiline = 'multiline',
  /** Indicates if should add Autocomplete instructions to aria-label */
  ariaAutocomplete = 'ariaAutocomplete',
  /** The value used for aria-pressed */
  ariaPressed = 'ariaPressed',
  /** The value used for aria-haspopup */
  ariaHaspopup = 'ariaHaspopup',
  /** The value used for aria-relevant */
  ariaRelevant = 'ariaRelevant',
  /** The value used for role attribute */
  role = 'role',
  /** The value used for aria-live */
  ariaLive = 'ariaLive',
  /** The value used for aria-current */
  ariaCurrent = 'ariaCurrent',
  /** The text used for aria-label */
  ariaLabel = 'ariaLabel',
  /** The text used for aria-roledescription */
  ariaRoledescription = 'ariaRoledescription',
  /** The value used for aria-describedby */
  ariaDescribedby = 'ariaDescribedby',
  /** The value used for aria-labelledby */
  ariaLabelledby = 'ariaLabelledby',
  /** The text used for aria-errormessage */
  ariaErrormessage = 'ariaErrormessage',
  /** The text used for aria-owns */
  ariaOwns = 'ariaOwns',
  /** The text used for aria-controls */
  ariaControls = 'ariaControls',
  /** The HTML tag to use for the element */
  tag = 'tag',
  /** The value used for aria-multiline */
  ariaMultiline = 'ariaMultiline',
  /** The value used for aria-invalid */
  ariaInvalid = 'ariaInvalid',
}

/** @enumType */
/** @internal */
export type A11yAttributesWithLiterals =
  | A11yAttributes
  | 'Unknown_AriaAttributes'
  | 'tabIndex'
  | 'ariaLevel'
  | 'ariaExpanded'
  | 'ariaDisabled'
  | 'ariaAtomic'
  | 'ariaHidden'
  | 'ariaBusy'
  | 'multiline'
  | 'ariaAutocomplete'
  | 'ariaPressed'
  | 'ariaHaspopup'
  | 'ariaRelevant'
  | 'role'
  | 'ariaLive'
  | 'ariaCurrent'
  | 'ariaLabel'
  | 'ariaRoledescription'
  | 'ariaDescribedby'
  | 'ariaLabelledby'
  | 'ariaErrormessage'
  | 'ariaOwns'
  | 'ariaControls'
  | 'tag'
  | 'ariaMultiline'
  | 'ariaInvalid';

/** @internal */
export interface Link {
  /**
   * A collection of possible link types that the component supports. Only one of the types will make it to the component after input.
   * @maxSize 12
   */
  linkTypes?: LinkTypeWithLiterals[];
  /**
   * Allows limiting the link to specific Wix apps, by their app ID, in case of LinkType dynamicPageLink or pageLink
   * @format GUID
   * @maxSize 20
   */
  appIds?: string[];
  /** In case of LinkType dynamicPageLink, whether to hide inner routes in the page selection dialog (only top level pages will be selectable) */
  hideInnerRoute?: boolean | null;
}

/** @internal */
export enum LinkType {
  UNKNOWN_LinkType = 'UNKNOWN_LinkType',
  /** A link to another website */
  externalLink = 'externalLink',
  /** A link to an item on the current page */
  anchorLink = 'anchorLink',
  /** A valid email link (`mailto:example@example.com`) */
  emailLink = 'emailLink',
  /** A valid phone link (`phone:11111111111`) */
  phoneLink = 'phoneLink',
  /** A link to a page in Wix that needs to be selected dynamically */
  dynamicPageLink = 'dynamicPageLink',
  /** A link to another page on the site */
  pageLink = 'pageLink',
  /** A link to open a whatsapp conversation */
  whatsAppLink = 'whatsAppLink',
  /** A link to a PDF file hosted by Wix */
  documentLink = 'documentLink',
  /** A link that opens a lightbox */
  popupLink = 'popupLink',
  /** A link that directs the user to an address on google maps */
  addressLink = 'addressLink',
  /** A link that scrolls to the top/bottom of the page */
  edgeAnchorLinks = 'edgeAnchorLinks',
  /** A link that directs the user to wix login dialog */
  loginToWixLink = 'loginToWixLink',
}

/** @enumType */
/** @internal */
export type LinkTypeWithLiterals =
  | LinkType
  | 'UNKNOWN_LinkType'
  | 'externalLink'
  | 'anchorLink'
  | 'emailLink'
  | 'phoneLink'
  | 'dynamicPageLink'
  | 'pageLink'
  | 'whatsAppLink'
  | 'documentLink'
  | 'popupLink'
  | 'addressLink'
  | 'edgeAnchorLinks'
  | 'loginToWixLink';

/** An array of data items or complex data types */
/** @internal */
export interface ArrayItems extends ArrayItemsArrayDataOneOf {
  /** The definition of multiple data items in each item of the Array */
  data?: DataItems;
  /** For a single data type in the array */
  dataItem?: DataItem;
  /**
   * Marks this array as one whose item types are dynamic and resolved at runtime.
   * Only applicable when a template container (containerType = TEMPLATE) has an item_key
   * that references this array. Mutually exclusive with 'data' and 'data_item'.
   */
  dynamicItems?: boolean | null;
  /** The maximum size of the Array (there will be a size limit in the Storage as well) */
  maxSize?: number | null;
}

/** @oneof */
/** @internal */
export interface ArrayItemsArrayDataOneOf {
  /** The definition of multiple data items in each item of the Array */
  data?: DataItems;
  /** For a single data type in the array */
  dataItem?: DataItem;
  /**
   * Marks this array as one whose item types are dynamic and resolved at runtime.
   * Only applicable when a template container (containerType = TEMPLATE) has an item_key
   * that references this array. Mutually exclusive with 'data' and 'data_item'.
   */
  dynamicItems?: boolean | null;
}

/** @internal */
export interface DataItems {
  /**
   * For an array of complex object types
   * Each item in the array, will contain all this data structure
   */
  items?: Record<string, DataItem>;
}

/**
 * A container is a place to add components to in the editor
 * There are a few different types of containers supported
 */
/** @internal */
export interface ReactElementContainer
  extends ReactElementContainerSelectedContainerTypeOneOf {
  /** A container element that will be passed in as children, it is composed in the editor */
  simple?: SimpleContainer;
  /** A Slot for targeting slot implementors, gets the API implementation by the host (definition in DEV Center for both) */
  slot?: Slot;
  /** Placeholder for components targeting a specific area (definition in DEV Center) */
  placeholder?: PlaceHolder;
  /** A template container that can be used to render a template multiple times */
  template?: TemplateContainer;
  /**
   * A DOM Selector that will allow us to target it in the editor
   * @maxLength 100
   * @deprecated A DOM Selector that will allow us to target it in the editor
   * @targetRemovalDate 2026-05-31
   */
  selector?: string;
  /** The type of Container to be rendered */
  containerType?: ContainerTypeWithLiterals;
  /** Contexts available in this container */
  contexts?: ContextReferences;
  /**
   * An optional override of the display name of the container.
   * @maxLength 50
   */
  displayName?: string | null;
  /**
   * An optional override of the description of the container
   * @maxLength 300
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface ReactElementContainerSelectedContainerTypeOneOf {
  /** A container element that will be passed in as children, it is composed in the editor */
  simple?: SimpleContainer;
  /** A Slot for targeting slot implementors, gets the API implementation by the host (definition in DEV Center for both) */
  slot?: Slot;
  /** Placeholder for components targeting a specific area (definition in DEV Center) */
  placeholder?: PlaceHolder;
  /** A template container that can be used to render a template multiple times */
  template?: TemplateContainer;
}

/** @internal */
export enum ContainerType {
  /** An undefined container type, is invalid */
  UNKNOWN_CONTAINER_TYPE = 'UNKNOWN_CONTAINER_TYPE',
  /** A simple container that can support adding and layouting elements in the editor */
  simple = 'simple',
  /** A slot declared by a component in DEV Center that allows integrations with a Props API from the host */
  slot = 'slot',
  /** A container to add elements targeting a specific product use case, exposed in DEV Center */
  placeholder = 'placeholder',
  /** A container that can be used to render a template multiple times */
  template = 'template',
}

/** @enumType */
/** @internal */
export type ContainerTypeWithLiterals =
  | ContainerType
  | 'UNKNOWN_CONTAINER_TYPE'
  | 'simple'
  | 'slot'
  | 'placeholder'
  | 'template';

/** @internal */
export interface SimpleContainer {
  /** Layout configuration for the container, can be used to configure the editing of the container and the layout. */
  layout?: ContainerLayout;
  /** Style configuration for the container, can be used to disable style properties, or change their display name. */
  style?: ContainerStyleOverrides;
  /** Behavior configuration for the container, can be used to disable selection of the container. */
  behaviors?: ContainerBehaviors;
  /**
   * An optional override of the display name of the container.
   * @maxLength 50
   * @deprecated
   * @replacedBy container.display_name
   * @targetRemovalDate 2026-06-30
   */
  displayName?: string | null;
}

/** @internal */
export interface ContainerLayout {
  /**
   * Which direction the container can resize to. will be used to determine the resize handle in the editor, and the container layout.
   * @deprecated Which direction the container can resize to. will be used to determine the resize handle in the editor, and the container layout.
   * @replacedBy container_resize_direction
   * @targetRemovalDate 2026-06-30
   */
  resizeDirection?: ResizeDirectionWithLiterals;
  /** Which direction the container can resize to. will be used to determine the resize handle in the editor, and the container layout. */
  containerResizeDirection?: ContentResizeDirectionWithLiterals;
  /**
   * In case the containerResizeDirection is horizontal or horizontalAndVertical this can be defined to provide the initial size of the container in the component
   * @min 1
   * @max 1280
   */
  width?: number | null;
  /**
   * In case the containerResizeDirection is vertical or horizontalAndVertical this can be defined to provide the initial size of the container in the component
   * @min 1
   * @max 1000
   */
  height?: number | null;
}

/** @internal */
export enum ResizeDirection {
  /** Default value when direction is not specified */
  UNKNOWN_ResizeDirection = 'UNKNOWN_ResizeDirection',
  /** Component can only be resized horizontally */
  horizontal = 'horizontal',
  /** Component can only be resized vertically */
  vertical = 'vertical',
  /** Component can be resized both horizontally and vertically */
  horizontalAndVertical = 'horizontalAndVertical',
  /** Component maintains its aspect ratio while resizing */
  aspectRatio = 'aspectRatio',
  /** Component cannot be resized in any direction */
  none = 'none',
}

/** @enumType */
/** @internal */
export type ResizeDirectionWithLiterals =
  | ResizeDirection
  | 'UNKNOWN_ResizeDirection'
  | 'horizontal'
  | 'vertical'
  | 'horizontalAndVertical'
  | 'aspectRatio'
  | 'none';

/** @internal */
export enum ContentResizeDirection {
  /** Default value when content resize behavior is not specified */
  UNKNOWN_ContentResizeDirection = 'UNKNOWN_ContentResizeDirection',
  /** Component's width will automatically adjust based on its content */
  horizontal = 'horizontal',
  /** Component's height will automatically adjust based on its content */
  vertical = 'vertical',
  /** Component's width and height will automatically adjust based on its content */
  horizontalAndVertical = 'horizontalAndVertical',
  /** Component's size will not be affected by its content */
  none = 'none',
}

/** @enumType */
/** @internal */
export type ContentResizeDirectionWithLiterals =
  | ContentResizeDirection
  | 'UNKNOWN_ContentResizeDirection'
  | 'horizontal'
  | 'vertical'
  | 'horizontalAndVertical'
  | 'none';

/** @internal */
export interface ContainerStyleOverrides {
  /** The border style of the container, can be used to disable editing of the border, or change the display name. */
  border?: StyleItemOverrides;
  /** The border radius style of the container, can be used to disable editing of the border radius, or change the display name. */
  borderRadius?: StyleItemOverrides;
  /** The shadow style of the container, can be used to disable editing of the shadow, or change the display name. */
  shadow?: StyleItemOverrides;
  /** The background style of the container, can be used to disable editing of the background, or change the display name. */
  background?: StyleItemOverrides;
}

/** DEPRECATED: This message is deprecated and will be removed in the future */
/** @internal */
export interface StyleItemOverrides {
  /** Disables the ability to edit this style-item */
  disableEditing?: boolean | null;
  /** Overrides the default value of this style-item */
  defaultValue?: any;
  /** Overrides the default values for the style-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
  /**
   * Overrides Display displayName of this style-item
   * @maxLength 100
   */
  displayName?: string | null;
}

/** @internal */
export interface ContainerBehaviors {
  /** Whether the container should be selectable in the editor. */
  selectable?: boolean | null;
}

/** @internal */
export interface Slot {
  /**
   * The slot definition that this container should accept as defined in DEV Center
   * @format GUID
   */
  slotId?: string;
}

/** @internal */
export interface PlaceHolder {
  /**
   * The placeholder definition that this container should accept as defined in DEV Center
   * @format GUID
   */
  placeholderId?: string;
}

/** @internal */
export interface TemplateContainer {
  /** Layout configuration for the container, can be used to configure the editing of the container and the layout. */
  layout?: ContainerLayout;
  /** Path to the target arrayItems data item within the same element scope. */
  dataItemPath?: ItemPath;
}

/** A path to a data item within the same element scope. */
/** @internal */
export interface ItemPath {
  /**
   * Deprecated, use item_key instead
   * @deprecated Deprecated, use item_key instead
   * @replacedBy item_key
   * @targetRemovalDate 2026-09-30
   */
  dataItemKey?: string;
  /**
   * The key of the data item within the element's data scope.
   * Example: "items"        – top-level data item 'items'
   * Example: "slides.title" – inner key 'title' of data item 'slides'
   * @minLength 1
   */
  itemKey?: string;
}

/** @internal */
export interface ContextReferences {
  /**
   * Available contexts in this container that were defined in the editorElement.contexts
   * Example: itemsList
   */
  local?: string[];
  /**
   * A list of contexts this component exposes because it uses other context providers inside it's code
   * Example: @wix/stores-products-list-context
   */
  reference?: string[];
}

/** rich text data type allow manipulation of text with html & inline styles */
/** @internal */
export interface RichText {
  /**
   * A collection of possible rich text abilities that the component supports. Only one of the types will make it to the component after input.
   * @maxSize 22
   */
  abilities?: RichTextAbilitiesWithLiterals[];
}

/** @internal */
export enum RichTextAbilities {
  UNKNOWN_RichTextAbilities = 'UNKNOWN_RichTextAbilities',
  /** selected theme font, also changing the html tag */
  font = 'font',
  /** font family of the text */
  fontFamily = 'fontFamily',
  /** font size of the text */
  fontSize = 'fontSize',
  /** italic / normal */
  fontStyle = 'fontStyle',
  /** bold / normal / 100-900 */
  fontWeight = 'fontWeight',
  /** underline / line-through */
  textDecoration = 'textDecoration',
  /** color of the text */
  color = 'color',
  /** background color of the text */
  backgroundColor = 'backgroundColor',
  /** letter spacing of the text */
  letterSpacing = 'letterSpacing',
  /** left / center / right / justify */
  textAlign = 'textAlign',
  /** rtl/ltr */
  direction = 'direction',
  /** indent of the text */
  marginStart = 'marginStart',
  /** outdent of the text */
  marginEnd = 'marginEnd',
  /** special data: */
  bulletedList = 'bulletedList',
  /** implemented with <ol> */
  numberedList = 'numberedList',
  /** h1,h2,h3,h4,h5,h6,p,blockquote */
  seoTag = 'seoTag',
}

/** @enumType */
/** @internal */
export type RichTextAbilitiesWithLiterals =
  | RichTextAbilities
  | 'UNKNOWN_RichTextAbilities'
  | 'font'
  | 'fontFamily'
  | 'fontSize'
  | 'fontStyle'
  | 'fontWeight'
  | 'textDecoration'
  | 'color'
  | 'backgroundColor'
  | 'letterSpacing'
  | 'textAlign'
  | 'direction'
  | 'marginStart'
  | 'marginEnd'
  | 'bulletedList'
  | 'numberedList'
  | 'seoTag';

/** @internal */
export interface Image {
  /** media manager categories to open media manager filtered by the component needs */
  category?: ImageCategoryTypesWithLiterals;
}

/** Categories to open media manager filtered by the component needs */
/** @internal */
export enum ImageCategoryTypes {
  /** Default value when image category is not specified */
  UNKNOWN_CategoryName = 'UNKNOWN_CategoryName',
  /** Images - mapped to IMAGE */
  IMAGE = 'IMAGE',
  /** Background Images - mapped to BG_IMAGE */
  IMAGE_BACKGROUND = 'IMAGE_BACKGROUND',
}

/** @enumType */
/** @internal */
export type ImageCategoryTypesWithLiterals =
  | ImageCategoryTypes
  | 'UNKNOWN_CategoryName'
  | 'IMAGE'
  | 'IMAGE_BACKGROUND';

/** @internal */
export interface Video {
  /** media manager categories to open media manager filtered by the component needs */
  category?: VideoCategoryTypesWithLiterals;
}

/** @internal */
export enum VideoCategoryTypes {
  /** Default value when video category is not specified */
  UNKNOWN_VideoCategoryTypes = 'UNKNOWN_VideoCategoryTypes',
  /** Both videos and transparent videos - mapped to VIDEO_BOX */
  VIDEO = 'VIDEO',
  /** Transparent videos - mapped to VIDEO_ALPHA */
  VIDEO_TRANSPARENT = 'VIDEO_TRANSPARENT',
  /** Videos without transparency - mapped to VIDEO */
  VIDEO_OPAQUE = 'VIDEO_OPAQUE',
}

/** @enumType */
/** @internal */
export type VideoCategoryTypesWithLiterals =
  | VideoCategoryTypes
  | 'UNKNOWN_VideoCategoryTypes'
  | 'VIDEO'
  | 'VIDEO_TRANSPARENT'
  | 'VIDEO_OPAQUE';

/** @internal */
export interface VectorArt {
  /** media manager categories to open media manager filtered by the component needs */
  category?: VectorArtCategoryTypesWithLiterals;
}

/** @internal */
export enum VectorArtCategoryTypes {
  /** Default value when vector art category is not specified */
  UNKNOWN_VectorArtCategoryTypes = 'UNKNOWN_VectorArtCategoryTypes',
  /** Vector Art (both basic and art shapes) - mapped to VECTOR_ART */
  SHAPE_ALL = 'SHAPE_ALL',
  /** Basic Shapes - mapped to SHAPE_BASIC */
  SHAPE_BASIC = 'SHAPE_BASIC',
  /** Vector Art Shapes - mapped to SHAPE_ART */
  SHAPE_ART = 'SHAPE_ART',
  /** Social Icons - deprecated use SHAPE_SOCIAL instead */
  ICON_SOCIAL = 'ICON_SOCIAL',
  /** SVG Shape Dividers - mapped to DIVIDERS */
  SHAPE_DIVIDERS = 'SHAPE_DIVIDERS',
  /** Location Icons - mapped to SHAPE_LOCATION */
  SHAPE_LOCATION = 'SHAPE_LOCATION',
  /** Documents Icons - mapped to SHAPE_DOCUMENTS */
  SHAPE_DOCUMENTS = 'SHAPE_DOCUMENTS',
  /** Social Icons - mapped to SHAPE_SOCIAL from type SVG */
  SHAPE_SOCIAL = 'SHAPE_SOCIAL',
  /** Arrow Icons - mapped to SHAPE_ARROWS */
  SHAPE_ARROWS = 'SHAPE_ARROWS',
}

/** @enumType */
/** @internal */
export type VectorArtCategoryTypesWithLiterals =
  | VectorArtCategoryTypes
  | 'UNKNOWN_VectorArtCategoryTypes'
  | 'SHAPE_ALL'
  | 'SHAPE_BASIC'
  | 'SHAPE_ART'
  | 'ICON_SOCIAL'
  | 'SHAPE_DIVIDERS'
  | 'SHAPE_LOCATION'
  | 'SHAPE_DOCUMENTS'
  | 'SHAPE_SOCIAL'
  | 'SHAPE_ARROWS';

/** @internal */
export interface EditorFunction {
  /**
   * The Parameters expected by the function, can be empty
   * @maxSize 10
   */
  parameters?: FunctionParameter[];
  /** The result of the function, can be empty for void return */
  returns?: FunctionReturnType;
  /** Whether the function returns a promise with the type of the result */
  async?: boolean | null;
  /**
   * The display name of the function for paneles
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * The description of the function for human readability
   * @maxLength 300
   */
  description?: string | null;
  /**
   * Whether this function is deprecated
   * @internal
   */
  deprecated?: boolean | null;
  /** The role of the function, describing the purpose it serves */
  role?: FunctionRoleWithLiterals;
}

/** @internal */
export interface FunctionParameter
  extends FunctionParameterSelectedDataTypeOneOf {
  /** In case of an array */
  arrayItems?: FunctionParameterArrayItems;
  /** In case of a complex object */
  data?: FunctionParameterItems;
  /** In case of a function */
  function?: EditorFunction;
  /** In case of a text enum */
  textEnum?: TextEnum;
  /** In case of a Change event parameter */
  changeEvent?: ChangeEvent;
  /** In case of a link */
  link?: Link;
  /**
   * Exactly one of `data_type` or `dom_event` must be set
   * A data type parameter
   */
  dataType?: DataTypeWithLiterals;
  /** A DOM event parameter */
  domEvent?: DomEventTypeWithLiterals;
  /** Whether the Parameter is optional, limitations of Javascript apply, only the last parameters can be optional */
  optional?: boolean | null;
  /**
   * The default value for this parameter, applicable when the parameter is optional,
   * this is for description purposes only and will NOT be injected at runtime
   */
  defaultValue?: any;
  /**
   * The display name of the Parameter for human readability
   * @maxLength 100
   */
  displayName?: string | null;
  /** @maxLength 100 */
  description?: string | null;
  /**
   * Whether this parameter is deprecated
   * @internal
   */
  deprecated?: boolean | null;
}

/** @oneof */
/** @internal */
export interface FunctionParameterSelectedDataTypeOneOf {
  /** In case of an array */
  arrayItems?: FunctionParameterArrayItems;
  /** In case of a complex object */
  data?: FunctionParameterItems;
  /** In case of a function */
  function?: EditorFunction;
  /** In case of a text enum */
  textEnum?: TextEnum;
  /** In case of a Change event parameter */
  changeEvent?: ChangeEvent;
  /** In case of a link */
  link?: Link;
}

/** @internal */
export enum DomEventType {
  UNKNOWN_DomEventType = 'UNKNOWN_DomEventType',
  /** Value change event (https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event) */
  CHANGE = 'CHANGE',
  /** Pointer interaction event (https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent) */
  POINTER = 'POINTER',
  /** Keyboard interaction event (https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent) */
  KEYBOARD = 'KEYBOARD',
  /** Focus and blur event (https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent) */
  FOCUS = 'FOCUS',
  /** Form submission event (https://developer.mozilla.org/en-US/docs/Web/API/SubmitEvent) */
  SUBMIT = 'SUBMIT',
}

/** @enumType */
/** @internal */
export type DomEventTypeWithLiterals =
  | DomEventType
  | 'UNKNOWN_DomEventType'
  | 'CHANGE'
  | 'POINTER'
  | 'KEYBOARD'
  | 'FOCUS'
  | 'SUBMIT';

/** An array of data items or complex data types */
/** @internal */
export interface FunctionParameterArrayItems
  extends FunctionParameterArrayItemsArrayDataOneOf {
  /** For a single data type in the array, including another array */
  item?: FunctionParameter;
}

/** @oneof */
/** @internal */
export interface FunctionParameterArrayItemsArrayDataOneOf {
  /** For a single data type in the array, including another array */
  item?: FunctionParameter;
}

/** @internal */
export interface FunctionParameterItems {
  /**
   * For an array of complex object types
   * Each item in the array, will contain all this data structure
   */
  items?: Record<string, FunctionParameter>;
}

/** @internal */
export interface ChangeEvent {
  /** The type of input this change event originates from */
  inputType?: InputTypeWithLiterals;
}

/** @internal */
export enum InputType {
  UNKNOWN_InputType = 'UNKNOWN_InputType',
  /** target.value (string) - Text inputs, selects, sliders, search boxes */
  text = 'text',
  /** target.checked (boolean) - Checkboxes, toggles, switches */
  checkbox = 'checkbox',
  /** target.valueAsNumber (number) - Number inputs, range inputs */
  number = 'number',
  /** target.valueAsDate (Date) - Date pickers, datetime inputs */
  date = 'date',
}

/** @enumType */
/** @internal */
export type InputTypeWithLiterals =
  | InputType
  | 'UNKNOWN_InputType'
  | 'text'
  | 'checkbox'
  | 'number'
  | 'date';

/** @internal */
export interface FunctionReturnType
  extends FunctionReturnTypeSelectedDataTypeOneOf {
  /** In case of an array */
  arrayItems?: FunctionParameterArrayItems;
  /** In case of a complex object */
  data?: FunctionParameterItems;
  /** In case of a text enum */
  textEnum?: TextEnum;
  /** The type of the return value, does not include containers */
  dataType?: DataTypeWithLiterals;
  /**
   * The display name of the return type for human readability
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * The description of the function return type for human readability
   * @maxLength 100
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface FunctionReturnTypeSelectedDataTypeOneOf {
  /** In case of an array */
  arrayItems?: FunctionParameterArrayItems;
  /** In case of a complex object */
  data?: FunctionParameterItems;
  /** In case of a text enum */
  textEnum?: TextEnum;
}

/** @internal */
export enum FunctionRole {
  UNKNOWN_FUNCTION_ROLE = 'UNKNOWN_FUNCTION_ROLE',
  /** The function converts between two data types, mostly useful for context providers and function libraries */
  data_type_conversion = 'data_type_conversion',
}

/** @enumType */
/** @internal */
export type FunctionRoleWithLiterals =
  | FunctionRole
  | 'UNKNOWN_FUNCTION_ROLE'
  | 'data_type_conversion';

/** Filter type - declares which items are filterable and which operators each item supports */
/** @internal */
export interface FilterDefinition {
  /** Fully described inline filter items */
  inlineItems?: InlineFilterItem[];
  /** Filter items referencing existing data items */
  dataItems?: FilterItem[];
  /** Filter items referencing existing context items */
  contextItems?: FilterItem[];
}

/** An inline filter item definition */
/** @internal */
export interface InlineFilterItem {
  /**
   * Name of the filtered field
   * @maxLength 200
   */
  name?: string | null;
  /**
   * Human-readable name for this field
   * @maxLength 100
   */
  displayName?: string | null;
  /** The data type of the field (subset of DataType suitable for filtering) */
  dataType?: DataTypeWithLiterals;
  /** Explicitly supported operators. If omitted, all applicable operators for the fieldType are assumed */
  operators?: FilterOperatorWithLiterals[];
  /**
   * Additional custom operators beyond the built-in FilterOperator set.
   * @maxSize 10
   */
  customOperators?: CustomFilterOperator[];
  /**
   * A description of this filter field
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export enum FilterOperator {
  UNKNOWN_FilterOperator = 'UNKNOWN_FilterOperator',
  /** $eq - Equal */
  eq = 'eq',
  /** $ne - Not equal */
  ne = 'ne',
  /** $lt - Less than */
  lt = 'lt',
  /** $lte - Less than or equal */
  lte = 'lte',
  /** $gt - Greater than */
  gt = 'gt',
  /** $gte - Greater than or equal */
  gte = 'gte',
  /** $in - Value is in list */
  'in' = 'in',
  /** $nin - Value is not in list */
  nin = 'nin',
  /** $exists - Field exists (is not null) */
  exists = 'exists',
  /** $isEmpty - Field value is empty */
  isEmpty = 'isEmpty',
  /** $startsWith - String starts with (text fields only) */
  startsWith = 'startsWith',
  /** $hasAll - Array contains all values */
  hasAll = 'hasAll',
  /** $hasSome - Array contains at least one value */
  hasSome = 'hasSome',
  /** $matchItems - Filter on inner fields of array items (arrayItems only) */
  matchItems = 'matchItems',
}

/** @enumType */
/** @internal */
export type FilterOperatorWithLiterals =
  | FilterOperator
  | 'UNKNOWN_FilterOperator'
  | 'eq'
  | 'ne'
  | 'lt'
  | 'lte'
  | 'gt'
  | 'gte'
  | 'in'
  | 'nin'
  | 'exists'
  | 'isEmpty'
  | 'startsWith'
  | 'hasAll'
  | 'hasSome'
  | 'matchItems';

/** A custom filter operator definition beyond the built-in FilterOperator set */
/** @internal */
export interface CustomFilterOperator {
  /**
   * The operator name as it will be passed in the filter object in the component's props.
   * Use the bare operator name without the leading `$` (e.g. `eq`, not `$eq`),
   * matching the FilterOperator enum convention.
   * @maxLength 20
   */
  name?: string | null;
  /**
   * Human-readable display name for this custom operator
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * A description of this custom filter operator
   * @maxLength 300
   */
  description?: string | null;
  /**
   * The value type this operator expects. When omitted, the operator is passed
   * with no value.
   */
  valueType?: FilterOperatorValueTypeWithLiterals;
  /** In case of text enum - a required list of options to supply to the users to choose from */
  textEnum?: TextEnum;
}

/** @internal */
export enum FilterOperatorValueType {
  UNKNOWN_FilterOperatorValueType = 'UNKNOWN_FilterOperatorValueType',
  /** A simple text value */
  text = 'text',
  /** A list of predefined textual values to choose from */
  textEnum = 'textEnum',
  /** Any number */
  number = 'number',
  /** true / false value */
  booleanValue = 'booleanValue',
  /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
  localDate = 'localDate',
  /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
  localTime = 'localTime',
  /** Local Date Time output ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
  localDateTime = 'localDateTime',
}

/** @enumType */
/** @internal */
export type FilterOperatorValueTypeWithLiterals =
  | FilterOperatorValueType
  | 'UNKNOWN_FilterOperatorValueType'
  | 'text'
  | 'textEnum'
  | 'number'
  | 'booleanValue'
  | 'localDate'
  | 'localTime'
  | 'localDateTime';

/** A filter item referencing an existing item (e.g. DataItem or ContextItem) */
/** @internal */
export interface FilterItem {
  /** Path to the item */
  itemPath?: ItemPath;
  /** Explicitly supported operators. If omitted, all applicable operators for the resolved type are assumed */
  operators?: FilterOperatorWithLiterals[];
  /**
   * Additional custom operators beyond the built-in FilterOperator set.
   * @maxSize 10
   */
  customOperators?: CustomFilterOperator[];
}

/** Sort type - declares which items are available for sorting */
/** @internal */
export interface SortDefinition {
  /** Fully described inline sort items */
  inlineItems?: InlineSortItem[];
  /** Sort items referencing existing data items */
  dataItems?: SortItem[];
  /** Sort items referencing existing context items */
  contextItems?: SortItem[];
}

/** An inline sort item definition */
/** @internal */
export interface InlineSortItem {
  /**
   * Name of the sorted field
   * @maxLength 200
   */
  name?: string | null;
  /**
   * Human-readable name for this field
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * Human-readable label for the ascending sort order of this field (e.g. "Oldest first")
   * @maxLength 100
   */
  ascendingDisplayName?: string | null;
  /**
   * Human-readable label for the descending sort order of this field (e.g. "Newest first")
   * @maxLength 100
   */
  descendingDisplayName?: string | null;
  /**
   * A description of this sort field
   * @maxLength 300
   */
  description?: string | null;
}

/**
 * A sort item referencing an existing item (e.g. DataItem or ContextItem),
 * with optional per-direction display labels.
 */
/** @internal */
export interface SortItem {
  /** Path to the item */
  itemPath?: ItemPath;
  /**
   * Human-readable label for the ascending sort order of this item (e.g. "Oldest first")
   * @maxLength 100
   */
  ascendingDisplayName?: string | null;
  /**
   * Human-readable label for the descending sort order of this item (e.g. "Newest first")
   * @maxLength 100
   */
  descendingDisplayName?: string | null;
}

/** @internal */
export interface ApiContext {
  /** A map of keys describing the context provided by this component */
  items?: Record<string, ContextItem>;
  /** Named preview states this context can be rendered in, keyed by state key */
  states?: Record<string, ContextState>;
}

/** @internal */
export interface ContextItem extends ContextItemSelectedDataTypeOneOf {
  /** For arrays, the items are defined here */
  arrayItems?: ContextArrayItems;
  /** For data objects, the items are defined here */
  data?: ContextDataItems;
  /** For functions, the function definition is defined here */
  function?: EditorFunction;
  /** For text enums, the enum options are defined here */
  textEnum?: TextEnum;
  /** The type exposed by the context item (can't be "container") */
  dataType?: DataTypeWithLiterals;
  /**
   * The display name of the context item for user facing and AI usage
   * @maxLength 100
   */
  displayName?: string | null;
  /** For sub types that implement parts of context, points to a context provider component type */
  contextImplementor?: ContextImplementor;
  /**
   * Will be set to true in case an item has been removed from the Context
   * @internal
   */
  deprecated?: boolean | null;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
  /**
   * A description of the context item for user facing and AI usage
   * @maxLength 300
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface ContextItemSelectedDataTypeOneOf {
  /** For arrays, the items are defined here */
  arrayItems?: ContextArrayItems;
  /** For data objects, the items are defined here */
  data?: ContextDataItems;
  /** For functions, the function definition is defined here */
  function?: EditorFunction;
  /** For text enums, the enum options are defined here */
  textEnum?: TextEnum;
}

/** @internal */
export interface ContextImplementor {
  /**
   * The component type to implement the context item
   * @maxLength 100
   */
  componentType?: string;
  /**
   * The prop key the component expects the context to be passed in to it (optional)
   * @maxLength 100
   */
  propKey?: string | null;
}

/** An array of data items or complex data types */
/** @internal */
export interface ContextArrayItems extends ContextArrayItemsArrayDataOneOf {
  /** Specify the type of data inside the array */
  item?: ContextItem;
}

/** @oneof */
/** @internal */
export interface ContextArrayItemsArrayDataOneOf {
  /** Specify the type of data inside the array */
  item?: ContextItem;
}

/** A map of keys describing the context items provided by this component */
/** @internal */
export interface ContextDataItems {
  /** A map of keys describing the data items provided by this component */
  items?: Record<string, ContextItem>;
  /** For sub types that implement parts of context, points to a context provider component type */
  contextImplementor?: ContextImplementor;
}

/** A named preview state this context can be rendered in */
/** @internal */
export interface ContextState {
  /**
   * Display name of this state for user facing and AI usage
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * A description of this state for user facing and AI usage
   * @maxLength 300
   */
  description?: string | null;
  /** The props to apply to activate this state */
  props?: Record<string, any>;
  /** The context item whose value the context applies in this state, given the props */
  contextItem?: StateContextItem;
}

/** The value the context applies to a context item in a given preview state */
/** @internal */
export interface StateContextItem extends StateContextItemValueOneOf {
  /** The boolean the context applies to a booleanValue context item */
  booleanValue?: boolean | null;
  /**
   * The TextEnum.Option.value the context applies to a textEnum context item
   * @maxLength 100
   */
  enumValue?: string | null;
  /**
   * Key of the context.items entry this value applies to. Must reference an existing item whose data_type is booleanValue or textEnum
   * @maxLength 100
   */
  itemKey?: string | null;
}

/** @oneof */
/** @internal */
export interface StateContextItemValueOneOf {
  /** The boolean the context applies to a booleanValue context item */
  booleanValue?: boolean | null;
  /**
   * The TextEnum.Option.value the context applies to a textEnum context item
   * @maxLength 100
   */
  enumValue?: string | null;
}

/** @internal */
export interface ElementItem extends ElementItemSelectedElementTypeOneOf {
  /** An new element definition */
  inlineElement?: InlineElement;
  /** A reference to the used element with overrides */
  refElement?: RefElement;
  /** Defines the type of element we are configuring */
  elementType?: ElementTypeWithLiterals;
  /**
   * Whether this element is deprecated
   * @internal
   */
  deprecated?: boolean;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
}

/** @oneof */
/** @internal */
export interface ElementItemSelectedElementTypeOneOf {
  /** An new element definition */
  inlineElement?: InlineElement;
  /** A reference to the used element with overrides */
  refElement?: RefElement;
}

/** @internal */
export enum ElementType {
  UNKNOWN_ElementType = 'UNKNOWN_ElementType',
  /** An element that was written as part of the component */
  inlineElement = 'inlineElement',
  /** An element provided by the Wix ecosystem that we are reusing. These elements must exist in the Wix DEV Center. */
  refElement = 'refElement',
}

/** @enumType */
/** @internal */
export type ElementTypeWithLiterals =
  | ElementType
  | 'UNKNOWN_ElementType'
  | 'inlineElement'
  | 'refElement';

/** @internal */
export interface InlineElement {
  /**
   * Relative DOM Query selector for this element to the component root. We assume nesting by it's parent elements for CSS Vars scoping.
   * @minLength 4
   * @maxLength 300
   */
  selector?: string;
  /**
   * Human friendly name on the editor stage when the component is in interaction with the user
   * @maxLength 50
   */
  displayName?: string;
  /** style-api of this element, a map of style-items where the key is the style-item name and the value is the style-item definition. These will be manifested as CSS vars in the scope of the component and prefixed with `--` */
  style?: Record<string, StyleItem>;
  /** data-api of this element, a map of data-items where the key is the data-item name and the value is the data-item definition */
  data?: Record<string, DataItem>;
  /** elements-map of this element, a map of inner-elements where the key is the element name and the value is the element definition */
  elements?: Record<string, ElementItem>;
  /** editor-behaviors-api of this inner-element, will determine which type of editor experiences this inner-element should support */
  behaviors?: Behaviors;
  /** Collection of the native actions specified for the concrete component */
  actions?: Actions;
  /** Custom actions specified for the component, allowing for flexibility beyond native actions */
  customActions?: Record<string, Action>;
  /** Component presets definition. Canonically useful for different layout or theming */
  presets?: Record<string, PresetItem>;
  /** The Archetype this component adheres to, to be used for classification by AI models */
  archetype?: ArchetypeWithLiterals;
  /** A map with definitions of states that this element can be edited in */
  states?: Record<string, ElementState>;
  /** A reference to a state that needs to be triggered in order for this element to be visible */
  visibleState?: VisibleState;
  /**
   * Display filters for the Element, used to define the visibility of inner / ref elements, style items, data items and custom actions in the editor
   * The Element is the first in line to affect the display, Preset and State are after it
   */
  displayFilters?: DisplayFilters;
  /** Display groups for the element, used to group elements in the editor for better UX */
  displayGroups?: Record<string, DisplayGroupItem>;
  /** A map of css-properties that this element supports, where the key is the CSS property name and the value is the CSS property definition */
  cssProperties?: Record<string, CssPropertyItem>;
  /** A map of css-custom-properties that this element supports, where the key is the CSS property name and the value is the CSS property definition */
  cssCustomProperties?: Record<string, CssCustomPropertyItem>;
  /** A reference to a help article for this element */
  helpArticle?: HelpArticle;
  /**
   * A description of this inline element
   * @maxLength 300
   */
  description?: string | null;
}

/** DEPRECATED: This message is deprecated and will be removed in the future, add new types and definitions in css_properties.proto */
/** @internal */
export interface StyleItem
  extends StyleItemSelectedItemTypeOneOf,
    StyleItemSelectedCssPropertyTypeOneOf,
    StyleItemSelectedCssVariableTypeOneOf {
  /**
   * DEPRECATED: use cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @deprecated DEPRECATED: use cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @replacedBy cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @targetRemovalDate 2025-08-01
   */
  cssPropertyType?: CssPropertyTypeEnumCssPropertyTypeWithLiterals;
  /**
   * DEPRECATED: use cssCustomProperties instead
   * @deprecated DEPRECATED: use cssCustomProperties instead
   * @replacedBy cssCustomProperties
   * @targetRemovalDate 2025-08-01
   */
  cssVariableType?: CssVariableTypeEnumCssDataTypeWithLiterals;
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
  /** Additional options to refine the customEnum style item */
  customEnum?: CustomEnum;
  /** Additional options to refine the number style item */
  number?: CssNumber;
  /**
   * The type of the style-item, used to define the type of the css property or css variable
   * @deprecated The type of the style-item, used to define the type of the css property or css variable
   * @replacedBy cssPropertyType or cssVariableType
   * @targetRemovalDate 2025-08-01
   */
  styleType?: StyleTypeWithLiterals;
  /** The default value for the style-item when the component is in the "regular" state */
  defaultValue?: any;
  /** The default values for the style-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
  /**
   * Will be used as displayName of this style-item
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * DEPRECATED - use cssCustomProperties instead
   * @deprecated DEPRECATED - use cssCustomProperties instead
   * @replacedBy cssCustomProperties
   * @targetRemovalDate 2025-08-01
   */
  cssCustomProperty?: boolean | null;
  /**
   * Whether this style-item is deprecated
   * @internal
   */
  deprecated?: boolean;
}

/** @oneof */
/** @internal */
export interface StyleItemSelectedItemTypeOneOf {
  /**
   * DEPRECATED: use cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @deprecated DEPRECATED: use cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @replacedBy cssProperties or cssCustomProperties depends if you need this as inline css-property or as a css variable
   * @targetRemovalDate 2025-08-01
   */
  cssPropertyType?: CssPropertyTypeEnumCssPropertyTypeWithLiterals;
  /**
   * DEPRECATED: use cssCustomProperties instead
   * @deprecated DEPRECATED: use cssCustomProperties instead
   * @replacedBy cssCustomProperties
   * @targetRemovalDate 2025-08-01
   */
  cssVariableType?: CssVariableTypeEnumCssDataTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface StyleItemSelectedCssPropertyTypeOneOf {
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
}

/** @oneof */
/** @internal */
export interface StyleItemSelectedCssVariableTypeOneOf {
  /** Additional options to refine the customEnum style item */
  customEnum?: CustomEnum;
  /** Additional options to refine the number style item */
  number?: CssNumber;
}

/** The supported [CSS Property Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) in Javascript naming format */
/** @internal */
export enum CssPropertyTypeEnumCssPropertyType {
  UNKNOWN_CssPropertyType = 'UNKNOWN_CssPropertyType',
  /** background properties */
  background = 'background',
  backgroundSize = 'backgroundSize',
  backgroundColor = 'backgroundColor',
  backgroundImage = 'backgroundImage',
  backgroundClip = 'backgroundClip',
  backgroundOrigin = 'backgroundOrigin',
  backgroundPosition = 'backgroundPosition',
  backgroundRepeat = 'backgroundRepeat',
  backgroundAttachment = 'backgroundAttachment',
  fill = 'fill',
  fillOpacity = 'fillOpacity',
  /** margin properties */
  margin = 'margin',
  marginTop = 'marginTop',
  marginRight = 'marginRight',
  marginBottom = 'marginBottom',
  marginLeft = 'marginLeft',
  marginInlineStart = 'marginInlineStart',
  marginInlineEnd = 'marginInlineEnd',
  /** padding properties */
  padding = 'padding',
  paddingTop = 'paddingTop',
  paddingRight = 'paddingRight',
  paddingBottom = 'paddingBottom',
  paddingLeft = 'paddingLeft',
  paddingInlineStart = 'paddingInlineStart',
  paddingInlineEnd = 'paddingInlineEnd',
  /** border properties */
  border = 'border',
  borderWidth = 'borderWidth',
  borderStyle = 'borderStyle',
  borderColor = 'borderColor',
  borderTop = 'borderTop',
  borderTopColor = 'borderTopColor',
  borderTopWidth = 'borderTopWidth',
  borderTopStyle = 'borderTopStyle',
  borderRight = 'borderRight',
  borderRightColor = 'borderRightColor',
  borderRightWidth = 'borderRightWidth',
  borderRightStyle = 'borderRightStyle',
  borderBottom = 'borderBottom',
  borderBottomColor = 'borderBottomColor',
  borderBottomWidth = 'borderBottomWidth',
  borderBottomStyle = 'borderBottomStyle',
  borderLeft = 'borderLeft',
  borderLeftColor = 'borderLeftColor',
  borderLeftWidth = 'borderLeftWidth',
  borderLeftStyle = 'borderLeftStyle',
  borderInlineStart = 'borderInlineStart',
  borderInlineStartColor = 'borderInlineStartColor',
  borderInlineStartWidth = 'borderInlineStartWidth',
  borderInlineStartStyle = 'borderInlineStartStyle',
  borderInlineEnd = 'borderInlineEnd',
  borderInlineEndColor = 'borderInlineEndColor',
  borderInlineEndWidth = 'borderInlineEndWidth',
  borderInlineEndStyle = 'borderInlineEndStyle',
  borderRadius = 'borderRadius',
  borderTopLeftRadius = 'borderTopLeftRadius',
  borderTopRightRadius = 'borderTopRightRadius',
  borderBottomRightRadius = 'borderBottomRightRadius',
  borderBottomLeftRadius = 'borderBottomLeftRadius',
  borderStartStartRadius = 'borderStartStartRadius',
  borderStartEndRadius = 'borderStartEndRadius',
  borderEndStartRadius = 'borderEndStartRadius',
  borderEndEndRadius = 'borderEndEndRadius',
  /** text properties */
  font = 'font',
  fontFamily = 'fontFamily',
  fontSize = 'fontSize',
  fontStretch = 'fontStretch',
  fontStyle = 'fontStyle',
  fontVariant = 'fontVariant',
  fontWeight = 'fontWeight',
  lineHeight = 'lineHeight',
  color = 'color',
  letterSpacing = 'letterSpacing',
  writingMode = 'writingMode',
  textAlign = 'textAlign',
  textTransform = 'textTransform',
  textShadow = 'textShadow',
  textOverflow = 'textOverflow',
  textIndent = 'textIndent',
  textDecoration = 'textDecoration',
  textDecorationColor = 'textDecorationColor',
  textDecorationLine = 'textDecorationLine',
  textDecorationStyle = 'textDecorationStyle',
  textDecorationThickness = 'textDecorationThickness',
  /** general box properties */
  boxShadow = 'boxShadow',
  opacity = 'opacity',
  overflow = 'overflow',
  /** layout properties */
  display = 'display',
  alignSelf = 'alignSelf',
  justifyContent = 'justifyContent',
  alignItems = 'alignItems',
  flexDirection = 'flexDirection',
  gap = 'gap',
  height = 'height',
  width = 'width',
  columnGap = 'columnGap',
  rowGap = 'rowGap',
  /** filters */
  filter = 'filter',
  backdropFilter = 'backdropFilter',
  /** media sizing & alignment */
  objectFit = 'objectFit',
  objectPosition = 'objectPosition',
  /** blending & compositing */
  mixBlendMode = 'mixBlendMode',
  isolation = 'isolation',
  /** stroke properties */
  stroke = 'stroke',
  strokeWidth = 'strokeWidth',
  strokeOpacity = 'strokeOpacity',
}

/** @enumType */
/** @internal */
export type CssPropertyTypeEnumCssPropertyTypeWithLiterals =
  | CssPropertyTypeEnumCssPropertyType
  | 'UNKNOWN_CssPropertyType'
  | 'background'
  | 'backgroundSize'
  | 'backgroundColor'
  | 'backgroundImage'
  | 'backgroundClip'
  | 'backgroundOrigin'
  | 'backgroundPosition'
  | 'backgroundRepeat'
  | 'backgroundAttachment'
  | 'fill'
  | 'fillOpacity'
  | 'margin'
  | 'marginTop'
  | 'marginRight'
  | 'marginBottom'
  | 'marginLeft'
  | 'marginInlineStart'
  | 'marginInlineEnd'
  | 'padding'
  | 'paddingTop'
  | 'paddingRight'
  | 'paddingBottom'
  | 'paddingLeft'
  | 'paddingInlineStart'
  | 'paddingInlineEnd'
  | 'border'
  | 'borderWidth'
  | 'borderStyle'
  | 'borderColor'
  | 'borderTop'
  | 'borderTopColor'
  | 'borderTopWidth'
  | 'borderTopStyle'
  | 'borderRight'
  | 'borderRightColor'
  | 'borderRightWidth'
  | 'borderRightStyle'
  | 'borderBottom'
  | 'borderBottomColor'
  | 'borderBottomWidth'
  | 'borderBottomStyle'
  | 'borderLeft'
  | 'borderLeftColor'
  | 'borderLeftWidth'
  | 'borderLeftStyle'
  | 'borderInlineStart'
  | 'borderInlineStartColor'
  | 'borderInlineStartWidth'
  | 'borderInlineStartStyle'
  | 'borderInlineEnd'
  | 'borderInlineEndColor'
  | 'borderInlineEndWidth'
  | 'borderInlineEndStyle'
  | 'borderRadius'
  | 'borderTopLeftRadius'
  | 'borderTopRightRadius'
  | 'borderBottomRightRadius'
  | 'borderBottomLeftRadius'
  | 'borderStartStartRadius'
  | 'borderStartEndRadius'
  | 'borderEndStartRadius'
  | 'borderEndEndRadius'
  | 'font'
  | 'fontFamily'
  | 'fontSize'
  | 'fontStretch'
  | 'fontStyle'
  | 'fontVariant'
  | 'fontWeight'
  | 'lineHeight'
  | 'color'
  | 'letterSpacing'
  | 'writingMode'
  | 'textAlign'
  | 'textTransform'
  | 'textShadow'
  | 'textOverflow'
  | 'textIndent'
  | 'textDecoration'
  | 'textDecorationColor'
  | 'textDecorationLine'
  | 'textDecorationStyle'
  | 'textDecorationThickness'
  | 'boxShadow'
  | 'opacity'
  | 'overflow'
  | 'display'
  | 'alignSelf'
  | 'justifyContent'
  | 'alignItems'
  | 'flexDirection'
  | 'gap'
  | 'height'
  | 'width'
  | 'columnGap'
  | 'rowGap'
  | 'filter'
  | 'backdropFilter'
  | 'objectFit'
  | 'objectPosition'
  | 'mixBlendMode'
  | 'isolation'
  | 'stroke'
  | 'strokeWidth'
  | 'strokeOpacity';

/** The supported [CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types) in Javascript naming format */
/** @internal */
export enum CssVariableTypeEnumCssDataType {
  UNKNOWN_CssDataType = 'UNKNOWN_CssDataType',
  number = 'number',
  length = 'length',
  color = 'color',
  angle = 'angle',
  percentage = 'percentage',
  lengthPercentage = 'lengthPercentage',
  blendMode = 'blendMode',
  customEnum = 'customEnum',
  string = 'string',
  time = 'time',
}

/** @enumType */
/** @internal */
export type CssVariableTypeEnumCssDataTypeWithLiterals =
  | CssVariableTypeEnumCssDataType
  | 'UNKNOWN_CssDataType'
  | 'number'
  | 'length'
  | 'color'
  | 'angle'
  | 'percentage'
  | 'lengthPercentage'
  | 'blendMode'
  | 'customEnum'
  | 'string'
  | 'time';

/** The supported [CSS Property Types & CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) in Javascript naming format */
/** @internal */
export enum StyleType {
  UNKNOWN_StyleType = 'UNKNOWN_StyleType',
  /** css-data-types */
  number = 'number',
  string = 'string',
  angle = 'angle',
  length = 'length',
  percentage = 'percentage',
  lengthPercentage = 'lengthPercentage',
  blendMode = 'blendMode',
  customEnum = 'customEnum',
  time = 'time',
  /** background properties */
  background = 'background',
  backgroundSize = 'backgroundSize',
  backgroundColor = 'backgroundColor',
  backgroundImage = 'backgroundImage',
  backgroundClip = 'backgroundClip',
  backgroundOrigin = 'backgroundOrigin',
  backgroundPosition = 'backgroundPosition',
  backgroundRepeat = 'backgroundRepeat',
  backgroundAttachment = 'backgroundAttachment',
  /** margin properties */
  margin = 'margin',
  marginTop = 'marginTop',
  marginRight = 'marginRight',
  marginBottom = 'marginBottom',
  marginLeft = 'marginLeft',
  marginInlineStart = 'marginInlineStart',
  marginInlineEnd = 'marginInlineEnd',
  /** padding properties */
  padding = 'padding',
  paddingTop = 'paddingTop',
  paddingRight = 'paddingRight',
  paddingBottom = 'paddingBottom',
  paddingLeft = 'paddingLeft',
  paddingInlineStart = 'paddingInlineStart',
  paddingInlineEnd = 'paddingInlineEnd',
  /** border properties */
  border = 'border',
  borderWidth = 'borderWidth',
  borderStyle = 'borderStyle',
  borderColor = 'borderColor',
  borderTop = 'borderTop',
  borderTopColor = 'borderTopColor',
  borderTopWidth = 'borderTopWidth',
  borderTopStyle = 'borderTopStyle',
  borderRight = 'borderRight',
  borderRightColor = 'borderRightColor',
  borderRightWidth = 'borderRightWidth',
  borderRightStyle = 'borderRightStyle',
  borderBottom = 'borderBottom',
  borderBottomColor = 'borderBottomColor',
  borderBottomWidth = 'borderBottomWidth',
  borderBottomStyle = 'borderBottomStyle',
  borderLeft = 'borderLeft',
  borderLeftColor = 'borderLeftColor',
  borderLeftWidth = 'borderLeftWidth',
  borderLeftStyle = 'borderLeftStyle',
  borderInlineStart = 'borderInlineStart',
  borderInlineStartColor = 'borderInlineStartColor',
  borderInlineStartWidth = 'borderInlineStartWidth',
  borderInlineStartStyle = 'borderInlineStartStyle',
  borderInlineEnd = 'borderInlineEnd',
  borderInlineEndColor = 'borderInlineEndColor',
  borderInlineEndWidth = 'borderInlineEndWidth',
  borderInlineEndStyle = 'borderInlineEndStyle',
  /** border-radius properties */
  borderRadius = 'borderRadius',
  borderTopLeftRadius = 'borderTopLeftRadius',
  borderTopRightRadius = 'borderTopRightRadius',
  borderBottomRightRadius = 'borderBottomRightRadius',
  borderBottomLeftRadius = 'borderBottomLeftRadius',
  borderStartStartRadius = 'borderStartStartRadius',
  borderStartEndRadius = 'borderStartEndRadius',
  borderEndStartRadius = 'borderEndStartRadius',
  borderEndEndRadius = 'borderEndEndRadius',
  /** font properties */
  font = 'font',
  fontFamily = 'fontFamily',
  fontSize = 'fontSize',
  fontStretch = 'fontStretch',
  fontStyle = 'fontStyle',
  fontVariant = 'fontVariant',
  fontWeight = 'fontWeight',
  lineHeight = 'lineHeight',
  /** text properties */
  color = 'color',
  letterSpacing = 'letterSpacing',
  writingMode = 'writingMode',
  textAlign = 'textAlign',
  textTransform = 'textTransform',
  textShadow = 'textShadow',
  textOverflow = 'textOverflow',
  textIndent = 'textIndent',
  /** text-decoration properties */
  textDecoration = 'textDecoration',
  textDecorationColor = 'textDecorationColor',
  textDecorationLine = 'textDecorationLine',
  textDecorationStyle = 'textDecorationStyle',
  textDecorationThickness = 'textDecorationThickness',
  /** box related properties */
  boxShadow = 'boxShadow',
  opacity = 'opacity',
  overflow = 'overflow',
  overflowX = 'overflowX',
  overflowY = 'overflowY',
  /** layout properties */
  display = 'display',
  alignSelf = 'alignSelf',
  justifyContent = 'justifyContent',
  alignItems = 'alignItems',
  flexDirection = 'flexDirection',
  height = 'height',
  width = 'width',
  gap = 'gap',
  columnGap = 'columnGap',
  rowGap = 'rowGap',
  /** filters */
  filter = 'filter',
  backdropFilter = 'backdropFilter',
  /** media sizing & alignment */
  objectFit = 'objectFit',
  objectPosition = 'objectPosition',
  /** blending & compositing */
  mixBlendMode = 'mixBlendMode',
  isolation = 'isolation',
  /** stroke properties */
  stroke = 'stroke',
  strokeWidth = 'strokeWidth',
  strokeOpacity = 'strokeOpacity',
  /** fill properties */
  fill = 'fill',
  fillOpacity = 'fillOpacity',
}

/** @enumType */
/** @internal */
export type StyleTypeWithLiterals =
  | StyleType
  | 'UNKNOWN_StyleType'
  | 'number'
  | 'string'
  | 'angle'
  | 'length'
  | 'percentage'
  | 'lengthPercentage'
  | 'blendMode'
  | 'customEnum'
  | 'time'
  | 'background'
  | 'backgroundSize'
  | 'backgroundColor'
  | 'backgroundImage'
  | 'backgroundClip'
  | 'backgroundOrigin'
  | 'backgroundPosition'
  | 'backgroundRepeat'
  | 'backgroundAttachment'
  | 'margin'
  | 'marginTop'
  | 'marginRight'
  | 'marginBottom'
  | 'marginLeft'
  | 'marginInlineStart'
  | 'marginInlineEnd'
  | 'padding'
  | 'paddingTop'
  | 'paddingRight'
  | 'paddingBottom'
  | 'paddingLeft'
  | 'paddingInlineStart'
  | 'paddingInlineEnd'
  | 'border'
  | 'borderWidth'
  | 'borderStyle'
  | 'borderColor'
  | 'borderTop'
  | 'borderTopColor'
  | 'borderTopWidth'
  | 'borderTopStyle'
  | 'borderRight'
  | 'borderRightColor'
  | 'borderRightWidth'
  | 'borderRightStyle'
  | 'borderBottom'
  | 'borderBottomColor'
  | 'borderBottomWidth'
  | 'borderBottomStyle'
  | 'borderLeft'
  | 'borderLeftColor'
  | 'borderLeftWidth'
  | 'borderLeftStyle'
  | 'borderInlineStart'
  | 'borderInlineStartColor'
  | 'borderInlineStartWidth'
  | 'borderInlineStartStyle'
  | 'borderInlineEnd'
  | 'borderInlineEndColor'
  | 'borderInlineEndWidth'
  | 'borderInlineEndStyle'
  | 'borderRadius'
  | 'borderTopLeftRadius'
  | 'borderTopRightRadius'
  | 'borderBottomRightRadius'
  | 'borderBottomLeftRadius'
  | 'borderStartStartRadius'
  | 'borderStartEndRadius'
  | 'borderEndStartRadius'
  | 'borderEndEndRadius'
  | 'font'
  | 'fontFamily'
  | 'fontSize'
  | 'fontStretch'
  | 'fontStyle'
  | 'fontVariant'
  | 'fontWeight'
  | 'lineHeight'
  | 'color'
  | 'letterSpacing'
  | 'writingMode'
  | 'textAlign'
  | 'textTransform'
  | 'textShadow'
  | 'textOverflow'
  | 'textIndent'
  | 'textDecoration'
  | 'textDecorationColor'
  | 'textDecorationLine'
  | 'textDecorationStyle'
  | 'textDecorationThickness'
  | 'boxShadow'
  | 'opacity'
  | 'overflow'
  | 'overflowX'
  | 'overflowY'
  | 'display'
  | 'alignSelf'
  | 'justifyContent'
  | 'alignItems'
  | 'flexDirection'
  | 'height'
  | 'width'
  | 'gap'
  | 'columnGap'
  | 'rowGap'
  | 'filter'
  | 'backdropFilter'
  | 'objectFit'
  | 'objectPosition'
  | 'mixBlendMode'
  | 'isolation'
  | 'stroke'
  | 'strokeWidth'
  | 'strokeOpacity'
  | 'fill'
  | 'fillOpacity';

/** @internal */
export interface Filter {
  /**
   * List of filter functions in case of reducing the abilities exposed to the User
   * @maxSize 100
   */
  filterFunctions?: FilterFunctionWithLiterals[];
}

/** @internal */
export enum FilterFunction {
  UNKNOWN_FilterFunctions = 'UNKNOWN_FilterFunctions',
  /** The value used for blur filter */
  blur = 'blur',
  /** The value used for brightness filter */
  brightness = 'brightness',
  /** The value used for contrast filter */
  contrast = 'contrast',
  /** DEPRECATED - use dropShadow instead */
  drop_shadow = 'drop_shadow',
  /** The value used for grayscale filter */
  grayscale = 'grayscale',
  /** DEPRECATED - use hueRotate instead */
  hue_rotate = 'hue_rotate',
  /** The value used for invert filter */
  invert = 'invert',
  /** The value used for opacity filter */
  opacity = 'opacity',
  /** The value used for sepia filter */
  sepia = 'sepia',
  /** The value used for saturate filter */
  saturate = 'saturate',
  /** The value used for drop-shadow filter */
  dropShadow = 'dropShadow',
  /** The value used for hue-rotate filter */
  hueRotate = 'hueRotate',
}

/** @enumType */
/** @internal */
export type FilterFunctionWithLiterals =
  | FilterFunction
  | 'UNKNOWN_FilterFunctions'
  | 'blur'
  | 'brightness'
  | 'contrast'
  | 'drop_shadow'
  | 'grayscale'
  | 'hue_rotate'
  | 'invert'
  | 'opacity'
  | 'sepia'
  | 'saturate'
  | 'dropShadow'
  | 'hueRotate';

/** @internal */
export interface BackdropFilter {
  /**
   * List of filter functions in case of reducing the abilities exposed to the User
   * @maxSize 100
   */
  filterFunctions?: FilterFunctionWithLiterals[];
}

/** @internal */
export interface Display {
  /**
   * list of display values in case we want to reduce the abilities exposed to the User
   * @maxSize 20
   */
  displayValues?: DisplayValueEnumDisplayValueWithLiterals[];
}

/** @internal */
export enum DisplayValueEnumDisplayValue {
  UNKNOWN_DisplayValue = 'UNKNOWN_DisplayValue',
  none = 'none',
  block = 'block',
  inline = 'inline',
  flow = 'flow',
  flowRoot = 'flowRoot',
  table = 'table',
  flex = 'flex',
  grid = 'grid',
  /** DEPRECATED - use listItem instead */
  list_item = 'list_item',
  contents = 'contents',
  /** DEPRECATED - use inlineBlock instead */
  inline_block = 'inline_block',
  /** DEPRECATED - use inlineTable instead */
  inline_table = 'inline_table',
  /** DEPRECATED - use inlineFlex instead */
  inline_flex = 'inline_flex',
  /** DEPRECATED - use inlineGrid instead */
  inline_grid = 'inline_grid',
  inlineBlock = 'inlineBlock',
  inlineTable = 'inlineTable',
  inlineFlex = 'inlineFlex',
  inlineGrid = 'inlineGrid',
  listItem = 'listItem',
}

/** @enumType */
/** @internal */
export type DisplayValueEnumDisplayValueWithLiterals =
  | DisplayValueEnumDisplayValue
  | 'UNKNOWN_DisplayValue'
  | 'none'
  | 'block'
  | 'inline'
  | 'flow'
  | 'flowRoot'
  | 'table'
  | 'flex'
  | 'grid'
  | 'list_item'
  | 'contents'
  | 'inline_block'
  | 'inline_table'
  | 'inline_flex'
  | 'inline_grid'
  | 'inlineBlock'
  | 'inlineTable'
  | 'inlineFlex'
  | 'inlineGrid'
  | 'listItem';

/** @internal */
export interface WritingMode {
  /**
   * list of writing-mode values in case we want to reduce the abilities exposed to the User
   * @maxSize 20
   */
  writingModeValues?: WritingModeValueWithLiterals[];
}

/** @internal */
export enum WritingModeValue {
  UNKNOWN_WritingModeValue = 'UNKNOWN_WritingModeValue',
  horizontalTb = 'horizontalTb',
  verticalRl = 'verticalRl',
  verticalLr = 'verticalLr',
  sidewaysRl = 'sidewaysRl',
  sidewaysLr = 'sidewaysLr',
}

/** @enumType */
/** @internal */
export type WritingModeValueWithLiterals =
  | WritingModeValue
  | 'UNKNOWN_WritingModeValue'
  | 'horizontalTb'
  | 'verticalRl'
  | 'verticalLr'
  | 'sidewaysRl'
  | 'sidewaysLr';

/** @internal */
export interface Background {
  /**
   * The background mode defines the type of background to be used
   * @internal
   */
  backgroundMode?: BackgroundModeEnumWithLiterals;
  /** The image media manager category to open media manager filtered by the component needs */
  imageCategory?: ImageCategoryTypesWithLiterals;
  /** The vector art media manager category to open media manager filtered by the component needs */
  vectorArtCategory?: VectorArtCategoryTypesWithLiterals;
}

/** @internal */
export enum BackgroundModeEnum {
  UNKNOWN_BackgroundModeEnum = 'UNKNOWN_BackgroundModeEnum',
  shapeDividerSvg = 'shapeDividerSvg',
}

/** @enumType */
/** @internal */
export type BackgroundModeEnumWithLiterals =
  | BackgroundModeEnum
  | 'UNKNOWN_BackgroundModeEnum'
  | 'shapeDividerSvg';

/** DEPRECATED: This message is deprecated and will be removed in the future */
/** @internal */
export interface CustomEnum {
  /**
   * DEPRECATED: use cssDataType instead
   * @deprecated DEPRECATED: use cssDataType instead
   * @replacedBy cssDataType
   * @targetRemovalDate 2025-08-01
   */
  cssVariableType?: CssVariableTypeEnumCssDataTypeWithLiterals;
  /** The type of the custom enum, used to define the type of the values allowed in the enum */
  cssDataType?: CssDataTypeWithLiterals;
  /**
   * The allowed value options for this custom enum
   * @maxSize 100
   */
  options?: CustomEnumOption[];
}

/** @internal */
export enum CssDataType {
  UNKNOWN_CssDataType = 'UNKNOWN_CssDataType',
  number = 'number',
  string = 'string',
  angle = 'angle',
  color = 'color',
  length = 'length',
  percentage = 'percentage',
  lengthPercentage = 'lengthPercentage',
  blendMode = 'blendMode',
  customEnum = 'customEnum',
  time = 'time',
}

/** @enumType */
/** @internal */
export type CssDataTypeWithLiterals =
  | CssDataType
  | 'UNKNOWN_CssDataType'
  | 'number'
  | 'string'
  | 'angle'
  | 'color'
  | 'length'
  | 'percentage'
  | 'lengthPercentage'
  | 'blendMode'
  | 'customEnum'
  | 'time';

/** DEPRECATED: This message is deprecated and will be removed in the future */
/** @internal */
export interface CustomEnumOption {
  /**
   * the enum value
   * @maxLength 100
   */
  value?: string;
  /**
   * Will be used as displayName of this enum option
   * @maxLength 100
   */
  displayName?: string;
  /**
   * the css-properties to apply when this enum value is selected [Internal use only]
   * @internal
   * @maxSize 100
   */
  appliedStyles?: CustomEnumOptionCssProperty[];
}

/** DEPRECATED: This message is deprecated and will be removed in the future */
/** @internal */
export interface CustomEnumOptionCssProperty {
  /**
   * the css property
   * @maxLength 100
   */
  property?: string;
  /**
   * the css value
   * @maxLength 300
   */
  value?: string;
}

/** @internal */
export interface CssNumber {
  /**
   * @deprecated
   * @replacedBy min
   * @targetRemovalDate 2025-11-30
   */
  minimum?: number | null;
  /**
   * Indicates minimum value required for the number
   * @format DECIMAL_VALUE
   */
  min?: string | null;
  /**
   * @deprecated
   * @replacedBy max
   * @targetRemovalDate 2025-11-30
   */
  maximum?: number | null;
  /**
   * Indicates maximum value allowed for the number
   * @format DECIMAL_VALUE
   */
  max?: string | null;
  /**
   * @deprecated
   * @replacedBy multiplier
   * @targetRemovalDate 2025-11-30
   */
  multipleOf?: number | null;
  /**
   * The multiplier for the number value
   * @format DECIMAL_VALUE
   */
  multiplier?: string | null;
}

/** @internal */
export interface Behaviors {
  /** Determines if the inner-element can be selectable in the editor */
  selectable?: boolean | null;
  /** Determines if the inner-element can be removed from the component */
  removable?: boolean | null;
}

/** List of the native actions */
/** @internal */
export interface Actions {
  /** Allows enabling / disabling and overriding the settings action */
  settings?: Action;
  /** Allows enabling / disabling and overriding the design action */
  design?: Action;
  /** Allows enabling / disabling and overriding the media action */
  media?: Action;
  /** Allows enabling / disabling and overriding the manageItems action */
  manageItems?: Action;
  /** Allows enabling / disabling and overriding the dashboard action */
  dashboard?: DashboardAction;
  /** Allows enabling / disabling and overriding the manageMenu action */
  manageMenu?: Action;
  /** Allows enabling / disabling and overriding the container action */
  container?: Action;
}

/** @internal */
export interface Action {
  /**
   * The public human-readable name given to the  action by the developer.
   * @maxLength 50
   */
  displayName?: string;
  /** A model definition for declaring a concrete instructions action will perform */
  execution?: Execution;
  /**
   * A description of this action
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface Execution extends ExecutionActionExecuteOneOf {
  /** Executes an action that manipulates component's data */
  data?: DataAction;
  /**
   * Executes an action that manipulates component's style
   * @deprecated Executes an action that manipulates component's style
   * @replacedBy cssProperty or cssCustomProperty
   * @targetRemovalDate 2025-08-01
   */
  style?: StyleAction;
  /** Executes an event-based action. Triggered event should be intercepted in the editor script */
  event?: EventAction;
  /** Opens a URL inside an iframe panel */
  panel?: PanelAction;
  /** Executes an action on a target element (based on path) */
  forward?: ForwardAction;
  /** Executes an action that is connected to a display-group */
  displayGroup?: DisplayGroupAction;
  /** Executes an action that points into a specific css-property-key, */
  cssProperty?: CssPropertyAction;
  /** Executes an action that points into a specific css-custom-property-key, */
  cssCustomProperty?: CssCustomPropertyAction;
  /** The action type allows to determine the return type of the execution function */
  actionType?: ActionTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ExecutionActionExecuteOneOf {
  /** Executes an action that manipulates component's data */
  data?: DataAction;
  /**
   * Executes an action that manipulates component's style
   * @deprecated Executes an action that manipulates component's style
   * @replacedBy cssProperty or cssCustomProperty
   * @targetRemovalDate 2025-08-01
   */
  style?: StyleAction;
  /** Executes an event-based action. Triggered event should be intercepted in the editor script */
  event?: EventAction;
  /** Opens a URL inside an iframe panel */
  panel?: PanelAction;
  /** Executes an action on a target element (based on path) */
  forward?: ForwardAction;
  /** Executes an action that is connected to a display-group */
  displayGroup?: DisplayGroupAction;
  /** Executes an action that points into a specific css-property-key, */
  cssProperty?: CssPropertyAction;
  /** Executes an action that points into a specific css-custom-property-key, */
  cssCustomProperty?: CssCustomPropertyAction;
}

/** @internal */
export enum ActionType {
  UNKNOWN_ActionType = 'UNKNOWN_ActionType',
  data = 'data',
  event = 'event',
  panel = 'panel',
  forward = 'forward',
  style = 'style',
  displayGroup = 'displayGroup',
  cssProperty = 'cssProperty',
  cssCustomProperty = 'cssCustomProperty',
}

/** @enumType */
/** @internal */
export type ActionTypeWithLiterals =
  | ActionType
  | 'UNKNOWN_ActionType'
  | 'data'
  | 'event'
  | 'panel'
  | 'forward'
  | 'style'
  | 'displayGroup'
  | 'cssProperty'
  | 'cssCustomProperty';

/**
 * Represents an action that points into a specific data-item-key,
 * the outcome of clicking such action will be determined by the editor
 */
/** @internal */
export interface DataAction {
  /**
   * Points to the data item within the component’s data structure
   * @minLength 1
   * @maxLength 50
   */
  dataItemKey?: string;
}

/** DEPRECATED - use CssPropertyAction or CssCustomPropertyAction */
/** @internal */
export interface StyleAction {
  /**
   * Points to the style item within the component’s style structure
   * @minLength 1
   * @maxLength 50
   */
  styleItemKey?: string;
}

/** Executes an event-based action. Triggered event should be intercepted in the editor script */
/** @internal */
export interface EventAction {
  /**
   * Name of the event to be handled by the editor script
   * @minLength 1
   * @maxLength 50
   */
  event?: string;
}

/** Represents a URL-based action that opens a panel */
/** @internal */
export interface PanelAction extends PanelActionSelectedPanelTypeOneOf {
  /**
   * For using a panel defined in dev-center
   * @format GUID
   */
  panelId?: string;
  /**
   * Internal implementation as an interim step, a defined inline panel
   * @internal
   */
  inline?: Panel;
  /** The selected panel reference type */
  panelType?: PanelTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface PanelActionSelectedPanelTypeOneOf {
  /**
   * For using a panel defined in dev-center
   * @format GUID
   */
  panelId?: string;
  /**
   * Internal implementation as an interim step, a defined inline panel
   * @internal
   */
  inline?: Panel;
}

/** list of possible panel types */
/** @internal */
export enum PanelType {
  UNKNOWN_PanelType = 'UNKNOWN_PanelType',
  panelId = 'panelId',
  inline = 'inline',
}

/** @enumType */
/** @internal */
export type PanelTypeWithLiterals =
  | PanelType
  | 'UNKNOWN_PanelType'
  | 'panelId'
  | 'inline';

/** Represents an action that targets another element within the component */
/** @internal */
export interface ForwardAction extends ForwardActionActionOneOf {
  /**
   * Used when actionType is custom
   * @minLength 1
   * @maxLength 50
   */
  custom?: string;
  /** Specifies the action names (one of the natives or custom) */
  actionName?: ActionNameWithLiterals;
  /**
   * Path to the target element
   * @minLength 1
   * @maxLength 500
   */
  elementPath?: string;
}

/** @oneof */
/** @internal */
export interface ForwardActionActionOneOf {
  /**
   * Used when actionType is custom
   * @minLength 1
   * @maxLength 50
   */
  custom?: string;
}

/** @internal */
export enum ActionName {
  UNKNOWN_ActionName = 'UNKNOWN_ActionName',
  /** Manage the component settings, this usually aligns with component data */
  settings = 'settings',
  /** Manage the `style` information */
  design = 'design',
  /** Manage any media type `data` defined in the component */
  media = 'media',
  /** Manage items in the component data */
  manageItems = 'manageItems',
  /** Open the apps default dashboard page, or select one if there is more than one */
  dashboard = 'dashboard',
  /** actionName to be triggered from the defined custom actions */
  custom = 'custom',
  /** Manage Menu Items */
  manageMenu = 'manageMenu',
  /** Shows the container actions, or select one if there is more than one */
  container = 'container',
}

/** @enumType */
/** @internal */
export type ActionNameWithLiterals =
  | ActionName
  | 'UNKNOWN_ActionName'
  | 'settings'
  | 'design'
  | 'media'
  | 'manageItems'
  | 'dashboard'
  | 'custom'
  | 'manageMenu'
  | 'container';

/**
 * Represents an action that points into a specific display-group-key,
 * the outcome will make the chosen display group visible to the user for changing the groups values in the component
 */
/** @internal */
export interface DisplayGroupAction {
  /**
   * The display group to be used
   * @minLength 1
   * @maxLength 50
   */
  displayGroupKey?: string;
}

/**
 * Represents an action that points into a single css-property,
 * the outcome of clicking such action will be determined by the editor
 */
/** @internal */
export interface CssPropertyAction {
  /**
   * Points to the style item within the component’s css-properties map
   * @minLength 1
   * @maxLength 50
   */
  cssPropertyKey?: string;
}

/**
 * Represents an action that points into a single css-custom-property,
 * the outcome of clicking such action will be determined by the editor
 */
/** @internal */
export interface CssCustomPropertyAction {
  /**
   * Points to the style item within the component’s css-custom-properties map
   * @minLength 1
   * @maxLength 50
   */
  cssCustomPropertyKey?: string;
}

/** @internal */
export interface DashboardAction {
  /**
   * The public human-readable name given to the  action by the developer.
   * @maxLength 50
   */
  displayName?: string;
  /**
   * Optional pageId of the dashboard in case there is more than one
   * @minLength 4
   * @maxLength 50
   */
  dashboardPageId?: string;
  /** A model definition for declaring a concrete instructions action will perform */
  execution?: Execution;
  /**
   * A description of this dashboard action
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface PresetItem {
  /**
   * Preset name for displaying purposes in the editor
   * @maxLength 100
   */
  displayName?: string;
  /**
   * A URL to the preset thumbnail file
   * @format WEB_URL
   * @maxLength 500
   */
  thumbnailUrl?: string | null;
  /** Optional initial size of the component when switching into this preset (will not be applied when element is used as an inner element) */
  initialSize?: ComponentInitialSize;
  /** The style overrides for this preset and the inner elements */
  styleOverrides?: BreakpointPresetStyleOverrides;
  /**
   * Show this preset in panel only on specified breakpoints
   * (undefined/empty list = all breakpoints, list with values = only those breakpoints)
   * TODO: MaxSize is 2, because we only support small and large breakpoints for now
   * @maxSize 2
   */
  optimizedFor?: BreakpointEnumBreakpointWithLiterals[];
  /**
   * A URL to the CSS file of this preset, to be used when you need to apply many css-changes or default-values to the DOM when this preset is selected, optional
   * @format WEB_URL
   * @maxLength 500
   */
  presetCssUrl?: string | null;
  /** All the default values that needs to be set when the preset is selected */
  presetDefaults?: PresetElementDefaults;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
  /**
   * A description of this preset
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface ComponentInitialSize {
  /** The component initial width setting */
  width?: InitialSizeSetting;
  /** The component initial height setting */
  height?: InitialSizeSetting;
  /**
   * The component will always keep the relationship between width and height when rendered
   * Only usable if width and height were set as 'pixels'
   */
  preserveAspectRatio?: boolean | null;
}

/** @internal */
export interface InitialSizeSetting
  extends InitialSizeSettingSelectedSizingTypeOneOf {
  /**
   * The value we should set as initial size in pixels
   * @min 1
   */
  pixels?: number;
  /** The initial size type */
  sizingType?: SizingTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface InitialSizeSettingSelectedSizingTypeOneOf {
  /**
   * The value we should set as initial size in pixels
   * @min 1
   */
  pixels?: number;
}

/** @internal */
export enum SizingType {
  UNKNOWN_SizingType = 'UNKNOWN_SizingType',
  /** Initial size should fit to the [content size](https://developer.mozilla.org/en-US/docs/Web/CSS/fit-content) */
  content = 'content',
  /** Initial size should stretch to the parent size and will keep tracking it unless a user changes it */
  stretched = 'stretched',
  /** Initial size should be set in pixels */
  pixels = 'pixels',
}

/** @enumType */
/** @internal */
export type SizingTypeWithLiterals =
  | SizingType
  | 'UNKNOWN_SizingType'
  | 'content'
  | 'stretched'
  | 'pixels';

/** @internal */
export interface BreakpointPresetStyleOverrides {
  /** The style overrides values for the default breakpoint, which will cascade to all other breakpoints (if not overridden) */
  default?: PresetStyleOverrides;
  /** The style overrides values for the small (mobile) breakpoint */
  small?: PresetStyleOverrides;
}

/** @internal */
export interface PresetStyleOverrides {
  /** The style overrides of inner elements for this preset */
  elements?: Record<string, ElementStyleOverrides>;
  /** The default values for the element css-properties when the preset is selected */
  cssProperties?: Record<string, PresetStyleItemOverrides>;
  /** The default values for the element css-custom-properties when the preset is selected */
  cssCustomProperties?: Record<string, PresetStyleItemOverrides>;
}

/** @internal */
export interface ElementStyleOverrides {
  /**
   * The override preset for an element
   * @maxLength 100
   */
  presetKey?: string | null;
  /** The override preset and styles for inner elements */
  elements?: Record<string, ElementStyleOverrides>;
  /** The default values for the element css-properties when the preset is selected */
  cssProperties?: Record<string, PresetStyleItemOverrides>;
  /** The default values for the element css-custom-properties when the preset is selected */
  cssCustomProperties?: Record<string, PresetStyleItemOverrides>;
}

/** @internal */
export interface PresetStyleItemOverrides {
  /** The override value of this style item */
  value?: any;
  /** The override values for the style item when the component is in one of the defined states */
  statesValues?: Record<string, any>;
}

/** @internal */
export enum BreakpointEnumBreakpoint {
  UNKNOWN_Breakpoint = 'UNKNOWN_Breakpoint',
  /** Represents the small (mobile) breakpoint */
  small = 'small',
  /** Represents the large (desktop) breakpoint */
  large = 'large',
}

/** @enumType */
/** @internal */
export type BreakpointEnumBreakpointWithLiterals =
  | BreakpointEnumBreakpoint
  | 'UNKNOWN_Breakpoint'
  | 'small'
  | 'large';

/** @internal */
export interface PresetElementDefaults {
  /**
   * The element display name when the preset is selected
   * @maxLength 100
   */
  displayName?: string | null;
  /** The default values for the element css-properties when the preset is selected */
  cssProperties?: Record<string, CssPropertyItemDefaults>;
  /** The default values for the element css-custom-properties when the preset is selected */
  cssCustomProperties?: Record<string, CssPropertyItemDefaults>;
  /** The default styles for the inner elements when the preset is selected */
  elements?: Record<string, PresetInnerElementDefaults>;
  /** Optional editor layout behaviors we want to apply when this preset is selected */
  layout?: EditorElementLayout;
  /**
   * Display filters for the Preset, used to define the visibility of inner / ref elements, style items, data items and custom actions in the editor
   * The Preset is the second in line to affect the display, Element is before and State is after it
   */
  displayFilters?: DisplayFilters;
  /**
   * A description of the element when this preset is selected
   * @maxLength 300
   */
  description?: string | null;
  /**
   * Optional per-preset layout overrides for containers in this element's data scope, keyed by the container's data-item key.
   * Each key must reference a data item of type 'container' in the same scope. Any field left unset on the
   * ContainerLayout falls back to the container's own declared layout.
   */
  containers?: Record<string, ContainerLayout>;
}

/** @internal */
export interface CssPropertyItemDefaults {
  /** The default value of this css-property-item */
  defaultValue?: any;
  /** The default values for the css-property-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
}

/** @internal */
export interface PresetInnerElementDefaults {
  /** The default values for the element css-properties */
  cssProperties?: Record<string, CssPropertyItemDefaults>;
  /** The default values for the element css-custom-properties */
  cssCustomProperties?: Record<string, CssPropertyItemDefaults>;
  /** The default preset and styles for inner elements */
  elements?: Record<string, PresetInnerElementDefaults>;
  /**
   * Optional per-preset layout overrides for containers in this element's data scope, keyed by the container's data-item key.
   * Each key must reference a data item of type 'container' in this element's scope. Any field left unset on the
   * ContainerLayout falls back to the container's own declared layout.
   */
  containers?: Record<string, ContainerLayout>;
}

/** Top-level message containing all layout capabilities */
/** @internal */
export interface EditorElementLayout {
  /** The resizing capabilities this component can supports */
  resizeDirection?: ResizeDirectionWithLiterals;
  /** Describes the ability of content to impact on the size of this component */
  contentResizeDirection?: ContentResizeDirectionWithLiterals;
  /** Will control the availability of the stretch capability for this component */
  disableStretching?: boolean | null;
  /** Will control the availability of freely positioning this component */
  disablePositioning?: boolean | null;
  /** Will control if the editor allows rotating the element */
  disableRotation?: boolean | null;
  /** Information related to content that fills the whole component visible space */
  contentFill?: ContentFill;
  /** Will control the availability of the duplicate capability for this component */
  disableDuplication?: boolean | null;
}

/** @internal */
export interface ContentFill {
  /**
   * The key of the data-item that holds the content that fills the whole component visible space, using this will provide a better layout experiences for such components
   * Restricted to data-items that hold specific data-types: "image", "video", "vectorArt", "container"
   * @maxLength 100
   */
  dataItemKey?: string | null;
}

/**
 * DisplayFilters is a collection of display filters that can be used to hide or show elements in the editor.
 * It is used to control the visibility of elements in the editor.
 * It is used to control the visibility of style items of elements in the editor.
 * It is used to control the visibility of data items of elements in the editor.
 * It is used to control the visibility of custom actions of elements in the editor.
 * The logical order of filtering is done from where the filter is defined.
 * Element takes first priority in narrowing the list, then the Preset and last is the State
 */
/** @internal */
export interface DisplayFilters {
  /** DisplayFilter for elements, defines which elements to hide or show, uses the element key in the elements map, optional */
  elements?: DisplayFilter;
  /** DisplayFilter for data, defines which data items to hide or show, uses the dataItem key in the data map, optional */
  data?: DisplayFilter;
  /** DisplayFilter for custom actions, defines which custom actions to hide or show, uses the customAction key in the customActions map, optional */
  customActions?: DisplayFilter;
  /** DisplayFilter for actions, defines which actions to hide or show, uses the key in the action map, optional */
  actions?: DisplayFilter;
  /** DisplayFilter for css-properties, defines which properties to hide or show in the editor, uses the css-property name, optional */
  cssProperties?: DisplayFilter;
  /** DisplayFilter for css-custom-properties, defines which css-custom-properties to hide or show in the editor, uses the key in the css-custom-properties map, optional */
  cssCustomProperties?: DisplayFilter;
  /** DisplayFilter for states, defines which states to hide or show, uses the state key in the states map, optional */
  states?: DisplayFilter;
  /** DisplayFilter for presets, defines which presets to hide or show, uses the preset key in the presets map, optional */
  presets?: DisplayFilter;
}

/**
 * The logic of the display filter is to define the minimal requirement
 * You can only provide one of the two fields, `hide` or `show`, but not both.
 * hide: *All items* not listed here will be shown by the editor. Useful for hiding a small list of items
 * show: *Only items* listed here will be show by the editor. Useful for hiding a large list of items
 */
/** @internal */
export interface DisplayFilter {
  /**
   * Selected items to hide
   * @maxSize 100
   * @maxLength 80
   */
  hide?: string[];
  /**
   * Selected items to show
   * @maxSize 100
   * @maxLength 80
   */
  show?: string[];
}

/** @internal */
export enum Archetype {
  UNKNOWN_Archetype = 'UNKNOWN_Archetype',
  Button = 'Button',
  LoginButton = 'LoginButton',
  Image = 'Image',
  Gallery = 'Gallery',
  Video = 'Video',
  Audio = 'Audio',
  Text = 'Text',
  TextInput = 'TextInput',
  RichTextEditor = 'RichTextEditor',
  SignatureInput = 'SignatureInput',
  Checkbox = 'Checkbox',
  RadioGroup = 'RadioGroup',
  Switch = 'Switch',
  Dropdown = 'Dropdown',
  DatePicker = 'DatePicker',
  TimePicker = 'TimePicker',
  Ratings = 'Ratings',
  RatingInput = 'RatingInput',
  Menu = 'Menu',
  Pagination = 'Pagination',
  Slider = 'Slider',
  Container = 'Container',
  Carousel = 'Carousel',
  Accordion = 'Accordion',
  Tabs = 'Tabs',
  ProgressBar = 'ProgressBar',
  Upload = 'Upload',
  Social = 'Social',
  Breadcrumbs = 'Breadcrumbs',
  SearchBox = 'SearchBox',
  Map = 'Map',
  Line = 'Line',
  Logo = 'Logo',
  Avatar = 'Avatar',
  Captcha = 'Captcha',
  VectorArt = 'VectorArt',
  AnimatedGraphic = 'AnimatedGraphic',
  Cart = 'Cart',
  ContactForm = 'ContactForm',
  Frame = 'Frame',
  Divider = 'Divider',
}

/** @enumType */
/** @internal */
export type ArchetypeWithLiterals =
  | Archetype
  | 'UNKNOWN_Archetype'
  | 'Button'
  | 'LoginButton'
  | 'Image'
  | 'Gallery'
  | 'Video'
  | 'Audio'
  | 'Text'
  | 'TextInput'
  | 'RichTextEditor'
  | 'SignatureInput'
  | 'Checkbox'
  | 'RadioGroup'
  | 'Switch'
  | 'Dropdown'
  | 'DatePicker'
  | 'TimePicker'
  | 'Ratings'
  | 'RatingInput'
  | 'Menu'
  | 'Pagination'
  | 'Slider'
  | 'Container'
  | 'Carousel'
  | 'Accordion'
  | 'Tabs'
  | 'ProgressBar'
  | 'Upload'
  | 'Social'
  | 'Breadcrumbs'
  | 'SearchBox'
  | 'Map'
  | 'Line'
  | 'Logo'
  | 'Avatar'
  | 'Captcha'
  | 'VectorArt'
  | 'AnimatedGraphic'
  | 'Cart'
  | 'ContactForm'
  | 'Frame'
  | 'Divider';

/** @internal */
export interface ElementState {
  /**
   * Display name of this state
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * The class-name to apply when this state is applied
   * @maxLength 100
   */
  className?: string | null;
  /** The pseudo-class to used to target this state in the browser */
  pseudoClass?: NativeStateTypeWithLiterals;
  /** The state props to apply when this state is applied */
  props?: Record<string, any>;
  /**
   * Display filters for the state, used to define the visibility of inner / ref elements, style items, data items and custom actions in the editor
   * The state is the last item to affect the display, Element and Preset are before it
   */
  displayFilters?: DisplayFilters;
  /** The element that needs to be targeted when this state is applied */
  target?: TargetElement;
  /**
   * A description of this state
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export enum NativeStateType {
  UNKNOWN_NativeStateType = 'UNKNOWN_NativeStateType',
  /** native browser "hover" state */
  hover = 'hover',
  /** native browser "focus" state */
  focus = 'focus',
  /** native browser "disabled" state */
  disabled = 'disabled',
  /** native browser "invalid" state */
  invalid = 'invalid',
}

/** @enumType */
/** @internal */
export type NativeStateTypeWithLiterals =
  | NativeStateType
  | 'UNKNOWN_NativeStateType'
  | 'hover'
  | 'focus'
  | 'disabled'
  | 'invalid';

/** @internal */
export interface TargetElement {
  /**
   * The path to the element that needs to be targeted when this state is applied.
   * @minLength 1
   * @maxLength 500
   */
  elementPath?: string;
}

/** @internal */
export interface VisibleState {
  /**
   * The key of the state that will trigger the visibility of this element
   * @minLength 1
   * @maxLength 100
   */
  stateKey?: string;
  /**
   * The path to the element that owns the relevant state to trigger, path pattern "/elementkey/elementkey"
   * @minLength 1
   * @maxLength 500
   */
  elementPath?: string;
}

/** @internal */
export interface DisplayGroupItem
  extends DisplayGroupItemSelectedGroupTypeOneOf {
  /** A group that contains cssCustomProperties items that used one of the supported css-data-types (length, angle, number, ..._) */
  cssDataType?: ItemsGroup;
  /** A group that contains data items, should be used for grouping and ordering purposes in the editor */
  data?: ItemsGroup;
  /** A group that contains preset items, which will be displayed in the editor as a category in the presets panel */
  presets?: ItemsGroup;
  /** A group that contains cssCustomProperties items that use the same cssPropertyType, should be used for grouping and ordering purposes */
  cssCustomProperties?: ItemsGroup;
  /** A group that contains other displayGroups items that use the same groupType, should be used for ordering purposes */
  displayGroups?: ItemsGroup;
  /** A group that contains elements that belong to the current element in the component, array order defines the display order to the elements in panels. Each item is the element name. */
  elements?: ItemsGroup;
  /** A group that contains background items */
  background?: ShorthandGroupBackground;
  /** A group that contains margin items */
  margin?: Coordinates;
  /** A group that contains padding items */
  padding?: Coordinates;
  /** A group that contains border items */
  border?: Border;
  /** A group that contains border-top items */
  borderTop?: Border;
  /** A group that contains border-right items */
  borderRight?: Border;
  /** A group that contains border-bottom items */
  borderBottom?: Border;
  /** A group that contains border-left items */
  borderLeft?: Border;
  /** A group that contains border-inline-start items */
  borderInlineStart?: Border;
  /** A group that contains border-inline-end items */
  borderInlineEnd?: Border;
  /** A group that contains border-radius items */
  borderRadius?: Corners;
  /** A group that contains font items */
  font?: Font;
  /** A group that contains text-decoration items */
  textDecoration?: TextDecoration;
  /** A group that contains gap items */
  gap?: Gap;
  /** A group that contains border-color items */
  borderColor?: Coordinates;
  /** A group that contains border-width items */
  borderWidth?: Coordinates;
  /** A group that contains border-style items */
  borderStyle?: Coordinates;
  /** a group that contains items related to text */
  text?: TextGroup;
  /** A group that contains data-items related to arrayItems, will be used for enhancing the editor experience when editing them */
  arrayItems?: DataGroupsArrayItems;
  /** A group that contains common data-items that are used within array-item objects, will be used for enhancing the editor experience when editing them */
  listItem?: ListItem;
  /**
   * Display name for this Group
   * @maxLength 20
   */
  displayName?: string | null;
  /** The type of the group, used to determine the group that will be displayed in the editor */
  groupType?: GroupTypeWithLiterals;
  /**
   * A description of this Group
   * @maxLength 300
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface DisplayGroupItemSelectedGroupTypeOneOf {
  /** A group that contains cssCustomProperties items that used one of the supported css-data-types (length, angle, number, ..._) */
  cssDataType?: ItemsGroup;
  /** A group that contains data items, should be used for grouping and ordering purposes in the editor */
  data?: ItemsGroup;
  /** A group that contains preset items, which will be displayed in the editor as a category in the presets panel */
  presets?: ItemsGroup;
  /** A group that contains cssCustomProperties items that use the same cssPropertyType, should be used for grouping and ordering purposes */
  cssCustomProperties?: ItemsGroup;
  /** A group that contains other displayGroups items that use the same groupType, should be used for ordering purposes */
  displayGroups?: ItemsGroup;
  /** A group that contains elements that belong to the current element in the component, array order defines the display order to the elements in panels. Each item is the element name. */
  elements?: ItemsGroup;
  /** A group that contains background items */
  background?: ShorthandGroupBackground;
  /** A group that contains margin items */
  margin?: Coordinates;
  /** A group that contains padding items */
  padding?: Coordinates;
  /** A group that contains border items */
  border?: Border;
  /** A group that contains border-top items */
  borderTop?: Border;
  /** A group that contains border-right items */
  borderRight?: Border;
  /** A group that contains border-bottom items */
  borderBottom?: Border;
  /** A group that contains border-left items */
  borderLeft?: Border;
  /** A group that contains border-inline-start items */
  borderInlineStart?: Border;
  /** A group that contains border-inline-end items */
  borderInlineEnd?: Border;
  /** A group that contains border-radius items */
  borderRadius?: Corners;
  /** A group that contains font items */
  font?: Font;
  /** A group that contains text-decoration items */
  textDecoration?: TextDecoration;
  /** A group that contains gap items */
  gap?: Gap;
  /** A group that contains border-color items */
  borderColor?: Coordinates;
  /** A group that contains border-width items */
  borderWidth?: Coordinates;
  /** A group that contains border-style items */
  borderStyle?: Coordinates;
  /** a group that contains items related to text */
  text?: TextGroup;
  /** A group that contains data-items related to arrayItems, will be used for enhancing the editor experience when editing them */
  arrayItems?: DataGroupsArrayItems;
  /** A group that contains common data-items that are used within array-item objects, will be used for enhancing the editor experience when editing them */
  listItem?: ListItem;
}

/** @internal */
export enum GroupType {
  UNKNOWN_GroupType = 'UNKNOWN_GroupType',
  cssDataType = 'cssDataType',
  /** Deprecated, use `data` instead; */
  dataType = 'dataType',
  /** Deprecated, use `presets` instead */
  preset = 'preset',
  data = 'data',
  presets = 'presets',
  cssCustomProperties = 'cssCustomProperties',
  displayGroups = 'displayGroups',
  elements = 'elements',
  /** Style Shorthand Groups */
  background = 'background',
  margin = 'margin',
  padding = 'padding',
  border = 'border',
  borderTop = 'borderTop',
  borderRight = 'borderRight',
  borderBottom = 'borderBottom',
  borderLeft = 'borderLeft',
  borderRadius = 'borderRadius',
  borderInlineStart = 'borderInlineStart',
  borderInlineEnd = 'borderInlineEnd',
  borderColor = 'borderColor',
  borderWidth = 'borderWidth',
  borderStyle = 'borderStyle',
  font = 'font',
  textDecoration = 'textDecoration',
  gap = 'gap',
  /** Mixed Variables Groups */
  text = 'text',
  /** Data Groups */
  arrayItems = 'arrayItems',
  /** Deprecated, use `listItem` instead */
  arrayItem = 'arrayItem',
  listItem = 'listItem',
}

/** @enumType */
/** @internal */
export type GroupTypeWithLiterals =
  | GroupType
  | 'UNKNOWN_GroupType'
  | 'cssDataType'
  | 'dataType'
  | 'preset'
  | 'data'
  | 'presets'
  | 'cssCustomProperties'
  | 'displayGroups'
  | 'elements'
  | 'background'
  | 'margin'
  | 'padding'
  | 'border'
  | 'borderTop'
  | 'borderRight'
  | 'borderBottom'
  | 'borderLeft'
  | 'borderRadius'
  | 'borderInlineStart'
  | 'borderInlineEnd'
  | 'borderColor'
  | 'borderWidth'
  | 'borderStyle'
  | 'font'
  | 'textDecoration'
  | 'gap'
  | 'text'
  | 'arrayItems'
  | 'arrayItem'
  | 'listItem';

/** @internal */
export interface ItemsGroup {
  /**
   * A list of items that should be in this group
   * @maxSize 300
   * @maxLength 100
   */
  items?: string[];
}

/** @internal */
export interface ShorthandGroupBackground {
  /**
   * Stores the background-color property of the background shorthand
   * @maxLength 100
   */
  backgroundColor?: string | null;
  /**
   * Stores the background-image property of the background shorthand
   * @maxLength 100
   */
  backgroundImage?: string | null;
  /**
   * Stores the background-position property of the background shorthand
   * @maxLength 100
   */
  backgroundPosition?: string | null;
  /**
   * Stores the background-size property of the background shorthand
   * @maxLength 100
   */
  backgroundSize?: string | null;
  /**
   * Stores the background-repeat property of the background shorthand
   * @maxLength 100
   */
  backgroundRepeat?: string | null;
  /**
   * Stores the background-origin property of the background shorthand
   * @maxLength 100
   */
  backgroundOrigin?: string | null;
  /**
   * Stores the background-clip property of the background shorthand
   * @maxLength 100
   */
  backgroundClip?: string | null;
  /**
   * Stores the background shorthand item itself, should be used when you want to achieve with this group partial editing of the background shorthand
   * @maxLength 100
   */
  background?: string | null;
}

/** @internal */
export interface Coordinates {
  /**
   * Stores the top coordinate of the property shorthand
   * @maxLength 100
   */
  top?: string | null;
  /**
   * Stores the right coordinate of the property shorthand
   * @maxLength 100
   */
  right?: string | null;
  /**
   * Stores the bottom coordinate of the property shorthand
   * @maxLength 100
   */
  bottom?: string | null;
  /**
   * Stores the left coordinate of the property shorthand
   * @maxLength 100
   */
  left?: string | null;
  /**
   * Stores the coordinates item of this shorthand
   * @maxLength 100
   */
  sides?: string | null;
}

/** @internal */
export interface Border {
  /**
   * Stores the width property of a border shorthand
   * @maxLength 100
   */
  width?: string | null;
  /**
   * Stores the style property of a border shorthand
   * @maxLength 100
   */
  style?: string | null;
  /**
   * Stores the color property of a border shorthand
   * @maxLength 100
   */
  color?: string | null;
  /**
   * Stores the border shorthand item itself, should be used when you want to achieve with this group partial editing of the border shorthand
   * @maxLength 100
   */
  border?: string | null;
}

/** @internal */
export interface Corners {
  /**
   * Stores the top-left property of the shorthand
   * @maxLength 100
   */
  topLeft?: string | null;
  /**
   * Stores the top-right property of the shorthand
   * @maxLength 100
   */
  topRight?: string | null;
  /**
   * Stores the bottom-right property of the shorthand
   * @maxLength 100
   */
  bottomRight?: string | null;
  /**
   * Stores the bottom-left property of the shorthand
   * @maxLength 100
   */
  bottomLeft?: string | null;
  /**
   * Stores the corners item of this shorthand
   * @maxLength 100
   */
  corners?: string | null;
}

/** @internal */
export interface Font {
  /**
   * Stores the font-style property of the font shorthand
   * @maxLength 100
   */
  fontStyle?: string | null;
  /**
   * Stores the font-variant property of the font shorthand
   * @maxLength 100
   */
  fontVariant?: string | null;
  /**
   * Stores the font-weight property of the font shorthand
   * @maxLength 100
   */
  fontWeight?: string | null;
  /**
   * Stores the font-size property of the font shorthand
   * @maxLength 100
   */
  fontSize?: string | null;
  /**
   * Stores the line-height property of the font shorthand
   * @maxLength 100
   */
  lineHeight?: string | null;
  /**
   * Stores the font-family property of the font shorthand
   * @maxLength 100
   */
  fontFamily?: string | null;
  /**
   * Stores the font shorthand item itself, should be used when you want to achieve with this group partial editing of the font shorthand
   * @maxLength 100
   */
  font?: string | null;
}

/** @internal */
export interface TextDecoration {
  /**
   * Stores the text-decoration-line property of the text-decoration shorthand
   * @maxLength 100
   */
  textDecorationLine?: string | null;
  /**
   * Stores the text-decoration-color property of the text-decoration shorthand
   * @maxLength 100
   */
  textDecorationColor?: string | null;
  /**
   * Stores the text-decoration-style property of the text-decoration shorthand
   * @maxLength 100
   */
  textDecorationStyle?: string | null;
  /**
   * Stores the text-decoration-thickness property of the text-decoration shorthand
   * @maxLength 100
   */
  textDecorationThickness?: string | null;
  /**
   * Stores the textDecoration shorthand item itself, should be used when you want to achieve with this group partial editing of the textDecoration shorthand
   * @maxLength 100
   */
  textDecoration?: string | null;
}

/** @internal */
export interface Gap {
  /**
   * Stores the row-gap property of the gap shorthand
   * @maxLength 100
   */
  rowGap?: string | null;
  /**
   * Stores the column-gap property of the gap shorthand
   * @maxLength 100
   */
  columnGap?: string | null;
  /**
   * Stores the gap shorthand item itself, should be used when you want to achieve with this group partial editing of the gap shorthand
   * @maxLength 100
   */
  gap?: string | null;
}

/** @internal */
export interface TextGroup {
  /**
   * Stores the font shorthand item itself, should be used when you want to achieve with this group partial editing of the font shorthand
   * @maxLength 100
   */
  font?: string | null;
  /**
   * Stores the font-style property for this text group
   * @maxLength 100
   */
  fontStyle?: string | null;
  /**
   * Stores the font-variant property for this text group
   * @maxLength 100
   */
  fontVariant?: string | null;
  /**
   * Stores the font-weight property of the font shorthand
   * @maxLength 100
   */
  fontWeight?: string | null;
  /**
   * Stores the font-size property for this text group
   * @maxLength 100
   */
  fontSize?: string | null;
  /**
   * Stores the line-height property for this text group
   * @maxLength 100
   */
  lineHeight?: string | null;
  /**
   * Stores the font-family property for this text group
   * @maxLength 100
   */
  fontFamily?: string | null;
  /**
   * Stores the color property for this text group
   * @maxLength 100
   */
  color?: string | null;
  /**
   * Stores the letter-spacing property for this text group
   * @maxLength 100
   */
  letterSpacing?: string | null;
  /**
   * Stores the text-align property for this text group
   * @maxLength 100
   */
  textAlign?: string | null;
  /**
   * Stores the text-transform property for this text group
   * @maxLength 100
   */
  textTransform?: string | null;
  /**
   * Stores the text-shadow property for this text group
   * @maxLength 100
   */
  textShadow?: string | null;
  /**
   * Stores the text-decoration-line property for this text group
   * @maxLength 100
   */
  textDecorationLine?: string | null;
  /**
   * Stores the writing-mode property for this text group
   * @maxLength 100
   */
  writingMode?: string | null;
  /**
   * Stores the direction data-item for this text group
   * @maxLength 100
   */
  direction?: string | null;
  /**
   * Stores the a11y data-item for this text group
   * @maxLength 100
   */
  a11y?: string | null;
}

/** @internal */
export interface DataGroupsArrayItems {
  /**
   * Stores the name of the 'arrayItems'
   * @maxLength 100
   */
  arrayItems?: string | null;
  /**
   * Stores the data-item of the currently selected index within the array items
   * @maxLength 100
   */
  selectedItemIndex?: string | null;
  /** Stores whether the editor should allow no selection of these array items, and the selected index passed to the component will be undefined in that case */
  allowNoSelection?: boolean | null;
}

/** @internal */
export interface ListItem {
  /**
   * Stores the name of the 'arrayItems' that stores the list of items
   * @maxLength 100
   */
  arrayItems?: string | null;
  /**
   * Stores the key of the 'text' data-item that will be used for label of this list-item
   * @maxLength 100
   */
  label?: string | null;
  /**
   * Stores the key of the 'text', 'link' or 'webUrl' data-item that will be used for subtitle of this list-item
   * @maxLength 100
   */
  subtitle?: string | null;
  /**
   * Stores the key of the 'vectorArt' or 'image' data-item that will be used for thumbnail of this list-item
   * @maxLength 100
   */
  thumbnail?: string | null;
}

/** @internal */
export interface CssPropertyItem
  extends CssPropertyItemSelectedCssPropertyTypeOneOf {
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
  /** Additional options to refine the background-image variable */
  backgroundImage?: BackgroundImage;
  /** Additional options to refine the mask-image variable */
  maskImage?: MaskImage;
  /**
   * Will be used as displayName of this css-property-item
   * @maxLength 100
   */
  displayName?: string | null;
  /** The default value for the css-property-item when the component is in the "regular" state */
  defaultValue?: any;
  /** The default values for the css-property-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
  /**
   * Determines if this css-property is deprecated (for internal use only)
   * @internal
   */
  deprecated?: boolean | null;
  /**
   * A description of this css-property-item
   * @maxLength 300
   */
  description?: string | null;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
}

/** @oneof */
/** @internal */
export interface CssPropertyItemSelectedCssPropertyTypeOneOf {
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
  /** Additional options to refine the background-image variable */
  backgroundImage?: BackgroundImage;
  /** Additional options to refine the mask-image variable */
  maskImage?: MaskImage;
}

/** @internal */
export interface BackgroundImage {
  /**
   * The image types allowed for this background-image property
   * @maxSize 6
   */
  imageTypes?: ImageTypeWithLiterals[];
  /** The image media manager category to open media manager filtered by the component needs */
  imageCategory?: ImageCategoryTypesWithLiterals;
  /** The vector art media manager category to open media manager filtered by the component needs */
  vectorArtCategory?: VectorArtCategoryTypesWithLiterals;
}

/** @internal */
export enum ImageType {
  UNKNOWN_ImageType = 'UNKNOWN_ImageType',
  url = 'url',
  image = 'image',
  imageSet = 'imageSet',
  crossFade = 'crossFade',
  element = 'element',
  gradient = 'gradient',
}

/** @enumType */
/** @internal */
export type ImageTypeWithLiterals =
  | ImageType
  | 'UNKNOWN_ImageType'
  | 'url'
  | 'image'
  | 'imageSet'
  | 'crossFade'
  | 'element'
  | 'gradient';

/** @internal */
export interface MaskImage {
  /**
   * The image types allowed for this mask-image property
   * @maxSize 6
   */
  imageTypes?: ImageTypeWithLiterals[];
  /** The image media manager category to open media manager filtered by the component needs */
  imageCategory?: ImageCategoryTypesWithLiterals;
  /** The vector art media manager category to open media manager filtered by the component needs */
  vectorArtCategory?: VectorArtCategoryTypesWithLiterals;
}

/** @internal */
export interface CssCustomPropertyItem
  extends CssCustomPropertyItemSelectedCssPropertyTypeOneOf {
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
  /** Additional options to refine the background-image variable */
  backgroundImage?: BackgroundImage;
  /** Additional options to refine the mask-image variable */
  maskImage?: MaskImage;
  /** Additional options to refine the customEnum item */
  customEnum?: CustomPropertyEnum;
  /** Additional options to refine the number item */
  number?: CssNumber;
  /**
   * The type of the value this css-custom-property will store, can be either
   * [CSS properties](https://developer.mozilla.org/en-US/docs/Web/CSS/Properties) or
   * [CSS data types](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Values_and_Units/CSS_data_types) in Javascript naming format
   */
  cssPropertyType?: CssPropertyTypeWithLiterals;
  /**
   * Determines if this css-custom-property is deprecated (for internal use only)
   * @internal
   */
  deprecated?: boolean | null;
  /**
   * Will be used as displayName of this css-property-item
   * @maxLength 100
   */
  displayName?: string | null;
  /** The default value for the css-property-item when the component is in the "regular" state */
  defaultValue?: any;
  /** The default values for the css-property-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
  /**
   * A description of this css-custom-property-item
   * @maxLength 300
   */
  description?: string | null;
  /**
   * Internal experiment spec definition to define if this message is not deleted, used by centralized conduction, limited to 5 per component. If the experiment value will be false, whole node is deleted. Applied in Editor and AI flows only. Spec names must begin with the scope prefix sp.erc. (e.g. sp.erc.{yourExperimentName}).
   * @internal
   * @maxLength 42
   */
  spec?: string | null;
}

/** @oneof */
/** @internal */
export interface CssCustomPropertyItemSelectedCssPropertyTypeOneOf {
  /** Additional options to refine the filter variable */
  filter?: Filter;
  /** Additional options to refine the backdropFilter variable */
  backdropFilter?: BackdropFilter;
  /** Additional options to refine the display variable */
  display?: Display;
  /** Additional options to refine the writingMode variable */
  writingMode?: WritingMode;
  /** Additional options to refine the background variable */
  background?: Background;
  /** Additional options to refine the background-image variable */
  backgroundImage?: BackgroundImage;
  /** Additional options to refine the mask-image variable */
  maskImage?: MaskImage;
  /** Additional options to refine the customEnum item */
  customEnum?: CustomPropertyEnum;
  /** Additional options to refine the number item */
  number?: CssNumber;
}

/**
 * The supported [CSS Property Types & CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) and
 * [CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Values_and_Units/CSS_data_types) in Javascript naming format
 */
/** @internal */
export enum CssPropertyType {
  UNKNOWN_CssPropertyType = 'UNKNOWN_CssPropertyType',
  /** css-data-types */
  number = 'number',
  string = 'string',
  angle = 'angle',
  length = 'length',
  percentage = 'percentage',
  lengthPercentage = 'lengthPercentage',
  blendMode = 'blendMode',
  customEnum = 'customEnum',
  time = 'time',
  /** background properties */
  background = 'background',
  backgroundSize = 'backgroundSize',
  backgroundColor = 'backgroundColor',
  backgroundImage = 'backgroundImage',
  backgroundClip = 'backgroundClip',
  backgroundOrigin = 'backgroundOrigin',
  backgroundPosition = 'backgroundPosition',
  backgroundRepeat = 'backgroundRepeat',
  backgroundAttachment = 'backgroundAttachment',
  /** margin properties */
  margin = 'margin',
  marginTop = 'marginTop',
  marginRight = 'marginRight',
  marginBottom = 'marginBottom',
  marginLeft = 'marginLeft',
  marginInlineStart = 'marginInlineStart',
  marginInlineEnd = 'marginInlineEnd',
  /** padding properties */
  padding = 'padding',
  paddingTop = 'paddingTop',
  paddingRight = 'paddingRight',
  paddingBottom = 'paddingBottom',
  paddingLeft = 'paddingLeft',
  paddingInlineStart = 'paddingInlineStart',
  paddingInlineEnd = 'paddingInlineEnd',
  /** border properties */
  border = 'border',
  borderWidth = 'borderWidth',
  borderStyle = 'borderStyle',
  borderColor = 'borderColor',
  borderTop = 'borderTop',
  borderTopColor = 'borderTopColor',
  borderTopWidth = 'borderTopWidth',
  borderTopStyle = 'borderTopStyle',
  borderRight = 'borderRight',
  borderRightColor = 'borderRightColor',
  borderRightWidth = 'borderRightWidth',
  borderRightStyle = 'borderRightStyle',
  borderBottom = 'borderBottom',
  borderBottomColor = 'borderBottomColor',
  borderBottomWidth = 'borderBottomWidth',
  borderBottomStyle = 'borderBottomStyle',
  borderLeft = 'borderLeft',
  borderLeftColor = 'borderLeftColor',
  borderLeftWidth = 'borderLeftWidth',
  borderLeftStyle = 'borderLeftStyle',
  borderInlineStart = 'borderInlineStart',
  borderInlineStartColor = 'borderInlineStartColor',
  borderInlineStartWidth = 'borderInlineStartWidth',
  borderInlineStartStyle = 'borderInlineStartStyle',
  borderInlineEnd = 'borderInlineEnd',
  borderInlineEndColor = 'borderInlineEndColor',
  borderInlineEndWidth = 'borderInlineEndWidth',
  borderInlineEndStyle = 'borderInlineEndStyle',
  /** border-radius properties */
  borderRadius = 'borderRadius',
  borderTopLeftRadius = 'borderTopLeftRadius',
  borderTopRightRadius = 'borderTopRightRadius',
  borderBottomRightRadius = 'borderBottomRightRadius',
  borderBottomLeftRadius = 'borderBottomLeftRadius',
  borderStartStartRadius = 'borderStartStartRadius',
  borderStartEndRadius = 'borderStartEndRadius',
  borderEndStartRadius = 'borderEndStartRadius',
  borderEndEndRadius = 'borderEndEndRadius',
  /** font properties */
  font = 'font',
  fontFamily = 'fontFamily',
  fontSize = 'fontSize',
  fontStretch = 'fontStretch',
  fontStyle = 'fontStyle',
  fontVariant = 'fontVariant',
  fontWeight = 'fontWeight',
  lineHeight = 'lineHeight',
  /** text properties */
  color = 'color',
  letterSpacing = 'letterSpacing',
  writingMode = 'writingMode',
  textAlign = 'textAlign',
  textTransform = 'textTransform',
  textShadow = 'textShadow',
  textOverflow = 'textOverflow',
  textIndent = 'textIndent',
  /** text-decoration properties */
  textDecoration = 'textDecoration',
  textDecorationColor = 'textDecorationColor',
  textDecorationLine = 'textDecorationLine',
  textDecorationStyle = 'textDecorationStyle',
  textDecorationThickness = 'textDecorationThickness',
  /** box related properties */
  boxShadow = 'boxShadow',
  opacity = 'opacity',
  overflow = 'overflow',
  /** layout properties */
  display = 'display',
  alignSelf = 'alignSelf',
  justifyContent = 'justifyContent',
  alignItems = 'alignItems',
  flexDirection = 'flexDirection',
  height = 'height',
  width = 'width',
  gap = 'gap',
  columnGap = 'columnGap',
  rowGap = 'rowGap',
  /** filters */
  filter = 'filter',
  backdropFilter = 'backdropFilter',
  /** media sizing & alignment */
  objectFit = 'objectFit',
  objectPosition = 'objectPosition',
  /** blending & compositing */
  mixBlendMode = 'mixBlendMode',
  isolation = 'isolation',
  /** stroke properties */
  stroke = 'stroke',
  strokeWidth = 'strokeWidth',
  strokeOpacity = 'strokeOpacity',
  /** fill properties */
  fill = 'fill',
  fillOpacity = 'fillOpacity',
  fillRule = 'fillRule',
  /** mask properties */
  mask = 'mask',
  maskImage = 'maskImage',
  maskMode = 'maskMode',
  maskRepeat = 'maskRepeat',
  maskPosition = 'maskPosition',
  maskClip = 'maskClip',
  maskOrigin = 'maskOrigin',
  maskSize = 'maskSize',
  maskComposite = 'maskComposite',
}

/** @enumType */
/** @internal */
export type CssPropertyTypeWithLiterals =
  | CssPropertyType
  | 'UNKNOWN_CssPropertyType'
  | 'number'
  | 'string'
  | 'angle'
  | 'length'
  | 'percentage'
  | 'lengthPercentage'
  | 'blendMode'
  | 'customEnum'
  | 'time'
  | 'background'
  | 'backgroundSize'
  | 'backgroundColor'
  | 'backgroundImage'
  | 'backgroundClip'
  | 'backgroundOrigin'
  | 'backgroundPosition'
  | 'backgroundRepeat'
  | 'backgroundAttachment'
  | 'margin'
  | 'marginTop'
  | 'marginRight'
  | 'marginBottom'
  | 'marginLeft'
  | 'marginInlineStart'
  | 'marginInlineEnd'
  | 'padding'
  | 'paddingTop'
  | 'paddingRight'
  | 'paddingBottom'
  | 'paddingLeft'
  | 'paddingInlineStart'
  | 'paddingInlineEnd'
  | 'border'
  | 'borderWidth'
  | 'borderStyle'
  | 'borderColor'
  | 'borderTop'
  | 'borderTopColor'
  | 'borderTopWidth'
  | 'borderTopStyle'
  | 'borderRight'
  | 'borderRightColor'
  | 'borderRightWidth'
  | 'borderRightStyle'
  | 'borderBottom'
  | 'borderBottomColor'
  | 'borderBottomWidth'
  | 'borderBottomStyle'
  | 'borderLeft'
  | 'borderLeftColor'
  | 'borderLeftWidth'
  | 'borderLeftStyle'
  | 'borderInlineStart'
  | 'borderInlineStartColor'
  | 'borderInlineStartWidth'
  | 'borderInlineStartStyle'
  | 'borderInlineEnd'
  | 'borderInlineEndColor'
  | 'borderInlineEndWidth'
  | 'borderInlineEndStyle'
  | 'borderRadius'
  | 'borderTopLeftRadius'
  | 'borderTopRightRadius'
  | 'borderBottomRightRadius'
  | 'borderBottomLeftRadius'
  | 'borderStartStartRadius'
  | 'borderStartEndRadius'
  | 'borderEndStartRadius'
  | 'borderEndEndRadius'
  | 'font'
  | 'fontFamily'
  | 'fontSize'
  | 'fontStretch'
  | 'fontStyle'
  | 'fontVariant'
  | 'fontWeight'
  | 'lineHeight'
  | 'color'
  | 'letterSpacing'
  | 'writingMode'
  | 'textAlign'
  | 'textTransform'
  | 'textShadow'
  | 'textOverflow'
  | 'textIndent'
  | 'textDecoration'
  | 'textDecorationColor'
  | 'textDecorationLine'
  | 'textDecorationStyle'
  | 'textDecorationThickness'
  | 'boxShadow'
  | 'opacity'
  | 'overflow'
  | 'display'
  | 'alignSelf'
  | 'justifyContent'
  | 'alignItems'
  | 'flexDirection'
  | 'height'
  | 'width'
  | 'gap'
  | 'columnGap'
  | 'rowGap'
  | 'filter'
  | 'backdropFilter'
  | 'objectFit'
  | 'objectPosition'
  | 'mixBlendMode'
  | 'isolation'
  | 'stroke'
  | 'strokeWidth'
  | 'strokeOpacity'
  | 'fill'
  | 'fillOpacity'
  | 'fillRule'
  | 'mask'
  | 'maskImage'
  | 'maskMode'
  | 'maskRepeat'
  | 'maskPosition'
  | 'maskClip'
  | 'maskOrigin'
  | 'maskSize'
  | 'maskComposite';

/** @internal */
export interface CustomPropertyEnum {
  /** The type of the css-custom-property, used to define the type of the values allowed in the enum */
  cssPropertyType?: CssPropertyTypeWithLiterals;
  /**
   * The allowed value options for this custom enum
   * @maxSize 100
   */
  options?: CustomPropertyEnumOption[];
}

/** @internal */
export interface CustomPropertyEnumOption {
  /**
   * the enum value
   * @maxLength 100
   */
  value?: string;
  /**
   * Will be used as displayName of this enum option
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * the css-properties to apply when this enum value is selected [Internal use only]
   * @internal
   * @maxSize 100
   */
  appliedStyles?: CustomPropertyEnumOptionStyle[];
  /**
   * A description of this enum option
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface CustomPropertyEnumOptionStyle {
  /**
   * the css property
   * @minLength 1
   * @maxLength 100
   */
  property?: string;
  /**
   * the css value
   * @minLength 1
   * @maxLength 300
   */
  value?: string;
}

/** @internal */
export interface HelpArticle extends HelpArticleArticleTypeOneOf {
  /**
   * A knowledge base article id by Wix, the URL should be built dynamically off topology and with any additional needed keys
   * @internal
   * @maxLength 100
   */
  kbId?: string | null;
  /**
   * A URL to an external help article
   * @format WEB_URL
   */
  url?: string | null;
}

/** @oneof */
/** @internal */
export interface HelpArticleArticleTypeOneOf {
  /**
   * A knowledge base article id by Wix, the URL should be built dynamically off topology and with any additional needed keys
   * @internal
   * @maxLength 100
   */
  kbId?: string | null;
  /**
   * A URL to an external help article
   * @format WEB_URL
   */
  url?: string | null;
}

/** @internal */
export interface RefElement {
  /**
   * The type of the referenced element. Must exist in the Wix Dev Center and be fully typed (`appSlug.componentType`).
   * @minLength 4
   * @maxLength 100
   */
  type?: string;
  /**
   * The override of the used element selector, full path from root
   * @minLength 4
   * @maxLength 300
   */
  selector?: string;
  /**
   * The override of the used element displayName
   * @maxLength 50
   */
  displayName?: string;
  /** The override of the used element style */
  style?: Record<string, StyleItemOverrides>;
  /** The override of the used element data */
  data?: Record<string, DataItemOverrides>;
  /** The override of the used element behaviors */
  behaviors?: Behaviors;
  /** The override of the used element native actions */
  actions?: Actions;
  /** The override of the used element custom actions */
  customActions?: Record<string, Action>;
  /**
   * The resolved element data after merging the DEV intent
   * @internal
   */
  resolvedElement?: InlineElement;
  /** A reference to a state that needs to be triggered in order for this element to be visible */
  visibleState?: VisibleState;
  /**
   * This is where you can override the  display filter defined by the original element
   * The override is per field. So you can override: style items, data items, custom actions and elements or just some of them.
   * Any item not overridden will be inherited from the original element
   */
  displayFilters?: DisplayFilters;
  /** The default style & data for inner elements */
  elements?: Record<string, RefInnerElementDefaults>;
  /** A map of definition overrides for the css-properties that this element supports */
  cssProperties?: Record<string, CssPropertyItemDefinitionOverrides>;
  /** A map of definition overrides for the css-custom-properties that this element supports */
  cssCustomProperties?: Record<string, CssPropertyItemDefinitionOverrides>;
  /** A reference to a help article for this element */
  helpArticle?: HelpArticle;
  /**
   * The override of the used element description
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface DataItemOverrides
  extends DataItemOverridesSelectedDataTypeOneOf {
  /** Overrides the definition of what images should be supported */
  image?: ImageOverrides;
  /** Overrides the definition of what videos should be supported */
  video?: VideoOverrides;
  /** Overrides the definition of what vector arts should be supported */
  vectorArt?: VectorArtOverrides;
  /** Disables the ability to edit this data-item */
  disableEditing?: boolean | null;
  /** Overrides the default value of this data-item */
  defaultValue?: any;
  /**
   * Overrides the display name of this data-item
   * @maxLength 100
   */
  displayName?: string | null;
  /** Overrides the ability to delete this data-item value in the Editor UI */
  disableDeletion?: boolean | null;
  /**
   * Overrides the description of this data-item
   * @maxLength 300
   */
  description?: string | null;
}

/** @oneof */
/** @internal */
export interface DataItemOverridesSelectedDataTypeOneOf {
  /** Overrides the definition of what images should be supported */
  image?: ImageOverrides;
  /** Overrides the definition of what videos should be supported */
  video?: VideoOverrides;
  /** Overrides the definition of what vector arts should be supported */
  vectorArt?: VectorArtOverrides;
}

/** @internal */
export interface ImageOverrides {
  /** media manager categories to open media manager filtered by the overriding component needs */
  category?: ImageCategoryTypesWithLiterals;
}

/** @internal */
export interface VideoOverrides {
  /** media manager categories to open media manager filtered by the overriding component needs */
  category?: VideoCategoryTypesWithLiterals;
}

/** @internal */
export interface VectorArtOverrides {
  /** media manager categories to open media manager filtered by the overriding component needs */
  category?: VectorArtCategoryTypesWithLiterals;
}

/** @internal */
export interface RefInnerElementDefaults {
  /** The default data for an element */
  data?: Record<string, any>;
  /** The default preset and styles for inner elements */
  elements?: Record<string, RefInnerElementDefaults>;
  /** A map of default values for the css-properties that this element supports */
  cssProperties?: Record<string, CssPropertyItemDefaults>;
  /** A map of default values for the css-properties that this element supports */
  cssCustomProperties?: Record<string, CssPropertyItemDefaults>;
}

/** @internal */
export interface CssPropertyItemDefinitionOverrides {
  /**
   * Will be used as displayName of this css-property-item
   * @maxLength 100
   */
  displayName?: string | null;
  /** Disables the ability to edit this css-property-item */
  disableEditing?: boolean | null;
  /** The default value for the css-property-item when the component is in the "regular" state */
  defaultValue?: any;
  /** The default values for the css-property-item when the component is in one of the defined states */
  statesDefaultValues?: Record<string, any>;
  /**
   * A description of this css-property-item
   * @maxLength 300
   */
  description?: string | null;
}

/** @internal */
export interface Interactions {
  /** @maxSize 7 */
  triggers?: TriggerWithLiterals[];
  /** @maxSize 1 */
  effectGroups?: EffectGroupWithLiterals[];
}

/** @internal */
export enum Trigger {
  UNKNOWN_TRIGGER = 'UNKNOWN_TRIGGER',
  /** When a compoent is hovered */
  hover = 'hover',
  /** When a component is clicked */
  click = 'click',
  /** When the component enters the viewport */
  viewEnter = 'viewEnter',
  /** Used for infinite-loop animations - mapped to `state` type of https://drafts.csswg.org/css-animations-2/#animation-trigger-type */
  pageVisible = 'pageVisible',
  /** Mapped to native ViewTimeline */
  viewProgress = 'viewProgress',
  /** Mapped to pointermove events on the element */
  pointerMove = 'pointerMove',
  /** Mapped to animationend events */
  animationEnd = 'animationEnd',
}

/** @enumType */
/** @internal */
export type TriggerWithLiterals =
  | Trigger
  | 'UNKNOWN_TRIGGER'
  | 'hover'
  | 'click'
  | 'viewEnter'
  | 'pageVisible'
  | 'viewProgress'
  | 'pointerMove'
  | 'animationEnd';

/** @internal */
export enum EffectGroup {
  UNKNOWN_EFFECT_GROUP = 'UNKNOWN_EFFECT_GROUP',
  /** Effects that are applied to the background layer of the component */
  background = 'background',
}

/** @enumType */
/** @internal */
export type EffectGroupWithLiterals =
  | EffectGroup
  | 'UNKNOWN_EFFECT_GROUP'
  | 'background';

/** @internal */
export interface InstallationInfo extends InstallationInfoTargetContainerOneOf {
  /** Which static container should the component be installed at */
  staticContainer?: StaticContainerWithLiterals;
  /** Default presets per breakpoint with which the component should be installed */
  presets?: DefaultPresets;
  /** Initial size with which the component should be added to the stage */
  initialSize?: ComponentInitialSize;
  /** Fixed position options for the component. If set, the component will be pinned to the specified position, and can't be unpinned */
  fixedPosition?: FixedPositionBuilder;
}

/** @oneof */
/** @internal */
export interface InstallationInfoTargetContainerOneOf {
  /** Which static container should the component be installed at */
  staticContainer?: StaticContainerWithLiterals;
}

/** Fixed position builder for component installation */
/** @internal */
export interface FixedPositionBuilder {
  /** Vertical position in the browser window */
  vertical?: VerticalWithLiterals;
  /** Horizontal position in the browser window */
  horizontal?: HorizontalWithLiterals;
}

/** @internal */
export enum Vertical {
  NONE = 'NONE',
  TOP = 'TOP',
  CENTER = 'CENTER',
  BOTTOM = 'BOTTOM',
}

/** @enumType */
/** @internal */
export type VerticalWithLiterals =
  | Vertical
  | 'NONE'
  | 'TOP'
  | 'CENTER'
  | 'BOTTOM';

/** @internal */
export enum Horizontal {
  NONE = 'NONE',
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** @enumType */
/** @internal */
export type HorizontalWithLiterals =
  | Horizontal
  | 'NONE'
  | 'LEFT'
  | 'CENTER'
  | 'RIGHT';

/** @internal */
export interface EditorReactComponentModuleConfiguration {
  /** Public NPM package details */
  package?: NPMPackage;
  /** The component export details */
  component?: NPMPackageEntry;
  /** The component CSS File location */
  cssFile?: NPMPackageEntry;
  /** The component SSR version export details */
  server?: NPMPackageEntry;
}

/** @internal */
export interface NPMPackage {
  /**
   * The npm package name
   * @minLength 1
   * @maxLength 214
   */
  name?: string;
  /**
   * the SEMVER package version
   * @minLength 1
   * @maxLength 214
   */
  version?: string;
}

/** @internal */
export interface NPMPackageEntry {
  /**
   * optional path to file in package
   * @maxLength 200
   */
  path?: string | null;
  /**
   * The named export key to import. If empty, the default export is used.
   * @maxLength 200
   */
  exportKey?: string | null;
}

/** @internal */
export interface MarketplaceSPIConfig {
  /** URI where the SPI implementer is deployed */
  deploymentUri?: SpiBaseUri;
}

/** @internal */
export interface FormSchemaDynamicValuesSpiConfig {
  /** URI where the SPI Implementer is deployed. */
  uriConfig?: SpiBaseUri;
  /**
   * Form ID which contains dynamic fields.
   * @format GUID
   */
  formId?: string;
  /**
   * Field IDs which trigger loading of dynamic values.
   * @maxSize 100
   * @format GUID
   */
  fieldsIds?: string[];
}

/** @internal */
export interface BlogPaywallProviderConfig {
  /** Uri config */
  uriConfig?: SpiBaseUri;
}

/** @internal */
export interface RewardProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * Name of the reward that will be visible to the end users
   * @maxLength 100
   */
  rewardName?: string;
  /**
   * Description of the reward that will be visible to the end users, describing how the reward works
   * @maxLength 500
   */
  rewardDescription?: string;
}

export interface ProductRestrictionsConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /** Product restrictions configuration. */
  productRestrictionsConfig?: RestrictionsConfig;
}

/** @internal */
export interface RestrictionsConfig {
  /**
   * Prices restrictions.
   *
   * Affected fields:
   * * `variantsInfo.variants.price.actualPrice.amount`
   * * `variantsInfo.variants.price.compareAtPrice.amount`
   * * `inventory.trackingMethod.quantity`
   */
  prices?: Restriction;
  /**
   * Options restrictions.
   *
   * Affected field: `options` (all nested fields except `linkedMedia`)
   */
  options?: Restriction;
  /**
   * Modifier restrictions.
   *
   * Affected field: `modifiers` (all nested fields except `linkedMedia`)
   */
  modifiers?: Restriction;
  /**
   * Inventory restrictions.
   *
   * Affected fields:
   * * `variantsInfo.variants.sku`
   * * `variantsInfo.variants.barcode`
   * * `inventory.trackingMethod.quantity`
   */
  inventory?: Restriction;
  /**
   * Pre order restrictions.
   *
   * Affected field: `inventory.preorderInfo`
   */
  preOrder?: Restriction;
  /** Whether to disallow product duplication or display a warning when duplicating a product. */
  duplicateProduct?: Restriction;
}

/** @internal */
export interface Restriction {
  /** Restriction level. */
  restrictionLevel?: RestrictionLevelWithLiterals;
}

/** @internal */
export enum RestrictionLevel {
  UNKNOWN_RESTRICTION_TYPE = 'UNKNOWN_RESTRICTION_TYPE',
  /** Users can edit the product field after acknowledging a warning modal. */
  WARNING = 'WARNING',
  /** Users **cannot** edit the product field. */
  LOCKED = 'LOCKED',
}

/** @enumType */
/** @internal */
export type RestrictionLevelWithLiterals =
  | RestrictionLevel
  | 'UNKNOWN_RESTRICTION_TYPE'
  | 'WARNING'
  | 'LOCKED';

/** @internal */
export interface FormSubmissionModerationSpiConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * Namespace names.
   * @maxSize 10
   */
  namespaceConfigs?: FormSubmissionModerationSpiNamespaceConfig[];
}

/** @internal */
export interface FormSubmissionModerationSpiNamespaceConfig {
  /**
   * The app which the form submissions belong to. For example, the namespace for the Wix Forms app is `wix.form_app.form`.
   *
   * Call `Get Submission` to retrieve the namespace.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string;
  /**
   * The ID of the specific form that will trigger form moderation.
   * This field is optional. If not provided, submissions from all forms will trigger the moderation.
   * @format GUID
   */
  formId?: string | null;
  /** Enable submission moderation. */
  submissionModerationEnabled?: boolean;
}

/** @internal */
export interface EventBadgesSpiConfig {
  /** URI where the SPI Implementer is deployed. */
  baseUri?: SpiBaseUri;
  /**
   * Events for which the SPI method should apply. If empty, applies to all events.
   * @maxSize 100
   * @format GUID
   */
  eventId?: string[];
}

/** @internal */
export interface OperationExecutorConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
}

/** Back-office Customization */
/** @internal */
export interface BackOfficeCustomization {
  /**
   * Hosting platform
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /** Optional Header customization, if not provided the default header will be used */
  header?: Header;
  /** Optional sidebar customization, if not provided the default sidebar will be used */
  sidebar?: Sidebar;
  /**
   * Optional list of core appIds to include in the dashboard. If not provided the host default will be used.
   * @internal
   */
  coreApps?: CoreApps;
  /** Optional sidepanel customization, if not provided, sidePanel will not be shown */
  leftPanel?: LeftPanel;
  /** Optional pages configuration, if not provided the default pages configuration will be used */
  pagesConfig?: PagesConfig;
}

/** @internal */
export interface Header extends HeaderConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: HeaderConfig;
  displayOption?: ElementDisplayOptionWithLiterals;
}

/** @oneof */
/** @internal */
export interface HeaderConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: HeaderConfig;
}

/** @internal */
export enum ElementDisplayOption {
  UNKNOWN_OPTION = 'UNKNOWN_OPTION',
  REMOVE = 'REMOVE',
  CUSTOMIZED = 'CUSTOMIZED',
}

/** @enumType */
/** @internal */
export type ElementDisplayOptionWithLiterals =
  | ElementDisplayOption
  | 'UNKNOWN_OPTION'
  | 'REMOVE'
  | 'CUSTOMIZED';

/** Header configuration, you can provide extensionId or using our platform header */
/** @internal */
export interface HeaderConfig extends HeaderConfigHeaderConfigOneOf {
  platform?: PlatformHeaderConfig;
  widget?: HeaderWidgetConfig;
  /**
   * @min 48
   * @max 70
   */
  defaultHeight?: number | null;
}

/** @oneof */
/** @internal */
export interface HeaderConfigHeaderConfigOneOf {
  platform?: PlatformHeaderConfig;
  widget?: HeaderWidgetConfig;
}

/** Platform header customization option */
/** @internal */
export interface PlatformHeaderConfig {
  /**
   * Sidebar skin from WDS, dark, light.
   * @maxLength 20
   */
  theme?: string | null;
  /** Header logo */
  logo?: Logo;
  /**
   * Header menuItems / Popovers
   * @maxSize 10
   */
  menuDropdowns?: MenuDropdown[];
  /** Header platformized search configuration */
  searchConfig?: SearchConfig;
}

/** MenuItems links */
/** @internal */
export interface MenuLink {
  /**
   * Link title
   * @minLength 2
   * @maxLength 100
   */
  title?: string;
  /**
   * Link url
   * @format WEB_URL
   */
  url?: string;
}

/** option to customize your header logo */
/** @internal */
export interface Logo {
  /**
   * Logo image url
   * @format WEB_URL
   */
  imageUrl?: string;
  /**
   * Target url, choose where to navigate when clicking on the logo
   * @format WEB_URL
   */
  targetUrl?: string | null;
}

/** Header menu dropdown, (popover) */
/** @internal */
export interface MenuDropdown {
  /**
   * MenuItem title
   * @minLength 2
   * @maxLength 50
   */
  title?: string;
  /**
   * Menu dropdown links
   * @maxSize 20
   */
  links?: MenuLink[];
}

/** @internal */
export interface SearchConfig {
  /** Weather include platformized search in header or not */
  visible?: boolean;
}

/** Header widget configuration, provide extensionId */
/** @internal */
export interface HeaderWidgetConfig {
  /** @format GUID */
  extensionId?: string;
}

/** @internal */
export interface Sidebar extends SidebarConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: SidebarConfig;
  displayOption?: ElementDisplayOptionWithLiterals;
}

/** @oneof */
/** @internal */
export interface SidebarConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: SidebarConfig;
}

/** Backoffice sidebar castomization options */
/** @internal */
export interface SidebarConfig {
  /**
   * List of root sidebar items, categories or separators, if empty default sidebar will be shown
   * @maxSize 100
   */
  sidebarItems?: SidebarRootItem[];
  /**
   * Sidebar skin from WDS, dark, light.
   * @maxLength 20
   */
  theme?: string | null;
  /** Option to override sidebar header with customize extension */
  sidebarHeader?: SidebarWidget;
  /** Option to override sidebar footer with customize extension */
  sidebarFooter?: SidebarWidget;
  /**
   * List of sidebar entities that cannot be hidden by a restricted customization extension
   * @maxSize 200
   */
  nonRemovableSidebarEntities?: BackOfficeCustomizationSidebarEntity[];
  /**
   * ID of the top-level category where pages of private apps will be added
   * @maxLength 50
   */
  categoryIdForPrivateAppPages?: string | null;
}

/**
 * First Inner level of sidebar item, can contain pages or separators or categories
 * For separator no need to set item
 */
/** @internal */
export interface SidebarChildItem extends SidebarChildItemItemOneOf {
  category?: SecondLevelCategory;
  page?: Page;
  type?: SidebarDataTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface SidebarChildItemItemOneOf {
  category?: SecondLevelCategory;
  page?: Page;
}

/** @internal */
export enum SidebarDataType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  CATEGORY = 'CATEGORY',
  PAGE = 'PAGE',
  SEPARATOR = 'SEPARATOR',
}

/** @enumType */
/** @internal */
export type SidebarDataTypeWithLiterals =
  | SidebarDataType
  | 'UNKNOWN_TYPE'
  | 'CATEGORY'
  | 'PAGE'
  | 'SEPARATOR';

/** Represents sidebar category of second level */
/** @internal */
export interface SecondLevelCategory {
  /**
   * Category id, should be unique
   * @format GUID
   */
  categoryId?: string;
  /**
   * Category label
   * @minLength 2
   * @maxLength 50
   */
  label?: string;
  /**
   * Category children, consist of pages, separators or categories, categories can be a child only on root level
   * @maxSize 100
   */
  children?: SidebarSecondLevelChildItem[];
}

/**
 * Second Inner level of sidebar item, can contain pages or separators
 * For separator no need to set item
 */
/** @internal */
export interface SidebarSecondLevelChildItem
  extends SidebarSecondLevelChildItemItemOneOf {
  page?: Page;
  type?: SidebarDataTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface SidebarSecondLevelChildItemItemOneOf {
  page?: Page;
}

/** Represents page item in the sidebar */
/** @internal */
export interface Page {
  /** @format GUID */
  pageId?: string;
}

/** Represents sidebar category of root level */
/** @internal */
export interface FirstLevelCategory {
  /**
   * Category id, should be unique
   * @minLength 4
   * @maxLength 36
   */
  categoryId?: string;
  /**
   * Category label
   * @minLength 2
   * @maxLength 50
   */
  label?: string;
  /**
   * Category icon, supported only on root level, will be ignores otherwise
   * [Wix Design System icon](https://www.wix-pages.com/wix-design-system-employees/?path=/story/foundations-icons--icons).
   * Use the full size key. The icon will be rendered in an appropriate size.
   * @minLength 3
   * @maxLength 50
   */
  icon?: string | null;
  /**
   * Category children, consist of pages, separators or categories, categories can be a child only on root level
   * @maxSize 100
   */
  children?: SidebarChildItem[];
}

/** Option to supply extension that will be shown in the sidebar */
/** @internal */
export interface SidebarWidgetConfig {
  /** @format GUID */
  extensionId?: string | null;
}

/** Root level sidebar item, can be category or separator (when not setting category) */
/** @internal */
export interface SidebarRootItem extends SidebarRootItemItemOneOf {
  category?: FirstLevelCategory;
  type?: SidebarDataTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface SidebarRootItemItemOneOf {
  category?: FirstLevelCategory;
}

/** Sidebar widget configuration */
/** @internal */
export interface SidebarWidget extends SidebarWidgetConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: SidebarWidgetConfig;
  /** Widget display option */
  displayOption?: ElementDisplayOptionWithLiterals;
}

/** @oneof */
/** @internal */
export interface SidebarWidgetConfigOneOf {
  /** Only set if option == CUSTOMIZED */
  customized?: SidebarWidgetConfig;
}

/** Represents a sidebar entity in a back office sidebar, used to configure required/hidden entities */
/** @internal */
export interface BackOfficeCustomizationSidebarEntity
  extends BackOfficeCustomizationSidebarEntityItemOneOf {
  /**
   * Category id
   * @minLength 1
   * @maxLength 50
   */
  categoryId?: string | null;
  /**
   * Page id
   * @format GUID
   */
  pageId?: string | null;
  /**
   * App id
   * @format GUID
   */
  appId?: string | null;
  /** Sidebar entity type */
  type?: SidebarEntityTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface BackOfficeCustomizationSidebarEntityItemOneOf {
  /**
   * Category id
   * @minLength 1
   * @maxLength 50
   */
  categoryId?: string | null;
  /**
   * Page id
   * @format GUID
   */
  pageId?: string | null;
  /**
   * App id
   * @format GUID
   */
  appId?: string | null;
}

/** Type of sidebar entity in a back office sidebar (cluster/category/page) */
/** @internal */
export enum SidebarEntityType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  CATEGORY = 'CATEGORY',
  PAGE = 'PAGE',
  APP = 'APP',
}

/** @enumType */
/** @internal */
export type SidebarEntityTypeWithLiterals =
  | SidebarEntityType
  | 'UNKNOWN_TYPE'
  | 'CATEGORY'
  | 'PAGE'
  | 'APP';

/** @internal */
export interface CoreApps {
  /**
   * List of core appIds to include in the dashboard. Only appIds present in the host's coreAppId list are allowed.
   * @maxSize 500
   * @format GUID
   */
  coreAppIds?: string[];
}

/** @internal */
export interface LeftPanel {
  widget?: LeftPanelWidgetConfig;
  /**
   * @min 300
   * @max 600
   */
  defaultWidth?: number | null;
}

/** sidePanel widget configuration, provide extensionId */
/** @internal */
export interface LeftPanelWidgetConfig {
  /** @format GUID */
  extensionId?: string;
}

/** @internal */
export interface PagesConfig {
  /** Optional keep-alive pages configuration, including page IDs and caching options. */
  keepAliveConfig?: KeepAliveConfig;
  /**
   * Optional default landing page to be loaded when the dashboard is loaded
   * @format GUID
   */
  defaultLandingPage?: string | null;
}

/** @internal */
export interface KeepAliveConfig {
  /**
   * Optional list of page IDs that should be kept alive on the client.
   * @maxSize 2
   * @format GUID
   */
  pageIds?: string[];
  /** Optional whether to keep the last visited page mounted when navigating to a keep-alive page. */
  cacheLastPage?: boolean | null;
}

/** SPI config - defines the relation between implementer URL and which types it validates */
/** @internal */
export interface ComponentEnricherConfig
  extends ComponentEnricherConfigComponentToViewOptionsOneOf {
  /** Context for BY_TYPES option */
  byTypesOptions?: ComponentToViewByTypes;
  /**
   * URI where the SPI Implementer is deployed
   * @maxLength 400
   */
  deploymentUri?: string;
  /**
   * Component types that will be enriched
   * @minSize 1
   * @maxSize 100
   */
  componentEnrichmentTypes?: ComponentTypeWithLiterals[];
  /**
   * Deprecated: use component_to_view instead
   * @maxSize 100
   * @deprecated Deprecated: use component_to_view instead
   * @replacedBy component_to_view
   * @targetRemovalDate 2026-06-10
   */
  componentTypesToView?: ComponentTypeWithLiterals[];
  componentToView?: ComponentToViewOptionWithLiterals;
}

/** @oneof */
/** @internal */
export interface ComponentEnricherConfigComponentToViewOptionsOneOf {
  /** Context for BY_TYPES option */
  byTypesOptions?: ComponentToViewByTypes;
}

/** @internal */
export enum ComponentToViewOption {
  UNKNOWN_COMPONENT_TO_VIEW_OPTION = 'UNKNOWN_COMPONENT_TO_VIEW_OPTION',
  /** Filter current app components by specific types to include in the enrichment context */
  BY_TYPES = 'BY_TYPES',
  /** The enricher receives the existing saved state of the components being enriched */
  EXISTING_VERSION_OF_COMPONENTS_TO_ENRICH = 'EXISTING_VERSION_OF_COMPONENTS_TO_ENRICH',
}

/** @enumType */
/** @internal */
export type ComponentToViewOptionWithLiterals =
  | ComponentToViewOption
  | 'UNKNOWN_COMPONENT_TO_VIEW_OPTION'
  | 'BY_TYPES'
  | 'EXISTING_VERSION_OF_COMPONENTS_TO_ENRICH';

/** Specifies which component types to include in the enrichment context */
/** @internal */
export interface ComponentToViewByTypes {
  /**
   * @minSize 1
   * @maxSize 100
   */
  types?: ComponentTypeWithLiterals[];
}

/** Back-office Restricted Customization */
/** @internal */
export interface BackOfficeRestrictedCustomization {
  /**
   * Hosting platform
   * @internal
   */
  hostingPlatform?: BackOfficeHostingPlatformsWithLiterals;
  /**
   * List of entities to hide from sidebar
   * @maxSize 200
   */
  sidebarEntitiesToHide?: BackOfficeCustomizationSidebarEntity[];
}

/** @internal */
export interface AppPreviewProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * Used to redirect to app overview
   * @maxLength 50
   */
  slug?: string | null;
}

/** @internal */
export interface LegendsSpiConfig {
  /**
   * URI where the SPI Implementer is deployed.
   * @maxLength 1000
   */
  deploymentUri?: string;
  /**
   * Legacy configuration of namespaces known by implementer.
   * @maxSize 5
   */
  namespaceConfigs?: NamespaceConfig[];
  /** Configuration of namespaces known by implementer V2. */
  namespaceConfigsV2?: NamespaceConfigV2;
}

/** @internal */
export interface NamespaceConfig {
  /**
   * Namespace name.
   * @maxLength 100
   */
  namespace?: string;
  /** PersonaService permissions associated with this namespace. */
  personaPermissions?: Permissions;
  /** KnowledgeService permissions associated with this namespace. */
  knowledgePermissions?: Permissions;
  /** MediaService permissions associated with this namespace. */
  mediaPermissions?: Permissions;
  /** PersonaChatService permissions associated with this namespace. */
  chatPermissions?: Permissions;
  /** AvatarService permissions associated with this namespace. */
  avatarPermissions?: Permissions;
  /** PitchService permissions associated with this namespace. */
  pitchPermissions?: Permissions;
  /** VoiceService permissions associated with this namespace. */
  voicePermissions?: Permissions;
  /** PersonaInsightsService permissions associated with this namespace. */
  personaInsightsPermissions?: Permissions;
  /** PersonaTopicClusteringService permissions associated with this namespace. */
  personaTopicClusteringPermissions?: Permissions;
}

/** @internal */
export interface Permissions {
  /**
   * Create permission.
   * @maxLength 50
   */
  create?: string;
  /**
   * Read permission.
   * @maxLength 50
   */
  read?: string;
  /**
   * Update permission.
   * @maxLength 50
   */
  update?: string;
  /**
   * Delete permission.
   * @maxLength 50
   */
  delete?: string;
  /**
   * Custom permissions
   * @maxSize 10
   */
  custom?: CustomPermission[];
}

/** @internal */
export interface CustomPermission {
  /**
   * The name of the custom permission.
   * @maxLength 50
   */
  name?: string;
  /**
   * The description of the custom permission.
   * @maxLength 50
   */
  permission?: string;
}

/** @internal */
export interface NamespaceConfigV2 {
  /**
   * Namespace name.
   * @maxLength 200
   */
  namespace?: string;
  /** Map of service name to its permissions. */
  servicePermissions?: Record<string, Permissions>;
}

/** @internal */
export interface AppDeploymentProviderConfig {
  /** URI where the SPI implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * `true` if SPI implementer provides custom permission checks API calls
   *
   * Default: `false`
   */
  toggleIsPermitted?: boolean;
  /**
   * `true` if SPI implementer provides override cloud provider logic for CreateAppDeployment API calls
   *
   * Default: `false`
   */
  toggleOverrideCloudProvider?: boolean;
}

/** @internal */
export interface BackendWorker {
  /**
   * BAAS deployment ID
   * @format GUID
   */
  deploymentId?: string;
  /**
   * BAAS deployment URL
   * @format WEB_URL
   */
  deploymentUrl?: string | null;
  /**
   * User assigned label
   * @maxLength 200
   */
  label?: string | null;
  /**
   * Deployment git commit hash
   * @maxLength 40
   */
  commitHash?: string | null;
}

/** @internal */
export interface EventTimeSlotsProviderConfig {
  /** Reserved. */
  deploymentUri?: SpiBaseUri;
  /**
   * Filter to base retrieved events on, for bookings it could be `{"type": "CLASS"}`.
   * See the [supported filters article](https://dev.wix.com/docs/sdk/backend-modules/bookings/staff-members/supported-filters)
   * for a complete list of supported filters.
   */
  eventFilter?: Record<string, any> | null;
  /**
   * event service id field, that will be used to map the event.
   * i.e. "externalScheduleId"
   * @maxLength 100
   */
  eventServiceIdField?: string | null;
  /** whether listExcludedServiceIds is enabled. */
  toggleListExcludedServiceIdsEnabled?: boolean;
}

/** @internal */
export interface AppEnvironmentProviderConfig {
  /** URI where the SPI implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * `true` if SPI implementer provides custom permission checks API calls
   *
   * Default: `false`
   */
  toggleIsAppEnvironmentPermitted?: boolean;
}

/** SDK exports specify the metadata of a module. */
/** @internal */
export interface SDKExports {
  /** Npm data that */
  importMetadata?: SDKExportsNpm;
  /** The export definition of a module */
  exportMetadata?: ExportMetadata;
  /** The maturity of the SDK exports */
  exposureAndMaturity?: ExtensionExposure;
  /** Map peer dependency package name to its version */
  peerDependencies?: Record<string, string>;
  /** Map dev dependency package name to its version */
  devDependencies?: Record<string, string>;
  /**
   * List of peer dependency package names that are optional
   * @maxLength 200
   * @maxSize 200
   */
  optionalPeerDependencies?: string[];
}

/** @internal */
export interface SDKExportsNpm {
  /**
   * Npm package name
   * @minLength 2
   * @maxLength 100
   */
  packageName?: string;
  /**
   * Npm semantic version
   * @minLength 2
   * @maxLength 100
   */
  packageVersion?: string;
  /**
   * Package entry point, default to main entry
   * @minLength 2
   * @maxLength 100
   */
  specifier?: string | null;
  /**
   * Imported name, default to default import
   * @minLength 2
   * @maxLength 100
   */
  importedName?: string | null;
}

/** @internal */
export interface ExportMetadata {
  /**
   * Exported name of a module
   * @maxLength 100
   */
  exportedName?: string | null;
  /**
   * Package entry point, default to main entry
   * @minLength 2
   * @maxLength 100
   */
  relativeSpecifier?: string | null;
}

/** A service to be used by components and apps in the viewer and editor */
/** @internal */
export interface ViewerService {
  /**
   * A unique package name of the service,@wix/site-environment, to be used when calling the `getService` API
   * @minLength 7
   * @maxLength 80
   */
  packageName?: string;
  /** The viewer implemenation of this service, *bundle* is required */
  viewer?: ViewerServiceAssets;
  /** The optional editor implementation of this service, optional (if you need a different version for the editor) */
  editor?: ViewerServiceAssets;
  /**
   * A short description of this service
   * @maxLength 50
   */
  description?: string | null;
  /**
   * A link to documentation by the article Id, example: "https://dev.wix.com/docs/editor/components/viewer-service"
   * @format WEB_URL
   */
  docLink?: string | null;
  /** Module configuration for NPM-based service */
  moduleConfiguration?: ViewerServiceModuleConfiguration;
}

/** @internal */
export interface ViewerServiceAssets {
  /**
   * The bundle of this javascript resource in production, example: "https://static.parastorage.com/services/wix-site-environment/1.0.0/bundle.min.js"
   * @format WEB_URL
   */
  bundle?: string;
  /**
   * The package names of other *Wix* services this service may depend on based on their unique package name, example: ["@wix/site-environment", "@wix/site-language"]
   * @maxSize 20
   * @maxLength 80
   */
  dependencies?: string[];
}

/** @internal */
export interface ViewerServiceModuleConfiguration {
  /** Public NPM package details */
  package?: NPMPackage;
  /** The viewer implementation details */
  viewer?: NPMPackageEntry;
  /** The editor implementation details */
  editor?: NPMPackageEntry;
}

/** @internal */
export interface ProviderAccountServicePluginConfig {
  /** The base URI where all the methods are deployed. */
  baseUri?: SpiBaseUri;
  /**
   * Update mode for provider account synchronization.
   * When not set, defaults to FULL behavior.
   * FULL: Host sends complete ProviderAccountData in a single UpdateProviderAccount call
   * PARTIAL: Host sends granular updates via separate endpoints
   */
  updateMode?: UpdateModeWithLiterals;
}

/** Update mode enum for provider account synchronization */
/** @internal */
export enum UpdateMode {
  /** Default value. This value is unused. Treat as FULL. */
  UNKNOWN_UPDATE_MODE = 'UNKNOWN_UPDATE_MODE',
  /** Single UpdateProviderAccount call with all data - plugin handles diffing */
  FULL = 'FULL',
  /** Granular endpoints for each data type (UpdateProviderAccount, UpsertBankAccounts, etc.) */
  PARTIAL = 'PARTIAL',
}

/** @enumType */
/** @internal */
export type UpdateModeWithLiterals =
  | UpdateMode
  | 'UNKNOWN_UPDATE_MODE'
  | 'FULL'
  | 'PARTIAL';

/** @internal */
export interface ProviderConfigMessage {
  /** Base URI for the provider */
  baseUri?: SpiBaseUri;
  /** Specifies which optional SPI methods this provider implements. */
  implementedMethods?: V2ImplementedMethods;
  /**
   * A list of capabilities supported by the provider.
   * Can be used in conjunction with ListFilteringCapabilities.
   * When a provider first integrates with segments, we allow to pass empty filtering_capabilities, and to gradually add capabilities.
   * a provider with 0 capabilities will not be shown in the UI.
   * @maxSize 50
   */
  filteringCapabilities?: FilteringCapability[];
  /**
   * Human-readable name of the provider for UI display (e.g., "Wix eCommerce", "Customer Reviews")
   * @maxLength 100
   */
  name?: string;
  /**
   * description explaining what this provider offers
   * @maxLength 500
   */
  description?: string;
  /**
   * identifier of the specific component. Allows a single app to have multiple providers.
   * @minLength 1
   * @maxLength 20
   */
  key?: string | null;
}

/** @internal */
export interface V2ImplementedMethods {
  /**
   * whether or not the provider supports dynamic capabilities.
   * If true, ListFilteringCapabilities will be called to fetch dynamic capabilities.
   * if both dynamic and static capabilities are declared, the list of capabilities will be merged.
   */
  listFilteringCapabilities?: boolean;
}

/** Capability for supported filters */
/** @internal */
export interface FilteringCapability {
  /**
   * Name of the attribute that can be filtered (e.g., "email", "age", "last_purchase_date").
   * For custom fields, may include type and format information (e.g., "_user_fields.custom_field_name.string.date").
   * Maximum length supports Data Extension field names up to 64 characters with type/format qualifiers.
   * @maxLength 100
   */
  attributeName?: string;
  /**
   * Human-readable display name for the attribute shown in UI.
   * @maxLength 64
   */
  displayName?: string;
  /**
   * Description explaining what this attribute represents.
   * @maxLength 200
   */
  description?: string;
  /**
   * operators and parameters supported for this attribute.
   * @maxSize 20
   */
  operatorConfigurations?: OperatorConfiguration[];
  /**
   * Optional time constraints that can be applied to this filter.
   * @maxSize 10
   */
  supportedTimeConstraints?: TimeConstraintConfiguration[];
  /** The filter requires a time constraint. */
  timeConstraintRequired?: boolean;
  /** The category of the filtering capability. */
  category?: CategoryWithLiterals;
}

/** Operator definition with its required parameters. */
/** @internal */
export interface OperatorConfiguration {
  /**
   * List of operators supported for this configuration (e.g., EQ, GT, IN).
   * @maxSize 10
   * @minSize 1
   */
  supportedOperators?: OperatorEnumOperatorWithLiterals[];
  /**
   * Parameters required for this operator (e.g., multiple parameters for "BETWEEN").
   * @maxSize 5
   */
  parameters?: Parameter[];
  /**
   * Unique identifier for this operator configuration within the filtering capability.
   * Used by Wix as a translation key, to allow translation of the parameters.
   * Example: "purchase_count_between", "age_greater_than", "email_empty_or_not_empty"
   * @maxLength 50
   */
  configurationKey?: string;
}

/**
 * Supported filter operators.
 * These are used by the API to define a filter and by the SPI to declare supported operations.
 * NOTICE: this list is not exhaustive and may change over time.
 */
/** @internal */
export enum OperatorEnumOperator {
  UNKNOWN_OPERATOR = 'UNKNOWN_OPERATOR',
  /** [Comparison] Matches values that are equal to a specified value. */
  EQ = 'EQ',
  /** [Comparison] Matches all values that are not equal to a specified value. */
  NEQ = 'NEQ',
  /** [Comparison] Matches values that are greater than a specified value. */
  GT = 'GT',
  /** [Comparison] Matches values that are greater than or equal to a specified value. */
  GTE = 'GTE',
  /** [Comparison] Matches values that are less than a specified value. */
  LT = 'LT',
  /** [Comparison] Matches values that are less than or equal to a specified value. */
  LTE = 'LTE',
  /** [Comparison] Matches values that fall within a specified range (inclusive). */
  BETWEEN = 'BETWEEN',
  /** [Comparison] Matches any of the values specified in an array. */
  IN = 'IN',
  /** [Comparison] Matches none of the values specified in an array. */
  NIN = 'NIN',
  /** [Existence] Matches values that are empty (e.g., empty string, null). */
  EMPTY = 'EMPTY',
  /** [Existence] Matches values that are not empty (e.g., non-empty string, not null). */
  NOT_EMPTY = 'NOT_EMPTY',
  /** [String] Matches values that start with a specified prefix. */
  STARTS_WITH = 'STARTS_WITH',
  /** [Array] Matches values that contain all specified items in an array. */
  WITH_ALL = 'WITH_ALL',
  /** [Array] Matches values that contain at least one of the specified items in an array. */
  WITH_SOME_OF = 'WITH_SOME_OF',
  /**
   * matches any value.
   * Example usage - "user bought ANY product"
   */
  ANY = 'ANY',
  /**
   * [Array] Negation of WITH_SOME_OF - matches when the contact's values contain
   * none of the specified items. Returns true for contacts with empty/no values.
   */
  WITH_NONE_OF = 'WITH_NONE_OF',
  /** [Array] Matches values that contain items with the specified prefixes. */
  WITH_PREFIX_FROM = 'WITH_PREFIX_FROM',
}

/** @enumType */
/** @internal */
export type OperatorEnumOperatorWithLiterals =
  | OperatorEnumOperator
  | 'UNKNOWN_OPERATOR'
  | 'EQ'
  | 'NEQ'
  | 'GT'
  | 'GTE'
  | 'LT'
  | 'LTE'
  | 'BETWEEN'
  | 'IN'
  | 'NIN'
  | 'EMPTY'
  | 'NOT_EMPTY'
  | 'STARTS_WITH'
  | 'WITH_ALL'
  | 'WITH_SOME_OF'
  | 'ANY'
  | 'WITH_NONE_OF'
  | 'WITH_PREFIX_FROM';

/** Parameter definition for parameterized filters */
/** @internal */
export interface Parameter extends ParameterValueDefinitionDetailsOneOf {
  /** For STRING_LIST */
  stringListOptions?: StringListOptions;
  /** For INT64_LIST */
  intListOptions?: IntListOptions;
  /** For DECIMAL_LIST */
  decimalListOptions?: DecimalListOptions;
  /** For BOOL_LIST */
  boolListOptions?: BoolListOptions;
  /** For CURRENCY_CODE_LIST */
  currencyListOptions?: CurrencyCodeListOptions;
  /** For LANGUAGE_LIST */
  languageTagListOptions?: LanguageTagListOptions;
  /** For ITEM_SELECTION */
  itemSelectionOptions?: ItemSelectionOptions;
  /**
   * Name or identifier of the parameter.
   * @maxLength 30
   */
  name?: string;
  /**
   * Human-readable display name for the parameter shown in UI.
   * @maxLength 30
   */
  displayName?: string;
  /** Data type of the parameter value. */
  type?: ParameterTypeWithLiterals;
  /** Whether this parameter is required for the operation. */
  mandatory?: boolean;
  /** Whether this parameter can accept multiple values (e.g., for IN operator). */
  repeated?: boolean;
  /**
   * The primary mode determining how values are defined.
   * This drives the 'value_definition_details' oneof.
   */
  definitionMode?: FilterValueDefinitionModeWithLiterals;
  /**
   * Maximum number of values allowed when `repeated` is true.
   * Valid range: [2, 100]. Default (when not set): 20.
   * Must not be set when `repeated` is false.
   * @min 2
   * @max 100
   */
  maxNumberOfItems?: number | null;
}

/** @oneof */
/** @internal */
export interface ParameterValueDefinitionDetailsOneOf {
  /** For STRING_LIST */
  stringListOptions?: StringListOptions;
  /** For INT64_LIST */
  intListOptions?: IntListOptions;
  /** For DECIMAL_LIST */
  decimalListOptions?: DecimalListOptions;
  /** For BOOL_LIST */
  boolListOptions?: BoolListOptions;
  /** For CURRENCY_CODE_LIST */
  currencyListOptions?: CurrencyCodeListOptions;
  /** For LANGUAGE_LIST */
  languageTagListOptions?: LanguageTagListOptions;
  /** For ITEM_SELECTION */
  itemSelectionOptions?: ItemSelectionOptions;
}

/** Supported parameter data types */
/** @internal */
export enum ParameterType {
  UNKNOWN_PARAMETER_TYPE = 'UNKNOWN_PARAMETER_TYPE',
  STRING = 'STRING',
  INT = 'INT',
  DECIMAL = 'DECIMAL',
  BOOL = 'BOOL',
  /** ISO 4217 currency codes */
  CURRENCY = 'CURRENCY',
  /** ISO 639-1 language code */
  LANGUAGE = 'LANGUAGE',
  /** Money type with amount and currency */
  MONEY = 'MONEY',
  /** Country with optional subdivision */
  COUNTRY_WITH_SUBDIVISION = 'COUNTRY_WITH_SUBDIVISION',
}

/** @enumType */
/** @internal */
export type ParameterTypeWithLiterals =
  | ParameterType
  | 'UNKNOWN_PARAMETER_TYPE'
  | 'STRING'
  | 'INT'
  | 'DECIMAL'
  | 'BOOL'
  | 'CURRENCY'
  | 'LANGUAGE'
  | 'MONEY'
  | 'COUNTRY_WITH_SUBDIVISION';

/**
 * This new enum becomes the primary driver for the 'value_definition_details' oneof.
 * It explicitly lists each way a filter parameter's values can be defined.
 */
/** @internal */
export enum FilterValueDefinitionMode {
  UNKNOWN_FILTER_VALUE_DEFINITION_MODE = 'UNKNOWN_FILTER_VALUE_DEFINITION_MODE',
  /**
   * For "any value": Relies on 'FilterParameterDefinition.fundamental_data_type'.
   * No specific message will be set in the 'value_definition_details' oneof.
   */
  ANY_VALUE_OF_SPECIFIED_TYPE = 'ANY_VALUE_OF_SPECIFIED_TYPE',
  /** pikachu */
  ITEM_SELECTION = 'ITEM_SELECTION',
  STRING_LIST = 'STRING_LIST',
  INT_LIST = 'INT_LIST',
  DECIMAL_LIST = 'DECIMAL_LIST',
  BOOL_LIST = 'BOOL_LIST',
  CURRENCY_LIST = 'CURRENCY_LIST',
  LANGUAGE_TAG_LIST = 'LANGUAGE_TAG_LIST',
}

/** @enumType */
/** @internal */
export type FilterValueDefinitionModeWithLiterals =
  | FilterValueDefinitionMode
  | 'UNKNOWN_FILTER_VALUE_DEFINITION_MODE'
  | 'ANY_VALUE_OF_SPECIFIED_TYPE'
  | 'ITEM_SELECTION'
  | 'STRING_LIST'
  | 'INT_LIST'
  | 'DECIMAL_LIST'
  | 'BOOL_LIST'
  | 'CURRENCY_LIST'
  | 'LANGUAGE_TAG_LIST';

/** @internal */
export interface StringListOptions {
  /**
   * List of predefined string options that can be selected.
   * @maxSize 20
   */
  options?: StringOption[];
}

/** @internal */
export interface StringOption {
  /**
   * Internal value/key used in filter evaluation.
   * @maxLength 50
   */
  value?: string;
  /**
   * Human-readable display name shown in UI.
   * @maxLength 50
   */
  displayName?: string;
}

/** @internal */
export interface IntListOptions {
  /**
   * List of predefined integer values that can be selected.
   * @maxSize 20
   */
  values?: string[];
}

/** @internal */
export interface DecimalListOptions {
  /**
   * List of predefined decimal values that can be selected.
   * Uses string representation of decimals for accuracy.
   * @maxSize 20
   * @maxLength 50
   */
  values?: string[];
}

/** @internal */
export interface BoolListOptions {
  /**
   * List of predefined boolean values that can be selected.
   * @maxSize 2
   */
  values?: boolean[];
}

/** @internal */
export interface CurrencyCodeListOptions {
  /**
   * List of predefined currency codes that can be selected.
   * ISO 4217 alphabetic codes (e.g., "USD", "EUR", "GBP").
   * @maxSize 20
   * @format CURRENCY
   */
  values?: string[];
}

/** @internal */
export interface LanguageTagListOptions {
  /**
   * List of predefined language codes that can be selected.
   * ISO 639-1 language codes (e.g., "en", "es", "fr").
   * @maxSize 20
   * @format LANGUAGE_TAG
   */
  values?: string[];
}

/** @internal */
export interface ItemSelectionOptions {
  /** @maxLength 200 */
  entityReference?: string;
}

/** TimeConstraintCapability and related messages for detailed time constraint validation */
/** @internal */
export interface TimeConstraintConfiguration
  extends TimeConstraintConfigurationValueConstraintsOneOf {
  /** For LAST_DAYS, NEXT_DAYS - only specific allowed values */
  predefinedValuesOptions?: PredefinedValues;
  /** For LAST_DAYS, NEXT_DAYS - any value within a min-max range */
  minMaxRangeOptions?: MinMaxRange;
  /** For BETWEEN - range validation */
  rangeOptions?: RangeConstraints;
  /** The type of time constraint */
  type?: TimeConstraintTypeWithLiterals;
  /** The type of value constraint to apply */
  valueConstraintType?: ValueConstraintTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface TimeConstraintConfigurationValueConstraintsOneOf {
  /** For LAST_DAYS, NEXT_DAYS - only specific allowed values */
  predefinedValuesOptions?: PredefinedValues;
  /** For LAST_DAYS, NEXT_DAYS - any value within a min-max range */
  minMaxRangeOptions?: MinMaxRange;
  /** For BETWEEN - range validation */
  rangeOptions?: RangeConstraints;
}

/**
 * Supported time-window types for a capability.
 * These are used by the API to define a filter and by the SPI to declare supported time constraints.
 */
/** @internal */
export enum TimeConstraintType {
  UNKNOWN_TIME_CONSTRAINT_TYPE = 'UNKNOWN_TIME_CONSTRAINT_TYPE',
  /** In the last given days. */
  LAST_DAYS = 'LAST_DAYS',
  /** In the next given days. */
  NEXT_DAYS = 'NEXT_DAYS',
  /** Between two specific dates: fromDate and toDate must be set */
  BETWEEN = 'BETWEEN',
  /** Today */
  TODAY = 'TODAY',
  /** This month */
  THIS_MONTH = 'THIS_MONTH',
  /** On or after a specific date: fromDate must be set */
  ON_OR_AFTER = 'ON_OR_AFTER',
  /** On or before a specific date: toDate must be set */
  ON_OR_BEFORE = 'ON_OR_BEFORE',
  /** In the last given months. */
  LAST_MONTHS = 'LAST_MONTHS',
  /** In the next given months. */
  NEXT_MONTHS = 'NEXT_MONTHS',
}

/** @enumType */
/** @internal */
export type TimeConstraintTypeWithLiterals =
  | TimeConstraintType
  | 'UNKNOWN_TIME_CONSTRAINT_TYPE'
  | 'LAST_DAYS'
  | 'NEXT_DAYS'
  | 'BETWEEN'
  | 'TODAY'
  | 'THIS_MONTH'
  | 'ON_OR_AFTER'
  | 'ON_OR_BEFORE'
  | 'LAST_MONTHS'
  | 'NEXT_MONTHS';

/** Enum for the different types of value constraints */
/** @internal */
export enum ValueConstraintType {
  UNKNOWN_VALUE_CONSTRAINT_TYPE = 'UNKNOWN_VALUE_CONSTRAINT_TYPE',
  /** No constraints - user can enter any value */
  NONE = 'NONE',
  /** Provider supports only specific predefined values */
  PREDEFINED_VALUES = 'PREDEFINED_VALUES',
  /** Provider supports any value within a min-max range */
  MIN_MAX_RANGE = 'MIN_MAX_RANGE',
  /** Provider supports range constraints for date ranges */
  RANGE = 'RANGE',
}

/** @enumType */
/** @internal */
export type ValueConstraintTypeWithLiterals =
  | ValueConstraintType
  | 'UNKNOWN_VALUE_CONSTRAINT_TYPE'
  | 'NONE'
  | 'PREDEFINED_VALUES'
  | 'MIN_MAX_RANGE'
  | 'RANGE';

/** List of specific allowed values (e.g., [1, 3, 7, 30]) */
/** @internal */
export interface PredefinedValues {
  /**
   * List of allowed values for the constraint
   * @maxSize 10
   * @min 1
   */
  allowedValues?: number[];
}

/** Minimum and maximum allowed value (inclusive) */
/** @internal */
export interface MinMaxRange {
  /**
   * Minimum value for the constraint
   * @min 1
   */
  minValue?: number;
  /**
   * Maximum value for the constraint
   * @min 1
   */
  maxValue?: number;
}

/** Constraints for TIME_CONSTRAINT_BETWEEN (date range selection) */
/** @internal */
export interface RangeConstraints {
  /**
   * Maximum allowed range in days (e.g., max 365 days between start and end)
   * @min 1
   */
  maxRangeDays?: number | null;
}

/** @internal */
export enum Category {
  UNKNOWN_CATEGORY = 'UNKNOWN_CATEGORY',
  CONTACT_ATTRIBUTES = 'CONTACT_ATTRIBUTES',
  CONTACT_ACTIVITIES = 'CONTACT_ACTIVITIES',
  EMAIL_MARKETING = 'EMAIL_MARKETING',
  MESSAGING_CAMPAIGNS = 'MESSAGING_CAMPAIGNS',
  BOOKING_SERVICES = 'BOOKING_SERVICES',
  STORES = 'STORES',
  EVENTS = 'EVENTS',
  PRICING_PLANS = 'PRICING_PLANS',
  ECOMMERCE = 'ECOMMERCE',
  GETTING_PAID = 'GETTING_PAID',
  OTHER = 'OTHER',
  ONLINE_PROGRAMS = 'ONLINE_PROGRAMS',
  GROUPS = 'GROUPS',
}

/** @enumType */
/** @internal */
export type CategoryWithLiterals =
  | Category
  | 'UNKNOWN_CATEGORY'
  | 'CONTACT_ATTRIBUTES'
  | 'CONTACT_ACTIVITIES'
  | 'EMAIL_MARKETING'
  | 'MESSAGING_CAMPAIGNS'
  | 'BOOKING_SERVICES'
  | 'STORES'
  | 'EVENTS'
  | 'PRICING_PLANS'
  | 'ECOMMERCE'
  | 'GETTING_PAID'
  | 'OTHER'
  | 'ONLINE_PROGRAMS'
  | 'GROUPS';

/** @internal */
export interface ProductCatalogProviderConfig {
  /** base uri */
  baseUri?: SpiBaseUri;
}

/** @internal */
export interface SiteMigrationSpiConfig {
  /**
   * @minLength 1
   * @maxLength 200
   */
  deploymentUri?: string;
}

/** @internal */
export interface PosProviderSettingsServicePluginConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * display name
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string | null;
  /**
   * Configuration specifying which fields of each menu-related entity
   * are managed by the POS and therefore disabled in the Wix UI.
   * Only fields listed here are considered disabled; all others remain editable in Wix.
   */
  managedMenuEntities?: ManagedMenuEntities;
}

/** @internal */
export interface ManagedMenuEntities {
  /** menu override config */
  menu?: FieldManagementConfig;
  /** section override config */
  section?: FieldManagementConfig;
  /** item override config */
  item?: FieldManagementConfig;
  /** modifier group override config */
  modifierGroup?: FieldManagementConfig;
  /** modifier override config */
  modifier?: FieldManagementConfig;
  /** variant override config */
  variant?: FieldManagementConfig;
  /** label override config */
  label?: FieldManagementConfig;
}

/** Configuration for disabling entity fields in Wix UI (i.e., fields managed by the POS). */
/** @internal */
export interface FieldManagementConfig {
  /**
   * Fields that are fully managed by the provider.
   * Applies to all field types — scalar, message, and repeated.
   * If a repeated field is listed here, the entire list and its nested content are disabled in Wix UI.
   * @maxSize 100
   * @maxLength 100
   */
  disabledFields?: string[];
  /**
   * Advanced configuration for repeated fields.
   * Use to customize add/remove or reorder behavior.
   * The key is the **path to the repeated field**, and the value is config for list-level behavior.
   * Can be used even if the field is in `disabled_fields`.
   */
  fieldConfigs?: Record<string, RepeatedFieldOverrideConfig>;
}

/** Controls list-level behavior for repeated fields. */
/** @internal */
export interface RepeatedFieldOverrideConfig {
  /** If false, disables adding or removing elements in the repeated field. */
  addOrRemoveEnabled?: boolean | null;
  /** If true, allows users to reorder elements in the Wix UI (even if add/remove is disabled). */
  reorderEnabled?: boolean | null;
}

/** A component that represents a set of instructions for Wix Vibe to execute on app installation */
/** @internal */
export interface WixVibeCodingInstructions {
  /**
   * System prompt for execution by Vibe
   * @minLength 20
   * @maxLength 10000
   */
  systemPrompt?: string;
  /**
   * Coding instructions module
   * @minLength 1
   * @maxLength 1000
   */
  module?: string | null;
}

/** @internal */
export interface TaxExemptGroupsProviderConfig {
  /** Base URI of the service plugin implementation. Since no endpoint is calling this path, it may be left blank. */
  deploymentUri?: SpiBaseUri;
  /** @maxSize 100 */
  taxExemptGroups?: TaxExemptGroup[];
}

/** @internal */
export interface TaxExemptGroup {
  /**
   * Name of the exempt tax group.
   * @maxLength 100
   */
  exemptTaxGroupName?: string;
  /**
   * Unique tax exempt group ID.
   * @format GUID
   */
  id?: string;
  /**
   * Supported exempt regions
   * Contacts that are buying in those regions will be exempt from paying taxes.
   */
  exemptRegions?: ExemptRegions;
}

/** The exempt regions could apply automatically to all regions or to specific regions. */
/** @internal */
export interface ExemptRegions {
  /** Scope of regions, when worldwide is selected, the regions list will be empty. */
  regionScope?: RegionScopeScopeWithLiterals;
  /**
   * The list of exempt regions, if specific regions scope is used.
   * @maxSize 200
   */
  regions?: V1Region[];
}

/** @internal */
export enum RegionScopeScope {
  /** Specific regions where tax exempt is applicable. */
  SPECIFIC_REGIONS = 'SPECIFIC_REGIONS',
  /** Tax exempt is applicable to all regions, no need to specify them. */
  WORLDWIDE = 'WORLDWIDE',
}

/** @enumType */
/** @internal */
export type RegionScopeScopeWithLiterals =
  | RegionScopeScope
  | 'SPECIFIC_REGIONS'
  | 'WORLDWIDE';

/** @internal */
export interface V1Region {
  /**
   * 2-letters code.
   * @format COUNTRY
   */
  countryCode?: string;
  /**
   * subdivisions - Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2).
   * If empty, the rule applies to the entire region.
   * @maxSize 100
   * @minLength 1
   * @maxLength 50
   */
  subdivisions?: string[];
}

/** @internal */
export interface BookingAutomationsConfig {
  /** URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name of the provider.
   * @maxLength 100
   */
  providerName?: string | null;
  /** Whether the booking automations are enabled for the app's users. Default is true. */
  enabled?: boolean | null;
  /** Whether to allow triggering booking automations. Default is true. */
  allowBookingAutomationTriggering?: boolean | null;
  /**
   * Map of booking automation triggers to the corresponding automation trigger key to use instead.
   * @maxSize 50
   */
  triggerOverrides?: Record<string, V2TriggerOverride>;
  /**
   * 📝 PAYLOAD FIELD OVERRIDES
   *
   * Customize specific data fields in automation trigger payloads without
   * changing the entire trigger. This allows fine-grained data transformation.
   *
   * KEY FORMAT: Original field name in payload (e.g., "staff_member_name")
   * VALUE: TriggerFieldOverride containing the replacement field key
   *
   * COMMON FIELD MAPPINGS:
   * • "staff_member_name" → "host_name"
   * • "service_name" → "meeting_name"
   *
   * EXAMPLE:
   * {
   * "staff_member_name": {
   * "automation_trigger_field_key": "consultant_name"
   * },
   * "service_name": {
   * "automation_trigger_field_key": "consultation_type"
   * }
   * }
   *
   * LIMITS: Maximum 100 field overrides per field
   * NOTE: Field overrides apply to ALL triggers
   * @maxSize 100
   */
  triggerFieldOverrides?: Record<string, TriggerFieldOverride>;
  /**
   * Optional behavior flags for the implementing app.
   *
   * Behavior flags express small, named bookings-side accommodations that
   * a particular app needs (e.g. Meetings). They are additive and default to
   * "current bookings behavior" when null/unset.
   *
   * See BookingAutomationBehavior for the available flags.
   */
  behavior?: BookingAutomationBehavior;
}

/** Represents an override for a booking automation trigger. */
/** @internal */
export interface V2TriggerOverride {
  /**
   * The automation trigger key to use instead of the default one for the given booking automation trigger.
   * @minLength 1
   * @maxLength 100
   */
  automationTriggerKey?: string;
}

/**
 * ========================================
 * FIELD OVERRIDE SPECIFICATION
 * ========================================
 *
 * Defines a replacement field key for granular payload data transformation.
 * Field overrides allow you to substitute specific data fields in automation
 * trigger payloads without changing the entire trigger or its behavior.
 *
 * FIELD MAPPING FLOW:
 * 1. Booking automation triggers with standard payload
 * 2. System checks for field overrides
 * 3. If field override exists → Replace field key with new field key
 * 4. If no override → Use original field value
 * 5. Continue with automation execution
 *
 * TRANSFORMATION SCOPE:
 * • Applies to ALL automation triggers
 * • Only affects data payload content, not trigger behavior
 * • Preserves original trigger timing and conditions
 * • Maintains automation flow and dependencies
 *
 * COMMON FIELD MAPPING SCENARIOS:
 * • Terminology alignment: "staff_member_name" → "host_name"
 * • Schema consistency: "service_name" → "meeting_name"
 */
/** @internal */
export interface TriggerFieldOverride {
  /**
   * 🏷️ REPLACEMENT FIELD IDENTIFIER
   *
   * The field key in your app's automation data schema that should be used
   * instead of the original booking automation field. This enables seamless
   * data transformation to match your app's terminology and requirements.
   *
   * FIELD KEY REQUIREMENTS:
   * ✓ Must exist in your app's automation data schema
   * ✓ Should be compatible with the original field's data type
   * ✓ Must follow consistent naming conventions
   * ✓ Should provide meaningful business context
   *
   * MAPPING EXAMPLES:
   *
   * TERMINOLOGY ALIGNMENT:
   * • "host_name" (for "staff_member_name")
   * • "attendee_name" (for "client_name")
   * • "consultation_type" (for "service_name")
   *
   * BUSINESS CONTEXT:
   * • "lead_email" (for "client_email")
   * • "opportunity_value" (for "booking_price")
   * • "meeting_duration_minutes" (for "booking_duration")
   *
   * INTEGRATION CONSISTENCY:
   * • "customer_contact" (for "client_email")
   * • "appointment_location" (for "booking_location")
   * • "session_datetime" (for "booking_date" + "booking_time")
   *
   * VALIDATION:
   * • Length: 1-100 characters
   * • Must be valid field identifier
   * • Should maintain data type compatibility
   * • Must exist in target automation schema
   * @minLength 1
   * @maxLength 100
   */
  automationTriggerFieldKey?: string;
}

/**
 * Behavioral accommodations bookings should apply for the implementing app.
 *
 * All options are optional and default to "current non-overridden bookings
 * behavior" when null/unset. Options are claimed by the SPI implementer via
 * platform install review.
 */
/** @internal */
export interface BookingAutomationBehavior {
  /**
   * When true, bookings should not fail/retry an automation report just because
   * the booking has no eCom order details. Used by apps (like Meetings) whose
   * bookings legitimately do not depend on eCom order details.
   */
  ecomOrderDetailsNotRequired?: boolean | null;
}

/** @internal */
export interface BookingsPlatformConfig {
  /** Reserved for future use */
  deploymentUri?: SpiBaseUri;
  /** Permission overrides for actions within the Bookings platform */
  permissionOverrides?: PermissionOverrides;
  /** Configuration for Wix Forms integration within the Bookings platform */
  formsConfiguration?: FormsConfig;
  /** Configuration for Automations integration within the Bookings platform */
  automationsConfiguration?: AutomationsConfig;
}

/** @internal */
export interface PermissionOverrides {
  /** Custom permission for services */
  servicePermissionOverrides?: ServicePermissionOverrides;
  /** Custom permission for bookings */
  bookingPermissionOverrides?: BookingPermissionOverrides;
  /** Custom permission for booking policies */
  policyPermissionOverrides?: PolicyPermissionOverrides;
}

/** @internal */
export interface ServicePermissionOverrides {
  /**
   * Permission required to create a service
   * @minLength 1
   * @maxLength 60
   */
  createPermission?: string | null;
  /**
   * Permission required to update a service
   * @minLength 1
   * @maxLength 60
   */
  updatePermission?: string | null;
}

/** @internal */
export interface BookingPermissionOverrides {
  /**
   * Permission required to create a booking
   * @minLength 1
   * @maxLength 60
   */
  createPermission?: string | null;
  /**
   * Permission required to update a booking
   * @minLength 1
   * @maxLength 60
   */
  updatePermission?: string | null;
}

/** @internal */
export interface PolicyPermissionOverrides {
  /**
   * Permission required to create a policy
   * @minLength 1
   * @maxLength 60
   */
  createPermission?: string | null;
  /**
   * Permission required to update a policy
   * @minLength 1
   * @maxLength 60
   */
  updatePermission?: string | null;
}

/** @internal */
export interface FormsConfig {
  /**
   * The namespace of the Wix Forms app to be used for forms integration within the Bookings platform.
   * If none is provided, the default Wix Bookings app namespace (`wix.bookings.v2.bookings`) will be used.
   * @minLength 10
   * @maxLength 50
   */
  namespace?: string | null;
}

/** @internal */
export interface AutomationsConfig {
  /** Flag to enable or disable Bookings automations */
  bookingsAutomationsEnabled?: boolean | null;
  /**
   * Overrides for triggers names
   * @maxSize 50
   */
  triggerOverrides?: TriggerOverride[];
  /**
   * Overrides for field names
   * @maxSize 100
   */
  globalFieldOverrides?: FieldOverride[];
}

/** @internal */
export interface TriggerOverride {
  /**
   * The key of the source trigger to be overridden
   * suported keys:
   * "wix_bookings-appointment_declined"
   * "wix_bookings-appointment_confirmed"
   * "wix_bookings-any_check_in"
   * "wix_bookings-booking_canceled"
   * "wix_bookings-appointment_requires_confirmation"
   * "wix_bookings-sessions_booked"
   * "wix_bookings-session_starts"
   * "wix_bookings-session_updated"
   * @minLength 1
   * @maxLength 100
   */
  sourceTriggerKey?: string | null;
  /**
   * The key of the target trigger to use as the override
   * @minLength 1
   * @maxLength 100
   */
  targetTriggerKey?: string | null;
}

/** @internal */
export interface FieldOverride {
  /**
   * The name of the source field to be overridden
   * @minLength 1
   * @maxLength 100
   */
  sourceFieldName?: string | null;
  /**
   * The name of the target field to use as the override
   * @minLength 1
   * @maxLength 100
   */
  targetFieldName?: string | null;
}

/** Configuration for the bookings validation provider. */
/** @internal */
export interface BookingsValidationProviderConfig {
  /** The base URI to reach the provider's service. */
  baseUri?: SpiBaseUri;
  /**
   * List of validation targets specifying which methods this provider handles.
   * @minSize 1
   * @maxSize 10
   */
  validationTargets?: V1ValidationTarget[];
}

/** Specifies which booking operation this provider validates. */
/** @internal */
export interface V1ValidationTarget {
  /** The booking operation method to validate. */
  method?: ValidationTargetMethodWithLiterals;
}

/** The booking operation method. */
/** @internal */
export enum ValidationTargetMethod {
  /** Default value. Do not use. */
  UNKNOWN_METHOD = 'UNKNOWN_METHOD',
  /** Validate a booking before reschedule. */
  RESCHEDULE = 'RESCHEDULE',
  /** Validate a booking before create. */
  CREATE = 'CREATE',
  /** Validate a booking before cancel. */
  CANCEL = 'CANCEL',
  /** Validate a multi-service booking before create. */
  CREATE_MULTI_SERVICE = 'CREATE_MULTI_SERVICE',
  /** Validate a multi-service booking before cancel. */
  CANCEL_MULTI_SERVICE = 'CANCEL_MULTI_SERVICE',
  /** Validate a multi-service booking before reschedule. */
  RESCHEDULE_MULTI_SERVICE = 'RESCHEDULE_MULTI_SERVICE',
}

/** @enumType */
/** @internal */
export type ValidationTargetMethodWithLiterals =
  | ValidationTargetMethod
  | 'UNKNOWN_METHOD'
  | 'RESCHEDULE'
  | 'CREATE'
  | 'CANCEL'
  | 'CREATE_MULTI_SERVICE'
  | 'CANCEL_MULTI_SERVICE'
  | 'RESCHEDULE_MULTI_SERVICE';

/** A component that represents a Wix Vibe UI component editing configuration */
/** @internal */
export interface WixVibeComponent {
  /**
   * @minLength 3
   * @maxLength 100
   */
  htmlCodeTag?: string;
  /**
   * The name of the component
   * @minLength 3
   * @maxLength 50
   */
  name?: string;
  /**
   * Description of the component functionality
   * @maxLength 300
   * @minLength 3
   */
  description?: string;
  /** Custom editor actions available for this component on selection */
  customActions?: Record<string, CustomAction>;
  /**
   * Collection ID for inline edit functionality
   * @maxLength 50
   */
  inlineEditCollectionId?: string;
}

/** Configuration for custom editor actions */
/** @internal */
export interface CustomAction extends CustomActionActionExecuteOneOf {
  openDashboard?: VibeDashboardAction;
  openCustomPanel?: VibeCustomPanelAction;
  /**
   * Display name for the action
   * @minLength 3
   * @maxLength 50
   */
  displayName?: string;
  actionType?: VibeActionTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface CustomActionActionExecuteOneOf {
  openDashboard?: VibeDashboardAction;
  openCustomPanel?: VibeCustomPanelAction;
}

/** @internal */
export enum VibeActionType {
  UNKNOWN_ActionType = 'UNKNOWN_ActionType',
  OPEN_DASHBOARD = 'OPEN_DASHBOARD',
  OPEN_CUSTOM_PANEL = 'OPEN_CUSTOM_PANEL',
}

/** @enumType */
/** @internal */
export type VibeActionTypeWithLiterals =
  | VibeActionType
  | 'UNKNOWN_ActionType'
  | 'OPEN_DASHBOARD'
  | 'OPEN_CUSTOM_PANEL';

/** Dashboard action configuration */
/** @internal */
export interface VibeDashboardAction {
  /**
   * Dashboard page identifier
   * @minLength 4
   * @maxLength 50
   */
  pageId?: string;
}

/** Custom panel action configuration */
/** @internal */
export interface VibeCustomPanelAction {
  /**
   * Exported component identifier
   * @format GUID
   */
  componentId?: string;
}

/** @internal */
export interface WixelSPIConfig {
  /** URI where the SPI implementation is deployed and accessible. */
  deploymentUri?: SpiBaseUri;
  /** Type of assets this SPI implementation processes. */
  assetType?: AssetTypeWithLiterals;
  /** Whether export functionality is enabled for this SPI implementation. */
  exposeExport?: boolean;
  /** Whether shared asset properties computation is enabled for this SPI implementation. */
  exposeSharedAssetProperties?: boolean;
  /** Whether asset copied from template handling is enabled for this SPI implementation. */
  exposeHandleAssetCopiedFromTemplate?: boolean;
  /** Whether publish asset functionality is enabled for this SPI implementation. */
  exposePublishAsset?: boolean;
  /** Whether create asset functionality is enabled for this SPI implementation. */
  exposeCreateAsset?: boolean;
  /** Whether asset summary functionality is enabled for this SPI implementation. */
  exposeAssetSummary?: boolean;
  /** Whether create asset by file functionality is enabled for this SPI implementation. */
  exposeCreateAssetByFile?: boolean;
  /** Whether handle project duplicated handling is enabled for this SPI implementation. */
  exposeHandleProjectDuplicated?: boolean;
  /** Which file media type is supported by this SPI implementation when creating assets by file. */
  fileMediaType?: FileMediaTypeWithLiterals;
}

/** @internal */
export enum AssetType {
  UNKNOWN = 'UNKNOWN',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  LOGO = 'LOGO',
  EVENT = 'EVENT',
  FORM = 'FORM',
  PDF = 'PDF',
  RICOS = 'RICOS',
  DOC = 'DOC',
  SLIDE = 'SLIDE',
  WIDGET = 'WIDGET',
  FONT = 'FONT',
  ICONS = 'ICONS',
}

/** @enumType */
/** @internal */
export type AssetTypeWithLiterals =
  | AssetType
  | 'UNKNOWN'
  | 'IMAGE'
  | 'VIDEO'
  | 'LOGO'
  | 'EVENT'
  | 'FORM'
  | 'PDF'
  | 'RICOS'
  | 'DOC'
  | 'SLIDE'
  | 'WIDGET'
  | 'FONT'
  | 'ICONS';

/** @internal */
export enum FileMediaType {
  UNKNOWN_FILE_MEDIA_TYPE = 'UNKNOWN_FILE_MEDIA_TYPE',
  IMAGE_MEDIA_TYPE = 'IMAGE_MEDIA_TYPE',
  VIDEO_MEDIA_TYPE = 'VIDEO_MEDIA_TYPE',
  DOCUMENT_MEDIA_TYPE = 'DOCUMENT_MEDIA_TYPE',
  VECTOR_MEDIA_TYPE = 'VECTOR_MEDIA_TYPE',
  ICON_MEDIA_TYPE = 'ICON_MEDIA_TYPE',
  FONT_MEDIA_TYPE = 'FONT_MEDIA_TYPE',
}

/** @enumType */
/** @internal */
export type FileMediaTypeWithLiterals =
  | FileMediaType
  | 'UNKNOWN_FILE_MEDIA_TYPE'
  | 'IMAGE_MEDIA_TYPE'
  | 'VIDEO_MEDIA_TYPE'
  | 'DOCUMENT_MEDIA_TYPE'
  | 'VECTOR_MEDIA_TYPE'
  | 'ICON_MEDIA_TYPE'
  | 'FONT_MEDIA_TYPE';

export interface StaffSortingProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * User-friendly name for the sorting method
   * @maxLength 100
   */
  methodName?: string;
  /**
   * User-friendly explanation about the sorting method.
   * @maxLength 100
   */
  methodDescription?: string;
  /**
   * Optional. An unique identifier for a component that will create a configuration for the method.
   * @format GUID
   */
  dashboardPluginId?: string | null;
}

/** @internal */
export interface FunctionEcomDiscountTriggerEligibilityProviderConfig {
  /** URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
}

/** @internal */
export interface FunctionAssistantToolProviderConfig {
  /**
   * instead of  .wix.common.spi.SpiBaseUri deployment_uri = 1;
   * @maxLength 100
   */
  deploymentUri?: string;
  /**
   * Function spi configuration
   * @format GUID
   * @readonly
   */
  functionToolId?: string;
}

/** @internal */
export interface SiteMapProviderConfig {
  /**
   * URL to dynamic site structure provider service
   * @maxLength 8192
   */
  deploymentUri?: string;
}

/** @internal */
export interface WixAiGatewaySpiConfig {
  /** Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  baseUri?: SpiBaseUri;
}

/** @internal */
export interface UrlMapperProviderConfig {
  /** the base URI where all the methods are deployed. E.g. "https://golden-coupons.com/wix-provider" */
  baseUri?: SpiBaseUri;
}

/** A ProviderSuppressionServicePluginConfig is entity which holds dev center app configuration for allowed payment provider on site */
/** @internal */
export interface ProviderSuppressionServicePluginConfig {
  /**
   * List of allowed payment providers and allowed methods for provider on sites where this app will be installed
   * @minSize 1
   * @maxSize 100
   */
  allowedProviders?: Provider[];
}

/** @internal */
export interface Provider {
  /**
   * Payment provider id allowed on a site
   * @format GUID
   */
  providerId?: string;
  /**
   * Payment method type ids list of the allow payment methods for the specified provider
   * @minSize 1
   * @maxSize 100
   * @format GUID
   */
  allowedPaymentMethodTypeIds?: string[];
}

/** @internal */
export interface FormsSPIConfig {
  /**
   * Base URI where the endpoints are called.
   * Wix eCommerce appends the endpoint path to the base URI.
   * For example, to call the Get Forms endpoint at `https://my-forms.com/v1/getForms`,
   * the base URI you provide here is `https://my-forms.com/`.
   * @minLength 1
   * @maxLength 150
   */
  deploymentUri?: string;
  /**
   * Optional WQL filter to apply to the `CalculateAdditionalFeesRequest`.
   * When provided, only requests that match the filter will be forwarded to the implementer.
   *
   * Learn more about how to define a [WQL filter](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   * @internal
   */
  filter?: Record<string, any> | null;
}

/**
 * A component that provides context to children and can be added
 * to any page, container or section in the Editor.
 * The compoent is logical and does not provide any UI.
 * It does however provide props for configuring it in the Editor.
 * The bundles can export the following:
 * method `default` export: the context provider component
 * method `injectAccessTokenGetter`:  A way to have an access token injected
 * hooks: The hook method exposed for usage (`useSomeContextName`)
 */
/** @internal */
export interface EditorContextProvider {
  /**
   * The component type, should be a namespaced: slug.componentName
   * @maxLength 100
   */
  type?: string;
  /** The runtime information needed for this component */
  resources?: EditorContextProviderResources;
  /** The exposed context model for this component */
  context?: ApiContext;
  /** data-api of this element, a map of data-items where the key is the data-item name and the value is the data-item definition. These will be manifested as `props` for the component, always has children as a prop */
  data?: Record<string, DataItem>;
  /** Allows overriding the default settings actions for the data of this component */
  settings?: Action;
  /**
   * Human friendly name of the context provider for human readability
   * @maxLength 50
   */
  displayName?: string | null;
  /**
   * The public description of the context provider
   * @maxLength 300
   */
  description?: string | null;
  /** Module configuration for NPM-based context provider */
  moduleConfiguration?: EditorContextProviderModuleConfiguration;
  /**
   * A URL to get the component Schema from the CDN
   * @internal
   * @format WEB_URL
   */
  schemaUrl?: string | null;
}

/** @internal */
export interface EditorContextProviderResources {
  /** The ESM bundle for this component in runtime */
  client?: Resource;
  /** An ESM bundle for editor experiences, can allow different things like having default data */
  editor?: Resource;
  /** The specifier of how to use thge context this component provides in React */
  contextSpecifier?: ContextSpecifier;
  /** Dependencies on other services and contexts */
  dependencies?: EditorDependencies;
  /**
   * A URL to get schema references of items for the funciton library
   * @internal
   * @format WEB_URL
   */
  schemaRefsUrl?: string | null;
}

/** A specifier of how to use the context this component provides in React */
/** @internal */
export interface ContextSpecifier {
  /**
   * The module name in case of public NPM package
   * @maxLength 100
   */
  moduleSpecifier?: string;
  /**
   * The exported hook for components usage
   * @maxLength 100
   */
  hook?: string;
}

/** @internal */
export interface EditorContextProviderModuleConfiguration {
  /** Public NPM package details */
  package?: NPMPackage;
  /** The client implementation details */
  client?: NPMPackageEntry;
  /** The editor implementation details */
  editor?: NPMPackageEntry;
}

/** @internal */
export interface EditorFunctionLibrary {
  /**
   * A unique type, uses the codeIdentifer as a prefix and the lib name as a suffix. Example: `wixElements.stringUtilFunctions`
   * @maxLength 100
   */
  type?: string;
  /** The functions definition exposed in this bundle, each key is the function name */
  functions?: Record<string, EditorFunction>;
  /** The bundle information for runtime */
  resources?: FunctionResources;
  /**
   * The display name of the library for human readability
   * @maxLength 100
   */
  name?: string | null;
  /**
   * A description of the librarie's main use cases
   * @maxLength 300
   */
  description?: string | null;
  /** Module configuration for NPM-based function library */
  moduleConfiguration?: EditorFunctionLibraryModuleConfiguration;
  /**
   * A URL to get the component Schema from the CDN
   * @internal
   * @format WEB_URL
   */
  schemaUrl?: string | null;
}

/** @internal */
export interface FunctionResources {
  /** The ESM bundle for this component in runtime */
  client?: Resource;
  /**
   * The module specifier for this library in case it is also available as an NPM package
   * @maxLength 100
   */
  moduleSpecifier?: string | null;
  /**
   * A URL to get schema references of items for the funciton library
   * @internal
   * @format WEB_URL
   */
  schemaRefsUrl?: string | null;
}

/** @internal */
export interface EditorFunctionLibraryModuleConfiguration {
  /** Public NPM package details */
  package?: NPMPackage;
  /** The client implementation details */
  client?: NPMPackageEntry;
}

/** Configuration for an app-level router that serves multiple pages. */
/** @internal */
export interface AppRouter {
  /**
   * Unique per site prefix.
   * Maximum length is 100 characters, as enforced by DM validation rules
   * @minLength 1
   * @maxLength 100
   */
  preferredPrefix?: string;
  /**
   * The data/routing source shared across the router's pages.
   * @minLength 1
   * @maxLength 2048
   */
  routerServiceUrl?: string;
  /**
   * Pages connected to this router
   * @maxSize 10
   */
  pages?: RouterPage[];
}

/** A single page served by the app router. */
/** @internal */
export interface RouterPage {
  /**
   * The extension ID of the Page
   * @format GUID
   */
  pageExtentionId?: string;
  /**
   * The page role.
   * @minLength 1
   * @maxLength 200
   */
  pageRole?: string;
}

/** @internal */
export interface BindingsSPIConfig {
  /** URI where the SPI implementation is deployed and accessible. */
  deploymentUri?: SpiBaseUri;
}

/** @internal */
export interface MarketplaceProviderConfig {
  /** URI where the service plugin implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * Whether your implementation supports the Get Pricing Breakdown method. When `false`, Wix doesn't call your implementation for pricing breakdowns and the Suppliers Hub UI omits that section.
   *
   * Default: `false`
   */
  toggleGetPricingBreakdownEnabled?: boolean;
}

/** @internal */
export interface BookingActionUrlsProviderConfig {
  /** Base URI where the SPI implementation is deployed. */
  baseUri?: SpiBaseUri;
}

/** @internal */
export interface ConferencingProviderConfig {
  /** Base URI where the SPI Implementer is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * Display name shown in UI (e.g., "Zoom", "Google Meet").
   * @maxLength 200
   */
  displayName?: string;
  /** Whether the provider supports updating conferences after creation. */
  updateSupported?: boolean;
  /**
   * Supported connection methods.
   * @maxSize 10
   */
  connectionMethods?: ConnectionMethodWithLiterals[];
  /**
   * Terms of service URL for this provider.
   * @format WEB_URL
   */
  termsUrl?: string | null;
  /**
   * Privacy policy URL for this provider.
   * @format WEB_URL
   */
  privacyUrl?: string | null;
  /**
   * URL to the provider's icon/logo image (e.g., SVG on CDN).
   * @format WEB_URL
   */
  iconUrl?: string | null;
  /**
   * Support page URL for this provider (e.g., setup instructions, troubleshooting, reconnection help).
   * @format WEB_URL
   */
  supportUrl?: string | null;
}

/** @internal */
export enum ConnectionMethod {
  UNKNOWN_CONNECTION_METHOD = 'UNKNOWN_CONNECTION_METHOD',
  OAUTH = 'OAUTH',
  CREDENTIALS = 'CREDENTIALS',
}

/** @enumType */
/** @internal */
export type ConnectionMethodWithLiterals =
  | ConnectionMethod
  | 'UNKNOWN_CONNECTION_METHOD'
  | 'OAUTH'
  | 'CREDENTIALS';

/** @internal */
export interface CancelSubscriptionsConfig {
  /** URI where the SPI Implementer is deployed */
  baseUri?: SpiBaseUri;
  /**
   * ID of the pricing plan entity associated with the function
   * @format GUID
   */
  pricingPlanId?: string | null;
}

/** Configuration for a viewer router SPI implementation. */
/** @internal */
export interface ViewerRouterSPIConfig {
  /** URI where the SPI implementation is deployed and accessible. */
  deploymentUri?: SpiBaseUri;
  /** The type of asset this SPI implementation supports. */
  assetType?: AssetTypeWithLiterals;
}

/** Premium action SPI configuration */
/** @internal */
export interface PremiumActionConfig {
  /** deployment URI */
  uriConfig?: SpiBaseUri;
}

/** @internal */
export interface AutomationTemplateComponent {
  /**
   * Template id - a pointer a the automation template.
   * @format GUID
   */
  templateId?: string | null;
  /**
   * The site which the automation used in template was originally created
   * @format GUID
   */
  originalMetaSiteId?: string | null;
  /**
   * The id of the original automation used to create the automation template
   * @format GUID
   */
  originalSiteAutomationId?: string | null;
  /** trigger used in the automation template */
  usedTrigger?: ProviderIdentifier;
  /**
   * actions used in the automation template
   * @maxSize 100
   */
  usedActions?: ProviderIdentifier[];
}

/** Identifier of a trigger/action provider used in an automation template */
/** @internal */
export interface ProviderIdentifier {
  /**
   * The app that the trigger/action belongs to
   * @format GUID
   */
  appId?: string;
  /**
   * The trigger/action key that identifies the trigger/action in the app
   * @minLength 1
   * @maxLength 100
   */
  key?: string;
}

/** @internal */
export interface ApprovalProviderConfig
  extends ApprovalProviderConfigScopeOneOf {
  /** Scope by agent task. */
  taskScope?: TaskScope;
  /** Scope by automation action. */
  automationActionScope?: AutomationActionScope;
  /** Base URI where the endpoints are called. Wix appends the endpoint path to the base URI. */
  deploymentUri?: SpiBaseUri;
  /** Scope that determines which approvals this provider handles. */
  scopeType?: ScopeTypeWithLiterals;
  /**
   * Name of the agent tool this provider evaluates.
   * @minLength 1
   * @maxLength 500
   */
  toolName?: string;
}

/** @oneof */
/** @internal */
export interface ApprovalProviderConfigScopeOneOf {
  /** Scope by agent task. */
  taskScope?: TaskScope;
  /** Scope by automation action. */
  automationActionScope?: AutomationActionScope;
}

/** @internal */
export enum ScopeType {
  UNKNOWN_SCOPE_TYPE = 'UNKNOWN_SCOPE_TYPE',
  /** Scoped to an agent task. */
  TASK = 'TASK',
  /** Scoped to an automation action. */
  AUTOMATION_ACTION = 'AUTOMATION_ACTION',
}

/** @enumType */
/** @internal */
export type ScopeTypeWithLiterals =
  | ScopeType
  | 'UNKNOWN_SCOPE_TYPE'
  | 'TASK'
  | 'AUTOMATION_ACTION';

/** @internal */
export interface TaskScope {
  /**
   * ID of the agent task this provider applies to.
   * @format GUID
   */
  taskId?: string;
}

/** @internal */
export interface AutomationActionScope {
  /**
   * ID of the automation this provider applies to.
   * @format GUID
   */
  automationId?: string;
  /**
   * ID of the action within the automation.
   * @format GUID
   */
  actionId?: string;
}

/** @internal */
export interface ServiceTagsConfig {
  allowedTags?: string[];
}

/** @internal */
export interface PointsAdjustmentProviderConfig {
  /**
   * Base URI where the implementer is deployed. Wix sends `AdjustPoints`
   * requests to this URI.
   */
  baseUri?: SpiBaseUri;
  /**
   * Display name of the points adjustment. Shown to the site owner when they
   * configure the points adjustment rule in their loyalty settings, and to
   * site visitors on the site's rewards page under the earn points rules.
   *
   * Doesn't affect how points are calculated. The number of points assigned
   * is determined solely by the `AdjustPoints` response.
   * @maxLength 100
   */
  multiplierName?: string;
  /**
   * Description of the points adjustment, explaining how it works. Shown
   * alongside `multiplierName` to the site owner in their loyalty settings,
   * and to site visitors on the site's rewards page under the earn points
   * rules.
   *
   * Doesn't affect how points are calculated.
   * @maxLength 500
   */
  multiplierDescription?: string;
}

/** @internal */
export interface EarnPointsLimitProviderConfig {
  /** URI where the SPI implementer is deployed. */
  baseUri?: SpiBaseUri;
}

export interface RealtimePermissionsProviderConfig {
  /** The URI where the SPI Implementer is deployed */
  deploymentUri?: SpiBaseUri;
  /**
   * A user-friendly name of the permissions provider
   * @maxLength 100
   */
  providerName?: string;
}

/** @internal */
export interface CalendarSearchProviderConfig {
  /** Base URI where the provider implementation is deployed. */
  deploymentUri?: SpiBaseUri;
  /**
   * Base event filter applied for this app (e.g., app scoping by appId + event type).
   * One per app — no duplication needed since each app registers a single implementor.
   */
  eventFilter?: Record<string, any> | null;
  /**
   * Per-entity configuration. Each entry describes one entity domain this implementor handles,
   * identified by FQDN, including how its IDs map to calendar event fields.
   */
  entityConfigs?: EntityConfig[];
}

/** Configuration for one entity domain within an implementor. */
/** @internal */
export interface EntityConfig {
  /** FQDN identifying this entity domain (e.g., "wix.bookings.staff.v1.staff_member"). */
  fqdn?: string;
  /** Declarative mapping from entity IDs to Calendar Event fields. */
  fieldMappings?: FieldMapping[];
}

/** @internal */
export interface FieldMapping {
  /** Which key from the provider's response entity IDs map to read. */
  filterKey?: string;
  /** Target field on Calendar Event to filter by. */
  eventField?: string;
  /** WQL operator to use when building the filter. */
  wqlOperator?: string;
}

/** Declares what to install when the parent app is installed in the editor. */
/** @internal */
export interface EditorInstallation {
  pages?: ApiInstallPage[];
  /**
   * Ordered placements onto static containers (homepage, master page).
   * Items install at their declared placement in array order.
   */
  staticPlacements?: StaticPlacement[];
  plugins?: InstallPlugin[];
  routers?: InstallRouter[];
  contextProviders?: InstallContextProvider[];
  /** Editor types this installation targets. */
  targetEditors?: EditorTypeWithLiterals[];
}

/** @internal */
export interface ApiInstallPage {
  component?: ComponentReference;
  options?: InstallPageOptions;
}

/** @internal */
export interface ComponentReference {
  /**
   * Owning app. Omit to reference a component in the current app.
   * @format GUID
   */
  appId?: string | null;
  /**
   * Stable app-unique component ID.
   * @minLength 1
   */
  componentId?: string;
  /**
   * Experiment gate: if set, this component is only installed when the spec is active.
   * @internal
   * @maxLength 200
   */
  spec?: string | null;
  /** When true, the app can function without this component being installed. */
  optional?: boolean;
  /**
   * funnel based feature flag
   * @internal
   */
  intent?: string;
}

/** @internal */
export interface InstallPageOptions {
  /**
   * When set, adds the page as an item of this platform-owned menu.
   * The menu is materialized on the site on first reference if not already present.
   */
  menu?: NavigationMenuWithLiterals;
}

/**
 * Closed, platform-owned set of navigation menus. Apps reference values
 * from this set; they cannot introduce new menu names. Adding a menu
 * requires a platform change (new enum value + EP support).
 */
/** @internal */
export enum NavigationMenu {
  /** Not set: the widget does not connect to a menu / the page is not added to a menu. */
  NAVIGATION_MENU_UNSPECIFIED = 'NAVIGATION_MENU_UNSPECIFIED',
  /** The default site menu, pre-existing on site creation. */
  NAVIGATION_MENU_SITE_DEFAULT = 'NAVIGATION_MENU_SITE_DEFAULT',
  /** Account menu (previously members login menu). */
  NAVIGATION_MENU_ACCOUNT = 'NAVIGATION_MENU_ACCOUNT',
}

/** @enumType */
/** @internal */
export type NavigationMenuWithLiterals =
  | NavigationMenu
  | 'NAVIGATION_MENU_UNSPECIFIED'
  | 'NAVIGATION_MENU_SITE_DEFAULT'
  | 'NAVIGATION_MENU_ACCOUNT';

/** @internal */
export interface StaticPlacement extends StaticPlacementItemOneOf {
  widget?: InstallWidget;
  sectionComposition?: CompositionRef;
}

/** @oneof */
/** @internal */
export interface StaticPlacementItemOneOf {
  widget?: InstallWidget;
  sectionComposition?: CompositionRef;
}

/** @internal */
export interface InstallWidget {
  component?: ComponentReference;
  options?: InstallWidgetOptions;
}

/** @internal */
export interface InstallWidgetOptions {
  /** Placement for automatic widget installation on home page or master page. */
  placement?: StaticContainerWithLiterals;
  /**
   * When set, connects the widget to render this platform-owned menu.
   * The menu is materialized on the site on first reference if not already present.
   */
  connectToMenu?: NavigationMenuWithLiterals;
}

/** @internal */
export interface InstallPlugin {
  component?: ComponentReference;
  options?: InstallPluginOptions;
}

/** @internal */
export interface InstallPluginOptions {
  /**
   * Placements to install the plugin into; must match placements declared on the plugin extension.
   * @maxSize 50
   */
  placements?: PluginPlacement[];
}

/** Only routers of the current app may be installed. */
/** @internal */
export interface InstallRouter {
  component?: ComponentReference;
}

/** Makes the context provider available in the site's CSM. */
/** @internal */
export interface InstallContextProvider {
  component?: ComponentReference;
}

/** @internal */
export enum EditorType {
  UNKNOWN_EDITOR_TYPE = 'UNKNOWN_EDITOR_TYPE',
  CLASSIC_EDITOR_TYPE = 'CLASSIC_EDITOR_TYPE',
  STUDIO_EDITOR_TYPE = 'STUDIO_EDITOR_TYPE',
  HARMONY_EDITOR_TYPE = 'HARMONY_EDITOR_TYPE',
}

/** @enumType */
/** @internal */
export type EditorTypeWithLiterals =
  | EditorType
  | 'UNKNOWN_EDITOR_TYPE'
  | 'CLASSIC_EDITOR_TYPE'
  | 'STUDIO_EDITOR_TYPE'
  | 'HARMONY_EDITOR_TYPE';

/** @internal */
export interface AppActions {
  /**
   * App-level actions. Order matters - actions are rendered in the order they appear here.
   * Each action's `action_key` must be unique within this list.
   * @maxSize 50
   */
  customActions?: AppCustomAction[];
}

/** @internal */
export interface AppCustomAction {
  /**
   * Required. Human-readable label for the action, shown next to its icon.
   * @minLength 1
   * @maxLength 50
   */
  displayName?: string;
  /** Required. Defines what happens when the user clicks the action. */
  execution?: AppExecution;
  /**
   * Optional. If not provided, a Default Icon will be displayed
   * @minLength 3
   * @maxLength 50
   */
  iconKey?: string | null;
  /**
   * Required. App-chosen stable identifier for this action.
   * Must be unique within `custom_actions` and stable across app versions
   * @minLength 1
   * @maxLength 50
   */
  actionKey?: string;
}

/** @internal */
export interface AppExecution extends AppExecutionActionExecuteOneOf {
  /** Extra configuration for opening a modal. */
  modal?: ModalExecution;
  /** Extra configuration for opening a dashboard page. */
  dashboard?: DashboardExecution;
  /** Extra configuration for opening an external link. */
  externalLink?: ExternalLinkExecution;
  /** Extra configuration for triggering an editor deeplink. */
  deeplink?: DeeplinkExecution;
  /** Required. Selects which execution runs when the action is triggered. */
  executionType?: AppExecutionTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface AppExecutionActionExecuteOneOf {
  /** Extra configuration for opening a modal. */
  modal?: ModalExecution;
  /** Extra configuration for opening a dashboard page. */
  dashboard?: DashboardExecution;
  /** Extra configuration for opening an external link. */
  externalLink?: ExternalLinkExecution;
  /** Extra configuration for triggering an editor deeplink. */
  deeplink?: DeeplinkExecution;
}

/** @internal */
export enum AppExecutionType {
  UNKNOWN_APP_EXECUTION_TYPE = 'UNKNOWN_APP_EXECUTION_TYPE',
  /** Opens a modal in the editor that loads the given URL in an iframe. */
  MODAL = 'MODAL',
  /** Opens a Wix dashboard URL or relative path inside the editor. */
  DASHBOARD = 'DASHBOARD',
  /** Opens a fully-qualified external URL in a new browser tab. */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Triggers an editor-side deeplink (e.g. open Add Page / Add Panel). */
  DEEPLINK = 'DEEPLINK',
}

/** @enumType */
/** @internal */
export type AppExecutionTypeWithLiterals =
  | AppExecutionType
  | 'UNKNOWN_APP_EXECUTION_TYPE'
  | 'MODAL'
  | 'DASHBOARD'
  | 'EXTERNAL_LINK'
  | 'DEEPLINK';

/**
 * Opens a modal in the editor that loads the given URL in an iframe.
 * When width / height are omitted, the editor uses its default modal dimensions.
 */
/** @internal */
export interface ModalExecution {
  /**
   * Required. Modal title shown in the modal header.
   * @minLength 1
   * @maxLength 100
   */
  title?: string;
  /**
   * Required. Fully qualified URL loaded inside the modal iframe.
   * @format WEB_URL
   * @minLength 1
   * @maxLength 2048
   */
  url?: string;
  /**
   * Optional. Modal width in pixels.
   * @min 1
   */
  width?: number | null;
  /**
   * Optional. Modal height in pixels.
   * @min 1
   */
  height?: number | null;
}

/** Opens a Wix dashboard URL or relative path inside the editor as an iframe panel. */
/** @internal */
export interface DashboardExecution {
  /**
   * Required. Dashboard URL or relative path (e.g. "/store/products").
   * @minLength 1
   * @maxLength 2048
   */
  url?: string;
}

/** Opens a fully-qualified external URL in a new browser tab. */
/** @internal */
export interface ExternalLinkExecution {
  /**
   * Required. Fully qualified external URL (relative paths not allowed).
   * @format WEB_URL
   * @minLength 1
   * @maxLength 2048
   */
  url?: string;
}

/** @internal */
export interface DeeplinkExecution extends DeeplinkExecutionFeatureOneOf {
  /** Extra configuration for opening the Add Page panel. */
  addPage?: AddPagePayload;
  /** The deeplink feature to activate. */
  featureType?: DeeplinkFeatureWithLiterals;
}

/** @oneof */
/** @internal */
export interface DeeplinkExecutionFeatureOneOf {
  /** Extra configuration for opening the Add Page panel. */
  addPage?: AddPagePayload;
}

/** @internal */
export enum DeeplinkFeature {
  UNKNOWN_DEEPLINK_FEATURE = 'UNKNOWN_DEEPLINK_FEATURE',
  /** Opens the editor's "Add Page" panel. */
  ADD_PAGE = 'ADD_PAGE',
  /** Opens the editor's "Add Panel" for the owning app. No payload required. */
  ADD_PANEL = 'ADD_PANEL',
}

/** @enumType */
/** @internal */
export type DeeplinkFeatureWithLiterals =
  | DeeplinkFeature
  | 'UNKNOWN_DEEPLINK_FEATURE'
  | 'ADD_PAGE'
  | 'ADD_PANEL';

/** @internal */
export interface AddPagePayload {
  /**
   * Optional. Pre-selects a category in the Add Page panel.
   * @minLength 1
   * @maxLength 50
   */
  categoryId?: string | null;
}

/** @internal */
export interface RolloutStepExecutorConfig {
  /**
   * Base URI where the implementer is deployed.
   * @maxLength 2000
   */
  deploymentUri?: string;
}

/**
 * Install-time configuration each provider registers with the host.
 * Determines endpoint routing, operation scope, and host behavior when
 * the provider is unavailable.
 */
/** @internal */
export interface BookingsPlatformPremiumValidationProviderConfig {
  /** Where the host sends CheckPremiumEligibility requests for this provider. */
  baseUri?: SpiBaseUri;
  /** Booking-domain scope this provider opts into. */
  booking?: BookingScope;
  /**
   * Per-provider RPC timeout in milliseconds (must be explicitly set).
   * @min 50
   * @max 30000
   */
  providerTimeoutMs?: number;
  /** Host behavior when provider is unavailable (must be explicitly set). */
  onProviderUnavailable?: PremiumProviderFailurePolicyWithLiterals;
}

/** @internal */
export interface BookingScope {
  /**
   * Non-empty list of booking operations this provider polices.
   * @minSize 1
   * @maxSize 8
   */
  operations?: BookingOperationWithLiterals[];
}

/** @internal */
export enum BookingOperation {
  BOOKING_OPERATION_UNKNOWN = 'BOOKING_OPERATION_UNKNOWN',
  BOOKING_OPERATION_CREATE = 'BOOKING_OPERATION_CREATE',
}

/** @enumType */
/** @internal */
export type BookingOperationWithLiterals =
  | BookingOperation
  | 'BOOKING_OPERATION_UNKNOWN'
  | 'BOOKING_OPERATION_CREATE';

/** @internal */
export enum PremiumProviderFailurePolicy {
  PREMIUM_PROVIDER_FAILURE_POLICY_UNKNOWN = 'PREMIUM_PROVIDER_FAILURE_POLICY_UNKNOWN',
  FAIL_OPEN = 'FAIL_OPEN',
  FAIL_CLOSED = 'FAIL_CLOSED',
}

/** @enumType */
/** @internal */
export type PremiumProviderFailurePolicyWithLiterals =
  | PremiumProviderFailurePolicy
  | 'PREMIUM_PROVIDER_FAILURE_POLICY_UNKNOWN'
  | 'FAIL_OPEN'
  | 'FAIL_CLOSED';

/** Global CSS — carries a URL pointing to the site's CSS content. */
/** @internal */
export interface GlobalCssConfig {
  /**
   * URL pointing to the raw CSS content (pre PostCSS processing).
   * @maxLength 1000
   */
  cssContentUrl?: string;
}

/**
 * Declares how the app connects to a third-party provider (e.g. Google, Slack, GitHub),
 * including the provider identity and the authentication method used to access it.
 * Client id/secret are NOT stored here — they are resolved at runtime from the app's secret.
 */
/** @internal */
export interface ConnectorConfig extends ConnectorConfigAuthConfigOneOf {
  /** Configuration for the OAuth 2.0 authorization-code flow. Set when auth_type is OAUTH2. */
  oauth2Config?: OAuthConfig;
  /** Configuration for static API-key authentication. Set when auth_type is API_KEY. */
  apiKeyConfig?: ApiKeyConfig;
  /**
   * Stable, unique identifier of the third-party provider this connector targets.
   * Lower-case, no spaces. For example: "google", "slack", "github".
   * @maxLength 80
   */
  slug?: string;
  /** The authentication scheme the connector uses to authenticate against the provider. */
  authType?: AuthTypeWithLiterals;
}

/** @oneof */
/** @internal */
export interface ConnectorConfigAuthConfigOneOf {
  /** Configuration for the OAuth 2.0 authorization-code flow. Set when auth_type is OAUTH2. */
  oauth2Config?: OAuthConfig;
  /** Configuration for static API-key authentication. Set when auth_type is API_KEY. */
  apiKeyConfig?: ApiKeyConfig;
}

/** Delimiter used to join requested scopes in the authorization request. */
/** @internal */
export enum ScopeSeparator {
  /** Default, unset value — treated as a single space. */
  UNKNOWN_SCOPE_SEPARATOR = 'UNKNOWN_SCOPE_SEPARATOR',
  /** Scopes are space-delimited (RFC 6749 §3.3 default). */
  SPACE = 'SPACE',
  /** Scopes are comma-delimited (required by some providers). */
  COMMA = 'COMMA',
}

/** @enumType */
/** @internal */
export type ScopeSeparatorWithLiterals =
  | ScopeSeparator
  | 'UNKNOWN_SCOPE_SEPARATOR'
  | 'SPACE'
  | 'COMMA';

/** Method used to authenticate the client at the token endpoint (RFC 6749 §2.3.1). */
/** @internal */
export enum TokenEndpointAuthMethod {
  /** Default, unset value — treated as CLIENT_SECRET_POST. */
  UNKNOWN_TOKEN_ENDPOINT_AUTH_METHOD = 'UNKNOWN_TOKEN_ENDPOINT_AUTH_METHOD',
  /** Client id/secret sent in the request body (default). */
  CLIENT_SECRET_POST = 'CLIENT_SECRET_POST',
  /** Client id/secret sent via the HTTP Basic Authorization header. */
  CLIENT_SECRET_BASIC = 'CLIENT_SECRET_BASIC',
}

/** @enumType */
/** @internal */
export type TokenEndpointAuthMethodWithLiterals =
  | TokenEndpointAuthMethod
  | 'UNKNOWN_TOKEN_ENDPOINT_AUTH_METHOD'
  | 'CLIENT_SECRET_POST'
  | 'CLIENT_SECRET_BASIC';

/** Supported authentication schemes for a connector. */
/** @internal */
export enum AuthType {
  /** Default, unset value. A concrete auth type must be selected. */
  UNKNOWN_AUTH_TYPE = 'UNKNOWN_AUTH_TYPE',
  /** OAuth 2.0 authorization-code flow. Use with OAuthConfig. */
  OAUTH2 = 'OAUTH2',
  /** Static API-key authentication. Use with ApiKeyConfig. */
  API_KEY = 'API_KEY',
}

/** @enumType */
/** @internal */
export type AuthTypeWithLiterals =
  | AuthType
  | 'UNKNOWN_AUTH_TYPE'
  | 'OAUTH2'
  | 'API_KEY';

/** Configuration for the OAuth 2.0 authorization-code flow (RFC 6749). */
/** @internal */
export interface OAuthConfig {
  /**
   * Authorization endpoint that begins the flow / user consent screen (RFC 6749 §3.1).
   * @format WEB_URL
   */
  authorizeUrl?: string;
  /**
   * Token endpoint that exchanges an authorization code for an access token (RFC 6749 §3.2).
   * @format WEB_URL
   */
  tokenUrl?: string;
  /**
   * Optional endpoint used to refresh an expired access token. Defaults to token_url when empty.
   * @format WEB_URL
   */
  refreshUrl?: string;
  /**
   * Optional token revocation endpoint used by the disconnect flow (RFC 7009). Empty if unsupported.
   * @format WEB_URL
   */
  revokeUrl?: string;
  /**
   * Scopes requested when initiating the authorization flow (RFC 6749 §3.3).
   * @maxSize 40
   * @maxLength 70
   */
  defaultScopes?: string[];
  /** Delimiter used to join scopes in the authorization request. Defaults to a space (RFC 6749 §3.3). */
  scopeSeparator?: ScopeSeparatorWithLiterals;
  /** Whether the provider requires PKCE for the authorization-code flow (RFC 7636). */
  usePkce?: boolean;
  /**
   * How client credentials are presented at the token endpoint (RFC 6749 §2.3.1).
   * Defaults to sending them in the request body.
   */
  tokenEndpointAuthMethod?: TokenEndpointAuthMethodWithLiterals;
  /**
   * Extra static query parameters appended to the authorization URL, beyond the RFC standard set.
   * Commonly used to obtain refresh tokens, e.g. {"access_type": "offline", "prompt": "consent"}.
   * @maxSize 20
   */
  authorizeParams?: Record<string, string>;
}

/** Configuration for static API-key authentication. */
/** @internal */
export interface ApiKeyConfig {
  /**
   * Name of the API key
   * @maxLength 120
   */
  keyName?: string;
  /**
   * Optional human-readable description explaining how to obtain or use the API key.
   * @maxLength 100
   */
  description?: string | null;
}

/** Configuration for a ChannelDataProvider implementer, stored on the host side. */
/** @internal */
export interface ChannelDataProviderConfig {
  /** URI where the SPI implementer is deployed. */
  deploymentUri?: SpiBaseUri;
}

/** @internal */
export interface Empty {}

/** @internal */
export interface GetComponentsCatalogResponse {
  componentsCatalog?: ComponentCatalog[];
}

/** Component Catalog Entity */
/** @internal */
export interface ComponentCatalog {
  /** Enum of Component Type */
  componentType?: ComponentTypeWithLiterals;
  /** Component name *from proto comment* */
  name?: string;
  /** Component description *from proto comment* */
  description?: string;
  /** Exposed in Dev Center to Internal users (Wix employees) or to all users (Wix users) *from proto comment* */
  exposure?: ExposureWithLiterals;
  /** Learn more link *from proto comment* */
  learnMoreLink?: string;
  /** Can be deleted */
  deletable?: boolean;
  /** Editable in Dev Center */
  editable?: boolean;
  /** Only one per app / multiple per app */
  singular?: boolean;
  /** if required approval before adding the component */
  requiresApproval?: boolean;
  /** Present in Editor / Dashboard / Extension */
  componentPresent?: ComponentPresentWithLiterals;
}

/** @internal */
export enum Exposure {
  NONE_EXPOSURE = 'NONE_EXPOSURE',
  PRIVATE_EXPOSURE = 'PRIVATE_EXPOSURE',
  INTERNAL_EXPOSURE = 'INTERNAL_EXPOSURE',
  PUBLIC_EXPOSURE = 'PUBLIC_EXPOSURE',
}

/** @enumType */
/** @internal */
export type ExposureWithLiterals =
  | Exposure
  | 'NONE_EXPOSURE'
  | 'PRIVATE_EXPOSURE'
  | 'INTERNAL_EXPOSURE'
  | 'PUBLIC_EXPOSURE';

/** @internal */
export enum ComponentPresent {
  NONE_PRESENT = 'NONE_PRESENT',
  EDITOR_PRESENT = 'EDITOR_PRESENT',
  DASHBOARD_PRESENT = 'DASHBOARD_PRESENT',
  EXTENSION_PRESENT = 'EXTENSION_PRESENT',
}

/** @enumType */
/** @internal */
export type ComponentPresentWithLiterals =
  | ComponentPresent
  | 'NONE_PRESENT'
  | 'EDITOR_PRESENT'
  | 'DASHBOARD_PRESENT'
  | 'EXTENSION_PRESENT';

/** @internal */
export interface CreateComponentCatalogRequest {
  componentCatalog?: ComponentCatalog;
}

/** @internal */
export interface UpdateComponentCatalogRequest {
  componentCatalog?: ComponentCatalog;
}

/** @internal */
export interface DeleteComponentCatalogRequest {
  componentType?: ComponentTypeWithLiterals;
}

export interface ExtensionData {
  compId: string;
  compType: ComponentType;
  compData: ComponentData;
  compName?: string;
}
